import { GraphQLClient } from 'graphql-request';
import * as Dom from 'graphql-request/dist/types.dom';
import gql from 'graphql-tag';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  BirthDate: { input: any; output: any; }
  CadastralNumber: { input: any; output: any; }
  CarChassisNumber: { input: any; output: any; }
  CarEngineNumber: { input: any; output: any; }
  CarOsagoPolicyNumber: { input: any; output: any; }
  CarPTSNumber: { input: any; output: any; }
  CarSTSNumber: { input: any; output: any; }
  CarVin: { input: any; output: any; }
  DadataResult: { input: any; output: any; }
  DateTimeISO: { input: any; output: any; }
  EmailAddress: { input: any; output: any; }
  FiasLevel: { input: any; output: any; }
  FloatString: { input: any; output: any; }
  INN: { input: any; output: any; }
  IssueId: { input: any; output: any; }
  JobTypeCode: { input: any; output: any; }
  KPP: { input: any; output: any; }
  NonNegativeInt: { input: any; output: any; }
  NumberString: { input: any; output: any; }
  OGRN: { input: any; output: any; }
  PassportNumber: { input: any; output: any; }
  PassportSeries: { input: any; output: any; }
  PhoneNumber: { input: any; output: any; }
  PostalCode: { input: any; output: any; }
  RegistrationPlateScalar: { input: any; output: any; }
  SNILS: { input: any; output: any; }
  SerialNumber: { input: any; output: any; }
  SerialNumberEPTS: { input: any; output: any; }
  SerialNumberInternationalPassport: { input: any; output: any; }
  SerialNumberTS: { input: any; output: any; }
  SimpleString: { input: any; output: any; }
  StrictString: { input: any; output: any; }
  Void: { input: any; output: any; }
  year: { input: any; output: any; }
};

/** Filter type for BirthDate scalar */
export type TBirthDateFilter = {
  /** [$all] Полное совпадение значений */
  ALL?: InputMaybe<Array<InputMaybe<Scalars['BirthDate']['input']>>>;
  /** [$eq] Равенство значений */
  EQ?: InputMaybe<Scalars['BirthDate']['input']>;
  /** [$in] Одно из значений */
  IN?: InputMaybe<Array<InputMaybe<Scalars['BirthDate']['input']>>>;
  /** [$ne] Не равно переданному значению */
  NE?: InputMaybe<Scalars['BirthDate']['input']>;
  /** [$nin] Не равно ни одному из переданных значений */
  NIN?: InputMaybe<Array<InputMaybe<Scalars['BirthDate']['input']>>>;
  /** [$not] Логическое отрицание */
  NOT?: InputMaybe<TBirthDateNotFilter>;
};

/** Filter type for $not of BirthDate scalar */
export type TBirthDateNotFilter = {
  /** [$all] Полное совпадение значений */
  ALL?: InputMaybe<Array<InputMaybe<Scalars['BirthDate']['input']>>>;
  /** [$eq] Равенство значений */
  EQ?: InputMaybe<Scalars['BirthDate']['input']>;
  /** [$in] Одно из значений */
  IN?: InputMaybe<Array<InputMaybe<Scalars['BirthDate']['input']>>>;
  /** [$ne] Не равно переданному значению */
  NE?: InputMaybe<Scalars['BirthDate']['input']>;
  /** [$nin] Не равно ни одному из переданных значений */
  NIN?: InputMaybe<Array<InputMaybe<Scalars['BirthDate']['input']>>>;
};

/** Filter type for Boolean scalar */
export type TBooleanFilter = {
  /** [$all] Полное совпадение значений */
  ALL?: InputMaybe<Array<InputMaybe<Scalars['Boolean']['input']>>>;
  /** [$eq] Равенство значений */
  EQ?: InputMaybe<Scalars['Boolean']['input']>;
  /** [$in] Одно из значений */
  IN?: InputMaybe<Array<InputMaybe<Scalars['Boolean']['input']>>>;
  /** [$ne] Не равно переданному значению */
  NE?: InputMaybe<Scalars['Boolean']['input']>;
  /** [$nin] Не равно ни одному из переданных значений */
  NIN?: InputMaybe<Array<InputMaybe<Scalars['Boolean']['input']>>>;
  /** [$not] Логическое отрицание */
  NOT?: InputMaybe<TBooleanNotFilter>;
};

/** Filter type for $not of Boolean scalar */
export type TBooleanNotFilter = {
  /** [$all] Полное совпадение значений */
  ALL?: InputMaybe<Array<InputMaybe<Scalars['Boolean']['input']>>>;
  /** [$eq] Равенство значений */
  EQ?: InputMaybe<Scalars['Boolean']['input']>;
  /** [$in] Одно из значений */
  IN?: InputMaybe<Array<InputMaybe<Scalars['Boolean']['input']>>>;
  /** [$ne] Не равно переданному значению */
  NE?: InputMaybe<Scalars['Boolean']['input']>;
  /** [$nin] Не равно ни одному из переданных значений */
  NIN?: InputMaybe<Array<InputMaybe<Scalars['Boolean']['input']>>>;
};

/** Filter type for CadastralNumber scalar */
export type TCadastralNumberFilter = {
  /** [$all] Полное совпадение значений */
  ALL?: InputMaybe<Array<InputMaybe<Scalars['CadastralNumber']['input']>>>;
  /** [$eq] Равенство значений */
  EQ?: InputMaybe<Scalars['CadastralNumber']['input']>;
  /** [$in] Одно из значений */
  IN?: InputMaybe<Array<InputMaybe<Scalars['CadastralNumber']['input']>>>;
  /** [$ne] Не равно переданному значению */
  NE?: InputMaybe<Scalars['CadastralNumber']['input']>;
  /** [$nin] Не равно ни одному из переданных значений */
  NIN?: InputMaybe<Array<InputMaybe<Scalars['CadastralNumber']['input']>>>;
  /** [$not] Логическое отрицание */
  NOT?: InputMaybe<TCadastralNumberNotFilter>;
};

/** Filter type for $not of CadastralNumber scalar */
export type TCadastralNumberNotFilter = {
  /** [$all] Полное совпадение значений */
  ALL?: InputMaybe<Array<InputMaybe<Scalars['CadastralNumber']['input']>>>;
  /** [$eq] Равенство значений */
  EQ?: InputMaybe<Scalars['CadastralNumber']['input']>;
  /** [$in] Одно из значений */
  IN?: InputMaybe<Array<InputMaybe<Scalars['CadastralNumber']['input']>>>;
  /** [$ne] Не равно переданному значению */
  NE?: InputMaybe<Scalars['CadastralNumber']['input']>;
  /** [$nin] Не равно ни одному из переданных значений */
  NIN?: InputMaybe<Array<InputMaybe<Scalars['CadastralNumber']['input']>>>;
};

export type TCar = {
  __typename?: 'Car';
  /** Псевдоним объекта */
  alias?: Maybe<Scalars['String']['output']>;
  /** Одобрение типа ТС */
  approveDocument?: Maybe<TNestedCarApproveDocument>;
  /** Цвет кузова */
  bodyColor?: Maybe<Scalars['String']['output']>;
  /** Номер кузова */
  bodyNumber?: Maybe<Scalars['String']['output']>;
  /** Id кузова в справочнике */
  bodyTypeId?: Maybe<Scalars['String']['output']>;
  /** Владелец авто */
  carOwner?: Maybe<TPeople>;
  /** Тип кузова */
  carcase?: Maybe<Scalars['String']['output']>;
  /** id типа кузова */
  carcaseid?: Maybe<Scalars['String']['output']>;
  casco?: Maybe<TNestedCarCasco>;
  /** Страхователь в расчете КАСКО */
  cascoInsurer?: Maybe<TPeople>;
  /** Категория авто по тех регламенту (A, B, C...) */
  category?: Maybe<ECarCategory>;
  /** Номер шасси */
  chassisNumber?: Maybe<Scalars['CarChassisNumber']['output']>;
  /** Дата создания объекта в БД */
  created?: Maybe<Scalars['DateTimeISO']['output']>;
  /** ClientId продукта, создавшего объект */
  createdBy?: Maybe<Scalars['String']['output']>;
  /** Залоговое авто в кредитах */
  creditSelectionPledgeForPeople?: Maybe<Array<Maybe<TPeople>>>;
  diagnosticCard?: Maybe<TNestedCarDiagnosticCard>;
  /** Привод автомобиля */
  drive?: Maybe<ECarDrive>;
  /** Водители */
  drivers?: Maybe<Array<Maybe<TPeople>>>;
  ePts?: Maybe<TNestedCarEPts>;
  /** Экологический класс */
  ecologyClass?: Maybe<Scalars['String']['output']>;
  /** Модель двигателя */
  engineModel?: Maybe<Scalars['String']['output']>;
  /** Номер двигателя */
  engineNum?: Maybe<Scalars['String']['output']>;
  /** Тип двигателя */
  engineType?: Maybe<Scalars['String']['output']>;
  /** Объём двигателя */
  enginevolume?: Maybe<Scalars['String']['output']>;
  /** Установлено ли ГБО */
  gazEnvironment?: Maybe<Scalars['Boolean']['output']>;
  /** Уникальный хеш машины клиента */
  hash?: Maybe<Scalars['String']['output']>;
  /** Код страны-изготовителя */
  issueCountryCode?: Maybe<Scalars['String']['output']>;
  /** Страна-изготовитель */
  issueCountryName?: Maybe<Scalars['String']['output']>;
  /** КПП */
  kpp?: Maybe<EKpp>;
  /** Идентификатор КПП */
  kppId?: Maybe<Scalars['String']['output']>;
  /** Ссылка на логотип марки автомобиля */
  logoLink?: Maybe<Scalars['String']['output']>;
  /** Производитель */
  manufacturer?: Maybe<Scalars['String']['output']>;
  /** Марка */
  mark: Scalars['String']['output'];
  /** Id марки в справочнике ОСАГО */
  markId?: Maybe<Scalars['String']['output']>;
  /** Максимальный вес */
  maxWeight?: Maybe<Scalars['Int']['output']>;
  /** Модель */
  model: Scalars['String']['output'];
  /** Id модели в справочнике ОСАГО */
  modelId?: Maybe<Scalars['String']['output']>;
  /** Название модификации машины */
  modification?: Maybe<Scalars['String']['output']>;
  /**
   * Номер СТС
   * @deprecated Не использовать. Старое поле для стс.
   */
  number?: Maybe<Scalars['String']['output']>;
  osago?: Maybe<TNestedCarOsago>;
  /** Страхователь авто в ОСАГО */
  osagoInsurer?: Maybe<TPeople>;
  /** Водители в расчете ОСАГО */
  osagoSelectedDrivers?: Maybe<Array<Maybe<TPeople>>>;
  /** Периоды владения */
  ownerPeriods?: Maybe<Array<Maybe<TNestedCarOwnerPeriods>>>;
  /** Залоговое авто в кредитах */
  pledger?: Maybe<TPeople>;
  /** Мощность двигателя */
  power?: Maybe<Scalars['String']['output']>;
  /** Мощность двигателя (кВт) */
  powerkVt?: Maybe<Scalars['Float']['output']>;
  /** Цена автомобиля */
  price?: Maybe<Scalars['Float']['output']>;
  /** Введенный вручную вне какого-либо продукта автомобиль */
  profileFromManualInput?: Maybe<TProfile>;
  pts?: Maybe<TNestedCarPts>;
  /** История регистрационных действий */
  regActions?: Maybe<Array<Maybe<TNestedCarRegActions>>>;
  /** Регистрационный знак */
  registrationPlate?: Maybe<Scalars['RegistrationPlateScalar']['output']>;
  /** Ограничения */
  restrictions?: Maybe<Scalars['String']['output']>;
  /** Источник транспорта */
  source?: Maybe<ESource>;
  /** Год начала владения */
  startOwnershipYear?: Maybe<Scalars['year']['output']>;
  sts?: Maybe<TNestedCarSts>;
  /** Таможенная декларация */
  tdtpo?: Maybe<TNestedCarTdtpo>;
  /** Срок владения автомобилем */
  tenure?: Maybe<Scalars['String']['output']>;
  /** Тестовая ссылка */
  testo2o?: Maybe<TPeople>;
  /** Дата последнего обновления объекта в БД */
  updated?: Maybe<Scalars['DateTimeISO']['output']>;
  /** ClientId продукта, обновившего объект */
  updatedBy?: Maybe<Scalars['String']['output']>;
  /** Статус оплаты утильсбора */
  utilizationStatus?: Maybe<Scalars['String']['output']>;
  /** Тип авто */
  vehicleType?: Maybe<Scalars['String']['output']>;
  /** Идентификационный номер транспортного средства (VIN)  */
  vin?: Maybe<Scalars['CarVin']['output']>;
  /** VIN2 */
  vin2?: Maybe<Scalars['CarVin']['output']>;
  /** Вес без загрузки */
  weightWithoutLoading?: Maybe<Scalars['Int']['output']>;
  /** Расположение руля */
  wheelLocation?: Maybe<EWheelLocation>;
  /** Год выпуска */
  year: Scalars['year']['output'];
};


export type TCarCarOwnerArgs = {
  filter?: InputMaybe<TPeopleFilter>;
};


export type TCarCascoInsurerArgs = {
  filter?: InputMaybe<TPeopleFilter>;
};


export type TCarCreditSelectionPledgeForPeopleArgs = {
  filter?: InputMaybe<TPeopleFilter>;
  pagination?: InputMaybe<TPagination>;
};


export type TCarDriversArgs = {
  filter?: InputMaybe<TPeopleFilter>;
  pagination?: InputMaybe<TPagination>;
};


export type TCarOsagoInsurerArgs = {
  filter?: InputMaybe<TPeopleFilter>;
};


export type TCarOsagoSelectedDriversArgs = {
  filter?: InputMaybe<TPeopleFilter>;
  pagination?: InputMaybe<TPagination>;
};


export type TCarOwnerPeriodsArgs = {
  pagination?: InputMaybe<TPagination>;
};


export type TCarPledgerArgs = {
  filter?: InputMaybe<TPeopleFilter>;
};


export type TCarProfileFromManualInputArgs = {
  filter?: InputMaybe<TProfileFilter>;
};


export type TCarRegActionsArgs = {
  pagination?: InputMaybe<TPagination>;
};


export type TCarTesto2oArgs = {
  filter?: InputMaybe<TPeopleFilter>;
};

/** Filter type for CarChassisNumber scalar */
export type TCarChassisNumberFilter = {
  /** [$all] Полное совпадение значений */
  ALL?: InputMaybe<Array<InputMaybe<Scalars['CarChassisNumber']['input']>>>;
  /** [$eq] Равенство значений */
  EQ?: InputMaybe<Scalars['CarChassisNumber']['input']>;
  /** [$in] Одно из значений */
  IN?: InputMaybe<Array<InputMaybe<Scalars['CarChassisNumber']['input']>>>;
  /** [$ne] Не равно переданному значению */
  NE?: InputMaybe<Scalars['CarChassisNumber']['input']>;
  /** [$nin] Не равно ни одному из переданных значений */
  NIN?: InputMaybe<Array<InputMaybe<Scalars['CarChassisNumber']['input']>>>;
  /** [$not] Логическое отрицание */
  NOT?: InputMaybe<TCarChassisNumberNotFilter>;
};

/** Filter type for $not of CarChassisNumber scalar */
export type TCarChassisNumberNotFilter = {
  /** [$all] Полное совпадение значений */
  ALL?: InputMaybe<Array<InputMaybe<Scalars['CarChassisNumber']['input']>>>;
  /** [$eq] Равенство значений */
  EQ?: InputMaybe<Scalars['CarChassisNumber']['input']>;
  /** [$in] Одно из значений */
  IN?: InputMaybe<Array<InputMaybe<Scalars['CarChassisNumber']['input']>>>;
  /** [$ne] Не равно переданному значению */
  NE?: InputMaybe<Scalars['CarChassisNumber']['input']>;
  /** [$nin] Не равно ни одному из переданных значений */
  NIN?: InputMaybe<Array<InputMaybe<Scalars['CarChassisNumber']['input']>>>;
};

export type TCarFilter = {
  AND?: InputMaybe<Array<InputMaybe<TCarFilter>>>;
  NOR?: InputMaybe<Array<InputMaybe<TCarFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<TCarFilter>>>;
  alias?: InputMaybe<TStringFilter>;
  approveDocument?: InputMaybe<TNestedCarApproveDocumentObjectFilterType>;
  bodyColor?: InputMaybe<TStringFilter>;
  bodyNumber?: InputMaybe<TStringFilter>;
  bodyTypeId?: InputMaybe<TStringFilter>;
  carcase?: InputMaybe<TStringFilter>;
  carcaseid?: InputMaybe<TStringFilter>;
  casco?: InputMaybe<TNestedCarCascoObjectFilterType>;
  category?: InputMaybe<TECarCategoryFilter>;
  chassisNumber?: InputMaybe<TCarChassisNumberFilter>;
  created?: InputMaybe<TDateTimeIsoFilter>;
  createdBy?: InputMaybe<TStringFilter>;
  diagnosticCard?: InputMaybe<TNestedCarDiagnosticCardObjectFilterType>;
  drive?: InputMaybe<TECarDriveFilter>;
  ePts?: InputMaybe<TNestedCarEPtsObjectFilterType>;
  ecologyClass?: InputMaybe<TStringFilter>;
  engineModel?: InputMaybe<TStringFilter>;
  engineNum?: InputMaybe<TStringFilter>;
  engineType?: InputMaybe<TStringFilter>;
  enginevolume?: InputMaybe<TStringFilter>;
  gazEnvironment?: InputMaybe<TBooleanFilter>;
  hash?: InputMaybe<TStringFilter>;
  issueCountryCode?: InputMaybe<TStringFilter>;
  issueCountryName?: InputMaybe<TStringFilter>;
  kpp?: InputMaybe<TEKppFilter>;
  kppId?: InputMaybe<TStringFilter>;
  logoLink?: InputMaybe<TStringFilter>;
  manufacturer?: InputMaybe<TStringFilter>;
  mark?: InputMaybe<TStringFilter>;
  markId?: InputMaybe<TStringFilter>;
  maxWeight?: InputMaybe<TIntFilter>;
  model?: InputMaybe<TStringFilter>;
  modelId?: InputMaybe<TStringFilter>;
  modification?: InputMaybe<TStringFilter>;
  number?: InputMaybe<TStringFilter>;
  osago?: InputMaybe<TNestedCarOsagoObjectFilterType>;
  ownerPeriods?: InputMaybe<TNestedCarOwnerPeriodsObjectFilterType>;
  power?: InputMaybe<TStringFilter>;
  powerkVt?: InputMaybe<TFloatFilter>;
  price?: InputMaybe<TFloatFilter>;
  pts?: InputMaybe<TNestedCarPtsObjectFilterType>;
  regActions?: InputMaybe<TNestedCarRegActionsObjectFilterType>;
  registrationPlate?: InputMaybe<TRegistrationPlateScalarFilter>;
  restrictions?: InputMaybe<TStringFilter>;
  source?: InputMaybe<TESourceFilter>;
  startOwnershipYear?: InputMaybe<TYearFilter>;
  sts?: InputMaybe<TNestedCarStsObjectFilterType>;
  tdtpo?: InputMaybe<TNestedCarTdtpoObjectFilterType>;
  tenure?: InputMaybe<TStringFilter>;
  updated?: InputMaybe<TDateTimeIsoFilter>;
  updatedBy?: InputMaybe<TStringFilter>;
  utilizationStatus?: InputMaybe<TStringFilter>;
  vehicleType?: InputMaybe<TStringFilter>;
  vin?: InputMaybe<TCarVinFilter>;
  vin2?: InputMaybe<TCarVinFilter>;
  weightWithoutLoading?: InputMaybe<TIntFilter>;
  wheelLocation?: InputMaybe<TEWheelLocationFilter>;
  year?: InputMaybe<TYearFilter>;
};

/** Filter type for CarOsagoPolicyNumber scalar */
export type TCarOsagoPolicyNumberFilter = {
  /** [$all] Полное совпадение значений */
  ALL?: InputMaybe<Array<InputMaybe<Scalars['CarOsagoPolicyNumber']['input']>>>;
  /** [$eq] Равенство значений */
  EQ?: InputMaybe<Scalars['CarOsagoPolicyNumber']['input']>;
  /** [$in] Одно из значений */
  IN?: InputMaybe<Array<InputMaybe<Scalars['CarOsagoPolicyNumber']['input']>>>;
  /** [$ne] Не равно переданному значению */
  NE?: InputMaybe<Scalars['CarOsagoPolicyNumber']['input']>;
  /** [$nin] Не равно ни одному из переданных значений */
  NIN?: InputMaybe<Array<InputMaybe<Scalars['CarOsagoPolicyNumber']['input']>>>;
  /** [$not] Логическое отрицание */
  NOT?: InputMaybe<TCarOsagoPolicyNumberNotFilter>;
};

/** Filter type for $not of CarOsagoPolicyNumber scalar */
export type TCarOsagoPolicyNumberNotFilter = {
  /** [$all] Полное совпадение значений */
  ALL?: InputMaybe<Array<InputMaybe<Scalars['CarOsagoPolicyNumber']['input']>>>;
  /** [$eq] Равенство значений */
  EQ?: InputMaybe<Scalars['CarOsagoPolicyNumber']['input']>;
  /** [$in] Одно из значений */
  IN?: InputMaybe<Array<InputMaybe<Scalars['CarOsagoPolicyNumber']['input']>>>;
  /** [$ne] Не равно переданному значению */
  NE?: InputMaybe<Scalars['CarOsagoPolicyNumber']['input']>;
  /** [$nin] Не равно ни одному из переданных значений */
  NIN?: InputMaybe<Array<InputMaybe<Scalars['CarOsagoPolicyNumber']['input']>>>;
};

/** Filter type for CarPTSNumber scalar */
export type TCarPtsNumberFilter = {
  /** [$all] Полное совпадение значений */
  ALL?: InputMaybe<Array<InputMaybe<Scalars['CarPTSNumber']['input']>>>;
  /** [$eq] Равенство значений */
  EQ?: InputMaybe<Scalars['CarPTSNumber']['input']>;
  /** [$in] Одно из значений */
  IN?: InputMaybe<Array<InputMaybe<Scalars['CarPTSNumber']['input']>>>;
  /** [$ne] Не равно переданному значению */
  NE?: InputMaybe<Scalars['CarPTSNumber']['input']>;
  /** [$nin] Не равно ни одному из переданных значений */
  NIN?: InputMaybe<Array<InputMaybe<Scalars['CarPTSNumber']['input']>>>;
  /** [$not] Логическое отрицание */
  NOT?: InputMaybe<TCarPtsNumberNotFilter>;
};

/** Filter type for $not of CarPTSNumber scalar */
export type TCarPtsNumberNotFilter = {
  /** [$all] Полное совпадение значений */
  ALL?: InputMaybe<Array<InputMaybe<Scalars['CarPTSNumber']['input']>>>;
  /** [$eq] Равенство значений */
  EQ?: InputMaybe<Scalars['CarPTSNumber']['input']>;
  /** [$in] Одно из значений */
  IN?: InputMaybe<Array<InputMaybe<Scalars['CarPTSNumber']['input']>>>;
  /** [$ne] Не равно переданному значению */
  NE?: InputMaybe<Scalars['CarPTSNumber']['input']>;
  /** [$nin] Не равно ни одному из переданных значений */
  NIN?: InputMaybe<Array<InputMaybe<Scalars['CarPTSNumber']['input']>>>;
};

/** Filter type for CarVin scalar */
export type TCarVinFilter = {
  /** [$all] Полное совпадение значений */
  ALL?: InputMaybe<Array<InputMaybe<Scalars['CarVin']['input']>>>;
  /** [$eq] Равенство значений */
  EQ?: InputMaybe<Scalars['CarVin']['input']>;
  /** [$in] Одно из значений */
  IN?: InputMaybe<Array<InputMaybe<Scalars['CarVin']['input']>>>;
  /** [$ne] Не равно переданному значению */
  NE?: InputMaybe<Scalars['CarVin']['input']>;
  /** [$nin] Не равно ни одному из переданных значений */
  NIN?: InputMaybe<Array<InputMaybe<Scalars['CarVin']['input']>>>;
  /** [$not] Логическое отрицание */
  NOT?: InputMaybe<TCarVinNotFilter>;
};

/** Filter type for $not of CarVin scalar */
export type TCarVinNotFilter = {
  /** [$all] Полное совпадение значений */
  ALL?: InputMaybe<Array<InputMaybe<Scalars['CarVin']['input']>>>;
  /** [$eq] Равенство значений */
  EQ?: InputMaybe<Scalars['CarVin']['input']>;
  /** [$in] Одно из значений */
  IN?: InputMaybe<Array<InputMaybe<Scalars['CarVin']['input']>>>;
  /** [$ne] Не равно переданному значению */
  NE?: InputMaybe<Scalars['CarVin']['input']>;
  /** [$nin] Не равно ни одному из переданных значений */
  NIN?: InputMaybe<Array<InputMaybe<Scalars['CarVin']['input']>>>;
};

/** Filter type for DateTimeISO scalar */
export type TDateTimeIsoFilter = {
  /** [$all] Полное совпадение значений */
  ALL?: InputMaybe<Array<InputMaybe<Scalars['DateTimeISO']['input']>>>;
  /** [$eq] Равенство значений */
  EQ?: InputMaybe<Scalars['DateTimeISO']['input']>;
  /** [$in] Одно из значений */
  IN?: InputMaybe<Array<InputMaybe<Scalars['DateTimeISO']['input']>>>;
  /** [$ne] Не равно переданному значению */
  NE?: InputMaybe<Scalars['DateTimeISO']['input']>;
  /** [$nin] Не равно ни одному из переданных значений */
  NIN?: InputMaybe<Array<InputMaybe<Scalars['DateTimeISO']['input']>>>;
  /** [$not] Логическое отрицание */
  NOT?: InputMaybe<TDateTimeIsoNotFilter>;
};

/** Filter type for $not of DateTimeISO scalar */
export type TDateTimeIsoNotFilter = {
  /** [$all] Полное совпадение значений */
  ALL?: InputMaybe<Array<InputMaybe<Scalars['DateTimeISO']['input']>>>;
  /** [$eq] Равенство значений */
  EQ?: InputMaybe<Scalars['DateTimeISO']['input']>;
  /** [$in] Одно из значений */
  IN?: InputMaybe<Array<InputMaybe<Scalars['DateTimeISO']['input']>>>;
  /** [$ne] Не равно переданному значению */
  NE?: InputMaybe<Scalars['DateTimeISO']['input']>;
  /** [$nin] Не равно ни одному из переданных значений */
  NIN?: InputMaybe<Array<InputMaybe<Scalars['DateTimeISO']['input']>>>;
};

export type TDeleteProfileResult = {
  __typename?: 'DeleteProfileResult';
  /** @deprecated Формы отключили. Не используйте этот параметр */
  formDeletedAmount?: Maybe<Scalars['Int']['output']>;
  profileLinksDeletedAmount?: Maybe<Scalars['Int']['output']>;
  profileObjectsDeletedAmount?: Maybe<Scalars['Int']['output']>;
  profileUpdateDataDeleteAmount?: Maybe<Scalars['Int']['output']>;
};

export type TDriverLicense = {
  __typename?: 'DriverLicense';
  /** Дата рождения  */
  birthDate?: Maybe<Scalars['BirthDate']['output']>;
  /** Место рождения  */
  birthPlace?: Maybe<Scalars['String']['output']>;
  /** Категории  */
  categories?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Страна выдачи ВУ  */
  countryName?: Maybe<Scalars['String']['output']>;
  /** Дата создания объекта в БД */
  created?: Maybe<Scalars['DateTimeISO']['output']>;
  /** ClientId продукта, создавшего объект */
  createdBy?: Maybe<Scalars['String']['output']>;
  /** Ведомство  */
  departmentDoc?: Maybe<Scalars['String']['output']>;
  /** Год начала стажа by  */
  experience?: Maybe<Scalars['DateTimeISO']['output']>;
  /** Дата начала стажа по категории A */
  experienceA?: Maybe<Scalars['DateTimeISO']['output']>;
  /**
   * Дата начала стажа
   * @deprecated This field is deprecated. Never use it
   */
  experienceStartDate?: Maybe<Scalars['DateTimeISO']['output']>;
  /** Действителен до  */
  expiryDate?: Maybe<Scalars['DateTimeISO']['output']>;
  /** Дата выдачи первых прав */
  firstIssueDate?: Maybe<Scalars['DateTimeISO']['output']>;
  /** Имя  */
  firstName?: Maybe<Scalars['StrictString']['output']>;
  /** Хэш прав */
  hash?: Maybe<Scalars['String']['output']>;
  /** ИД документа  */
  id?: Maybe<Scalars['String']['output']>;
  /** Дата выдачи  */
  issueDate?: Maybe<Scalars['DateTimeISO']['output']>;
  /** Кем выдан документ  */
  issuedBy?: Maybe<Scalars['String']['output']>;
  /** Фамилия  */
  lastName?: Maybe<Scalars['StrictString']['output']>;
  /** Отчество  */
  middleName?: Maybe<Scalars['StrictString']['output']>;
  /** Номер  */
  number: Scalars['String']['output'];
  /** Временная ссылка для миграции People.driverLicense в отдельный объект */
  people?: Maybe<TPeople>;
  /** Номер  */
  previousNumber?: Maybe<Scalars['String']['output']>;
  /** Серия  */
  previousSeries?: Maybe<Scalars['String']['output']>;
  /** История водительских удостоверений */
  profileFromESIADriver?: Maybe<TPeople>;
  /** История водительских удостоверений (ЕСИА) */
  profileFromESIADriverHistory?: Maybe<TProfile>;
  /** Водительское удостоверение (Сбер) */
  profileFromSberDriver?: Maybe<TProfile>;
  /** История водительских удостоверений (Сбер) */
  profileFromSberDriverHistory?: Maybe<TProfile>;
  /** Дата получения документа  */
  receiptDocDate?: Maybe<Scalars['DateTimeISO']['output']>;
  /** Релевантность  */
  relevance?: Maybe<EDocumentRelevance>;
  /** Серия  */
  series: Scalars['String']['output'];
  /** Источник паспорта (default или approved) */
  source: ESource;
  /** Статус  */
  status?: Maybe<EDocumentStatus>;
  /** Тип документа  */
  type?: Maybe<EDocumentType>;
  /** Дата последнего обновления объекта в БД */
  updated?: Maybe<Scalars['DateTimeISO']['output']>;
  /** ClientId продукта, обновившего объект */
  updatedBy?: Maybe<Scalars['String']['output']>;
  /** Дата валидации документа  */
  validateDateDoc?: Maybe<Scalars['DateTimeISO']['output']>;
};


export type TDriverLicenseCategoriesArgs = {
  pagination?: InputMaybe<TPagination>;
};


export type TDriverLicensePeopleArgs = {
  filter?: InputMaybe<TPeopleFilter>;
};


export type TDriverLicenseProfileFromEsiaDriverArgs = {
  filter?: InputMaybe<TPeopleFilter>;
};


export type TDriverLicenseProfileFromEsiaDriverHistoryArgs = {
  filter?: InputMaybe<TProfileFilter>;
};


export type TDriverLicenseProfileFromSberDriverArgs = {
  filter?: InputMaybe<TProfileFilter>;
};


export type TDriverLicenseProfileFromSberDriverHistoryArgs = {
  filter?: InputMaybe<TProfileFilter>;
};

export type TDriverLicenseFilter = {
  AND?: InputMaybe<Array<InputMaybe<TDriverLicenseFilter>>>;
  NOR?: InputMaybe<Array<InputMaybe<TDriverLicenseFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<TDriverLicenseFilter>>>;
  birthDate?: InputMaybe<TBirthDateFilter>;
  birthPlace?: InputMaybe<TStringFilter>;
  categories?: InputMaybe<TStringFilter>;
  countryName?: InputMaybe<TStringFilter>;
  created?: InputMaybe<TDateTimeIsoFilter>;
  createdBy?: InputMaybe<TStringFilter>;
  departmentDoc?: InputMaybe<TStringFilter>;
  experience?: InputMaybe<TDateTimeIsoFilter>;
  experienceA?: InputMaybe<TDateTimeIsoFilter>;
  experienceStartDate?: InputMaybe<TDateTimeIsoFilter>;
  expiryDate?: InputMaybe<TDateTimeIsoFilter>;
  firstIssueDate?: InputMaybe<TDateTimeIsoFilter>;
  firstName?: InputMaybe<TStrictStringFilter>;
  hash?: InputMaybe<TStringFilter>;
  id?: InputMaybe<TStringFilter>;
  issueDate?: InputMaybe<TDateTimeIsoFilter>;
  issuedBy?: InputMaybe<TStringFilter>;
  lastName?: InputMaybe<TStrictStringFilter>;
  middleName?: InputMaybe<TStrictStringFilter>;
  number?: InputMaybe<TStringFilter>;
  previousNumber?: InputMaybe<TStringFilter>;
  previousSeries?: InputMaybe<TStringFilter>;
  receiptDocDate?: InputMaybe<TDateTimeIsoFilter>;
  relevance?: InputMaybe<TEDocumentRelevanceFilter>;
  series?: InputMaybe<TStringFilter>;
  source?: InputMaybe<TESourceFilter>;
  status?: InputMaybe<TEDocumentStatusFilter>;
  type?: InputMaybe<TEDocumentTypeFilter>;
  updated?: InputMaybe<TDateTimeIsoFilter>;
  updatedBy?: InputMaybe<TStringFilter>;
  validateDateDoc?: InputMaybe<TDateTimeIsoFilter>;
};

export enum EAdditionalPhoneOwner {
  FriendNumber = 'friendNumber',
  MyNumber = 'myNumber',
  RelativeNumber = 'relativeNumber'
}

/** Filter type for EAdditionalPhoneOwner scalar */
export type TEAdditionalPhoneOwnerFilter = {
  /** [$all] Полное совпадение значений */
  ALL?: InputMaybe<Array<InputMaybe<EAdditionalPhoneOwner>>>;
  /** [$eq] Равенство значений */
  EQ?: InputMaybe<EAdditionalPhoneOwner>;
  /** [$in] Одно из значений */
  IN?: InputMaybe<Array<InputMaybe<EAdditionalPhoneOwner>>>;
  /** [$ne] Не равно переданному значению */
  NE?: InputMaybe<EAdditionalPhoneOwner>;
  /** [$nin] Не равно ни одному из переданных значений */
  NIN?: InputMaybe<Array<InputMaybe<EAdditionalPhoneOwner>>>;
  /** [$not] Логическое отрицание */
  NOT?: InputMaybe<TEAdditionalPhoneOwnerNotFilter>;
};

/** Filter type for $not of EAdditionalPhoneOwner scalar */
export type TEAdditionalPhoneOwnerNotFilter = {
  /** [$all] Полное совпадение значений */
  ALL?: InputMaybe<Array<InputMaybe<EAdditionalPhoneOwner>>>;
  /** [$eq] Равенство значений */
  EQ?: InputMaybe<EAdditionalPhoneOwner>;
  /** [$in] Одно из значений */
  IN?: InputMaybe<Array<InputMaybe<EAdditionalPhoneOwner>>>;
  /** [$ne] Не равно переданному значению */
  NE?: InputMaybe<EAdditionalPhoneOwner>;
  /** [$nin] Не равно ни одному из переданных значений */
  NIN?: InputMaybe<Array<InputMaybe<EAdditionalPhoneOwner>>>;
};

export enum ECarCategory {
  A = 'A',
  A1 = 'A1',
  B = 'B',
  B1 = 'B1',
  Be = 'BE',
  C = 'C',
  C1 = 'C1',
  C1E = 'C1E',
  Ce = 'CE',
  D = 'D',
  D1 = 'D1',
  D1E = 'D1E',
  De = 'DE',
  M = 'M',
  Tb = 'Tb',
  Tm = 'Tm'
}

/** Filter type for ECarCategory scalar */
export type TECarCategoryFilter = {
  /** [$all] Полное совпадение значений */
  ALL?: InputMaybe<Array<InputMaybe<ECarCategory>>>;
  /** [$eq] Равенство значений */
  EQ?: InputMaybe<ECarCategory>;
  /** [$in] Одно из значений */
  IN?: InputMaybe<Array<InputMaybe<ECarCategory>>>;
  /** [$ne] Не равно переданному значению */
  NE?: InputMaybe<ECarCategory>;
  /** [$nin] Не равно ни одному из переданных значений */
  NIN?: InputMaybe<Array<InputMaybe<ECarCategory>>>;
  /** [$not] Логическое отрицание */
  NOT?: InputMaybe<TECarCategoryNotFilter>;
};

/** Filter type for $not of ECarCategory scalar */
export type TECarCategoryNotFilter = {
  /** [$all] Полное совпадение значений */
  ALL?: InputMaybe<Array<InputMaybe<ECarCategory>>>;
  /** [$eq] Равенство значений */
  EQ?: InputMaybe<ECarCategory>;
  /** [$in] Одно из значений */
  IN?: InputMaybe<Array<InputMaybe<ECarCategory>>>;
  /** [$ne] Не равно переданному значению */
  NE?: InputMaybe<ECarCategory>;
  /** [$nin] Не равно ни одному из переданных значений */
  NIN?: InputMaybe<Array<InputMaybe<ECarCategory>>>;
};

export enum ECarDrive {
  FrontWheel = 'frontWheel',
  FullWheel = 'fullWheel',
  RearWheel = 'rearWheel'
}

/** Filter type for ECarDrive scalar */
export type TECarDriveFilter = {
  /** [$all] Полное совпадение значений */
  ALL?: InputMaybe<Array<InputMaybe<ECarDrive>>>;
  /** [$eq] Равенство значений */
  EQ?: InputMaybe<ECarDrive>;
  /** [$in] Одно из значений */
  IN?: InputMaybe<Array<InputMaybe<ECarDrive>>>;
  /** [$ne] Не равно переданному значению */
  NE?: InputMaybe<ECarDrive>;
  /** [$nin] Не равно ни одному из переданных значений */
  NIN?: InputMaybe<Array<InputMaybe<ECarDrive>>>;
  /** [$not] Логическое отрицание */
  NOT?: InputMaybe<TECarDriveNotFilter>;
};

/** Filter type for $not of ECarDrive scalar */
export type TECarDriveNotFilter = {
  /** [$all] Полное совпадение значений */
  ALL?: InputMaybe<Array<InputMaybe<ECarDrive>>>;
  /** [$eq] Равенство значений */
  EQ?: InputMaybe<ECarDrive>;
  /** [$in] Одно из значений */
  IN?: InputMaybe<Array<InputMaybe<ECarDrive>>>;
  /** [$ne] Не равно переданному значению */
  NE?: InputMaybe<ECarDrive>;
  /** [$nin] Не равно ни одному из переданных значений */
  NIN?: InputMaybe<Array<InputMaybe<ECarDrive>>>;
};

export enum ECitizenship {
  Ab = 'AB',
  Ad = 'AD',
  Ae = 'AE',
  Af = 'AF',
  Ag = 'AG',
  Ai = 'AI',
  Al = 'AL',
  Am = 'AM',
  Ao = 'AO',
  Aq = 'AQ',
  Ar = 'AR',
  As = 'AS',
  At = 'AT',
  Au = 'AU',
  Aw = 'AW',
  Ax = 'AX',
  Az = 'AZ',
  Ba = 'BA',
  Bb = 'BB',
  Bd = 'BD',
  Be = 'BE',
  Bf = 'BF',
  Bg = 'BG',
  Bh = 'BH',
  Bi = 'BI',
  Bj = 'BJ',
  Bl = 'BL',
  Bm = 'BM',
  Bn = 'BN',
  Bo = 'BO',
  Bq = 'BQ',
  Br = 'BR',
  Bs = 'BS',
  Bt = 'BT',
  Bv = 'BV',
  Bw = 'BW',
  By = 'BY',
  Bz = 'BZ',
  Ca = 'CA',
  Cc = 'CC',
  Cd = 'CD',
  Cf = 'CF',
  Cg = 'CG',
  Ch = 'CH',
  Ci = 'CI',
  Ck = 'CK',
  Cl = 'CL',
  Cm = 'CM',
  Cn = 'CN',
  Co = 'CO',
  Cr = 'CR',
  Cu = 'CU',
  Cv = 'CV',
  Cw = 'CW',
  Cx = 'CX',
  Cy = 'CY',
  Cz = 'CZ',
  De = 'DE',
  Dj = 'DJ',
  Dk = 'DK',
  Dm = 'DM',
  Dn = 'DN',
  Do = 'DO',
  Dz = 'DZ',
  Ec = 'EC',
  Ee = 'EE',
  Eg = 'EG',
  Eh = 'EH',
  Er = 'ER',
  Es = 'ES',
  Et = 'ET',
  Fi = 'FI',
  Fj = 'FJ',
  Fk = 'FK',
  Fm = 'FM',
  Fo = 'FO',
  Fr = 'FR',
  Ga = 'GA',
  Gb = 'GB',
  Gd = 'GD',
  Ge = 'GE',
  Gf = 'GF',
  Gg = 'GG',
  Gh = 'GH',
  Gi = 'GI',
  Gl = 'GL',
  Gm = 'GM',
  Gn = 'GN',
  Gp = 'GP',
  Gq = 'GQ',
  Gr = 'GR',
  Gs = 'GS',
  Gt = 'GT',
  Gu = 'GU',
  Gw = 'GW',
  Gy = 'GY',
  Hk = 'HK',
  Hm = 'HM',
  Hn = 'HN',
  Hr = 'HR',
  Ht = 'HT',
  Hu = 'HU',
  Id = 'ID',
  Ie = 'IE',
  Il = 'IL',
  Im = 'IM',
  In = 'IN',
  Io = 'IO',
  Iq = 'IQ',
  Ir = 'IR',
  Is = 'IS',
  It = 'IT',
  Je = 'JE',
  Jm = 'JM',
  Jo = 'JO',
  Jp = 'JP',
  Ke = 'KE',
  Kg = 'KG',
  Kh = 'KH',
  Ki = 'KI',
  Km = 'KM',
  Kn = 'KN',
  Kp = 'KP',
  Kr = 'KR',
  Kw = 'KW',
  Ky = 'KY',
  Kz = 'KZ',
  La = 'LA',
  Lb = 'LB',
  Lc = 'LC',
  Li = 'LI',
  Lk = 'LK',
  Ln = 'LN',
  Lr = 'LR',
  Ls = 'LS',
  Lt = 'LT',
  Lu = 'LU',
  Lv = 'LV',
  Ly = 'LY',
  Ma = 'MA',
  Mc = 'MC',
  Md = 'MD',
  Me = 'ME',
  Mf = 'MF',
  Mg = 'MG',
  Mh = 'MH',
  Mk = 'MK',
  Ml = 'ML',
  Mm = 'MM',
  Mn = 'MN',
  Mo = 'MO',
  Mp = 'MP',
  Mq = 'MQ',
  Mr = 'MR',
  Ms = 'MS',
  Mt = 'MT',
  Mu = 'MU',
  Mv = 'MV',
  Mw = 'MW',
  Mx = 'MX',
  My = 'MY',
  Mz = 'MZ',
  Na = 'NA',
  Nc = 'NC',
  Ne = 'NE',
  Nf = 'NF',
  Ng = 'NG',
  Ni = 'NI',
  Nl = 'NL',
  No = 'NO',
  Np = 'NP',
  Nr = 'NR',
  Nu = 'NU',
  Nz = 'NZ',
  Om = 'OM',
  Os = 'OS',
  Pa = 'PA',
  Pe = 'PE',
  Pf = 'PF',
  Pg = 'PG',
  Ph = 'PH',
  Pk = 'PK',
  Pl = 'PL',
  Pm = 'PM',
  Pn = 'PN',
  Pr = 'PR',
  Ps = 'PS',
  Pt = 'PT',
  Pw = 'PW',
  Py = 'PY',
  Qa = 'QA',
  Re = 'RE',
  Ro = 'RO',
  Rs = 'RS',
  Ru = 'RU',
  Rw = 'RW',
  Sa = 'SA',
  Sb = 'SB',
  Sc = 'SC',
  Sd = 'SD',
  Se = 'SE',
  Sg = 'SG',
  Sh = 'SH',
  Si = 'SI',
  Sj = 'SJ',
  Sk = 'SK',
  Sl = 'SL',
  Sm = 'SM',
  Sn = 'SN',
  So = 'SO',
  Sr = 'SR',
  Ss = 'SS',
  St = 'ST',
  Sv = 'SV',
  Sx = 'SX',
  Sy = 'SY',
  Sz = 'SZ',
  Tc = 'TC',
  Td = 'TD',
  Tf = 'TF',
  Tg = 'TG',
  Th = 'TH',
  Tj = 'TJ',
  Tk = 'TK',
  Tl = 'TL',
  Tm = 'TM',
  Tn = 'TN',
  To = 'TO',
  Tr = 'TR',
  Tt = 'TT',
  Tv = 'TV',
  Tw = 'TW',
  Tz = 'TZ',
  Ua = 'UA',
  Ug = 'UG',
  Um = 'UM',
  Us = 'US',
  Uy = 'UY',
  Uz = 'UZ',
  Va = 'VA',
  Vc = 'VC',
  Ve = 'VE',
  Vg = 'VG',
  Vi = 'VI',
  Vn = 'VN',
  Vu = 'VU',
  Wf = 'WF',
  Ws = 'WS',
  Ye = 'YE',
  Yt = 'YT',
  Za = 'ZA',
  Zm = 'ZM',
  Zw = 'ZW'
}

/** Filter type for ECitizenship scalar */
export type TECitizenshipFilter = {
  /** [$all] Полное совпадение значений */
  ALL?: InputMaybe<Array<InputMaybe<ECitizenship>>>;
  /** [$eq] Равенство значений */
  EQ?: InputMaybe<ECitizenship>;
  /** [$in] Одно из значений */
  IN?: InputMaybe<Array<InputMaybe<ECitizenship>>>;
  /** [$ne] Не равно переданному значению */
  NE?: InputMaybe<ECitizenship>;
  /** [$nin] Не равно ни одному из переданных значений */
  NIN?: InputMaybe<Array<InputMaybe<ECitizenship>>>;
  /** [$not] Логическое отрицание */
  NOT?: InputMaybe<TECitizenshipNotFilter>;
};

/** Filter type for $not of ECitizenship scalar */
export type TECitizenshipNotFilter = {
  /** [$all] Полное совпадение значений */
  ALL?: InputMaybe<Array<InputMaybe<ECitizenship>>>;
  /** [$eq] Равенство значений */
  EQ?: InputMaybe<ECitizenship>;
  /** [$in] Одно из значений */
  IN?: InputMaybe<Array<InputMaybe<ECitizenship>>>;
  /** [$ne] Не равно переданному значению */
  NE?: InputMaybe<ECitizenship>;
  /** [$nin] Не равно ни одному из переданных значений */
  NIN?: InputMaybe<Array<InputMaybe<ECitizenship>>>;
};

export enum ECreditPurpose {
  Money = 'money',
  Mortgage = 'mortgage',
  NewCar = 'newCar',
  RefinanceCredit = 'refinanceCredit',
  RefinanceMortgage = 'refinanceMortgage',
  UsedCar = 'usedCar'
}

/** Filter type for ECreditPurpose scalar */
export type TECreditPurposeFilter = {
  /** [$all] Полное совпадение значений */
  ALL?: InputMaybe<Array<InputMaybe<ECreditPurpose>>>;
  /** [$eq] Равенство значений */
  EQ?: InputMaybe<ECreditPurpose>;
  /** [$in] Одно из значений */
  IN?: InputMaybe<Array<InputMaybe<ECreditPurpose>>>;
  /** [$ne] Не равно переданному значению */
  NE?: InputMaybe<ECreditPurpose>;
  /** [$nin] Не равно ни одному из переданных значений */
  NIN?: InputMaybe<Array<InputMaybe<ECreditPurpose>>>;
  /** [$not] Логическое отрицание */
  NOT?: InputMaybe<TECreditPurposeNotFilter>;
};

/** Filter type for $not of ECreditPurpose scalar */
export type TECreditPurposeNotFilter = {
  /** [$all] Полное совпадение значений */
  ALL?: InputMaybe<Array<InputMaybe<ECreditPurpose>>>;
  /** [$eq] Равенство значений */
  EQ?: InputMaybe<ECreditPurpose>;
  /** [$in] Одно из значений */
  IN?: InputMaybe<Array<InputMaybe<ECreditPurpose>>>;
  /** [$ne] Не равно переданному значению */
  NE?: InputMaybe<ECreditPurpose>;
  /** [$nin] Не равно ни одному из переданных значений */
  NIN?: InputMaybe<Array<InputMaybe<ECreditPurpose>>>;
};

export enum ECreditSecurity {
  NoMatter = 'noMatter',
  SecuredByAvailableRealEstate = 'securedByAvailableRealEstate',
  SecuredByAvailableVehicle = 'securedByAvailableVehicle',
  WithoutBail = 'withoutBail'
}

/** Filter type for ECreditSecurity scalar */
export type TECreditSecurityFilter = {
  /** [$all] Полное совпадение значений */
  ALL?: InputMaybe<Array<InputMaybe<ECreditSecurity>>>;
  /** [$eq] Равенство значений */
  EQ?: InputMaybe<ECreditSecurity>;
  /** [$in] Одно из значений */
  IN?: InputMaybe<Array<InputMaybe<ECreditSecurity>>>;
  /** [$ne] Не равно переданному значению */
  NE?: InputMaybe<ECreditSecurity>;
  /** [$nin] Не равно ни одному из переданных значений */
  NIN?: InputMaybe<Array<InputMaybe<ECreditSecurity>>>;
  /** [$not] Логическое отрицание */
  NOT?: InputMaybe<TECreditSecurityNotFilter>;
};

/** Filter type for $not of ECreditSecurity scalar */
export type TECreditSecurityNotFilter = {
  /** [$all] Полное совпадение значений */
  ALL?: InputMaybe<Array<InputMaybe<ECreditSecurity>>>;
  /** [$eq] Равенство значений */
  EQ?: InputMaybe<ECreditSecurity>;
  /** [$in] Одно из значений */
  IN?: InputMaybe<Array<InputMaybe<ECreditSecurity>>>;
  /** [$ne] Не равно переданному значению */
  NE?: InputMaybe<ECreditSecurity>;
  /** [$nin] Не равно ни одному из переданных значений */
  NIN?: InputMaybe<Array<InputMaybe<ECreditSecurity>>>;
};

export enum EDependents {
  MoreThanThree = 'moreThanThree',
  One = 'one',
  Three = 'three',
  Two = 'two',
  Zero = 'zero'
}

/** Filter type for EDependents scalar */
export type TEDependentsFilter = {
  /** [$all] Полное совпадение значений */
  ALL?: InputMaybe<Array<InputMaybe<EDependents>>>;
  /** [$eq] Равенство значений */
  EQ?: InputMaybe<EDependents>;
  /** [$in] Одно из значений */
  IN?: InputMaybe<Array<InputMaybe<EDependents>>>;
  /** [$ne] Не равно переданному значению */
  NE?: InputMaybe<EDependents>;
  /** [$nin] Не равно ни одному из переданных значений */
  NIN?: InputMaybe<Array<InputMaybe<EDependents>>>;
  /** [$not] Логическое отрицание */
  NOT?: InputMaybe<TEDependentsNotFilter>;
};

/** Filter type for $not of EDependents scalar */
export type TEDependentsNotFilter = {
  /** [$all] Полное совпадение значений */
  ALL?: InputMaybe<Array<InputMaybe<EDependents>>>;
  /** [$eq] Равенство значений */
  EQ?: InputMaybe<EDependents>;
  /** [$in] Одно из значений */
  IN?: InputMaybe<Array<InputMaybe<EDependents>>>;
  /** [$ne] Не равно переданному значению */
  NE?: InputMaybe<EDependents>;
  /** [$nin] Не равно ни одному из переданных значений */
  NIN?: InputMaybe<Array<InputMaybe<EDependents>>>;
};

export enum EDocumentRelevance {
  Actual = 'actual',
  Expired = 'expired',
  Invalid = 'invalid'
}

/** Filter type for EDocumentRelevance scalar */
export type TEDocumentRelevanceFilter = {
  /** [$all] Полное совпадение значений */
  ALL?: InputMaybe<Array<InputMaybe<EDocumentRelevance>>>;
  /** [$eq] Равенство значений */
  EQ?: InputMaybe<EDocumentRelevance>;
  /** [$in] Одно из значений */
  IN?: InputMaybe<Array<InputMaybe<EDocumentRelevance>>>;
  /** [$ne] Не равно переданному значению */
  NE?: InputMaybe<EDocumentRelevance>;
  /** [$nin] Не равно ни одному из переданных значений */
  NIN?: InputMaybe<Array<InputMaybe<EDocumentRelevance>>>;
  /** [$not] Логическое отрицание */
  NOT?: InputMaybe<TEDocumentRelevanceNotFilter>;
};

/** Filter type for $not of EDocumentRelevance scalar */
export type TEDocumentRelevanceNotFilter = {
  /** [$all] Полное совпадение значений */
  ALL?: InputMaybe<Array<InputMaybe<EDocumentRelevance>>>;
  /** [$eq] Равенство значений */
  EQ?: InputMaybe<EDocumentRelevance>;
  /** [$in] Одно из значений */
  IN?: InputMaybe<Array<InputMaybe<EDocumentRelevance>>>;
  /** [$ne] Не равно переданному значению */
  NE?: InputMaybe<EDocumentRelevance>;
  /** [$nin] Не равно ни одному из переданных значений */
  NIN?: InputMaybe<Array<InputMaybe<EDocumentRelevance>>>;
};

export enum EDocumentStatus {
  Unverified = 'unverified',
  VerifiedByPush = 'verifiedByPush',
  VerifiedByRequest = 'verifiedByRequest',
  VerifiedByValidate = 'verifiedByValidate'
}

/** Filter type for EDocumentStatus scalar */
export type TEDocumentStatusFilter = {
  /** [$all] Полное совпадение значений */
  ALL?: InputMaybe<Array<InputMaybe<EDocumentStatus>>>;
  /** [$eq] Равенство значений */
  EQ?: InputMaybe<EDocumentStatus>;
  /** [$in] Одно из значений */
  IN?: InputMaybe<Array<InputMaybe<EDocumentStatus>>>;
  /** [$ne] Не равно переданному значению */
  NE?: InputMaybe<EDocumentStatus>;
  /** [$nin] Не равно ни одному из переданных значений */
  NIN?: InputMaybe<Array<InputMaybe<EDocumentStatus>>>;
  /** [$not] Логическое отрицание */
  NOT?: InputMaybe<TEDocumentStatusNotFilter>;
};

/** Filter type for $not of EDocumentStatus scalar */
export type TEDocumentStatusNotFilter = {
  /** [$all] Полное совпадение значений */
  ALL?: InputMaybe<Array<InputMaybe<EDocumentStatus>>>;
  /** [$eq] Равенство значений */
  EQ?: InputMaybe<EDocumentStatus>;
  /** [$in] Одно из значений */
  IN?: InputMaybe<Array<InputMaybe<EDocumentStatus>>>;
  /** [$ne] Не равно переданному значению */
  NE?: InputMaybe<EDocumentStatus>;
  /** [$nin] Не равно ни одному из переданных значений */
  NIN?: InputMaybe<Array<InputMaybe<EDocumentStatus>>>;
};

export enum EDocumentType {
  FrgnPass = 'frgn_pass',
  RfDrivingLicense = 'rf_driving_license',
  RfPassport = 'rf_passport',
  UssrPassport = 'ussr_passport'
}

/** Filter type for EDocumentType scalar */
export type TEDocumentTypeFilter = {
  /** [$all] Полное совпадение значений */
  ALL?: InputMaybe<Array<InputMaybe<EDocumentType>>>;
  /** [$eq] Равенство значений */
  EQ?: InputMaybe<EDocumentType>;
  /** [$in] Одно из значений */
  IN?: InputMaybe<Array<InputMaybe<EDocumentType>>>;
  /** [$ne] Не равно переданному значению */
  NE?: InputMaybe<EDocumentType>;
  /** [$nin] Не равно ни одному из переданных значений */
  NIN?: InputMaybe<Array<InputMaybe<EDocumentType>>>;
  /** [$not] Логическое отрицание */
  NOT?: InputMaybe<TEDocumentTypeNotFilter>;
};

/** Filter type for $not of EDocumentType scalar */
export type TEDocumentTypeNotFilter = {
  /** [$all] Полное совпадение значений */
  ALL?: InputMaybe<Array<InputMaybe<EDocumentType>>>;
  /** [$eq] Равенство значений */
  EQ?: InputMaybe<EDocumentType>;
  /** [$in] Одно из значений */
  IN?: InputMaybe<Array<InputMaybe<EDocumentType>>>;
  /** [$ne] Не равно переданному значению */
  NE?: InputMaybe<EDocumentType>;
  /** [$nin] Не равно ни одному из переданных значений */
  NIN?: InputMaybe<Array<InputMaybe<EDocumentType>>>;
};

export enum EEducation {
  AcademicDegree = 'academicDegree',
  Elementary = 'elementary',
  Higher = 'higher',
  IncompleteHigher = 'incompleteHigher',
  Primary = 'primary',
  SecondHigher = 'secondHigher'
}

/** Filter type for EEducation scalar */
export type TEEducationFilter = {
  /** [$all] Полное совпадение значений */
  ALL?: InputMaybe<Array<InputMaybe<EEducation>>>;
  /** [$eq] Равенство значений */
  EQ?: InputMaybe<EEducation>;
  /** [$in] Одно из значений */
  IN?: InputMaybe<Array<InputMaybe<EEducation>>>;
  /** [$ne] Не равно переданному значению */
  NE?: InputMaybe<EEducation>;
  /** [$nin] Не равно ни одному из переданных значений */
  NIN?: InputMaybe<Array<InputMaybe<EEducation>>>;
  /** [$not] Логическое отрицание */
  NOT?: InputMaybe<TEEducationNotFilter>;
};

/** Filter type for $not of EEducation scalar */
export type TEEducationNotFilter = {
  /** [$all] Полное совпадение значений */
  ALL?: InputMaybe<Array<InputMaybe<EEducation>>>;
  /** [$eq] Равенство значений */
  EQ?: InputMaybe<EEducation>;
  /** [$in] Одно из значений */
  IN?: InputMaybe<Array<InputMaybe<EEducation>>>;
  /** [$ne] Не равно переданному значению */
  NE?: InputMaybe<EEducation>;
  /** [$nin] Не равно ни одному из переданных значений */
  NIN?: InputMaybe<Array<InputMaybe<EEducation>>>;
};

export enum EEmployerType {
  Ao = 'AO',
  Ip = 'IP',
  Nao = 'NAO',
  Oao = 'OAO',
  Ooo = 'OOO',
  Pao = 'PAO',
  Zao = 'ZAO',
  Branch = 'branch',
  DontKnow = 'dontKnow',
  FederalBudgetaryInstitution = 'federalBudgetaryInstitution',
  FederalStateTreasury = 'federalStateTreasury',
  MunicipalInstitution = 'municipalInstitution',
  StateInstitution = 'stateInstitution'
}

/** Filter type for EEmployerType scalar */
export type TEEmployerTypeFilter = {
  /** [$all] Полное совпадение значений */
  ALL?: InputMaybe<Array<InputMaybe<EEmployerType>>>;
  /** [$eq] Равенство значений */
  EQ?: InputMaybe<EEmployerType>;
  /** [$in] Одно из значений */
  IN?: InputMaybe<Array<InputMaybe<EEmployerType>>>;
  /** [$ne] Не равно переданному значению */
  NE?: InputMaybe<EEmployerType>;
  /** [$nin] Не равно ни одному из переданных значений */
  NIN?: InputMaybe<Array<InputMaybe<EEmployerType>>>;
  /** [$not] Логическое отрицание */
  NOT?: InputMaybe<TEEmployerTypeNotFilter>;
};

/** Filter type for $not of EEmployerType scalar */
export type TEEmployerTypeNotFilter = {
  /** [$all] Полное совпадение значений */
  ALL?: InputMaybe<Array<InputMaybe<EEmployerType>>>;
  /** [$eq] Равенство значений */
  EQ?: InputMaybe<EEmployerType>;
  /** [$in] Одно из значений */
  IN?: InputMaybe<Array<InputMaybe<EEmployerType>>>;
  /** [$ne] Не равно переданному значению */
  NE?: InputMaybe<EEmployerType>;
  /** [$nin] Не равно ни одному из переданных значений */
  NIN?: InputMaybe<Array<InputMaybe<EEmployerType>>>;
};

export enum EEmploymentType {
  Ip = 'IP',
  Another = 'another',
  BusinessOwner = 'businessOwner',
  Employment = 'employment',
  EmploymentPermanent = 'employmentPermanent',
  Judge = 'judge',
  NotWorking = 'notWorking',
  Retired = 'retired',
  SelfEmployed = 'selfEmployed',
  Serviceman = 'serviceman',
  StateEmployee = 'stateEmployee'
}

/** Filter type for EEmploymentType scalar */
export type TEEmploymentTypeFilter = {
  /** [$all] Полное совпадение значений */
  ALL?: InputMaybe<Array<InputMaybe<EEmploymentType>>>;
  /** [$eq] Равенство значений */
  EQ?: InputMaybe<EEmploymentType>;
  /** [$in] Одно из значений */
  IN?: InputMaybe<Array<InputMaybe<EEmploymentType>>>;
  /** [$ne] Не равно переданному значению */
  NE?: InputMaybe<EEmploymentType>;
  /** [$nin] Не равно ни одному из переданных значений */
  NIN?: InputMaybe<Array<InputMaybe<EEmploymentType>>>;
  /** [$not] Логическое отрицание */
  NOT?: InputMaybe<TEEmploymentTypeNotFilter>;
};

/** Filter type for $not of EEmploymentType scalar */
export type TEEmploymentTypeNotFilter = {
  /** [$all] Полное совпадение значений */
  ALL?: InputMaybe<Array<InputMaybe<EEmploymentType>>>;
  /** [$eq] Равенство значений */
  EQ?: InputMaybe<EEmploymentType>;
  /** [$in] Одно из значений */
  IN?: InputMaybe<Array<InputMaybe<EEmploymentType>>>;
  /** [$ne] Не равно переданному значению */
  NE?: InputMaybe<EEmploymentType>;
  /** [$nin] Не равно ни одному из переданных значений */
  NIN?: InputMaybe<Array<InputMaybe<EEmploymentType>>>;
};

export enum EFamilyStatus {
  CivilMarriage = 'civilMarriage',
  Divorced = 'divorced',
  Married = 'married',
  Single = 'single',
  Widow = 'widow'
}

/** Filter type for EFamilyStatus scalar */
export type TEFamilyStatusFilter = {
  /** [$all] Полное совпадение значений */
  ALL?: InputMaybe<Array<InputMaybe<EFamilyStatus>>>;
  /** [$eq] Равенство значений */
  EQ?: InputMaybe<EFamilyStatus>;
  /** [$in] Одно из значений */
  IN?: InputMaybe<Array<InputMaybe<EFamilyStatus>>>;
  /** [$ne] Не равно переданному значению */
  NE?: InputMaybe<EFamilyStatus>;
  /** [$nin] Не равно ни одному из переданных значений */
  NIN?: InputMaybe<Array<InputMaybe<EFamilyStatus>>>;
  /** [$not] Логическое отрицание */
  NOT?: InputMaybe<TEFamilyStatusNotFilter>;
};

/** Filter type for $not of EFamilyStatus scalar */
export type TEFamilyStatusNotFilter = {
  /** [$all] Полное совпадение значений */
  ALL?: InputMaybe<Array<InputMaybe<EFamilyStatus>>>;
  /** [$eq] Равенство значений */
  EQ?: InputMaybe<EFamilyStatus>;
  /** [$in] Одно из значений */
  IN?: InputMaybe<Array<InputMaybe<EFamilyStatus>>>;
  /** [$ne] Не равно переданному значению */
  NE?: InputMaybe<EFamilyStatus>;
  /** [$nin] Не равно ни одному из переданных значений */
  NIN?: InputMaybe<Array<InputMaybe<EFamilyStatus>>>;
};

export enum EGender {
  Female = 'female',
  Male = 'male'
}

/** Filter type for EGender scalar */
export type TEGenderFilter = {
  /** [$all] Полное совпадение значений */
  ALL?: InputMaybe<Array<InputMaybe<EGender>>>;
  /** [$eq] Равенство значений */
  EQ?: InputMaybe<EGender>;
  /** [$in] Одно из значений */
  IN?: InputMaybe<Array<InputMaybe<EGender>>>;
  /** [$ne] Не равно переданному значению */
  NE?: InputMaybe<EGender>;
  /** [$nin] Не равно ни одному из переданных значений */
  NIN?: InputMaybe<Array<InputMaybe<EGender>>>;
  /** [$not] Логическое отрицание */
  NOT?: InputMaybe<TEGenderNotFilter>;
};

/** Filter type for $not of EGender scalar */
export type TEGenderNotFilter = {
  /** [$all] Полное совпадение значений */
  ALL?: InputMaybe<Array<InputMaybe<EGender>>>;
  /** [$eq] Равенство значений */
  EQ?: InputMaybe<EGender>;
  /** [$in] Одно из значений */
  IN?: InputMaybe<Array<InputMaybe<EGender>>>;
  /** [$ne] Не равно переданному значению */
  NE?: InputMaybe<EGender>;
  /** [$nin] Не равно ни одному из переданных значений */
  NIN?: InputMaybe<Array<InputMaybe<EGender>>>;
};

export enum EHabitationFloorMaterials {
  Composite = 'composite',
  Concrete = 'concrete',
  Metal = 'metal',
  Other = 'other',
  Wood = 'wood'
}

export enum EHabitationType {
  Flat = 'flat'
}

export enum EHabitationWallMaterials {
  Block = 'block',
  Brick = 'brick',
  Composite = 'composite',
  Concrete = 'concrete',
  Metal = 'metal',
  Other = 'other',
  Panel = 'panel',
  Rock = 'rock',
  Wood = 'wood'
}

export enum EHaveCar {
  Domestic = 'domestic',
  Foreign = 'foreign',
  No = 'no'
}

/** Filter type for EHaveCar scalar */
export type TEHaveCarFilter = {
  /** [$all] Полное совпадение значений */
  ALL?: InputMaybe<Array<InputMaybe<EHaveCar>>>;
  /** [$eq] Равенство значений */
  EQ?: InputMaybe<EHaveCar>;
  /** [$in] Одно из значений */
  IN?: InputMaybe<Array<InputMaybe<EHaveCar>>>;
  /** [$ne] Не равно переданному значению */
  NE?: InputMaybe<EHaveCar>;
  /** [$nin] Не равно ни одному из переданных значений */
  NIN?: InputMaybe<Array<InputMaybe<EHaveCar>>>;
  /** [$not] Логическое отрицание */
  NOT?: InputMaybe<TEHaveCarNotFilter>;
};

/** Filter type for $not of EHaveCar scalar */
export type TEHaveCarNotFilter = {
  /** [$all] Полное совпадение значений */
  ALL?: InputMaybe<Array<InputMaybe<EHaveCar>>>;
  /** [$eq] Равенство значений */
  EQ?: InputMaybe<EHaveCar>;
  /** [$in] Одно из значений */
  IN?: InputMaybe<Array<InputMaybe<EHaveCar>>>;
  /** [$ne] Не равно переданному значению */
  NE?: InputMaybe<EHaveCar>;
  /** [$nin] Не равно ни одному из переданных значений */
  NIN?: InputMaybe<Array<InputMaybe<EHaveCar>>>;
};

export enum EIncomeConfirmation {
  Ndfl2 = 'NDFL2',
  Ndfl3 = 'NDFL3',
  Any = 'any',
  BankForm = 'bankForm',
  None = 'none'
}

/** Filter type for EIncomeConfirmation scalar */
export type TEIncomeConfirmationFilter = {
  /** [$all] Полное совпадение значений */
  ALL?: InputMaybe<Array<InputMaybe<EIncomeConfirmation>>>;
  /** [$eq] Равенство значений */
  EQ?: InputMaybe<EIncomeConfirmation>;
  /** [$in] Одно из значений */
  IN?: InputMaybe<Array<InputMaybe<EIncomeConfirmation>>>;
  /** [$ne] Не равно переданному значению */
  NE?: InputMaybe<EIncomeConfirmation>;
  /** [$nin] Не равно ни одному из переданных значений */
  NIN?: InputMaybe<Array<InputMaybe<EIncomeConfirmation>>>;
  /** [$not] Логическое отрицание */
  NOT?: InputMaybe<TEIncomeConfirmationNotFilter>;
};

/** Filter type for $not of EIncomeConfirmation scalar */
export type TEIncomeConfirmationNotFilter = {
  /** [$all] Полное совпадение значений */
  ALL?: InputMaybe<Array<InputMaybe<EIncomeConfirmation>>>;
  /** [$eq] Равенство значений */
  EQ?: InputMaybe<EIncomeConfirmation>;
  /** [$in] Одно из значений */
  IN?: InputMaybe<Array<InputMaybe<EIncomeConfirmation>>>;
  /** [$ne] Не равно переданному значению */
  NE?: InputMaybe<EIncomeConfirmation>;
  /** [$nin] Не равно ни одному из переданных значений */
  NIN?: InputMaybe<Array<InputMaybe<EIncomeConfirmation>>>;
};

export enum EIntegrationDocumentStatus {
  Done = 'done',
  Empty = 'empty',
  Failed = 'failed',
  Pending = 'pending',
  Unsupported = 'unsupported'
}

/** Filter type for EIntegrationDocumentStatus scalar */
export type TEIntegrationDocumentStatusFilter = {
  /** [$all] Полное совпадение значений */
  ALL?: InputMaybe<Array<InputMaybe<EIntegrationDocumentStatus>>>;
  /** [$eq] Равенство значений */
  EQ?: InputMaybe<EIntegrationDocumentStatus>;
  /** [$in] Одно из значений */
  IN?: InputMaybe<Array<InputMaybe<EIntegrationDocumentStatus>>>;
  /** [$ne] Не равно переданному значению */
  NE?: InputMaybe<EIntegrationDocumentStatus>;
  /** [$nin] Не равно ни одному из переданных значений */
  NIN?: InputMaybe<Array<InputMaybe<EIntegrationDocumentStatus>>>;
  /** [$not] Логическое отрицание */
  NOT?: InputMaybe<TEIntegrationDocumentStatusNotFilter>;
};

/** Filter type for $not of EIntegrationDocumentStatus scalar */
export type TEIntegrationDocumentStatusNotFilter = {
  /** [$all] Полное совпадение значений */
  ALL?: InputMaybe<Array<InputMaybe<EIntegrationDocumentStatus>>>;
  /** [$eq] Равенство значений */
  EQ?: InputMaybe<EIntegrationDocumentStatus>;
  /** [$in] Одно из значений */
  IN?: InputMaybe<Array<InputMaybe<EIntegrationDocumentStatus>>>;
  /** [$ne] Не равно переданному значению */
  NE?: InputMaybe<EIntegrationDocumentStatus>;
  /** [$nin] Не равно ни одному из переданных значений */
  NIN?: InputMaybe<Array<InputMaybe<EIntegrationDocumentStatus>>>;
};

export enum EJobPosition {
  CivilServant = 'civilServant',
  HeadOfDepartment = 'headOfDepartment',
  HeadOfOrganization = 'headOfOrganization',
  ServiceStaff = 'serviceStaff',
  Soldier = 'soldier',
  Specialist = 'specialist'
}

/** Filter type for EJobPosition scalar */
export type TEJobPositionFilter = {
  /** [$all] Полное совпадение значений */
  ALL?: InputMaybe<Array<InputMaybe<EJobPosition>>>;
  /** [$eq] Равенство значений */
  EQ?: InputMaybe<EJobPosition>;
  /** [$in] Одно из значений */
  IN?: InputMaybe<Array<InputMaybe<EJobPosition>>>;
  /** [$ne] Не равно переданному значению */
  NE?: InputMaybe<EJobPosition>;
  /** [$nin] Не равно ни одному из переданных значений */
  NIN?: InputMaybe<Array<InputMaybe<EJobPosition>>>;
  /** [$not] Логическое отрицание */
  NOT?: InputMaybe<TEJobPositionNotFilter>;
};

/** Filter type for $not of EJobPosition scalar */
export type TEJobPositionNotFilter = {
  /** [$all] Полное совпадение значений */
  ALL?: InputMaybe<Array<InputMaybe<EJobPosition>>>;
  /** [$eq] Равенство значений */
  EQ?: InputMaybe<EJobPosition>;
  /** [$in] Одно из значений */
  IN?: InputMaybe<Array<InputMaybe<EJobPosition>>>;
  /** [$ne] Не равно переданному значению */
  NE?: InputMaybe<EJobPosition>;
  /** [$nin] Не равно ни одному из переданных значений */
  NIN?: InputMaybe<Array<InputMaybe<EJobPosition>>>;
};

export enum EKpp {
  Automatic = 'automatic',
  Manual = 'manual'
}

/** Filter type for EKpp scalar */
export type TEKppFilter = {
  /** [$all] Полное совпадение значений */
  ALL?: InputMaybe<Array<InputMaybe<EKpp>>>;
  /** [$eq] Равенство значений */
  EQ?: InputMaybe<EKpp>;
  /** [$in] Одно из значений */
  IN?: InputMaybe<Array<InputMaybe<EKpp>>>;
  /** [$ne] Не равно переданному значению */
  NE?: InputMaybe<EKpp>;
  /** [$nin] Не равно ни одному из переданных значений */
  NIN?: InputMaybe<Array<InputMaybe<EKpp>>>;
  /** [$not] Логическое отрицание */
  NOT?: InputMaybe<TEKppNotFilter>;
};

/** Filter type for $not of EKpp scalar */
export type TEKppNotFilter = {
  /** [$all] Полное совпадение значений */
  ALL?: InputMaybe<Array<InputMaybe<EKpp>>>;
  /** [$eq] Равенство значений */
  EQ?: InputMaybe<EKpp>;
  /** [$in] Одно из значений */
  IN?: InputMaybe<Array<InputMaybe<EKpp>>>;
  /** [$ne] Не равно переданному значению */
  NE?: InputMaybe<EKpp>;
  /** [$nin] Не равно ни одному из переданных значений */
  NIN?: InputMaybe<Array<InputMaybe<EKpp>>>;
};

export enum ELoanRestrictionsType {
  BankAll = 'BANK_ALL',
  BankMfoAll = 'BANK_MFO_ALL',
  BankOnline = 'BANK_ONLINE',
  Closed = 'CLOSED',
  MfoAll = 'MFO_ALL',
  MfoOnline = 'MFO_ONLINE'
}

/** Filter type for ELoanRestrictionsType scalar */
export type TELoanRestrictionsTypeFilter = {
  /** [$all] Полное совпадение значений */
  ALL?: InputMaybe<Array<InputMaybe<ELoanRestrictionsType>>>;
  /** [$eq] Равенство значений */
  EQ?: InputMaybe<ELoanRestrictionsType>;
  /** [$in] Одно из значений */
  IN?: InputMaybe<Array<InputMaybe<ELoanRestrictionsType>>>;
  /** [$ne] Не равно переданному значению */
  NE?: InputMaybe<ELoanRestrictionsType>;
  /** [$nin] Не равно ни одному из переданных значений */
  NIN?: InputMaybe<Array<InputMaybe<ELoanRestrictionsType>>>;
  /** [$not] Логическое отрицание */
  NOT?: InputMaybe<TELoanRestrictionsTypeNotFilter>;
};

/** Filter type for $not of ELoanRestrictionsType scalar */
export type TELoanRestrictionsTypeNotFilter = {
  /** [$all] Полное совпадение значений */
  ALL?: InputMaybe<Array<InputMaybe<ELoanRestrictionsType>>>;
  /** [$eq] Равенство значений */
  EQ?: InputMaybe<ELoanRestrictionsType>;
  /** [$in] Одно из значений */
  IN?: InputMaybe<Array<InputMaybe<ELoanRestrictionsType>>>;
  /** [$ne] Не равно переданному значению */
  NE?: InputMaybe<ELoanRestrictionsType>;
  /** [$nin] Не равно ни одному из переданных значений */
  NIN?: InputMaybe<Array<InputMaybe<ELoanRestrictionsType>>>;
};

export enum EObjectTypeName {
  Car = 'Car',
  DriverLicense = 'DriverLicense',
  FrgnPassport = 'FRGNPassport',
  Habitation = 'Habitation',
  Ndfl2 = 'NDFL2',
  Organization = 'Organization',
  Passport = 'Passport',
  PayoutIncome = 'PayoutIncome',
  People = 'People'
}

export enum EOrgOwnershipRoomType {
  Owner = 'owner',
  Renter = 'renter'
}

/** Filter type for EOrgOwnershipRoomType scalar */
export type TEOrgOwnershipRoomTypeFilter = {
  /** [$all] Полное совпадение значений */
  ALL?: InputMaybe<Array<InputMaybe<EOrgOwnershipRoomType>>>;
  /** [$eq] Равенство значений */
  EQ?: InputMaybe<EOrgOwnershipRoomType>;
  /** [$in] Одно из значений */
  IN?: InputMaybe<Array<InputMaybe<EOrgOwnershipRoomType>>>;
  /** [$ne] Не равно переданному значению */
  NE?: InputMaybe<EOrgOwnershipRoomType>;
  /** [$nin] Не равно ни одному из переданных значений */
  NIN?: InputMaybe<Array<InputMaybe<EOrgOwnershipRoomType>>>;
  /** [$not] Логическое отрицание */
  NOT?: InputMaybe<TEOrgOwnershipRoomTypeNotFilter>;
};

/** Filter type for $not of EOrgOwnershipRoomType scalar */
export type TEOrgOwnershipRoomTypeNotFilter = {
  /** [$all] Полное совпадение значений */
  ALL?: InputMaybe<Array<InputMaybe<EOrgOwnershipRoomType>>>;
  /** [$eq] Равенство значений */
  EQ?: InputMaybe<EOrgOwnershipRoomType>;
  /** [$in] Одно из значений */
  IN?: InputMaybe<Array<InputMaybe<EOrgOwnershipRoomType>>>;
  /** [$ne] Не равно переданному значению */
  NE?: InputMaybe<EOrgOwnershipRoomType>;
  /** [$nin] Не равно ни одному из переданных значений */
  NIN?: InputMaybe<Array<InputMaybe<EOrgOwnershipRoomType>>>;
};

export enum EOrgTaxationType {
  Ausn = 'ausn',
  Eshn = 'eshn',
  Osno = 'osno',
  Srp = 'srp',
  Usn = 'usn'
}

/** Filter type for EOrgTaxationType scalar */
export type TEOrgTaxationTypeFilter = {
  /** [$all] Полное совпадение значений */
  ALL?: InputMaybe<Array<InputMaybe<EOrgTaxationType>>>;
  /** [$eq] Равенство значений */
  EQ?: InputMaybe<EOrgTaxationType>;
  /** [$in] Одно из значений */
  IN?: InputMaybe<Array<InputMaybe<EOrgTaxationType>>>;
  /** [$ne] Не равно переданному значению */
  NE?: InputMaybe<EOrgTaxationType>;
  /** [$nin] Не равно ни одному из переданных значений */
  NIN?: InputMaybe<Array<InputMaybe<EOrgTaxationType>>>;
  /** [$not] Логическое отрицание */
  NOT?: InputMaybe<TEOrgTaxationTypeNotFilter>;
};

/** Filter type for $not of EOrgTaxationType scalar */
export type TEOrgTaxationTypeNotFilter = {
  /** [$all] Полное совпадение значений */
  ALL?: InputMaybe<Array<InputMaybe<EOrgTaxationType>>>;
  /** [$eq] Равенство значений */
  EQ?: InputMaybe<EOrgTaxationType>;
  /** [$in] Одно из значений */
  IN?: InputMaybe<Array<InputMaybe<EOrgTaxationType>>>;
  /** [$ne] Не равно переданному значению */
  NE?: InputMaybe<EOrgTaxationType>;
  /** [$nin] Не равно ни одному из переданных значений */
  NIN?: InputMaybe<Array<InputMaybe<EOrgTaxationType>>>;
};

export enum EOrganizationActivity {
  AgricultureFishingHuntingForestry = 'agricultureFishingHuntingForestry',
  Building = 'building',
  CultureSportsActivities = 'cultureSportsActivities',
  DefenseLawEnforcementAgencies = 'defenseLawEnforcementAgencies',
  Education = 'education',
  ElectricityGasWaterHeatSupply = 'electricityGasWaterHeatSupply',
  FinanceInsurance = 'financeInsurance',
  HealthCareSocialServices = 'healthCareSocialServices',
  ManufacturingIndustry = 'manufacturingIndustry',
  MiningIndustry = 'miningIndustry',
  Other = 'other',
  ProfessionalScientificTechnicalActivities = 'professionalScientificTechnicalActivities',
  StateMunicipalAdministration = 'stateMunicipalAdministration',
  TradeServicesCommunications = 'tradeServicesCommunications',
  Transport = 'transport'
}

/** Filter type for EOrganizationActivity scalar */
export type TEOrganizationActivityFilter = {
  /** [$all] Полное совпадение значений */
  ALL?: InputMaybe<Array<InputMaybe<EOrganizationActivity>>>;
  /** [$eq] Равенство значений */
  EQ?: InputMaybe<EOrganizationActivity>;
  /** [$in] Одно из значений */
  IN?: InputMaybe<Array<InputMaybe<EOrganizationActivity>>>;
  /** [$ne] Не равно переданному значению */
  NE?: InputMaybe<EOrganizationActivity>;
  /** [$nin] Не равно ни одному из переданных значений */
  NIN?: InputMaybe<Array<InputMaybe<EOrganizationActivity>>>;
  /** [$not] Логическое отрицание */
  NOT?: InputMaybe<TEOrganizationActivityNotFilter>;
};

/** Filter type for $not of EOrganizationActivity scalar */
export type TEOrganizationActivityNotFilter = {
  /** [$all] Полное совпадение значений */
  ALL?: InputMaybe<Array<InputMaybe<EOrganizationActivity>>>;
  /** [$eq] Равенство значений */
  EQ?: InputMaybe<EOrganizationActivity>;
  /** [$in] Одно из значений */
  IN?: InputMaybe<Array<InputMaybe<EOrganizationActivity>>>;
  /** [$ne] Не равно переданному значению */
  NE?: InputMaybe<EOrganizationActivity>;
  /** [$nin] Не равно ни одному из переданных значений */
  NIN?: InputMaybe<Array<InputMaybe<EOrganizationActivity>>>;
};

export enum EOrganizationRoomType {
  Commercial = 'commercial',
  Industrial = 'industrial',
  Office = 'office',
  Warehouse = 'warehouse'
}

/** Filter type for EOrganizationRoomType scalar */
export type TEOrganizationRoomTypeFilter = {
  /** [$all] Полное совпадение значений */
  ALL?: InputMaybe<Array<InputMaybe<EOrganizationRoomType>>>;
  /** [$eq] Равенство значений */
  EQ?: InputMaybe<EOrganizationRoomType>;
  /** [$in] Одно из значений */
  IN?: InputMaybe<Array<InputMaybe<EOrganizationRoomType>>>;
  /** [$ne] Не равно переданному значению */
  NE?: InputMaybe<EOrganizationRoomType>;
  /** [$nin] Не равно ни одному из переданных значений */
  NIN?: InputMaybe<Array<InputMaybe<EOrganizationRoomType>>>;
  /** [$not] Логическое отрицание */
  NOT?: InputMaybe<TEOrganizationRoomTypeNotFilter>;
};

/** Filter type for $not of EOrganizationRoomType scalar */
export type TEOrganizationRoomTypeNotFilter = {
  /** [$all] Полное совпадение значений */
  ALL?: InputMaybe<Array<InputMaybe<EOrganizationRoomType>>>;
  /** [$eq] Равенство значений */
  EQ?: InputMaybe<EOrganizationRoomType>;
  /** [$in] Одно из значений */
  IN?: InputMaybe<Array<InputMaybe<EOrganizationRoomType>>>;
  /** [$ne] Не равно переданному значению */
  NE?: InputMaybe<EOrganizationRoomType>;
  /** [$nin] Не равно ни одному из переданных значений */
  NIN?: InputMaybe<Array<InputMaybe<EOrganizationRoomType>>>;
};

export enum EOsagoCarDocumentType {
  Epts = 'EPTS',
  Pts = 'PTS',
  Sts = 'STS'
}

/** Filter type for EOsagoCarDocumentType scalar */
export type TEOsagoCarDocumentTypeFilter = {
  /** [$all] Полное совпадение значений */
  ALL?: InputMaybe<Array<InputMaybe<EOsagoCarDocumentType>>>;
  /** [$eq] Равенство значений */
  EQ?: InputMaybe<EOsagoCarDocumentType>;
  /** [$in] Одно из значений */
  IN?: InputMaybe<Array<InputMaybe<EOsagoCarDocumentType>>>;
  /** [$ne] Не равно переданному значению */
  NE?: InputMaybe<EOsagoCarDocumentType>;
  /** [$nin] Не равно ни одному из переданных значений */
  NIN?: InputMaybe<Array<InputMaybe<EOsagoCarDocumentType>>>;
  /** [$not] Логическое отрицание */
  NOT?: InputMaybe<TEOsagoCarDocumentTypeNotFilter>;
};

/** Filter type for $not of EOsagoCarDocumentType scalar */
export type TEOsagoCarDocumentTypeNotFilter = {
  /** [$all] Полное совпадение значений */
  ALL?: InputMaybe<Array<InputMaybe<EOsagoCarDocumentType>>>;
  /** [$eq] Равенство значений */
  EQ?: InputMaybe<EOsagoCarDocumentType>;
  /** [$in] Одно из значений */
  IN?: InputMaybe<Array<InputMaybe<EOsagoCarDocumentType>>>;
  /** [$ne] Не равно переданному значению */
  NE?: InputMaybe<EOsagoCarDocumentType>;
  /** [$nin] Не равно ни одному из переданных значений */
  NIN?: InputMaybe<Array<InputMaybe<EOsagoCarDocumentType>>>;
};

export enum EProfileChars {
  CarWantOnlyCredit = 'car_want_only_credit',
  GotMortWithoutIns = 'got_mort_without_ins',
  LowIncomeMfo = 'low_income_mfo',
  LowRevenueHighLoad = 'low_revenue_high_load',
  OnlyMfo = 'only_mfo',
  OsagoBoughtPolis = 'osago_bought_polis'
}

export enum EProfileOwnerSources {
  Alfa = 'alfa',
  Esia = 'esia',
  Mfo = 'mfo',
  Osago = 'osago',
  Red = 'red',
  Sber = 'sber',
  Tbank = 'tbank'
}

export enum EPropertyType {
  Apartments = 'apartments',
  CommercialRealEstate = 'commercialRealEstate',
  Flat = 'flat',
  Nothing = 'nothing'
}

/** Filter type for EPropertyType scalar */
export type TEPropertyTypeFilter = {
  /** [$all] Полное совпадение значений */
  ALL?: InputMaybe<Array<InputMaybe<EPropertyType>>>;
  /** [$eq] Равенство значений */
  EQ?: InputMaybe<EPropertyType>;
  /** [$in] Одно из значений */
  IN?: InputMaybe<Array<InputMaybe<EPropertyType>>>;
  /** [$ne] Не равно переданному значению */
  NE?: InputMaybe<EPropertyType>;
  /** [$nin] Не равно ни одному из переданных значений */
  NIN?: InputMaybe<Array<InputMaybe<EPropertyType>>>;
  /** [$not] Логическое отрицание */
  NOT?: InputMaybe<TEPropertyTypeNotFilter>;
};

/** Filter type for $not of EPropertyType scalar */
export type TEPropertyTypeNotFilter = {
  /** [$all] Полное совпадение значений */
  ALL?: InputMaybe<Array<InputMaybe<EPropertyType>>>;
  /** [$eq] Равенство значений */
  EQ?: InputMaybe<EPropertyType>;
  /** [$in] Одно из значений */
  IN?: InputMaybe<Array<InputMaybe<EPropertyType>>>;
  /** [$ne] Не равно переданному значению */
  NE?: InputMaybe<EPropertyType>;
  /** [$nin] Не равно ни одному из переданных значений */
  NIN?: InputMaybe<Array<InputMaybe<EPropertyType>>>;
};

export enum ERelationStatus {
  AnotherRelative = 'anotherRelative',
  Child = 'child',
  Other = 'other',
  Parent = 'parent',
  Spouse = 'spouse'
}

/** Filter type for ERelationStatus scalar */
export type TERelationStatusFilter = {
  /** [$all] Полное совпадение значений */
  ALL?: InputMaybe<Array<InputMaybe<ERelationStatus>>>;
  /** [$eq] Равенство значений */
  EQ?: InputMaybe<ERelationStatus>;
  /** [$in] Одно из значений */
  IN?: InputMaybe<Array<InputMaybe<ERelationStatus>>>;
  /** [$ne] Не равно переданному значению */
  NE?: InputMaybe<ERelationStatus>;
  /** [$nin] Не равно ни одному из переданных значений */
  NIN?: InputMaybe<Array<InputMaybe<ERelationStatus>>>;
  /** [$not] Логическое отрицание */
  NOT?: InputMaybe<TERelationStatusNotFilter>;
};

/** Filter type for $not of ERelationStatus scalar */
export type TERelationStatusNotFilter = {
  /** [$all] Полное совпадение значений */
  ALL?: InputMaybe<Array<InputMaybe<ERelationStatus>>>;
  /** [$eq] Равенство значений */
  EQ?: InputMaybe<ERelationStatus>;
  /** [$in] Одно из значений */
  IN?: InputMaybe<Array<InputMaybe<ERelationStatus>>>;
  /** [$ne] Не равно переданному значению */
  NE?: InputMaybe<ERelationStatus>;
  /** [$nin] Не равно ни одному из переданных значений */
  NIN?: InputMaybe<Array<InputMaybe<ERelationStatus>>>;
};

export type TEsiaeWorkbook = {
  __typename?: 'ESIAEWorkbook';
  /** Дата создания объекта в БД */
  created?: Maybe<Scalars['DateTimeISO']['output']>;
  /** ClientId продукта, создавшего объект */
  createdBy?: Maybe<Scalars['String']['output']>;
  /** ЕСИА */
  departmentDoc?: Maybe<Scalars['String']['output']>;
  /** События в электронной трудовой книжке */
  events?: Maybe<Array<Maybe<TEWorkbookEvent>>>;
  /** ЕСИА */
  hash?: Maybe<Scalars['String']['output']>;
  /** Идентификатор электронной книжки ЕСИА */
  id: Scalars['String']['output'];
  /** Электронная книжка */
  profile?: Maybe<TPeople>;
  /** Трудовая книжка ЕСИА */
  receiptDocDate?: Maybe<Scalars['DateTimeISO']['output']>;
  /** ЕСИА */
  relevance?: Maybe<EDocumentRelevance>;
  /** Источник */
  source: ESource;
  /** ЕСИА */
  status?: Maybe<EDocumentStatus>;
  /** Дата последнего обновления объекта в БД */
  updated?: Maybe<Scalars['DateTimeISO']['output']>;
  /** ClientId продукта, обновившего объект */
  updatedBy?: Maybe<Scalars['String']['output']>;
  /** Трудовая книжка ЕСИА */
  validateDateDoc?: Maybe<Scalars['DateTimeISO']['output']>;
};


export type TEsiaeWorkbookEventsArgs = {
  filter?: InputMaybe<TEWorkbookEventFilter>;
  pagination?: InputMaybe<TPagination>;
};


export type TEsiaeWorkbookProfileArgs = {
  filter?: InputMaybe<TPeopleFilter>;
};

export type TEsiaeWorkbookFilter = {
  AND?: InputMaybe<Array<InputMaybe<TEsiaeWorkbookFilter>>>;
  NOR?: InputMaybe<Array<InputMaybe<TEsiaeWorkbookFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<TEsiaeWorkbookFilter>>>;
  created?: InputMaybe<TDateTimeIsoFilter>;
  createdBy?: InputMaybe<TStringFilter>;
  departmentDoc?: InputMaybe<TStringFilter>;
  hash?: InputMaybe<TStringFilter>;
  id?: InputMaybe<TStringFilter>;
  receiptDocDate?: InputMaybe<TDateTimeIsoFilter>;
  relevance?: InputMaybe<TEDocumentRelevanceFilter>;
  source?: InputMaybe<TESourceFilter>;
  status?: InputMaybe<TEDocumentStatusFilter>;
  updated?: InputMaybe<TDateTimeIsoFilter>;
  updatedBy?: InputMaybe<TStringFilter>;
  validateDateDoc?: InputMaybe<TDateTimeIsoFilter>;
};

export type TEsiaVehicle = {
  __typename?: 'ESIAVehicle';
  /** Дата выдачи Одобрения типа ТС */
  approveDocumentDate?: Maybe<Scalars['DateTimeISO']['output']>;
  /** Кем выдано Одобрение типа ТС */
  approveIssueAgency?: Maybe<Scalars['String']['output']>;
  /** Серия и номер Одобрения типа ТС */
  approveSerNum?: Maybe<Scalars['String']['output']>;
  /** Цвет кузова */
  carcaseColor?: Maybe<Scalars['String']['output']>;
  /** Номер кузова */
  carcaseNumber?: Maybe<Scalars['String']['output']>;
  /** Номер шасси */
  chassisNumber?: Maybe<Scalars['String']['output']>;
  /** Дата создания объекта в БД */
  created?: Maybe<Scalars['DateTimeISO']['output']>;
  /** ClientId продукта, создавшего объект */
  createdBy?: Maybe<Scalars['String']['output']>;
  /** Таможенная декларация */
  customsDeclaration?: Maybe<Scalars['String']['output']>;
  /** Привод */
  driveUnitType?: Maybe<Scalars['String']['output']>;
  /** Экологический класс */
  ecologyClass?: Maybe<Scalars['String']['output']>;
  /** Модель двигателя */
  engineModel?: Maybe<Scalars['String']['output']>;
  /** Номер двигателя */
  engineNum?: Maybe<Scalars['String']['output']>;
  /** Мощность двигателя (л/с) */
  enginePowerHorse?: Maybe<Scalars['Float']['output']>;
  /** Можность двигателя (кВт) */
  enginePowerkVt?: Maybe<Scalars['Float']['output']>;
  /** Тип двигателя */
  engineType?: Maybe<Scalars['String']['output']>;
  /** Мощность двигателя */
  engineVolume?: Maybe<Scalars['Int']['output']>;
  /** Установлено ли ГБО */
  gazEnvironmentFlag?: Maybe<Scalars['Boolean']['output']>;
  /** Регистрационный знак */
  govRegNumber?: Maybe<Scalars['String']['output']>;
  /** Хеш */
  hash?: Maybe<Scalars['String']['output']>;
  /** ID */
  id?: Maybe<Scalars['Int']['output']>;
  /** Код страны-изготовителя */
  issueCountryCode?: Maybe<Scalars['String']['output']>;
  /** Страна-изготовитель */
  issueCountryName?: Maybe<Scalars['String']['output']>;
  /** Год выпуска */
  manufacturedYear: Scalars['Int']['output'];
  /** Производитель */
  manufacturer?: Maybe<Scalars['String']['output']>;
  /** Марка */
  markName: Scalars['String']['output'];
  /** Максимальный вес */
  maxWeight?: Maybe<Scalars['Int']['output']>;
  /** Модель */
  modelName: Scalars['String']['output'];
  owner?: Maybe<TNestedEsiaVehicleOwner>;
  ownerPeriod?: Maybe<Array<Maybe<TNestedEsiaVehicleOwnerPeriod>>>;
  /** Цена автомобиля */
  price?: Maybe<Scalars['Float']['output']>;
  /** Транспортное средство (ESIA) */
  profile?: Maybe<TProfile>;
  pts?: Maybe<TNestedEsiaVehiclePts>;
  regAction?: Maybe<Array<Maybe<TNestedEsiaVehicleRegAction>>>;
  registrationDoc?: Maybe<TNestedEsiaVehicleRegistrationDoc>;
  /** Ограничения */
  restrictions?: Maybe<Scalars['String']['output']>;
  /** Статус */
  status?: Maybe<Scalars['String']['output']>;
  /** Дата оформления таможенной декларации */
  tdtpoDocumentDate?: Maybe<Scalars['DateTimeISO']['output']>;
  /** Таможенный орган */
  tdtpoIssueAgency?: Maybe<Scalars['String']['output']>;
  /** Коробка передач */
  transmissionType?: Maybe<Scalars['String']['output']>;
  /** Дата последнего обновления объекта в БД */
  updated?: Maybe<Scalars['DateTimeISO']['output']>;
  /** ClientId продукта, обновившего объект */
  updatedBy?: Maybe<Scalars['String']['output']>;
  /** Статус оплаты утильсбора */
  utilizStatus?: Maybe<Scalars['String']['output']>;
  /** Категория авто */
  vehicleCategory?: Maybe<Scalars['String']['output']>;
  /** Тип авто */
  vehicleType?: Maybe<Scalars['String']['output']>;
  /** Класс авто */
  vehicleTypeTAM?: Maybe<Scalars['String']['output']>;
  /** VIN */
  vin?: Maybe<Scalars['String']['output']>;
  /** VIN2 */
  vin2?: Maybe<Scalars['String']['output']>;
  /** Вес без загрузки */
  weightWithoutLoading?: Maybe<Scalars['Int']['output']>;
  /** Расположение руля */
  wheelLocation?: Maybe<Scalars['String']['output']>;
};


export type TEsiaVehicleOwnerPeriodArgs = {
  pagination?: InputMaybe<TPagination>;
};


export type TEsiaVehicleProfileArgs = {
  filter?: InputMaybe<TProfileFilter>;
};


export type TEsiaVehicleRegActionArgs = {
  pagination?: InputMaybe<TPagination>;
};

export type TEsiaVehicleFilter = {
  AND?: InputMaybe<Array<InputMaybe<TEsiaVehicleFilter>>>;
  NOR?: InputMaybe<Array<InputMaybe<TEsiaVehicleFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<TEsiaVehicleFilter>>>;
  approveDocumentDate?: InputMaybe<TDateTimeIsoFilter>;
  approveIssueAgency?: InputMaybe<TStringFilter>;
  approveSerNum?: InputMaybe<TStringFilter>;
  carcaseColor?: InputMaybe<TStringFilter>;
  carcaseNumber?: InputMaybe<TStringFilter>;
  chassisNumber?: InputMaybe<TStringFilter>;
  created?: InputMaybe<TDateTimeIsoFilter>;
  createdBy?: InputMaybe<TStringFilter>;
  customsDeclaration?: InputMaybe<TStringFilter>;
  driveUnitType?: InputMaybe<TStringFilter>;
  ecologyClass?: InputMaybe<TStringFilter>;
  engineModel?: InputMaybe<TStringFilter>;
  engineNum?: InputMaybe<TStringFilter>;
  enginePowerHorse?: InputMaybe<TFloatFilter>;
  enginePowerkVt?: InputMaybe<TFloatFilter>;
  engineType?: InputMaybe<TStringFilter>;
  engineVolume?: InputMaybe<TIntFilter>;
  gazEnvironmentFlag?: InputMaybe<TBooleanFilter>;
  govRegNumber?: InputMaybe<TStringFilter>;
  hash?: InputMaybe<TStringFilter>;
  id?: InputMaybe<TIntFilter>;
  issueCountryCode?: InputMaybe<TStringFilter>;
  issueCountryName?: InputMaybe<TStringFilter>;
  manufacturedYear?: InputMaybe<TIntFilter>;
  manufacturer?: InputMaybe<TStringFilter>;
  markName?: InputMaybe<TStringFilter>;
  maxWeight?: InputMaybe<TIntFilter>;
  modelName?: InputMaybe<TStringFilter>;
  owner?: InputMaybe<TNestedEsiaVehicleOwnerObjectFilterType>;
  ownerPeriod?: InputMaybe<TNestedEsiaVehicleOwnerPeriodObjectFilterType>;
  price?: InputMaybe<TFloatFilter>;
  pts?: InputMaybe<TNestedEsiaVehiclePtsObjectFilterType>;
  regAction?: InputMaybe<TNestedEsiaVehicleRegActionObjectFilterType>;
  registrationDoc?: InputMaybe<TNestedEsiaVehicleRegistrationDocObjectFilterType>;
  restrictions?: InputMaybe<TStringFilter>;
  status?: InputMaybe<TStringFilter>;
  tdtpoDocumentDate?: InputMaybe<TDateTimeIsoFilter>;
  tdtpoIssueAgency?: InputMaybe<TStringFilter>;
  transmissionType?: InputMaybe<TStringFilter>;
  updated?: InputMaybe<TDateTimeIsoFilter>;
  updatedBy?: InputMaybe<TStringFilter>;
  utilizStatus?: InputMaybe<TStringFilter>;
  vehicleCategory?: InputMaybe<TStringFilter>;
  vehicleType?: InputMaybe<TStringFilter>;
  vehicleTypeTAM?: InputMaybe<TStringFilter>;
  vin?: InputMaybe<TStringFilter>;
  vin2?: InputMaybe<TStringFilter>;
  weightWithoutLoading?: InputMaybe<TIntFilter>;
  wheelLocation?: InputMaybe<TStringFilter>;
};

export enum ESource {
  Alfa = 'alfa',
  Approved = 'approved',
  Esia = 'esia',
  Manual = 'manual',
  Sber = 'sber',
  Tbank = 'tbank'
}

/** Filter type for ESource scalar */
export type TESourceFilter = {
  /** [$all] Полное совпадение значений */
  ALL?: InputMaybe<Array<InputMaybe<ESource>>>;
  /** [$eq] Равенство значений */
  EQ?: InputMaybe<ESource>;
  /** [$in] Одно из значений */
  IN?: InputMaybe<Array<InputMaybe<ESource>>>;
  /** [$ne] Не равно переданному значению */
  NE?: InputMaybe<ESource>;
  /** [$nin] Не равно ни одному из переданных значений */
  NIN?: InputMaybe<Array<InputMaybe<ESource>>>;
  /** [$not] Логическое отрицание */
  NOT?: InputMaybe<TESourceNotFilter>;
};

/** Filter type for $not of ESource scalar */
export type TESourceNotFilter = {
  /** [$all] Полное совпадение значений */
  ALL?: InputMaybe<Array<InputMaybe<ESource>>>;
  /** [$eq] Равенство значений */
  EQ?: InputMaybe<ESource>;
  /** [$in] Одно из значений */
  IN?: InputMaybe<Array<InputMaybe<ESource>>>;
  /** [$ne] Не равно переданному значению */
  NE?: InputMaybe<ESource>;
  /** [$nin] Не равно ни одному из переданных значений */
  NIN?: InputMaybe<Array<InputMaybe<ESource>>>;
};

export enum EUnemploymentReason {
  Other = 'other',
  PensionerByAge = 'pensionerByAge',
  PensionerByDisability = 'pensionerByDisability',
  RetiredJudge = 'retiredJudge',
  SearchJob = 'searchJob',
  Spouse = 'spouse'
}

/** Filter type for EUnemploymentReason scalar */
export type TEUnemploymentReasonFilter = {
  /** [$all] Полное совпадение значений */
  ALL?: InputMaybe<Array<InputMaybe<EUnemploymentReason>>>;
  /** [$eq] Равенство значений */
  EQ?: InputMaybe<EUnemploymentReason>;
  /** [$in] Одно из значений */
  IN?: InputMaybe<Array<InputMaybe<EUnemploymentReason>>>;
  /** [$ne] Не равно переданному значению */
  NE?: InputMaybe<EUnemploymentReason>;
  /** [$nin] Не равно ни одному из переданных значений */
  NIN?: InputMaybe<Array<InputMaybe<EUnemploymentReason>>>;
  /** [$not] Логическое отрицание */
  NOT?: InputMaybe<TEUnemploymentReasonNotFilter>;
};

/** Filter type for $not of EUnemploymentReason scalar */
export type TEUnemploymentReasonNotFilter = {
  /** [$all] Полное совпадение значений */
  ALL?: InputMaybe<Array<InputMaybe<EUnemploymentReason>>>;
  /** [$eq] Равенство значений */
  EQ?: InputMaybe<EUnemploymentReason>;
  /** [$in] Одно из значений */
  IN?: InputMaybe<Array<InputMaybe<EUnemploymentReason>>>;
  /** [$ne] Не равно переданному значению */
  NE?: InputMaybe<EUnemploymentReason>;
  /** [$nin] Не равно ни одному из переданных значений */
  NIN?: InputMaybe<Array<InputMaybe<EUnemploymentReason>>>;
};

export enum EWheelLocation {
  Left = 'left',
  Right = 'right'
}

/** Filter type for EWheelLocation scalar */
export type TEWheelLocationFilter = {
  /** [$all] Полное совпадение значений */
  ALL?: InputMaybe<Array<InputMaybe<EWheelLocation>>>;
  /** [$eq] Равенство значений */
  EQ?: InputMaybe<EWheelLocation>;
  /** [$in] Одно из значений */
  IN?: InputMaybe<Array<InputMaybe<EWheelLocation>>>;
  /** [$ne] Не равно переданному значению */
  NE?: InputMaybe<EWheelLocation>;
  /** [$nin] Не равно ни одному из переданных значений */
  NIN?: InputMaybe<Array<InputMaybe<EWheelLocation>>>;
  /** [$not] Логическое отрицание */
  NOT?: InputMaybe<TEWheelLocationNotFilter>;
};

/** Filter type for $not of EWheelLocation scalar */
export type TEWheelLocationNotFilter = {
  /** [$all] Полное совпадение значений */
  ALL?: InputMaybe<Array<InputMaybe<EWheelLocation>>>;
  /** [$eq] Равенство значений */
  EQ?: InputMaybe<EWheelLocation>;
  /** [$in] Одно из значений */
  IN?: InputMaybe<Array<InputMaybe<EWheelLocation>>>;
  /** [$ne] Не равно переданному значению */
  NE?: InputMaybe<EWheelLocation>;
  /** [$nin] Не равно ни одному из переданных значений */
  NIN?: InputMaybe<Array<InputMaybe<EWheelLocation>>>;
};

export enum EWorkExperience {
  BetweenOneAndThreeYears = 'betweenOneAndThreeYears',
  BetweenThreeAndTenYears = 'betweenThreeAndTenYears',
  LessOneYear = 'lessOneYear',
  MoreTenYears = 'moreTenYears'
}

/** Filter type for EWorkExperience scalar */
export type TEWorkExperienceFilter = {
  /** [$all] Полное совпадение значений */
  ALL?: InputMaybe<Array<InputMaybe<EWorkExperience>>>;
  /** [$eq] Равенство значений */
  EQ?: InputMaybe<EWorkExperience>;
  /** [$in] Одно из значений */
  IN?: InputMaybe<Array<InputMaybe<EWorkExperience>>>;
  /** [$ne] Не равно переданному значению */
  NE?: InputMaybe<EWorkExperience>;
  /** [$nin] Не равно ни одному из переданных значений */
  NIN?: InputMaybe<Array<InputMaybe<EWorkExperience>>>;
  /** [$not] Логическое отрицание */
  NOT?: InputMaybe<TEWorkExperienceNotFilter>;
};

/** Filter type for $not of EWorkExperience scalar */
export type TEWorkExperienceNotFilter = {
  /** [$all] Полное совпадение значений */
  ALL?: InputMaybe<Array<InputMaybe<EWorkExperience>>>;
  /** [$eq] Равенство значений */
  EQ?: InputMaybe<EWorkExperience>;
  /** [$in] Одно из значений */
  IN?: InputMaybe<Array<InputMaybe<EWorkExperience>>>;
  /** [$ne] Не равно переданному значению */
  NE?: InputMaybe<EWorkExperience>;
  /** [$nin] Не равно ни одному из переданных значений */
  NIN?: InputMaybe<Array<InputMaybe<EWorkExperience>>>;
};

export type TEWorkbookEvent = {
  __typename?: 'EWorkbookEvent';
  /** Дата создания объекта в БД */
  created?: Maybe<Scalars['DateTimeISO']['output']>;
  /** ClientId продукта, создавшего объект */
  createdBy?: Maybe<Scalars['String']['output']>;
  /** ЕСИА */
  date: Scalars['DateTimeISO']['output'];
  dismissalBasis?: Maybe<TNestedEWorkbookEventDismissalBasis>;
  /** ЕСИА */
  dismissalReason?: Maybe<Scalars['String']['output']>;
  /** ЕСИА */
  division?: Maybe<Scalars['String']['output']>;
  /** hash */
  hash?: Maybe<Scalars['String']['output']>;
  /** ЕСИА */
  isPartTimeJob?: Maybe<Scalars['Boolean']['output']>;
  organization?: Maybe<TNestedEWorkbookEventOrganization>;
  /** ЕСИА */
  position?: Maybe<Scalars['String']['output']>;
  /** Список основания для события */
  reason?: Maybe<Array<Maybe<TNestedEWorkbookEventReason>>>;
  /** Источник */
  source: ESource;
  /** ЕСИА */
  type: Scalars['Int']['output'];
  /** Дата последнего обновления объекта в БД */
  updated?: Maybe<Scalars['DateTimeISO']['output']>;
  /** ClientId продукта, обновившего объект */
  updatedBy?: Maybe<Scalars['String']['output']>;
  /** ЕСИА */
  uuid: Scalars['String']['output'];
};


export type TEWorkbookEventReasonArgs = {
  pagination?: InputMaybe<TPagination>;
};

export type TEWorkbookEventFilter = {
  AND?: InputMaybe<Array<InputMaybe<TEWorkbookEventFilter>>>;
  NOR?: InputMaybe<Array<InputMaybe<TEWorkbookEventFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<TEWorkbookEventFilter>>>;
  created?: InputMaybe<TDateTimeIsoFilter>;
  createdBy?: InputMaybe<TStringFilter>;
  date?: InputMaybe<TDateTimeIsoFilter>;
  dismissalBasis?: InputMaybe<TNestedEWorkbookEventDismissalBasisObjectFilterType>;
  dismissalReason?: InputMaybe<TStringFilter>;
  division?: InputMaybe<TStringFilter>;
  hash?: InputMaybe<TStringFilter>;
  isPartTimeJob?: InputMaybe<TBooleanFilter>;
  organization?: InputMaybe<TNestedEWorkbookEventOrganizationObjectFilterType>;
  position?: InputMaybe<TStringFilter>;
  reason?: InputMaybe<TNestedEWorkbookEventReasonObjectFilterType>;
  source?: InputMaybe<TESourceFilter>;
  type?: InputMaybe<TIntFilter>;
  updated?: InputMaybe<TDateTimeIsoFilter>;
  updatedBy?: InputMaybe<TStringFilter>;
  uuid?: InputMaybe<TStringFilter>;
};

/** Filter type for EmailAddress scalar */
export type TEmailAddressFilter = {
  /** [$all] Полное совпадение значений */
  ALL?: InputMaybe<Array<InputMaybe<Scalars['EmailAddress']['input']>>>;
  /** [$eq] Равенство значений */
  EQ?: InputMaybe<Scalars['EmailAddress']['input']>;
  /** [$in] Одно из значений */
  IN?: InputMaybe<Array<InputMaybe<Scalars['EmailAddress']['input']>>>;
  /** [$ne] Не равно переданному значению */
  NE?: InputMaybe<Scalars['EmailAddress']['input']>;
  /** [$nin] Не равно ни одному из переданных значений */
  NIN?: InputMaybe<Array<InputMaybe<Scalars['EmailAddress']['input']>>>;
  /** [$not] Логическое отрицание */
  NOT?: InputMaybe<TEmailAddressNotFilter>;
};

/** Filter type for $not of EmailAddress scalar */
export type TEmailAddressNotFilter = {
  /** [$all] Полное совпадение значений */
  ALL?: InputMaybe<Array<InputMaybe<Scalars['EmailAddress']['input']>>>;
  /** [$eq] Равенство значений */
  EQ?: InputMaybe<Scalars['EmailAddress']['input']>;
  /** [$in] Одно из значений */
  IN?: InputMaybe<Array<InputMaybe<Scalars['EmailAddress']['input']>>>;
  /** [$ne] Не равно переданному значению */
  NE?: InputMaybe<Scalars['EmailAddress']['input']>;
  /** [$nin] Не равно ни одному из переданных значений */
  NIN?: InputMaybe<Array<InputMaybe<Scalars['EmailAddress']['input']>>>;
};

export type TFrgnPassport = {
  __typename?: 'FRGNPassport';
  /** Дата рождения */
  birthDate?: Maybe<Scalars['BirthDate']['output']>;
  /** Место рождения */
  birthPlace?: Maybe<Scalars['String']['output']>;
  /** Дата создания объекта в БД */
  created?: Maybe<Scalars['DateTimeISO']['output']>;
  /** ClientId продукта, создавшего объект */
  createdBy?: Maybe<Scalars['String']['output']>;
  /** Ведомство */
  departmentDoc?: Maybe<Scalars['String']['output']>;
  /** Дата окончания срока действия */
  expirationDate?: Maybe<Scalars['DateTimeISO']['output']>;
  /** Имя */
  firstName?: Maybe<Scalars['StrictString']['output']>;
  /** Пол клиента */
  gender?: Maybe<EGender>;
  hash?: Maybe<Scalars['String']['output']>;
  /**
   * ИД документа ESIA
   * @deprecated This field is deprecated. Never use it
   */
  id?: Maybe<Scalars['String']['output']>;
  /** Дата выдачи */
  issueDate?: Maybe<Scalars['DateTimeISO']['output']>;
  /** Код подразделения */
  issueId?: Maybe<Scalars['IssueId']['output']>;
  /** Кем выдан паспорт */
  issuedBy?: Maybe<Scalars['String']['output']>;
  /** Фамилия */
  lastName?: Maybe<Scalars['StrictString']['output']>;
  /** Отчество */
  middleName?: Maybe<Scalars['StrictString']['output']>;
  /** Номер */
  number: Scalars['String']['output'];
  /** Статус паспорта ESIA */
  passportStatus?: Maybe<Scalars['String']['output']>;
  /**
   * Тип паспорта
   * @deprecated Не используется. Отдельные типы паспорта в отдельных типах данных.
   */
  passportType?: Maybe<Scalars['String']['output']>;
  /** История заграничных паспортов */
  people?: Maybe<TPeople>;
  /** Последний заграничный паспорт [ЕСИА] */
  peopleFromEsiaFrgnPassport?: Maybe<TPeople>;
  /** История заграничных паспортов [ЕСИА] */
  peopleFromEsiaFrgnPassportHistory?: Maybe<TPeople>;
  /** Последний заграничный паспорт [Сбер] */
  peopleFromSberFrgnPassport?: Maybe<TPeople>;
  /** История заграничных паспортов [Сбер] */
  peopleFromSberFrgnPassportHistory?: Maybe<TPeople>;
  /** Последний заграничный паспорт [ТБанк] */
  peopleFromTBankFrgnPassport?: Maybe<TPeople>;
  /** История заграничных паспортов [ТБанк] */
  peopleFromTBankFrgnPassportHistory?: Maybe<TPeople>;
  /** Последний заграничный паспорт [ТБанк] */
  profile?: Maybe<TProfile>;
  /** Дата получения документа */
  receiptDocDate?: Maybe<Scalars['DateTimeISO']['output']>;
  /** Релевантность ESIA */
  relevance?: Maybe<EDocumentRelevance>;
  /** Серия */
  series: Scalars['String']['output'];
  /** Источник паспорта (manual или esia) */
  source: ESource;
  /**
   * Статус ESIA
   * @deprecated Поле бесмысленно и не используется.
   */
  status?: Maybe<EDocumentStatus>;
  /**
   * Тип документа
   * @deprecated Поле бесмысленно и не используется.
   */
  type?: Maybe<EDocumentType>;
  /** Дата последнего обновления объекта в БД */
  updated?: Maybe<Scalars['DateTimeISO']['output']>;
  /** ClientId продукта, обновившего объект */
  updatedBy?: Maybe<Scalars['String']['output']>;
  /**
   * Дата валидации документа ESIA
   * @deprecated This field is deprecated. Never use it
   */
  validateDateDoc?: Maybe<Scalars['DateTimeISO']['output']>;
};


export type TFrgnPassportPeopleArgs = {
  filter?: InputMaybe<TPeopleFilter>;
};


export type TFrgnPassportPeopleFromEsiaFrgnPassportArgs = {
  filter?: InputMaybe<TPeopleFilter>;
};


export type TFrgnPassportPeopleFromEsiaFrgnPassportHistoryArgs = {
  filter?: InputMaybe<TPeopleFilter>;
};


export type TFrgnPassportPeopleFromSberFrgnPassportArgs = {
  filter?: InputMaybe<TPeopleFilter>;
};


export type TFrgnPassportPeopleFromSberFrgnPassportHistoryArgs = {
  filter?: InputMaybe<TPeopleFilter>;
};


export type TFrgnPassportPeopleFromTBankFrgnPassportArgs = {
  filter?: InputMaybe<TPeopleFilter>;
};


export type TFrgnPassportPeopleFromTBankFrgnPassportHistoryArgs = {
  filter?: InputMaybe<TPeopleFilter>;
};


export type TFrgnPassportProfileArgs = {
  filter?: InputMaybe<TProfileFilter>;
};

export type TFrgnPassportFilter = {
  AND?: InputMaybe<Array<InputMaybe<TFrgnPassportFilter>>>;
  NOR?: InputMaybe<Array<InputMaybe<TFrgnPassportFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<TFrgnPassportFilter>>>;
  birthDate?: InputMaybe<TBirthDateFilter>;
  birthPlace?: InputMaybe<TStringFilter>;
  created?: InputMaybe<TDateTimeIsoFilter>;
  createdBy?: InputMaybe<TStringFilter>;
  departmentDoc?: InputMaybe<TStringFilter>;
  expirationDate?: InputMaybe<TDateTimeIsoFilter>;
  firstName?: InputMaybe<TStrictStringFilter>;
  gender?: InputMaybe<TEGenderFilter>;
  hash?: InputMaybe<TStringFilter>;
  id?: InputMaybe<TStringFilter>;
  issueDate?: InputMaybe<TDateTimeIsoFilter>;
  issueId?: InputMaybe<TIssueIdFilter>;
  issuedBy?: InputMaybe<TStringFilter>;
  lastName?: InputMaybe<TStrictStringFilter>;
  middleName?: InputMaybe<TStrictStringFilter>;
  number?: InputMaybe<TStringFilter>;
  passportStatus?: InputMaybe<TStringFilter>;
  passportType?: InputMaybe<TStringFilter>;
  receiptDocDate?: InputMaybe<TDateTimeIsoFilter>;
  relevance?: InputMaybe<TEDocumentRelevanceFilter>;
  series?: InputMaybe<TStringFilter>;
  source?: InputMaybe<TESourceFilter>;
  status?: InputMaybe<TEDocumentStatusFilter>;
  type?: InputMaybe<TEDocumentTypeFilter>;
  updated?: InputMaybe<TDateTimeIsoFilter>;
  updatedBy?: InputMaybe<TStringFilter>;
  validateDateDoc?: InputMaybe<TDateTimeIsoFilter>;
};

/** Filter type for Float scalar */
export type TFloatFilter = {
  /** [$all] Полное совпадение значений */
  ALL?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  /** [$eq] Равенство значений */
  EQ?: InputMaybe<Scalars['Float']['input']>;
  /** [$gt] Больше переданного значения */
  GT?: InputMaybe<Scalars['Float']['input']>;
  /** [$gte] Больше или равно переданному значению */
  GTE?: InputMaybe<Scalars['Float']['input']>;
  /** [$in] Одно из значений */
  IN?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  /** [$lt] Меньше переданного значения */
  LT?: InputMaybe<Scalars['Float']['input']>;
  /** [$lte] Меньше или равно переданного значения */
  LTE?: InputMaybe<Scalars['Float']['input']>;
  /** [$ne] Не равно переданному значению */
  NE?: InputMaybe<Scalars['Float']['input']>;
  /** [$nin] Не равно ни одному из переданных значений */
  NIN?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  /** [$not] Логическое отрицание */
  NOT?: InputMaybe<TFloatNotFilter>;
};

/** Filter type for $not of Float scalar */
export type TFloatNotFilter = {
  /** [$all] Полное совпадение значений */
  ALL?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  /** [$eq] Равенство значений */
  EQ?: InputMaybe<Scalars['Float']['input']>;
  /** [$gt] Больше переданного значения */
  GT?: InputMaybe<Scalars['Float']['input']>;
  /** [$gte] Больше или равно переданному значению */
  GTE?: InputMaybe<Scalars['Float']['input']>;
  /** [$in] Одно из значений */
  IN?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  /** [$lt] Меньше переданного значения */
  LT?: InputMaybe<Scalars['Float']['input']>;
  /** [$lte] Меньше или равно переданного значения */
  LTE?: InputMaybe<Scalars['Float']['input']>;
  /** [$ne] Не равно переданному значению */
  NE?: InputMaybe<Scalars['Float']['input']>;
  /** [$nin] Не равно ни одному из переданных значений */
  NIN?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
};

export type THabitation = {
  __typename?: 'Habitation';
  Alfa?: Maybe<TNestedHabitationAlfa>;
  Sber?: Maybe<TNestedHabitationSber>;
  TBank?: Maybe<TNestedHabitationTBank>;
  address: TNestedHabitationAddress;
  /** Псевдоним объекта */
  alias?: Maybe<Scalars['String']['output']>;
  /** Вручную подтвержденный адрес регистрации в CRM */
  approvedPassport?: Maybe<TPassport>;
  /** Дата создания объекта в БД */
  created?: Maybe<Scalars['DateTimeISO']['output']>;
  /** ClientId продукта, создавшего объект */
  createdBy?: Maybe<Scalars['String']['output']>;
  creditSelection?: Maybe<TNestedHabitationCreditSelection>;
  /** Адрес залога в кредитах */
  creditSelectionPledgers?: Maybe<Array<Maybe<TPeople>>>;
  documents?: Maybe<TNestedHabitationDocuments>;
  /** Ипотечная квартира */
  habitationInsuranceAgreement?: Maybe<THabitationInsuranceAgreement>;
  /** Уникальный хеш адреса клиента */
  hash?: Maybe<Scalars['String']['output']>;
  /** Страхуемая квартира */
  insurer?: Maybe<TPeople>;
  /** Адрес  проживания (ЕСИА) */
  livingESIAPeople?: Maybe<TPeople>;
  /** Адрес проживания */
  livingPeople?: Maybe<Array<Maybe<TPeople>>>;
  /** Ипотечная квартира */
  mortgageAgreement?: Maybe<TMortgageAgreement>;
  /** Адрес ипотеки */
  mortgager?: Maybe<TPeople>;
  /** Владелец недвижимости */
  owner?: Maybe<TPeople>;
  /** Владельцы недвижимости */
  owners?: Maybe<Array<Maybe<TPeople>>>;
  /** Домашний Телефон */
  phone?: Maybe<Scalars['PhoneNumber']['output']>;
  /** Адрес залога в кредитах */
  pledgers?: Maybe<Array<Maybe<TPeople>>>;
  /** Руками введенный адрес после регистрации ЕСИА */
  profile?: Maybe<TProfile>;
  /** Введенная вручную вне какого-либо продукта недвижимость */
  profileFromManualInput?: Maybe<TProfile>;
  properties?: Maybe<TNestedHabitationProperties>;
  /** Адрес  регистрации (ЕСИА) */
  registeredESIAPeople?: Maybe<TPeople>;
  /** Адрес регистрации! */
  registeredPeople?: Maybe<Array<Maybe<TPeople>>>;
  /** Источник недвижимости */
  source: ESource;
  /** Область договора страхования от клеща */
  tickInsuranceAgreement?: Maybe<TTickInsuranceAgreement>;
  /** Тип недвижимости */
  type?: Maybe<EPropertyType>;
  /** Дата последнего обновления объекта в БД */
  updated?: Maybe<Scalars['DateTimeISO']['output']>;
  /** ClientId продукта, обновившего объект */
  updatedBy?: Maybe<Scalars['String']['output']>;
};


export type THabitationApprovedPassportArgs = {
  filter?: InputMaybe<TPassportFilter>;
};


export type THabitationCreditSelectionPledgersArgs = {
  filter?: InputMaybe<TPeopleFilter>;
  pagination?: InputMaybe<TPagination>;
};


export type THabitationHabitationInsuranceAgreementArgs = {
  filter?: InputMaybe<THabitationInsuranceAgreementFilter>;
};


export type THabitationInsurerArgs = {
  filter?: InputMaybe<TPeopleFilter>;
};


export type THabitationLivingEsiaPeopleArgs = {
  filter?: InputMaybe<TPeopleFilter>;
};


export type THabitationLivingPeopleArgs = {
  filter?: InputMaybe<TPeopleFilter>;
  pagination?: InputMaybe<TPagination>;
};


export type THabitationMortgageAgreementArgs = {
  filter?: InputMaybe<TMortgageAgreementFilter>;
};


export type THabitationMortgagerArgs = {
  filter?: InputMaybe<TPeopleFilter>;
};


export type THabitationOwnerArgs = {
  filter?: InputMaybe<TPeopleFilter>;
};


export type THabitationOwnersArgs = {
  filter?: InputMaybe<TPeopleFilter>;
  pagination?: InputMaybe<TPagination>;
};


export type THabitationPledgersArgs = {
  filter?: InputMaybe<TPeopleFilter>;
  pagination?: InputMaybe<TPagination>;
};


export type THabitationProfileArgs = {
  filter?: InputMaybe<TProfileFilter>;
};


export type THabitationProfileFromManualInputArgs = {
  filter?: InputMaybe<TProfileFilter>;
};


export type THabitationRegisteredEsiaPeopleArgs = {
  filter?: InputMaybe<TPeopleFilter>;
};


export type THabitationRegisteredPeopleArgs = {
  filter?: InputMaybe<TPeopleFilter>;
  pagination?: InputMaybe<TPagination>;
};


export type THabitationTickInsuranceAgreementArgs = {
  filter?: InputMaybe<TTickInsuranceAgreementFilter>;
};

export type THabitationFilter = {
  AND?: InputMaybe<Array<InputMaybe<THabitationFilter>>>;
  NOR?: InputMaybe<Array<InputMaybe<THabitationFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<THabitationFilter>>>;
  address?: InputMaybe<TNestedHabitationAddressObjectFilterType>;
  alias?: InputMaybe<TStringFilter>;
  created?: InputMaybe<TDateTimeIsoFilter>;
  createdBy?: InputMaybe<TStringFilter>;
  creditSelection?: InputMaybe<TNestedHabitationCreditSelectionObjectFilterType>;
  hash?: InputMaybe<TStringFilter>;
  phone?: InputMaybe<TPhoneNumberFilter>;
  properties?: InputMaybe<TNestedHabitationPropertiesObjectFilterType>;
  source?: InputMaybe<TESourceFilter>;
  type?: InputMaybe<TEPropertyTypeFilter>;
  updated?: InputMaybe<TDateTimeIsoFilter>;
  updatedBy?: InputMaybe<TStringFilter>;
};

export type THabitationInsuranceAgreement = {
  __typename?: 'HabitationInsuranceAgreement';
  /** Дата заключения договора страхования квартиры */
  contractAgreementDate?: Maybe<Scalars['DateTimeISO']['output']>;
  /** Дата окончания договора страхования квартиры */
  contractAgreementEndDate?: Maybe<Scalars['DateTimeISO']['output']>;
  /** Номер договора страхования квартиры */
  contractNumber: Scalars['String']['output'];
  /** Дата создания объекта в БД */
  created?: Maybe<Scalars['DateTimeISO']['output']>;
  /** ClientId продукта, создавшего объект */
  createdBy?: Maybe<Scalars['String']['output']>;
  /** Хэш договора страхования квартиры */
  hash?: Maybe<Scalars['String']['output']>;
  /** Ипотечная квартира */
  insuredHabitation?: Maybe<THabitation>;
  /** Договор страхования квартиры */
  insurer?: Maybe<TPeople>;
  /** Дата окончания действия полиса */
  policyEndDate?: Maybe<Scalars['DateTimeISO']['output']>;
  /** Дата начала действия полиса */
  policyStartDate?: Maybe<Scalars['DateTimeISO']['output']>;
  /** Дата последнего обновления объекта в БД */
  updated?: Maybe<Scalars['DateTimeISO']['output']>;
  /** ClientId продукта, обновившего объект */
  updatedBy?: Maybe<Scalars['String']['output']>;
};


export type THabitationInsuranceAgreementInsuredHabitationArgs = {
  filter?: InputMaybe<THabitationFilter>;
};


export type THabitationInsuranceAgreementInsurerArgs = {
  filter?: InputMaybe<TPeopleFilter>;
};

export type THabitationInsuranceAgreementFilter = {
  AND?: InputMaybe<Array<InputMaybe<THabitationInsuranceAgreementFilter>>>;
  NOR?: InputMaybe<Array<InputMaybe<THabitationInsuranceAgreementFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<THabitationInsuranceAgreementFilter>>>;
  contractAgreementDate?: InputMaybe<TDateTimeIsoFilter>;
  contractAgreementEndDate?: InputMaybe<TDateTimeIsoFilter>;
  contractNumber?: InputMaybe<TStringFilter>;
  created?: InputMaybe<TDateTimeIsoFilter>;
  createdBy?: InputMaybe<TStringFilter>;
  hash?: InputMaybe<TStringFilter>;
  policyEndDate?: InputMaybe<TDateTimeIsoFilter>;
  policyStartDate?: InputMaybe<TDateTimeIsoFilter>;
  updated?: InputMaybe<TDateTimeIsoFilter>;
  updatedBy?: InputMaybe<TStringFilter>;
};

/** Filter type for INN scalar */
export type TInnFilter = {
  /** [$all] Полное совпадение значений */
  ALL?: InputMaybe<Array<InputMaybe<Scalars['INN']['input']>>>;
  /** [$eq] Равенство значений */
  EQ?: InputMaybe<Scalars['INN']['input']>;
  /** [$in] Одно из значений */
  IN?: InputMaybe<Array<InputMaybe<Scalars['INN']['input']>>>;
  /** [$ne] Не равно переданному значению */
  NE?: InputMaybe<Scalars['INN']['input']>;
  /** [$nin] Не равно ни одному из переданных значений */
  NIN?: InputMaybe<Array<InputMaybe<Scalars['INN']['input']>>>;
  /** [$not] Логическое отрицание */
  NOT?: InputMaybe<TInnNotFilter>;
};

/** Filter type for $not of INN scalar */
export type TInnNotFilter = {
  /** [$all] Полное совпадение значений */
  ALL?: InputMaybe<Array<InputMaybe<Scalars['INN']['input']>>>;
  /** [$eq] Равенство значений */
  EQ?: InputMaybe<Scalars['INN']['input']>;
  /** [$in] Одно из значений */
  IN?: InputMaybe<Array<InputMaybe<Scalars['INN']['input']>>>;
  /** [$ne] Не равно переданному значению */
  NE?: InputMaybe<Scalars['INN']['input']>;
  /** [$nin] Не равно ни одному из переданных значений */
  NIN?: InputMaybe<Array<InputMaybe<Scalars['INN']['input']>>>;
};

export type TInputAlfa = {
  Alfa?: InputMaybe<TInputNestedAlfaAlfa>;
};

export type TInputCar = {
  /** Псевдоним объекта */
  alias?: InputMaybe<Scalars['String']['input']>;
  /** Одобрение типа ТС */
  approveDocument?: InputMaybe<TInputNestedCarApproveDocument>;
  /** Цвет кузова */
  bodyColor?: InputMaybe<Scalars['String']['input']>;
  /** Номер кузова */
  bodyNumber?: InputMaybe<Scalars['String']['input']>;
  /** Id кузова в справочнике */
  bodyTypeId?: InputMaybe<Scalars['String']['input']>;
  /** Владелец авто */
  carOwner?: InputMaybe<TInputPeople>;
  /** Тип кузова */
  carcase?: InputMaybe<Scalars['String']['input']>;
  /** id типа кузова */
  carcaseid?: InputMaybe<Scalars['String']['input']>;
  casco?: InputMaybe<TInputNestedCarCasco>;
  /** Страхователь в расчете КАСКО */
  cascoInsurer?: InputMaybe<TInputPeople>;
  /** Категория авто по тех регламенту (A, B, C...) */
  category?: InputMaybe<ECarCategory>;
  /** Номер шасси */
  chassisNumber?: InputMaybe<Scalars['CarChassisNumber']['input']>;
  /** Залоговое авто в кредитах */
  creditSelectionPledgeForPeople?: InputMaybe<Array<InputMaybe<TInputPeople>>>;
  diagnosticCard?: InputMaybe<TInputNestedCarDiagnosticCard>;
  /** Привод автомобиля */
  drive?: InputMaybe<ECarDrive>;
  /** Водители */
  drivers?: InputMaybe<Array<InputMaybe<TInputPeople>>>;
  ePts?: InputMaybe<TInputNestedCarEPts>;
  /** Экологический класс */
  ecologyClass?: InputMaybe<Scalars['String']['input']>;
  /** Модель двигателя */
  engineModel?: InputMaybe<Scalars['String']['input']>;
  /** Номер двигателя */
  engineNum?: InputMaybe<Scalars['String']['input']>;
  /** Тип двигателя */
  engineType?: InputMaybe<Scalars['String']['input']>;
  /** Объём двигателя */
  enginevolume?: InputMaybe<Scalars['String']['input']>;
  /** Установлено ли ГБО */
  gazEnvironment?: InputMaybe<Scalars['Boolean']['input']>;
  /** Код страны-изготовителя */
  issueCountryCode?: InputMaybe<Scalars['String']['input']>;
  /** Страна-изготовитель */
  issueCountryName?: InputMaybe<Scalars['String']['input']>;
  /** КПП */
  kpp?: InputMaybe<EKpp>;
  /** Идентификатор КПП */
  kppId?: InputMaybe<Scalars['String']['input']>;
  /** Ссылка на логотип марки автомобиля */
  logoLink?: InputMaybe<Scalars['String']['input']>;
  /** Производитель */
  manufacturer?: InputMaybe<Scalars['String']['input']>;
  /** Марка */
  mark: Scalars['String']['input'];
  /** Id марки в справочнике ОСАГО */
  markId?: InputMaybe<Scalars['String']['input']>;
  /** Максимальный вес */
  maxWeight?: InputMaybe<Scalars['Int']['input']>;
  /** Модель */
  model: Scalars['String']['input'];
  /** Id модели в справочнике ОСАГО */
  modelId?: InputMaybe<Scalars['String']['input']>;
  /** Название модификации машины */
  modification?: InputMaybe<Scalars['String']['input']>;
  osago?: InputMaybe<TInputNestedCarOsago>;
  /** Страхователь авто в ОСАГО */
  osagoInsurer?: InputMaybe<TInputPeople>;
  /** Водители в расчете ОСАГО */
  osagoSelectedDrivers?: InputMaybe<Array<InputMaybe<TInputPeople>>>;
  /** Периоды владения */
  ownerPeriods?: InputMaybe<Array<InputMaybe<TInputNestedCarOwnerPeriods>>>;
  /** Залоговое авто в кредитах */
  pledger?: InputMaybe<TInputPeople>;
  /** Мощность двигателя */
  power?: InputMaybe<Scalars['String']['input']>;
  /** Мощность двигателя (кВт) */
  powerkVt?: InputMaybe<Scalars['Float']['input']>;
  /** Цена автомобиля */
  price?: InputMaybe<Scalars['Float']['input']>;
  /** Введенный вручную вне какого-либо продукта автомобиль */
  profileFromManualInput?: InputMaybe<TInputCommon>;
  pts?: InputMaybe<TInputNestedCarPts>;
  /** История регистрационных действий */
  regActions?: InputMaybe<Array<InputMaybe<TInputNestedCarRegActions>>>;
  /** Регистрационный знак */
  registrationPlate?: InputMaybe<Scalars['RegistrationPlateScalar']['input']>;
  /** Ограничения */
  restrictions?: InputMaybe<Scalars['String']['input']>;
  /** Источник транспорта */
  source?: InputMaybe<ESource>;
  /** Год начала владения */
  startOwnershipYear?: InputMaybe<Scalars['year']['input']>;
  sts?: InputMaybe<TInputNestedCarSts>;
  /** Таможенная декларация */
  tdtpo?: InputMaybe<TInputNestedCarTdtpo>;
  /** Срок владения автомобилем */
  tenure?: InputMaybe<Scalars['String']['input']>;
  /** Тестовая ссылка */
  testo2o?: InputMaybe<TInputPeople>;
  /** Статус оплаты утильсбора */
  utilizationStatus?: InputMaybe<Scalars['String']['input']>;
  /** Тип авто */
  vehicleType?: InputMaybe<Scalars['String']['input']>;
  /** Идентификационный номер транспортного средства (VIN)  */
  vin?: InputMaybe<Scalars['CarVin']['input']>;
  /** VIN2 */
  vin2?: InputMaybe<Scalars['CarVin']['input']>;
  /** Вес без загрузки */
  weightWithoutLoading?: InputMaybe<Scalars['Int']['input']>;
  /** Расположение руля */
  wheelLocation?: InputMaybe<EWheelLocation>;
  /** Год выпуска */
  year: Scalars['year']['input'];
};

export type TInputChangePhoneNumber = {
  phone: Scalars['PhoneNumber']['input'];
};

export type TInputCommon = {
  /** Вручную подтвержденный паспорт в CRM */
  approvedPassport?: InputMaybe<TInputPassport>;
  /** credit people */
  creditPeople?: InputMaybe<TInputPeople>;
  /** mfo people */
  creditRatingPeople?: InputMaybe<TInputPeople>;
  /** Введенный вручную вне какого-либо продукта автомобиль */
  manualInputCars?: InputMaybe<Array<InputMaybe<TInputCar>>>;
  /** Руками введенный адрес после регистрации ЕСИА */
  manualInputESIARegistrationHabitation?: InputMaybe<TInputHabitation>;
  /** Введенная вручную вне какого-либо продукта недвижимость */
  manualInputHabitations?: InputMaybe<Array<InputMaybe<TInputHabitation>>>;
  /** mfo people */
  mfoPeople?: InputMaybe<TInputPeople>;
  /** Mortgage People */
  mortgagePeople?: InputMaybe<TInputPeople>;
  /** mpl people */
  mplPeople?: InputMaybe<TInputPeople>;
  /** MSB People */
  msbPeople?: InputMaybe<TInputPeople>;
  /** OSAGO People */
  osagoPeople?: InputMaybe<TInputPeople>;
  /** Red people */
  redPeople?: InputMaybe<TInputPeople>;
  /** Для записи данных клиента, получаемых от партнерских заявок. */
  waybackPeople?: InputMaybe<TInputPeople>;
};

export type TInputDeleteProfileObjectParams = {
  throwIfNotFound?: InputMaybe<Scalars['Boolean']['input']>;
};

export type TInputDeleteProfileParams = {
  deletionReason?: InputMaybe<Scalars['String']['input']>;
  notSaveAsDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  removedByUserId?: InputMaybe<Scalars['Int']['input']>;
};

export type TInputDriverLicense = {
  /** Дата рождения  */
  birthDate?: InputMaybe<Scalars['BirthDate']['input']>;
  /** Место рождения  */
  birthPlace?: InputMaybe<Scalars['String']['input']>;
  /** Категории  */
  categories?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Страна выдачи ВУ  */
  countryName?: InputMaybe<Scalars['String']['input']>;
  /** Ведомство  */
  departmentDoc?: InputMaybe<Scalars['String']['input']>;
  /** Год начала стажа by  */
  experience?: InputMaybe<Scalars['DateTimeISO']['input']>;
  /** Дата начала стажа по категории A */
  experienceA?: InputMaybe<Scalars['DateTimeISO']['input']>;
  /** Действителен до  */
  expiryDate?: InputMaybe<Scalars['DateTimeISO']['input']>;
  /** Дата выдачи первых прав */
  firstIssueDate?: InputMaybe<Scalars['DateTimeISO']['input']>;
  /** Имя  */
  firstName?: InputMaybe<Scalars['StrictString']['input']>;
  /** ИД документа  */
  id?: InputMaybe<Scalars['String']['input']>;
  /** Дата выдачи  */
  issueDate?: InputMaybe<Scalars['DateTimeISO']['input']>;
  /** Кем выдан документ  */
  issuedBy?: InputMaybe<Scalars['String']['input']>;
  /** Фамилия  */
  lastName?: InputMaybe<Scalars['StrictString']['input']>;
  /** Отчество  */
  middleName?: InputMaybe<Scalars['StrictString']['input']>;
  /** Номер  */
  number: Scalars['String']['input'];
  /** Временная ссылка для миграции People.driverLicense в отдельный объект */
  people?: InputMaybe<TInputPeople>;
  /** Номер  */
  previousNumber?: InputMaybe<Scalars['String']['input']>;
  /** Серия  */
  previousSeries?: InputMaybe<Scalars['String']['input']>;
  /** История водительских удостоверений */
  profileFromESIADriver?: InputMaybe<TInputPeople>;
  /** История водительских удостоверений (ЕСИА) */
  profileFromESIADriverHistory?: InputMaybe<TInputProfile>;
  /** Водительское удостоверение (Сбер) */
  profileFromSberDriver?: InputMaybe<TInputProfile>;
  /** История водительских удостоверений (Сбер) */
  profileFromSberDriverHistory?: InputMaybe<TInputProfile>;
  /** Дата получения документа  */
  receiptDocDate?: InputMaybe<Scalars['DateTimeISO']['input']>;
  /** Релевантность  */
  relevance?: InputMaybe<EDocumentRelevance>;
  /** Серия  */
  series: Scalars['String']['input'];
  /** Источник паспорта (default или approved) */
  source?: InputMaybe<ESource>;
  /** Статус  */
  status?: InputMaybe<EDocumentStatus>;
  /** Тип документа  */
  type?: InputMaybe<EDocumentType>;
  /** Дата валидации документа  */
  validateDateDoc?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type TInputEsiaeWorkbook = {
  /** ЕСИА */
  departmentDoc?: InputMaybe<Scalars['String']['input']>;
  /** События в электронной трудовой книжке */
  events?: InputMaybe<Array<InputMaybe<TInputEWorkbookEvent>>>;
  /** Идентификатор электронной книжки ЕСИА */
  id: Scalars['String']['input'];
  /** Электронная книжка ЕСИА */
  profile?: InputMaybe<TInputEsia>;
  /** Трудовая книжка ЕСИА */
  receiptDocDate?: InputMaybe<Scalars['DateTimeISO']['input']>;
  /** ЕСИА */
  relevance?: InputMaybe<EDocumentRelevance>;
  /** Источник */
  source?: InputMaybe<ESource>;
  /** ЕСИА */
  status?: InputMaybe<EDocumentStatus>;
  /** Трудовая книжка ЕСИА */
  validateDateDoc?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type TInputEsiaVehicle = {
  /** Дата выдачи Одобрения типа ТС */
  approveDocumentDate?: InputMaybe<Scalars['DateTimeISO']['input']>;
  /** Кем выдано Одобрение типа ТС */
  approveIssueAgency?: InputMaybe<Scalars['String']['input']>;
  /** Серия и номер Одобрения типа ТС */
  approveSerNum?: InputMaybe<Scalars['String']['input']>;
  /** Цвет кузова */
  carcaseColor?: InputMaybe<Scalars['String']['input']>;
  /** Номер кузова */
  carcaseNumber?: InputMaybe<Scalars['String']['input']>;
  /** Номер шасси */
  chassisNumber?: InputMaybe<Scalars['String']['input']>;
  /** Таможенная декларация */
  customsDeclaration?: InputMaybe<Scalars['String']['input']>;
  /** Привод */
  driveUnitType?: InputMaybe<Scalars['String']['input']>;
  /** Экологический класс */
  ecologyClass?: InputMaybe<Scalars['String']['input']>;
  /** Модель двигателя */
  engineModel?: InputMaybe<Scalars['String']['input']>;
  /** Номер двигателя */
  engineNum?: InputMaybe<Scalars['String']['input']>;
  /** Мощность двигателя (л/с) */
  enginePowerHorse?: InputMaybe<Scalars['Float']['input']>;
  /** Можность двигателя (кВт) */
  enginePowerkVt?: InputMaybe<Scalars['Float']['input']>;
  /** Тип двигателя */
  engineType?: InputMaybe<Scalars['String']['input']>;
  /** Мощность двигателя */
  engineVolume?: InputMaybe<Scalars['Int']['input']>;
  /** Установлено ли ГБО */
  gazEnvironmentFlag?: InputMaybe<Scalars['Boolean']['input']>;
  /** Регистрационный знак */
  govRegNumber?: InputMaybe<Scalars['String']['input']>;
  /** ID */
  id?: InputMaybe<Scalars['Int']['input']>;
  /** Код страны-изготовителя */
  issueCountryCode?: InputMaybe<Scalars['String']['input']>;
  /** Страна-изготовитель */
  issueCountryName?: InputMaybe<Scalars['String']['input']>;
  /** Год выпуска */
  manufacturedYear: Scalars['Int']['input'];
  /** Производитель */
  manufacturer?: InputMaybe<Scalars['String']['input']>;
  /** Марка */
  markName: Scalars['String']['input'];
  /** Максимальный вес */
  maxWeight?: InputMaybe<Scalars['Int']['input']>;
  /** Модель */
  modelName: Scalars['String']['input'];
  owner?: InputMaybe<TInputNestedEsiaVehicleOwner>;
  ownerPeriod?: InputMaybe<Array<InputMaybe<TInputNestedEsiaVehicleOwnerPeriod>>>;
  /** Цена автомобиля */
  price?: InputMaybe<Scalars['Float']['input']>;
  /** Транспортное средство (ESIA) */
  profile?: InputMaybe<TInputEsia>;
  pts?: InputMaybe<TInputNestedEsiaVehiclePts>;
  regAction?: InputMaybe<Array<InputMaybe<TInputNestedEsiaVehicleRegAction>>>;
  registrationDoc?: InputMaybe<TInputNestedEsiaVehicleRegistrationDoc>;
  /** Ограничения */
  restrictions?: InputMaybe<Scalars['String']['input']>;
  /** Статус */
  status?: InputMaybe<Scalars['String']['input']>;
  /** Дата оформления таможенной декларации */
  tdtpoDocumentDate?: InputMaybe<Scalars['DateTimeISO']['input']>;
  /** Таможенный орган */
  tdtpoIssueAgency?: InputMaybe<Scalars['String']['input']>;
  /** Коробка передач */
  transmissionType?: InputMaybe<Scalars['String']['input']>;
  /** Статус оплаты утильсбора */
  utilizStatus?: InputMaybe<Scalars['String']['input']>;
  /** Категория авто */
  vehicleCategory?: InputMaybe<Scalars['String']['input']>;
  /** Тип авто */
  vehicleType?: InputMaybe<Scalars['String']['input']>;
  /** Класс авто */
  vehicleTypeTAM?: InputMaybe<Scalars['String']['input']>;
  /** VIN */
  vin?: InputMaybe<Scalars['String']['input']>;
  /** VIN2 */
  vin2?: InputMaybe<Scalars['String']['input']>;
  /** Вес без загрузки */
  weightWithoutLoading?: InputMaybe<Scalars['Int']['input']>;
  /** Расположение руля */
  wheelLocation?: InputMaybe<Scalars['String']['input']>;
};

export type TInputEWorkbookEvent = {
  /** ЕСИА */
  date: Scalars['DateTimeISO']['input'];
  dismissalBasis?: InputMaybe<TInputNestedEWorkbookEventDismissalBasis>;
  /** ЕСИА */
  dismissalReason?: InputMaybe<Scalars['String']['input']>;
  /** ЕСИА */
  division?: InputMaybe<Scalars['String']['input']>;
  /** ЕСИА */
  isPartTimeJob?: InputMaybe<Scalars['Boolean']['input']>;
  organization?: InputMaybe<TInputNestedEWorkbookEventOrganization>;
  /** ЕСИА */
  position?: InputMaybe<Scalars['String']['input']>;
  /** Список основания для события */
  reason?: InputMaybe<Array<InputMaybe<TInputNestedEWorkbookEventReason>>>;
  /** Источник */
  source: ESource;
  /** ЕСИА */
  type: Scalars['Int']['input'];
  /** ЕСИА */
  uuid: Scalars['String']['input'];
};

export type TInputEsia = {
  ESIA?: InputMaybe<TInputNestedEsiaEsia>;
  /** Недвижимость во владении */
  estate?: InputMaybe<Array<InputMaybe<TInputHabitation>>>;
};

export type TInputFrgnPassport = {
  /** Дата рождения */
  birthDate?: InputMaybe<Scalars['BirthDate']['input']>;
  /** Место рождения */
  birthPlace?: InputMaybe<Scalars['String']['input']>;
  /** Ведомство */
  departmentDoc?: InputMaybe<Scalars['String']['input']>;
  /** Дата окончания срока действия */
  expirationDate?: InputMaybe<Scalars['DateTimeISO']['input']>;
  /** Имя */
  firstName?: InputMaybe<Scalars['StrictString']['input']>;
  /** Пол клиента */
  gender?: InputMaybe<EGender>;
  /** Дата выдачи */
  issueDate?: InputMaybe<Scalars['DateTimeISO']['input']>;
  /** Код подразделения */
  issueId?: InputMaybe<Scalars['IssueId']['input']>;
  /** Кем выдан паспорт */
  issuedBy?: InputMaybe<Scalars['String']['input']>;
  /** Фамилия */
  lastName?: InputMaybe<Scalars['StrictString']['input']>;
  /** Отчество */
  middleName?: InputMaybe<Scalars['StrictString']['input']>;
  /** Номер */
  number: Scalars['String']['input'];
  /** Статус паспорта ESIA */
  passportStatus?: InputMaybe<Scalars['String']['input']>;
  /** История заграничных паспортов */
  people?: InputMaybe<TInputPeople>;
  /** Последний заграничный паспорт [ЕСИА] */
  peopleFromEsiaFrgnPassport?: InputMaybe<TInputPeople>;
  /** История заграничных паспортов [ЕСИА] */
  peopleFromEsiaFrgnPassportHistory?: InputMaybe<TInputPeople>;
  /** Последний заграничный паспорт [Сбер] */
  peopleFromSberFrgnPassport?: InputMaybe<TInputPeople>;
  /** История заграничных паспортов [Сбер] */
  peopleFromSberFrgnPassportHistory?: InputMaybe<TInputPeople>;
  /** Последний заграничный паспорт [ТБанк] */
  peopleFromTBankFrgnPassport?: InputMaybe<TInputPeople>;
  /** История заграничных паспортов [ТБанк] */
  peopleFromTBankFrgnPassportHistory?: InputMaybe<TInputPeople>;
  /** Последний заграничный паспорт [Сбер] */
  profile?: InputMaybe<TInputSber>;
  /** Дата получения документа */
  receiptDocDate?: InputMaybe<Scalars['DateTimeISO']['input']>;
  /** Релевантность ESIA */
  relevance?: InputMaybe<EDocumentRelevance>;
  /** Серия */
  series: Scalars['String']['input'];
  /** Источник паспорта (manual или esia) */
  source?: InputMaybe<ESource>;
};

export type TInputHabitation = {
  Alfa?: InputMaybe<TInputNestedHabitationAlfa>;
  Sber?: InputMaybe<TInputNestedHabitationSber>;
  TBank?: InputMaybe<TInputNestedHabitationTBank>;
  address: TInputNestedHabitationAddress;
  /** Псевдоним объекта */
  alias?: InputMaybe<Scalars['String']['input']>;
  /** Вручную подтвержденный адрес регистрации в CRM */
  approvedPassport?: InputMaybe<TInputPassport>;
  creditSelection?: InputMaybe<TInputNestedHabitationCreditSelection>;
  /** Адрес залога в кредитах */
  creditSelectionPledgers?: InputMaybe<Array<InputMaybe<TInputPeople>>>;
  documents?: InputMaybe<TInputNestedHabitationDocuments>;
  /** Ипотечная квартира */
  habitationInsuranceAgreement?: InputMaybe<TInputHabitationInsuranceAgreement>;
  /** Страхуемая квартира */
  insurer?: InputMaybe<TInputPeople>;
  /** Адрес  проживания (ЕСИА) */
  livingESIAPeople?: InputMaybe<TInputPeople>;
  /** Адрес проживания */
  livingPeople?: InputMaybe<Array<InputMaybe<TInputPeople>>>;
  /** Ипотечная квартира */
  mortgageAgreement?: InputMaybe<TInputMortgageAgreement>;
  /** Адрес ипотеки */
  mortgager?: InputMaybe<TInputPeople>;
  /** Владелец недвижимости */
  owner?: InputMaybe<TInputPeople>;
  /** Владельцы недвижимости */
  owners?: InputMaybe<Array<InputMaybe<TInputPeople>>>;
  /** Домашний Телефон */
  phone?: InputMaybe<Scalars['PhoneNumber']['input']>;
  /** Адрес залога в кредитах */
  pledgers?: InputMaybe<Array<InputMaybe<TInputPeople>>>;
  /** Руками введенный адрес после регистрации ЕСИА */
  profile?: InputMaybe<TInputCommon>;
  /** Введенная вручную вне какого-либо продукта недвижимость */
  profileFromManualInput?: InputMaybe<TInputCommon>;
  properties?: InputMaybe<TInputNestedHabitationProperties>;
  /** Адрес  регистрации (ЕСИА) */
  registeredESIAPeople?: InputMaybe<TInputPeople>;
  /** Адрес регистрации! */
  registeredPeople?: InputMaybe<Array<InputMaybe<TInputPeople>>>;
  /** Источник недвижимости */
  source?: InputMaybe<ESource>;
  /** Область договора страхования от клеща */
  tickInsuranceAgreement?: InputMaybe<TInputTickInsuranceAgreement>;
  /** Тип недвижимости */
  type?: InputMaybe<EPropertyType>;
};

export type TInputHabitationInsuranceAgreement = {
  /** Дата заключения договора страхования квартиры */
  contractAgreementDate?: InputMaybe<Scalars['DateTimeISO']['input']>;
  /** Дата окончания договора страхования квартиры */
  contractAgreementEndDate?: InputMaybe<Scalars['DateTimeISO']['input']>;
  /** Номер договора страхования квартиры */
  contractNumber: Scalars['String']['input'];
  /** Ипотечная квартира */
  insuredHabitation?: InputMaybe<TInputHabitation>;
  /** Договор страхования квартиры */
  insurer?: InputMaybe<TInputPeople>;
  /** Дата окончания действия полиса */
  policyEndDate?: InputMaybe<Scalars['DateTimeISO']['input']>;
  /** Дата начала действия полиса */
  policyStartDate?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type TInputLoanApplication = {
  /** Выбранная сумма кредита */
  amount?: InputMaybe<Scalars['Int']['input']>;
  /** Ссылка от заемщика на заявку */
  loaner?: InputMaybe<TInputPeople>;
  /** Номер/идентификатор заявки */
  number: Scalars['String']['input'];
  /** Связь между организацией и заявкой */
  organization?: InputMaybe<TInputOrganization>;
  /** Цель кредита */
  purpose?: InputMaybe<Scalars['String']['input']>;
  /** Выбранный срок кредита (количество дней) */
  termInDays?: InputMaybe<Scalars['Int']['input']>;
};

export type TInputMplClientFlags = {
  /** Флаг даты и времени, когда клиент дал ответы на вопросы AML */
  AMLQuestionsDate?: InputMaybe<Scalars['DateTimeISO']['input']>;
  /** Флаг даты и времени присоединения клиента к правилам платформы МПЛ */
  MPLRegistration?: InputMaybe<Scalars['DateTimeISO']['input']>;
  /** Причина блокировки клиента */
  blockReason?: InputMaybe<Scalars['String']['input']>;
  /** Флаг даты и времени, когда клиента заблокировали */
  blockedDate?: InputMaybe<Scalars['DateTimeISO']['input']>;
  /** Флаги id */
  id?: InputMaybe<Scalars['String']['input']>;
  /** Флаг даты и времени прохождения клиентом идентификации */
  identificationDate?: InputMaybe<Scalars['DateTimeISO']['input']>;
  /** Флаги клиента MPL */
  profile?: InputMaybe<TInputProfile>;
};

export type TInputMeta = {
  /** Мета по интеграциям */
  integrations?: InputMaybe<Array<InputMaybe<TInputMetaIntegration>>>;
};

export type TInputMetaIntegration = {
  /** Мета по документу из интеграции */
  documents?: InputMaybe<Array<InputMaybe<TInputMetaIntegrationDocument>>>;
  /** Источник */
  source: ESource;
};

export type TInputMetaIntegrationDocument = {
  /** Описание ошибки */
  error?: InputMaybe<Scalars['String']['input']>;
  /** Название документа */
  name: Scalars['String']['input'];
  /** ID запроса на получение документа */
  requestId?: InputMaybe<Scalars['String']['input']>;
  /** Дата запроса документа */
  requestedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  /** Источник */
  source: ESource;
  /** Статус документа */
  status: EIntegrationDocumentStatus;
};

export type TInputMortgageAgreement = {
  /** Место заключения кредитного договора */
  agreementAddress?: InputMaybe<Scalars['String']['input']>;
  /** Ежемесячный платеж по кредиту */
  annuityPayment?: InputMaybe<Scalars['Float']['input']>;
  /** Процентная ставка при отказе от страхования */
  cancellationCreditRate?: InputMaybe<Scalars['Float']['input']>;
  /** Дата заключения кредитного договора */
  contractAgreementDate?: InputMaybe<Scalars['DateTimeISO']['input']>;
  /** Дата окончания кредитного договора */
  contractAgreementEndDate?: InputMaybe<Scalars['DateTimeISO']['input']>;
  /** Номер кредитного договора */
  contractNumber: Scalars['String']['input'];
  /** Банк кредитор */
  creditBankId?: InputMaybe<Scalars['String']['input']>;
  /** Начальная сумма кредита */
  initialAmount?: InputMaybe<Scalars['Float']['input']>;
  /** Ипотечный договор */
  insurer?: InputMaybe<Array<InputMaybe<TInputPeople>>>;
  /** Ипотечная квартира */
  mortgageHabitation?: InputMaybe<TInputHabitation>;
  /** Дата окончания действия полиса */
  policyEndDate?: InputMaybe<Scalars['DateTimeISO']['input']>;
  /** Дата начала действия полиса */
  policyStartDate?: InputMaybe<Scalars['DateTimeISO']['input']>;
  /** Процентная ставка */
  rate?: InputMaybe<Scalars['Float']['input']>;
};

export type TInputNdfl2 = {
  /** Номер корректировки */
  correctionNumber: Scalars['String']['input'];
  /** Дата формирования справки */
  formationDate: Scalars['DateTimeISO']['input'];
  income?: InputMaybe<Array<InputMaybe<TInputNestedNdfl2Income>>>;
  person?: InputMaybe<TInputNestedNdfl2Person>;
  /** Справка 2-НДФЛ */
  profile?: InputMaybe<TInputEsia>;
  /** Источник справки */
  source?: InputMaybe<ESource>;
  taxAgent?: InputMaybe<TInputNestedNdfl2TaxAgent>;
  /** Отчетный год */
  year: Scalars['Int']['input'];
};

export type TInputNestedAlfaAlfa = {
  /** Владелец профиля [Альфа] */
  owner?: InputMaybe<TInputPeople>;
};

export type TInputNestedCarApproveDocument = {
  /** Дата выдачи */
  date?: InputMaybe<Scalars['DateTimeISO']['input']>;
  /** Орган выдачи */
  issueAgency?: InputMaybe<Scalars['String']['input']>;
  /** Серия и номер */
  serialNumber?: InputMaybe<Scalars['String']['input']>;
};

export type TInputNestedCarCasco = {
  /** Тип документа при вводе данных в каско */
  documentType?: InputMaybe<Scalars['String']['input']>;
  /** Залоговый ли автомобиль */
  isPledge?: InputMaybe<Scalars['String']['input']>;
  /** Количество ключей у автомобиля */
  keysNumber?: InputMaybe<Scalars['String']['input']>;
  /** Пробег автомобиля */
  mileage?: InputMaybe<Scalars['String']['input']>;
  /** Id банка, в котором автомобиль оставлен в залог */
  pledgeBankId?: InputMaybe<Scalars['String']['input']>;
  /** Номер полиса КАСКО */
  policyNumber?: InputMaybe<Scalars['String']['input']>;
  /** Оригинал ли птс или дубликат */
  ptsIsOriginal?: InputMaybe<Scalars['String']['input']>;
};

export type TInputNestedCarDiagnosticCard = {
  /** Дата окончания действия диагностической карты */
  expirationDate?: InputMaybe<Scalars['DateTimeISO']['input']>;
  /** Номер диагностической карты */
  number?: InputMaybe<Scalars['String']['input']>;
};

export type TInputNestedCarEPts = {
  /** Дата выдачи еПТС */
  issueDate?: InputMaybe<Scalars['DateTimeISO']['input']>;
  /** Номер еПТС */
  number?: InputMaybe<Scalars['SerialNumberEPTS']['input']>;
};

export type TInputNestedCarOsago = {
  /** Тип документа при вводе данных в осаго */
  documentType?: InputMaybe<EOsagoCarDocumentType>;
  /** Номер полиса ОСАГО */
  policyNumber?: InputMaybe<Scalars['CarOsagoPolicyNumber']['input']>;
  /** Дата начала действия полиса осаго */
  policyStartDate?: InputMaybe<Scalars['DateTimeISO']['input']>;
  /** Id продукта, который пользователь выбрал на выдаче */
  productId?: InputMaybe<Scalars['String']['input']>;
  /** Id выдачи в сервисе осаго */
  searchId?: InputMaybe<Scalars['String']['input']>;
};

export type TInputNestedCarOwnerPeriods = {
  /** Дата окончания */
  dateEnd?: InputMaybe<Scalars['DateTimeISO']['input']>;
  /** Дата начала */
  dateStart?: InputMaybe<Scalars['DateTimeISO']['input']>;
  /** Тип владельца */
  ownerType?: InputMaybe<Scalars['String']['input']>;
};

export type TInputNestedCarPts = {
  /** Орган выдачи */
  issueAgency?: InputMaybe<Scalars['String']['input']>;
  /** Дата выдачи ПТС */
  issueDate?: InputMaybe<Scalars['DateTimeISO']['input']>;
  /** Серия и номер ПТС */
  number?: InputMaybe<Scalars['CarPTSNumber']['input']>;
  /** Особые отметки */
  specialTags?: InputMaybe<Scalars['String']['input']>;
  /** Тип ПТС */
  type?: InputMaybe<Scalars['String']['input']>;
};

export type TInputNestedCarRegActions = {
  /** confidentSign */
  confidentSign?: InputMaybe<Scalars['Boolean']['input']>;
  /** Дата регистрации */
  date?: InputMaybe<Scalars['DateTimeISO']['input']>;
  /** Орган регистрации */
  issueAgency?: InputMaybe<Scalars['String']['input']>;
  /** Признак лизинга */
  leasingFlag?: InputMaybe<Scalars['Boolean']['input']>;
  /** Причина регистрации */
  name?: InputMaybe<Scalars['String']['input']>;
};

export type TInputNestedCarSts = {
  /** Орган выдачи */
  issueAgency?: InputMaybe<Scalars['String']['input']>;
  /** Дата выдачи СТС */
  issueDate?: InputMaybe<Scalars['DateTimeISO']['input']>;
  /** Номер СТС */
  number?: InputMaybe<Scalars['String']['input']>;
  /** Особые отметки */
  specialTags?: InputMaybe<Scalars['String']['input']>;
};

export type TInputNestedCarTdtpo = {
  /** Дата оформаления декларации */
  date?: InputMaybe<Scalars['DateTimeISO']['input']>;
  /** Таможенный орган */
  issueAgency?: InputMaybe<Scalars['String']['input']>;
  /** Номер таможенной декларации */
  number?: InputMaybe<Scalars['String']['input']>;
};

export type TInputNestedEsiaVehicleOwner = {
  /** День рождения владельца машины */
  birthDate?: InputMaybe<Scalars['BirthDate']['input']>;
  /** Место рождения */
  birthPlace?: InputMaybe<Scalars['String']['input']>;
  /** Имя */
  firstName?: InputMaybe<Scalars['StrictString']['input']>;
  /** Фамилия */
  lastName?: InputMaybe<Scalars['StrictString']['input']>;
  /** Отчество */
  middleName?: InputMaybe<Scalars['StrictString']['input']>;
};

export type TInputNestedEsiaVehicleOwnerPeriod = {
  /** Дата окончания */
  dateEnd?: InputMaybe<Scalars['DateTimeISO']['input']>;
  /** Дата начала */
  dateStart?: InputMaybe<Scalars['DateTimeISO']['input']>;
  /** Тип владельца */
  ownerType?: InputMaybe<Scalars['String']['input']>;
};

export type TInputNestedEsiaVehiclePts = {
  /** Дата выдачи */
  ptsDocumentDate?: InputMaybe<Scalars['DateTimeISO']['input']>;
  /** Кем выдан */
  ptsIssueAgency?: InputMaybe<Scalars['String']['input']>;
  /** Серия и номер */
  ptsSeriesNumber?: InputMaybe<Scalars['String']['input']>;
  /** Доп инфа по выдаче */
  ptsSpecialTags?: InputMaybe<Scalars['String']['input']>;
  /** Тип */
  ptsType?: InputMaybe<Scalars['String']['input']>;
};

export type TInputNestedEsiaVehicleRegAction = {
  /** confidentSign */
  confidentSign?: InputMaybe<Scalars['Boolean']['input']>;
  /** Признак лизинга */
  leasingFlag?: InputMaybe<Scalars['Boolean']['input']>;
  /** Причина регистрации */
  regActionName?: InputMaybe<Scalars['String']['input']>;
  /** Дата выдачи */
  regDocumentDate?: InputMaybe<Scalars['DateTimeISO']['input']>;
  /** Кем выдан */
  regIssueAgency?: InputMaybe<Scalars['String']['input']>;
};

export type TInputNestedEsiaVehicleRegistrationDoc = {
  /** Дата выдачи */
  regDocDocumentDate?: InputMaybe<Scalars['DateTimeISO']['input']>;
  /** Кем выдан */
  regDocIssueAgency?: InputMaybe<Scalars['String']['input']>;
  /** Серия и номер */
  regDocSeriesNumber?: InputMaybe<Scalars['String']['input']>;
  /** Тип */
  regDocType?: InputMaybe<Scalars['String']['input']>;
  /** Комментарий */
  specialTags?: InputMaybe<Scalars['String']['input']>;
};

export type TInputNestedEWorkbookEventDismissalBasis = {
  /** ЕСИА */
  basisItem?: InputMaybe<Scalars['String']['input']>;
  /** ЕСИА */
  basisParagraph?: InputMaybe<Scalars['String']['input']>;
  /** ЕСИА dismissalBasis basisPart */
  basisPart?: InputMaybe<Scalars['String']['input']>;
  /** ЕСИА */
  normativeDocument?: InputMaybe<Scalars['String']['input']>;
  /** ЕСИА */
  type?: InputMaybe<Scalars['String']['input']>;
};

export type TInputNestedEWorkbookEventOrganization = {
  /** ЕСИА */
  inn?: InputMaybe<Scalars['INN']['input']>;
  /** ЕСИА */
  kpp?: InputMaybe<Scalars['String']['input']>;
  /** ЕСИА */
  orgName?: InputMaybe<Scalars['String']['input']>;
  /** ЕСИА */
  regNumber?: InputMaybe<Scalars['String']['input']>;
};

export type TInputNestedEWorkbookEventReason = {
  /** ЕСИА events reason date */
  date?: InputMaybe<Scalars['DateTimeISO']['input']>;
  /** ЕСИА events reason document */
  document?: InputMaybe<Scalars['String']['input']>;
  /** ЕСИА events reason number */
  number?: InputMaybe<Scalars['String']['input']>;
};

export type TInputNestedEsiaEsia = {
  /** Владелец профиля (ЕСИА) */
  owner?: InputMaybe<TInputPeople>;
};

export type TInputNestedHabitationAddress = {
  area?: InputMaybe<Scalars['String']['input']>;
  /** ФИАС-код района */
  areaFiasId?: InputMaybe<Scalars['String']['input']>;
  /** КЛАДР-код района */
  areaKladrId?: InputMaybe<Scalars['String']['input']>;
  areaType?: InputMaybe<Scalars['String']['input']>;
  /** Тип района в регионе (полный) */
  areaTypeFull?: InputMaybe<Scalars['String']['input']>;
  /** Район в регионе с типом */
  areaWithType?: InputMaybe<Scalars['String']['input']>;
  /** Расстояние от кольцевой в километрах */
  beltwayDistance?: InputMaybe<Scalars['String']['input']>;
  /** Внутри кольцевой? */
  beltwayHit?: InputMaybe<Scalars['String']['input']>;
  /** Корпус */
  block?: InputMaybe<Scalars['String']['input']>;
  blockType?: InputMaybe<Scalars['String']['input']>;
  /** Тип корпуса/строения (полный) */
  blockTypeFull?: InputMaybe<Scalars['String']['input']>;
  /** Кадастровый номер */
  cadastralNumber?: InputMaybe<Scalars['CadastralNumber']['input']>;
  /** Признак центра района или региона:  1 — центр района, 2 — центр региона, 3 — центр района и региона, 4 — центральный район региона, 0 — ничего из перечисленного */
  capitalMarker?: InputMaybe<Scalars['String']['input']>;
  /** Город / населенный пункт */
  city?: InputMaybe<Scalars['String']['input']>;
  /** Административный округ (только для Москвы) */
  cityArea?: InputMaybe<Scalars['String']['input']>;
  /** Адм. район города */
  cityDistrict?: InputMaybe<Scalars['String']['input']>;
  /** ФИАС-код адм. района города */
  cityDistrictFiasId?: InputMaybe<Scalars['String']['input']>;
  /** Тип адм. района города */
  cityDistrictType?: InputMaybe<Scalars['String']['input']>;
  /** Тип адм. района города (полный) */
  cityDistrictTypeFull?: InputMaybe<Scalars['String']['input']>;
  /** Адм. район города с типом */
  cityDistrictWithType?: InputMaybe<Scalars['String']['input']>;
  /** ФИАС-код города */
  cityFiasId?: InputMaybe<Scalars['String']['input']>;
  /** КЛАДР-код города */
  cityKladrId?: InputMaybe<Scalars['String']['input']>;
  cityType?: InputMaybe<Scalars['String']['input']>;
  /** Тип города (полный) */
  cityTypeFull?: InputMaybe<Scalars['String']['input']>;
  /** Город с типом */
  cityWithType?: InputMaybe<Scalars['String']['input']>;
  /** Год постройки дома */
  constructionYear?: InputMaybe<Scalars['year']['input']>;
  /** Код страны */
  countryId?: InputMaybe<Scalars['String']['input']>;
  /** ISO-код страны (двухсимвольный) */
  countryIsoCode?: InputMaybe<Scalars['String']['input']>;
  /** Адрес */
  dadata?: InputMaybe<Scalars['String']['input']>;
  /** Федеральный округ */
  federalDistrict?: InputMaybe<Scalars['String']['input']>;
  /** Признак актуальности адреса в ФИАС */
  fiasActualityState?: InputMaybe<Scalars['String']['input']>;
  /** ФИАС-код адреса (идентификатор ФИАС) */
  fiasId: Scalars['String']['input'];
  /** Уровень детализации, до которого адрес найден в ФИАС */
  fiasLevel?: InputMaybe<Scalars['String']['input']>;
  /** Квартира */
  flat?: InputMaybe<Scalars['String']['input']>;
  /** Площадь */
  flatArea?: InputMaybe<Scalars['String']['input']>;
  /** Код ФИАС квартиры */
  flatFiasId?: InputMaybe<Scalars['String']['input']>;
  /** Рыночная стоимость квартиры */
  flatPrice?: InputMaybe<Scalars['String']['input']>;
  flatType?: InputMaybe<Scalars['String']['input']>;
  /** Тип квартиры (полный) */
  flatTypeFull?: InputMaybe<Scalars['String']['input']>;
  /** Номер этажа */
  floorNumber?: InputMaybe<Scalars['String']['input']>;
  /** Количество этажей */
  floorsNumber?: InputMaybe<Scalars['String']['input']>;
  /** Координаты: широта */
  geoLat?: InputMaybe<Scalars['String']['input']>;
  /** Координаты: долгота */
  geoLon?: InputMaybe<Scalars['String']['input']>;
  /** Идентификатор объекта в базе GeoNames. Для российских адресов не заполняется. */
  geonameOd?: InputMaybe<Scalars['String']['input']>;
  /** Дом */
  house?: InputMaybe<Scalars['String']['input']>;
  /** Кадастровый номер дома */
  houseCadastralNumber?: InputMaybe<Scalars['String']['input']>;
  /** ФИАС-код дома */
  houseFiasId?: InputMaybe<Scalars['String']['input']>;
  /** КЛАДР-код дома */
  houseKladrId?: InputMaybe<Scalars['String']['input']>;
  houseType?: InputMaybe<Scalars['String']['input']>;
  /** Тип дома (полный) */
  houseTypeFull?: InputMaybe<Scalars['String']['input']>;
  /** Актуализирован ли адрес через Дадату */
  isFromDadata?: InputMaybe<Scalars['Boolean']['input']>;
  /** КЛАДР-код адреса */
  kladrId?: InputMaybe<Scalars['String']['input']>;
  /** Роут адреса из сервиса locations */
  locationRoute?: InputMaybe<Scalars['String']['input']>;
  /** Список ближайших станций метро */
  metro?: InputMaybe<Array<InputMaybe<TInputNestedHabitationAddressMetro>>>;
  /** Код ОКАТО */
  okato?: InputMaybe<Scalars['String']['input']>;
  /** Код ОКТМО */
  oktmo?: InputMaybe<Scalars['String']['input']>;
  /** Абонентский ящик */
  postalBox?: InputMaybe<Scalars['String']['input']>;
  /** Почтовый индекс РФ */
  postalCode?: InputMaybe<Scalars['PostalCode']['input']>;
  /** Регион */
  region?: InputMaybe<Scalars['String']['input']>;
  /** ФИАС-код региона */
  regionFiasId?: InputMaybe<Scalars['String']['input']>;
  /** ISO-код региона */
  regionIsoCode?: InputMaybe<Scalars['String']['input']>;
  /** КЛАДР-код региона */
  regionKladrId?: InputMaybe<Scalars['String']['input']>;
  regionType?: InputMaybe<Scalars['String']['input']>;
  /** Тип региона (полный) */
  regionTypeFull?: InputMaybe<Scalars['String']['input']>;
  /** Регион с типом */
  regionWithType?: InputMaybe<Scalars['String']['input']>;
  /** Количество комнат */
  roomsCount?: InputMaybe<Scalars['String']['input']>;
  settlement?: InputMaybe<Scalars['String']['input']>;
  /** ФИАС-код нас. пункта */
  settlementFiasId?: InputMaybe<Scalars['String']['input']>;
  /** КЛАДР-код нас. пункта */
  settlementKladrId?: InputMaybe<Scalars['String']['input']>;
  settlementType?: InputMaybe<Scalars['String']['input']>;
  /** Тип населенного пункта (полный) */
  settlementTypeFull?: InputMaybe<Scalars['String']['input']>;
  /** Населенный пункт с типом */
  settlementTypeWithType?: InputMaybe<Scalars['String']['input']>;
  /** Рыночная стоимость м² */
  squareMeterPrice?: InputMaybe<Scalars['String']['input']>;
  /** Номер земельного участка */
  stead?: InputMaybe<Scalars['String']['input']>;
  /** Кадастровый номер земельного участка */
  steadCadastralNumber?: InputMaybe<Scalars['String']['input']>;
  /** ФИАС-код земельного участка */
  steadFiasId?: InputMaybe<Scalars['String']['input']>;
  /** КЛАДР-код земельного участка */
  steadKladrId?: InputMaybe<Scalars['String']['input']>;
  /** Тип земельного участка (всегда "уч") */
  steadType?: InputMaybe<Scalars['String']['input']>;
  /** Тип земельного участка (полный, всегда "участок") */
  steadTypeFull?: InputMaybe<Scalars['String']['input']>;
  /** Улица */
  street?: InputMaybe<Scalars['String']['input']>;
  /** ФИАС-код улицы */
  streetFiasId?: InputMaybe<Scalars['String']['input']>;
  /** Тип улицы */
  streetType?: InputMaybe<Scalars['String']['input']>;
  /** Тип улицы (полный) */
  streetTypeFull?: InputMaybe<Scalars['String']['input']>;
  /** Улица с типом */
  streetWithType?: InputMaybe<Scalars['String']['input']>;
  /** Код ИФНС для физических лиц */
  taxOffice?: InputMaybe<Scalars['String']['input']>;
  /** Код ИФНС для организаций */
  taxOfficeLegal?: InputMaybe<Scalars['String']['input']>;
  /** Часовой пояс */
  timezone?: InputMaybe<Scalars['String']['input']>;
};

export type TInputNestedHabitationAddressMetro = {
  /** Расстояние до станции метро в километрах */
  distance?: InputMaybe<Scalars['Float']['input']>;
  /** Станция метро - название линии */
  line?: InputMaybe<Scalars['String']['input']>;
  /** Станция метро - название станции */
  name?: InputMaybe<Scalars['String']['input']>;
};

export type TInputNestedHabitationAlfa = {
  /** Адрес  проживания [Альфа] */
  livingPeople?: InputMaybe<TInputPeople>;
  /** Адрес регистрации [Альфа] */
  registeredPeople?: InputMaybe<TInputPeople>;
};

export type TInputNestedHabitationCreditSelection = {
  pledgeOwnerFamilyStatus?: InputMaybe<EFamilyStatus>;
  pledgeOwnerFirstName?: InputMaybe<Scalars['StrictString']['input']>;
  pledgeOwnerLastName?: InputMaybe<Scalars['StrictString']['input']>;
  pledgeOwnerMiddleName?: InputMaybe<Scalars['StrictString']['input']>;
  pledgeOwnerPhone?: InputMaybe<Scalars['PhoneNumber']['input']>;
  pledgeOwnerRelationship?: InputMaybe<ERelationStatus>;
  pledgeOwnerSingle?: InputMaybe<Scalars['String']['input']>;
};

export type TInputNestedHabitationDocuments = {
  /** Информация о недвижимости из ЕГРН */
  EGRN?: InputMaybe<Array<InputMaybe<TInputRealestateFile>>>;
};

export type TInputNestedHabitationProperties = {
  /** Оценочная стоимость */
  assessedValue?: InputMaybe<Scalars['Float']['input']>;
  /** Кадастровый номер (специально для RED), потому что в address это поле может быть перезатёрто DaData`ой */
  cadastralNumber?: InputMaybe<Scalars['CadastralNumber']['input']>;
  /** Год постройки дома (специально для RED), потому что в address это поле может быть перезатёрто DaData`ой */
  constructionYear?: InputMaybe<Scalars['year']['input']>;
  /** Площадь (специально для RED), потому что в address это поле может быть перезатёрто DaData`ой */
  flatArea?: InputMaybe<Scalars['String']['input']>;
  /** Номер этажа (специально для RED), потому что в address это поле может быть перезатёрто DaData`ой */
  floorNumber?: InputMaybe<Scalars['String']['input']>;
  /** Количество этажей */
  floorsNumber?: InputMaybe<Scalars['Int']['input']>;
  /** Вид недвижимости квартира/дом/комната */
  habitationType?: InputMaybe<Scalars['String']['input']>;
  /** Газификация */
  hasGas?: InputMaybe<Scalars['Boolean']['input']>;
  /** Наличие перепланировки */
  hasRedevelopment?: InputMaybe<Scalars['Boolean']['input']>;
  /** Имеются ли деревянные перекрытия */
  hasWoodenFloors?: InputMaybe<Scalars['Boolean']['input']>;
  /** Планируется ремонт */
  isRenovationPlanned?: InputMaybe<Scalars['Boolean']['input']>;
  /** Снимаю квартиру */
  isRented?: InputMaybe<Scalars['Boolean']['input']>;
  /** Сдаю квартиру в аренду */
  isRenting?: InputMaybe<Scalars['Boolean']['input']>;
  /** Материал перекрытий */
  overlapMaterial?: InputMaybe<Scalars['String']['input']>;
  /** Количество комнат (специально для RED), потому что в address это поле может быть перезатёрто DaData`ой */
  roomsCount?: InputMaybe<Scalars['String']['input']>;
  /** Материал стен */
  wallMaterial?: InputMaybe<Scalars['String']['input']>;
};

export type TInputNestedHabitationSber = {
  /** Адрес  проживания (Сбер) */
  livingPeople?: InputMaybe<TInputPeople>;
  /** Адрес регистрации (Сбер) */
  registeredPeople?: InputMaybe<TInputPeople>;
};

export type TInputNestedHabitationTBank = {
  /** Адрес  проживания (ТБанк) */
  livingPeople?: InputMaybe<TInputPeople>;
  /** Адрес регистрации (ТБанк) */
  registeredPeople?: InputMaybe<TInputPeople>;
};

export type TInputNestedNdfl2Income = {
  /** Доходы, облагаемые по ставке: Код бюджетной классификации */
  budgetClassificationCode?: InputMaybe<Scalars['String']['input']>;
  incomeTaxableByMonth?: InputMaybe<Array<InputMaybe<TInputNestedNdfl2IncomeIncomeTaxableByMonth>>>;
  /** Доходы, облагаемые по ставке: Ставка */
  taxRate?: InputMaybe<Scalars['Int']['input']>;
  total?: InputMaybe<TInputNestedNdfl2IncomeTotal>;
};

export type TInputNestedNdfl2IncomeIncomeTaxableByMonth = {
  /** Доходы, облагаемые по ставке: Сумма дохода */
  amount?: InputMaybe<Scalars['Float']['input']>;
  /** Доходы, облагаемые по ставке: Код дохода */
  code?: InputMaybe<Scalars['String']['input']>;
  deduction?: InputMaybe<TInputNestedNdfl2IncomeIncomeTaxableByMonthDeduction>;
  /** Доходы, облагаемые по ставке: Месяц */
  month?: InputMaybe<Scalars['String']['input']>;
};

export type TInputNestedNdfl2IncomeIncomeTaxableByMonthDeduction = {
  /** Доходы, облагаемые по ставке: Сумма вычета */
  amount?: InputMaybe<Scalars['Float']['input']>;
  /** Доходы, облагаемые по ставке: Код вычета */
  code?: InputMaybe<Scalars['String']['input']>;
};

export type TInputNestedNdfl2IncomeTotal = {
  /** Общие суммы дохода и налога: Общая сумма доходов */
  amount?: InputMaybe<Scalars['Float']['input']>;
  /** Общие суммы дохода и налога: Сумма фиксированных  авансовых платежей */
  fixedAdvancePaymentAmount?: InputMaybe<Scalars['Float']['input']>;
  /** Общие суммы дохода и налога: Сумма налога исчисленная  */
  taxAmount?: InputMaybe<Scalars['Float']['input']>;
  /** Общие суммы дохода и налога: Сумма налога перечисленная */
  taxAmountPaid?: InputMaybe<Scalars['Float']['input']>;
  /** Общие суммы дохода и налога: Налоговая база */
  taxBase?: InputMaybe<Scalars['Float']['input']>;
  /** Общие суммы дохода и налога: Сумма налога на прибыль организаций, подлежащая зачету */
  taxOrganizationAmount?: InputMaybe<Scalars['Float']['input']>;
  /** Общие суммы дохода и налога: Сумма налога, излишне  удержанная налоговым агентом  */
  taxOverWithheld?: InputMaybe<Scalars['Float']['input']>;
  /** Общие суммы дохода и налога: Сумма налога удержанная  */
  taxWithholding?: InputMaybe<Scalars['Float']['input']>;
};

export type TInputNestedNdfl2Person = {
  /** Получатель доходов: дата рождения налогоплательщика */
  birthDate?: InputMaybe<Scalars['BirthDate']['input']>;
  /** Получатель доходов: гражданство налогоплательщика */
  citizenship?: InputMaybe<Scalars['String']['input']>;
  document?: InputMaybe<TInputNestedNdfl2PersonDocument>;
  /** Получатель доходов: Имя */
  firstName?: InputMaybe<Scalars['StrictString']['input']>;
  /** Получатель доходов: Фамилия */
  lastName?: InputMaybe<Scalars['StrictString']['input']>;
  /** Получатель доходов: Отчество */
  middleName?: InputMaybe<Scalars['StrictString']['input']>;
  /** Получатель доходов: статус налогоплательщика */
  status?: InputMaybe<Scalars['String']['input']>;
};

export type TInputNestedNdfl2PersonDocument = {
  /** Получатель доходов: код документа, подтвержающего личность */
  code?: InputMaybe<Scalars['String']['input']>;
  /** Получатель доходов: серия и номер документа, подтвержающего личность */
  seriesNumber?: InputMaybe<Scalars['String']['input']>;
};

export type TInputNestedNdfl2TaxAgent = {
  legalEntity?: InputMaybe<TInputNestedNdfl2TaxAgentLegalEntity>;
  naturalPerson?: InputMaybe<TInputNestedNdfl2TaxAgentNaturalPerson>;
  /** Данные о налоговом агенте: ОКТМО */
  oktmo?: InputMaybe<Scalars['String']['input']>;
  /** Данные о налоговом агенте: Телефон */
  phone?: InputMaybe<Scalars['String']['input']>;
};

export type TInputNestedNdfl2TaxAgentLegalEntity = {
  /** Данные о налоговом агенте (юридическое лицо): ИНН */
  inn?: InputMaybe<Scalars['INN']['input']>;
  /** Данные о налоговом агенте (юридическое лицо): КПП */
  kpp?: InputMaybe<Scalars['KPP']['input']>;
  reorganizedInfo?: InputMaybe<TInputNestedNdfl2TaxAgentLegalEntityReorganizedInfo>;
  /** Данные о налоговом агенте (юридическое лицо): наименование организации */
  title?: InputMaybe<Scalars['String']['input']>;
};

export type TInputNestedNdfl2TaxAgentLegalEntityReorganizedInfo = {
  /** Код формы реорганизации (ликвидации)/закрытия */
  form?: InputMaybe<Scalars['String']['input']>;
  /** ИНН реорганизованной организации/закрытого подразделения */
  inn?: InputMaybe<Scalars['INN']['input']>;
  /** КПП реорганизованной организации/закрытого подразделения */
  kpp?: InputMaybe<Scalars['KPP']['input']>;
};

export type TInputNestedNdfl2TaxAgentNaturalPerson = {
  /** Данные о налоговом агенте (физическое лицо): Имя */
  firstName?: InputMaybe<Scalars['StrictString']['input']>;
  /** Данные о налоговом агенте (физическое лицо): ИНН */
  inn?: InputMaybe<Scalars['String']['input']>;
  /** Данные о налоговом агенте (физическое лицо): Фамилия */
  lastName?: InputMaybe<Scalars['StrictString']['input']>;
  /** Данные о налоговом агенте (физическое лицо): Отчество */
  middleName?: InputMaybe<Scalars['StrictString']['input']>;
};

export type TInputNestedOrganizationBank = {
  /** Расчётный счёт */
  accountNumber?: InputMaybe<Scalars['NumberString']['input']>;
  /** БИК банка */
  bik?: InputMaybe<Scalars['NumberString']['input']>;
  /** Корреспондентский счёт */
  correspondentAccount?: InputMaybe<Scalars['NumberString']['input']>;
  /** Id банка */
  id?: InputMaybe<Scalars['String']['input']>;
  /** ИНН банка */
  inn?: InputMaybe<Scalars['INN']['input']>;
  /** Имя банк */
  name?: InputMaybe<Scalars['StrictString']['input']>;
};

export type TInputNestedOrganizationCeo = {
  /** Годовой доход ЕИО */
  annualIncome?: InputMaybe<Scalars['Int']['input']>;
  /** Образование ЕИО */
  education?: InputMaybe<EEducation>;
  /** Признак того, что ЕИО собственник */
  isOwner?: InputMaybe<Scalars['Boolean']['input']>;
  /** Семейное положение */
  maritalStatus?: InputMaybe<EFamilyStatus>;
  /** Номер телефона ЕИО */
  phone?: InputMaybe<Scalars['PhoneNumber']['input']>;
  /** Должность ЕИО */
  position?: InputMaybe<Scalars['String']['input']>;
  /** Доля ЕИО в уставном капитале */
  share?: InputMaybe<Scalars['Int']['input']>;
  spouse?: InputMaybe<TInputNestedOrganizationCeoSpouse>;
  /** Сколько лет в качестве учредителя */
  yearsAsFounder?: InputMaybe<Scalars['Int']['input']>;
  /** Сколько лет ведёт бизнес */
  yearsInBusiness?: InputMaybe<Scalars['Int']['input']>;
};

export type TInputNestedOrganizationCeoSpouse = {
  /** Дата рождения супруга/супруги */
  birthDate?: InputMaybe<Scalars['BirthDate']['input']>;
  /** Имя супруга/супруги */
  firstName?: InputMaybe<Scalars['StrictString']['input']>;
  /** Фамилия супруга/супруги */
  lastName?: InputMaybe<Scalars['StrictString']['input']>;
  /** Отчество супруга/супруги */
  middleName?: InputMaybe<Scalars['StrictString']['input']>;
};

export type TInputNestedOrganizationContact = {
  /** Фамилия контактного лица */
  firstName?: InputMaybe<Scalars['StrictString']['input']>;
  /** Фамилия контактного лица */
  lastName?: InputMaybe<Scalars['StrictString']['input']>;
  /** Отчество контактного лица */
  middleName?: InputMaybe<Scalars['StrictString']['input']>;
  /** Телефон контактного лица */
  phone?: InputMaybe<Scalars['PhoneNumber']['input']>;
};

export type TInputNestedOrganizationOwner = {
  /** Фамилия владельца */
  firstName?: InputMaybe<Scalars['StrictString']['input']>;
  /** Фамилия владельца */
  lastName?: InputMaybe<Scalars['StrictString']['input']>;
  /** Фамилия владельца */
  middleName?: InputMaybe<Scalars['StrictString']['input']>;
};

export type TInputNestedPayoutIncomeNdfl2IncomeTaxable = {
  /** Сумма дохода */
  amount?: InputMaybe<Scalars['Float']['input']>;
  /** Код дохода */
  code?: InputMaybe<Scalars['String']['input']>;
};

export type TInputNestedPayoutIncomeNdfl2TaxAgent = {
  legalEntity?: InputMaybe<TInputNestedPayoutIncomeNdfl2TaxAgentLegalEntity>;
  naturalPerson?: InputMaybe<TInputNestedPayoutIncomeNdfl2TaxAgentNaturalPerson>;
};

export type TInputNestedPayoutIncomeNdfl2TaxAgentLegalEntity = {
  /** Данные о налоговом агенте (юридическое лицо): ИНН */
  inn?: InputMaybe<Scalars['String']['input']>;
  /** Данные о налоговом агенте (юридическое лицо): КПП */
  kpp?: InputMaybe<Scalars['KPP']['input']>;
  reorganizedInfo?: InputMaybe<TInputNestedPayoutIncomeNdfl2TaxAgentLegalEntityReorganizedInfo>;
  /** Данные о налоговом агенте (юридическое лицо): наименование организации */
  title?: InputMaybe<Scalars['String']['input']>;
};

export type TInputNestedPayoutIncomeNdfl2TaxAgentLegalEntityReorganizedInfo = {
  /** Код формы реорганизации (ликвидации)/закрытия */
  form?: InputMaybe<Scalars['String']['input']>;
  /** ИНН реорганизованной организации/закрытого подразделения */
  inn?: InputMaybe<Scalars['String']['input']>;
  /** КПП реорганизованной организации/закрытого подразделения */
  kpp?: InputMaybe<Scalars['KPP']['input']>;
};

export type TInputNestedPayoutIncomeNdfl2TaxAgentNaturalPerson = {
  /** Данные о налоговом агенте (физическое лицо): Имя */
  firstName?: InputMaybe<Scalars['StrictString']['input']>;
  /** Данные о налоговом агенте (физическое лицо): ИНН */
  inn?: InputMaybe<Scalars['String']['input']>;
  /** Данные о налоговом агенте (физическое лицо): Фамилия */
  lastName?: InputMaybe<Scalars['StrictString']['input']>;
  /** Данные о налоговом агенте (физическое лицо): Отчество */
  middleName?: InputMaybe<Scalars['StrictString']['input']>;
};

export type TInputNestedPayoutIncomeNdfl2Total = {
  /** Общая сумма дохода */
  amount?: InputMaybe<Scalars['Float']['input']>;
  /** Налоговая база */
  taxBase?: InputMaybe<Scalars['Float']['input']>;
};

export type TInputNestedPayoutIncomeNdfl3Entrepreneurship = {
  /** Доходы, полученные от предпринимательской, адвокатской деятельности и частной практики: Общая сумма дохода */
  amount?: InputMaybe<Scalars['Float']['input']>;
  /** Доходы, полученные от предпринимательской, адвокатской деятельности и частной практики: Налоговая база */
  taxBase?: InputMaybe<Scalars['Float']['input']>;
};

export type TInputNestedPayoutIncomeNdfl3Income = {
  agent?: InputMaybe<TInputNestedPayoutIncomeNdfl3IncomeAgent>;
  /** Общая сумма дохода */
  amount?: InputMaybe<Scalars['Float']['input']>;
};

export type TInputNestedPayoutIncomeNdfl3IncomeAgent = {
  legalEntity?: InputMaybe<TInputNestedPayoutIncomeNdfl3IncomeAgentLegalEntity>;
  naturalPerson?: InputMaybe<TInputNestedPayoutIncomeNdfl3IncomeAgentNaturalPerson>;
};

export type TInputNestedPayoutIncomeNdfl3IncomeAgentLegalEntity = {
  /** Данные о налоговом агенте (юридическое лицо): ИНН */
  inn?: InputMaybe<Scalars['String']['input']>;
  /** Данные о налоговом агенте (юридическое лицо): КПП */
  kpp?: InputMaybe<Scalars['KPP']['input']>;
  reorganizedInfo?: InputMaybe<TInputNestedPayoutIncomeNdfl3IncomeAgentLegalEntityReorganizedInfo>;
  /** Данные о налоговом агенте (юридическое лицо): наименование организации */
  title?: InputMaybe<Scalars['String']['input']>;
};

export type TInputNestedPayoutIncomeNdfl3IncomeAgentLegalEntityReorganizedInfo = {
  /** Код формы реорганизации (ликвидации)/закрытия */
  form?: InputMaybe<Scalars['String']['input']>;
  /** ИНН реорганизованной организации/закрытого подразделения */
  inn?: InputMaybe<Scalars['String']['input']>;
  /** КПП реорганизованной организации/закрытого подразделения */
  kpp?: InputMaybe<Scalars['KPP']['input']>;
};

export type TInputNestedPayoutIncomeNdfl3IncomeAgentNaturalPerson = {
  /** Данные о налоговом агенте (физическое лицо): Имя */
  firstName?: InputMaybe<Scalars['StrictString']['input']>;
  /** Данные о налоговом агенте (физическое лицо): ИНН */
  inn?: InputMaybe<Scalars['String']['input']>;
  /** Данные о налоговом агенте (физическое лицо): Фамилия */
  lastName?: InputMaybe<Scalars['StrictString']['input']>;
  /** Данные о налоговом агенте (физическое лицо): Отчество */
  middleName?: InputMaybe<Scalars['StrictString']['input']>;
};

export type TInputNestedPayoutIncomePayout = {
  agent?: InputMaybe<TInputNestedPayoutIncomePayoutAgent>;
  incomeByMonth?: InputMaybe<Array<InputMaybe<TInputNestedPayoutIncomePayoutIncomeByMonth>>>;
  /** Год выплаты */
  year?: InputMaybe<Scalars['year']['input']>;
};

export type TInputNestedPayoutIncomePayoutAgent = {
  legalEntity?: InputMaybe<TInputNestedPayoutIncomePayoutAgentLegalEntity>;
  naturalPerson?: InputMaybe<TInputNestedPayoutIncomePayoutAgentNaturalPerson>;
};

export type TInputNestedPayoutIncomePayoutAgentLegalEntity = {
  /** Данные о налоговом агенте (юридическое лицо): ИНН */
  inn?: InputMaybe<Scalars['String']['input']>;
  /** Данные о налоговом агенте (юридическое лицо): КПП */
  kpp?: InputMaybe<Scalars['KPP']['input']>;
  reorganizedInfo?: InputMaybe<TInputNestedPayoutIncomePayoutAgentLegalEntityReorganizedInfo>;
  /** Данные о налоговом агенте (юридическое лицо): наименование организации */
  title?: InputMaybe<Scalars['String']['input']>;
};

export type TInputNestedPayoutIncomePayoutAgentLegalEntityReorganizedInfo = {
  /** Код формы реорганизации (ликвидации)/закрытия */
  form?: InputMaybe<Scalars['String']['input']>;
  /** ИНН реорганизованной организации/закрытого подразделения */
  inn?: InputMaybe<Scalars['String']['input']>;
  /** КПП реорганизованной организации/закрытого подразделения */
  kpp?: InputMaybe<Scalars['KPP']['input']>;
};

export type TInputNestedPayoutIncomePayoutAgentNaturalPerson = {
  /** Данные о налоговом агенте (физическое лицо): Имя */
  firstName?: InputMaybe<Scalars['StrictString']['input']>;
  /** Данные о налоговом агенте (физическое лицо): ИНН */
  inn?: InputMaybe<Scalars['String']['input']>;
  /** Данные о налоговом агенте (физическое лицо): Фамилия */
  lastName?: InputMaybe<Scalars['StrictString']['input']>;
  /** Данные о налоговом агенте (физическое лицо): Отчество */
  middleName?: InputMaybe<Scalars['StrictString']['input']>;
};

export type TInputNestedPayoutIncomePayoutIncomeByMonth = {
  /** Сумма выплаты */
  amount?: InputMaybe<Scalars['Float']['input']>;
  /** Месяц выплаты */
  month?: InputMaybe<Scalars['String']['input']>;
};

export type TInputNestedPayoutIncomePerson = {
  /** Дата рождения */
  birthDate?: InputMaybe<Scalars['BirthDate']['input']>;
  document?: InputMaybe<TInputNestedPayoutIncomePersonDocument>;
  /** Имя */
  firstName?: InputMaybe<Scalars['StrictString']['input']>;
  /** ИНН */
  inn?: InputMaybe<Scalars['String']['input']>;
  /** Фамилия */
  lastName?: InputMaybe<Scalars['StrictString']['input']>;
  /** Отчество */
  middleName?: InputMaybe<Scalars['StrictString']['input']>;
  /** СНИЛС */
  snils?: InputMaybe<Scalars['SNILS']['input']>;
};

export type TInputNestedPayoutIncomePersonDocument = {
  /** Код документа, подтвержающего личность */
  code?: InputMaybe<Scalars['String']['input']>;
  /** Серия и номер документа, подтвержающего личность */
  seriesNumber?: InputMaybe<Scalars['String']['input']>;
};

export type TInputNestedPeopleCreditRating = {
  /** Дата обновления анкеты кредитного рейтинга */
  dateUpdate?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type TInputNestedPeopleCreditSelection = {
  /** Сумма кредита */
  amount?: InputMaybe<Scalars['String']['input']>;
  /** Марка автомобиля, на который берется кредит */
  autoBrand?: InputMaybe<Scalars['String']['input']>;
  /** Модель автомобиля, на который берется кредит */
  autoModel?: InputMaybe<Scalars['String']['input']>;
  /** Год автомобиля, на который берется кредит */
  autoYear?: InputMaybe<Scalars['year']['input']>;
  /** Залог */
  creditSecurity?: InputMaybe<ECreditSecurity>;
  /** Сумма личных средств */
  initialFee?: InputMaybe<Scalars['String']['input']>;
  /** fias города получения кредита */
  obtainCityFiasId?: InputMaybe<Scalars['String']['input']>;
  /** id города получения кредита */
  obtainCityId?: InputMaybe<Scalars['String']['input']>;
  /** Роут города получения кредита из сервиса locations */
  obtainCityLocationRoute?: InputMaybe<Scalars['String']['input']>;
  /** Срок кредита */
  period?: InputMaybe<Scalars['String']['input']>;
  /** Госномер машины, которая в собственности у пользователя */
  propertyAutoRegistrationPlate?: InputMaybe<Scalars['RegistrationPlateScalar']['input']>;
  /** Цель кредита */
  purpose?: InputMaybe<ECreditPurpose>;
  /** Город получения кредита */
  region?: InputMaybe<Scalars['String']['input']>;
};

export type TInputNestedPeopleDocuments = {
  /** Новый объект загран. паспорта в People.documents */
  FRGNPassport?: InputMaybe<TInputFrgnPassport>;
  /** История заграничных паспортов */
  FRGNPassportHistory?: InputMaybe<Array<InputMaybe<TInputFrgnPassport>>>;
  /** Справка 2-НДФЛ */
  NDFL2?: InputMaybe<Array<InputMaybe<TInputNdfl2>>>;
  /** Новый объект ВУ в People.documents */
  driverLicense?: InputMaybe<TInputDriverLicense>;
  /** История водительских удостоверений */
  driverLicenseHistory?: InputMaybe<Array<InputMaybe<TInputDriverLicense>>>;
  /** Новый объект паспорта в People.documents */
  passport?: InputMaybe<TInputPassport>;
  passportHistory?: InputMaybe<Array<InputMaybe<TInputPassport>>>;
  /** Сведения о доходах физического лица, о выплатах, произведённых плательщиками страховых взносов в пользу физического лица */
  payoutIncome?: InputMaybe<Array<InputMaybe<TInputPayoutIncome>>>;
  /** Договор страхования от клеща */
  tickInsurance?: InputMaybe<TInputTickInsuranceAgreement>;
  /** Застрахованные от клеща люди */
  tickInsuranceAgreements?: InputMaybe<Array<InputMaybe<TInputTickInsuranceAgreement>>>;
  /** Электронная книжка */
  workbook?: InputMaybe<TInputEsiaeWorkbook>;
};

export type TInputNestedPeopleDriverLicence = {
  /** Дата начала стажа по категории A */
  experienceAStartDate?: InputMaybe<Scalars['DateTimeISO']['input']>;
  /** Дата начала стажа */
  experienceStartDate?: InputMaybe<Scalars['DateTimeISO']['input']>;
  /** Дата выдачи первых прав */
  firstIssueDate?: InputMaybe<Scalars['DateTimeISO']['input']>;
  /** Дата выдачи текущих прав */
  issueDate?: InputMaybe<Scalars['DateTimeISO']['input']>;
  /** Серия и номер водительского удостоверения */
  number?: InputMaybe<Scalars['SerialNumber']['input']>;
  /** Серия и номер предыдущего водительского удостоверения */
  previousNumber?: InputMaybe<Scalars['String']['input']>;
};

export type TInputNestedPeopleFamilyAssets = {
  /** Остаток материнского капитала */
  amount?: InputMaybe<Scalars['Float']['input']>;
  /** Общаяя сумма материнского капитала */
  total?: InputMaybe<Scalars['Float']['input']>;
};

export type TInputNestedPeopleInternationalPassport = {
  /** Место рождения */
  birthPlace?: InputMaybe<Scalars['String']['input']>;
  /** Дата окончания срока действия */
  expirationDate?: InputMaybe<Scalars['DateTimeISO']['input']>;
  /** Имя в заграничном паспорте */
  firstName?: InputMaybe<Scalars['String']['input']>;
  /** Дата выдачи заграничного паспорта */
  issueDate?: InputMaybe<Scalars['DateTimeISO']['input']>;
  /** Орган, выдавший заграничный паспорт */
  issuedBy?: InputMaybe<Scalars['String']['input']>;
  /** Фамилия в заграничном паспорте */
  lastName?: InputMaybe<Scalars['String']['input']>;
  /** Серия и номер заграничного паспорта */
  number?: InputMaybe<Scalars['SerialNumberInternationalPassport']['input']>;
};

export type TInputNestedPeopleJob = {
  address?: InputMaybe<TInputNestedPeopleJobAddress>;
  /** Дата начала работы на текущем месте */
  lastExperienceStartDate?: InputMaybe<Scalars['DateTimeISO']['input']>;
  organization?: InputMaybe<TInputNestedPeopleJobOrganization>;
  /** Название должности */
  title?: InputMaybe<Scalars['String']['input']>;
  /** Тип должности */
  type?: InputMaybe<EJobPosition>;
};

export type TInputNestedPeopleJobAddress = {
  area?: InputMaybe<Scalars['String']['input']>;
  areaType?: InputMaybe<Scalars['String']['input']>;
  /** Корпус организации */
  block?: InputMaybe<Scalars['String']['input']>;
  blockType?: InputMaybe<Scalars['String']['input']>;
  /** Город / населенный пункт организации */
  city?: InputMaybe<Scalars['String']['input']>;
  cityType?: InputMaybe<Scalars['String']['input']>;
  /** Год постройки дома организации */
  constructionYear?: InputMaybe<Scalars['String']['input']>;
  /** Код страны */
  countryId?: InputMaybe<Scalars['String']['input']>;
  /** Адрес организации */
  dadata?: InputMaybe<Scalars['String']['input']>;
  /** ФИАС-код адреса (идентификатор ФИАС) */
  fiasId?: InputMaybe<Scalars['String']['input']>;
  /** Уровень детализации, до которого адрес найден в ФИАС */
  fiasLevel?: InputMaybe<Scalars['String']['input']>;
  /** Квартира организации */
  flat?: InputMaybe<Scalars['String']['input']>;
  /** Площадь квартиры организации */
  flatArea?: InputMaybe<Scalars['String']['input']>;
  flatType?: InputMaybe<Scalars['String']['input']>;
  /** Номер этажа */
  floorNumber?: InputMaybe<Scalars['String']['input']>;
  /** Количество этажей в доме организации */
  floorsNumber?: InputMaybe<Scalars['String']['input']>;
  /** Дом организации */
  house?: InputMaybe<Scalars['String']['input']>;
  houseType?: InputMaybe<Scalars['String']['input']>;
  /** КЛАДР-код адреса организации */
  kladrId?: InputMaybe<Scalars['String']['input']>;
  /** Роут адреса работы из сервиса locations */
  locationRoute?: InputMaybe<Scalars['String']['input']>;
  /** Почтовый индекс РФ организации */
  postalCode?: InputMaybe<Scalars['PostalCode']['input']>;
  /** Регион организации */
  region?: InputMaybe<Scalars['String']['input']>;
  regionType?: InputMaybe<Scalars['String']['input']>;
  /** Количество комнат в доме организации */
  roomsCount?: InputMaybe<Scalars['String']['input']>;
  settlement?: InputMaybe<Scalars['String']['input']>;
  settlementType?: InputMaybe<Scalars['String']['input']>;
  /** Улица организации */
  street?: InputMaybe<Scalars['String']['input']>;
  /** Тип улицы */
  streetType?: InputMaybe<Scalars['String']['input']>;
};

export type TInputNestedPeopleJobOrganization = {
  /** Сфера деятельности организации */
  activity?: InputMaybe<EOrganizationActivity>;
  /** Идентификационный номер налогоплательщика (ИНН) */
  inn?: InputMaybe<Scalars['INN']['input']>;
  /** Наименование организации, где работает клиент */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Основной государственный регистрационный номер (ОГРН) */
  ogrn?: InputMaybe<Scalars['OGRN']['input']>;
  /** Код ОКВЭД */
  okved?: InputMaybe<Scalars['String']['input']>;
  /** Рабочий телефон */
  phone?: InputMaybe<Scalars['PhoneNumber']['input']>;
  /** Организационно-правовая форма организации */
  type?: InputMaybe<EEmployerType>;
  /** Код ОПФ */
  typeCode?: InputMaybe<Scalars['JobTypeCode']['input']>;
};

export type TInputNestedPeopleLoanRestrictions = {
  /** Дата последнего обновления информации об ограничениях */
  lastUpdate?: InputMaybe<Scalars['DateTimeISO']['input']>;
  /** Список ограничений */
  restrictions?: InputMaybe<Array<InputMaybe<TInputNestedPeopleLoanRestrictionsRestrictions>>>;
};

export type TInputNestedPeopleLoanRestrictionsRestrictions = {
  /** Дата заявления */
  applicationDate?: InputMaybe<Scalars['DateTimeISO']['input']>;
  /** Дата начала действия */
  startDate?: InputMaybe<Scalars['DateTimeISO']['input']>;
  /** Тип ограничения */
  type?: InputMaybe<ELoanRestrictionsType>;
};

export type TInputNestedPeopleMfo = {
  /** Сумма займа */
  amount?: InputMaybe<Scalars['String']['input']>;
  /** Идентификатор диалога в реакт анкете */
  conversationId?: InputMaybe<Scalars['String']['input']>;
  /** Срок займа */
  dateTo?: InputMaybe<Scalars['DateTimeISO']['input']>;
  /** Срок займа */
  period?: InputMaybe<Scalars['String']['input']>;
};

export type TInputNestedPeopleOsago = {
  /** КБМ */
  kbm?: InputMaybe<Scalars['String']['input']>;
  /** Дата сохранения предыдущих прав в процессе оформления ОСАГО */
  previousLicenceInputDate?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type TInputNestedPeoplePassport = {
  /** Дата регистрации */
  addressRegistrationDate?: InputMaybe<Scalars['DateTimeISO']['input']>;
  /** Дата выдачи паспорта РФ */
  issueDate?: InputMaybe<Scalars['DateTimeISO']['input']>;
  /** Орган, выдавший паспорт РФ */
  issuedBy?: InputMaybe<Scalars['String']['input']>;
  /** Код подразделения организации, выдавшей паспорт РФ */
  issuedByCode?: InputMaybe<Scalars['IssueId']['input']>;
  /** Серия и номер паспорта РФ */
  number?: InputMaybe<Scalars['SerialNumber']['input']>;
};

export type TInputNestedPeoplePhysiology = {
  /** Нижнее давление */
  arterialRangeDown?: InputMaybe<Scalars['Int']['input']>;
  /** Верхнее давление */
  arterialRangeUp?: InputMaybe<Scalars['Int']['input']>;
  /** Рост */
  height?: InputMaybe<Scalars['Float']['input']>;
  /** Вес */
  weight?: InputMaybe<Scalars['Float']['input']>;
};

export type TInputNestedProfileAlfa = {
  /** Владелец профиля [Альфа] */
  owner?: InputMaybe<TInputPeople>;
};

export type TInputNestedProfileEsia = {
  /** Владелец профиля (ЕСИА) */
  owner?: InputMaybe<TInputPeople>;
};

export type TInputNestedProfileSber = {
  /** Владелец профиля (Сбер) */
  owner?: InputMaybe<TInputPeople>;
};

export type TInputNestedProfileTBank = {
  /** Флаги профиля [ТБанк] */
  flags?: InputMaybe<TInputTBankFlags>;
  /** Владелец профиля (ТБанк) */
  owner?: InputMaybe<TInputPeople>;
};

export type TInputNestedRealestateFileCarParkingSpaceRecords = {
  /** Расположение в пределах объекта недвижимости */
  locationInBuild?: InputMaybe<Array<InputMaybe<TInputNestedRealestateFileCarParkingSpaceRecordsLocationInBuild>>>;
  /** Общие сведения (кадастровый номер машиноместа) */
  object?: InputMaybe<TInputNestedRealestateFileCarParkingSpaceRecordsObject>;
};

export type TInputNestedRealestateFileCarParkingSpaceRecordsLocationInBuild = {
  /** Описание расположения */
  description?: InputMaybe<Scalars['String']['input']>;
  /** Номер этажа */
  floor?: InputMaybe<Scalars['Int']['input']>;
  /** Тип этажа */
  floorType?: InputMaybe<TInputNestedRealestateFileCarParkingSpaceRecordsLocationInBuildFloorType>;
  /** Номер на поэтажном плане */
  planNumber?: InputMaybe<Scalars['String']['input']>;
  /** Планы */
  plans?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type TInputNestedRealestateFileCarParkingSpaceRecordsLocationInBuildFloorType = {
  /** код из справочника */
  code?: InputMaybe<Scalars['NumberString']['input']>;
  /** значение */
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type TInputNestedRealestateFileCarParkingSpaceRecordsObject = {
  /** Кадастровый номер */
  cadNumber?: InputMaybe<Scalars['String']['input']>;
  /** Номер кадастрового квартала */
  quarterCadNumber?: InputMaybe<Scalars['String']['input']>;
  /** Вид объекта недвижимости */
  type?: InputMaybe<TInputNestedRealestateFileCarParkingSpaceRecordsObjectType>;
};

export type TInputNestedRealestateFileCarParkingSpaceRecordsObjectType = {
  /** код из справочника */
  code?: InputMaybe<Scalars['NumberString']['input']>;
  /** значение */
  value?: InputMaybe<Scalars['String']['input']>;
};

export type TInputNestedRealestateFileClaimRecords = {
  markContent?: InputMaybe<Scalars['String']['input']>;
  /** Вид регистрационно-учетного действия */
  urdType?: InputMaybe<Scalars['String']['input']>;
};

export type TInputNestedRealestateFileConstructionRecord = {
  /** Адрес (местоположение) */
  addressLocation?: InputMaybe<TInputNestedRealestateFileConstructionRecordAddressLocation>;
  /** Сведения об объектах (связь с кадастровыми номерами) */
  cadLinks?: InputMaybe<TInputNestedRealestateFileConstructionRecordCadLinks>;
  /** Описание местоположения контура сооружения */
  contours?: InputMaybe<TInputNestedRealestateFileConstructionRecordContours>;
  /** Кадастровая стоимость */
  cost?: InputMaybe<Scalars['Float']['input']>;
  /** Общие сведения об объекте недвижимости */
  object?: InputMaybe<TInputNestedRealestateFileConstructionRecordObject>;
  /** Сведения о частях сооружения */
  objectParts?: InputMaybe<Array<InputMaybe<TInputNestedRealestateFileConstructionRecordObjectParts>>>;
  /** Характеристики сооружения */
  params?: InputMaybe<TInputNestedRealestateFileConstructionRecordParams>;
  /** Даты государственной регистрации */
  recordInfo?: InputMaybe<TInputNestedRealestateFileConstructionRecordRecordInfo>;
  /** Особые отметки */
  specialNotes?: InputMaybe<Scalars['String']['input']>;
};

export type TInputNestedRealestateFileConstructionRecordAddressLocation = {
  /** Адрес (местоположение) */
  address?: InputMaybe<TInputNestedRealestateFileConstructionRecordAddressLocationAddress>;
  /** Тип адреса */
  addressType?: InputMaybe<TInputNestedRealestateFileConstructionRecordAddressLocationAddressType>;
  /** Наименования субъектов Российской Федерации, муниципальных образований, населенных пунктов (при наличии) */
  location?: InputMaybe<TInputNestedRealestateFileConstructionRecordAddressLocationLocation>;
  /** Местоположение относительно ориентира */
  relPosition?: InputMaybe<TInputNestedRealestateFileConstructionRecordAddressLocationRelPosition>;
};

export type TInputNestedRealestateFileConstructionRecordAddressLocationAddress = {
  /** Адрес (по справочнику ФИАС) */
  addressFias?: InputMaybe<TInputNestedRealestateFileConstructionRecordAddressLocationAddressAddressFias>;
  /** Неформализованное описание */
  note?: InputMaybe<Scalars['String']['input']>;
  /** Адрес в соответствии с ФИАС */
  readableAddress?: InputMaybe<Scalars['String']['input']>;
};

export type TInputNestedRealestateFileConstructionRecordAddressLocationAddressAddressFias = {
  /** Детализированный уровень */
  detailedLevel?: InputMaybe<TInputNestedRealestateFileConstructionRecordAddressLocationAddressAddressFiasDetailedLevel>;
  /** Уровень населенного пункта */
  levelSettlement?: InputMaybe<TInputNestedRealestateFileConstructionRecordAddressLocationAddressAddressFiasLevelSettlement>;
};

export type TInputNestedRealestateFileConstructionRecordAddressLocationAddressAddressFiasDetailedLevel = {
  /** Квартира */
  apartment?: InputMaybe<TInputNestedRealestateFileConstructionRecordAddressLocationAddressAddressFiasDetailedLevelApartment>;
  /** Дом */
  level1?: InputMaybe<TInputNestedRealestateFileConstructionRecordAddressLocationAddressAddressFiasDetailedLevelLevel1>;
  /** Корпус */
  level2?: InputMaybe<TInputNestedRealestateFileConstructionRecordAddressLocationAddressAddressFiasDetailedLevelLevel2>;
  /** Строение */
  level3?: InputMaybe<TInputNestedRealestateFileConstructionRecordAddressLocationAddressAddressFiasDetailedLevelLevel3>;
  /** Иное описание местоположения */
  other?: InputMaybe<Scalars['String']['input']>;
  /** Улица */
  street?: InputMaybe<TInputNestedRealestateFileConstructionRecordAddressLocationAddressAddressFiasDetailedLevelStreet>;
};

export type TInputNestedRealestateFileConstructionRecordAddressLocationAddressAddressFiasDetailedLevelApartment = {
  name?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
};

export type TInputNestedRealestateFileConstructionRecordAddressLocationAddressAddressFiasDetailedLevelLevel1 = {
  name?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
};

export type TInputNestedRealestateFileConstructionRecordAddressLocationAddressAddressFiasDetailedLevelLevel2 = {
  name?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
};

export type TInputNestedRealestateFileConstructionRecordAddressLocationAddressAddressFiasDetailedLevelLevel3 = {
  name?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
};

export type TInputNestedRealestateFileConstructionRecordAddressLocationAddressAddressFiasDetailedLevelStreet = {
  /** Наименование */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Тип */
  type?: InputMaybe<Scalars['String']['input']>;
};

export type TInputNestedRealestateFileConstructionRecordAddressLocationAddressAddressFiasLevelSettlement = {
  /** Муниципальное образование */
  city?: InputMaybe<TInputNestedRealestateFileConstructionRecordAddressLocationAddressAddressFiasLevelSettlementCity>;
  /** Район */
  district?: InputMaybe<TInputNestedRealestateFileConstructionRecordAddressLocationAddressAddressFiasLevelSettlementDistrict>;
  fias?: InputMaybe<Scalars['String']['input']>;
  kladr?: InputMaybe<Scalars['String']['input']>;
  /** Населенный пункт */
  locality?: InputMaybe<TInputNestedRealestateFileConstructionRecordAddressLocationAddressAddressFiasLevelSettlementLocality>;
  okato?: InputMaybe<Scalars['String']['input']>;
  oktmo?: InputMaybe<Scalars['String']['input']>;
  /** Почтовый индекс */
  postalCode?: InputMaybe<Scalars['PostalCode']['input']>;
  /** Код региона */
  region?: InputMaybe<TInputNestedRealestateFileConstructionRecordAddressLocationAddressAddressFiasLevelSettlementRegion>;
  /** Сельсовет */
  sovietVillage?: InputMaybe<TInputNestedRealestateFileConstructionRecordAddressLocationAddressAddressFiasLevelSettlementSovietVillage>;
  /** Городской район */
  urbanDistrict?: InputMaybe<TInputNestedRealestateFileConstructionRecordAddressLocationAddressAddressFiasLevelSettlementUrbanDistrict>;
};

export type TInputNestedRealestateFileConstructionRecordAddressLocationAddressAddressFiasLevelSettlementCity = {
  /** Наименование */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Тип */
  type?: InputMaybe<Scalars['String']['input']>;
};

export type TInputNestedRealestateFileConstructionRecordAddressLocationAddressAddressFiasLevelSettlementDistrict = {
  /** Наименование */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Тип */
  type?: InputMaybe<Scalars['String']['input']>;
};

export type TInputNestedRealestateFileConstructionRecordAddressLocationAddressAddressFiasLevelSettlementLocality = {
  /** Наименование */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Тип */
  type?: InputMaybe<Scalars['String']['input']>;
};

export type TInputNestedRealestateFileConstructionRecordAddressLocationAddressAddressFiasLevelSettlementRegion = {
  /** код из справочника */
  code?: InputMaybe<Scalars['NumberString']['input']>;
  /** значение */
  value?: InputMaybe<Scalars['String']['input']>;
};

export type TInputNestedRealestateFileConstructionRecordAddressLocationAddressAddressFiasLevelSettlementSovietVillage = {
  /** Наименование */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Тип */
  type?: InputMaybe<Scalars['String']['input']>;
};

export type TInputNestedRealestateFileConstructionRecordAddressLocationAddressAddressFiasLevelSettlementUrbanDistrict = {
  /** Наименование */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Тип */
  type?: InputMaybe<Scalars['String']['input']>;
};

export type TInputNestedRealestateFileConstructionRecordAddressLocationAddressType = {
  /** код из справочника */
  code?: InputMaybe<Scalars['NumberString']['input']>;
  /** значение */
  value?: InputMaybe<Scalars['String']['input']>;
};

export type TInputNestedRealestateFileConstructionRecordAddressLocationLocation = {
  /** Муниципальное образование */
  city?: InputMaybe<TInputNestedRealestateFileConstructionRecordAddressLocationLocationCity>;
  /** Район */
  district?: InputMaybe<TInputNestedRealestateFileConstructionRecordAddressLocationLocationDistrict>;
  fias?: InputMaybe<Scalars['String']['input']>;
  kladr?: InputMaybe<Scalars['String']['input']>;
  /** Населенный пункт */
  locality?: InputMaybe<TInputNestedRealestateFileConstructionRecordAddressLocationLocationLocality>;
  okato?: InputMaybe<Scalars['String']['input']>;
  oktmo?: InputMaybe<Scalars['String']['input']>;
  /** Почтовый индекс */
  postalCode?: InputMaybe<Scalars['PostalCode']['input']>;
  /** Код региона */
  region?: InputMaybe<TInputNestedRealestateFileConstructionRecordAddressLocationLocationRegion>;
  /** Сельсовет */
  sovietVillage?: InputMaybe<TInputNestedRealestateFileConstructionRecordAddressLocationLocationSovietVillage>;
  /** Городской район */
  urbanDistrict?: InputMaybe<TInputNestedRealestateFileConstructionRecordAddressLocationLocationUrbanDistrict>;
};

export type TInputNestedRealestateFileConstructionRecordAddressLocationLocationCity = {
  /** Наименование */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Тип */
  type?: InputMaybe<Scalars['String']['input']>;
};

export type TInputNestedRealestateFileConstructionRecordAddressLocationLocationDistrict = {
  /** Наименование */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Тип */
  type?: InputMaybe<Scalars['String']['input']>;
};

export type TInputNestedRealestateFileConstructionRecordAddressLocationLocationLocality = {
  /** Наименование */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Тип */
  type?: InputMaybe<Scalars['String']['input']>;
};

export type TInputNestedRealestateFileConstructionRecordAddressLocationLocationRegion = {
  /** код из справочника */
  code?: InputMaybe<Scalars['NumberString']['input']>;
  /** значение */
  value?: InputMaybe<Scalars['String']['input']>;
};

export type TInputNestedRealestateFileConstructionRecordAddressLocationLocationSovietVillage = {
  /** Наименование */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Тип */
  type?: InputMaybe<Scalars['String']['input']>;
};

export type TInputNestedRealestateFileConstructionRecordAddressLocationLocationUrbanDistrict = {
  /** Наименование */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Тип */
  type?: InputMaybe<Scalars['String']['input']>;
};

export type TInputNestedRealestateFileConstructionRecordAddressLocationRelPosition = {
  /** Ориентир расположен в границах участка */
  inBoundariesMark?: InputMaybe<Scalars['Boolean']['input']>;
  /** Расположение относительно ориентира */
  locationDescription?: InputMaybe<Scalars['String']['input']>;
  /** Наименование ориентира */
  refPointName?: InputMaybe<Scalars['String']['input']>;
};

export type TInputNestedRealestateFileConstructionRecordCadLinks = {
  /** Кадастровые номера земельных участков, из которых образован данный земельный участок */
  ascendantCadNumbers?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Кадастровые номера машиномест, расположенных в объекте недвижимости */
  carParkingSpaceCadNumbers?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Единое землепользование */
  commonLand?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Кадастровые номера земельных участков, образованных из данного земельного участка */
  descendantCadNumbers?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Кадастровый номер предприятия как имущественного комплекса, в состав которого входит земельный участок */
  facilityCadNumber?: InputMaybe<Scalars['String']['input']>;
  /** Кадастровые номера объектов недвижимости, входящих в состав единого недвижимого комплекса */
  includedCadNumbers?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Кадастровые номера расположенных в пределах земельного участка объектов недвижимости */
  includedObjects?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Кадастровые номера иных объектов недвижимости (земельных участков), в пределах которых расположен объект недвижимости */
  landCadNumbers?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Ранее присвоенные номера */
  oldNumbers?: InputMaybe<Array<InputMaybe<TInputNestedRealestateFileConstructionRecordCadLinksOldNumbers>>>;
  parentCadNumber?: InputMaybe<Scalars['String']['input']>;
  /** Кадастровые номера помещений, расположенных в объекте недвижимости */
  roomCadNumbers?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type TInputNestedRealestateFileConstructionRecordCadLinksOldNumbers = {
  /** Организация, присвоившая номер */
  assigner?: InputMaybe<Scalars['String']['input']>;
  /** Дата присвоения */
  assignmentDate?: InputMaybe<Scalars['String']['input']>;
  /** Номер */
  number?: InputMaybe<Scalars['String']['input']>;
  /** Вид номера */
  numberType?: InputMaybe<TInputNestedRealestateFileConstructionRecordCadLinksOldNumbersNumberType>;
};

export type TInputNestedRealestateFileConstructionRecordCadLinksOldNumbersNumberType = {
  /** код из справочника */
  code?: InputMaybe<Scalars['NumberString']['input']>;
  /** значение */
  value?: InputMaybe<Scalars['String']['input']>;
};

export type TInputNestedRealestateFileConstructionRecordContours = {
  contour?: InputMaybe<Array<InputMaybe<TInputNestedRealestateFileConstructionRecordContoursContour>>>;
};

export type TInputNestedRealestateFileConstructionRecordContoursContour = {
  /** Описание элементов контура (характерных точек контура) */
  entitySpatial?: InputMaybe<TInputNestedRealestateFileConstructionRecordContoursContourEntitySpatial>;
  /** Номер контура */
  numberPp?: InputMaybe<Scalars['Int']['input']>;
};

export type TInputNestedRealestateFileConstructionRecordContoursContourEntitySpatial = {
  /** Система координат */
  skId?: InputMaybe<Scalars['String']['input']>;
  /** Элементы контура */
  spatialsElements?: InputMaybe<Array<InputMaybe<TInputNestedRealestateFileConstructionRecordContoursContourEntitySpatialSpatialsElements>>>;
};

export type TInputNestedRealestateFileConstructionRecordContoursContourEntitySpatialSpatialsElements = {
  /** Тип контура */
  levelContour?: InputMaybe<TInputNestedRealestateFileConstructionRecordContoursContourEntitySpatialSpatialsElementsLevelContour>;
  /** Список координат */
  ordinates?: InputMaybe<Array<InputMaybe<TInputNestedRealestateFileConstructionRecordContoursContourEntitySpatialSpatialsElementsOrdinates>>>;
};

export type TInputNestedRealestateFileConstructionRecordContoursContourEntitySpatialSpatialsElementsLevelContour = {
  /** код из справочника */
  code?: InputMaybe<Scalars['NumberString']['input']>;
  /** значение */
  value?: InputMaybe<Scalars['String']['input']>;
};

export type TInputNestedRealestateFileConstructionRecordContoursContourEntitySpatialSpatialsElementsOrdinates = {
  /** Погрешность */
  deltaGeopoint?: InputMaybe<Scalars['Int']['input']>;
  /** Номер точки */
  numGeopoint?: InputMaybe<Scalars['String']['input']>;
  /** Номер точки (порядок обхода) */
  ordNmb?: InputMaybe<Scalars['Int']['input']>;
  /** Радиус */
  r?: InputMaybe<Scalars['Int']['input']>;
  /** Координата X */
  x?: InputMaybe<Scalars['Int']['input']>;
  /** Координата Y */
  y?: InputMaybe<Scalars['Int']['input']>;
  /** Координата Z */
  z?: InputMaybe<Scalars['Int']['input']>;
};

export type TInputNestedRealestateFileConstructionRecordObject = {
  /** Кадастровый номер */
  cadNumber?: InputMaybe<Scalars['String']['input']>;
  /** Номер кадастрового квартала */
  quarterCadNumber?: InputMaybe<Scalars['String']['input']>;
  /** Вид объекта недвижимости */
  type?: InputMaybe<TInputNestedRealestateFileConstructionRecordObjectType>;
};

export type TInputNestedRealestateFileConstructionRecordObjectParts = {
  /** Площадь || Площадь, в кв. метрах */
  area?: InputMaybe<TInputNestedRealestateFileConstructionRecordObjectPartsArea>;
  /** Содержание ограничений */
  contentRestrictions?: InputMaybe<TInputNestedRealestateFileConstructionRecordObjectPartsContentRestrictions>;
  /** Описание местоположения границ */
  contours?: InputMaybe<Array<InputMaybe<TInputNestedRealestateFileConstructionRecordObjectPartsContours>>>;
  /** Примечание */
  footnote?: InputMaybe<Scalars['String']['input']>;
  /** Местоположение части здания */
  locationBuilding?: InputMaybe<TInputNestedRealestateFileConstructionRecordObjectPartsLocationBuilding>;
  /** Порядковый номер части */
  partNumber?: InputMaybe<Scalars['Int']['input']>;
};

export type TInputNestedRealestateFileConstructionRecordObjectPartsArea = {
  /** код из справочника */
  code?: InputMaybe<Scalars['NumberString']['input']>;
  /** значение */
  value?: InputMaybe<Scalars['Float']['input']>;
};

export type TInputNestedRealestateFileConstructionRecordObjectPartsContentRestrictions = {
  /** Сведения о регистрации */
  dataRegistration?: InputMaybe<TInputNestedRealestateFileConstructionRecordObjectPartsContentRestrictionsDataRegistration>;
  /** Реестровый номер границы */
  regNumbBorder?: InputMaybe<TInputNestedRealestateFileConstructionRecordObjectPartsContentRestrictionsRegNumbBorder>;
};

export type TInputNestedRealestateFileConstructionRecordObjectPartsContentRestrictionsDataRegistration = {
  /** Дата регистрации */
  registrationDate?: InputMaybe<Scalars['String']['input']>;
  /** Номер регистрации/реестровой записи */
  restrictionEncumbranceNumber?: InputMaybe<TInputNestedRealestateFileConstructionRecordObjectPartsContentRestrictionsDataRegistrationRestrictionEncumbranceNumber>;
};

export type TInputNestedRealestateFileConstructionRecordObjectPartsContentRestrictionsDataRegistrationRestrictionEncumbranceNumber = {
  /** Номер реестровой записи */
  number?: InputMaybe<Scalars['String']['input']>;
  /** Номер регистрации ограничения права или обременения ОН */
  rightNumber?: InputMaybe<Scalars['String']['input']>;
};

export type TInputNestedRealestateFileConstructionRecordObjectPartsContentRestrictionsRegNumbBorder = {
  regNumber?: InputMaybe<Scalars['String']['input']>;
};

export type TInputNestedRealestateFileConstructionRecordObjectPartsContours = {
  /** Описание элементов контура (характерных точек контура) */
  entitySpatial?: InputMaybe<TInputNestedRealestateFileConstructionRecordObjectPartsContoursEntitySpatial>;
  /** Номер контура */
  numberPp?: InputMaybe<Scalars['Int']['input']>;
};

export type TInputNestedRealestateFileConstructionRecordObjectPartsContoursEntitySpatial = {
  /** Система координат */
  skId?: InputMaybe<Scalars['String']['input']>;
  /** Координаты */
  spatialsElements?: InputMaybe<Array<InputMaybe<TInputNestedRealestateFileConstructionRecordObjectPartsContoursEntitySpatialSpatialsElements>>>;
};

export type TInputNestedRealestateFileConstructionRecordObjectPartsContoursEntitySpatialSpatialsElements = {
  /** Погрешность */
  deltaGeopoint?: InputMaybe<Scalars['Int']['input']>;
  /** Описание закрепления точки */
  geopointZacrep?: InputMaybe<Scalars['String']['input']>;
  /** Номер межевой точки */
  numGeopoint?: InputMaybe<Scalars['String']['input']>;
  /** Номер точки (порядок обхода) */
  ordNmb?: InputMaybe<Scalars['Int']['input']>;
  /** Координата X */
  x?: InputMaybe<Scalars['Int']['input']>;
  /** Координата Y */
  y?: InputMaybe<Scalars['Int']['input']>;
  /** Координата Z */
  z?: InputMaybe<Scalars['Int']['input']>;
};

export type TInputNestedRealestateFileConstructionRecordObjectPartsLocationBuilding = {
  /** Описание местоположения контура */
  contours?: InputMaybe<Array<InputMaybe<TInputNestedRealestateFileConstructionRecordObjectPartsLocationBuildingContours>>>;
  /** Расположение в пределах объекта недвижимости */
  inBuild?: InputMaybe<Array<InputMaybe<TInputNestedRealestateFileConstructionRecordObjectPartsLocationBuildingInBuild>>>;
};

export type TInputNestedRealestateFileConstructionRecordObjectPartsLocationBuildingContours = {
  /** Описание элементов контура (характерных точек контура) */
  entitySpatial?: InputMaybe<TInputNestedRealestateFileConstructionRecordObjectPartsLocationBuildingContoursEntitySpatial>;
  /** Номер контура */
  numberPp?: InputMaybe<Scalars['Int']['input']>;
};

export type TInputNestedRealestateFileConstructionRecordObjectPartsLocationBuildingContoursEntitySpatial = {
  /** Система координат */
  skId?: InputMaybe<Scalars['String']['input']>;
  /** Элементы контура */
  spatialsElements?: InputMaybe<Array<InputMaybe<TInputNestedRealestateFileConstructionRecordObjectPartsLocationBuildingContoursEntitySpatialSpatialsElements>>>;
};

export type TInputNestedRealestateFileConstructionRecordObjectPartsLocationBuildingContoursEntitySpatialSpatialsElements = {
  /** Тип контура */
  levelContour?: InputMaybe<TInputNestedRealestateFileConstructionRecordObjectPartsLocationBuildingContoursEntitySpatialSpatialsElementsLevelContour>;
  /** Список координат */
  ordinates?: InputMaybe<Array<InputMaybe<TInputNestedRealestateFileConstructionRecordObjectPartsLocationBuildingContoursEntitySpatialSpatialsElementsOrdinates>>>;
};

export type TInputNestedRealestateFileConstructionRecordObjectPartsLocationBuildingContoursEntitySpatialSpatialsElementsLevelContour = {
  /** код из справочника */
  code?: InputMaybe<Scalars['NumberString']['input']>;
  /** значение */
  value?: InputMaybe<Scalars['String']['input']>;
};

export type TInputNestedRealestateFileConstructionRecordObjectPartsLocationBuildingContoursEntitySpatialSpatialsElementsOrdinates = {
  /** Погрешность */
  deltaGeopoint?: InputMaybe<Scalars['Int']['input']>;
  /** Номер точки */
  numGeopoint?: InputMaybe<Scalars['String']['input']>;
  /** Номер точки (порядок обхода) */
  ordNmb?: InputMaybe<Scalars['Int']['input']>;
  /** Радиус */
  r?: InputMaybe<Scalars['Int']['input']>;
  /** Координата X */
  x?: InputMaybe<Scalars['Int']['input']>;
  /** Координата Y */
  y?: InputMaybe<Scalars['Int']['input']>;
  /** Координата Z */
  z?: InputMaybe<Scalars['Int']['input']>;
};

export type TInputNestedRealestateFileConstructionRecordObjectPartsLocationBuildingInBuild = {
  /** Описание расположения */
  description?: InputMaybe<Scalars['String']['input']>;
  /** Номер этажа */
  floor?: InputMaybe<Scalars['Int']['input']>;
  /** Тип этажа */
  floorType?: InputMaybe<Scalars['Int']['input']>;
  /** Номер на поэтажном плане */
  planNumber?: InputMaybe<Scalars['String']['input']>;
  /** Планы */
  plans?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type TInputNestedRealestateFileConstructionRecordObjectType = {
  /** код из справочника */
  code?: InputMaybe<Scalars['NumberString']['input']>;
  /** значение */
  value?: InputMaybe<Scalars['String']['input']>;
};

export type TInputNestedRealestateFileConstructionRecordParams = {
  /** Разрешенное использование */
  allowedUse?: InputMaybe<TInputNestedRealestateFileConstructionRecordParamsAllowedUse>;
  /** В Здании это значение является числом */
  area?: InputMaybe<TInputNestedRealestateFileConstructionRecordParamsArea>;
  /** Основные характеристики */
  baseParameters?: InputMaybe<Array<InputMaybe<TInputNestedRealestateFileConstructionRecordParamsBaseParameters>>>;
  /** Категория */
  category?: InputMaybe<TInputNestedRealestateFileConstructionRecordParamsCategory>;
  /** Степень готовности объекта незавершенного строительства в процентах */
  degreeReadiness?: InputMaybe<Scalars['String']['input']>;
  /** Количество этажей (в том числе подземных) */
  floors?: InputMaybe<Scalars['Int']['input']>;
  /** Материалы наружных стен здания */
  materials?: InputMaybe<Array<InputMaybe<TInputNestedRealestateFileConstructionRecordParamsMaterials>>>;
  /** Наименование сооружения */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Вид(ы) разрешенного использования */
  permittedUses?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Разрешенное использование по градостроительному регламенту */
  permittesUsesGradReg?: InputMaybe<TInputNestedRealestateFileConstructionRecordParamsPermittesUsesGradReg>;
  /** Назначение сооружения */
  purpose?: InputMaybe<TInputNestedRealestateFileConstructionRecordParamsPurpose>;
  /** Количество подземных этажей */
  undergroundFloors?: InputMaybe<Scalars['Int']['input']>;
  /** Год завершения строительства */
  yearBuilt?: InputMaybe<Scalars['year']['input']>;
  /** Год ввода в эксплуатацию по завершении строительства */
  yearCommisioning?: InputMaybe<Scalars['String']['input']>;
};

export type TInputNestedRealestateFileConstructionRecordParamsAllowedUse = {
  /** По документу */
  byDocument?: InputMaybe<Scalars['String']['input']>;
  /** Вид разрешенного использования земельного участка в соответствии с ранее использовавшимся классификатором */
  landUse?: InputMaybe<TInputNestedRealestateFileConstructionRecordParamsAllowedUseLandUse>;
  /** Вид разрешенного использования земельного участка в соответствии с классификатором, утвержденным приказом Минэкономразвития России от 01.09.2014 № 540 */
  landUseMer?: InputMaybe<TInputNestedRealestateFileConstructionRecordParamsAllowedUseLandUseMer>;
};

export type TInputNestedRealestateFileConstructionRecordParamsAllowedUseLandUse = {
  /** код из справочника */
  code?: InputMaybe<Scalars['NumberString']['input']>;
  /** значение */
  value?: InputMaybe<Scalars['String']['input']>;
};

export type TInputNestedRealestateFileConstructionRecordParamsAllowedUseLandUseMer = {
  /** код из справочника */
  code?: InputMaybe<Scalars['NumberString']['input']>;
  /** значение */
  value?: InputMaybe<Scalars['String']['input']>;
};

export type TInputNestedRealestateFileConstructionRecordParamsArea = {
  /** код из справочника */
  code?: InputMaybe<Scalars['NumberString']['input']>;
  /** значение */
  value?: InputMaybe<Scalars['Float']['input']>;
};

export type TInputNestedRealestateFileConstructionRecordParamsBaseParameters = {
  /** Площадь в кв. метрах */
  area?: InputMaybe<Scalars['Float']['input']>;
  /** Площадь застройки в квадратных метрах с округлением до 0,1 квадратного метра */
  builtUpArea?: InputMaybe<Scalars['Int']['input']>;
  /** Глубина в метрах с округлением до 0,1 метра */
  depth?: InputMaybe<Scalars['Int']['input']>;
  /** Протяженность в метрах с округлением до 1 метра */
  extension?: InputMaybe<Scalars['Int']['input']>;
  /** Высота в метрах с округлением до 0,1 метра */
  height?: InputMaybe<Scalars['Int']['input']>;
  /** Глубина залегания в метрах с округлением до 0,1 метра */
  occurenceDepth?: InputMaybe<Scalars['Int']['input']>;
  /** Объем в кубических метрах с округлением до 1 кубического метра */
  volume?: InputMaybe<Scalars['Int']['input']>;
};

export type TInputNestedRealestateFileConstructionRecordParamsCategory = {
  /** код из справочника */
  code?: InputMaybe<Scalars['NumberString']['input']>;
  /** значение */
  value?: InputMaybe<Scalars['String']['input']>;
};

export type TInputNestedRealestateFileConstructionRecordParamsMaterials = {
  /** код из справочника */
  code?: InputMaybe<Scalars['NumberString']['input']>;
  /** значение */
  value?: InputMaybe<Scalars['String']['input']>;
};

export type TInputNestedRealestateFileConstructionRecordParamsPermittesUsesGradReg = {
  /** Вид разрешенного использования в соответствии с классификатором, утвержденным приказом Минэкономразвития России от 01.09.2014 № 540 */
  landUse?: InputMaybe<TInputNestedRealestateFileConstructionRecordParamsPermittesUsesGradRegLandUse>;
  /** Разрешенное использование (текстовое описание) */
  permittedUseText?: InputMaybe<Scalars['String']['input']>;
  /** Реестровый номер границы */
  regNumbBorder?: InputMaybe<Scalars['String']['input']>;
};

export type TInputNestedRealestateFileConstructionRecordParamsPermittesUsesGradRegLandUse = {
  /** код из справочника */
  code?: InputMaybe<Scalars['NumberString']['input']>;
  /** значение */
  value?: InputMaybe<Scalars['String']['input']>;
};

export type TInputNestedRealestateFileConstructionRecordParamsPurpose = {
  /** код из справочника */
  code?: InputMaybe<Scalars['NumberString']['input']>;
  /** значение */
  value?: InputMaybe<Scalars['String']['input']>;
};

export type TInputNestedRealestateFileConstructionRecordRecordInfo = {
  /** Дата снятия с учета / регистрации */
  cancelDate?: InputMaybe<Scalars['String']['input']>;
  /** Дата постановки на учет / регистрации */
  registrationDate?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type TInputNestedRealestateFileDealRecords = {
  /** Общие сведения о сделке (вид сделки) */
  dealData?: InputMaybe<TInputNestedRealestateFileDealRecordsDealData>;
  /** Сведения об осуществлении государственной регистрации сделки, права, ограничения права, совершенных без необходимого в силу закона согласия третьего лица, органа */
  thirdPartyConsents?: InputMaybe<TInputNestedRealestateFileDealRecordsThirdPartyConsents>;
};

export type TInputNestedRealestateFileDealRecordsDealData = {
  /** код из справочника */
  code?: InputMaybe<Scalars['NumberString']['input']>;
  /** значение */
  value?: InputMaybe<Scalars['String']['input']>;
};

export type TInputNestedRealestateFileDealRecordsThirdPartyConsents = {
  /** Не представлено согласие на совершение сделки */
  dissentingEntities?: InputMaybe<TInputNestedRealestateFileDealRecordsThirdPartyConsentsDissentingEntities>;
  /** Федеральный закон, которым предусмотрено получение согласия на совершение сделки */
  law?: InputMaybe<TInputNestedRealestateFileDealRecordsThirdPartyConsentsLaw>;
  /** Содержание отметки при возникновении / погашении */
  markContent?: InputMaybe<Scalars['String']['input']>;
};

export type TInputNestedRealestateFileDealRecordsThirdPartyConsentsDissentingEntities = {
  /** Физическое лицо */
  individual?: InputMaybe<TInputNestedRealestateFileDealRecordsThirdPartyConsentsDissentingEntitiesIndividual>;
  /** Юридическое лицо, орган власти, местного самоуправления */
  legalEntity?: InputMaybe<Scalars['String']['input']>;
};

export type TInputNestedRealestateFileDealRecordsThirdPartyConsentsDissentingEntitiesIndividual = {
  firstName?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  middleName?: InputMaybe<Scalars['String']['input']>;
};

export type TInputNestedRealestateFileDealRecordsThirdPartyConsentsLaw = {
  /** Статья */
  article?: InputMaybe<Scalars['String']['input']>;
  /** Дата */
  lawDate?: InputMaybe<Scalars['String']['input']>;
  /** Номер */
  number?: InputMaybe<Scalars['String']['input']>;
  /** Пункт */
  paragraph?: InputMaybe<Scalars['String']['input']>;
  /** Часть */
  section?: InputMaybe<Scalars['String']['input']>;
  /** Наименование */
  title?: InputMaybe<Scalars['String']['input']>;
};

export type TInputNestedRealestateFileDetailsRequest = {
  /** Дата получения запроса органом регистрации прав */
  dateReceiptRequestRegAuthorityRights?: InputMaybe<Scalars['DateTimeISO']['input']>;
  /** Дата поступившего запроса */
  dateReceivedRequest?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type TInputNestedRealestateFileDetailsStatement = {
  /** Группа нижних реквизитов */
  groupLowerRequisites?: InputMaybe<TInputNestedRealestateFileDetailsStatementGroupLowerRequisites>;
  /** Группа верхних реквизитов */
  groupTopRequisites?: InputMaybe<TInputNestedRealestateFileDetailsStatementGroupTopRequisites>;
};

export type TInputNestedRealestateFileDetailsStatementGroupLowerRequisites = {
  /** Полное наименование должности */
  fullNamePosition?: InputMaybe<Scalars['String']['input']>;
  /** Инициалы, фамилия */
  initialsSurname?: InputMaybe<Scalars['String']['input']>;
};

export type TInputNestedRealestateFileDetailsStatementGroupTopRequisites = {
  /** Дата формирования выписки */
  dateFormation?: InputMaybe<Scalars['DateTimeISO']['input']>;
  /** Полное наименование органа регистрации прав */
  organRegistrRights?: InputMaybe<Scalars['String']['input']>;
  /** Регистрационный номер */
  registrationNumber?: InputMaybe<Scalars['String']['input']>;
};

export type TInputNestedRealestateFileOwnerlessRightRecord = {
  /** Общие сведения о правах на бесхозяйное имущество */
  ownerlessRightData?: InputMaybe<TInputNestedRealestateFileOwnerlessRightRecordOwnerlessRightData>;
  recordInfo?: InputMaybe<TInputNestedRealestateFileOwnerlessRightRecordRecordInfo>;
};

export type TInputNestedRealestateFileOwnerlessRightRecordOwnerlessRightData = {
  /** Наименование органа местного самоуправления (органа государственной власти - для городов федерального значения Москвы, Санкт-Петербурга, Севастополя), представившего заявление о постановке на учет данного объекта недвижимости в качестве бесхозяйного */
  authorityName?: InputMaybe<Scalars['String']['input']>;
  /** Номер регистрации */
  ownerlessRightNumber?: InputMaybe<Scalars['String']['input']>;
};

export type TInputNestedRealestateFileOwnerlessRightRecordRecordInfo = {
  /** Дата снятия с учета / регистрации */
  cancelDate?: InputMaybe<Scalars['String']['input']>;
  /** Дата постановки на учет / регистрации */
  registrationDate?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type TInputNestedRealestateFileRealestateRecord = {
  /** Дополнительное пространственное описание конструктивных элементов */
  additionalContourLocation?: InputMaybe<TInputNestedRealestateFileRealestateRecordAdditionalContourLocation>;
  /** Адрес (местоположение) */
  address?: InputMaybe<TInputNestedRealestateFileRealestateRecordAddress>;
  /** Сведения о создании (эксплуатации) на земельном участке наемного дома */
  apartmentBuilding?: InputMaybe<TInputNestedRealestateFileRealestateRecordApartmentBuilding>;
  /** Сведения об объектах (связь с кадастровыми номерами) */
  cadLinks?: InputMaybe<TInputNestedRealestateFileRealestateRecordCadLinks>;
  /** Сведения о кадастровом инженере (кадастровых инженерах) */
  cadWorks?: InputMaybe<Array<InputMaybe<TInputNestedRealestateFileRealestateRecordCadWorks>>>;
  /** Описание местоположения контура сооружения */
  contours?: InputMaybe<Array<InputMaybe<TInputNestedRealestateFileRealestateRecordContours>>>;
  /** Описание местоположения границ земельного участка */
  contoursLocation?: InputMaybe<TInputNestedRealestateFileRealestateRecordContoursLocation>;
  /** Кадастровая стоимость */
  cost?: InputMaybe<Scalars['Float']['input']>;
  /** Сведения о включении объекта недвижимости в единый государственный реестр объектов культурного наследия (памятников истории и культуры) народов Российской Федерации */
  culturalHeritage?: InputMaybe<TInputNestedRealestateFileRealestateRecordCulturalHeritage>;
  /** Сведения о результатах проведения государственного земельного надзора */
  governmentLandSupervision?: InputMaybe<TInputNestedRealestateFileRealestateRecordGovernmentLandSupervision>;
  locationInBuild?: InputMaybe<Array<InputMaybe<TInputNestedRealestateFileRealestateRecordLocationInBuild>>>;
  /** Сведения о природных объектах, расположенных в пределах земельного участка */
  naturalObjects?: InputMaybe<TInputNestedRealestateFileRealestateRecordNaturalObjects>;
  /** Общие сведения об объекте недвижимости */
  object: TInputNestedRealestateFileRealestateRecordObject;
  /** Сведения о частях земельного участка */
  objectParts?: InputMaybe<Array<InputMaybe<TInputNestedRealestateFileRealestateRecordObjectParts>>>;
  /** Характеристики земельного участка */
  params?: InputMaybe<TInputNestedRealestateFileRealestateRecordParams>;
  /** Даты государственной регистрации */
  recordInfo?: InputMaybe<TInputNestedRealestateFileRealestateRecordRecordInfo>;
  /** Незарегистрированные и не подлежащие государственной регистрации ограничения (обременения) */
  restrictionsEncumbrances?: InputMaybe<TInputNestedRealestateFileRealestateRecordRestrictionsEncumbrances>;
  /** Особые отметки */
  specialNotes?: InputMaybe<Scalars['String']['input']>;
  /** Условный номер земельного участка и сведения о расположении земельного участка в границах территории, в отношении которой утвержден проект межевания территории */
  surveyBoundaries?: InputMaybe<TInputNestedRealestateFileRealestateRecordSurveyBoundaries>;
  /** Сведения о расположении земельного участка в границах зон, территорий */
  zonesAndBoundaries?: InputMaybe<TInputNestedRealestateFileRealestateRecordZonesAndBoundaries>;
};

export type TInputNestedRealestateFileRealestateRecordAdditionalContourLocation = {
  /** Точки пересечения проекций контуров объекта */
  intersectionPoints?: InputMaybe<TInputNestedRealestateFileRealestateRecordAdditionalContourLocationIntersectionPoints>;
  /** Предельные размеры */
  limitDimensions?: InputMaybe<TInputNestedRealestateFileRealestateRecordAdditionalContourLocationLimitDimensions>;
  /** Система координат */
  skId?: InputMaybe<Scalars['String']['input']>;
};

export type TInputNestedRealestateFileRealestateRecordAdditionalContourLocationIntersectionPoints = {
  /** Точка пересечения */
  intersectionPoint?: InputMaybe<Array<InputMaybe<TInputNestedRealestateFileRealestateRecordAdditionalContourLocationIntersectionPointsIntersectionPoint>>>;
  /** Уровень расположения (тип контура) */
  levelContour?: InputMaybe<TInputNestedRealestateFileRealestateRecordAdditionalContourLocationIntersectionPointsLevelContour>;
};

export type TInputNestedRealestateFileRealestateRecordAdditionalContourLocationIntersectionPointsIntersectionPoint = {
  /** Кадастровые номера объектов недвижимости, с контуром которых пересекается контур данного объекта недвижимости */
  intersectionCadNumbers?: InputMaybe<Array<InputMaybe<TInputNestedRealestateFileRealestateRecordAdditionalContourLocationIntersectionPointsIntersectionPointIntersectionCadNumbers>>>;
  /** Описание точки пересечения */
  intersectionOrdinate?: InputMaybe<TInputNestedRealestateFileRealestateRecordAdditionalContourLocationIntersectionPointsIntersectionPointIntersectionOrdinate>;
};

export type TInputNestedRealestateFileRealestateRecordAdditionalContourLocationIntersectionPointsIntersectionPointIntersectionCadNumbers = {
  cadNumber?: InputMaybe<Scalars['String']['input']>;
};

export type TInputNestedRealestateFileRealestateRecordAdditionalContourLocationIntersectionPointsIntersectionPointIntersectionOrdinate = {
  /** Погрешность */
  deltaGeopoint?: InputMaybe<Scalars['Int']['input']>;
  /** Глубина */
  depth?: InputMaybe<Scalars['Int']['input']>;
  /** Высота */
  height?: InputMaybe<Scalars['Int']['input']>;
  /** Номер точки */
  numGeopoint?: InputMaybe<Scalars['String']['input']>;
  /** Координата X */
  x?: InputMaybe<Scalars['Int']['input']>;
  /** Координата Y */
  y?: InputMaybe<Scalars['Int']['input']>;
};

export type TInputNestedRealestateFileRealestateRecordAdditionalContourLocationIntersectionPointsLevelContour = {
  /** код из справочника */
  code?: InputMaybe<Scalars['NumberString']['input']>;
  /** значение */
  value?: InputMaybe<Scalars['String']['input']>;
};

export type TInputNestedRealestateFileRealestateRecordAdditionalContourLocationLimitDimensions = {
  /** Максимальная глубина */
  maxDepth?: InputMaybe<Scalars['Int']['input']>;
  /** Максимальная высота */
  maxHeight?: InputMaybe<Scalars['Int']['input']>;
};

export type TInputNestedRealestateFileRealestateRecordAddress = {
  /** Адрес (местоположение) */
  address?: InputMaybe<TInputNestedRealestateFileRealestateRecordAddressAddress>;
  /** Тип адреса */
  addressType?: InputMaybe<TInputNestedRealestateFileRealestateRecordAddressAddressType>;
  /** Наименования субъектов Российской Федерации, муниципальных образований, населенных пунктов (при наличии) */
  location?: InputMaybe<TInputNestedRealestateFileRealestateRecordAddressLocation>;
  /** Местоположение относительно ориентира */
  relPosition?: InputMaybe<TInputNestedRealestateFileRealestateRecordAddressRelPosition>;
};

export type TInputNestedRealestateFileRealestateRecordAddressAddress = {
  /** Адрес (по справочнику ФИАС) */
  addressFias?: InputMaybe<TInputNestedRealestateFileRealestateRecordAddressAddressAddressFias>;
  /** Неформализованное описание */
  note?: InputMaybe<Scalars['String']['input']>;
  /** Адрес в соответствии с ФИАС */
  readableAddress?: InputMaybe<Scalars['String']['input']>;
};

export type TInputNestedRealestateFileRealestateRecordAddressAddressAddressFias = {
  /** Детализированный уровень */
  detailedLevel?: InputMaybe<TInputNestedRealestateFileRealestateRecordAddressAddressAddressFiasDetailedLevel>;
  /** Уровень населенного пункта */
  levelSettlement?: InputMaybe<TInputNestedRealestateFileRealestateRecordAddressAddressAddressFiasLevelSettlement>;
};

export type TInputNestedRealestateFileRealestateRecordAddressAddressAddressFiasDetailedLevel = {
  /** Квартира */
  apartment?: InputMaybe<TInputNestedRealestateFileRealestateRecordAddressAddressAddressFiasDetailedLevelApartment>;
  /** Дом */
  level1?: InputMaybe<TInputNestedRealestateFileRealestateRecordAddressAddressAddressFiasDetailedLevelLevel1>;
  /** Корпус */
  level2?: InputMaybe<TInputNestedRealestateFileRealestateRecordAddressAddressAddressFiasDetailedLevelLevel2>;
  /** Строение */
  level3?: InputMaybe<TInputNestedRealestateFileRealestateRecordAddressAddressAddressFiasDetailedLevelLevel3>;
  /** Иное описание местоположения */
  other?: InputMaybe<Scalars['String']['input']>;
  /** Улица */
  street?: InputMaybe<TInputNestedRealestateFileRealestateRecordAddressAddressAddressFiasDetailedLevelStreet>;
};

export type TInputNestedRealestateFileRealestateRecordAddressAddressAddressFiasDetailedLevelApartment = {
  name?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
};

export type TInputNestedRealestateFileRealestateRecordAddressAddressAddressFiasDetailedLevelLevel1 = {
  name?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
};

export type TInputNestedRealestateFileRealestateRecordAddressAddressAddressFiasDetailedLevelLevel2 = {
  name?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
};

export type TInputNestedRealestateFileRealestateRecordAddressAddressAddressFiasDetailedLevelLevel3 = {
  name?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
};

export type TInputNestedRealestateFileRealestateRecordAddressAddressAddressFiasDetailedLevelStreet = {
  /** Наименование */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Тип */
  type?: InputMaybe<Scalars['String']['input']>;
};

export type TInputNestedRealestateFileRealestateRecordAddressAddressAddressFiasLevelSettlement = {
  /** Муниципальное образование */
  city?: InputMaybe<TInputNestedRealestateFileRealestateRecordAddressAddressAddressFiasLevelSettlementCity>;
  /** Район */
  district?: InputMaybe<TInputNestedRealestateFileRealestateRecordAddressAddressAddressFiasLevelSettlementDistrict>;
  fias?: InputMaybe<Scalars['String']['input']>;
  kladr?: InputMaybe<Scalars['String']['input']>;
  /** Населенный пункт */
  locality?: InputMaybe<TInputNestedRealestateFileRealestateRecordAddressAddressAddressFiasLevelSettlementLocality>;
  okato?: InputMaybe<Scalars['String']['input']>;
  oktmo?: InputMaybe<Scalars['String']['input']>;
  /** Почтовый индекс */
  postalCode?: InputMaybe<Scalars['PostalCode']['input']>;
  /** Код региона */
  region?: InputMaybe<TInputNestedRealestateFileRealestateRecordAddressAddressAddressFiasLevelSettlementRegion>;
  /** Сельсовет */
  sovietVillage?: InputMaybe<TInputNestedRealestateFileRealestateRecordAddressAddressAddressFiasLevelSettlementSovietVillage>;
  /** Городской район */
  urbanDistrict?: InputMaybe<TInputNestedRealestateFileRealestateRecordAddressAddressAddressFiasLevelSettlementUrbanDistrict>;
};

export type TInputNestedRealestateFileRealestateRecordAddressAddressAddressFiasLevelSettlementCity = {
  /** Наименование */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Тип */
  type?: InputMaybe<Scalars['String']['input']>;
};

export type TInputNestedRealestateFileRealestateRecordAddressAddressAddressFiasLevelSettlementDistrict = {
  /** Наименование */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Тип */
  type?: InputMaybe<Scalars['String']['input']>;
};

export type TInputNestedRealestateFileRealestateRecordAddressAddressAddressFiasLevelSettlementLocality = {
  /** Наименование */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Тип */
  type?: InputMaybe<Scalars['String']['input']>;
};

export type TInputNestedRealestateFileRealestateRecordAddressAddressAddressFiasLevelSettlementRegion = {
  /** код из справочника */
  code?: InputMaybe<Scalars['NumberString']['input']>;
  /** значение */
  value?: InputMaybe<Scalars['String']['input']>;
};

export type TInputNestedRealestateFileRealestateRecordAddressAddressAddressFiasLevelSettlementSovietVillage = {
  /** Наименование */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Тип */
  type?: InputMaybe<Scalars['String']['input']>;
};

export type TInputNestedRealestateFileRealestateRecordAddressAddressAddressFiasLevelSettlementUrbanDistrict = {
  /** Наименование */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Тип */
  type?: InputMaybe<Scalars['String']['input']>;
};

export type TInputNestedRealestateFileRealestateRecordAddressAddressType = {
  /** код из справочника */
  code?: InputMaybe<Scalars['NumberString']['input']>;
  /** значение */
  value?: InputMaybe<Scalars['String']['input']>;
};

export type TInputNestedRealestateFileRealestateRecordAddressLocation = {
  /** Муниципальное образование */
  city?: InputMaybe<TInputNestedRealestateFileRealestateRecordAddressLocationCity>;
  /** Район */
  district?: InputMaybe<TInputNestedRealestateFileRealestateRecordAddressLocationDistrict>;
  fias?: InputMaybe<Scalars['String']['input']>;
  kladr?: InputMaybe<Scalars['String']['input']>;
  /** Населенный пункт */
  locality?: InputMaybe<TInputNestedRealestateFileRealestateRecordAddressLocationLocality>;
  okato?: InputMaybe<Scalars['String']['input']>;
  oktmo?: InputMaybe<Scalars['String']['input']>;
  /** Почтовый индекс */
  postalCode?: InputMaybe<Scalars['PostalCode']['input']>;
  /** Код региона */
  region?: InputMaybe<TInputNestedRealestateFileRealestateRecordAddressLocationRegion>;
  /** Сельсовет */
  sovietVillage?: InputMaybe<TInputNestedRealestateFileRealestateRecordAddressLocationSovietVillage>;
  /** Городской район */
  urbanDistrict?: InputMaybe<TInputNestedRealestateFileRealestateRecordAddressLocationUrbanDistrict>;
};

export type TInputNestedRealestateFileRealestateRecordAddressLocationCity = {
  /** Наименование */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Тип */
  type?: InputMaybe<Scalars['String']['input']>;
};

export type TInputNestedRealestateFileRealestateRecordAddressLocationDistrict = {
  /** Наименование */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Тип */
  type?: InputMaybe<Scalars['String']['input']>;
};

export type TInputNestedRealestateFileRealestateRecordAddressLocationLocality = {
  /** Наименование */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Тип */
  type?: InputMaybe<Scalars['String']['input']>;
};

export type TInputNestedRealestateFileRealestateRecordAddressLocationRegion = {
  /** код из справочника */
  code?: InputMaybe<Scalars['NumberString']['input']>;
  /** значение */
  value?: InputMaybe<Scalars['String']['input']>;
};

export type TInputNestedRealestateFileRealestateRecordAddressLocationSovietVillage = {
  /** Наименование */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Тип */
  type?: InputMaybe<Scalars['String']['input']>;
};

export type TInputNestedRealestateFileRealestateRecordAddressLocationUrbanDistrict = {
  /** Наименование */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Тип */
  type?: InputMaybe<Scalars['String']['input']>;
};

export type TInputNestedRealestateFileRealestateRecordAddressRelPosition = {
  /** Ориентир расположен в границах участка */
  inBoundariesMark?: InputMaybe<Scalars['Boolean']['input']>;
  /** Расположение относительно ориентира */
  locationDescription?: InputMaybe<Scalars['String']['input']>;
  /** Наименование ориентира */
  refPointName?: InputMaybe<Scalars['String']['input']>;
};

export type TInputNestedRealestateFileRealestateRecordApartmentBuilding = {
  /** Основание создания наемного дома */
  basisHiredHouse?: InputMaybe<TInputNestedRealestateFileRealestateRecordApartmentBuildingBasisHiredHouse>;
  /** Назначение участка под наемный дом */
  purposeHiredHome?: InputMaybe<TInputNestedRealestateFileRealestateRecordApartmentBuildingPurposeHiredHome>;
  /** Вид использования наемного дома */
  useApartBuild?: InputMaybe<TInputNestedRealestateFileRealestateRecordApartmentBuildingUseApartBuild>;
};

export type TInputNestedRealestateFileRealestateRecordApartmentBuildingBasisHiredHouse = {
  /** Акт о предоставлении */
  act?: InputMaybe<TInputNestedRealestateFileRealestateRecordApartmentBuildingBasisHiredHouseAct>;
  /** Договор */
  contract?: InputMaybe<TInputNestedRealestateFileRealestateRecordApartmentBuildingBasisHiredHouseContract>;
  /** Договор собственника */
  contractOwner?: InputMaybe<TInputNestedRealestateFileRealestateRecordApartmentBuildingBasisHiredHouseContractOwner>;
  /** Решение собственника */
  decisionOwner?: InputMaybe<TInputNestedRealestateFileRealestateRecordApartmentBuildingBasisHiredHouseDecisionOwner>;
};

export type TInputNestedRealestateFileRealestateRecordApartmentBuildingBasisHiredHouseAct = {
  /** Код документа */
  code?: InputMaybe<TInputNestedRealestateFileRealestateRecordApartmentBuildingBasisHiredHouseActCode>;
  /** Дата документа */
  date?: InputMaybe<Scalars['String']['input']>;
  /** Орган власти, организация, выдавшие документ. Автор документа */
  issuer?: InputMaybe<Scalars['String']['input']>;
  /** Номер документа */
  number?: InputMaybe<Scalars['String']['input']>;
};

export type TInputNestedRealestateFileRealestateRecordApartmentBuildingBasisHiredHouseActCode = {
  /** код из справочника */
  code?: InputMaybe<Scalars['NumberString']['input']>;
  /** значение */
  value?: InputMaybe<Scalars['String']['input']>;
};

export type TInputNestedRealestateFileRealestateRecordApartmentBuildingBasisHiredHouseContract = {
  /** Код документа */
  code?: InputMaybe<TInputNestedRealestateFileRealestateRecordApartmentBuildingBasisHiredHouseContractCode>;
  /** Стороны договора */
  contractors?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Дата документа */
  date?: InputMaybe<Scalars['String']['input']>;
  /** Орган власти, организация, выдавшие документ. Автор документа */
  issuer?: InputMaybe<Scalars['String']['input']>;
  /** Номер документа */
  number?: InputMaybe<Scalars['String']['input']>;
};

export type TInputNestedRealestateFileRealestateRecordApartmentBuildingBasisHiredHouseContractCode = {
  /** код из справочника */
  code?: InputMaybe<Scalars['NumberString']['input']>;
  /** значение */
  value?: InputMaybe<Scalars['String']['input']>;
};

export type TInputNestedRealestateFileRealestateRecordApartmentBuildingBasisHiredHouseContractOwner = {
  /** Код документа */
  code?: InputMaybe<TInputNestedRealestateFileRealestateRecordApartmentBuildingBasisHiredHouseContractOwnerCode>;
  /** Стороны договора */
  contractors?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Дата документа */
  date?: InputMaybe<Scalars['String']['input']>;
  /** Орган власти, организация, выдавшие документ. Автор документа */
  issuer?: InputMaybe<Scalars['String']['input']>;
  /** Номер документа */
  number?: InputMaybe<Scalars['String']['input']>;
};

export type TInputNestedRealestateFileRealestateRecordApartmentBuildingBasisHiredHouseContractOwnerCode = {
  /** код из справочника */
  code?: InputMaybe<Scalars['NumberString']['input']>;
  /** значение */
  value?: InputMaybe<Scalars['String']['input']>;
};

export type TInputNestedRealestateFileRealestateRecordApartmentBuildingBasisHiredHouseDecisionOwner = {
  /** Код документа */
  code?: InputMaybe<TInputNestedRealestateFileRealestateRecordApartmentBuildingBasisHiredHouseDecisionOwnerCode>;
  /** Дата документа */
  date?: InputMaybe<Scalars['String']['input']>;
  /** Орган власти, организация, выдавшие документ. Автор документа */
  issuer?: InputMaybe<Scalars['String']['input']>;
  /** Номер документа */
  number?: InputMaybe<Scalars['String']['input']>;
};

export type TInputNestedRealestateFileRealestateRecordApartmentBuildingBasisHiredHouseDecisionOwnerCode = {
  /** код из справочника */
  code?: InputMaybe<Scalars['NumberString']['input']>;
  /** значение */
  value?: InputMaybe<Scalars['String']['input']>;
};

export type TInputNestedRealestateFileRealestateRecordApartmentBuildingPurposeHiredHome = {
  /** код из справочника */
  code?: InputMaybe<Scalars['NumberString']['input']>;
  /** значение */
  value?: InputMaybe<Scalars['String']['input']>;
};

export type TInputNestedRealestateFileRealestateRecordApartmentBuildingUseApartBuild = {
  /** код из справочника */
  code?: InputMaybe<Scalars['NumberString']['input']>;
  /** значение */
  value?: InputMaybe<Scalars['String']['input']>;
};

export type TInputNestedRealestateFileRealestateRecordCadLinks = {
  /** Кадастровые номера земельных участков, из которых образован данный земельный участок */
  ascendantCadNumbers?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Кадастровые номера машиномест, расположенных в объекте недвижимости */
  carParkingSpaceCadNumbers?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Единое землепользование */
  commonLand?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Кадастровые номера земельных участков, образованных из данного земельного участка */
  descendantCadNumbers?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Кадастровый номер предприятия как имущественного комплекса, в состав которого входит земельный участок */
  facilityCadNumber?: InputMaybe<Scalars['String']['input']>;
  /** Кадастровые номера объектов недвижимости, входящих в состав единого недвижимого комплекса */
  includedCadNumbers?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Кадастровые номера расположенных в пределах земельного участка объектов недвижимости */
  includedObjects?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Кадастровые номера иных объектов недвижимости (земельных участков), в пределах которых расположен объект недвижимости */
  landCadNumbers?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Ранее присвоенные номера */
  oldNumbers?: InputMaybe<Array<InputMaybe<TInputNestedRealestateFileRealestateRecordCadLinksOldNumbers>>>;
  parentCadNumber?: InputMaybe<Scalars['String']['input']>;
  /** Кадастровые номера помещений, расположенных в объекте недвижимости */
  roomCadNumbers?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type TInputNestedRealestateFileRealestateRecordCadLinksOldNumbers = {
  /** Организация, присвоившая номер */
  assigner?: InputMaybe<Scalars['String']['input']>;
  /** Дата присвоения */
  assignmentDate?: InputMaybe<Scalars['String']['input']>;
  /** Номер */
  number?: InputMaybe<Scalars['String']['input']>;
  /** Вид номера */
  numberType?: InputMaybe<TInputNestedRealestateFileRealestateRecordCadLinksOldNumbersNumberType>;
};

export type TInputNestedRealestateFileRealestateRecordCadLinksOldNumbersNumberType = {
  /** код из справочника */
  code?: InputMaybe<Scalars['NumberString']['input']>;
  /** значение */
  value?: InputMaybe<Scalars['String']['input']>;
};

export type TInputNestedRealestateFileRealestateRecordCadWorks = {
  /** Номер заключения договора на выполнение кадастровых работ */
  cadastralEngineerAgreement?: InputMaybe<Scalars['String']['input']>;
  /** Дата заключения договора на выполнение кадастровых работ */
  cadastralEngineerDate?: InputMaybe<Scalars['String']['input']>;
  /** Номер регистрации в государственном реестре лиц, осуществляющих кадастровую деятельность */
  cadastralEngineerRegistryNumber?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  middleName?: InputMaybe<Scalars['String']['input']>;
  /** Вид выполненных кадастровых работ */
  workType?: InputMaybe<Scalars['String']['input']>;
};

export type TInputNestedRealestateFileRealestateRecordContours = {
  /** Описание элементов контура (характерных точек контура) */
  entitySpatial?: InputMaybe<TInputNestedRealestateFileRealestateRecordContoursEntitySpatial>;
  /** Номер контура */
  numberPp?: InputMaybe<Scalars['Int']['input']>;
};

export type TInputNestedRealestateFileRealestateRecordContoursEntitySpatial = {
  /** Система координат */
  skId?: InputMaybe<Scalars['String']['input']>;
  /** Элементы контура */
  spatialsElements?: InputMaybe<Array<InputMaybe<TInputNestedRealestateFileRealestateRecordContoursEntitySpatialSpatialsElements>>>;
};

export type TInputNestedRealestateFileRealestateRecordContoursEntitySpatialSpatialsElements = {
  /** Тип контура */
  levelContour?: InputMaybe<TInputNestedRealestateFileRealestateRecordContoursEntitySpatialSpatialsElementsLevelContour>;
  /** Список координат */
  ordinates?: InputMaybe<Array<InputMaybe<TInputNestedRealestateFileRealestateRecordContoursEntitySpatialSpatialsElementsOrdinates>>>;
};

export type TInputNestedRealestateFileRealestateRecordContoursEntitySpatialSpatialsElementsLevelContour = {
  /** код из справочника */
  code?: InputMaybe<Scalars['NumberString']['input']>;
  /** значение */
  value?: InputMaybe<Scalars['String']['input']>;
};

export type TInputNestedRealestateFileRealestateRecordContoursEntitySpatialSpatialsElementsOrdinates = {
  /** Погрешность */
  deltaGeopoint?: InputMaybe<Scalars['Int']['input']>;
  /** Номер точки */
  numGeopoint?: InputMaybe<Scalars['String']['input']>;
  /** Номер точки (порядок обхода) */
  ordNmb?: InputMaybe<Scalars['Int']['input']>;
  /** Радиус */
  r?: InputMaybe<Scalars['Int']['input']>;
  /** Координата X */
  x?: InputMaybe<Scalars['Int']['input']>;
  /** Координата Y */
  y?: InputMaybe<Scalars['Int']['input']>;
  /** Координата Z */
  z?: InputMaybe<Scalars['Int']['input']>;
};

export type TInputNestedRealestateFileRealestateRecordContoursLocation = {
  /** Описание границ земельного участка (от точки до точки) и наличие земельного спора */
  borders?: InputMaybe<Array<InputMaybe<TInputNestedRealestateFileRealestateRecordContoursLocationBorders>>>;
  /** Контуры границы */
  contours?: InputMaybe<Array<InputMaybe<TInputNestedRealestateFileRealestateRecordContoursLocationContours>>>;
};

export type TInputNestedRealestateFileRealestateRecordContoursLocationBorders = {
  /** Часть границы (от точки до точки) по описанию */
  byDefinition?: InputMaybe<Array<InputMaybe<TInputNestedRealestateFileRealestateRecordContoursLocationBordersByDefinition>>>;
  /** Кадастровые номера смежных участков */
  cadastralNumbsAdjacentParcels?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Дирекционный угол */
  directionAngle?: InputMaybe<Scalars['String']['input']>;
  /** Описание закрепления на местности */
  geopointZacrep?: InputMaybe<Scalars['String']['input']>;
  /** Адреса правообладателей смежных земельных участков */
  holdersRelatedLands?: InputMaybe<Array<InputMaybe<TInputNestedRealestateFileRealestateRecordContoursLocationBordersHoldersRelatedLands>>>;
  /** Горизонтальное положение */
  horizontalDistance?: InputMaybe<Scalars['String']['input']>;
  /** Земельный спор */
  landDisput?: InputMaybe<TInputNestedRealestateFileRealestateRecordContoursLocationBordersLandDisput>;
};

export type TInputNestedRealestateFileRealestateRecordContoursLocationBordersByDefinition = {
  /** Описание границы */
  definition?: InputMaybe<Scalars['String']['input']>;
  /** Номер контура */
  nmbContour?: InputMaybe<Scalars['String']['input']>;
  /** Порядковый номер точки1 в элементе */
  point1?: InputMaybe<Scalars['Int']['input']>;
  /** Порядковый номер точки2 в элементе */
  point2?: InputMaybe<Scalars['Int']['input']>;
  /** Порядковый номер элемента контура */
  spatialElement?: InputMaybe<Scalars['String']['input']>;
};

export type TInputNestedRealestateFileRealestateRecordContoursLocationBordersHoldersRelatedLands = {
  email?: InputMaybe<Scalars['String']['input']>;
  /** ! Возможно в документации ошибка: mailing_addess */
  mailingAddress?: InputMaybe<Scalars['String']['input']>;
};

export type TInputNestedRealestateFileRealestateRecordContoursLocationBordersLandDisput = {
  /** Реквизиты акта об утверждении карты-плана территории */
  approovalActRequisites?: InputMaybe<TInputNestedRealestateFileRealestateRecordContoursLocationBordersLandDisputApproovalActRequisites>;
  /** Дата окончания контрольного срока действия отметки о наличии земельного спора */
  disputeCancelDate?: InputMaybe<Scalars['String']['input']>;
  /** Учетный номер контура */
  numberContour?: InputMaybe<Scalars['String']['input']>;
};

export type TInputNestedRealestateFileRealestateRecordContoursLocationBordersLandDisputApproovalActRequisites = {
  /** Код документа */
  code?: InputMaybe<TInputNestedRealestateFileRealestateRecordContoursLocationBordersLandDisputApproovalActRequisitesCode>;
  /** Дата документа */
  date?: InputMaybe<Scalars['String']['input']>;
  /** Орган власти, организация, выдавшие документ. Автор документа */
  issuer?: InputMaybe<Scalars['String']['input']>;
  /** Номер документа */
  number?: InputMaybe<Scalars['String']['input']>;
};

export type TInputNestedRealestateFileRealestateRecordContoursLocationBordersLandDisputApproovalActRequisitesCode = {
  /** код из справочника */
  code?: InputMaybe<Scalars['NumberString']['input']>;
  /** значение */
  value?: InputMaybe<Scalars['String']['input']>;
};

export type TInputNestedRealestateFileRealestateRecordContoursLocationContours = {
  /** Площадь контура в квадратных метрах */
  area?: InputMaybe<Scalars['Float']['input']>;
  /** Кадастровый номер участка, входящего в состав единого землепользования */
  cadNumber?: InputMaybe<Scalars['String']['input']>;
  /** Описание элементов контура (характерных точек контура) */
  entitySpatial?: InputMaybe<TInputNestedRealestateFileRealestateRecordContoursLocationContoursEntitySpatial>;
  /** Номер контура */
  numberPp?: InputMaybe<Scalars['Int']['input']>;
};

export type TInputNestedRealestateFileRealestateRecordContoursLocationContoursEntitySpatial = {
  /** Система координат */
  skId?: InputMaybe<Scalars['String']['input']>;
  /** Координаты */
  spatialsElements?: InputMaybe<Array<InputMaybe<TInputNestedRealestateFileRealestateRecordContoursLocationContoursEntitySpatialSpatialsElements>>>;
};

export type TInputNestedRealestateFileRealestateRecordContoursLocationContoursEntitySpatialSpatialsElements = {
  /** Погрешность */
  deltaGeopoint?: InputMaybe<Scalars['Int']['input']>;
  /** Описание закрепления точки */
  geopointZacrep?: InputMaybe<Scalars['String']['input']>;
  /** Номер межевой точки */
  numGeopoint?: InputMaybe<Scalars['String']['input']>;
  /** Номер точки (порядок обхода) */
  ordNmb?: InputMaybe<Scalars['Int']['input']>;
  /** Координата X */
  x?: InputMaybe<Scalars['Int']['input']>;
  /** Координата Y */
  y?: InputMaybe<Scalars['Int']['input']>;
  /** Координата Z */
  z?: InputMaybe<Scalars['Int']['input']>;
};

export type TInputNestedRealestateFileRealestateRecordCulturalHeritage = {
  /** Реквизиты решений */
  heritageDecisions?: InputMaybe<Array<InputMaybe<TInputNestedRealestateFileRealestateRecordCulturalHeritageHeritageDecisions>>>;
  /** Включен в реестр объектов культурного наследия или является выявленным объектом */
  included?: InputMaybe<Scalars['Boolean']['input']>;
  /** Вид объекта */
  kind?: InputMaybe<TInputNestedRealestateFileRealestateRecordCulturalHeritageKind>;
  /** Наименование объекта */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Регистрационный номер (регистрационный номер учетной карты) */
  regNumber?: InputMaybe<Scalars['String']['input']>;
};

export type TInputNestedRealestateFileRealestateRecordCulturalHeritageHeritageDecisions = {
  /** Дата документа */
  date?: InputMaybe<Scalars['String']['input']>;
  /** Номер документа */
  number?: InputMaybe<Scalars['String']['input']>;
};

export type TInputNestedRealestateFileRealestateRecordCulturalHeritageKind = {
  /** код из справочника */
  code?: InputMaybe<Scalars['NumberString']['input']>;
  /** значение */
  value?: InputMaybe<Scalars['String']['input']>;
};

export type TInputNestedRealestateFileRealestateRecordGovernmentLandSupervision = {
  /** Наименование органа, проводившего мероприятие по государственному земельному надзору */
  agency?: InputMaybe<Scalars['String']['input']>;
  /** Реквизиты оформленных документов */
  docRequisites?: InputMaybe<Array<InputMaybe<TInputNestedRealestateFileRealestateRecordGovernmentLandSupervisionDocRequisites>>>;
  /** Сведения об устранении выявленного нарушения */
  elimination?: InputMaybe<TInputNestedRealestateFileRealestateRecordGovernmentLandSupervisionElimination>;
  /** Реквизиты документа, содержащего сведения об устранении правонарушения */
  eliminationDocRequisites?: InputMaybe<TInputNestedRealestateFileRealestateRecordGovernmentLandSupervisionEliminationDocRequisites>;
  /** Форма проведения плановой или внеплановой проверки */
  eventForm?: InputMaybe<TInputNestedRealestateFileRealestateRecordGovernmentLandSupervisionEventForm>;
  /** Мероприятие государственного земельного надзора по соблюдению требований законодательства (плановая, внеплановая проверка, административное обследование) */
  eventName?: InputMaybe<TInputNestedRealestateFileRealestateRecordGovernmentLandSupervisionEventName>;
  /** Дата окончания проверки */
  inspectionEnd?: InputMaybe<Scalars['String']['input']>;
  /** Результаты проведенного мероприятия */
  resultsEvent?: InputMaybe<TInputNestedRealestateFileRealestateRecordGovernmentLandSupervisionResultsEvent>;
};

export type TInputNestedRealestateFileRealestateRecordGovernmentLandSupervisionDocRequisites = {
  /** Дата документа */
  date?: InputMaybe<Scalars['String']['input']>;
  /** Номер документа */
  number?: InputMaybe<Scalars['String']['input']>;
};

export type TInputNestedRealestateFileRealestateRecordGovernmentLandSupervisionElimination = {
  /** Наименование органа, принявшего решение об устранении правонарушения */
  agency?: InputMaybe<Scalars['String']['input']>;
  /** Отметка об устранении выявленного нарушения: устранено */
  mark?: InputMaybe<Scalars['Boolean']['input']>;
};

export type TInputNestedRealestateFileRealestateRecordGovernmentLandSupervisionEliminationDocRequisites = {
  /** Дата документа */
  date?: InputMaybe<Scalars['String']['input']>;
  /** Номер документа */
  number?: InputMaybe<Scalars['String']['input']>;
};

export type TInputNestedRealestateFileRealestateRecordGovernmentLandSupervisionEventForm = {
  /** код из справочника */
  code?: InputMaybe<Scalars['NumberString']['input']>;
  /** значение */
  value?: InputMaybe<Scalars['String']['input']>;
};

export type TInputNestedRealestateFileRealestateRecordGovernmentLandSupervisionEventName = {
  /** код из справочника */
  code?: InputMaybe<Scalars['NumberString']['input']>;
  /** значение */
  value?: InputMaybe<Scalars['String']['input']>;
};

export type TInputNestedRealestateFileRealestateRecordGovernmentLandSupervisionResultsEvent = {
  /** Наличие правонарушения */
  availabilityViolations?: InputMaybe<Scalars['Boolean']['input']>;
  /** Выявленные правонарушения */
  identifiedViolations?: InputMaybe<TInputNestedRealestateFileRealestateRecordGovernmentLandSupervisionResultsEventIdentifiedViolations>;
};

export type TInputNestedRealestateFileRealestateRecordGovernmentLandSupervisionResultsEventIdentifiedViolations = {
  /** Площадь */
  area?: InputMaybe<Scalars['Float']['input']>;
  /** Признаки выявленного правонарушения */
  sign?: InputMaybe<Scalars['String']['input']>;
  /** Вид выявленного правонарушения */
  type?: InputMaybe<Scalars['String']['input']>;
};

export type TInputNestedRealestateFileRealestateRecordLocationInBuild = {
  /** Описание расположения */
  description?: InputMaybe<Scalars['String']['input']>;
  /** Номер этажа */
  floor?: InputMaybe<Scalars['Int']['input']>;
  /** Тип этажа */
  floorType?: InputMaybe<TInputNestedRealestateFileRealestateRecordLocationInBuildFloorType>;
  /** Номер на поэтажном плане */
  planNumber?: InputMaybe<Scalars['String']['input']>;
  /** Планы */
  plans?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type TInputNestedRealestateFileRealestateRecordLocationInBuildFloorType = {
  /** код из справочника */
  code?: InputMaybe<Scalars['NumberString']['input']>;
  /** значение */
  value?: InputMaybe<Scalars['String']['input']>;
};

export type TInputNestedRealestateFileRealestateRecordNaturalObjects = {
  /** Лесные объекты */
  forests?: InputMaybe<Array<InputMaybe<TInputNestedRealestateFileRealestateRecordNaturalObjectsForests>>>;
  /** Иные природные объекты */
  otherNaturalObjects?: InputMaybe<Array<InputMaybe<TInputNestedRealestateFileRealestateRecordNaturalObjectsOtherNaturalObjects>>>;
  /** Водные объекты */
  waters?: InputMaybe<Array<InputMaybe<TInputNestedRealestateFileRealestateRecordNaturalObjectsWaters>>>;
};

export type TInputNestedRealestateFileRealestateRecordNaturalObjectsForests = {
  /** Категория защитных лесов */
  forestCategory?: InputMaybe<TInputNestedRealestateFileRealestateRecordNaturalObjectsForestsForestCategory>;
  /** Целевое назначение (категория) лесов */
  forestPurpose?: InputMaybe<TInputNestedRealestateFileRealestateRecordNaturalObjectsForestsForestPurpose>;
  /** Номера лесных кварталов */
  forestQuarters?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  /** Наименование лесничества, лесопарка, участкового лесничества */
  forestry?: InputMaybe<Scalars['String']['input']>;
};

export type TInputNestedRealestateFileRealestateRecordNaturalObjectsForestsForestCategory = {
  /** код из справочника */
  code?: InputMaybe<Scalars['NumberString']['input']>;
  /** значение */
  value?: InputMaybe<Scalars['String']['input']>;
};

export type TInputNestedRealestateFileRealestateRecordNaturalObjectsForestsForestPurpose = {
  /** код из справочника */
  code?: InputMaybe<Scalars['NumberString']['input']>;
  /** значение */
  value?: InputMaybe<Scalars['String']['input']>;
};

export type TInputNestedRealestateFileRealestateRecordNaturalObjectsOtherNaturalObjects = {
  /** Наименование */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Назначение */
  purpose?: InputMaybe<Scalars['String']['input']>;
};

export type TInputNestedRealestateFileRealestateRecordNaturalObjectsWaters = {
  /** Наименование водного объекта */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Вид (тип) водного объекта */
  type?: InputMaybe<TInputNestedRealestateFileRealestateRecordNaturalObjectsWatersType>;
};

export type TInputNestedRealestateFileRealestateRecordNaturalObjectsWatersType = {
  /** код из справочника */
  code?: InputMaybe<Scalars['NumberString']['input']>;
  /** значение */
  value?: InputMaybe<Scalars['String']['input']>;
};

export type TInputNestedRealestateFileRealestateRecordObject = {
  /** Общие сведения о земельном участке */
  commonData: TInputNestedRealestateFileRealestateRecordObjectCommonData;
  /** Сведения об образовании земельного участка (на основании решения об изъятии, или из земель или земельных участков, государственная собственность на которые не разграничена) */
  dateRemovedCadAccount?: InputMaybe<TInputNestedRealestateFileRealestateRecordObjectDateRemovedCadAccount>;
  /** Дата постановки по документу */
  regDateByDoc?: InputMaybe<Scalars['String']['input']>;
  /** Вид земельного участка */
  subtype?: InputMaybe<TInputNestedRealestateFileRealestateRecordObjectSubtype>;
};

export type TInputNestedRealestateFileRealestateRecordObjectCommonData = {
  /** Кадастровый номер */
  cadNumber: Scalars['String']['input'];
  /** Номер кадастрового квартала */
  quarterCadNumber?: InputMaybe<Scalars['String']['input']>;
  /** Вид объекта недвижимости */
  type?: InputMaybe<TInputNestedRealestateFileRealestateRecordObjectCommonDataType>;
};

export type TInputNestedRealestateFileRealestateRecordObjectCommonDataType = {
  /** код из справочника */
  code?: InputMaybe<Scalars['NumberString']['input']>;
  /** значение */
  value?: InputMaybe<Scalars['String']['input']>;
};

export type TInputNestedRealestateFileRealestateRecordObjectDateRemovedCadAccount = {
  /** Сведения об образовании земельного участка из земель или земельных участков, государственная собственность на которые не разграничена */
  formLandStateNotDifferentiated?: InputMaybe<TInputNestedRealestateFileRealestateRecordObjectDateRemovedCadAccountFormLandStateNotDifferentiated>;
  /** Сведения об образовании земельного участка на основании решения об изъятии объекта недвижимости для государственных и муниципальных нужд (реквизиты решения) */
  withdrawalStateMunicNeeds?: InputMaybe<TInputNestedRealestateFileRealestateRecordObjectDateRemovedCadAccountWithdrawalStateMunicNeeds>;
};

export type TInputNestedRealestateFileRealestateRecordObjectDateRemovedCadAccountFormLandStateNotDifferentiated = {
  /** Дата снятия с учета */
  dateRemove?: InputMaybe<Scalars['String']['input']>;
  /** Наименование уполномоченного органа */
  nameAuthority?: InputMaybe<Scalars['String']['input']>;
};

export type TInputNestedRealestateFileRealestateRecordObjectDateRemovedCadAccountWithdrawalStateMunicNeeds = {
  /** Код документа */
  code?: InputMaybe<TInputNestedRealestateFileRealestateRecordObjectDateRemovedCadAccountWithdrawalStateMunicNeedsCode>;
  /** Дата документа */
  date?: InputMaybe<Scalars['String']['input']>;
  /** Орган власти, организация, выдавшие документ. Автор документа */
  issuer?: InputMaybe<Scalars['String']['input']>;
  /** Номер документа */
  number?: InputMaybe<Scalars['String']['input']>;
};

export type TInputNestedRealestateFileRealestateRecordObjectDateRemovedCadAccountWithdrawalStateMunicNeedsCode = {
  /** код из справочника */
  code?: InputMaybe<Scalars['NumberString']['input']>;
  /** значение */
  value?: InputMaybe<Scalars['String']['input']>;
};

export type TInputNestedRealestateFileRealestateRecordObjectParts = {
  /** Площадь || Площадь, в кв. метрах */
  area?: InputMaybe<TInputNestedRealestateFileRealestateRecordObjectPartsArea>;
  /** Содержание ограничений */
  contentRestrictions?: InputMaybe<TInputNestedRealestateFileRealestateRecordObjectPartsContentRestrictions>;
  /** Описание местоположения границ */
  contours?: InputMaybe<Array<InputMaybe<TInputNestedRealestateFileRealestateRecordObjectPartsContours>>>;
  /** Примечание */
  footnote?: InputMaybe<Scalars['String']['input']>;
  /** Местоположение части здания */
  locationBuilding?: InputMaybe<TInputNestedRealestateFileRealestateRecordObjectPartsLocationBuilding>;
  /** Порядковый номер части */
  partNumber?: InputMaybe<Scalars['Int']['input']>;
};

export type TInputNestedRealestateFileRealestateRecordObjectPartsArea = {
  /** код из справочника */
  code?: InputMaybe<Scalars['NumberString']['input']>;
  /** значение */
  value?: InputMaybe<Scalars['Float']['input']>;
};

export type TInputNestedRealestateFileRealestateRecordObjectPartsContentRestrictions = {
  /** Сведения о регистрации */
  dataRegistration?: InputMaybe<TInputNestedRealestateFileRealestateRecordObjectPartsContentRestrictionsDataRegistration>;
  /** Реестровый номер границы */
  regNumbBorder?: InputMaybe<TInputNestedRealestateFileRealestateRecordObjectPartsContentRestrictionsRegNumbBorder>;
};

export type TInputNestedRealestateFileRealestateRecordObjectPartsContentRestrictionsDataRegistration = {
  /** Дата регистрации */
  registrationDate?: InputMaybe<Scalars['String']['input']>;
  /** Номер регистрации/реестровой записи */
  restrictionEncumbranceNumber?: InputMaybe<TInputNestedRealestateFileRealestateRecordObjectPartsContentRestrictionsDataRegistrationRestrictionEncumbranceNumber>;
};

export type TInputNestedRealestateFileRealestateRecordObjectPartsContentRestrictionsDataRegistrationRestrictionEncumbranceNumber = {
  /** Номер реестровой записи */
  number?: InputMaybe<Scalars['String']['input']>;
  /** Номер регистрации ограничения права или обременения ОН */
  rightNumber?: InputMaybe<Scalars['String']['input']>;
};

export type TInputNestedRealestateFileRealestateRecordObjectPartsContentRestrictionsRegNumbBorder = {
  regNumber?: InputMaybe<Scalars['String']['input']>;
};

export type TInputNestedRealestateFileRealestateRecordObjectPartsContours = {
  /** Описание элементов контура (характерных точек контура) */
  entitySpatial?: InputMaybe<TInputNestedRealestateFileRealestateRecordObjectPartsContoursEntitySpatial>;
  /** Номер контура */
  numberPp?: InputMaybe<Scalars['Int']['input']>;
};

export type TInputNestedRealestateFileRealestateRecordObjectPartsContoursEntitySpatial = {
  /** Система координат */
  skId?: InputMaybe<Scalars['String']['input']>;
  /** Координаты */
  spatialsElements?: InputMaybe<Array<InputMaybe<TInputNestedRealestateFileRealestateRecordObjectPartsContoursEntitySpatialSpatialsElements>>>;
};

export type TInputNestedRealestateFileRealestateRecordObjectPartsContoursEntitySpatialSpatialsElements = {
  /** Погрешность */
  deltaGeopoint?: InputMaybe<Scalars['Int']['input']>;
  /** Описание закрепления точки */
  geopointZacrep?: InputMaybe<Scalars['String']['input']>;
  /** Номер межевой точки */
  numGeopoint?: InputMaybe<Scalars['String']['input']>;
  /** Номер точки (порядок обхода) */
  ordNmb?: InputMaybe<Scalars['Int']['input']>;
  /** Координата X */
  x?: InputMaybe<Scalars['Int']['input']>;
  /** Координата Y */
  y?: InputMaybe<Scalars['Int']['input']>;
  /** Координата Z */
  z?: InputMaybe<Scalars['Int']['input']>;
};

export type TInputNestedRealestateFileRealestateRecordObjectPartsLocationBuilding = {
  /** Описание местоположения контура */
  contours?: InputMaybe<Array<InputMaybe<TInputNestedRealestateFileRealestateRecordObjectPartsLocationBuildingContours>>>;
  /** Расположение в пределах объекта недвижимости */
  inBuild?: InputMaybe<Array<InputMaybe<TInputNestedRealestateFileRealestateRecordObjectPartsLocationBuildingInBuild>>>;
};

export type TInputNestedRealestateFileRealestateRecordObjectPartsLocationBuildingContours = {
  /** Описание элементов контура (характерных точек контура) */
  entitySpatial?: InputMaybe<TInputNestedRealestateFileRealestateRecordObjectPartsLocationBuildingContoursEntitySpatial>;
  /** Номер контура */
  numberPp?: InputMaybe<Scalars['Int']['input']>;
};

export type TInputNestedRealestateFileRealestateRecordObjectPartsLocationBuildingContoursEntitySpatial = {
  /** Система координат */
  skId?: InputMaybe<Scalars['String']['input']>;
  /** Элементы контура */
  spatialsElements?: InputMaybe<Array<InputMaybe<TInputNestedRealestateFileRealestateRecordObjectPartsLocationBuildingContoursEntitySpatialSpatialsElements>>>;
};

export type TInputNestedRealestateFileRealestateRecordObjectPartsLocationBuildingContoursEntitySpatialSpatialsElements = {
  /** Тип контура */
  levelContour?: InputMaybe<TInputNestedRealestateFileRealestateRecordObjectPartsLocationBuildingContoursEntitySpatialSpatialsElementsLevelContour>;
  /** Список координат */
  ordinates?: InputMaybe<Array<InputMaybe<TInputNestedRealestateFileRealestateRecordObjectPartsLocationBuildingContoursEntitySpatialSpatialsElementsOrdinates>>>;
};

export type TInputNestedRealestateFileRealestateRecordObjectPartsLocationBuildingContoursEntitySpatialSpatialsElementsLevelContour = {
  /** код из справочника */
  code?: InputMaybe<Scalars['NumberString']['input']>;
  /** значение */
  value?: InputMaybe<Scalars['String']['input']>;
};

export type TInputNestedRealestateFileRealestateRecordObjectPartsLocationBuildingContoursEntitySpatialSpatialsElementsOrdinates = {
  /** Погрешность */
  deltaGeopoint?: InputMaybe<Scalars['Int']['input']>;
  /** Номер точки */
  numGeopoint?: InputMaybe<Scalars['String']['input']>;
  /** Номер точки (порядок обхода) */
  ordNmb?: InputMaybe<Scalars['Int']['input']>;
  /** Радиус */
  r?: InputMaybe<Scalars['Int']['input']>;
  /** Координата X */
  x?: InputMaybe<Scalars['Int']['input']>;
  /** Координата Y */
  y?: InputMaybe<Scalars['Int']['input']>;
  /** Координата Z */
  z?: InputMaybe<Scalars['Int']['input']>;
};

export type TInputNestedRealestateFileRealestateRecordObjectPartsLocationBuildingInBuild = {
  /** Описание расположения */
  description?: InputMaybe<Scalars['String']['input']>;
  /** Номер этажа */
  floor?: InputMaybe<Scalars['Int']['input']>;
  /** Тип этажа */
  floorType?: InputMaybe<Scalars['Int']['input']>;
  /** Номер на поэтажном плане */
  planNumber?: InputMaybe<Scalars['String']['input']>;
  /** Планы */
  plans?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type TInputNestedRealestateFileRealestateRecordObjectSubtype = {
  /** код из справочника */
  code?: InputMaybe<Scalars['NumberString']['input']>;
  /** значение */
  value?: InputMaybe<Scalars['String']['input']>;
};

export type TInputNestedRealestateFileRealestateRecordParams = {
  /** Разрешенное использование */
  allowedUse?: InputMaybe<TInputNestedRealestateFileRealestateRecordParamsAllowedUse>;
  /** В Здании это значение является числом */
  area?: InputMaybe<TInputNestedRealestateFileRealestateRecordParamsArea>;
  /** Основные характеристики */
  baseParameters?: InputMaybe<Array<InputMaybe<TInputNestedRealestateFileRealestateRecordParamsBaseParameters>>>;
  /** Категория */
  category?: InputMaybe<TInputNestedRealestateFileRealestateRecordParamsCategory>;
  /** Степень готовности объекта незавершенного строительства в процентах */
  degreeReadiness?: InputMaybe<Scalars['String']['input']>;
  /** Количество этажей (в том числе подземных) */
  floors?: InputMaybe<Scalars['Int']['input']>;
  /** Материалы наружных стен здания */
  materials?: InputMaybe<Array<InputMaybe<TInputNestedRealestateFileRealestateRecordParamsMaterials>>>;
  /** Наименование сооружения */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Вид(ы) разрешенного использования */
  permittedUses?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Разрешенное использование по градостроительному регламенту */
  permittesUsesGradReg?: InputMaybe<TInputNestedRealestateFileRealestateRecordParamsPermittesUsesGradReg>;
  /** Назначение сооружения */
  purpose?: InputMaybe<TInputNestedRealestateFileRealestateRecordParamsPurpose>;
  /** Количество подземных этажей */
  undergroundFloors?: InputMaybe<Scalars['Int']['input']>;
  /** Год завершения строительства */
  yearBuilt?: InputMaybe<Scalars['year']['input']>;
  /** Год ввода в эксплуатацию по завершении строительства */
  yearCommisioning?: InputMaybe<Scalars['String']['input']>;
};

export type TInputNestedRealestateFileRealestateRecordParamsAllowedUse = {
  /** По документу */
  byDocument?: InputMaybe<Scalars['String']['input']>;
  /** Вид разрешенного использования земельного участка в соответствии с ранее использовавшимся классификатором */
  landUse?: InputMaybe<TInputNestedRealestateFileRealestateRecordParamsAllowedUseLandUse>;
  /** Вид разрешенного использования земельного участка в соответствии с классификатором, утвержденным приказом Минэкономразвития России от 01.09.2014 № 540 */
  landUseMer?: InputMaybe<TInputNestedRealestateFileRealestateRecordParamsAllowedUseLandUseMer>;
};

export type TInputNestedRealestateFileRealestateRecordParamsAllowedUseLandUse = {
  /** код из справочника */
  code?: InputMaybe<Scalars['NumberString']['input']>;
  /** значение */
  value?: InputMaybe<Scalars['String']['input']>;
};

export type TInputNestedRealestateFileRealestateRecordParamsAllowedUseLandUseMer = {
  /** код из справочника */
  code?: InputMaybe<Scalars['NumberString']['input']>;
  /** значение */
  value?: InputMaybe<Scalars['String']['input']>;
};

export type TInputNestedRealestateFileRealestateRecordParamsArea = {
  type?: InputMaybe<TInputNestedRealestateFileRealestateRecordParamsAreaType>;
  /** значение */
  value?: InputMaybe<Scalars['Float']['input']>;
};

export type TInputNestedRealestateFileRealestateRecordParamsAreaType = {
  /** код из справочника */
  code?: InputMaybe<Scalars['NumberString']['input']>;
  /** значение */
  value?: InputMaybe<Scalars['String']['input']>;
};

export type TInputNestedRealestateFileRealestateRecordParamsBaseParameters = {
  /** Площадь в кв. метрах */
  area?: InputMaybe<Scalars['Float']['input']>;
  /** Площадь застройки в квадратных метрах с округлением до 0,1 квадратного метра */
  builtUpArea?: InputMaybe<Scalars['Int']['input']>;
  /** Глубина в метрах с округлением до 0,1 метра */
  depth?: InputMaybe<Scalars['Int']['input']>;
  /** Протяженность в метрах с округлением до 1 метра */
  extension?: InputMaybe<Scalars['Int']['input']>;
  /** Высота в метрах с округлением до 0,1 метра */
  height?: InputMaybe<Scalars['Int']['input']>;
  /** Глубина залегания в метрах с округлением до 0,1 метра */
  occurenceDepth?: InputMaybe<Scalars['Int']['input']>;
  /** Объем в кубических метрах с округлением до 1 кубического метра */
  volume?: InputMaybe<Scalars['Int']['input']>;
};

export type TInputNestedRealestateFileRealestateRecordParamsCategory = {
  /** код из справочника */
  code?: InputMaybe<Scalars['NumberString']['input']>;
  /** значение */
  value?: InputMaybe<Scalars['String']['input']>;
};

export type TInputNestedRealestateFileRealestateRecordParamsMaterials = {
  /** код из справочника */
  code?: InputMaybe<Scalars['NumberString']['input']>;
  /** значение */
  value?: InputMaybe<Scalars['String']['input']>;
};

export type TInputNestedRealestateFileRealestateRecordParamsPermittesUsesGradReg = {
  /** Вид разрешенного использования в соответствии с классификатором, утвержденным приказом Минэкономразвития России от 01.09.2014 № 540 */
  landUse?: InputMaybe<TInputNestedRealestateFileRealestateRecordParamsPermittesUsesGradRegLandUse>;
  /** Разрешенное использование (текстовое описание) */
  permittedUseText?: InputMaybe<Scalars['String']['input']>;
  /** Реестровый номер границы */
  regNumbBorder?: InputMaybe<Scalars['String']['input']>;
};

export type TInputNestedRealestateFileRealestateRecordParamsPermittesUsesGradRegLandUse = {
  /** код из справочника */
  code?: InputMaybe<Scalars['NumberString']['input']>;
  /** значение */
  value?: InputMaybe<Scalars['String']['input']>;
};

export type TInputNestedRealestateFileRealestateRecordParamsPurpose = {
  /** код из справочника */
  code?: InputMaybe<Scalars['NumberString']['input']>;
  /** значение */
  value?: InputMaybe<Scalars['String']['input']>;
};

export type TInputNestedRealestateFileRealestateRecordRecordInfo = {
  /** Дата снятия с учета / регистрации */
  cancelDate?: InputMaybe<Scalars['String']['input']>;
  /** Дата постановки на учет / регистрации */
  registrationDate?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type TInputNestedRealestateFileRealestateRecordRestrictionsEncumbrances = {
  /** Сведения об объектах */
  cadLink?: InputMaybe<TInputNestedRealestateFileRealestateRecordRestrictionsEncumbrancesCadLink>;
  /** Содержание ограничения (обременения) */
  contentRestrictEncumbrances?: InputMaybe<Scalars['String']['input']>;
  /** Вид обременения */
  encumbranceType?: InputMaybe<TInputNestedRealestateFileRealestateRecordRestrictionsEncumbrancesEncumbranceType>;
  /** Порядковый номер части */
  partNumber?: InputMaybe<Scalars['Int']['input']>;
  /** Лица, в пользу которых ограничиваются права */
  persons?: InputMaybe<Array<InputMaybe<TInputNestedRealestateFileRealestateRecordRestrictionsEncumbrancesPersons>>>;
  /** Документы - основания для внесения сведений */
  underlyingDocs?: InputMaybe<Array<InputMaybe<TInputNestedRealestateFileRealestateRecordRestrictionsEncumbrancesUnderlyingDocs>>>;
  /** Срок действия обременения */
  validity?: InputMaybe<Scalars['String']['input']>;
};

export type TInputNestedRealestateFileRealestateRecordRestrictionsEncumbrancesCadLink = {
  /** Кадастровый номер земельного участка, для которого обеспечен проход (проезд) */
  easementCadNumbers?: InputMaybe<Scalars['String']['input']>;
  /** Реестровый номер зоны */
  regNumberBorder?: InputMaybe<Scalars['String']['input']>;
};

export type TInputNestedRealestateFileRealestateRecordRestrictionsEncumbrancesEncumbranceType = {
  /** код из справочника */
  code?: InputMaybe<Scalars['NumberString']['input']>;
  /** значение */
  value?: InputMaybe<Scalars['String']['input']>;
};

export type TInputNestedRealestateFileRealestateRecordRestrictionsEncumbrancesPersons = {
  subject?: InputMaybe<TInputNestedRealestateFileRealestateRecordRestrictionsEncumbrancesPersonsSubject>;
  /** Тип лица, в пользу которых установлены ограничения права и обременения объекта недвижимости */
  type?: InputMaybe<TInputNestedRealestateFileRealestateRecordRestrictionsEncumbrancesPersonsType>;
};

export type TInputNestedRealestateFileRealestateRecordRestrictionsEncumbrancesPersonsSubject = {
  /** Иное лицо, в пользу которого установлены ограничения права и обременения объекта недвижимости */
  another?: InputMaybe<TInputNestedRealestateFileRealestateRecordRestrictionsEncumbrancesPersonsSubjectAnother>;
  /** Физическое лицо */
  individual?: InputMaybe<TInputNestedRealestateFileRealestateRecordRestrictionsEncumbrancesPersonsSubjectIndividual>;
  /** Юридическое лицо, орган власти */
  legalEntity?: InputMaybe<TInputNestedRealestateFileRealestateRecordRestrictionsEncumbrancesPersonsSubjectLegalEntity>;
  /** Публично-правовое образование */
  publicFormation?: InputMaybe<TInputNestedRealestateFileRealestateRecordRestrictionsEncumbrancesPersonsSubjectPublicFormation>;
  /** Публичный сервитут */
  publicServitude?: InputMaybe<Scalars['String']['input']>;
  /** Не определено (тип undefined в документации) */
  somethingElse?: InputMaybe<Scalars['String']['input']>;
};

export type TInputNestedRealestateFileRealestateRecordRestrictionsEncumbrancesPersonsSubjectAnother = {
  /** Собственники помещений в многоквартирном доме */
  aparthouseOwners?: InputMaybe<Scalars['String']['input']>;
  /** Владельцы облигаций */
  bondsHolders?: InputMaybe<TInputNestedRealestateFileRealestateRecordRestrictionsEncumbrancesPersonsSubjectAnotherBondsHolders>;
  /** Индивидуальное обозначение, идентифицирующее ипотечные сертификаты участия, в интересах владельцев которых осуществляется доверительное управление таким ипотечным покрытием */
  certificatesHolders?: InputMaybe<Scalars['String']['input']>;
  /** Участники долевого строительства */
  equityParticipantsInfo?: InputMaybe<Scalars['String']['input']>;
  /** Название (индивидуальное обозначение), идентифицирующее паевой инвестиционный фонд */
  investmentUnitOwner?: InputMaybe<Scalars['String']['input']>;
  /** Участники долевого строительства по договорам участия в долевом строительстве, которым не переданы объекты долевого строительства */
  notEquityParticipantsInfo?: InputMaybe<Scalars['String']['input']>;
  /** Иной субъект */
  other?: InputMaybe<TInputNestedRealestateFileRealestateRecordRestrictionsEncumbrancesPersonsSubjectAnotherOther>;
  /** Инвестиционное товарищество */
  partnership?: InputMaybe<TInputNestedRealestateFileRealestateRecordRestrictionsEncumbrancesPersonsSubjectAnotherPartnership>;
};

export type TInputNestedRealestateFileRealestateRecordRestrictionsEncumbrancesPersonsSubjectAnotherBondsHolders = {
  /** Дата государственной регистрации номера выпуска облигаций */
  issueDate?: InputMaybe<Scalars['String']['input']>;
  /** Государственный регистрационный номер выпуска облигаций */
  number?: InputMaybe<Scalars['String']['input']>;
};

export type TInputNestedRealestateFileRealestateRecordRestrictionsEncumbrancesPersonsSubjectAnotherOther = {
  /** Комментарий */
  comment?: InputMaybe<Scalars['String']['input']>;
  contacts?: InputMaybe<TInputNestedRealestateFileRealestateRecordRestrictionsEncumbrancesPersonsSubjectAnotherOtherContacts>;
  /** Наименование для печати */
  printText?: InputMaybe<Scalars['String']['input']>;
  /** Регистрирующий орган */
  registrationOrgan?: InputMaybe<Scalars['String']['input']>;
  /** Краткое наименование */
  shortTitle?: InputMaybe<Scalars['String']['input']>;
  /** Наименование */
  title?: InputMaybe<Scalars['String']['input']>;
};

export type TInputNestedRealestateFileRealestateRecordRestrictionsEncumbrancesPersonsSubjectAnotherOtherContacts = {
  email?: InputMaybe<Scalars['String']['input']>;
  /** ! Возможно в документации ошибка: mailing_addess */
  mailingAddress?: InputMaybe<Scalars['String']['input']>;
};

export type TInputNestedRealestateFileRealestateRecordRestrictionsEncumbrancesPersonsSubjectAnotherPartnership = {
  /** Участник договора инвестиционного товарищества */
  participants?: InputMaybe<Array<InputMaybe<TInputNestedRealestateFileRealestateRecordRestrictionsEncumbrancesPersonsSubjectAnotherPartnershipParticipants>>>;
};

export type TInputNestedRealestateFileRealestateRecordRestrictionsEncumbrancesPersonsSubjectAnotherPartnershipParticipants = {
  contacts?: InputMaybe<TInputNestedRealestateFileRealestateRecordRestrictionsEncumbrancesPersonsSubjectAnotherPartnershipParticipantsContacts>;
  legalEntity?: InputMaybe<TInputNestedRealestateFileRealestateRecordRestrictionsEncumbrancesPersonsSubjectAnotherPartnershipParticipantsLegalEntity>;
};

export type TInputNestedRealestateFileRealestateRecordRestrictionsEncumbrancesPersonsSubjectAnotherPartnershipParticipantsContacts = {
  email?: InputMaybe<Scalars['String']['input']>;
  /** ! Возможно в документации ошибка: mailing_addess */
  mailingAddress?: InputMaybe<Scalars['String']['input']>;
};

export type TInputNestedRealestateFileRealestateRecordRestrictionsEncumbrancesPersonsSubjectAnotherPartnershipParticipantsLegalEntity = {
  notResident?: InputMaybe<TInputNestedRealestateFileRealestateRecordRestrictionsEncumbrancesPersonsSubjectAnotherPartnershipParticipantsLegalEntityNotResident>;
  resident?: InputMaybe<TInputNestedRealestateFileRealestateRecordRestrictionsEncumbrancesPersonsSubjectAnotherPartnershipParticipantsLegalEntityResident>;
};

export type TInputNestedRealestateFileRealestateRecordRestrictionsEncumbrancesPersonsSubjectAnotherPartnershipParticipantsLegalEntityNotResident = {
  /** Страна регистрации (инкорпорации) */
  incorporateCountry?: InputMaybe<TInputNestedRealestateFileRealestateRecordRestrictionsEncumbrancesPersonsSubjectAnotherPartnershipParticipantsLegalEntityNotResidentIncorporateCountry>;
  /** Организационно-правовая форма */
  incorporationForm?: InputMaybe<TInputNestedRealestateFileRealestateRecordRestrictionsEncumbrancesPersonsSubjectAnotherPartnershipParticipantsLegalEntityNotResidentIncorporationForm>;
  inn?: InputMaybe<Scalars['String']['input']>;
  /** Адрес (местонахождение) в стране регистрации (инкорпорации) */
  regAddress?: InputMaybe<Scalars['String']['input']>;
  /** Дата регистрации */
  registrationDate?: InputMaybe<Scalars['String']['input']>;
  /** Регистрационный номер */
  registrationNumber?: InputMaybe<Scalars['String']['input']>;
  /** Наименование регистрирующего органа */
  registrationOrgan?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type TInputNestedRealestateFileRealestateRecordRestrictionsEncumbrancesPersonsSubjectAnotherPartnershipParticipantsLegalEntityNotResidentIncorporateCountry = {
  /** код из справочника */
  code?: InputMaybe<Scalars['NumberString']['input']>;
  /** значение */
  value?: InputMaybe<Scalars['String']['input']>;
};

export type TInputNestedRealestateFileRealestateRecordRestrictionsEncumbrancesPersonsSubjectAnotherPartnershipParticipantsLegalEntityNotResidentIncorporationForm = {
  /** код из справочника */
  code?: InputMaybe<Scalars['NumberString']['input']>;
  /** значение */
  value?: InputMaybe<Scalars['String']['input']>;
};

export type TInputNestedRealestateFileRealestateRecordRestrictionsEncumbrancesPersonsSubjectAnotherPartnershipParticipantsLegalEntityResident = {
  /** Организационно-правовая форма */
  incorporationForm?: InputMaybe<TInputNestedRealestateFileRealestateRecordRestrictionsEncumbrancesPersonsSubjectAnotherPartnershipParticipantsLegalEntityResidentIncorporationForm>;
  inn?: InputMaybe<Scalars['String']['input']>;
  ogrn?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type TInputNestedRealestateFileRealestateRecordRestrictionsEncumbrancesPersonsSubjectAnotherPartnershipParticipantsLegalEntityResidentIncorporationForm = {
  /** код из справочника */
  code?: InputMaybe<Scalars['NumberString']['input']>;
  /** значение */
  value?: InputMaybe<Scalars['String']['input']>;
};

export type TInputNestedRealestateFileRealestateRecordRestrictionsEncumbrancesPersonsSubjectIndividual = {
  birthDate?: InputMaybe<Scalars['BirthDate']['input']>;
  birthPlace?: InputMaybe<Scalars['String']['input']>;
  /** Гражданство */
  citizenship?: InputMaybe<TInputNestedRealestateFileRealestateRecordRestrictionsEncumbrancesPersonsSubjectIndividualCitizenship>;
  /** Связь с правообладателем */
  contacts?: InputMaybe<TInputNestedRealestateFileRealestateRecordRestrictionsEncumbrancesPersonsSubjectIndividualContacts>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  /** Документ, удостоверяющий личность */
  identityDocument?: InputMaybe<TInputNestedRealestateFileRealestateRecordRestrictionsEncumbrancesPersonsSubjectIndividualIdentityDocument>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  middleName?: InputMaybe<Scalars['String']['input']>;
  snils?: InputMaybe<Scalars['String']['input']>;
  /** Тип физического лица */
  type?: InputMaybe<TInputNestedRealestateFileRealestateRecordRestrictionsEncumbrancesPersonsSubjectIndividualType>;
};

export type TInputNestedRealestateFileRealestateRecordRestrictionsEncumbrancesPersonsSubjectIndividualCitizenship = {
  /** Страна гражданства */
  country?: InputMaybe<TInputNestedRealestateFileRealestateRecordRestrictionsEncumbrancesPersonsSubjectIndividualCitizenshipCountry>;
  /** Без гражданства [по документации тут какой-то текст должен быть] */
  noCitizenship?: InputMaybe<Scalars['String']['input']>;
};

export type TInputNestedRealestateFileRealestateRecordRestrictionsEncumbrancesPersonsSubjectIndividualCitizenshipCountry = {
  code?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type TInputNestedRealestateFileRealestateRecordRestrictionsEncumbrancesPersonsSubjectIndividualContacts = {
  email?: InputMaybe<Scalars['String']['input']>;
  /** ! Возможно в документации ошибка: mailing_addess */
  mailingAddress?: InputMaybe<Scalars['String']['input']>;
};

export type TInputNestedRealestateFileRealestateRecordRestrictionsEncumbrancesPersonsSubjectIndividualIdentityDocument = {
  /** Код документа */
  code?: InputMaybe<TInputNestedRealestateFileRealestateRecordRestrictionsEncumbrancesPersonsSubjectIndividualIdentityDocumentCode>;
  /** Дата документа */
  date?: InputMaybe<Scalars['DateTimeISO']['input']>;
  /** Нотариальное удостоверение документа */
  docNotarized?: InputMaybe<TInputNestedRealestateFileRealestateRecordRestrictionsEncumbrancesPersonsSubjectIndividualIdentityDocumentDocNotarized>;
  /** Кем выдан (Организация, выдавшая документ) */
  issuer?: InputMaybe<Scalars['String']['input']>;
  /** Наименование */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Номер документа */
  number?: InputMaybe<Scalars['String']['input']>;
  /** Серия документа */
  series?: InputMaybe<Scalars['String']['input']>;
  /** Особые отметки */
  specialMarks?: InputMaybe<Scalars['String']['input']>;
};

export type TInputNestedRealestateFileRealestateRecordRestrictionsEncumbrancesPersonsSubjectIndividualIdentityDocumentCode = {
  /** код из справочника */
  code?: InputMaybe<Scalars['NumberString']['input']>;
  /** значение */
  value?: InputMaybe<Scalars['String']['input']>;
};

export type TInputNestedRealestateFileRealestateRecordRestrictionsEncumbrancesPersonsSubjectIndividualIdentityDocumentDocNotarized = {
  /** Дата нотариального удостоверения */
  notarizeDate?: InputMaybe<Scalars['String']['input']>;
  /** Номер в реестре регистрации нотариальных действий */
  notaryActionNum?: InputMaybe<Scalars['String']['input']>;
  /** Фамилия и инициалы нотариуса */
  notaryName?: InputMaybe<Scalars['String']['input']>;
};

export type TInputNestedRealestateFileRealestateRecordRestrictionsEncumbrancesPersonsSubjectIndividualType = {
  /** код из справочника */
  code?: InputMaybe<Scalars['NumberString']['input']>;
  /** значение */
  value?: InputMaybe<Scalars['String']['input']>;
};

export type TInputNestedRealestateFileRealestateRecordRestrictionsEncumbrancesPersonsSubjectLegalEntity = {
  contacts?: InputMaybe<TInputNestedRealestateFileRealestateRecordRestrictionsEncumbrancesPersonsSubjectLegalEntityContacts>;
  entity?: InputMaybe<TInputNestedRealestateFileRealestateRecordRestrictionsEncumbrancesPersonsSubjectLegalEntityEntity>;
  /** Тип юридического лица */
  type?: InputMaybe<TInputNestedRealestateFileRealestateRecordRestrictionsEncumbrancesPersonsSubjectLegalEntityType>;
};

export type TInputNestedRealestateFileRealestateRecordRestrictionsEncumbrancesPersonsSubjectLegalEntityContacts = {
  email?: InputMaybe<Scalars['String']['input']>;
  /** ! Возможно в документации ошибка: mailing_addess */
  mailingAddress?: InputMaybe<Scalars['String']['input']>;
};

export type TInputNestedRealestateFileRealestateRecordRestrictionsEncumbrancesPersonsSubjectLegalEntityEntity = {
  /** Орган государственной власти, орган местного самоуправления, иной государственный орган */
  governmentEntity?: InputMaybe<TInputNestedRealestateFileRealestateRecordRestrictionsEncumbrancesPersonsSubjectLegalEntityEntityGovernmentEntity>;
  /** Иностранное юридическое лицо */
  notResident?: InputMaybe<TInputNestedRealestateFileRealestateRecordRestrictionsEncumbrancesPersonsSubjectLegalEntityEntityNotResident>;
  /** Российское юридическое лицо */
  resident?: InputMaybe<TInputNestedRealestateFileRealestateRecordRestrictionsEncumbrancesPersonsSubjectLegalEntityEntityResident>;
};

export type TInputNestedRealestateFileRealestateRecordRestrictionsEncumbrancesPersonsSubjectLegalEntityEntityGovernmentEntity = {
  inn?: InputMaybe<Scalars['String']['input']>;
  ogrn?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type TInputNestedRealestateFileRealestateRecordRestrictionsEncumbrancesPersonsSubjectLegalEntityEntityNotResident = {
  /** Страна регистрации (инкорпорации) */
  incorporateCountry?: InputMaybe<TInputNestedRealestateFileRealestateRecordRestrictionsEncumbrancesPersonsSubjectLegalEntityEntityNotResidentIncorporateCountry>;
  /** Организационно-правовая форма */
  incorporationForm?: InputMaybe<TInputNestedRealestateFileRealestateRecordRestrictionsEncumbrancesPersonsSubjectLegalEntityEntityNotResidentIncorporationForm>;
  inn?: InputMaybe<Scalars['String']['input']>;
  /** Адрес (местонахождение) в стране регистрации (инкорпорации) */
  regAddress?: InputMaybe<Scalars['String']['input']>;
  /** Дата регистрации */
  registrationDate?: InputMaybe<Scalars['String']['input']>;
  /** Регистрационный номер */
  registrationNumber?: InputMaybe<Scalars['String']['input']>;
  /** Наименование регистрирующего органа */
  registrationOrgan?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type TInputNestedRealestateFileRealestateRecordRestrictionsEncumbrancesPersonsSubjectLegalEntityEntityNotResidentIncorporateCountry = {
  /** код из справочника */
  code?: InputMaybe<Scalars['NumberString']['input']>;
  /** значение */
  value?: InputMaybe<Scalars['String']['input']>;
};

export type TInputNestedRealestateFileRealestateRecordRestrictionsEncumbrancesPersonsSubjectLegalEntityEntityNotResidentIncorporationForm = {
  /** код из справочника */
  code?: InputMaybe<Scalars['NumberString']['input']>;
  /** значение */
  value?: InputMaybe<Scalars['String']['input']>;
};

export type TInputNestedRealestateFileRealestateRecordRestrictionsEncumbrancesPersonsSubjectLegalEntityEntityResident = {
  /** Организационно-правовая форма */
  incorporationForm?: InputMaybe<TInputNestedRealestateFileRealestateRecordRestrictionsEncumbrancesPersonsSubjectLegalEntityEntityResidentIncorporationForm>;
  inn?: InputMaybe<Scalars['String']['input']>;
  ogrn?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type TInputNestedRealestateFileRealestateRecordRestrictionsEncumbrancesPersonsSubjectLegalEntityEntityResidentIncorporationForm = {
  /** код из справочника */
  code?: InputMaybe<Scalars['NumberString']['input']>;
  /** значение */
  value?: InputMaybe<Scalars['String']['input']>;
};

export type TInputNestedRealestateFileRealestateRecordRestrictionsEncumbrancesPersonsSubjectLegalEntityType = {
  /** код из справочника */
  code?: InputMaybe<Scalars['NumberString']['input']>;
  /** значение */
  value?: InputMaybe<Scalars['String']['input']>;
};

export type TInputNestedRealestateFileRealestateRecordRestrictionsEncumbrancesPersonsSubjectPublicFormation = {
  /** Иностранное государство */
  foreign?: InputMaybe<Scalars['String']['input']>;
  /** Наименование муниципального образования */
  municipality?: InputMaybe<Scalars['String']['input']>;
  /** Российская Федерация */
  russia?: InputMaybe<TInputNestedRealestateFileRealestateRecordRestrictionsEncumbrancesPersonsSubjectPublicFormationRussia>;
  /** Наименование субъекта Российской Федерации */
  subjectOfRf?: InputMaybe<TInputNestedRealestateFileRealestateRecordRestrictionsEncumbrancesPersonsSubjectPublicFormationSubjectOfRf>;
  /** Союзное государство */
  union?: InputMaybe<Scalars['String']['input']>;
};

export type TInputNestedRealestateFileRealestateRecordRestrictionsEncumbrancesPersonsSubjectPublicFormationRussia = {
  /** код из справочника */
  code?: InputMaybe<Scalars['NumberString']['input']>;
  /** значение */
  value?: InputMaybe<Scalars['String']['input']>;
};

export type TInputNestedRealestateFileRealestateRecordRestrictionsEncumbrancesPersonsSubjectPublicFormationSubjectOfRf = {
  /** код из справочника */
  code?: InputMaybe<Scalars['NumberString']['input']>;
  /** значение */
  value?: InputMaybe<Scalars['String']['input']>;
};

export type TInputNestedRealestateFileRealestateRecordRestrictionsEncumbrancesPersonsType = {
  /** код из справочника */
  code?: InputMaybe<Scalars['NumberString']['input']>;
  /** значение */
  value?: InputMaybe<Scalars['String']['input']>;
};

export type TInputNestedRealestateFileRealestateRecordRestrictionsEncumbrancesUnderlyingDocs = {
  /** Код документа */
  code?: InputMaybe<TInputNestedRealestateFileRealestateRecordRestrictionsEncumbrancesUnderlyingDocsCode>;
  /** Дата документа */
  date?: InputMaybe<Scalars['String']['input']>;
  /** Нотариальное удостоверение документа */
  docNotarized?: InputMaybe<TInputNestedRealestateFileRealestateRecordRestrictionsEncumbrancesUnderlyingDocsDocNotarized>;
  /** Полное наименование должности должностного лица */
  fullnamePostsPerson?: InputMaybe<Scalars['String']['input']>;
  /** Орган власти, организация, выдавшие документ */
  issuer?: InputMaybe<Scalars['String']['input']>;
  /** Наименование документа */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Номер документа */
  number?: InputMaybe<Scalars['String']['input']>;
  /** Серия документа */
  series?: InputMaybe<Scalars['String']['input']>;
};

export type TInputNestedRealestateFileRealestateRecordRestrictionsEncumbrancesUnderlyingDocsCode = {
  /** код из справочника */
  code?: InputMaybe<Scalars['NumberString']['input']>;
  /** значение */
  value?: InputMaybe<Scalars['String']['input']>;
};

export type TInputNestedRealestateFileRealestateRecordRestrictionsEncumbrancesUnderlyingDocsDocNotarized = {
  /** Дата нотариального удостоверения */
  notarizeDate?: InputMaybe<Scalars['String']['input']>;
  /** Номер в реестре регистрации нотариальных действий */
  notaryActionNum?: InputMaybe<Scalars['String']['input']>;
  /** Фамилия и инициалы нотариуса */
  notaryName?: InputMaybe<Scalars['String']['input']>;
};

export type TInputNestedRealestateFileRealestateRecordSurveyBoundaries = {
  /** Реквизиты акта об утверждении проекта межевания территории */
  actRequisites?: InputMaybe<TInputNestedRealestateFileRealestateRecordSurveyBoundariesActRequisites>;
  /** Сведения о лице (лицах), утвердивших проект межевания земельного участка */
  approvePersons?: InputMaybe<Array<InputMaybe<TInputNestedRealestateFileRealestateRecordSurveyBoundariesApprovePersons>>>;
  /** Реквизиты решения */
  decisionRequisites?: InputMaybe<TInputNestedRealestateFileRealestateRecordSurveyBoundariesDecisionRequisites>;
  /** Условный номер земельного участка */
  nominalNumber?: InputMaybe<Scalars['String']['input']>;
  /** Реквизиты протокола, подготовленного по результатам общего собрания участников долевой собственности на земельный участок */
  protocolRequisites?: InputMaybe<TInputNestedRealestateFileRealestateRecordSurveyBoundariesProtocolRequisites>;
  /** Дата присвоения учетного номера проекту межевания */
  registrationDate?: InputMaybe<Scalars['String']['input']>;
  /** Учетный номер проекта межевания */
  surveyProjectNum?: InputMaybe<Scalars['String']['input']>;
};

export type TInputNestedRealestateFileRealestateRecordSurveyBoundariesActRequisites = {
  /** Код документа */
  code?: InputMaybe<TInputNestedRealestateFileRealestateRecordSurveyBoundariesActRequisitesCode>;
  /** Дата документа */
  date?: InputMaybe<Scalars['String']['input']>;
  /** Орган власти, организация, выдавшие документ. Автор документа */
  issuer?: InputMaybe<Scalars['String']['input']>;
  /** Номер документа */
  number?: InputMaybe<Scalars['String']['input']>;
};

export type TInputNestedRealestateFileRealestateRecordSurveyBoundariesActRequisitesCode = {
  /** код из справочника */
  code?: InputMaybe<Scalars['NumberString']['input']>;
  /** значение */
  value?: InputMaybe<Scalars['String']['input']>;
};

export type TInputNestedRealestateFileRealestateRecordSurveyBoundariesApprovePersons = {
  /** Фамилия, имя, отчество физического лица */
  individual?: InputMaybe<TInputNestedRealestateFileRealestateRecordSurveyBoundariesApprovePersonsIndividual>;
  /** Полное наименование юридического лица */
  legalEntity?: InputMaybe<Scalars['String']['input']>;
};

export type TInputNestedRealestateFileRealestateRecordSurveyBoundariesApprovePersonsIndividual = {
  /** Имя */
  firstName?: InputMaybe<Scalars['String']['input']>;
  /** Фамилия */
  lastName?: InputMaybe<Scalars['String']['input']>;
  /** Отчество */
  middleName?: InputMaybe<Scalars['String']['input']>;
};

export type TInputNestedRealestateFileRealestateRecordSurveyBoundariesDecisionRequisites = {
  /** Код документа */
  code?: InputMaybe<TInputNestedRealestateFileRealestateRecordSurveyBoundariesDecisionRequisitesCode>;
  /** Дата документа */
  date?: InputMaybe<Scalars['String']['input']>;
  /** Орган власти, организация, выдавшие документ. Автор документа */
  issuer?: InputMaybe<Scalars['String']['input']>;
  /** Номер документа */
  number?: InputMaybe<Scalars['String']['input']>;
};

export type TInputNestedRealestateFileRealestateRecordSurveyBoundariesDecisionRequisitesCode = {
  /** код из справочника */
  code?: InputMaybe<Scalars['NumberString']['input']>;
  /** значение */
  value?: InputMaybe<Scalars['String']['input']>;
};

export type TInputNestedRealestateFileRealestateRecordSurveyBoundariesProtocolRequisites = {
  /** Код документа */
  code?: InputMaybe<TInputNestedRealestateFileRealestateRecordSurveyBoundariesProtocolRequisitesCode>;
  /** Дата документа */
  date?: InputMaybe<Scalars['String']['input']>;
  /** Орган власти, организация, выдавшие документ. Автор документа */
  issuer?: InputMaybe<Scalars['String']['input']>;
  /** Номер документа */
  number?: InputMaybe<Scalars['String']['input']>;
};

export type TInputNestedRealestateFileRealestateRecordSurveyBoundariesProtocolRequisitesCode = {
  /** код из справочника */
  code?: InputMaybe<Scalars['NumberString']['input']>;
  /** значение */
  value?: InputMaybe<Scalars['String']['input']>;
};

export type TInputNestedRealestateFileRealestateRecordZonesAndBoundaries = {
  /** Сведения о расположении земельного участка в границах особо охраняемой природной территории, охотничьих угодий, лесничеств, лесопарков */
  guardedNaturalBoundaries?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Сведения о расположении земельного участка в границах особо охраняемой природной территории, охотничьих угодий, лесничеств, лесопарков */
  specialEconomicBoundary?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Сведения о расположении земельного участка полностью или частично в границах зоны с особыми условиями использования территории или территории объекта культурного наследия */
  specialUseBoundaries?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type TInputNestedRealestateFileRestrictRecords = {
  recordInfo?: InputMaybe<TInputNestedRealestateFileRestrictRecordsRecordInfo>;
  /** Номер регистрации ограничения права или обременения объекта недвижимости */
  restrictionsEncumbrancesData?: InputMaybe<TInputNestedRealestateFileRestrictRecordsRestrictionsEncumbrancesData>;
  rightHolders?: InputMaybe<Array<InputMaybe<TInputNestedRealestateFileRestrictRecordsRightHolders>>>;
  underlyingDocuments?: InputMaybe<Array<InputMaybe<TInputNestedRealestateFileRestrictRecordsUnderlyingDocuments>>>;
};

export type TInputNestedRealestateFileRestrictRecordsRecordInfo = {
  /** Дата снятия с учета / регистрации */
  cancelDate?: InputMaybe<Scalars['String']['input']>;
  /** Дата постановки на учет / регистрации */
  registrationDate?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type TInputNestedRealestateFileRestrictRecordsRestrictionsEncumbrancesData = {
  /** Дополнительная информация в зависимости от вида зарегистрированного ограничения права или обременения объекта недвижимости */
  additionalInfo?: InputMaybe<TInputNestedRealestateFileRestrictRecordsRestrictionsEncumbrancesDataAdditionalInfo>;
  /** Номер регистрации ограничения права или обременения объекта недвижимости */
  number?: InputMaybe<Scalars['String']['input']>;
  /** Дата начала действия */
  period?: InputMaybe<TInputNestedRealestateFileRestrictRecordsRestrictionsEncumbrancesDataPeriod>;
  /** Ограничиваемые права */
  restrictingRights?: InputMaybe<Array<InputMaybe<TInputNestedRealestateFileRestrictRecordsRestrictionsEncumbrancesDataRestrictingRights>>>;
  /** Вид зарегистрированного ограничения права или обременения объекта недвижимости */
  type?: InputMaybe<TInputNestedRealestateFileRestrictRecordsRestrictionsEncumbrancesDataType>;
};

export type TInputNestedRealestateFileRestrictRecordsRestrictionsEncumbrancesDataAdditionalInfo = {
  /** Условия сервитута */
  servitudeCondition?: InputMaybe<Scalars['String']['input']>;
  /** Вид сервитута */
  servitudeType?: InputMaybe<TInputNestedRealestateFileRestrictRecordsRestrictionsEncumbrancesDataAdditionalInfoServitudeType>;
};

export type TInputNestedRealestateFileRestrictRecordsRestrictionsEncumbrancesDataAdditionalInfoServitudeType = {
  /** код из справочника */
  code?: InputMaybe<Scalars['NumberString']['input']>;
  /** значение */
  value?: InputMaybe<Scalars['String']['input']>;
};

export type TInputNestedRealestateFileRestrictRecordsRestrictionsEncumbrancesDataPeriod = {
  /** Срок действия ограничения/обременения (Продолжительность) */
  dealValidityTime?: InputMaybe<Scalars['String']['input']>;
  /** Дата прекращения действия */
  endDate?: InputMaybe<Scalars['String']['input']>;
  /** Дата начала действия */
  startDate?: InputMaybe<Scalars['String']['input']>;
};

export type TInputNestedRealestateFileRestrictRecordsRestrictionsEncumbrancesDataRestrictingRights = {
  /** Номер реестровой записи */
  number?: InputMaybe<Scalars['String']['input']>;
  /** Номер регистрации вещного права */
  rightNumber?: InputMaybe<Scalars['String']['input']>;
};

export type TInputNestedRealestateFileRestrictRecordsRestrictionsEncumbrancesDataType = {
  /** код из справочника */
  code?: InputMaybe<Scalars['NumberString']['input']>;
  /** значение */
  value?: InputMaybe<Scalars['String']['input']>;
};

export type TInputNestedRealestateFileRestrictRecordsRightHolders = {
  /** Иное лицо, в пользу которого установлены ограничения права и обременения объекта недвижимости */
  another?: InputMaybe<TInputNestedRealestateFileRestrictRecordsRightHoldersAnother>;
  /** Физическое лицо */
  individual?: InputMaybe<TInputNestedRealestateFileRestrictRecordsRightHoldersIndividual>;
  /** Юридическое лицо, орган власти */
  legalEntity?: InputMaybe<TInputNestedRealestateFileRestrictRecordsRightHoldersLegalEntity>;
  /** Публично-правовое образование */
  publicFormation?: InputMaybe<TInputNestedRealestateFileRestrictRecordsRightHoldersPublicFormation>;
  /** Публичный сервитут */
  publicServitude?: InputMaybe<Scalars['String']['input']>;
  /** Не определено (тип undefined в документации) */
  somethingElse?: InputMaybe<Scalars['String']['input']>;
};

export type TInputNestedRealestateFileRestrictRecordsRightHoldersAnother = {
  /** Собственники помещений в многоквартирном доме */
  aparthouseOwners?: InputMaybe<Scalars['String']['input']>;
  /** Владельцы облигаций */
  bondsHolders?: InputMaybe<TInputNestedRealestateFileRestrictRecordsRightHoldersAnotherBondsHolders>;
  /** Индивидуальное обозначение, идентифицирующее ипотечные сертификаты участия, в интересах владельцев которых осуществляется доверительное управление таким ипотечным покрытием */
  certificatesHolders?: InputMaybe<Scalars['String']['input']>;
  /** Участники долевого строительства */
  equityParticipantsInfo?: InputMaybe<Scalars['String']['input']>;
  /** Название (индивидуальное обозначение), идентифицирующее паевой инвестиционный фонд */
  investmentUnitOwner?: InputMaybe<Scalars['String']['input']>;
  /** Участники долевого строительства по договорам участия в долевом строительстве, которым не переданы объекты долевого строительства */
  notEquityParticipantsInfo?: InputMaybe<Scalars['String']['input']>;
  /** Иной субъект */
  other?: InputMaybe<TInputNestedRealestateFileRestrictRecordsRightHoldersAnotherOther>;
  /** Инвестиционное товарищество */
  partnership?: InputMaybe<TInputNestedRealestateFileRestrictRecordsRightHoldersAnotherPartnership>;
};

export type TInputNestedRealestateFileRestrictRecordsRightHoldersAnotherBondsHolders = {
  /** Дата государственной регистрации номера выпуска облигаций */
  issueDate?: InputMaybe<Scalars['String']['input']>;
  /** Государственный регистрационный номер выпуска облигаций */
  number?: InputMaybe<Scalars['String']['input']>;
};

export type TInputNestedRealestateFileRestrictRecordsRightHoldersAnotherOther = {
  /** Комментарий */
  comment?: InputMaybe<Scalars['String']['input']>;
  contacts?: InputMaybe<TInputNestedRealestateFileRestrictRecordsRightHoldersAnotherOtherContacts>;
  /** Наименование для печати */
  printText?: InputMaybe<Scalars['String']['input']>;
  /** Регистрирующий орган */
  registrationOrgan?: InputMaybe<Scalars['String']['input']>;
  /** Краткое наименование */
  shortTitle?: InputMaybe<Scalars['String']['input']>;
  /** Наименование */
  title?: InputMaybe<Scalars['String']['input']>;
};

export type TInputNestedRealestateFileRestrictRecordsRightHoldersAnotherOtherContacts = {
  email?: InputMaybe<Scalars['String']['input']>;
  /** ! Возможно в документации ошибка: mailing_addess */
  mailingAddress?: InputMaybe<Scalars['String']['input']>;
};

export type TInputNestedRealestateFileRestrictRecordsRightHoldersAnotherPartnership = {
  /** Участник договора инвестиционного товарищества */
  participants?: InputMaybe<Array<InputMaybe<TInputNestedRealestateFileRestrictRecordsRightHoldersAnotherPartnershipParticipants>>>;
};

export type TInputNestedRealestateFileRestrictRecordsRightHoldersAnotherPartnershipParticipants = {
  contacts?: InputMaybe<TInputNestedRealestateFileRestrictRecordsRightHoldersAnotherPartnershipParticipantsContacts>;
  legalEntity?: InputMaybe<TInputNestedRealestateFileRestrictRecordsRightHoldersAnotherPartnershipParticipantsLegalEntity>;
};

export type TInputNestedRealestateFileRestrictRecordsRightHoldersAnotherPartnershipParticipantsContacts = {
  email?: InputMaybe<Scalars['String']['input']>;
  /** ! Возможно в документации ошибка: mailing_addess */
  mailingAddress?: InputMaybe<Scalars['String']['input']>;
};

export type TInputNestedRealestateFileRestrictRecordsRightHoldersAnotherPartnershipParticipantsLegalEntity = {
  notResident?: InputMaybe<TInputNestedRealestateFileRestrictRecordsRightHoldersAnotherPartnershipParticipantsLegalEntityNotResident>;
  resident?: InputMaybe<TInputNestedRealestateFileRestrictRecordsRightHoldersAnotherPartnershipParticipantsLegalEntityResident>;
};

export type TInputNestedRealestateFileRestrictRecordsRightHoldersAnotherPartnershipParticipantsLegalEntityNotResident = {
  /** Страна регистрации (инкорпорации) */
  incorporateCountry?: InputMaybe<TInputNestedRealestateFileRestrictRecordsRightHoldersAnotherPartnershipParticipantsLegalEntityNotResidentIncorporateCountry>;
  /** Организационно-правовая форма */
  incorporationForm?: InputMaybe<TInputNestedRealestateFileRestrictRecordsRightHoldersAnotherPartnershipParticipantsLegalEntityNotResidentIncorporationForm>;
  inn?: InputMaybe<Scalars['String']['input']>;
  /** Адрес (местонахождение) в стране регистрации (инкорпорации) */
  regAddress?: InputMaybe<Scalars['String']['input']>;
  /** Дата регистрации */
  registrationDate?: InputMaybe<Scalars['String']['input']>;
  /** Регистрационный номер */
  registrationNumber?: InputMaybe<Scalars['String']['input']>;
  /** Наименование регистрирующего органа */
  registrationOrgan?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type TInputNestedRealestateFileRestrictRecordsRightHoldersAnotherPartnershipParticipantsLegalEntityNotResidentIncorporateCountry = {
  /** код из справочника */
  code?: InputMaybe<Scalars['NumberString']['input']>;
  /** значение */
  value?: InputMaybe<Scalars['String']['input']>;
};

export type TInputNestedRealestateFileRestrictRecordsRightHoldersAnotherPartnershipParticipantsLegalEntityNotResidentIncorporationForm = {
  /** код из справочника */
  code?: InputMaybe<Scalars['NumberString']['input']>;
  /** значение */
  value?: InputMaybe<Scalars['String']['input']>;
};

export type TInputNestedRealestateFileRestrictRecordsRightHoldersAnotherPartnershipParticipantsLegalEntityResident = {
  /** Организационно-правовая форма */
  incorporationForm?: InputMaybe<TInputNestedRealestateFileRestrictRecordsRightHoldersAnotherPartnershipParticipantsLegalEntityResidentIncorporationForm>;
  inn?: InputMaybe<Scalars['String']['input']>;
  ogrn?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type TInputNestedRealestateFileRestrictRecordsRightHoldersAnotherPartnershipParticipantsLegalEntityResidentIncorporationForm = {
  /** код из справочника */
  code?: InputMaybe<Scalars['NumberString']['input']>;
  /** значение */
  value?: InputMaybe<Scalars['String']['input']>;
};

export type TInputNestedRealestateFileRestrictRecordsRightHoldersIndividual = {
  birthDate?: InputMaybe<Scalars['BirthDate']['input']>;
  birthPlace?: InputMaybe<Scalars['String']['input']>;
  /** Гражданство */
  citizenship?: InputMaybe<TInputNestedRealestateFileRestrictRecordsRightHoldersIndividualCitizenship>;
  /** Связь с правообладателем */
  contacts?: InputMaybe<TInputNestedRealestateFileRestrictRecordsRightHoldersIndividualContacts>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  /** Документ, удостоверяющий личность */
  identityDocument?: InputMaybe<TInputNestedRealestateFileRestrictRecordsRightHoldersIndividualIdentityDocument>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  middleName?: InputMaybe<Scalars['String']['input']>;
  snils?: InputMaybe<Scalars['String']['input']>;
  /** Тип физического лица */
  type?: InputMaybe<TInputNestedRealestateFileRestrictRecordsRightHoldersIndividualType>;
};

export type TInputNestedRealestateFileRestrictRecordsRightHoldersIndividualCitizenship = {
  /** Страна гражданства */
  country?: InputMaybe<TInputNestedRealestateFileRestrictRecordsRightHoldersIndividualCitizenshipCountry>;
  /** Без гражданства [по документации тут какой-то текст должен быть] */
  noCitizenship?: InputMaybe<Scalars['String']['input']>;
};

export type TInputNestedRealestateFileRestrictRecordsRightHoldersIndividualCitizenshipCountry = {
  code?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type TInputNestedRealestateFileRestrictRecordsRightHoldersIndividualContacts = {
  email?: InputMaybe<Scalars['String']['input']>;
  /** ! Возможно в документации ошибка: mailing_addess */
  mailingAddress?: InputMaybe<Scalars['String']['input']>;
};

export type TInputNestedRealestateFileRestrictRecordsRightHoldersIndividualIdentityDocument = {
  /** Код документа */
  code?: InputMaybe<TInputNestedRealestateFileRestrictRecordsRightHoldersIndividualIdentityDocumentCode>;
  /** Дата документа */
  date?: InputMaybe<Scalars['DateTimeISO']['input']>;
  /** Нотариальное удостоверение документа */
  docNotarized?: InputMaybe<TInputNestedRealestateFileRestrictRecordsRightHoldersIndividualIdentityDocumentDocNotarized>;
  /** Кем выдан (Организация, выдавшая документ) */
  issuer?: InputMaybe<Scalars['String']['input']>;
  /** Наименование */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Номер документа */
  number?: InputMaybe<Scalars['String']['input']>;
  /** Серия документа */
  series?: InputMaybe<Scalars['String']['input']>;
  /** Особые отметки */
  specialMarks?: InputMaybe<Scalars['String']['input']>;
};

export type TInputNestedRealestateFileRestrictRecordsRightHoldersIndividualIdentityDocumentCode = {
  /** код из справочника */
  code?: InputMaybe<Scalars['NumberString']['input']>;
  /** значение */
  value?: InputMaybe<Scalars['String']['input']>;
};

export type TInputNestedRealestateFileRestrictRecordsRightHoldersIndividualIdentityDocumentDocNotarized = {
  /** Дата нотариального удостоверения */
  notarizeDate?: InputMaybe<Scalars['String']['input']>;
  /** Номер в реестре регистрации нотариальных действий */
  notaryActionNum?: InputMaybe<Scalars['String']['input']>;
  /** Фамилия и инициалы нотариуса */
  notaryName?: InputMaybe<Scalars['String']['input']>;
};

export type TInputNestedRealestateFileRestrictRecordsRightHoldersIndividualType = {
  /** код из справочника */
  code?: InputMaybe<Scalars['NumberString']['input']>;
  /** значение */
  value?: InputMaybe<Scalars['String']['input']>;
};

export type TInputNestedRealestateFileRestrictRecordsRightHoldersLegalEntity = {
  contacts?: InputMaybe<TInputNestedRealestateFileRestrictRecordsRightHoldersLegalEntityContacts>;
  entity?: InputMaybe<TInputNestedRealestateFileRestrictRecordsRightHoldersLegalEntityEntity>;
  /** Тип юридического лица */
  type?: InputMaybe<TInputNestedRealestateFileRestrictRecordsRightHoldersLegalEntityType>;
};

export type TInputNestedRealestateFileRestrictRecordsRightHoldersLegalEntityContacts = {
  email?: InputMaybe<Scalars['String']['input']>;
  /** ! Возможно в документации ошибка: mailing_addess */
  mailingAddress?: InputMaybe<Scalars['String']['input']>;
};

export type TInputNestedRealestateFileRestrictRecordsRightHoldersLegalEntityEntity = {
  /** Орган государственной власти, орган местного самоуправления, иной государственный орган */
  governmentEntity?: InputMaybe<TInputNestedRealestateFileRestrictRecordsRightHoldersLegalEntityEntityGovernmentEntity>;
  /** Иностранное юридическое лицо */
  notResident?: InputMaybe<TInputNestedRealestateFileRestrictRecordsRightHoldersLegalEntityEntityNotResident>;
  /** Российское юридическое лицо */
  resident?: InputMaybe<TInputNestedRealestateFileRestrictRecordsRightHoldersLegalEntityEntityResident>;
};

export type TInputNestedRealestateFileRestrictRecordsRightHoldersLegalEntityEntityGovernmentEntity = {
  inn?: InputMaybe<Scalars['String']['input']>;
  ogrn?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type TInputNestedRealestateFileRestrictRecordsRightHoldersLegalEntityEntityNotResident = {
  /** Страна регистрации (инкорпорации) */
  incorporateCountry?: InputMaybe<TInputNestedRealestateFileRestrictRecordsRightHoldersLegalEntityEntityNotResidentIncorporateCountry>;
  /** Организационно-правовая форма */
  incorporationForm?: InputMaybe<TInputNestedRealestateFileRestrictRecordsRightHoldersLegalEntityEntityNotResidentIncorporationForm>;
  inn?: InputMaybe<Scalars['String']['input']>;
  /** Адрес (местонахождение) в стране регистрации (инкорпорации) */
  regAddress?: InputMaybe<Scalars['String']['input']>;
  /** Дата регистрации */
  registrationDate?: InputMaybe<Scalars['String']['input']>;
  /** Регистрационный номер */
  registrationNumber?: InputMaybe<Scalars['String']['input']>;
  /** Наименование регистрирующего органа */
  registrationOrgan?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type TInputNestedRealestateFileRestrictRecordsRightHoldersLegalEntityEntityNotResidentIncorporateCountry = {
  /** код из справочника */
  code?: InputMaybe<Scalars['NumberString']['input']>;
  /** значение */
  value?: InputMaybe<Scalars['String']['input']>;
};

export type TInputNestedRealestateFileRestrictRecordsRightHoldersLegalEntityEntityNotResidentIncorporationForm = {
  /** код из справочника */
  code?: InputMaybe<Scalars['NumberString']['input']>;
  /** значение */
  value?: InputMaybe<Scalars['String']['input']>;
};

export type TInputNestedRealestateFileRestrictRecordsRightHoldersLegalEntityEntityResident = {
  /** Организационно-правовая форма */
  incorporationForm?: InputMaybe<TInputNestedRealestateFileRestrictRecordsRightHoldersLegalEntityEntityResidentIncorporationForm>;
  inn?: InputMaybe<Scalars['String']['input']>;
  ogrn?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type TInputNestedRealestateFileRestrictRecordsRightHoldersLegalEntityEntityResidentIncorporationForm = {
  /** код из справочника */
  code?: InputMaybe<Scalars['NumberString']['input']>;
  /** значение */
  value?: InputMaybe<Scalars['String']['input']>;
};

export type TInputNestedRealestateFileRestrictRecordsRightHoldersLegalEntityType = {
  /** код из справочника */
  code?: InputMaybe<Scalars['NumberString']['input']>;
  /** значение */
  value?: InputMaybe<Scalars['String']['input']>;
};

export type TInputNestedRealestateFileRestrictRecordsRightHoldersPublicFormation = {
  /** Иностранное государство */
  foreign?: InputMaybe<Scalars['String']['input']>;
  /** Наименование муниципального образования */
  municipality?: InputMaybe<Scalars['String']['input']>;
  /** Российская Федерация */
  russia?: InputMaybe<TInputNestedRealestateFileRestrictRecordsRightHoldersPublicFormationRussia>;
  /** Наименование субъекта Российской Федерации */
  subjectOfRf?: InputMaybe<TInputNestedRealestateFileRestrictRecordsRightHoldersPublicFormationSubjectOfRf>;
  /** Союзное государство */
  union?: InputMaybe<Scalars['String']['input']>;
};

export type TInputNestedRealestateFileRestrictRecordsRightHoldersPublicFormationRussia = {
  /** код из справочника */
  code?: InputMaybe<Scalars['NumberString']['input']>;
  /** значение */
  value?: InputMaybe<Scalars['String']['input']>;
};

export type TInputNestedRealestateFileRestrictRecordsRightHoldersPublicFormationSubjectOfRf = {
  /** код из справочника */
  code?: InputMaybe<Scalars['NumberString']['input']>;
  /** значение */
  value?: InputMaybe<Scalars['String']['input']>;
};

export type TInputNestedRealestateFileRestrictRecordsUnderlyingDocuments = {
  code?: InputMaybe<TInputNestedRealestateFileRestrictRecordsUnderlyingDocumentsCode>;
  date?: InputMaybe<Scalars['DateTimeISO']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type TInputNestedRealestateFileRestrictRecordsUnderlyingDocumentsCode = {
  /** код из справочника */
  code?: InputMaybe<Scalars['NumberString']['input']>;
  /** значение */
  value?: InputMaybe<Scalars['String']['input']>;
};

export type TInputNestedRealestateFileRightRecordRecordInfo = {
  /** Дата снятия с учета / регистрации */
  cancelDate?: InputMaybe<Scalars['String']['input']>;
  /** Дата постановки на учет / регистрации */
  registrationDate?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type TInputNestedRealestateFileRightRecordRightData = {
  reinstatement?: InputMaybe<Scalars['String']['input']>;
  rightNumber: Scalars['String']['input'];
  rightType?: InputMaybe<TInputNestedRealestateFileRightRecordRightDataRightType>;
  shareDescription?: InputMaybe<Scalars['String']['input']>;
  /** Размер доли в праве */
  shares?: InputMaybe<Array<InputMaybe<TInputNestedRealestateFileRightRecordRightDataShares>>>;
};

export type TInputNestedRealestateFileRightRecordRightDataRightType = {
  /** код из справочника */
  code?: InputMaybe<Scalars['NumberString']['input']>;
  /** значение */
  value?: InputMaybe<Scalars['String']['input']>;
};

export type TInputNestedRealestateFileRightRecordRightDataShares = {
  /** Размер доли в праве общей долевой собственности на общее имущество */
  roomOwnersShare?: InputMaybe<Scalars['String']['input']>;
  /** Размер доли в праве */
  share?: InputMaybe<TInputNestedRealestateFileRightRecordRightDataSharesShare>;
  /** Размер доли в праве в баллогектарах */
  shareBalHectare?: InputMaybe<Scalars['Int']['input']>;
  /** Размер доли в праве в гектарах */
  shareHectare?: InputMaybe<Scalars['Int']['input']>;
  /** Не указан размер доли в праве общей долевой собственности на общее имущество, в том числе на земельный участок, собственников помещений, машиномест в здании, если объектом недвижимости является помещение, машиноместо в здании */
  shareUnknown?: InputMaybe<TInputNestedRealestateFileRightRecordRightDataSharesShareUnknown>;
};

export type TInputNestedRealestateFileRightRecordRightDataSharesShare = {
  denominator?: InputMaybe<Scalars['Int']['input']>;
  numerator?: InputMaybe<Scalars['Int']['input']>;
};

export type TInputNestedRealestateFileRightRecordRightDataSharesShareUnknown = {
  cadNumber?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
};

export type TInputNestedRealestateFileRightRecordRightHolders = {
  /** Иное лицо, в пользу которого установлены ограничения права и обременения объекта недвижимости */
  another?: InputMaybe<TInputNestedRealestateFileRightRecordRightHoldersAnother>;
  /** Физическое лицо */
  individual?: InputMaybe<TInputNestedRealestateFileRightRecordRightHoldersIndividual>;
  /** Юридическое лицо, орган власти */
  legalEntity?: InputMaybe<TInputNestedRealestateFileRightRecordRightHoldersLegalEntity>;
  /** Публично-правовое образование */
  publicFormation?: InputMaybe<TInputNestedRealestateFileRightRecordRightHoldersPublicFormation>;
  /** Публичный сервитут */
  publicServitude?: InputMaybe<Scalars['String']['input']>;
  /** Не определено (тип undefined в документации) */
  somethingElse?: InputMaybe<Scalars['String']['input']>;
};

export type TInputNestedRealestateFileRightRecordRightHoldersAnother = {
  /** Собственники помещений в многоквартирном доме */
  aparthouseOwners?: InputMaybe<Scalars['String']['input']>;
  /** Владельцы облигаций */
  bondsHolders?: InputMaybe<TInputNestedRealestateFileRightRecordRightHoldersAnotherBondsHolders>;
  /** Индивидуальное обозначение, идентифицирующее ипотечные сертификаты участия, в интересах владельцев которых осуществляется доверительное управление таким ипотечным покрытием */
  certificatesHolders?: InputMaybe<Scalars['String']['input']>;
  /** Участники долевого строительства */
  equityParticipantsInfo?: InputMaybe<Scalars['String']['input']>;
  /** Название (индивидуальное обозначение), идентифицирующее паевой инвестиционный фонд */
  investmentUnitOwner?: InputMaybe<Scalars['String']['input']>;
  /** Участники долевого строительства по договорам участия в долевом строительстве, которым не переданы объекты долевого строительства */
  notEquityParticipantsInfo?: InputMaybe<Scalars['String']['input']>;
  /** Иной субъект */
  other?: InputMaybe<TInputNestedRealestateFileRightRecordRightHoldersAnotherOther>;
  /** Инвестиционное товарищество */
  partnership?: InputMaybe<TInputNestedRealestateFileRightRecordRightHoldersAnotherPartnership>;
};

export type TInputNestedRealestateFileRightRecordRightHoldersAnotherBondsHolders = {
  /** Дата государственной регистрации номера выпуска облигаций */
  issueDate?: InputMaybe<Scalars['String']['input']>;
  /** Государственный регистрационный номер выпуска облигаций */
  number?: InputMaybe<Scalars['String']['input']>;
};

export type TInputNestedRealestateFileRightRecordRightHoldersAnotherOther = {
  /** Комментарий */
  comment?: InputMaybe<Scalars['String']['input']>;
  contacts?: InputMaybe<TInputNestedRealestateFileRightRecordRightHoldersAnotherOtherContacts>;
  /** Наименование для печати */
  printText?: InputMaybe<Scalars['String']['input']>;
  /** Регистрирующий орган */
  registrationOrgan?: InputMaybe<Scalars['String']['input']>;
  /** Краткое наименование */
  shortTitle?: InputMaybe<Scalars['String']['input']>;
  /** Наименование */
  title?: InputMaybe<Scalars['String']['input']>;
};

export type TInputNestedRealestateFileRightRecordRightHoldersAnotherOtherContacts = {
  email?: InputMaybe<Scalars['String']['input']>;
  /** ! Возможно в документации ошибка: mailing_addess */
  mailingAddress?: InputMaybe<Scalars['String']['input']>;
};

export type TInputNestedRealestateFileRightRecordRightHoldersAnotherPartnership = {
  /** Участник договора инвестиционного товарищества */
  participants?: InputMaybe<Array<InputMaybe<TInputNestedRealestateFileRightRecordRightHoldersAnotherPartnershipParticipants>>>;
};

export type TInputNestedRealestateFileRightRecordRightHoldersAnotherPartnershipParticipants = {
  contacts?: InputMaybe<TInputNestedRealestateFileRightRecordRightHoldersAnotherPartnershipParticipantsContacts>;
  legalEntity?: InputMaybe<TInputNestedRealestateFileRightRecordRightHoldersAnotherPartnershipParticipantsLegalEntity>;
};

export type TInputNestedRealestateFileRightRecordRightHoldersAnotherPartnershipParticipantsContacts = {
  email?: InputMaybe<Scalars['String']['input']>;
  /** ! Возможно в документации ошибка: mailing_addess */
  mailingAddress?: InputMaybe<Scalars['String']['input']>;
};

export type TInputNestedRealestateFileRightRecordRightHoldersAnotherPartnershipParticipantsLegalEntity = {
  notResident?: InputMaybe<TInputNestedRealestateFileRightRecordRightHoldersAnotherPartnershipParticipantsLegalEntityNotResident>;
  resident?: InputMaybe<TInputNestedRealestateFileRightRecordRightHoldersAnotherPartnershipParticipantsLegalEntityResident>;
};

export type TInputNestedRealestateFileRightRecordRightHoldersAnotherPartnershipParticipantsLegalEntityNotResident = {
  /** Страна регистрации (инкорпорации) */
  incorporateCountry?: InputMaybe<TInputNestedRealestateFileRightRecordRightHoldersAnotherPartnershipParticipantsLegalEntityNotResidentIncorporateCountry>;
  /** Организационно-правовая форма */
  incorporationForm?: InputMaybe<TInputNestedRealestateFileRightRecordRightHoldersAnotherPartnershipParticipantsLegalEntityNotResidentIncorporationForm>;
  inn?: InputMaybe<Scalars['String']['input']>;
  /** Адрес (местонахождение) в стране регистрации (инкорпорации) */
  regAddress?: InputMaybe<Scalars['String']['input']>;
  /** Дата регистрации */
  registrationDate?: InputMaybe<Scalars['String']['input']>;
  /** Регистрационный номер */
  registrationNumber?: InputMaybe<Scalars['String']['input']>;
  /** Наименование регистрирующего органа */
  registrationOrgan?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type TInputNestedRealestateFileRightRecordRightHoldersAnotherPartnershipParticipantsLegalEntityNotResidentIncorporateCountry = {
  /** код из справочника */
  code?: InputMaybe<Scalars['NumberString']['input']>;
  /** значение */
  value?: InputMaybe<Scalars['String']['input']>;
};

export type TInputNestedRealestateFileRightRecordRightHoldersAnotherPartnershipParticipantsLegalEntityNotResidentIncorporationForm = {
  /** код из справочника */
  code?: InputMaybe<Scalars['NumberString']['input']>;
  /** значение */
  value?: InputMaybe<Scalars['String']['input']>;
};

export type TInputNestedRealestateFileRightRecordRightHoldersAnotherPartnershipParticipantsLegalEntityResident = {
  /** Организационно-правовая форма */
  incorporationForm?: InputMaybe<TInputNestedRealestateFileRightRecordRightHoldersAnotherPartnershipParticipantsLegalEntityResidentIncorporationForm>;
  inn?: InputMaybe<Scalars['String']['input']>;
  ogrn?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type TInputNestedRealestateFileRightRecordRightHoldersAnotherPartnershipParticipantsLegalEntityResidentIncorporationForm = {
  /** код из справочника */
  code?: InputMaybe<Scalars['NumberString']['input']>;
  /** значение */
  value?: InputMaybe<Scalars['String']['input']>;
};

export type TInputNestedRealestateFileRightRecordRightHoldersIndividual = {
  birthDate?: InputMaybe<Scalars['BirthDate']['input']>;
  birthPlace?: InputMaybe<Scalars['String']['input']>;
  /** Гражданство */
  citizenship?: InputMaybe<TInputNestedRealestateFileRightRecordRightHoldersIndividualCitizenship>;
  /** Связь с правообладателем */
  contacts?: InputMaybe<TInputNestedRealestateFileRightRecordRightHoldersIndividualContacts>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  /** Документ, удостоверяющий личность */
  identityDocument?: InputMaybe<TInputNestedRealestateFileRightRecordRightHoldersIndividualIdentityDocument>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  middleName?: InputMaybe<Scalars['String']['input']>;
  snils?: InputMaybe<Scalars['String']['input']>;
  /** Тип физического лица */
  type?: InputMaybe<TInputNestedRealestateFileRightRecordRightHoldersIndividualType>;
};

export type TInputNestedRealestateFileRightRecordRightHoldersIndividualCitizenship = {
  /** Страна гражданства */
  country?: InputMaybe<TInputNestedRealestateFileRightRecordRightHoldersIndividualCitizenshipCountry>;
  /** Без гражданства [по документации тут какой-то текст должен быть] */
  noCitizenship?: InputMaybe<Scalars['String']['input']>;
};

export type TInputNestedRealestateFileRightRecordRightHoldersIndividualCitizenshipCountry = {
  code?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type TInputNestedRealestateFileRightRecordRightHoldersIndividualContacts = {
  email?: InputMaybe<Scalars['String']['input']>;
  /** ! Возможно в документации ошибка: mailing_addess */
  mailingAddress?: InputMaybe<Scalars['String']['input']>;
};

export type TInputNestedRealestateFileRightRecordRightHoldersIndividualIdentityDocument = {
  /** Код документа */
  code?: InputMaybe<TInputNestedRealestateFileRightRecordRightHoldersIndividualIdentityDocumentCode>;
  /** Дата документа */
  date?: InputMaybe<Scalars['DateTimeISO']['input']>;
  /** Нотариальное удостоверение документа */
  docNotarized?: InputMaybe<TInputNestedRealestateFileRightRecordRightHoldersIndividualIdentityDocumentDocNotarized>;
  /** Кем выдан (Организация, выдавшая документ) */
  issuer?: InputMaybe<Scalars['String']['input']>;
  /** Наименование */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Номер документа */
  number?: InputMaybe<Scalars['String']['input']>;
  /** Серия документа */
  series?: InputMaybe<Scalars['String']['input']>;
  /** Особые отметки */
  specialMarks?: InputMaybe<Scalars['String']['input']>;
};

export type TInputNestedRealestateFileRightRecordRightHoldersIndividualIdentityDocumentCode = {
  /** код из справочника */
  code?: InputMaybe<Scalars['NumberString']['input']>;
  /** значение */
  value?: InputMaybe<Scalars['String']['input']>;
};

export type TInputNestedRealestateFileRightRecordRightHoldersIndividualIdentityDocumentDocNotarized = {
  /** Дата нотариального удостоверения */
  notarizeDate?: InputMaybe<Scalars['String']['input']>;
  /** Номер в реестре регистрации нотариальных действий */
  notaryActionNum?: InputMaybe<Scalars['String']['input']>;
  /** Фамилия и инициалы нотариуса */
  notaryName?: InputMaybe<Scalars['String']['input']>;
};

export type TInputNestedRealestateFileRightRecordRightHoldersIndividualType = {
  /** код из справочника */
  code?: InputMaybe<Scalars['NumberString']['input']>;
  /** значение */
  value?: InputMaybe<Scalars['String']['input']>;
};

export type TInputNestedRealestateFileRightRecordRightHoldersLegalEntity = {
  contacts?: InputMaybe<TInputNestedRealestateFileRightRecordRightHoldersLegalEntityContacts>;
  entity?: InputMaybe<TInputNestedRealestateFileRightRecordRightHoldersLegalEntityEntity>;
  /** Тип юридического лица */
  type?: InputMaybe<TInputNestedRealestateFileRightRecordRightHoldersLegalEntityType>;
};

export type TInputNestedRealestateFileRightRecordRightHoldersLegalEntityContacts = {
  email?: InputMaybe<Scalars['String']['input']>;
  /** ! Возможно в документации ошибка: mailing_addess */
  mailingAddress?: InputMaybe<Scalars['String']['input']>;
};

export type TInputNestedRealestateFileRightRecordRightHoldersLegalEntityEntity = {
  /** Орган государственной власти, орган местного самоуправления, иной государственный орган */
  governmentEntity?: InputMaybe<TInputNestedRealestateFileRightRecordRightHoldersLegalEntityEntityGovernmentEntity>;
  /** Иностранное юридическое лицо */
  notResident?: InputMaybe<TInputNestedRealestateFileRightRecordRightHoldersLegalEntityEntityNotResident>;
  /** Российское юридическое лицо */
  resident?: InputMaybe<TInputNestedRealestateFileRightRecordRightHoldersLegalEntityEntityResident>;
};

export type TInputNestedRealestateFileRightRecordRightHoldersLegalEntityEntityGovernmentEntity = {
  inn?: InputMaybe<Scalars['String']['input']>;
  ogrn?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type TInputNestedRealestateFileRightRecordRightHoldersLegalEntityEntityNotResident = {
  /** Страна регистрации (инкорпорации) */
  incorporateCountry?: InputMaybe<TInputNestedRealestateFileRightRecordRightHoldersLegalEntityEntityNotResidentIncorporateCountry>;
  /** Организационно-правовая форма */
  incorporationForm?: InputMaybe<TInputNestedRealestateFileRightRecordRightHoldersLegalEntityEntityNotResidentIncorporationForm>;
  inn?: InputMaybe<Scalars['String']['input']>;
  /** Адрес (местонахождение) в стране регистрации (инкорпорации) */
  regAddress?: InputMaybe<Scalars['String']['input']>;
  /** Дата регистрации */
  registrationDate?: InputMaybe<Scalars['String']['input']>;
  /** Регистрационный номер */
  registrationNumber?: InputMaybe<Scalars['String']['input']>;
  /** Наименование регистрирующего органа */
  registrationOrgan?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type TInputNestedRealestateFileRightRecordRightHoldersLegalEntityEntityNotResidentIncorporateCountry = {
  /** код из справочника */
  code?: InputMaybe<Scalars['NumberString']['input']>;
  /** значение */
  value?: InputMaybe<Scalars['String']['input']>;
};

export type TInputNestedRealestateFileRightRecordRightHoldersLegalEntityEntityNotResidentIncorporationForm = {
  /** код из справочника */
  code?: InputMaybe<Scalars['NumberString']['input']>;
  /** значение */
  value?: InputMaybe<Scalars['String']['input']>;
};

export type TInputNestedRealestateFileRightRecordRightHoldersLegalEntityEntityResident = {
  /** Организационно-правовая форма */
  incorporationForm?: InputMaybe<TInputNestedRealestateFileRightRecordRightHoldersLegalEntityEntityResidentIncorporationForm>;
  inn?: InputMaybe<Scalars['String']['input']>;
  ogrn?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type TInputNestedRealestateFileRightRecordRightHoldersLegalEntityEntityResidentIncorporationForm = {
  /** код из справочника */
  code?: InputMaybe<Scalars['NumberString']['input']>;
  /** значение */
  value?: InputMaybe<Scalars['String']['input']>;
};

export type TInputNestedRealestateFileRightRecordRightHoldersLegalEntityType = {
  /** код из справочника */
  code?: InputMaybe<Scalars['NumberString']['input']>;
  /** значение */
  value?: InputMaybe<Scalars['String']['input']>;
};

export type TInputNestedRealestateFileRightRecordRightHoldersPublicFormation = {
  /** Иностранное государство */
  foreign?: InputMaybe<Scalars['String']['input']>;
  /** Наименование муниципального образования */
  municipality?: InputMaybe<Scalars['String']['input']>;
  /** Российская Федерация */
  russia?: InputMaybe<TInputNestedRealestateFileRightRecordRightHoldersPublicFormationRussia>;
  /** Наименование субъекта Российской Федерации */
  subjectOfRf?: InputMaybe<TInputNestedRealestateFileRightRecordRightHoldersPublicFormationSubjectOfRf>;
  /** Союзное государство */
  union?: InputMaybe<Scalars['String']['input']>;
};

export type TInputNestedRealestateFileRightRecordRightHoldersPublicFormationRussia = {
  /** код из справочника */
  code?: InputMaybe<Scalars['NumberString']['input']>;
  /** значение */
  value?: InputMaybe<Scalars['String']['input']>;
};

export type TInputNestedRealestateFileRightRecordRightHoldersPublicFormationSubjectOfRf = {
  /** код из справочника */
  code?: InputMaybe<Scalars['NumberString']['input']>;
  /** значение */
  value?: InputMaybe<Scalars['String']['input']>;
};

export type TInputNestedRealestateFileRightRecordThirdPartyConsents = {
  /** Не представлено согласие на совершение сделки */
  dissentingEntities?: InputMaybe<TInputNestedRealestateFileRightRecordThirdPartyConsentsDissentingEntities>;
  /** Федеральный закон, которым предусмотрено получение согласия на совершение сделки */
  law?: InputMaybe<TInputNestedRealestateFileRightRecordThirdPartyConsentsLaw>;
  /** Содержание отметки при возникновении / погашении */
  markContent?: InputMaybe<Scalars['String']['input']>;
};

export type TInputNestedRealestateFileRightRecordThirdPartyConsentsDissentingEntities = {
  /** Физическое лицо */
  individual?: InputMaybe<TInputNestedRealestateFileRightRecordThirdPartyConsentsDissentingEntitiesIndividual>;
  /** Юридическое лицо, орган власти, местного самоуправления */
  legalEntity?: InputMaybe<Scalars['String']['input']>;
};

export type TInputNestedRealestateFileRightRecordThirdPartyConsentsDissentingEntitiesIndividual = {
  firstName?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  middleName?: InputMaybe<Scalars['String']['input']>;
};

export type TInputNestedRealestateFileRightRecordThirdPartyConsentsLaw = {
  /** Статья */
  article?: InputMaybe<Scalars['String']['input']>;
  /** Дата */
  lawDate?: InputMaybe<Scalars['String']['input']>;
  /** Номер */
  number?: InputMaybe<Scalars['String']['input']>;
  /** Пункт */
  paragraph?: InputMaybe<Scalars['String']['input']>;
  /** Часть */
  section?: InputMaybe<Scalars['String']['input']>;
  /** Наименование */
  title?: InputMaybe<Scalars['String']['input']>;
};

export type TInputNestedRealestateFileRightRecordUnderlyingDocuments = {
  code?: InputMaybe<TInputNestedRealestateFileRightRecordUnderlyingDocumentsCode>;
  date?: InputMaybe<Scalars['DateTimeISO']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type TInputNestedRealestateFileRightRecordUnderlyingDocumentsCode = {
  /** код из справочника */
  code?: InputMaybe<Scalars['NumberString']['input']>;
  /** значение */
  value?: InputMaybe<Scalars['String']['input']>;
};

export type TInputNestedRealestateFileRoomRecords = {
  /** Расположение в пределах объекта недвижимости (планы этажа, части этажа, нескольких этажей) */
  locationInBuild?: InputMaybe<Array<InputMaybe<TInputNestedRealestateFileRoomRecordsLocationInBuild>>>;
  /** Общие сведения (кадастровый номер помещения) */
  object?: InputMaybe<TInputNestedRealestateFileRoomRecordsObject>;
};

export type TInputNestedRealestateFileRoomRecordsLocationInBuild = {
  /** Описание расположения */
  description?: InputMaybe<Scalars['String']['input']>;
  /** Номер этажа */
  floor?: InputMaybe<Scalars['Int']['input']>;
  /** Тип этажа */
  floorType?: InputMaybe<Scalars['Int']['input']>;
  /** Номер на поэтажном плане */
  planNumber?: InputMaybe<Scalars['String']['input']>;
  /** Планы */
  plans?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type TInputNestedRealestateFileRoomRecordsObject = {
  /** Кадастровый номер */
  cadNumber?: InputMaybe<Scalars['String']['input']>;
  /** Номер кадастрового квартала */
  quarterCadNumber?: InputMaybe<Scalars['String']['input']>;
  /** Вид объекта недвижимости */
  type?: InputMaybe<TInputNestedRealestateFileRoomRecordsObjectType>;
};

export type TInputNestedRealestateFileRoomRecordsObjectType = {
  /** код из справочника */
  code?: InputMaybe<Scalars['NumberString']['input']>;
  /** значение */
  value?: InputMaybe<Scalars['String']['input']>;
};

export type TInputNestedSberSber = {
  /** Владелец профиля (Сбер) */
  owner?: InputMaybe<TInputPeople>;
};

export type TInputNestedTBankTBank = {
  /** Флаги профиля [ТБанк] */
  flags?: InputMaybe<TInputTBankFlags>;
  /** Владелец профиля (ТБанк) */
  owner?: InputMaybe<TInputPeople>;
};

export type TInputOrganization = {
  /** Фактический адрес */
  actualAddress?: InputMaybe<Scalars['String']['input']>;
  bank?: InputMaybe<TInputNestedOrganizationBank>;
  ceo?: InputMaybe<TInputNestedOrganizationCeo>;
  /** Город организации */
  city?: InputMaybe<Scalars['String']['input']>;
  contact?: InputMaybe<TInputNestedOrganizationContact>;
  /** Email организации */
  email?: InputMaybe<Scalars['EmailAddress']['input']>;
  /** Количество сотрудников */
  employeesCount?: InputMaybe<Scalars['Int']['input']>;
  /** Идентификационный номер налогоплательщика организации (ИНН) */
  inn: Scalars['INN']['input'];
  /** КПП */
  kpp?: InputMaybe<Scalars['KPP']['input']>;
  /** Связь между организацией и заявкой */
  loanApplication?: InputMaybe<TInputLoanApplication>;
  /** Организация которая является основной у человека */
  mainOwner?: InputMaybe<TInputPeople>;
  /** Тип основного помещения */
  mainRoomType?: InputMaybe<EOrganizationRoomType>;
  /** Название организации */
  name?: InputMaybe<Scalars['String']['input']>;
  /** ОКАТО */
  okato?: InputMaybe<Scalars['String']['input']>;
  /** ОКПО */
  okpo?: InputMaybe<Scalars['String']['input']>;
  /** ОКВЭД */
  okved?: InputMaybe<Scalars['String']['input']>;
  owner?: InputMaybe<TInputNestedOrganizationOwner>;
  /** Список организаций пользователя (как владельца) */
  ownerPeople?: InputMaybe<TInputPeople>;
  /** Тип собственности помещения */
  ownershipRoomType?: InputMaybe<EOrgOwnershipRoomType>;
  /** Адрес регистрации */
  registrationAddress?: InputMaybe<Scalars['String']['input']>;
  /** Выручка компании */
  revenue?: InputMaybe<Scalars['Int']['input']>;
  /** Система налогооблажения */
  taxationType?: InputMaybe<EOrgTaxationType>;
  /** Сайт компании */
  webSiteUrl?: InputMaybe<Scalars['String']['input']>;
};

export type TInputPassport = {
  /** Дата регистрации */
  addressRegistrationDate?: InputMaybe<Scalars['DateTimeISO']['input']>;
  /** Вручную подтвержденный адрес регистрации в CRM */
  approvedRegistration?: InputMaybe<TInputHabitation>;
  /** Дата рождения */
  birthDate?: InputMaybe<Scalars['BirthDate']['input']>;
  /** Место рождения */
  birthPlace?: InputMaybe<Scalars['String']['input']>;
  /** Ведомство */
  departmentDoc?: InputMaybe<Scalars['String']['input']>;
  /** Имя */
  firstName?: InputMaybe<Scalars['StrictString']['input']>;
  /** Пол клиента */
  gender?: InputMaybe<EGender>;
  /** Дата выдачи */
  issueDate?: InputMaybe<Scalars['DateTimeISO']['input']>;
  /** Код подразделения */
  issueId?: InputMaybe<Scalars['IssueId']['input']>;
  /** Кем выдан паспорт */
  issuedBy?: InputMaybe<Scalars['String']['input']>;
  /** Фамилия */
  lastName?: InputMaybe<Scalars['StrictString']['input']>;
  /** Отчество */
  middleName?: InputMaybe<Scalars['StrictString']['input']>;
  /** Номер */
  number: Scalars['String']['input'];
  /** Временная ссылка для миграции People.passport в отдельный объект */
  people?: InputMaybe<TInputPeople>;
  /** Паспорт гражданина РФ [Альфа] */
  peopleFromAlfaPassport?: InputMaybe<TInputPeople>;
  peopleFromAlfaPassportHistory?: InputMaybe<TInputPeople>;
  /** Паспорт гражданина РФ [ЕСИА] */
  peopleFromEsiaPassport?: InputMaybe<TInputPeople>;
  /** Паспорт гражданина РФ [Сбер] */
  peopleFromSberPassport?: InputMaybe<TInputPeople>;
  peopleFromSberPassportHistory?: InputMaybe<TInputPeople>;
  /** Паспорт гражданина РФ [ТБанк] */
  peopleFromTBankPassport?: InputMaybe<TInputPeople>;
  peopleFromTBankPassportHistory?: InputMaybe<TInputPeople>;
  /** Вручную подтвержденный паспорт в CRM */
  profile?: InputMaybe<TInputCommon>;
  /** Паспорт гражданина РФ (ЕСИА) */
  profileFromESIAPassport?: InputMaybe<TInputEsia>;
  profileFromESIAPassportHistory?: InputMaybe<TInputEsia>;
  /** Паспорт гражданина РФ (Сбер) */
  profileFromSberPassport?: InputMaybe<TInputSber>;
  profileFromSberPassportHistory?: InputMaybe<TInputSber>;
  /** Паспорт гражданина РФ (ТБанк) */
  profileFromTBankPassport?: InputMaybe<TInputTBank>;
  profileFromTBankPassportHistory?: InputMaybe<TInputTBank>;
  /** Дата получения документа */
  receiptDocDate?: InputMaybe<Scalars['DateTimeISO']['input']>;
  /** Релевантность ESIA */
  relevance?: InputMaybe<EDocumentRelevance>;
  /** Серия */
  series: Scalars['String']['input'];
  /** Источник паспорта (manual или approved) */
  source?: InputMaybe<ESource>;
};

export type TInputPayoutIncome = {
  /** Список информации о 2-НДФЛ */
  NDFL2?: InputMaybe<Array<InputMaybe<TInputPayoutIncomeNdfl2>>>;
  /** Список информации о 2-НДФЛ */
  NDFL3?: InputMaybe<Array<InputMaybe<TInputPayoutIncomeNdfl3>>>;
  /** ИД документа ESIA */
  id?: InputMaybe<Scalars['String']['input']>;
  /** [Тут когда-то будет описание] */
  payout?: InputMaybe<Array<InputMaybe<TInputNestedPayoutIncomePayout>>>;
  person?: InputMaybe<TInputNestedPayoutIncomePerson>;
  /** Сведения о доходах физического лица, о выплатах, произведённых плательщиками страховых взносов в пользу физического лица */
  profile?: InputMaybe<TInputPeople>;
  /** Источник */
  source?: InputMaybe<ESource>;
  /** Отчетный год */
  year: Scalars['year']['input'];
};

export type TInputPayoutIncomeNdfl2 = {
  /** Список доходов */
  incomeTaxable?: InputMaybe<Array<InputMaybe<TInputNestedPayoutIncomeNdfl2IncomeTaxable>>>;
  /** Системное поле для генерации hash */
  index: Scalars['Int']['input'];
  /** Источник */
  source: ESource;
  taxAgent?: InputMaybe<TInputNestedPayoutIncomeNdfl2TaxAgent>;
  total?: InputMaybe<TInputNestedPayoutIncomeNdfl2Total>;
  /** Год дохода */
  year: Scalars['year']['input'];
};

export type TInputPayoutIncomeNdfl3 = {
  entrepreneurship?: InputMaybe<TInputNestedPayoutIncomeNdfl3Entrepreneurship>;
  income?: InputMaybe<TInputNestedPayoutIncomeNdfl3Income>;
  /** Системное поле для генерации hash */
  index: Scalars['Int']['input'];
  /** Источник */
  source: ESource;
  /** Год */
  year: Scalars['year']['input'];
};

export type TInputPeople = {
  /** Дополнительный доход, руб. */
  additionalIncome?: InputMaybe<Scalars['String']['input']>;
  /** Дополнительный телефон */
  additionalPhone?: InputMaybe<Scalars['PhoneNumber']['input']>;
  /** Владелец дополнительного телефона */
  additionalPhoneOwner?: InputMaybe<EAdditionalPhoneOwner>;
  additionalPhoneOwnerFIO?: InputMaybe<Scalars['String']['input']>;
  /** Псевдоним объекта */
  alias?: InputMaybe<Scalars['String']['input']>;
  /** Дата рождения */
  birthDate: Scalars['BirthDate']['input'];
  /** Место рождения */
  birthPlace?: InputMaybe<Scalars['String']['input']>;
  /** Страхователь в расчете КАСКО */
  cascoInsuredCars?: InputMaybe<Array<InputMaybe<TInputCar>>>;
  /** Гражданство */
  citizenship?: InputMaybe<ECitizenship>;
  creditRating?: InputMaybe<TInputNestedPeopleCreditRating>;
  creditSelection?: InputMaybe<TInputNestedPeopleCreditSelection>;
  /** Залоговое авто в кредитах */
  creditSelectionPledgeCar?: InputMaybe<TInputCar>;
  /** Адрес залога в кредитах */
  creditSelectionPledgeHabitation?: InputMaybe<TInputHabitation>;
  /** Количество иждивенцев */
  dependentsCount?: InputMaybe<EDependents>;
  documents?: InputMaybe<TInputNestedPeopleDocuments>;
  /** Водители */
  driveCars?: InputMaybe<Array<InputMaybe<TInputCar>>>;
  /** Уровень образования */
  education?: InputMaybe<EEducation>;
  /** Email. Адрес электронной почты */
  email?: InputMaybe<Scalars['EmailAddress']['input']>;
  /** Тип занятости */
  employmentType?: InputMaybe<EEmploymentType>;
  /** Недвижимость во владении */
  estate?: InputMaybe<Array<InputMaybe<TInputHabitation>>>;
  /** Количество детей */
  exactDependentsNumber?: InputMaybe<Scalars['String']['input']>;
  familyAssets?: InputMaybe<TInputNestedPeopleFamilyAssets>;
  /** Имя */
  firstName: Scalars['StrictString']['input'];
  /** Стоимость аренды квартиры, руб. */
  flatRentAmount?: InputMaybe<Scalars['String']['input']>;
  /** Пол */
  gender?: InputMaybe<EGender>;
  /** Договор страхования квартиры */
  habitationInsurance?: InputMaybe<Array<InputMaybe<TInputHabitationInsuranceAgreement>>>;
  /** Уникальный хеш клиента */
  hash?: InputMaybe<Scalars['String']['input']>;
  /** Флаг наличия квартиры */
  haveApartment?: InputMaybe<EPropertyType>;
  /** Идентификационный номер налогоплательщика (ИНН) */
  inn?: InputMaybe<Scalars['INN']['input']>;
  /** Страхуемая квартира */
  insuredHabitation?: InputMaybe<TInputHabitation>;
  /** Адрес страхования недвижимости */
  insuredHabitations?: InputMaybe<Array<InputMaybe<TInputHabitation>>>;
  internationalPassport?: InputMaybe<TInputNestedPeopleInternationalPassport>;
  job?: InputMaybe<TInputNestedPeopleJob>;
  /** Фамилия */
  lastName: Scalars['StrictString']['input'];
  /** Адрес проживания */
  livingHabitation?: InputMaybe<TInputHabitation>;
  /** Суммарный платеж по действующим кредитам, руб. */
  loanPaymentTotal?: InputMaybe<Scalars['String']['input']>;
  /** Ограничения на кредиты */
  loanRestrictions?: InputMaybe<TInputNestedPeopleLoanRestrictions>;
  /** Организация которая является основной у человека */
  mainOrganization?: InputMaybe<TInputOrganization>;
  /** Семейное положение */
  maritalStatus?: InputMaybe<EFamilyStatus>;
  mfo?: InputMaybe<TInputNestedPeopleMfo>;
  /** Отчество */
  middleName?: InputMaybe<Scalars['StrictString']['input']>;
  /** Мобильный номер */
  mobilePhone?: InputMaybe<Scalars['PhoneNumber']['input']>;
  /** Ежемесячный доход, руб. */
  monthlyIncome?: InputMaybe<Scalars['String']['input']>;
  /** Ипотечный договор */
  mortgageAgreement?: InputMaybe<Array<InputMaybe<TInputMortgageAgreement>>>;
  /** Адрес ипотеки */
  mortgageHabitations?: InputMaybe<TInputHabitation>;
  /** Нет отчества */
  noMiddleName?: InputMaybe<Scalars['Boolean']['input']>;
  /** Ссылка от заемщика на заявку */
  organizationLoanApps?: InputMaybe<Array<InputMaybe<TInputLoanApplication>>>;
  /** Список организаций пользователя (как владельца) */
  organizations?: InputMaybe<Array<InputMaybe<TInputOrganization>>>;
  osago?: InputMaybe<TInputNestedPeopleOsago>;
  /** Страхователь авто в ОСАГО */
  osagoInsuredCars?: InputMaybe<Array<InputMaybe<TInputCar>>>;
  /** Водители в расчете ОСАГО */
  osagoSelectedCars?: InputMaybe<Array<InputMaybe<TInputCar>>>;
  /** Владелец авто */
  ownCars?: InputMaybe<Array<InputMaybe<TInputCar>>>;
  /** Владельцы недвижимости */
  ownHabitations?: InputMaybe<Array<InputMaybe<TInputHabitation>>>;
  /** Принадлежность к владельцу профиля */
  ownerRelation?: InputMaybe<ERelationStatus>;
  /** Телефон */
  phone?: InputMaybe<Scalars['PhoneNumber']['input']>;
  physiology?: InputMaybe<TInputNestedPeoplePhysiology>;
  /** Залоговое авто в кредитах */
  pledgeCar?: InputMaybe<Array<InputMaybe<TInputCar>>>;
  /** Адрес залога в кредитах */
  pledgeHabitations?: InputMaybe<Array<InputMaybe<TInputHabitation>>>;
  /** Бывшее имя */
  previousFirstName?: InputMaybe<Scalars['String']['input']>;
  /** Бывшая фамилия */
  previousLastName?: InputMaybe<Scalars['StrictString']['input']>;
  /** Бывшее отчество */
  previousMiddleName?: InputMaybe<Scalars['StrictString']['input']>;
  /** Владелец профиля */
  profile?: InputMaybe<TInputProfile>;
  /** credit people */
  profileFromCreditPeople?: InputMaybe<TInputCommon>;
  /** mfo people */
  profileFromCreditRatingPeople?: InputMaybe<TInputCommon>;
  /** mfo people */
  profileFromMfoPeople?: InputMaybe<TInputCommon>;
  /** Mortgage People */
  profileFromMortgagePeople?: InputMaybe<TInputCommon>;
  /** mpl people */
  profileFromMplPeople?: InputMaybe<TInputCommon>;
  /** MSB People */
  profileFromMsbPeople?: InputMaybe<TInputCommon>;
  /** OSAGO People */
  profileFromOsagoPeople?: InputMaybe<TInputCommon>;
  /** Для записи данных клиента, получаемых от партнерских заявок. */
  profileFromWaybackPeople?: InputMaybe<TInputCommon>;
  /** Red people */
  profileRedPeople?: InputMaybe<TInputCommon>;
  /** Адрес регистрации! */
  registrationHabitation?: InputMaybe<TInputHabitation>;
  /** Расходы на аренду и ЖКХ в месяц, руб. */
  rentCost?: InputMaybe<Scalars['String']['input']>;
  /** Заработная плата, руб. */
  salary?: InputMaybe<Scalars['String']['input']>;
  /** Банк, в котором ведется зарплатный проект */
  salaryBank?: InputMaybe<Scalars['String']['input']>;
  /** Страховой номер индивидуального лицевого счёта (СНИЛС) */
  snils?: InputMaybe<Scalars['SNILS']['input']>;
  /** Документ, подтверждающий платежеспособность */
  solvencyProof?: InputMaybe<EIncomeConfirmation>;
  /** Какой источник данных использовался для создания объекта */
  source?: InputMaybe<ESource>;
  /** Тестовая ссылка */
  testo2o?: InputMaybe<TInputCar>;
  /** Причина отсутствия занятости */
  unemploymentReason?: InputMaybe<EUnemploymentReason>;
  /** Тестовое описание причины отсутствия занятости */
  unemploymentReasonText?: InputMaybe<Scalars['String']['input']>;
  /** Общий рабочий стаж */
  workExperience?: InputMaybe<EWorkExperience>;
};

export type TInputProductMeta = {
  meta?: InputMaybe<Scalars['String']['input']>;
};

export type TInputProfile = {
  Alfa?: InputMaybe<TInputNestedProfileAlfa>;
  ESIA?: InputMaybe<TInputNestedProfileEsia>;
  /** Флаги клиента MPL */
  MPLFlags?: InputMaybe<TInputMplClientFlags>;
  Sber?: InputMaybe<TInputNestedProfileSber>;
  TBank?: InputMaybe<TInputNestedProfileTBank>;
  /** Я принимаю оферту сервиса и условия обработки персональных данных */
  acceptOffer?: InputMaybe<Scalars['Boolean']['input']>;
  /** Дата и время согласия с офертой и условиями обработки персональных данных */
  acceptOfferTime?: InputMaybe<Scalars['String']['input']>;
  /** Вручную подтвержденный паспорт в CRM */
  approvedPassport?: InputMaybe<TInputPassport>;
  /** Аватар профиля */
  avatar?: InputMaybe<Scalars['String']['input']>;
  /** credit people */
  creditPeople?: InputMaybe<TInputPeople>;
  /** mfo people */
  creditRatingPeople?: InputMaybe<TInputPeople>;
  /** Email клиента */
  email?: InputMaybe<Scalars['EmailAddress']['input']>;
  emailConfirmed?: InputMaybe<Scalars['Boolean']['input']>;
  /** Имя identity */
  firstName?: InputMaybe<Scalars['String']['input']>;
  /** Фамилия identity */
  lastName?: InputMaybe<Scalars['String']['input']>;
  /** Введенный вручную вне какого-либо продукта автомобиль */
  manualInputCars?: InputMaybe<Array<InputMaybe<TInputCar>>>;
  /** Руками введенный адрес после регистрации ЕСИА */
  manualInputESIARegistrationHabitation?: InputMaybe<TInputHabitation>;
  /** Введенная вручную вне какого-либо продукта недвижимость */
  manualInputHabitations?: InputMaybe<Array<InputMaybe<TInputHabitation>>>;
  /** Мета информация */
  meta?: InputMaybe<TInputMeta>;
  /** mfo people */
  mfoPeople?: InputMaybe<TInputPeople>;
  /** Mortgage People */
  mortgagePeople?: InputMaybe<TInputPeople>;
  /** mpl people */
  mplPeople?: InputMaybe<TInputPeople>;
  /** MSB People */
  msbPeople?: InputMaybe<TInputPeople>;
  /** OSAGO People */
  osagoPeople?: InputMaybe<TInputPeople>;
  /** Владелец профиля */
  owner?: InputMaybe<TInputPeople>;
  phone?: InputMaybe<Scalars['PhoneNumber']['input']>;
  phoneConfirmed?: InputMaybe<Scalars['Boolean']['input']>;
  /** Red people */
  redPeople?: InputMaybe<TInputPeople>;
  /** Источник установки приложения */
  sourceInstallApp?: InputMaybe<Scalars['String']['input']>;
  /** Для записи данных клиента, получаемых от партнерских заявок. */
  waybackPeople?: InputMaybe<TInputPeople>;
};

export type TInputProfileRaw = {
  /** Я принимаю оферту сервиса и условия обработки персональных данных */
  acceptOffer?: InputMaybe<Scalars['Boolean']['input']>;
  /** Дата и время согласия с офертой и условиями обработки персональных данных */
  acceptOfferTime?: InputMaybe<Scalars['String']['input']>;
  /** Аватар профиля */
  avatar?: InputMaybe<Scalars['String']['input']>;
  /** Email клиента */
  email?: InputMaybe<Scalars['EmailAddress']['input']>;
  emailConfirmed?: InputMaybe<Scalars['Boolean']['input']>;
  /** Имя identity */
  firstName?: InputMaybe<Scalars['String']['input']>;
  /** Фамилия identity */
  lastName?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['PhoneNumber']['input']>;
  phoneConfirmed?: InputMaybe<Scalars['Boolean']['input']>;
  /** Источник установки приложения */
  sourceInstallApp?: InputMaybe<Scalars['String']['input']>;
};

export type TInputRealestateFile = {
  /** Местоположение машиномест в объекте недвижимости (план(ы) расположения машиноместа) */
  carParkingSpaceRecords?: InputMaybe<Array<InputMaybe<TInputNestedRealestateFileCarParkingSpaceRecords>>>;
  /** Сведения о правопритязаниях */
  claimRecords?: InputMaybe<Array<InputMaybe<TInputNestedRealestateFileClaimRecords>>>;
  /** Сведения об объекте недвижимости - сооружении */
  constructionRecord?: InputMaybe<TInputNestedRealestateFileConstructionRecord>;
  /** Сведения о сделках, совершенных без необходимого в силу закона согласия третьего лица, органа */
  dealRecords?: InputMaybe<Array<InputMaybe<TInputNestedRealestateFileDealRecords>>>;
  /** Реквизиты поступившего запроса */
  detailsRequest?: InputMaybe<TInputNestedRealestateFileDetailsRequest>;
  /** Реквизиты выписки */
  detailsStatement?: InputMaybe<TInputNestedRealestateFileDetailsStatement>;
  /** Сведения о невозможности государственной регистрации перехода, прекращения, ограничения права на земельный участок из земель сельскохозяйственного назначения или обременения такого земельного участка до завершения рассмотрения судом дела о его изъятии в связи с неиспользованием по целевому назначению или использованием с нарушением законодательства Российской Федерации */
  nonRegistrabilitys?: InputMaybe<Scalars['String']['input']>;
  /** Сведения о праве (бесхозяйное имущество) */
  ownerlessRightRecord?: InputMaybe<TInputNestedRealestateFileOwnerlessRightRecord>;
  /** !! Вычисляем на основании ключей в исходных данных */
  realestateRecord: TInputNestedRealestateFileRealestateRecord;
  /** Получатель выписки */
  recipientStatement?: InputMaybe<Scalars['String']['input']>;
  /** Ограничение прав и обременение объекта недвижимости */
  restrictRecords?: InputMaybe<Array<InputMaybe<TInputNestedRealestateFileRestrictRecords>>>;
  /** Права собственности */
  rightRecords?: InputMaybe<Array<InputMaybe<TInputRealestateFileRightRecord>>>;
  /** Местоположение помещений в объекте недвижимости (план(ы) расположения помещения) */
  roomRecords?: InputMaybe<Array<InputMaybe<TInputNestedRealestateFileRoomRecords>>>;
  /** Источник */
  source?: InputMaybe<ESource>;
  /** Статус записи об объекте недвижимости */
  status?: InputMaybe<Scalars['String']['input']>;
};

export type TInputRealestateFileRightRecord = {
  /** Заявленное в судебном порядке право требования */
  litigations?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Сведения о возражении в отношении зарегистрированного права */
  objections?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Личное участие правообладателя */
  personalParticipations?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  recordInfo?: InputMaybe<TInputNestedRealestateFileRightRecordRecordInfo>;
  /** Размер доли в праве */
  rightData: TInputNestedRealestateFileRightRecordRightData;
  rightHolders?: InputMaybe<Array<InputMaybe<TInputNestedRealestateFileRightRecordRightHolders>>>;
  /** Источник */
  source?: InputMaybe<ESource>;
  /** Сведения об осуществлении государственной регистрации сделки, права, ограничения права, совершенных без необходимого в силу закона согласия третьего лица, органа */
  thirdPartyConsents?: InputMaybe<Array<InputMaybe<TInputNestedRealestateFileRightRecordThirdPartyConsents>>>;
  underlyingDocuments?: InputMaybe<Array<InputMaybe<TInputNestedRealestateFileRightRecordUnderlyingDocuments>>>;
};

export type TInputSber = {
  Sber?: InputMaybe<TInputNestedSberSber>;
};

export type TInputTBank = {
  TBank?: InputMaybe<TInputNestedTBankTBank>;
};

export type TInputTBankFlags = {
  /** Статус идентификации пользователя */
  identificationStatus?: InputMaybe<Scalars['Boolean']['input']>;
  /** Флаги профиля [ТБанк] */
  profile?: InputMaybe<TInputProfile>;
  /** Статус самозанятости ТБанк */
  selfEmployedStatus?: InputMaybe<Scalars['Boolean']['input']>;
};

export type TInputTickInsuranceAgreement = {
  /** Дата начала договора страхования от клеща */
  contractAgreementDate?: InputMaybe<Scalars['DateTimeISO']['input']>;
  /** Дата окончания договора страхования от клеща */
  contractAgreementEndDate?: InputMaybe<Scalars['DateTimeISO']['input']>;
  /** Номер договора страхования от клеща */
  contractNumber: Scalars['String']['input'];
  /** Застрахованные от клеща люди */
  insuredPeople?: InputMaybe<Array<InputMaybe<TInputPeople>>>;
  /** Договор страхования от клеща */
  insurer?: InputMaybe<TInputPeople>;
  /** Дата окончания действия полиса */
  policyEndDate?: InputMaybe<Scalars['DateTimeISO']['input']>;
  /** Дата начала действия полиса */
  policyStartDate?: InputMaybe<Scalars['DateTimeISO']['input']>;
  /** Область договора страхования от клеща */
  region?: InputMaybe<TInputHabitation>;
  /** Регион страхования от клеща */
  region1?: InputMaybe<Scalars['String']['input']>;
};

/** Filter type for Int scalar */
export type TIntFilter = {
  /** [$all] Полное совпадение значений */
  ALL?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  /** [$eq] Равенство значений */
  EQ?: InputMaybe<Scalars['Int']['input']>;
  /** [$gt] Больше переданного значения */
  GT?: InputMaybe<Scalars['Int']['input']>;
  /** [$gte] Больше или равно переданному значению */
  GTE?: InputMaybe<Scalars['Int']['input']>;
  /** [$in] Одно из значений */
  IN?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  /** [$lt] Меньше переданного значения */
  LT?: InputMaybe<Scalars['Int']['input']>;
  /** [$lte] Меньше или равно переданного значения */
  LTE?: InputMaybe<Scalars['Int']['input']>;
  /** [$ne] Не равно переданному значению */
  NE?: InputMaybe<Scalars['Int']['input']>;
  /** [$nin] Не равно ни одному из переданных значений */
  NIN?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  /** [$not] Логическое отрицание */
  NOT?: InputMaybe<TIntNotFilter>;
};

/** Filter type for $not of Int scalar */
export type TIntNotFilter = {
  /** [$all] Полное совпадение значений */
  ALL?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  /** [$eq] Равенство значений */
  EQ?: InputMaybe<Scalars['Int']['input']>;
  /** [$gt] Больше переданного значения */
  GT?: InputMaybe<Scalars['Int']['input']>;
  /** [$gte] Больше или равно переданному значению */
  GTE?: InputMaybe<Scalars['Int']['input']>;
  /** [$in] Одно из значений */
  IN?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  /** [$lt] Меньше переданного значения */
  LT?: InputMaybe<Scalars['Int']['input']>;
  /** [$lte] Меньше или равно переданного значения */
  LTE?: InputMaybe<Scalars['Int']['input']>;
  /** [$ne] Не равно переданному значению */
  NE?: InputMaybe<Scalars['Int']['input']>;
  /** [$nin] Не равно ни одному из переданных значений */
  NIN?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
};

/** Filter type for IssueId scalar */
export type TIssueIdFilter = {
  /** [$all] Полное совпадение значений */
  ALL?: InputMaybe<Array<InputMaybe<Scalars['IssueId']['input']>>>;
  /** [$eq] Равенство значений */
  EQ?: InputMaybe<Scalars['IssueId']['input']>;
  /** [$in] Одно из значений */
  IN?: InputMaybe<Array<InputMaybe<Scalars['IssueId']['input']>>>;
  /** [$ne] Не равно переданному значению */
  NE?: InputMaybe<Scalars['IssueId']['input']>;
  /** [$nin] Не равно ни одному из переданных значений */
  NIN?: InputMaybe<Array<InputMaybe<Scalars['IssueId']['input']>>>;
  /** [$not] Логическое отрицание */
  NOT?: InputMaybe<TIssueIdNotFilter>;
};

/** Filter type for $not of IssueId scalar */
export type TIssueIdNotFilter = {
  /** [$all] Полное совпадение значений */
  ALL?: InputMaybe<Array<InputMaybe<Scalars['IssueId']['input']>>>;
  /** [$eq] Равенство значений */
  EQ?: InputMaybe<Scalars['IssueId']['input']>;
  /** [$in] Одно из значений */
  IN?: InputMaybe<Array<InputMaybe<Scalars['IssueId']['input']>>>;
  /** [$ne] Не равно переданному значению */
  NE?: InputMaybe<Scalars['IssueId']['input']>;
  /** [$nin] Не равно ни одному из переданных значений */
  NIN?: InputMaybe<Array<InputMaybe<Scalars['IssueId']['input']>>>;
};

/** Filter type for JobTypeCode scalar */
export type TJobTypeCodeFilter = {
  /** [$all] Полное совпадение значений */
  ALL?: InputMaybe<Array<InputMaybe<Scalars['JobTypeCode']['input']>>>;
  /** [$eq] Равенство значений */
  EQ?: InputMaybe<Scalars['JobTypeCode']['input']>;
  /** [$in] Одно из значений */
  IN?: InputMaybe<Array<InputMaybe<Scalars['JobTypeCode']['input']>>>;
  /** [$ne] Не равно переданному значению */
  NE?: InputMaybe<Scalars['JobTypeCode']['input']>;
  /** [$nin] Не равно ни одному из переданных значений */
  NIN?: InputMaybe<Array<InputMaybe<Scalars['JobTypeCode']['input']>>>;
  /** [$not] Логическое отрицание */
  NOT?: InputMaybe<TJobTypeCodeNotFilter>;
};

/** Filter type for $not of JobTypeCode scalar */
export type TJobTypeCodeNotFilter = {
  /** [$all] Полное совпадение значений */
  ALL?: InputMaybe<Array<InputMaybe<Scalars['JobTypeCode']['input']>>>;
  /** [$eq] Равенство значений */
  EQ?: InputMaybe<Scalars['JobTypeCode']['input']>;
  /** [$in] Одно из значений */
  IN?: InputMaybe<Array<InputMaybe<Scalars['JobTypeCode']['input']>>>;
  /** [$ne] Не равно переданному значению */
  NE?: InputMaybe<Scalars['JobTypeCode']['input']>;
  /** [$nin] Не равно ни одному из переданных значений */
  NIN?: InputMaybe<Array<InputMaybe<Scalars['JobTypeCode']['input']>>>;
};

/** Filter type for KPP scalar */
export type TKppFilter = {
  /** [$all] Полное совпадение значений */
  ALL?: InputMaybe<Array<InputMaybe<Scalars['KPP']['input']>>>;
  /** [$eq] Равенство значений */
  EQ?: InputMaybe<Scalars['KPP']['input']>;
  /** [$in] Одно из значений */
  IN?: InputMaybe<Array<InputMaybe<Scalars['KPP']['input']>>>;
  /** [$ne] Не равно переданному значению */
  NE?: InputMaybe<Scalars['KPP']['input']>;
  /** [$nin] Не равно ни одному из переданных значений */
  NIN?: InputMaybe<Array<InputMaybe<Scalars['KPP']['input']>>>;
  /** [$not] Логическое отрицание */
  NOT?: InputMaybe<TKppNotFilter>;
};

/** Filter type for $not of KPP scalar */
export type TKppNotFilter = {
  /** [$all] Полное совпадение значений */
  ALL?: InputMaybe<Array<InputMaybe<Scalars['KPP']['input']>>>;
  /** [$eq] Равенство значений */
  EQ?: InputMaybe<Scalars['KPP']['input']>;
  /** [$in] Одно из значений */
  IN?: InputMaybe<Array<InputMaybe<Scalars['KPP']['input']>>>;
  /** [$ne] Не равно переданному значению */
  NE?: InputMaybe<Scalars['KPP']['input']>;
  /** [$nin] Не равно ни одному из переданных значений */
  NIN?: InputMaybe<Array<InputMaybe<Scalars['KPP']['input']>>>;
};

export type TLoanApplication = {
  __typename?: 'LoanApplication';
  /** Выбранная сумма кредита */
  amount?: Maybe<Scalars['Int']['output']>;
  /** Дата создания объекта в БД */
  created?: Maybe<Scalars['DateTimeISO']['output']>;
  /** ClientId продукта, создавшего объект */
  createdBy?: Maybe<Scalars['String']['output']>;
  /** hash */
  hash?: Maybe<Scalars['String']['output']>;
  /** Ссылка от заемщика на заявку */
  loaner?: Maybe<TPeople>;
  /** Номер/идентификатор заявки */
  number: Scalars['String']['output'];
  /** Связь между организацией и заявкой */
  organization?: Maybe<TOrganization>;
  /** Цель кредита */
  purpose?: Maybe<Scalars['String']['output']>;
  /** Выбранный срок кредита (количество дней) */
  termInDays?: Maybe<Scalars['Int']['output']>;
  /** Дата последнего обновления объекта в БД */
  updated?: Maybe<Scalars['DateTimeISO']['output']>;
  /** ClientId продукта, обновившего объект */
  updatedBy?: Maybe<Scalars['String']['output']>;
};


export type TLoanApplicationLoanerArgs = {
  filter?: InputMaybe<TPeopleFilter>;
};


export type TLoanApplicationOrganizationArgs = {
  filter?: InputMaybe<TOrganizationFilter>;
};

export type TLoanApplicationFilter = {
  AND?: InputMaybe<Array<InputMaybe<TLoanApplicationFilter>>>;
  NOR?: InputMaybe<Array<InputMaybe<TLoanApplicationFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<TLoanApplicationFilter>>>;
  amount?: InputMaybe<TIntFilter>;
  created?: InputMaybe<TDateTimeIsoFilter>;
  createdBy?: InputMaybe<TStringFilter>;
  hash?: InputMaybe<TStringFilter>;
  number?: InputMaybe<TStringFilter>;
  purpose?: InputMaybe<TStringFilter>;
  termInDays?: InputMaybe<TIntFilter>;
  updated?: InputMaybe<TDateTimeIsoFilter>;
  updatedBy?: InputMaybe<TStringFilter>;
};

export type TMplClientFlags = {
  __typename?: 'MPLClientFlags';
  /** Флаг даты и времени, когда клиент дал ответы на вопросы AML */
  AMLQuestionsDate?: Maybe<Scalars['DateTimeISO']['output']>;
  /** Флаг даты и времени присоединения клиента к правилам платформы МПЛ */
  MPLRegistration?: Maybe<Scalars['DateTimeISO']['output']>;
  /** Причина блокировки клиента */
  blockReason?: Maybe<Scalars['String']['output']>;
  /** Флаг даты и времени, когда клиента заблокировали */
  blockedDate?: Maybe<Scalars['DateTimeISO']['output']>;
  /** Дата создания объекта в БД */
  created?: Maybe<Scalars['DateTimeISO']['output']>;
  /** ClientId продукта, создавшего объект */
  createdBy?: Maybe<Scalars['String']['output']>;
  /**
   * Hash флаг
   * @deprecated Старое поле для хэша. Неимеет смысла.
   */
  hash?: Maybe<Scalars['String']['output']>;
  /** Флаги id */
  id?: Maybe<Scalars['String']['output']>;
  /** Флаг даты и времени прохождения клиентом идентификации */
  identificationDate?: Maybe<Scalars['DateTimeISO']['output']>;
  /** Флаги клиента MPL */
  profile?: Maybe<TProfile>;
  /** Дата последнего обновления объекта в БД */
  updated?: Maybe<Scalars['DateTimeISO']['output']>;
  /** ClientId продукта, обновившего объект */
  updatedBy?: Maybe<Scalars['String']['output']>;
};


export type TMplClientFlagsProfileArgs = {
  filter?: InputMaybe<TProfileFilter>;
};

export type TMplClientFlagsFilter = {
  AMLQuestionsDate?: InputMaybe<TDateTimeIsoFilter>;
  AND?: InputMaybe<Array<InputMaybe<TMplClientFlagsFilter>>>;
  MPLRegistration?: InputMaybe<TDateTimeIsoFilter>;
  NOR?: InputMaybe<Array<InputMaybe<TMplClientFlagsFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<TMplClientFlagsFilter>>>;
  blockReason?: InputMaybe<TStringFilter>;
  blockedDate?: InputMaybe<TDateTimeIsoFilter>;
  created?: InputMaybe<TDateTimeIsoFilter>;
  createdBy?: InputMaybe<TStringFilter>;
  hash?: InputMaybe<TStringFilter>;
  id?: InputMaybe<TStringFilter>;
  identificationDate?: InputMaybe<TDateTimeIsoFilter>;
  updated?: InputMaybe<TDateTimeIsoFilter>;
  updatedBy?: InputMaybe<TStringFilter>;
};

export type TMeta = {
  __typename?: 'Meta';
  /** Дата создания объекта в БД */
  created?: Maybe<Scalars['DateTimeISO']['output']>;
  /** ClientId продукта, создавшего объект */
  createdBy?: Maybe<Scalars['String']['output']>;
  /** hash */
  hash?: Maybe<Scalars['String']['output']>;
  /**
   * Поле-заглушка
   * @deprecated This field is deprecated. Never use it
   */
  id?: Maybe<Scalars['String']['output']>;
  /** Мета по интеграциям */
  integrations?: Maybe<Array<Maybe<TMetaIntegration>>>;
  /** Дата последнего обновления объекта в БД */
  updated?: Maybe<Scalars['DateTimeISO']['output']>;
  /** ClientId продукта, обновившего объект */
  updatedBy?: Maybe<Scalars['String']['output']>;
};


export type TMetaIntegrationsArgs = {
  filter?: InputMaybe<TMetaIntegrationFilter>;
  pagination?: InputMaybe<TPagination>;
};

export type TMetaFilter = {
  AND?: InputMaybe<Array<InputMaybe<TMetaFilter>>>;
  NOR?: InputMaybe<Array<InputMaybe<TMetaFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<TMetaFilter>>>;
  created?: InputMaybe<TDateTimeIsoFilter>;
  createdBy?: InputMaybe<TStringFilter>;
  hash?: InputMaybe<TStringFilter>;
  id?: InputMaybe<TStringFilter>;
  updated?: InputMaybe<TDateTimeIsoFilter>;
  updatedBy?: InputMaybe<TStringFilter>;
};

export type TMetaIntegration = {
  __typename?: 'MetaIntegration';
  /** Дата создания объекта в БД */
  created?: Maybe<Scalars['DateTimeISO']['output']>;
  /** ClientId продукта, создавшего объект */
  createdBy?: Maybe<Scalars['String']['output']>;
  /** Мета по документу из интеграции */
  documents?: Maybe<Array<Maybe<TMetaIntegrationDocument>>>;
  /** hash */
  hash?: Maybe<Scalars['String']['output']>;
  /** Источник */
  source: ESource;
  /** Дата последнего обновления объекта в БД */
  updated?: Maybe<Scalars['DateTimeISO']['output']>;
  /** ClientId продукта, обновившего объект */
  updatedBy?: Maybe<Scalars['String']['output']>;
};


export type TMetaIntegrationDocumentsArgs = {
  filter?: InputMaybe<TMetaIntegrationDocumentFilter>;
  pagination?: InputMaybe<TPagination>;
};

export type TMetaIntegrationDocument = {
  __typename?: 'MetaIntegrationDocument';
  /** Дата создания объекта в БД */
  created?: Maybe<Scalars['DateTimeISO']['output']>;
  /** ClientId продукта, создавшего объект */
  createdBy?: Maybe<Scalars['String']['output']>;
  /** Описание ошибки */
  error?: Maybe<Scalars['String']['output']>;
  /** hash */
  hash?: Maybe<Scalars['String']['output']>;
  /** Название документа */
  name: Scalars['String']['output'];
  /** ID запроса на получение документа */
  requestId?: Maybe<Scalars['String']['output']>;
  /** Дата запроса документа */
  requestedAt?: Maybe<Scalars['DateTimeISO']['output']>;
  /** Источник */
  source: ESource;
  /** Статус документа */
  status: EIntegrationDocumentStatus;
  /** Дата последнего обновления объекта в БД */
  updated?: Maybe<Scalars['DateTimeISO']['output']>;
  /** ClientId продукта, обновившего объект */
  updatedBy?: Maybe<Scalars['String']['output']>;
};

export type TMetaIntegrationDocumentFilter = {
  AND?: InputMaybe<Array<InputMaybe<TMetaIntegrationDocumentFilter>>>;
  NOR?: InputMaybe<Array<InputMaybe<TMetaIntegrationDocumentFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<TMetaIntegrationDocumentFilter>>>;
  created?: InputMaybe<TDateTimeIsoFilter>;
  createdBy?: InputMaybe<TStringFilter>;
  error?: InputMaybe<TStringFilter>;
  hash?: InputMaybe<TStringFilter>;
  name?: InputMaybe<TStringFilter>;
  requestId?: InputMaybe<TStringFilter>;
  requestedAt?: InputMaybe<TDateTimeIsoFilter>;
  source?: InputMaybe<TESourceFilter>;
  status?: InputMaybe<TEIntegrationDocumentStatusFilter>;
  updated?: InputMaybe<TDateTimeIsoFilter>;
  updatedBy?: InputMaybe<TStringFilter>;
};

export type TMetaIntegrationFilter = {
  AND?: InputMaybe<Array<InputMaybe<TMetaIntegrationFilter>>>;
  NOR?: InputMaybe<Array<InputMaybe<TMetaIntegrationFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<TMetaIntegrationFilter>>>;
  created?: InputMaybe<TDateTimeIsoFilter>;
  createdBy?: InputMaybe<TStringFilter>;
  hash?: InputMaybe<TStringFilter>;
  source?: InputMaybe<TESourceFilter>;
  updated?: InputMaybe<TDateTimeIsoFilter>;
  updatedBy?: InputMaybe<TStringFilter>;
};

export type TMortgageAgreement = {
  __typename?: 'MortgageAgreement';
  /** Место заключения кредитного договора */
  agreementAddress?: Maybe<Scalars['String']['output']>;
  /** Ежемесячный платеж по кредиту */
  annuityPayment?: Maybe<Scalars['Float']['output']>;
  /** Процентная ставка при отказе от страхования */
  cancellationCreditRate?: Maybe<Scalars['Float']['output']>;
  /** Дата заключения кредитного договора */
  contractAgreementDate?: Maybe<Scalars['DateTimeISO']['output']>;
  /** Дата окончания кредитного договора */
  contractAgreementEndDate?: Maybe<Scalars['DateTimeISO']['output']>;
  /** Номер кредитного договора */
  contractNumber: Scalars['String']['output'];
  /** Дата создания объекта в БД */
  created?: Maybe<Scalars['DateTimeISO']['output']>;
  /** ClientId продукта, создавшего объект */
  createdBy?: Maybe<Scalars['String']['output']>;
  /** Банк кредитор */
  creditBankId?: Maybe<Scalars['String']['output']>;
  /** Хэш кредитного договора */
  hash?: Maybe<Scalars['String']['output']>;
  /** Начальная сумма кредита */
  initialAmount?: Maybe<Scalars['Float']['output']>;
  /** Ипотечный договор */
  insurer?: Maybe<Array<Maybe<TPeople>>>;
  /** Ипотечная квартира */
  mortgageHabitation?: Maybe<THabitation>;
  /** Дата окончания действия полиса */
  policyEndDate?: Maybe<Scalars['DateTimeISO']['output']>;
  /** Дата начала действия полиса */
  policyStartDate?: Maybe<Scalars['DateTimeISO']['output']>;
  /** Процентная ставка */
  rate?: Maybe<Scalars['Float']['output']>;
  /** Дата последнего обновления объекта в БД */
  updated?: Maybe<Scalars['DateTimeISO']['output']>;
  /** ClientId продукта, обновившего объект */
  updatedBy?: Maybe<Scalars['String']['output']>;
};


export type TMortgageAgreementInsurerArgs = {
  filter?: InputMaybe<TPeopleFilter>;
  pagination?: InputMaybe<TPagination>;
};


export type TMortgageAgreementMortgageHabitationArgs = {
  filter?: InputMaybe<THabitationFilter>;
};

export type TMortgageAgreementFilter = {
  AND?: InputMaybe<Array<InputMaybe<TMortgageAgreementFilter>>>;
  NOR?: InputMaybe<Array<InputMaybe<TMortgageAgreementFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<TMortgageAgreementFilter>>>;
  agreementAddress?: InputMaybe<TStringFilter>;
  annuityPayment?: InputMaybe<TFloatFilter>;
  cancellationCreditRate?: InputMaybe<TFloatFilter>;
  contractAgreementDate?: InputMaybe<TDateTimeIsoFilter>;
  contractAgreementEndDate?: InputMaybe<TDateTimeIsoFilter>;
  contractNumber?: InputMaybe<TStringFilter>;
  created?: InputMaybe<TDateTimeIsoFilter>;
  createdBy?: InputMaybe<TStringFilter>;
  creditBankId?: InputMaybe<TStringFilter>;
  hash?: InputMaybe<TStringFilter>;
  initialAmount?: InputMaybe<TFloatFilter>;
  policyEndDate?: InputMaybe<TDateTimeIsoFilter>;
  policyStartDate?: InputMaybe<TDateTimeIsoFilter>;
  rate?: InputMaybe<TFloatFilter>;
  updated?: InputMaybe<TDateTimeIsoFilter>;
  updatedBy?: InputMaybe<TStringFilter>;
};

export type TMutation = {
  __typename?: 'Mutation';
  /** Мутация для смены номера телефона в объекте Profile и Profile.owner */
  changePhoneNumber?: Maybe<Scalars['Void']['output']>;
  deleteProfile?: Maybe<TDeleteProfileResult>;
  deleteProfileObject?: Maybe<Scalars['Void']['output']>;
  saveAlfa?: Maybe<TProfile>;
  /** @deprecated Ретро Альфы на всякий случай */
  saveAlfaTmp?: Maybe<Scalars['Void']['output']>;
  saveCar?: Maybe<TCar>;
  saveData?: Maybe<TProfile>;
  saveESIA?: Maybe<TProfile>;
  saveFRGNPassport?: Maybe<Array<Maybe<TFrgnPassport>>>;
  saveHabitation?: Maybe<THabitation>;
  saveHabitations?: Maybe<Array<Maybe<THabitation>>>;
  saveMPLFlags?: Maybe<TMplClientFlags>;
  saveMeta?: Maybe<TMeta>;
  saveOrganizations?: Maybe<Array<Maybe<TOrganization>>>;
  saveOwner?: Maybe<TPeople>;
  savePassport?: Maybe<Array<Maybe<TPassport>>>;
  savePeople?: Maybe<TPeople>;
  saveProductMeta?: Maybe<Scalars['Void']['output']>;
  saveProfile?: Maybe<TProfile>;
  /** @deprecated Остаток от форм */
  saveProfileState?: Maybe<TProfile>;
  saveSber?: Maybe<TProfile>;
  /** @deprecated Ретро Сбера на всякий случай */
  saveSberTmp?: Maybe<Scalars['Void']['output']>;
  saveTBank?: Maybe<TProfile>;
  /** @deprecated Переезд на мутацию saveTBank */
  saveTinkoffTmp?: Maybe<Scalars['Void']['output']>;
};


export type TMutationChangePhoneNumberArgs = {
  data: TInputChangePhoneNumber;
  ownerId: Scalars['Int']['input'];
};


export type TMutationDeleteProfileArgs = {
  options?: InputMaybe<TInputDeleteProfileParams>;
  ownerId?: InputMaybe<Scalars['Int']['input']>;
};


export type TMutationDeleteProfileObjectArgs = {
  objectHash: Scalars['String']['input'];
  objectTypeName: EObjectTypeName;
  options?: InputMaybe<TInputDeleteProfileObjectParams>;
  ownerId?: InputMaybe<Scalars['Int']['input']>;
};


export type TMutationSaveAlfaArgs = {
  data: TInputAlfa;
  ownerId?: InputMaybe<Scalars['Int']['input']>;
};


export type TMutationSaveAlfaTmpArgs = {
  data: Scalars['String']['input'];
  ownerId: Scalars['Int']['input'];
  type: Scalars['String']['input'];
};


export type TMutationSaveCarArgs = {
  data: TInputCar;
  ownerId?: InputMaybe<Scalars['Int']['input']>;
};


export type TMutationSaveDataArgs = {
  data: TInputCommon;
  ownerId?: InputMaybe<Scalars['Int']['input']>;
};


export type TMutationSaveEsiaArgs = {
  data: TInputEsia;
  ownerId?: InputMaybe<Scalars['Int']['input']>;
};


export type TMutationSaveFrgnPassportArgs = {
  data: Array<TInputFrgnPassport>;
  ownerId?: InputMaybe<Scalars['Int']['input']>;
};


export type TMutationSaveHabitationArgs = {
  data: TInputHabitation;
  ownerId?: InputMaybe<Scalars['Int']['input']>;
};


export type TMutationSaveHabitationsArgs = {
  data: Array<TInputHabitation>;
  ownerId?: InputMaybe<Scalars['Int']['input']>;
};


export type TMutationSaveMplFlagsArgs = {
  data: TInputMplClientFlags;
  ownerId?: InputMaybe<Scalars['Int']['input']>;
};


export type TMutationSaveMetaArgs = {
  data: TInputMeta;
  ownerId?: InputMaybe<Scalars['Int']['input']>;
};


export type TMutationSaveOrganizationsArgs = {
  data: Array<TInputOrganization>;
  ownerId?: InputMaybe<Scalars['Int']['input']>;
};


export type TMutationSaveOwnerArgs = {
  data: TInputPeople;
  ownerId?: InputMaybe<Scalars['Int']['input']>;
};


export type TMutationSavePassportArgs = {
  data: Array<TInputPassport>;
  ownerId?: InputMaybe<Scalars['Int']['input']>;
};


export type TMutationSavePeopleArgs = {
  data: TInputPeople;
  ownerId?: InputMaybe<Scalars['Int']['input']>;
};


export type TMutationSaveProductMetaArgs = {
  data: TInputProductMeta;
  key: Scalars['String']['input'];
  ownerId: Scalars['Int']['input'];
};


export type TMutationSaveProfileArgs = {
  data: TInputProfileRaw;
  ownerId?: InputMaybe<Scalars['Int']['input']>;
};


export type TMutationSaveProfileStateArgs = {
  data: TInputProfile;
  form: Scalars['String']['input'];
  ownerId?: InputMaybe<Scalars['Int']['input']>;
};


export type TMutationSaveSberArgs = {
  data: TInputSber;
  ownerId?: InputMaybe<Scalars['Int']['input']>;
};


export type TMutationSaveSberTmpArgs = {
  data: Scalars['String']['input'];
  ownerId: Scalars['Int']['input'];
  type: Scalars['String']['input'];
};


export type TMutationSaveTBankArgs = {
  data: TInputTBank;
  ownerId?: InputMaybe<Scalars['Int']['input']>;
};


export type TMutationSaveTinkoffTmpArgs = {
  data: Scalars['String']['input'];
  ownerId: Scalars['Int']['input'];
  type: Scalars['String']['input'];
};

export type TNdfl2 = {
  __typename?: 'NDFL2';
  /** Номер корректировки */
  correctionNumber: Scalars['String']['output'];
  /** Дата создания объекта в БД */
  created?: Maybe<Scalars['DateTimeISO']['output']>;
  /** ClientId продукта, создавшего объект */
  createdBy?: Maybe<Scalars['String']['output']>;
  /** Дата формирования справки */
  formationDate: Scalars['DateTimeISO']['output'];
  /** - */
  hash?: Maybe<Scalars['String']['output']>;
  income?: Maybe<Array<Maybe<TNestedNdfl2Income>>>;
  person?: Maybe<TNestedNdfl2Person>;
  /** Справка 2-НДФЛ */
  profile?: Maybe<TPeople>;
  /** Источник справки */
  source: ESource;
  taxAgent?: Maybe<TNestedNdfl2TaxAgent>;
  /** Дата последнего обновления объекта в БД */
  updated?: Maybe<Scalars['DateTimeISO']['output']>;
  /** ClientId продукта, обновившего объект */
  updatedBy?: Maybe<Scalars['String']['output']>;
  /** Отчетный год */
  year: Scalars['Int']['output'];
};


export type TNdfl2IncomeArgs = {
  pagination?: InputMaybe<TPagination>;
};


export type TNdfl2ProfileArgs = {
  filter?: InputMaybe<TPeopleFilter>;
};

export type TNdfl2Filter = {
  AND?: InputMaybe<Array<InputMaybe<TNdfl2Filter>>>;
  NOR?: InputMaybe<Array<InputMaybe<TNdfl2Filter>>>;
  OR?: InputMaybe<Array<InputMaybe<TNdfl2Filter>>>;
  correctionNumber?: InputMaybe<TStringFilter>;
  created?: InputMaybe<TDateTimeIsoFilter>;
  createdBy?: InputMaybe<TStringFilter>;
  formationDate?: InputMaybe<TDateTimeIsoFilter>;
  hash?: InputMaybe<TStringFilter>;
  income?: InputMaybe<TNestedNdfl2IncomeObjectFilterType>;
  person?: InputMaybe<TNestedNdfl2PersonObjectFilterType>;
  source?: InputMaybe<TESourceFilter>;
  taxAgent?: InputMaybe<TNestedNdfl2TaxAgentObjectFilterType>;
  updated?: InputMaybe<TDateTimeIsoFilter>;
  updatedBy?: InputMaybe<TStringFilter>;
  year?: InputMaybe<TIntFilter>;
};

export type TNestedCarApproveDocument = {
  __typename?: 'NestedCarApproveDocument';
  /** Дата выдачи */
  date?: Maybe<Scalars['DateTimeISO']['output']>;
  /** Орган выдачи */
  issueAgency?: Maybe<Scalars['String']['output']>;
  /** Серия и номер */
  serialNumber?: Maybe<Scalars['String']['output']>;
};

export type TNestedCarApproveDocumentObjectFilterType = {
  date?: InputMaybe<TDateTimeIsoFilter>;
  issueAgency?: InputMaybe<TStringFilter>;
  serialNumber?: InputMaybe<TStringFilter>;
};

export type TNestedCarCasco = {
  __typename?: 'NestedCarCasco';
  /** Тип документа при вводе данных в каско */
  documentType?: Maybe<Scalars['String']['output']>;
  /** Залоговый ли автомобиль */
  isPledge?: Maybe<Scalars['String']['output']>;
  /** Количество ключей у автомобиля */
  keysNumber?: Maybe<Scalars['String']['output']>;
  /** Пробег автомобиля */
  mileage?: Maybe<Scalars['String']['output']>;
  /** Id банка, в котором автомобиль оставлен в залог */
  pledgeBankId?: Maybe<Scalars['String']['output']>;
  /** Номер полиса КАСКО */
  policyNumber?: Maybe<Scalars['String']['output']>;
  /** Оригинал ли птс или дубликат */
  ptsIsOriginal?: Maybe<Scalars['String']['output']>;
};

export type TNestedCarCascoObjectFilterType = {
  documentType?: InputMaybe<TStringFilter>;
  isPledge?: InputMaybe<TStringFilter>;
  keysNumber?: InputMaybe<TStringFilter>;
  mileage?: InputMaybe<TStringFilter>;
  pledgeBankId?: InputMaybe<TStringFilter>;
  policyNumber?: InputMaybe<TStringFilter>;
  ptsIsOriginal?: InputMaybe<TStringFilter>;
};

export type TNestedCarDiagnosticCard = {
  __typename?: 'NestedCarDiagnosticCard';
  /** Дата окончания действия диагностической карты */
  expirationDate?: Maybe<Scalars['DateTimeISO']['output']>;
  /** Номер диагностической карты */
  number?: Maybe<Scalars['String']['output']>;
};

export type TNestedCarDiagnosticCardObjectFilterType = {
  expirationDate?: InputMaybe<TDateTimeIsoFilter>;
  number?: InputMaybe<TStringFilter>;
};

export type TNestedCarEPts = {
  __typename?: 'NestedCarEPts';
  /** Дата выдачи еПТС */
  issueDate?: Maybe<Scalars['DateTimeISO']['output']>;
  /** Номер еПТС */
  number?: Maybe<Scalars['SerialNumberEPTS']['output']>;
};

export type TNestedCarEPtsObjectFilterType = {
  issueDate?: InputMaybe<TDateTimeIsoFilter>;
  number?: InputMaybe<TSerialNumberEptsFilter>;
};

export type TNestedCarOsago = {
  __typename?: 'NestedCarOsago';
  /** Тип документа при вводе данных в осаго */
  documentType?: Maybe<EOsagoCarDocumentType>;
  /** Номер полиса ОСАГО */
  policyNumber?: Maybe<Scalars['CarOsagoPolicyNumber']['output']>;
  /** Дата начала действия полиса осаго */
  policyStartDate?: Maybe<Scalars['DateTimeISO']['output']>;
  /** Id продукта, который пользователь выбрал на выдаче */
  productId?: Maybe<Scalars['String']['output']>;
  /** Id выдачи в сервисе осаго */
  searchId?: Maybe<Scalars['String']['output']>;
};

export type TNestedCarOsagoObjectFilterType = {
  documentType?: InputMaybe<TEOsagoCarDocumentTypeFilter>;
  policyNumber?: InputMaybe<TCarOsagoPolicyNumberFilter>;
  policyStartDate?: InputMaybe<TDateTimeIsoFilter>;
  productId?: InputMaybe<TStringFilter>;
  searchId?: InputMaybe<TStringFilter>;
};

export type TNestedCarOwnerPeriods = {
  __typename?: 'NestedCarOwnerPeriods';
  /** Дата окончания */
  dateEnd?: Maybe<Scalars['DateTimeISO']['output']>;
  /** Дата начала */
  dateStart?: Maybe<Scalars['DateTimeISO']['output']>;
  /** Тип владельца */
  ownerType?: Maybe<Scalars['String']['output']>;
};

export type TNestedCarOwnerPeriodsObjectFilterType = {
  dateEnd?: InputMaybe<TDateTimeIsoFilter>;
  dateStart?: InputMaybe<TDateTimeIsoFilter>;
  ownerType?: InputMaybe<TStringFilter>;
};

export type TNestedCarPts = {
  __typename?: 'NestedCarPts';
  /** Орган выдачи */
  issueAgency?: Maybe<Scalars['String']['output']>;
  /** Дата выдачи ПТС */
  issueDate?: Maybe<Scalars['DateTimeISO']['output']>;
  /** Серия и номер ПТС */
  number?: Maybe<Scalars['CarPTSNumber']['output']>;
  /** Особые отметки */
  specialTags?: Maybe<Scalars['String']['output']>;
  /** Тип ПТС */
  type?: Maybe<Scalars['String']['output']>;
};

export type TNestedCarPtsObjectFilterType = {
  issueAgency?: InputMaybe<TStringFilter>;
  issueDate?: InputMaybe<TDateTimeIsoFilter>;
  number?: InputMaybe<TCarPtsNumberFilter>;
  specialTags?: InputMaybe<TStringFilter>;
  type?: InputMaybe<TStringFilter>;
};

export type TNestedCarRegActions = {
  __typename?: 'NestedCarRegActions';
  /** confidentSign */
  confidentSign?: Maybe<Scalars['Boolean']['output']>;
  /** Дата регистрации */
  date?: Maybe<Scalars['DateTimeISO']['output']>;
  /** Орган регистрации */
  issueAgency?: Maybe<Scalars['String']['output']>;
  /** Признак лизинга */
  leasingFlag?: Maybe<Scalars['Boolean']['output']>;
  /** Причина регистрации */
  name?: Maybe<Scalars['String']['output']>;
};

export type TNestedCarRegActionsObjectFilterType = {
  confidentSign?: InputMaybe<TBooleanFilter>;
  date?: InputMaybe<TDateTimeIsoFilter>;
  issueAgency?: InputMaybe<TStringFilter>;
  leasingFlag?: InputMaybe<TBooleanFilter>;
  name?: InputMaybe<TStringFilter>;
};

export type TNestedCarSts = {
  __typename?: 'NestedCarSts';
  /** Орган выдачи */
  issueAgency?: Maybe<Scalars['String']['output']>;
  /** Дата выдачи СТС */
  issueDate?: Maybe<Scalars['DateTimeISO']['output']>;
  /** Номер СТС */
  number?: Maybe<Scalars['String']['output']>;
  /** Особые отметки */
  specialTags?: Maybe<Scalars['String']['output']>;
};

export type TNestedCarStsObjectFilterType = {
  issueAgency?: InputMaybe<TStringFilter>;
  issueDate?: InputMaybe<TDateTimeIsoFilter>;
  number?: InputMaybe<TStringFilter>;
  specialTags?: InputMaybe<TStringFilter>;
};

export type TNestedCarTdtpo = {
  __typename?: 'NestedCarTdtpo';
  /** Дата оформаления декларации */
  date?: Maybe<Scalars['DateTimeISO']['output']>;
  /** Таможенный орган */
  issueAgency?: Maybe<Scalars['String']['output']>;
  /** Номер таможенной декларации */
  number?: Maybe<Scalars['String']['output']>;
};

export type TNestedCarTdtpoObjectFilterType = {
  date?: InputMaybe<TDateTimeIsoFilter>;
  issueAgency?: InputMaybe<TStringFilter>;
  number?: InputMaybe<TStringFilter>;
};

export type TNestedEsiaVehicleOwner = {
  __typename?: 'NestedESIAVehicleOwner';
  /** День рождения владельца машины */
  birthDate?: Maybe<Scalars['BirthDate']['output']>;
  /** Место рождения */
  birthPlace?: Maybe<Scalars['String']['output']>;
  /** Имя */
  firstName?: Maybe<Scalars['StrictString']['output']>;
  /** Фамилия */
  lastName?: Maybe<Scalars['StrictString']['output']>;
  /** Отчество */
  middleName?: Maybe<Scalars['StrictString']['output']>;
};

export type TNestedEsiaVehicleOwnerObjectFilterType = {
  birthDate?: InputMaybe<TBirthDateFilter>;
  birthPlace?: InputMaybe<TStringFilter>;
  firstName?: InputMaybe<TStrictStringFilter>;
  lastName?: InputMaybe<TStrictStringFilter>;
  middleName?: InputMaybe<TStrictStringFilter>;
};

export type TNestedEsiaVehicleOwnerPeriod = {
  __typename?: 'NestedESIAVehicleOwnerPeriod';
  /** Дата окончания */
  dateEnd?: Maybe<Scalars['DateTimeISO']['output']>;
  /** Дата начала */
  dateStart?: Maybe<Scalars['DateTimeISO']['output']>;
  /** Тип владельца */
  ownerType?: Maybe<Scalars['String']['output']>;
};

export type TNestedEsiaVehicleOwnerPeriodObjectFilterType = {
  dateEnd?: InputMaybe<TDateTimeIsoFilter>;
  dateStart?: InputMaybe<TDateTimeIsoFilter>;
  ownerType?: InputMaybe<TStringFilter>;
};

export type TNestedEsiaVehiclePts = {
  __typename?: 'NestedESIAVehiclePts';
  /** Дата выдачи */
  ptsDocumentDate?: Maybe<Scalars['DateTimeISO']['output']>;
  /** Кем выдан */
  ptsIssueAgency?: Maybe<Scalars['String']['output']>;
  /** Серия и номер */
  ptsSeriesNumber?: Maybe<Scalars['String']['output']>;
  /** Доп инфа по выдаче */
  ptsSpecialTags?: Maybe<Scalars['String']['output']>;
  /** Тип */
  ptsType?: Maybe<Scalars['String']['output']>;
};

export type TNestedEsiaVehiclePtsObjectFilterType = {
  ptsDocumentDate?: InputMaybe<TDateTimeIsoFilter>;
  ptsIssueAgency?: InputMaybe<TStringFilter>;
  ptsSeriesNumber?: InputMaybe<TStringFilter>;
  ptsSpecialTags?: InputMaybe<TStringFilter>;
  ptsType?: InputMaybe<TStringFilter>;
};

export type TNestedEsiaVehicleRegAction = {
  __typename?: 'NestedESIAVehicleRegAction';
  /** confidentSign */
  confidentSign?: Maybe<Scalars['Boolean']['output']>;
  /** Признак лизинга */
  leasingFlag?: Maybe<Scalars['Boolean']['output']>;
  /** Причина регистрации */
  regActionName?: Maybe<Scalars['String']['output']>;
  /** Дата выдачи */
  regDocumentDate?: Maybe<Scalars['DateTimeISO']['output']>;
  /** Кем выдан */
  regIssueAgency?: Maybe<Scalars['String']['output']>;
};

export type TNestedEsiaVehicleRegActionObjectFilterType = {
  confidentSign?: InputMaybe<TBooleanFilter>;
  leasingFlag?: InputMaybe<TBooleanFilter>;
  regActionName?: InputMaybe<TStringFilter>;
  regDocumentDate?: InputMaybe<TDateTimeIsoFilter>;
  regIssueAgency?: InputMaybe<TStringFilter>;
};

export type TNestedEsiaVehicleRegistrationDoc = {
  __typename?: 'NestedESIAVehicleRegistrationDoc';
  /** Дата выдачи */
  regDocDocumentDate?: Maybe<Scalars['DateTimeISO']['output']>;
  /** Кем выдан */
  regDocIssueAgency?: Maybe<Scalars['String']['output']>;
  /** Серия и номер */
  regDocSeriesNumber?: Maybe<Scalars['String']['output']>;
  /** Тип */
  regDocType?: Maybe<Scalars['String']['output']>;
  /** Комментарий */
  specialTags?: Maybe<Scalars['String']['output']>;
};

export type TNestedEsiaVehicleRegistrationDocObjectFilterType = {
  regDocDocumentDate?: InputMaybe<TDateTimeIsoFilter>;
  regDocIssueAgency?: InputMaybe<TStringFilter>;
  regDocSeriesNumber?: InputMaybe<TStringFilter>;
  regDocType?: InputMaybe<TStringFilter>;
  specialTags?: InputMaybe<TStringFilter>;
};

export type TNestedEWorkbookEventDismissalBasis = {
  __typename?: 'NestedEWorkbookEventDismissalBasis';
  /** ЕСИА */
  basisItem?: Maybe<Scalars['String']['output']>;
  /** ЕСИА */
  basisParagraph?: Maybe<Scalars['String']['output']>;
  /** ЕСИА dismissalBasis basisPart */
  basisPart?: Maybe<Scalars['String']['output']>;
  /** ЕСИА */
  normativeDocument?: Maybe<Scalars['String']['output']>;
  /** ЕСИА */
  type?: Maybe<Scalars['String']['output']>;
};

export type TNestedEWorkbookEventDismissalBasisObjectFilterType = {
  basisItem?: InputMaybe<TStringFilter>;
  basisParagraph?: InputMaybe<TStringFilter>;
  basisPart?: InputMaybe<TStringFilter>;
  normativeDocument?: InputMaybe<TStringFilter>;
  type?: InputMaybe<TStringFilter>;
};

export type TNestedEWorkbookEventOrganization = {
  __typename?: 'NestedEWorkbookEventOrganization';
  /** ЕСИА */
  inn?: Maybe<Scalars['INN']['output']>;
  /** ЕСИА */
  kpp?: Maybe<Scalars['String']['output']>;
  /** ЕСИА */
  orgName?: Maybe<Scalars['String']['output']>;
  /** ЕСИА */
  regNumber?: Maybe<Scalars['String']['output']>;
};

export type TNestedEWorkbookEventOrganizationObjectFilterType = {
  inn?: InputMaybe<TInnFilter>;
  kpp?: InputMaybe<TStringFilter>;
  orgName?: InputMaybe<TStringFilter>;
  regNumber?: InputMaybe<TStringFilter>;
};

export type TNestedEWorkbookEventReason = {
  __typename?: 'NestedEWorkbookEventReason';
  /** ЕСИА events reason date */
  date?: Maybe<Scalars['DateTimeISO']['output']>;
  /** ЕСИА events reason document */
  document?: Maybe<Scalars['String']['output']>;
  /** ЕСИА events reason number */
  number?: Maybe<Scalars['String']['output']>;
};

export type TNestedEWorkbookEventReasonObjectFilterType = {
  date?: InputMaybe<TDateTimeIsoFilter>;
  document?: InputMaybe<TStringFilter>;
  number?: InputMaybe<TStringFilter>;
};

export type TNestedGlobalDocuments = {
  __typename?: 'NestedGlobalDocuments';
  FRGNPassport?: Maybe<Array<Maybe<TFrgnPassport>>>;
  NDFL2?: Maybe<Array<Maybe<TNdfl2>>>;
  driverLicense?: Maybe<Array<Maybe<TDriverLicense>>>;
  passport?: Maybe<Array<Maybe<TPassport>>>;
  payoutIncome?: Maybe<Array<Maybe<TPayoutIncome>>>;
  workbook?: Maybe<Array<Maybe<TEsiaeWorkbook>>>;
};


export type TNestedGlobalDocumentsFrgnPassportArgs = {
  filter?: InputMaybe<TFrgnPassportFilter>;
  pagination?: InputMaybe<TPagination>;
};


export type TNestedGlobalDocumentsNdfl2Args = {
  filter?: InputMaybe<TNdfl2Filter>;
  pagination?: InputMaybe<TPagination>;
};


export type TNestedGlobalDocumentsDriverLicenseArgs = {
  filter?: InputMaybe<TDriverLicenseFilter>;
  pagination?: InputMaybe<TPagination>;
};


export type TNestedGlobalDocumentsPassportArgs = {
  filter?: InputMaybe<TPassportFilter>;
  pagination?: InputMaybe<TPagination>;
};


export type TNestedGlobalDocumentsPayoutIncomeArgs = {
  filter?: InputMaybe<TPayoutIncomeFilter>;
  pagination?: InputMaybe<TPagination>;
};


export type TNestedGlobalDocumentsWorkbookArgs = {
  filter?: InputMaybe<TEsiaeWorkbookFilter>;
  pagination?: InputMaybe<TPagination>;
};

export type TNestedHabitationAddress = {
  __typename?: 'NestedHabitationAddress';
  area?: Maybe<Scalars['String']['output']>;
  /** ФИАС-код района */
  areaFiasId?: Maybe<Scalars['String']['output']>;
  /** КЛАДР-код района */
  areaKladrId?: Maybe<Scalars['String']['output']>;
  areaType?: Maybe<Scalars['String']['output']>;
  /** Тип района в регионе (полный) */
  areaTypeFull?: Maybe<Scalars['String']['output']>;
  /** Район в регионе с типом */
  areaWithType?: Maybe<Scalars['String']['output']>;
  /** Расстояние от кольцевой в километрах */
  beltwayDistance?: Maybe<Scalars['String']['output']>;
  /** Внутри кольцевой? */
  beltwayHit?: Maybe<Scalars['String']['output']>;
  /** Корпус */
  block?: Maybe<Scalars['String']['output']>;
  blockType?: Maybe<Scalars['String']['output']>;
  /** Тип корпуса/строения (полный) */
  blockTypeFull?: Maybe<Scalars['String']['output']>;
  /** Кадастровый номер */
  cadastralNumber?: Maybe<Scalars['CadastralNumber']['output']>;
  /** Признак центра района или региона:  1 — центр района, 2 — центр региона, 3 — центр района и региона, 4 — центральный район региона, 0 — ничего из перечисленного */
  capitalMarker?: Maybe<Scalars['String']['output']>;
  /** Город / населенный пункт */
  city?: Maybe<Scalars['String']['output']>;
  /** Административный округ (только для Москвы) */
  cityArea?: Maybe<Scalars['String']['output']>;
  /** Адм. район города */
  cityDistrict?: Maybe<Scalars['String']['output']>;
  /** ФИАС-код адм. района города */
  cityDistrictFiasId?: Maybe<Scalars['String']['output']>;
  /** Тип адм. района города */
  cityDistrictType?: Maybe<Scalars['String']['output']>;
  /** Тип адм. района города (полный) */
  cityDistrictTypeFull?: Maybe<Scalars['String']['output']>;
  /** Адм. район города с типом */
  cityDistrictWithType?: Maybe<Scalars['String']['output']>;
  /** ФИАС-код города */
  cityFiasId?: Maybe<Scalars['String']['output']>;
  /** КЛАДР-код города */
  cityKladrId?: Maybe<Scalars['String']['output']>;
  cityType?: Maybe<Scalars['String']['output']>;
  /** Тип города (полный) */
  cityTypeFull?: Maybe<Scalars['String']['output']>;
  /** Город с типом */
  cityWithType?: Maybe<Scalars['String']['output']>;
  /** Год постройки дома */
  constructionYear?: Maybe<Scalars['year']['output']>;
  /** Код страны */
  countryId?: Maybe<Scalars['String']['output']>;
  /** ISO-код страны (двухсимвольный) */
  countryIsoCode?: Maybe<Scalars['String']['output']>;
  /** Адрес */
  dadata?: Maybe<Scalars['String']['output']>;
  /** Федеральный округ */
  federalDistrict?: Maybe<Scalars['String']['output']>;
  /** Признак актуальности адреса в ФИАС */
  fiasActualityState?: Maybe<Scalars['String']['output']>;
  /** ФИАС-код адреса (идентификатор ФИАС) */
  fiasId: Scalars['String']['output'];
  /** Уровень детализации, до которого адрес найден в ФИАС */
  fiasLevel?: Maybe<Scalars['String']['output']>;
  /** Квартира */
  flat?: Maybe<Scalars['String']['output']>;
  /** Площадь */
  flatArea?: Maybe<Scalars['String']['output']>;
  /** Код ФИАС квартиры */
  flatFiasId?: Maybe<Scalars['String']['output']>;
  /** Рыночная стоимость квартиры */
  flatPrice?: Maybe<Scalars['String']['output']>;
  flatType?: Maybe<Scalars['String']['output']>;
  /** Тип квартиры (полный) */
  flatTypeFull?: Maybe<Scalars['String']['output']>;
  /** Номер этажа */
  floorNumber?: Maybe<Scalars['String']['output']>;
  /** Количество этажей */
  floorsNumber?: Maybe<Scalars['String']['output']>;
  /** Координаты: широта */
  geoLat?: Maybe<Scalars['String']['output']>;
  /** Координаты: долгота */
  geoLon?: Maybe<Scalars['String']['output']>;
  /** Идентификатор объекта в базе GeoNames. Для российских адресов не заполняется. */
  geonameOd?: Maybe<Scalars['String']['output']>;
  /** Дом */
  house?: Maybe<Scalars['String']['output']>;
  /** Кадастровый номер дома */
  houseCadastralNumber?: Maybe<Scalars['String']['output']>;
  /** ФИАС-код дома */
  houseFiasId?: Maybe<Scalars['String']['output']>;
  /** КЛАДР-код дома */
  houseKladrId?: Maybe<Scalars['String']['output']>;
  houseType?: Maybe<Scalars['String']['output']>;
  /** Тип дома (полный) */
  houseTypeFull?: Maybe<Scalars['String']['output']>;
  /** Актуализирован ли адрес через Дадату */
  isFromDadata?: Maybe<Scalars['Boolean']['output']>;
  /** КЛАДР-код адреса */
  kladrId?: Maybe<Scalars['String']['output']>;
  /** Роут адреса из сервиса locations */
  locationRoute?: Maybe<Scalars['String']['output']>;
  /** Список ближайших станций метро */
  metro?: Maybe<Array<Maybe<TNestedHabitationAddressMetro>>>;
  /** Код ОКАТО */
  okato?: Maybe<Scalars['String']['output']>;
  /** Код ОКТМО */
  oktmo?: Maybe<Scalars['String']['output']>;
  /** Абонентский ящик */
  postalBox?: Maybe<Scalars['String']['output']>;
  /** Почтовый индекс РФ */
  postalCode?: Maybe<Scalars['PostalCode']['output']>;
  /** Регион */
  region?: Maybe<Scalars['String']['output']>;
  /** ФИАС-код региона */
  regionFiasId?: Maybe<Scalars['String']['output']>;
  /** ISO-код региона */
  regionIsoCode?: Maybe<Scalars['String']['output']>;
  /** КЛАДР-код региона */
  regionKladrId?: Maybe<Scalars['String']['output']>;
  regionType?: Maybe<Scalars['String']['output']>;
  /** Тип региона (полный) */
  regionTypeFull?: Maybe<Scalars['String']['output']>;
  /** Регион с типом */
  regionWithType?: Maybe<Scalars['String']['output']>;
  /**
   * Дата регистрации
   * @deprecated Поле относится к паспорту, используйте People.passport.addressRegistrationDate
   */
  registrationDate?: Maybe<Scalars['DateTimeISO']['output']>;
  /** Количество комнат */
  roomsCount?: Maybe<Scalars['String']['output']>;
  settlement?: Maybe<Scalars['String']['output']>;
  /** ФИАС-код нас. пункта */
  settlementFiasId?: Maybe<Scalars['String']['output']>;
  /** КЛАДР-код нас. пункта */
  settlementKladrId?: Maybe<Scalars['String']['output']>;
  settlementType?: Maybe<Scalars['String']['output']>;
  /** Тип населенного пункта (полный) */
  settlementTypeFull?: Maybe<Scalars['String']['output']>;
  /** Населенный пункт с типом */
  settlementTypeWithType?: Maybe<Scalars['String']['output']>;
  /** Рыночная стоимость м² */
  squareMeterPrice?: Maybe<Scalars['String']['output']>;
  /** Номер земельного участка */
  stead?: Maybe<Scalars['String']['output']>;
  /** Кадастровый номер земельного участка */
  steadCadastralNumber?: Maybe<Scalars['String']['output']>;
  /** ФИАС-код земельного участка */
  steadFiasId?: Maybe<Scalars['String']['output']>;
  /** КЛАДР-код земельного участка */
  steadKladrId?: Maybe<Scalars['String']['output']>;
  /** Тип земельного участка (всегда "уч") */
  steadType?: Maybe<Scalars['String']['output']>;
  /** Тип земельного участка (полный, всегда "участок") */
  steadTypeFull?: Maybe<Scalars['String']['output']>;
  /** Улица */
  street?: Maybe<Scalars['String']['output']>;
  /** ФИАС-код улицы */
  streetFiasId?: Maybe<Scalars['String']['output']>;
  /** Тип улицы */
  streetType?: Maybe<Scalars['String']['output']>;
  /** Тип улицы (полный) */
  streetTypeFull?: Maybe<Scalars['String']['output']>;
  /** Улица с типом */
  streetWithType?: Maybe<Scalars['String']['output']>;
  /** Код ИФНС для физических лиц */
  taxOffice?: Maybe<Scalars['String']['output']>;
  /** Код ИФНС для организаций */
  taxOfficeLegal?: Maybe<Scalars['String']['output']>;
  /** Часовой пояс */
  timezone?: Maybe<Scalars['String']['output']>;
};


export type TNestedHabitationAddressMetroArgs = {
  pagination?: InputMaybe<TPagination>;
};

export type TNestedHabitationAddressMetro = {
  __typename?: 'NestedHabitationAddressMetro';
  /** Расстояние до станции метро в километрах */
  distance?: Maybe<Scalars['Float']['output']>;
  /** Станция метро - название линии */
  line?: Maybe<Scalars['String']['output']>;
  /** Станция метро - название станции */
  name?: Maybe<Scalars['String']['output']>;
};

export type TNestedHabitationAddressMetroObjectFilterType = {
  distance?: InputMaybe<TFloatFilter>;
  line?: InputMaybe<TStringFilter>;
  name?: InputMaybe<TStringFilter>;
};

export type TNestedHabitationAddressObjectFilterType = {
  area?: InputMaybe<TStringFilter>;
  areaFiasId?: InputMaybe<TStringFilter>;
  areaKladrId?: InputMaybe<TStringFilter>;
  areaType?: InputMaybe<TStringFilter>;
  areaTypeFull?: InputMaybe<TStringFilter>;
  areaWithType?: InputMaybe<TStringFilter>;
  beltwayDistance?: InputMaybe<TStringFilter>;
  beltwayHit?: InputMaybe<TStringFilter>;
  block?: InputMaybe<TStringFilter>;
  blockType?: InputMaybe<TStringFilter>;
  blockTypeFull?: InputMaybe<TStringFilter>;
  cadastralNumber?: InputMaybe<TCadastralNumberFilter>;
  capitalMarker?: InputMaybe<TStringFilter>;
  city?: InputMaybe<TStringFilter>;
  cityArea?: InputMaybe<TStringFilter>;
  cityDistrict?: InputMaybe<TStringFilter>;
  cityDistrictFiasId?: InputMaybe<TStringFilter>;
  cityDistrictType?: InputMaybe<TStringFilter>;
  cityDistrictTypeFull?: InputMaybe<TStringFilter>;
  cityDistrictWithType?: InputMaybe<TStringFilter>;
  cityFiasId?: InputMaybe<TStringFilter>;
  cityKladrId?: InputMaybe<TStringFilter>;
  cityType?: InputMaybe<TStringFilter>;
  cityTypeFull?: InputMaybe<TStringFilter>;
  cityWithType?: InputMaybe<TStringFilter>;
  constructionYear?: InputMaybe<TYearFilter>;
  countryId?: InputMaybe<TStringFilter>;
  countryIsoCode?: InputMaybe<TStringFilter>;
  dadata?: InputMaybe<TStringFilter>;
  federalDistrict?: InputMaybe<TStringFilter>;
  fiasActualityState?: InputMaybe<TStringFilter>;
  fiasId?: InputMaybe<TStringFilter>;
  fiasLevel?: InputMaybe<TStringFilter>;
  flat?: InputMaybe<TStringFilter>;
  flatArea?: InputMaybe<TStringFilter>;
  flatFiasId?: InputMaybe<TStringFilter>;
  flatPrice?: InputMaybe<TStringFilter>;
  flatType?: InputMaybe<TStringFilter>;
  flatTypeFull?: InputMaybe<TStringFilter>;
  floorNumber?: InputMaybe<TStringFilter>;
  floorsNumber?: InputMaybe<TStringFilter>;
  geoLat?: InputMaybe<TStringFilter>;
  geoLon?: InputMaybe<TStringFilter>;
  geonameOd?: InputMaybe<TStringFilter>;
  house?: InputMaybe<TStringFilter>;
  houseCadastralNumber?: InputMaybe<TStringFilter>;
  houseFiasId?: InputMaybe<TStringFilter>;
  houseKladrId?: InputMaybe<TStringFilter>;
  houseType?: InputMaybe<TStringFilter>;
  houseTypeFull?: InputMaybe<TStringFilter>;
  isFromDadata?: InputMaybe<TBooleanFilter>;
  kladrId?: InputMaybe<TStringFilter>;
  locationRoute?: InputMaybe<TStringFilter>;
  metro?: InputMaybe<TNestedHabitationAddressMetroObjectFilterType>;
  okato?: InputMaybe<TStringFilter>;
  oktmo?: InputMaybe<TStringFilter>;
  postalBox?: InputMaybe<TStringFilter>;
  postalCode?: InputMaybe<TPostalCodeFilter>;
  region?: InputMaybe<TStringFilter>;
  regionFiasId?: InputMaybe<TStringFilter>;
  regionIsoCode?: InputMaybe<TStringFilter>;
  regionKladrId?: InputMaybe<TStringFilter>;
  regionType?: InputMaybe<TStringFilter>;
  regionTypeFull?: InputMaybe<TStringFilter>;
  regionWithType?: InputMaybe<TStringFilter>;
  registrationDate?: InputMaybe<TDateTimeIsoFilter>;
  roomsCount?: InputMaybe<TStringFilter>;
  settlement?: InputMaybe<TStringFilter>;
  settlementFiasId?: InputMaybe<TStringFilter>;
  settlementKladrId?: InputMaybe<TStringFilter>;
  settlementType?: InputMaybe<TStringFilter>;
  settlementTypeFull?: InputMaybe<TStringFilter>;
  settlementTypeWithType?: InputMaybe<TStringFilter>;
  squareMeterPrice?: InputMaybe<TStringFilter>;
  stead?: InputMaybe<TStringFilter>;
  steadCadastralNumber?: InputMaybe<TStringFilter>;
  steadFiasId?: InputMaybe<TStringFilter>;
  steadKladrId?: InputMaybe<TStringFilter>;
  steadType?: InputMaybe<TStringFilter>;
  steadTypeFull?: InputMaybe<TStringFilter>;
  street?: InputMaybe<TStringFilter>;
  streetFiasId?: InputMaybe<TStringFilter>;
  streetType?: InputMaybe<TStringFilter>;
  streetTypeFull?: InputMaybe<TStringFilter>;
  streetWithType?: InputMaybe<TStringFilter>;
  taxOffice?: InputMaybe<TStringFilter>;
  taxOfficeLegal?: InputMaybe<TStringFilter>;
  timezone?: InputMaybe<TStringFilter>;
};

export type TNestedHabitationAlfa = {
  __typename?: 'NestedHabitationAlfa';
  /** Адрес  проживания [Альфа] */
  livingPeople?: Maybe<TPeople>;
  /** Адрес регистрации [Альфа] */
  registeredPeople?: Maybe<TPeople>;
};


export type TNestedHabitationAlfaLivingPeopleArgs = {
  filter?: InputMaybe<TPeopleFilter>;
};


export type TNestedHabitationAlfaRegisteredPeopleArgs = {
  filter?: InputMaybe<TPeopleFilter>;
};

export type TNestedHabitationCreditSelection = {
  __typename?: 'NestedHabitationCreditSelection';
  pledgeOwnerFamilyStatus?: Maybe<EFamilyStatus>;
  pledgeOwnerFirstName?: Maybe<Scalars['StrictString']['output']>;
  pledgeOwnerLastName?: Maybe<Scalars['StrictString']['output']>;
  pledgeOwnerMiddleName?: Maybe<Scalars['StrictString']['output']>;
  pledgeOwnerPhone?: Maybe<Scalars['PhoneNumber']['output']>;
  pledgeOwnerRelationship?: Maybe<ERelationStatus>;
  pledgeOwnerSingle?: Maybe<Scalars['String']['output']>;
};

export type TNestedHabitationCreditSelectionObjectFilterType = {
  pledgeOwnerFamilyStatus?: InputMaybe<TEFamilyStatusFilter>;
  pledgeOwnerFirstName?: InputMaybe<TStrictStringFilter>;
  pledgeOwnerLastName?: InputMaybe<TStrictStringFilter>;
  pledgeOwnerMiddleName?: InputMaybe<TStrictStringFilter>;
  pledgeOwnerPhone?: InputMaybe<TPhoneNumberFilter>;
  pledgeOwnerRelationship?: InputMaybe<TERelationStatusFilter>;
  pledgeOwnerSingle?: InputMaybe<TStringFilter>;
};

export type TNestedHabitationDocuments = {
  __typename?: 'NestedHabitationDocuments';
  /** Информация о недвижимости из ЕГРН */
  EGRN?: Maybe<Array<Maybe<TRealestateFile>>>;
};


export type TNestedHabitationDocumentsEgrnArgs = {
  filter?: InputMaybe<TRealestateFileFilter>;
  pagination?: InputMaybe<TPagination>;
};

export type TNestedHabitationProperties = {
  __typename?: 'NestedHabitationProperties';
  /** Оценочная стоимость */
  assessedValue?: Maybe<Scalars['Float']['output']>;
  /** Кадастровый номер (специально для RED), потому что в address это поле может быть перезатёрто DaData`ой */
  cadastralNumber?: Maybe<Scalars['CadastralNumber']['output']>;
  /** Год постройки дома (специально для RED), потому что в address это поле может быть перезатёрто DaData`ой */
  constructionYear?: Maybe<Scalars['year']['output']>;
  /** Площадь (специально для RED), потому что в address это поле может быть перезатёрто DaData`ой */
  flatArea?: Maybe<Scalars['String']['output']>;
  /** Номер этажа (специально для RED), потому что в address это поле может быть перезатёрто DaData`ой */
  floorNumber?: Maybe<Scalars['String']['output']>;
  /** Количество этажей */
  floorsNumber?: Maybe<Scalars['Int']['output']>;
  /** Вид недвижимости квартира/дом/комната */
  habitationType?: Maybe<Scalars['String']['output']>;
  /** Газификация */
  hasGas?: Maybe<Scalars['Boolean']['output']>;
  /** Наличие перепланировки */
  hasRedevelopment?: Maybe<Scalars['Boolean']['output']>;
  /** Имеются ли деревянные перекрытия */
  hasWoodenFloors?: Maybe<Scalars['Boolean']['output']>;
  /** Планируется ремонт */
  isRenovationPlanned?: Maybe<Scalars['Boolean']['output']>;
  /** Снимаю квартиру */
  isRented?: Maybe<Scalars['Boolean']['output']>;
  /** Сдаю квартиру в аренду */
  isRenting?: Maybe<Scalars['Boolean']['output']>;
  /** Материал перекрытий */
  overlapMaterial?: Maybe<Scalars['String']['output']>;
  /** Количество комнат (специально для RED), потому что в address это поле может быть перезатёрто DaData`ой */
  roomsCount?: Maybe<Scalars['String']['output']>;
  /** Материал стен */
  wallMaterial?: Maybe<Scalars['String']['output']>;
};

export type TNestedHabitationPropertiesObjectFilterType = {
  assessedValue?: InputMaybe<TFloatFilter>;
  cadastralNumber?: InputMaybe<TCadastralNumberFilter>;
  constructionYear?: InputMaybe<TYearFilter>;
  flatArea?: InputMaybe<TStringFilter>;
  floorNumber?: InputMaybe<TStringFilter>;
  floorsNumber?: InputMaybe<TIntFilter>;
  habitationType?: InputMaybe<TStringFilter>;
  hasGas?: InputMaybe<TBooleanFilter>;
  hasRedevelopment?: InputMaybe<TBooleanFilter>;
  hasWoodenFloors?: InputMaybe<TBooleanFilter>;
  isRenovationPlanned?: InputMaybe<TBooleanFilter>;
  isRented?: InputMaybe<TBooleanFilter>;
  isRenting?: InputMaybe<TBooleanFilter>;
  overlapMaterial?: InputMaybe<TStringFilter>;
  roomsCount?: InputMaybe<TStringFilter>;
  wallMaterial?: InputMaybe<TStringFilter>;
};

export type TNestedHabitationSber = {
  __typename?: 'NestedHabitationSber';
  /** Адрес  проживания (Сбер) */
  livingPeople?: Maybe<TPeople>;
  /** Адрес регистрации (Сбер) */
  registeredPeople?: Maybe<TPeople>;
};


export type TNestedHabitationSberLivingPeopleArgs = {
  filter?: InputMaybe<TPeopleFilter>;
};


export type TNestedHabitationSberRegisteredPeopleArgs = {
  filter?: InputMaybe<TPeopleFilter>;
};

export type TNestedHabitationTBank = {
  __typename?: 'NestedHabitationTBank';
  /** Адрес  проживания (ТБанк) */
  livingPeople?: Maybe<TPeople>;
  /** Адрес регистрации (ТБанк) */
  registeredPeople?: Maybe<TPeople>;
};


export type TNestedHabitationTBankLivingPeopleArgs = {
  filter?: InputMaybe<TPeopleFilter>;
};


export type TNestedHabitationTBankRegisteredPeopleArgs = {
  filter?: InputMaybe<TPeopleFilter>;
};

export type TNestedNdfl2Income = {
  __typename?: 'NestedNDFL2Income';
  /** Доходы, облагаемые по ставке: Код бюджетной классификации */
  budgetClassificationCode?: Maybe<Scalars['String']['output']>;
  incomeTaxableByMonth?: Maybe<Array<Maybe<TNestedNdfl2IncomeIncomeTaxableByMonth>>>;
  /** Доходы, облагаемые по ставке: Ставка */
  taxRate?: Maybe<Scalars['Int']['output']>;
  total?: Maybe<TNestedNdfl2IncomeTotal>;
};


export type TNestedNdfl2IncomeIncomeTaxableByMonthArgs = {
  pagination?: InputMaybe<TPagination>;
};

export type TNestedNdfl2IncomeIncomeTaxableByMonth = {
  __typename?: 'NestedNDFL2IncomeIncomeTaxableByMonth';
  /** Доходы, облагаемые по ставке: Сумма дохода */
  amount?: Maybe<Scalars['Float']['output']>;
  /** Доходы, облагаемые по ставке: Код дохода */
  code?: Maybe<Scalars['String']['output']>;
  deduction?: Maybe<TNestedNdfl2IncomeIncomeTaxableByMonthDeduction>;
  /** Доходы, облагаемые по ставке: Месяц */
  month?: Maybe<Scalars['String']['output']>;
};

export type TNestedNdfl2IncomeIncomeTaxableByMonthDeduction = {
  __typename?: 'NestedNDFL2IncomeIncomeTaxableByMonthDeduction';
  /** Доходы, облагаемые по ставке: Сумма вычета */
  amount?: Maybe<Scalars['Float']['output']>;
  /** Доходы, облагаемые по ставке: Код вычета */
  code?: Maybe<Scalars['String']['output']>;
};

export type TNestedNdfl2IncomeIncomeTaxableByMonthDeductionObjectFilterType = {
  amount?: InputMaybe<TFloatFilter>;
  code?: InputMaybe<TStringFilter>;
};

export type TNestedNdfl2IncomeIncomeTaxableByMonthObjectFilterType = {
  amount?: InputMaybe<TFloatFilter>;
  code?: InputMaybe<TStringFilter>;
  deduction?: InputMaybe<TNestedNdfl2IncomeIncomeTaxableByMonthDeductionObjectFilterType>;
  month?: InputMaybe<TStringFilter>;
};

export type TNestedNdfl2IncomeObjectFilterType = {
  budgetClassificationCode?: InputMaybe<TStringFilter>;
  incomeTaxableByMonth?: InputMaybe<TNestedNdfl2IncomeIncomeTaxableByMonthObjectFilterType>;
  taxRate?: InputMaybe<TIntFilter>;
  total?: InputMaybe<TNestedNdfl2IncomeTotalObjectFilterType>;
};

export type TNestedNdfl2IncomeTotal = {
  __typename?: 'NestedNDFL2IncomeTotal';
  /** Общие суммы дохода и налога: Общая сумма доходов */
  amount?: Maybe<Scalars['Float']['output']>;
  /** Общие суммы дохода и налога: Сумма фиксированных  авансовых платежей */
  fixedAdvancePaymentAmount?: Maybe<Scalars['Float']['output']>;
  /** Общие суммы дохода и налога: Сумма налога исчисленная  */
  taxAmount?: Maybe<Scalars['Float']['output']>;
  /** Общие суммы дохода и налога: Сумма налога перечисленная */
  taxAmountPaid?: Maybe<Scalars['Float']['output']>;
  /** Общие суммы дохода и налога: Налоговая база */
  taxBase?: Maybe<Scalars['Float']['output']>;
  /** Общие суммы дохода и налога: Сумма налога на прибыль организаций, подлежащая зачету */
  taxOrganizationAmount?: Maybe<Scalars['Float']['output']>;
  /** Общие суммы дохода и налога: Сумма налога, излишне  удержанная налоговым агентом  */
  taxOverWithheld?: Maybe<Scalars['Float']['output']>;
  /** Общие суммы дохода и налога: Сумма налога удержанная  */
  taxWithholding?: Maybe<Scalars['Float']['output']>;
};

export type TNestedNdfl2IncomeTotalObjectFilterType = {
  amount?: InputMaybe<TFloatFilter>;
  fixedAdvancePaymentAmount?: InputMaybe<TFloatFilter>;
  taxAmount?: InputMaybe<TFloatFilter>;
  taxAmountPaid?: InputMaybe<TFloatFilter>;
  taxBase?: InputMaybe<TFloatFilter>;
  taxOrganizationAmount?: InputMaybe<TFloatFilter>;
  taxOverWithheld?: InputMaybe<TFloatFilter>;
  taxWithholding?: InputMaybe<TFloatFilter>;
};

export type TNestedNdfl2Person = {
  __typename?: 'NestedNDFL2Person';
  /** Получатель доходов: дата рождения налогоплательщика */
  birthDate?: Maybe<Scalars['BirthDate']['output']>;
  /** Получатель доходов: гражданство налогоплательщика */
  citizenship?: Maybe<Scalars['String']['output']>;
  document?: Maybe<TNestedNdfl2PersonDocument>;
  /** Получатель доходов: Имя */
  firstName?: Maybe<Scalars['StrictString']['output']>;
  /** Получатель доходов: Фамилия */
  lastName?: Maybe<Scalars['StrictString']['output']>;
  /** Получатель доходов: Отчество */
  middleName?: Maybe<Scalars['StrictString']['output']>;
  /** Получатель доходов: статус налогоплательщика */
  status?: Maybe<Scalars['String']['output']>;
};

export type TNestedNdfl2PersonDocument = {
  __typename?: 'NestedNDFL2PersonDocument';
  /** Получатель доходов: код документа, подтвержающего личность */
  code?: Maybe<Scalars['String']['output']>;
  /** Получатель доходов: серия и номер документа, подтвержающего личность */
  seriesNumber?: Maybe<Scalars['String']['output']>;
};

export type TNestedNdfl2PersonDocumentObjectFilterType = {
  code?: InputMaybe<TStringFilter>;
  seriesNumber?: InputMaybe<TStringFilter>;
};

export type TNestedNdfl2PersonObjectFilterType = {
  birthDate?: InputMaybe<TBirthDateFilter>;
  citizenship?: InputMaybe<TStringFilter>;
  document?: InputMaybe<TNestedNdfl2PersonDocumentObjectFilterType>;
  firstName?: InputMaybe<TStrictStringFilter>;
  lastName?: InputMaybe<TStrictStringFilter>;
  middleName?: InputMaybe<TStrictStringFilter>;
  status?: InputMaybe<TStringFilter>;
};

export type TNestedNdfl2TaxAgent = {
  __typename?: 'NestedNDFL2TaxAgent';
  legalEntity?: Maybe<TNestedNdfl2TaxAgentLegalEntity>;
  naturalPerson?: Maybe<TNestedNdfl2TaxAgentNaturalPerson>;
  /** Данные о налоговом агенте: ОКТМО */
  oktmo?: Maybe<Scalars['String']['output']>;
  /** Данные о налоговом агенте: Телефон */
  phone?: Maybe<Scalars['String']['output']>;
};

export type TNestedNdfl2TaxAgentLegalEntity = {
  __typename?: 'NestedNDFL2TaxAgentLegalEntity';
  /** Данные о налоговом агенте (юридическое лицо): ИНН */
  inn?: Maybe<Scalars['INN']['output']>;
  /** Данные о налоговом агенте (юридическое лицо): КПП */
  kpp?: Maybe<Scalars['KPP']['output']>;
  reorganizedInfo?: Maybe<TNestedNdfl2TaxAgentLegalEntityReorganizedInfo>;
  /** Данные о налоговом агенте (юридическое лицо): наименование организации */
  title?: Maybe<Scalars['String']['output']>;
};

export type TNestedNdfl2TaxAgentLegalEntityObjectFilterType = {
  inn?: InputMaybe<TInnFilter>;
  kpp?: InputMaybe<TKppFilter>;
  reorganizedInfo?: InputMaybe<TNestedNdfl2TaxAgentLegalEntityReorganizedInfoObjectFilterType>;
  title?: InputMaybe<TStringFilter>;
};

export type TNestedNdfl2TaxAgentLegalEntityReorganizedInfo = {
  __typename?: 'NestedNDFL2TaxAgentLegalEntityReorganizedInfo';
  /** Код формы реорганизации (ликвидации)/закрытия */
  form?: Maybe<Scalars['String']['output']>;
  /** ИНН реорганизованной организации/закрытого подразделения */
  inn?: Maybe<Scalars['INN']['output']>;
  /** КПП реорганизованной организации/закрытого подразделения */
  kpp?: Maybe<Scalars['KPP']['output']>;
};

export type TNestedNdfl2TaxAgentLegalEntityReorganizedInfoObjectFilterType = {
  form?: InputMaybe<TStringFilter>;
  inn?: InputMaybe<TInnFilter>;
  kpp?: InputMaybe<TKppFilter>;
};

export type TNestedNdfl2TaxAgentNaturalPerson = {
  __typename?: 'NestedNDFL2TaxAgentNaturalPerson';
  /** Данные о налоговом агенте (физическое лицо): Имя */
  firstName?: Maybe<Scalars['StrictString']['output']>;
  /** Данные о налоговом агенте (физическое лицо): ИНН */
  inn?: Maybe<Scalars['String']['output']>;
  /** Данные о налоговом агенте (физическое лицо): Фамилия */
  lastName?: Maybe<Scalars['StrictString']['output']>;
  /** Данные о налоговом агенте (физическое лицо): Отчество */
  middleName?: Maybe<Scalars['StrictString']['output']>;
};

export type TNestedNdfl2TaxAgentNaturalPersonObjectFilterType = {
  firstName?: InputMaybe<TStrictStringFilter>;
  inn?: InputMaybe<TStringFilter>;
  lastName?: InputMaybe<TStrictStringFilter>;
  middleName?: InputMaybe<TStrictStringFilter>;
};

export type TNestedNdfl2TaxAgentObjectFilterType = {
  legalEntity?: InputMaybe<TNestedNdfl2TaxAgentLegalEntityObjectFilterType>;
  naturalPerson?: InputMaybe<TNestedNdfl2TaxAgentNaturalPersonObjectFilterType>;
  oktmo?: InputMaybe<TStringFilter>;
  phone?: InputMaybe<TStringFilter>;
};

export type TNestedOrganizationBank = {
  __typename?: 'NestedOrganizationBank';
  /** Расчётный счёт */
  accountNumber?: Maybe<Scalars['NumberString']['output']>;
  /** БИК банка */
  bik?: Maybe<Scalars['NumberString']['output']>;
  /** Корреспондентский счёт */
  correspondentAccount?: Maybe<Scalars['NumberString']['output']>;
  /** Id банка */
  id?: Maybe<Scalars['String']['output']>;
  /** ИНН банка */
  inn?: Maybe<Scalars['INN']['output']>;
  /** Имя банк */
  name?: Maybe<Scalars['StrictString']['output']>;
};

export type TNestedOrganizationBankObjectFilterType = {
  accountNumber?: InputMaybe<TNumberStringFilter>;
  bik?: InputMaybe<TNumberStringFilter>;
  correspondentAccount?: InputMaybe<TNumberStringFilter>;
  id?: InputMaybe<TStringFilter>;
  inn?: InputMaybe<TInnFilter>;
  name?: InputMaybe<TStrictStringFilter>;
};

export type TNestedOrganizationCeo = {
  __typename?: 'NestedOrganizationCeo';
  /** Годовой доход ЕИО */
  annualIncome?: Maybe<Scalars['Int']['output']>;
  /** Образование ЕИО */
  education?: Maybe<EEducation>;
  /** Признак того, что ЕИО собственник */
  isOwner?: Maybe<Scalars['Boolean']['output']>;
  /** Семейное положение */
  maritalStatus?: Maybe<EFamilyStatus>;
  /** Номер телефона ЕИО */
  phone?: Maybe<Scalars['PhoneNumber']['output']>;
  /** Должность ЕИО */
  position?: Maybe<Scalars['String']['output']>;
  /** Доля ЕИО в уставном капитале */
  share?: Maybe<Scalars['Int']['output']>;
  spouse?: Maybe<TNestedOrganizationCeoSpouse>;
  /** Сколько лет в качестве учредителя */
  yearsAsFounder?: Maybe<Scalars['Int']['output']>;
  /** Сколько лет ведёт бизнес */
  yearsInBusiness?: Maybe<Scalars['Int']['output']>;
};

export type TNestedOrganizationCeoObjectFilterType = {
  annualIncome?: InputMaybe<TIntFilter>;
  education?: InputMaybe<TEEducationFilter>;
  isOwner?: InputMaybe<TBooleanFilter>;
  maritalStatus?: InputMaybe<TEFamilyStatusFilter>;
  phone?: InputMaybe<TPhoneNumberFilter>;
  position?: InputMaybe<TStringFilter>;
  share?: InputMaybe<TIntFilter>;
  spouse?: InputMaybe<TNestedOrganizationCeoSpouseObjectFilterType>;
  yearsAsFounder?: InputMaybe<TIntFilter>;
  yearsInBusiness?: InputMaybe<TIntFilter>;
};

export type TNestedOrganizationCeoSpouse = {
  __typename?: 'NestedOrganizationCeoSpouse';
  /** Дата рождения супруга/супруги */
  birthDate?: Maybe<Scalars['BirthDate']['output']>;
  /** Имя супруга/супруги */
  firstName?: Maybe<Scalars['StrictString']['output']>;
  /** Фамилия супруга/супруги */
  lastName?: Maybe<Scalars['StrictString']['output']>;
  /** Отчество супруга/супруги */
  middleName?: Maybe<Scalars['StrictString']['output']>;
};

export type TNestedOrganizationCeoSpouseObjectFilterType = {
  birthDate?: InputMaybe<TBirthDateFilter>;
  firstName?: InputMaybe<TStrictStringFilter>;
  lastName?: InputMaybe<TStrictStringFilter>;
  middleName?: InputMaybe<TStrictStringFilter>;
};

export type TNestedOrganizationContact = {
  __typename?: 'NestedOrganizationContact';
  /** Фамилия контактного лица */
  firstName?: Maybe<Scalars['StrictString']['output']>;
  /** Фамилия контактного лица */
  lastName?: Maybe<Scalars['StrictString']['output']>;
  /** Отчество контактного лица */
  middleName?: Maybe<Scalars['StrictString']['output']>;
  /** Телефон контактного лица */
  phone?: Maybe<Scalars['PhoneNumber']['output']>;
};

export type TNestedOrganizationContactObjectFilterType = {
  firstName?: InputMaybe<TStrictStringFilter>;
  lastName?: InputMaybe<TStrictStringFilter>;
  middleName?: InputMaybe<TStrictStringFilter>;
  phone?: InputMaybe<TPhoneNumberFilter>;
};

export type TNestedOrganizationOwner = {
  __typename?: 'NestedOrganizationOwner';
  /** Фамилия владельца */
  firstName?: Maybe<Scalars['StrictString']['output']>;
  /** Фамилия владельца */
  lastName?: Maybe<Scalars['StrictString']['output']>;
  /** Фамилия владельца */
  middleName?: Maybe<Scalars['StrictString']['output']>;
};

export type TNestedOrganizationOwnerObjectFilterType = {
  firstName?: InputMaybe<TStrictStringFilter>;
  lastName?: InputMaybe<TStrictStringFilter>;
  middleName?: InputMaybe<TStrictStringFilter>;
};

export type TNestedPayoutIncomeNdfl2IncomeTaxable = {
  __typename?: 'NestedPayoutIncomeNDFL2IncomeTaxable';
  /** Сумма дохода */
  amount?: Maybe<Scalars['Float']['output']>;
  /** Код дохода */
  code?: Maybe<Scalars['String']['output']>;
};

export type TNestedPayoutIncomeNdfl2IncomeTaxableObjectFilterType = {
  amount?: InputMaybe<TFloatFilter>;
  code?: InputMaybe<TStringFilter>;
};

export type TNestedPayoutIncomeNdfl2TaxAgent = {
  __typename?: 'NestedPayoutIncomeNDFL2TaxAgent';
  legalEntity?: Maybe<TNestedPayoutIncomeNdfl2TaxAgentLegalEntity>;
  naturalPerson?: Maybe<TNestedPayoutIncomeNdfl2TaxAgentNaturalPerson>;
};

export type TNestedPayoutIncomeNdfl2TaxAgentLegalEntity = {
  __typename?: 'NestedPayoutIncomeNDFL2TaxAgentLegalEntity';
  /** Данные о налоговом агенте (юридическое лицо): ИНН */
  inn?: Maybe<Scalars['String']['output']>;
  /** Данные о налоговом агенте (юридическое лицо): КПП */
  kpp?: Maybe<Scalars['KPP']['output']>;
  reorganizedInfo?: Maybe<TNestedPayoutIncomeNdfl2TaxAgentLegalEntityReorganizedInfo>;
  /** Данные о налоговом агенте (юридическое лицо): наименование организации */
  title?: Maybe<Scalars['String']['output']>;
};

export type TNestedPayoutIncomeNdfl2TaxAgentLegalEntityObjectFilterType = {
  inn?: InputMaybe<TStringFilter>;
  kpp?: InputMaybe<TKppFilter>;
  reorganizedInfo?: InputMaybe<TNestedPayoutIncomeNdfl2TaxAgentLegalEntityReorganizedInfoObjectFilterType>;
  title?: InputMaybe<TStringFilter>;
};

export type TNestedPayoutIncomeNdfl2TaxAgentLegalEntityReorganizedInfo = {
  __typename?: 'NestedPayoutIncomeNDFL2TaxAgentLegalEntityReorganizedInfo';
  /** Код формы реорганизации (ликвидации)/закрытия */
  form?: Maybe<Scalars['String']['output']>;
  /** ИНН реорганизованной организации/закрытого подразделения */
  inn?: Maybe<Scalars['String']['output']>;
  /** КПП реорганизованной организации/закрытого подразделения */
  kpp?: Maybe<Scalars['KPP']['output']>;
};

export type TNestedPayoutIncomeNdfl2TaxAgentLegalEntityReorganizedInfoObjectFilterType = {
  form?: InputMaybe<TStringFilter>;
  inn?: InputMaybe<TStringFilter>;
  kpp?: InputMaybe<TKppFilter>;
};

export type TNestedPayoutIncomeNdfl2TaxAgentNaturalPerson = {
  __typename?: 'NestedPayoutIncomeNDFL2TaxAgentNaturalPerson';
  /** Данные о налоговом агенте (физическое лицо): Имя */
  firstName?: Maybe<Scalars['StrictString']['output']>;
  /** Данные о налоговом агенте (физическое лицо): ИНН */
  inn?: Maybe<Scalars['String']['output']>;
  /** Данные о налоговом агенте (физическое лицо): Фамилия */
  lastName?: Maybe<Scalars['StrictString']['output']>;
  /** Данные о налоговом агенте (физическое лицо): Отчество */
  middleName?: Maybe<Scalars['StrictString']['output']>;
};

export type TNestedPayoutIncomeNdfl2TaxAgentNaturalPersonObjectFilterType = {
  firstName?: InputMaybe<TStrictStringFilter>;
  inn?: InputMaybe<TStringFilter>;
  lastName?: InputMaybe<TStrictStringFilter>;
  middleName?: InputMaybe<TStrictStringFilter>;
};

export type TNestedPayoutIncomeNdfl2TaxAgentObjectFilterType = {
  legalEntity?: InputMaybe<TNestedPayoutIncomeNdfl2TaxAgentLegalEntityObjectFilterType>;
  naturalPerson?: InputMaybe<TNestedPayoutIncomeNdfl2TaxAgentNaturalPersonObjectFilterType>;
};

export type TNestedPayoutIncomeNdfl2Total = {
  __typename?: 'NestedPayoutIncomeNDFL2Total';
  /** Общая сумма дохода */
  amount?: Maybe<Scalars['Float']['output']>;
  /** Налоговая база */
  taxBase?: Maybe<Scalars['Float']['output']>;
};

export type TNestedPayoutIncomeNdfl2TotalObjectFilterType = {
  amount?: InputMaybe<TFloatFilter>;
  taxBase?: InputMaybe<TFloatFilter>;
};

export type TNestedPayoutIncomeNdfl3Entrepreneurship = {
  __typename?: 'NestedPayoutIncomeNDFL3Entrepreneurship';
  /** Доходы, полученные от предпринимательской, адвокатской деятельности и частной практики: Общая сумма дохода */
  amount?: Maybe<Scalars['Float']['output']>;
  /** Доходы, полученные от предпринимательской, адвокатской деятельности и частной практики: Налоговая база */
  taxBase?: Maybe<Scalars['Float']['output']>;
};

export type TNestedPayoutIncomeNdfl3EntrepreneurshipObjectFilterType = {
  amount?: InputMaybe<TFloatFilter>;
  taxBase?: InputMaybe<TFloatFilter>;
};

export type TNestedPayoutIncomeNdfl3Income = {
  __typename?: 'NestedPayoutIncomeNDFL3Income';
  agent?: Maybe<TNestedPayoutIncomeNdfl3IncomeAgent>;
  /** Общая сумма дохода */
  amount?: Maybe<Scalars['Float']['output']>;
};

export type TNestedPayoutIncomeNdfl3IncomeAgent = {
  __typename?: 'NestedPayoutIncomeNDFL3IncomeAgent';
  legalEntity?: Maybe<TNestedPayoutIncomeNdfl3IncomeAgentLegalEntity>;
  naturalPerson?: Maybe<TNestedPayoutIncomeNdfl3IncomeAgentNaturalPerson>;
};

export type TNestedPayoutIncomeNdfl3IncomeAgentLegalEntity = {
  __typename?: 'NestedPayoutIncomeNDFL3IncomeAgentLegalEntity';
  /** Данные о налоговом агенте (юридическое лицо): ИНН */
  inn?: Maybe<Scalars['String']['output']>;
  /** Данные о налоговом агенте (юридическое лицо): КПП */
  kpp?: Maybe<Scalars['KPP']['output']>;
  reorganizedInfo?: Maybe<TNestedPayoutIncomeNdfl3IncomeAgentLegalEntityReorganizedInfo>;
  /** Данные о налоговом агенте (юридическое лицо): наименование организации */
  title?: Maybe<Scalars['String']['output']>;
};

export type TNestedPayoutIncomeNdfl3IncomeAgentLegalEntityObjectFilterType = {
  inn?: InputMaybe<TStringFilter>;
  kpp?: InputMaybe<TKppFilter>;
  reorganizedInfo?: InputMaybe<TNestedPayoutIncomeNdfl3IncomeAgentLegalEntityReorganizedInfoObjectFilterType>;
  title?: InputMaybe<TStringFilter>;
};

export type TNestedPayoutIncomeNdfl3IncomeAgentLegalEntityReorganizedInfo = {
  __typename?: 'NestedPayoutIncomeNDFL3IncomeAgentLegalEntityReorganizedInfo';
  /** Код формы реорганизации (ликвидации)/закрытия */
  form?: Maybe<Scalars['String']['output']>;
  /** ИНН реорганизованной организации/закрытого подразделения */
  inn?: Maybe<Scalars['String']['output']>;
  /** КПП реорганизованной организации/закрытого подразделения */
  kpp?: Maybe<Scalars['KPP']['output']>;
};

export type TNestedPayoutIncomeNdfl3IncomeAgentLegalEntityReorganizedInfoObjectFilterType = {
  form?: InputMaybe<TStringFilter>;
  inn?: InputMaybe<TStringFilter>;
  kpp?: InputMaybe<TKppFilter>;
};

export type TNestedPayoutIncomeNdfl3IncomeAgentNaturalPerson = {
  __typename?: 'NestedPayoutIncomeNDFL3IncomeAgentNaturalPerson';
  /** Данные о налоговом агенте (физическое лицо): Имя */
  firstName?: Maybe<Scalars['StrictString']['output']>;
  /** Данные о налоговом агенте (физическое лицо): ИНН */
  inn?: Maybe<Scalars['String']['output']>;
  /** Данные о налоговом агенте (физическое лицо): Фамилия */
  lastName?: Maybe<Scalars['StrictString']['output']>;
  /** Данные о налоговом агенте (физическое лицо): Отчество */
  middleName?: Maybe<Scalars['StrictString']['output']>;
};

export type TNestedPayoutIncomeNdfl3IncomeAgentNaturalPersonObjectFilterType = {
  firstName?: InputMaybe<TStrictStringFilter>;
  inn?: InputMaybe<TStringFilter>;
  lastName?: InputMaybe<TStrictStringFilter>;
  middleName?: InputMaybe<TStrictStringFilter>;
};

export type TNestedPayoutIncomeNdfl3IncomeAgentObjectFilterType = {
  legalEntity?: InputMaybe<TNestedPayoutIncomeNdfl3IncomeAgentLegalEntityObjectFilterType>;
  naturalPerson?: InputMaybe<TNestedPayoutIncomeNdfl3IncomeAgentNaturalPersonObjectFilterType>;
};

export type TNestedPayoutIncomeNdfl3IncomeObjectFilterType = {
  agent?: InputMaybe<TNestedPayoutIncomeNdfl3IncomeAgentObjectFilterType>;
  amount?: InputMaybe<TFloatFilter>;
};

export type TNestedPayoutIncomePayout = {
  __typename?: 'NestedPayoutIncomePayout';
  agent?: Maybe<TNestedPayoutIncomePayoutAgent>;
  incomeByMonth?: Maybe<Array<Maybe<TNestedPayoutIncomePayoutIncomeByMonth>>>;
  /** Год выплаты */
  year?: Maybe<Scalars['year']['output']>;
};


export type TNestedPayoutIncomePayoutIncomeByMonthArgs = {
  pagination?: InputMaybe<TPagination>;
};

export type TNestedPayoutIncomePayoutAgent = {
  __typename?: 'NestedPayoutIncomePayoutAgent';
  legalEntity?: Maybe<TNestedPayoutIncomePayoutAgentLegalEntity>;
  naturalPerson?: Maybe<TNestedPayoutIncomePayoutAgentNaturalPerson>;
};

export type TNestedPayoutIncomePayoutAgentLegalEntity = {
  __typename?: 'NestedPayoutIncomePayoutAgentLegalEntity';
  /** Данные о налоговом агенте (юридическое лицо): ИНН */
  inn?: Maybe<Scalars['String']['output']>;
  /** Данные о налоговом агенте (юридическое лицо): КПП */
  kpp?: Maybe<Scalars['KPP']['output']>;
  reorganizedInfo?: Maybe<TNestedPayoutIncomePayoutAgentLegalEntityReorganizedInfo>;
  /** Данные о налоговом агенте (юридическое лицо): наименование организации */
  title?: Maybe<Scalars['String']['output']>;
};

export type TNestedPayoutIncomePayoutAgentLegalEntityObjectFilterType = {
  inn?: InputMaybe<TStringFilter>;
  kpp?: InputMaybe<TKppFilter>;
  reorganizedInfo?: InputMaybe<TNestedPayoutIncomePayoutAgentLegalEntityReorganizedInfoObjectFilterType>;
  title?: InputMaybe<TStringFilter>;
};

export type TNestedPayoutIncomePayoutAgentLegalEntityReorganizedInfo = {
  __typename?: 'NestedPayoutIncomePayoutAgentLegalEntityReorganizedInfo';
  /** Код формы реорганизации (ликвидации)/закрытия */
  form?: Maybe<Scalars['String']['output']>;
  /** ИНН реорганизованной организации/закрытого подразделения */
  inn?: Maybe<Scalars['String']['output']>;
  /** КПП реорганизованной организации/закрытого подразделения */
  kpp?: Maybe<Scalars['KPP']['output']>;
};

export type TNestedPayoutIncomePayoutAgentLegalEntityReorganizedInfoObjectFilterType = {
  form?: InputMaybe<TStringFilter>;
  inn?: InputMaybe<TStringFilter>;
  kpp?: InputMaybe<TKppFilter>;
};

export type TNestedPayoutIncomePayoutAgentNaturalPerson = {
  __typename?: 'NestedPayoutIncomePayoutAgentNaturalPerson';
  /** Данные о налоговом агенте (физическое лицо): Имя */
  firstName?: Maybe<Scalars['StrictString']['output']>;
  /** Данные о налоговом агенте (физическое лицо): ИНН */
  inn?: Maybe<Scalars['String']['output']>;
  /** Данные о налоговом агенте (физическое лицо): Фамилия */
  lastName?: Maybe<Scalars['StrictString']['output']>;
  /** Данные о налоговом агенте (физическое лицо): Отчество */
  middleName?: Maybe<Scalars['StrictString']['output']>;
};

export type TNestedPayoutIncomePayoutAgentNaturalPersonObjectFilterType = {
  firstName?: InputMaybe<TStrictStringFilter>;
  inn?: InputMaybe<TStringFilter>;
  lastName?: InputMaybe<TStrictStringFilter>;
  middleName?: InputMaybe<TStrictStringFilter>;
};

export type TNestedPayoutIncomePayoutAgentObjectFilterType = {
  legalEntity?: InputMaybe<TNestedPayoutIncomePayoutAgentLegalEntityObjectFilterType>;
  naturalPerson?: InputMaybe<TNestedPayoutIncomePayoutAgentNaturalPersonObjectFilterType>;
};

export type TNestedPayoutIncomePayoutIncomeByMonth = {
  __typename?: 'NestedPayoutIncomePayoutIncomeByMonth';
  /** Сумма выплаты */
  amount?: Maybe<Scalars['Float']['output']>;
  /** Месяц выплаты */
  month?: Maybe<Scalars['String']['output']>;
};

export type TNestedPayoutIncomePayoutIncomeByMonthObjectFilterType = {
  amount?: InputMaybe<TFloatFilter>;
  month?: InputMaybe<TStringFilter>;
};

export type TNestedPayoutIncomePayoutObjectFilterType = {
  agent?: InputMaybe<TNestedPayoutIncomePayoutAgentObjectFilterType>;
  incomeByMonth?: InputMaybe<TNestedPayoutIncomePayoutIncomeByMonthObjectFilterType>;
  year?: InputMaybe<TYearFilter>;
};

export type TNestedPayoutIncomePerson = {
  __typename?: 'NestedPayoutIncomePerson';
  /** Дата рождения */
  birthDate?: Maybe<Scalars['BirthDate']['output']>;
  document?: Maybe<TNestedPayoutIncomePersonDocument>;
  /** Имя */
  firstName?: Maybe<Scalars['StrictString']['output']>;
  /** ИНН */
  inn?: Maybe<Scalars['String']['output']>;
  /** Фамилия */
  lastName?: Maybe<Scalars['StrictString']['output']>;
  /** Отчество */
  middleName?: Maybe<Scalars['StrictString']['output']>;
  /** СНИЛС */
  snils?: Maybe<Scalars['SNILS']['output']>;
};

export type TNestedPayoutIncomePersonDocument = {
  __typename?: 'NestedPayoutIncomePersonDocument';
  /** Код документа, подтвержающего личность */
  code?: Maybe<Scalars['String']['output']>;
  /** Серия и номер документа, подтвержающего личность */
  seriesNumber?: Maybe<Scalars['String']['output']>;
};

export type TNestedPayoutIncomePersonDocumentObjectFilterType = {
  code?: InputMaybe<TStringFilter>;
  seriesNumber?: InputMaybe<TStringFilter>;
};

export type TNestedPayoutIncomePersonObjectFilterType = {
  birthDate?: InputMaybe<TBirthDateFilter>;
  document?: InputMaybe<TNestedPayoutIncomePersonDocumentObjectFilterType>;
  firstName?: InputMaybe<TStrictStringFilter>;
  inn?: InputMaybe<TStringFilter>;
  lastName?: InputMaybe<TStrictStringFilter>;
  middleName?: InputMaybe<TStrictStringFilter>;
  snils?: InputMaybe<TSnilsFilter>;
};

export type TNestedPeopleCreditRating = {
  __typename?: 'NestedPeopleCreditRating';
  /** Дата обновления анкеты кредитного рейтинга */
  dateUpdate?: Maybe<Scalars['DateTimeISO']['output']>;
};

export type TNestedPeopleCreditRatingObjectFilterType = {
  dateUpdate?: InputMaybe<TDateTimeIsoFilter>;
};

export type TNestedPeopleCreditSelection = {
  __typename?: 'NestedPeopleCreditSelection';
  /** Сумма кредита */
  amount?: Maybe<Scalars['String']['output']>;
  /** Марка автомобиля, на который берется кредит */
  autoBrand?: Maybe<Scalars['String']['output']>;
  /** Модель автомобиля, на который берется кредит */
  autoModel?: Maybe<Scalars['String']['output']>;
  /** Год автомобиля, на который берется кредит */
  autoYear?: Maybe<Scalars['year']['output']>;
  /** Залог */
  creditSecurity?: Maybe<ECreditSecurity>;
  /** Сумма личных средств */
  initialFee?: Maybe<Scalars['String']['output']>;
  /** fias города получения кредита */
  obtainCityFiasId?: Maybe<Scalars['String']['output']>;
  /** id города получения кредита */
  obtainCityId?: Maybe<Scalars['String']['output']>;
  /** Роут города получения кредита из сервиса locations */
  obtainCityLocationRoute?: Maybe<Scalars['String']['output']>;
  /** Срок кредита */
  period?: Maybe<Scalars['String']['output']>;
  /** Госномер машины, которая в собственности у пользователя */
  propertyAutoRegistrationPlate?: Maybe<Scalars['RegistrationPlateScalar']['output']>;
  /** Цель кредита */
  purpose?: Maybe<ECreditPurpose>;
  /** Город получения кредита */
  region?: Maybe<Scalars['String']['output']>;
};

export type TNestedPeopleCreditSelectionObjectFilterType = {
  amount?: InputMaybe<TStringFilter>;
  autoBrand?: InputMaybe<TStringFilter>;
  autoModel?: InputMaybe<TStringFilter>;
  autoYear?: InputMaybe<TYearFilter>;
  creditSecurity?: InputMaybe<TECreditSecurityFilter>;
  initialFee?: InputMaybe<TStringFilter>;
  obtainCityFiasId?: InputMaybe<TStringFilter>;
  obtainCityId?: InputMaybe<TStringFilter>;
  obtainCityLocationRoute?: InputMaybe<TStringFilter>;
  period?: InputMaybe<TStringFilter>;
  propertyAutoRegistrationPlate?: InputMaybe<TRegistrationPlateScalarFilter>;
  purpose?: InputMaybe<TECreditPurposeFilter>;
  region?: InputMaybe<TStringFilter>;
};

export type TNestedPeopleDocuments = {
  __typename?: 'NestedPeopleDocuments';
  /** Новый объект загран. паспорта в People.documents */
  FRGNPassport?: Maybe<TFrgnPassport>;
  /** История заграничных паспортов */
  FRGNPassportHistory?: Maybe<Array<Maybe<TFrgnPassport>>>;
  /** Справка 2-НДФЛ */
  NDFL2?: Maybe<Array<Maybe<TNdfl2>>>;
  /** Новый объект ВУ в People.documents */
  driverLicense?: Maybe<TDriverLicense>;
  /** История водительских удостоверений */
  driverLicenseHistory?: Maybe<Array<Maybe<TDriverLicense>>>;
  /** Новый объект паспорта в People.documents */
  passport?: Maybe<TPassport>;
  passportHistory?: Maybe<Array<Maybe<TPassport>>>;
  /** Сведения о доходах физического лица, о выплатах, произведённых плательщиками страховых взносов в пользу физического лица */
  payoutIncome?: Maybe<Array<Maybe<TPayoutIncome>>>;
  /** Договор страхования от клеща */
  tickInsurance?: Maybe<TTickInsuranceAgreement>;
  /** Застрахованные от клеща люди */
  tickInsuranceAgreements?: Maybe<Array<Maybe<TTickInsuranceAgreement>>>;
  /** Электронная книжка */
  workbook?: Maybe<TEsiaeWorkbook>;
};


export type TNestedPeopleDocumentsFrgnPassportArgs = {
  filter?: InputMaybe<TFrgnPassportFilter>;
};


export type TNestedPeopleDocumentsFrgnPassportHistoryArgs = {
  filter?: InputMaybe<TFrgnPassportFilter>;
  pagination?: InputMaybe<TPagination>;
};


export type TNestedPeopleDocumentsNdfl2Args = {
  filter?: InputMaybe<TNdfl2Filter>;
  pagination?: InputMaybe<TPagination>;
};


export type TNestedPeopleDocumentsDriverLicenseArgs = {
  filter?: InputMaybe<TDriverLicenseFilter>;
};


export type TNestedPeopleDocumentsDriverLicenseHistoryArgs = {
  filter?: InputMaybe<TDriverLicenseFilter>;
  pagination?: InputMaybe<TPagination>;
};


export type TNestedPeopleDocumentsPassportArgs = {
  filter?: InputMaybe<TPassportFilter>;
};


export type TNestedPeopleDocumentsPassportHistoryArgs = {
  filter?: InputMaybe<TPassportFilter>;
  pagination?: InputMaybe<TPagination>;
};


export type TNestedPeopleDocumentsPayoutIncomeArgs = {
  filter?: InputMaybe<TPayoutIncomeFilter>;
  pagination?: InputMaybe<TPagination>;
};


export type TNestedPeopleDocumentsTickInsuranceArgs = {
  filter?: InputMaybe<TTickInsuranceAgreementFilter>;
};


export type TNestedPeopleDocumentsTickInsuranceAgreementsArgs = {
  filter?: InputMaybe<TTickInsuranceAgreementFilter>;
  pagination?: InputMaybe<TPagination>;
};


export type TNestedPeopleDocumentsWorkbookArgs = {
  filter?: InputMaybe<TEsiaeWorkbookFilter>;
};

export type TNestedPeopleDriverLicence = {
  __typename?: 'NestedPeopleDriverLicence';
  /** Дата начала стажа по категории A */
  experienceAStartDate?: Maybe<Scalars['DateTimeISO']['output']>;
  /** Дата начала стажа */
  experienceStartDate?: Maybe<Scalars['DateTimeISO']['output']>;
  /** Дата выдачи первых прав */
  firstIssueDate?: Maybe<Scalars['DateTimeISO']['output']>;
  /** Дата выдачи текущих прав */
  issueDate?: Maybe<Scalars['DateTimeISO']['output']>;
  /** Серия и номер водительского удостоверения */
  number?: Maybe<Scalars['SerialNumber']['output']>;
  /** Серия и номер предыдущего водительского удостоверения */
  previousNumber?: Maybe<Scalars['String']['output']>;
};

export type TNestedPeopleFamilyAssets = {
  __typename?: 'NestedPeopleFamilyAssets';
  /** Остаток материнского капитала */
  amount?: Maybe<Scalars['Float']['output']>;
  /** Общаяя сумма материнского капитала */
  total?: Maybe<Scalars['Float']['output']>;
};

export type TNestedPeopleFamilyAssetsObjectFilterType = {
  amount?: InputMaybe<TFloatFilter>;
  total?: InputMaybe<TFloatFilter>;
};

export type TNestedPeopleInternationalPassport = {
  __typename?: 'NestedPeopleInternationalPassport';
  /** Место рождения */
  birthPlace?: Maybe<Scalars['String']['output']>;
  /** Дата окончания срока действия */
  expirationDate?: Maybe<Scalars['DateTimeISO']['output']>;
  /** Имя в заграничном паспорте */
  firstName?: Maybe<Scalars['String']['output']>;
  /** Дата выдачи заграничного паспорта */
  issueDate?: Maybe<Scalars['DateTimeISO']['output']>;
  /** Орган, выдавший заграничный паспорт */
  issuedBy?: Maybe<Scalars['String']['output']>;
  /** Фамилия в заграничном паспорте */
  lastName?: Maybe<Scalars['String']['output']>;
  /** Серия и номер заграничного паспорта */
  number?: Maybe<Scalars['SerialNumberInternationalPassport']['output']>;
};

export type TNestedPeopleJob = {
  __typename?: 'NestedPeopleJob';
  address?: Maybe<TNestedPeopleJobAddress>;
  /** Дата начала работы на текущем месте */
  lastExperienceStartDate?: Maybe<Scalars['DateTimeISO']['output']>;
  organization?: Maybe<TNestedPeopleJobOrganization>;
  /** Название должности */
  title?: Maybe<Scalars['String']['output']>;
  /** Тип должности */
  type?: Maybe<EJobPosition>;
};

export type TNestedPeopleJobAddress = {
  __typename?: 'NestedPeopleJobAddress';
  area?: Maybe<Scalars['String']['output']>;
  areaType?: Maybe<Scalars['String']['output']>;
  /** Корпус организации */
  block?: Maybe<Scalars['String']['output']>;
  blockType?: Maybe<Scalars['String']['output']>;
  /** Город / населенный пункт организации */
  city?: Maybe<Scalars['String']['output']>;
  cityType?: Maybe<Scalars['String']['output']>;
  /** Год постройки дома организации */
  constructionYear?: Maybe<Scalars['String']['output']>;
  /** Код страны */
  countryId?: Maybe<Scalars['String']['output']>;
  /** Адрес организации */
  dadata?: Maybe<Scalars['String']['output']>;
  /** ФИАС-код адреса (идентификатор ФИАС) */
  fiasId?: Maybe<Scalars['String']['output']>;
  /** Уровень детализации, до которого адрес найден в ФИАС */
  fiasLevel?: Maybe<Scalars['String']['output']>;
  /** Квартира организации */
  flat?: Maybe<Scalars['String']['output']>;
  /** Площадь квартиры организации */
  flatArea?: Maybe<Scalars['String']['output']>;
  flatType?: Maybe<Scalars['String']['output']>;
  /** Номер этажа */
  floorNumber?: Maybe<Scalars['String']['output']>;
  /** Количество этажей в доме организации */
  floorsNumber?: Maybe<Scalars['String']['output']>;
  /** Дом организации */
  house?: Maybe<Scalars['String']['output']>;
  houseType?: Maybe<Scalars['String']['output']>;
  /** КЛАДР-код адреса организации */
  kladrId?: Maybe<Scalars['String']['output']>;
  /** Роут адреса работы из сервиса locations */
  locationRoute?: Maybe<Scalars['String']['output']>;
  /** Почтовый индекс РФ организации */
  postalCode?: Maybe<Scalars['PostalCode']['output']>;
  /** Регион организации */
  region?: Maybe<Scalars['String']['output']>;
  regionType?: Maybe<Scalars['String']['output']>;
  /** Количество комнат в доме организации */
  roomsCount?: Maybe<Scalars['String']['output']>;
  settlement?: Maybe<Scalars['String']['output']>;
  settlementType?: Maybe<Scalars['String']['output']>;
  /** Улица организации */
  street?: Maybe<Scalars['String']['output']>;
  /** Тип улицы */
  streetType?: Maybe<Scalars['String']['output']>;
};

export type TNestedPeopleJobAddressObjectFilterType = {
  area?: InputMaybe<TStringFilter>;
  areaType?: InputMaybe<TStringFilter>;
  block?: InputMaybe<TStringFilter>;
  blockType?: InputMaybe<TStringFilter>;
  city?: InputMaybe<TStringFilter>;
  cityType?: InputMaybe<TStringFilter>;
  constructionYear?: InputMaybe<TStringFilter>;
  countryId?: InputMaybe<TStringFilter>;
  dadata?: InputMaybe<TStringFilter>;
  fiasId?: InputMaybe<TStringFilter>;
  fiasLevel?: InputMaybe<TStringFilter>;
  flat?: InputMaybe<TStringFilter>;
  flatArea?: InputMaybe<TStringFilter>;
  flatType?: InputMaybe<TStringFilter>;
  floorNumber?: InputMaybe<TStringFilter>;
  floorsNumber?: InputMaybe<TStringFilter>;
  house?: InputMaybe<TStringFilter>;
  houseType?: InputMaybe<TStringFilter>;
  kladrId?: InputMaybe<TStringFilter>;
  locationRoute?: InputMaybe<TStringFilter>;
  postalCode?: InputMaybe<TPostalCodeFilter>;
  region?: InputMaybe<TStringFilter>;
  regionType?: InputMaybe<TStringFilter>;
  roomsCount?: InputMaybe<TStringFilter>;
  settlement?: InputMaybe<TStringFilter>;
  settlementType?: InputMaybe<TStringFilter>;
  street?: InputMaybe<TStringFilter>;
  streetType?: InputMaybe<TStringFilter>;
};

export type TNestedPeopleJobObjectFilterType = {
  address?: InputMaybe<TNestedPeopleJobAddressObjectFilterType>;
  lastExperienceStartDate?: InputMaybe<TDateTimeIsoFilter>;
  organization?: InputMaybe<TNestedPeopleJobOrganizationObjectFilterType>;
  title?: InputMaybe<TStringFilter>;
  type?: InputMaybe<TEJobPositionFilter>;
};

export type TNestedPeopleJobOrganization = {
  __typename?: 'NestedPeopleJobOrganization';
  /** Сфера деятельности организации */
  activity?: Maybe<EOrganizationActivity>;
  /** Идентификационный номер налогоплательщика (ИНН) */
  inn?: Maybe<Scalars['INN']['output']>;
  /** Наименование организации, где работает клиент */
  name?: Maybe<Scalars['String']['output']>;
  /** Основной государственный регистрационный номер (ОГРН) */
  ogrn?: Maybe<Scalars['OGRN']['output']>;
  /** Код ОКВЭД */
  okved?: Maybe<Scalars['String']['output']>;
  /** Рабочий телефон */
  phone?: Maybe<Scalars['PhoneNumber']['output']>;
  /** Организационно-правовая форма организации */
  type?: Maybe<EEmployerType>;
  /** Код ОПФ */
  typeCode?: Maybe<Scalars['JobTypeCode']['output']>;
};

export type TNestedPeopleJobOrganizationObjectFilterType = {
  activity?: InputMaybe<TEOrganizationActivityFilter>;
  inn?: InputMaybe<TInnFilter>;
  name?: InputMaybe<TStringFilter>;
  ogrn?: InputMaybe<TOgrnFilter>;
  okved?: InputMaybe<TStringFilter>;
  phone?: InputMaybe<TPhoneNumberFilter>;
  type?: InputMaybe<TEEmployerTypeFilter>;
  typeCode?: InputMaybe<TJobTypeCodeFilter>;
};

export type TNestedPeopleLoanRestrictions = {
  __typename?: 'NestedPeopleLoanRestrictions';
  /** Дата последнего обновления информации об ограничениях */
  lastUpdate?: Maybe<Scalars['DateTimeISO']['output']>;
  /** Список ограничений */
  restrictions?: Maybe<Array<Maybe<TNestedPeopleLoanRestrictionsRestrictions>>>;
};


export type TNestedPeopleLoanRestrictionsRestrictionsArgs = {
  pagination?: InputMaybe<TPagination>;
};

export type TNestedPeopleLoanRestrictionsObjectFilterType = {
  lastUpdate?: InputMaybe<TDateTimeIsoFilter>;
  restrictions?: InputMaybe<TNestedPeopleLoanRestrictionsRestrictionsObjectFilterType>;
};

export type TNestedPeopleLoanRestrictionsRestrictions = {
  __typename?: 'NestedPeopleLoanRestrictionsRestrictions';
  /** Дата заявления */
  applicationDate?: Maybe<Scalars['DateTimeISO']['output']>;
  /** Дата начала действия */
  startDate?: Maybe<Scalars['DateTimeISO']['output']>;
  /** Тип ограничения */
  type?: Maybe<ELoanRestrictionsType>;
};

export type TNestedPeopleLoanRestrictionsRestrictionsObjectFilterType = {
  applicationDate?: InputMaybe<TDateTimeIsoFilter>;
  startDate?: InputMaybe<TDateTimeIsoFilter>;
  type?: InputMaybe<TELoanRestrictionsTypeFilter>;
};

export type TNestedPeopleMfo = {
  __typename?: 'NestedPeopleMfo';
  /** Сумма займа */
  amount?: Maybe<Scalars['String']['output']>;
  /** Идентификатор диалога в реакт анкете */
  conversationId?: Maybe<Scalars['String']['output']>;
  /** Срок займа */
  dateTo?: Maybe<Scalars['DateTimeISO']['output']>;
  /** Срок займа */
  period?: Maybe<Scalars['String']['output']>;
};

export type TNestedPeopleMfoObjectFilterType = {
  amount?: InputMaybe<TStringFilter>;
  conversationId?: InputMaybe<TStringFilter>;
  dateTo?: InputMaybe<TDateTimeIsoFilter>;
  period?: InputMaybe<TStringFilter>;
};

export type TNestedPeopleOsago = {
  __typename?: 'NestedPeopleOsago';
  /** КБМ */
  kbm?: Maybe<Scalars['String']['output']>;
  /** Дата сохранения предыдущих прав в процессе оформления ОСАГО */
  previousLicenceInputDate?: Maybe<Scalars['DateTimeISO']['output']>;
};

export type TNestedPeopleOsagoObjectFilterType = {
  kbm?: InputMaybe<TStringFilter>;
  previousLicenceInputDate?: InputMaybe<TDateTimeIsoFilter>;
};

export type TNestedPeoplePassport = {
  __typename?: 'NestedPeoplePassport';
  /** Дата регистрации */
  addressRegistrationDate?: Maybe<Scalars['DateTimeISO']['output']>;
  /** Дата выдачи паспорта РФ */
  issueDate?: Maybe<Scalars['DateTimeISO']['output']>;
  /** Орган, выдавший паспорт РФ */
  issuedBy?: Maybe<Scalars['String']['output']>;
  /** Код подразделения организации, выдавшей паспорт РФ */
  issuedByCode?: Maybe<Scalars['IssueId']['output']>;
  /** Серия и номер паспорта РФ */
  number?: Maybe<Scalars['SerialNumber']['output']>;
};

export type TNestedPeoplePhysiology = {
  __typename?: 'NestedPeoplePhysiology';
  /** Нижнее давление */
  arterialRangeDown?: Maybe<Scalars['Int']['output']>;
  /** Верхнее давление */
  arterialRangeUp?: Maybe<Scalars['Int']['output']>;
  /** Рост */
  height?: Maybe<Scalars['Float']['output']>;
  /** Вес */
  weight?: Maybe<Scalars['Float']['output']>;
};

export type TNestedPeoplePhysiologyObjectFilterType = {
  arterialRangeDown?: InputMaybe<TIntFilter>;
  arterialRangeUp?: InputMaybe<TIntFilter>;
  height?: InputMaybe<TFloatFilter>;
  weight?: InputMaybe<TFloatFilter>;
};

export type TNestedProfileAlfa = {
  __typename?: 'NestedProfileAlfa';
  /** Владелец профиля [Альфа] */
  owner?: Maybe<TPeople>;
};


export type TNestedProfileAlfaOwnerArgs = {
  filter?: InputMaybe<TPeopleFilter>;
};

export type TNestedProfileEsia = {
  __typename?: 'NestedProfileESIA';
  /** Владелец профиля (ЕСИА) */
  owner?: Maybe<TPeople>;
  /**
   * Транспортное средство (ESIA)
   * @deprecated Use 'profile.ESIA.owner.ownCars'
   */
  vehicle?: Maybe<Array<Maybe<TEsiaVehicle>>>;
};


export type TNestedProfileEsiaOwnerArgs = {
  filter?: InputMaybe<TPeopleFilter>;
};


export type TNestedProfileEsiaVehicleArgs = {
  filter?: InputMaybe<TEsiaVehicleFilter>;
  pagination?: InputMaybe<TPagination>;
};

export type TNestedProfileSber = {
  __typename?: 'NestedProfileSber';
  /**
   * Водительское удостоверение (Сбер)
   * @deprecated Use 'profile.Sber.owner.documents.driverLicense'
   */
  driverLicense?: Maybe<TDriverLicense>;
  /**
   * История водительских удостоверений (Сбер)
   * @deprecated Use 'profile.Sber.owner.documents.driverLicenseHistory'
   */
  driverLicenseHistory?: Maybe<Array<Maybe<TDriverLicense>>>;
  /**
   * Последний заграничный паспорт [Сбер]
   * @deprecated Use 'profile.Sber.owner.documents.FRGNPassport'
   */
  frgnPassport?: Maybe<TFrgnPassport>;
  /**
   * История заграничных паспортов [Сбер]
   * @deprecated Use 'profile.Sber.owner.documents.FRGNPassportHistory'
   */
  frgnPassportHistory?: Maybe<Array<Maybe<TFrgnPassport>>>;
  /** Владелец профиля (Сбер) */
  owner?: Maybe<TPeople>;
  /**
   * Паспорт гражданина РФ (Сбер)
   * @deprecated Use 'profile.Sber.owner.documents.passport'
   */
  passport?: Maybe<TPassport>;
  /** @deprecated Use 'profile.Sber.owner.documents.passportHistory' */
  passportHistory?: Maybe<Array<Maybe<TPassport>>>;
};


export type TNestedProfileSberDriverLicenseArgs = {
  filter?: InputMaybe<TDriverLicenseFilter>;
};


export type TNestedProfileSberDriverLicenseHistoryArgs = {
  filter?: InputMaybe<TDriverLicenseFilter>;
  pagination?: InputMaybe<TPagination>;
};


export type TNestedProfileSberFrgnPassportArgs = {
  filter?: InputMaybe<TFrgnPassportFilter>;
};


export type TNestedProfileSberFrgnPassportHistoryArgs = {
  filter?: InputMaybe<TFrgnPassportFilter>;
  pagination?: InputMaybe<TPagination>;
};


export type TNestedProfileSberOwnerArgs = {
  filter?: InputMaybe<TPeopleFilter>;
};


export type TNestedProfileSberPassportArgs = {
  filter?: InputMaybe<TPassportFilter>;
};


export type TNestedProfileSberPassportHistoryArgs = {
  filter?: InputMaybe<TPassportFilter>;
  pagination?: InputMaybe<TPagination>;
};

export type TNestedProfileTBank = {
  __typename?: 'NestedProfileTBank';
  /** Флаги профиля [ТБанк] */
  flags?: Maybe<TTBankFlags>;
  /**
   * Последний заграничный паспорт [ТБанк]
   * @deprecated Use 'profile.Tbank.owner.documents.FRGNPassport'
   */
  frgnPassport?: Maybe<TFrgnPassport>;
  /**
   * История заграничных паспортов [ТБанк]
   * @deprecated Use 'profile.TBank.owner.documents.FRGNPassportHistory'
   */
  frgnPassportHistory?: Maybe<Array<Maybe<TFrgnPassport>>>;
  /** Владелец профиля (ТБанк) */
  owner?: Maybe<TPeople>;
  /**
   * Паспорт гражданина РФ (ТБанк)
   * @deprecated Use 'profile.TBank.owner.documents.passport'
   */
  passport?: Maybe<TPassport>;
  /** @deprecated Use 'profile.TBank.owner.documents.passportHistory' */
  passportHistory?: Maybe<Array<Maybe<TPassport>>>;
};


export type TNestedProfileTBankFlagsArgs = {
  filter?: InputMaybe<TTBankFlagsFilter>;
};


export type TNestedProfileTBankFrgnPassportArgs = {
  filter?: InputMaybe<TFrgnPassportFilter>;
};


export type TNestedProfileTBankFrgnPassportHistoryArgs = {
  filter?: InputMaybe<TFrgnPassportFilter>;
  pagination?: InputMaybe<TPagination>;
};


export type TNestedProfileTBankOwnerArgs = {
  filter?: InputMaybe<TPeopleFilter>;
};


export type TNestedProfileTBankPassportArgs = {
  filter?: InputMaybe<TPassportFilter>;
};


export type TNestedProfileTBankPassportHistoryArgs = {
  filter?: InputMaybe<TPassportFilter>;
  pagination?: InputMaybe<TPagination>;
};

export type TNestedRealestateFileCarParkingSpaceRecords = {
  __typename?: 'NestedRealestateFileCarParkingSpaceRecords';
  /** Расположение в пределах объекта недвижимости */
  locationInBuild?: Maybe<Array<Maybe<TNestedRealestateFileCarParkingSpaceRecordsLocationInBuild>>>;
  /** Общие сведения (кадастровый номер машиноместа) */
  object?: Maybe<TNestedRealestateFileCarParkingSpaceRecordsObject>;
};


export type TNestedRealestateFileCarParkingSpaceRecordsLocationInBuildArgs = {
  pagination?: InputMaybe<TPagination>;
};

export type TNestedRealestateFileCarParkingSpaceRecordsLocationInBuild = {
  __typename?: 'NestedRealestateFileCarParkingSpaceRecordsLocationInBuild';
  /** Описание расположения */
  description?: Maybe<Scalars['String']['output']>;
  /** Номер этажа */
  floor?: Maybe<Scalars['Int']['output']>;
  /** Тип этажа */
  floorType?: Maybe<TNestedRealestateFileCarParkingSpaceRecordsLocationInBuildFloorType>;
  /** Номер на поэтажном плане */
  planNumber?: Maybe<Scalars['String']['output']>;
  /** Планы */
  plans?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};


export type TNestedRealestateFileCarParkingSpaceRecordsLocationInBuildPlansArgs = {
  pagination?: InputMaybe<TPagination>;
};

export type TNestedRealestateFileCarParkingSpaceRecordsLocationInBuildFloorType = {
  __typename?: 'NestedRealestateFileCarParkingSpaceRecordsLocationInBuildFloorType';
  /** код из справочника */
  code?: Maybe<Scalars['NumberString']['output']>;
  /** значение */
  value?: Maybe<Scalars['Int']['output']>;
};

export type TNestedRealestateFileCarParkingSpaceRecordsLocationInBuildFloorTypeObjectFilterType = {
  code?: InputMaybe<TNumberStringFilter>;
  value?: InputMaybe<TIntFilter>;
};

export type TNestedRealestateFileCarParkingSpaceRecordsLocationInBuildObjectFilterType = {
  description?: InputMaybe<TStringFilter>;
  floor?: InputMaybe<TIntFilter>;
  floorType?: InputMaybe<TNestedRealestateFileCarParkingSpaceRecordsLocationInBuildFloorTypeObjectFilterType>;
  planNumber?: InputMaybe<TStringFilter>;
  plans?: InputMaybe<TStringFilter>;
};

export type TNestedRealestateFileCarParkingSpaceRecordsObject = {
  __typename?: 'NestedRealestateFileCarParkingSpaceRecordsObject';
  /** Кадастровый номер */
  cadNumber?: Maybe<Scalars['String']['output']>;
  /** Номер кадастрового квартала */
  quarterCadNumber?: Maybe<Scalars['String']['output']>;
  /** Вид объекта недвижимости */
  type?: Maybe<TNestedRealestateFileCarParkingSpaceRecordsObjectType>;
};

export type TNestedRealestateFileCarParkingSpaceRecordsObjectFilterType = {
  locationInBuild?: InputMaybe<TNestedRealestateFileCarParkingSpaceRecordsLocationInBuildObjectFilterType>;
  object?: InputMaybe<TNestedRealestateFileCarParkingSpaceRecordsObjectObjectFilterType>;
};

export type TNestedRealestateFileCarParkingSpaceRecordsObjectObjectFilterType = {
  cadNumber?: InputMaybe<TStringFilter>;
  quarterCadNumber?: InputMaybe<TStringFilter>;
  type?: InputMaybe<TNestedRealestateFileCarParkingSpaceRecordsObjectTypeObjectFilterType>;
};

export type TNestedRealestateFileCarParkingSpaceRecordsObjectType = {
  __typename?: 'NestedRealestateFileCarParkingSpaceRecordsObjectType';
  /** код из справочника */
  code?: Maybe<Scalars['NumberString']['output']>;
  /** значение */
  value?: Maybe<Scalars['String']['output']>;
};

export type TNestedRealestateFileCarParkingSpaceRecordsObjectTypeObjectFilterType = {
  code?: InputMaybe<TNumberStringFilter>;
  value?: InputMaybe<TStringFilter>;
};

export type TNestedRealestateFileClaimRecords = {
  __typename?: 'NestedRealestateFileClaimRecords';
  markContent?: Maybe<Scalars['String']['output']>;
  /** Вид регистрационно-учетного действия */
  urdType?: Maybe<Scalars['String']['output']>;
};

export type TNestedRealestateFileClaimRecordsObjectFilterType = {
  markContent?: InputMaybe<TStringFilter>;
  urdType?: InputMaybe<TStringFilter>;
};

export type TNestedRealestateFileConstructionRecord = {
  __typename?: 'NestedRealestateFileConstructionRecord';
  /** Адрес (местоположение) */
  addressLocation?: Maybe<TNestedRealestateFileConstructionRecordAddressLocation>;
  /** Сведения об объектах (связь с кадастровыми номерами) */
  cadLinks?: Maybe<TNestedRealestateFileConstructionRecordCadLinks>;
  /** Описание местоположения контура сооружения */
  contours?: Maybe<TNestedRealestateFileConstructionRecordContours>;
  /** Кадастровая стоимость */
  cost?: Maybe<Scalars['Float']['output']>;
  /** Общие сведения об объекте недвижимости */
  object?: Maybe<TNestedRealestateFileConstructionRecordObject>;
  /** Сведения о частях сооружения */
  objectParts?: Maybe<Array<Maybe<TNestedRealestateFileConstructionRecordObjectParts>>>;
  /** Характеристики сооружения */
  params?: Maybe<TNestedRealestateFileConstructionRecordParams>;
  /** Даты государственной регистрации */
  recordInfo?: Maybe<TNestedRealestateFileConstructionRecordRecordInfo>;
  /** Особые отметки */
  specialNotes?: Maybe<Scalars['String']['output']>;
};


export type TNestedRealestateFileConstructionRecordObjectPartsArgs = {
  pagination?: InputMaybe<TPagination>;
};

export type TNestedRealestateFileConstructionRecordAddressLocation = {
  __typename?: 'NestedRealestateFileConstructionRecordAddressLocation';
  /** Адрес (местоположение) */
  address?: Maybe<TNestedRealestateFileConstructionRecordAddressLocationAddress>;
  /** Тип адреса */
  addressType?: Maybe<TNestedRealestateFileConstructionRecordAddressLocationAddressType>;
  /** Наименования субъектов Российской Федерации, муниципальных образований, населенных пунктов (при наличии) */
  location?: Maybe<TNestedRealestateFileConstructionRecordAddressLocationLocation>;
  /** Местоположение относительно ориентира */
  relPosition?: Maybe<TNestedRealestateFileConstructionRecordAddressLocationRelPosition>;
};

export type TNestedRealestateFileConstructionRecordAddressLocationAddress = {
  __typename?: 'NestedRealestateFileConstructionRecordAddressLocationAddress';
  /** Адрес (по справочнику ФИАС) */
  addressFias?: Maybe<TNestedRealestateFileConstructionRecordAddressLocationAddressAddressFias>;
  /** Неформализованное описание */
  note?: Maybe<Scalars['String']['output']>;
  /** Адрес в соответствии с ФИАС */
  readableAddress?: Maybe<Scalars['String']['output']>;
};

export type TNestedRealestateFileConstructionRecordAddressLocationAddressAddressFias = {
  __typename?: 'NestedRealestateFileConstructionRecordAddressLocationAddressAddressFias';
  /** Детализированный уровень */
  detailedLevel?: Maybe<TNestedRealestateFileConstructionRecordAddressLocationAddressAddressFiasDetailedLevel>;
  /** Уровень населенного пункта */
  levelSettlement?: Maybe<TNestedRealestateFileConstructionRecordAddressLocationAddressAddressFiasLevelSettlement>;
};

export type TNestedRealestateFileConstructionRecordAddressLocationAddressAddressFiasDetailedLevel = {
  __typename?: 'NestedRealestateFileConstructionRecordAddressLocationAddressAddressFiasDetailedLevel';
  /** Квартира */
  apartment?: Maybe<TNestedRealestateFileConstructionRecordAddressLocationAddressAddressFiasDetailedLevelApartment>;
  /** Дом */
  level1?: Maybe<TNestedRealestateFileConstructionRecordAddressLocationAddressAddressFiasDetailedLevelLevel1>;
  /** Корпус */
  level2?: Maybe<TNestedRealestateFileConstructionRecordAddressLocationAddressAddressFiasDetailedLevelLevel2>;
  /** Строение */
  level3?: Maybe<TNestedRealestateFileConstructionRecordAddressLocationAddressAddressFiasDetailedLevelLevel3>;
  /** Иное описание местоположения */
  other?: Maybe<Scalars['String']['output']>;
  /** Улица */
  street?: Maybe<TNestedRealestateFileConstructionRecordAddressLocationAddressAddressFiasDetailedLevelStreet>;
};

export type TNestedRealestateFileConstructionRecordAddressLocationAddressAddressFiasDetailedLevelApartment = {
  __typename?: 'NestedRealestateFileConstructionRecordAddressLocationAddressAddressFiasDetailedLevelApartment';
  name?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

export type TNestedRealestateFileConstructionRecordAddressLocationAddressAddressFiasDetailedLevelApartmentObjectFilterType = {
  name?: InputMaybe<TStringFilter>;
  type?: InputMaybe<TStringFilter>;
};

export type TNestedRealestateFileConstructionRecordAddressLocationAddressAddressFiasDetailedLevelLevel1 = {
  __typename?: 'NestedRealestateFileConstructionRecordAddressLocationAddressAddressFiasDetailedLevelLevel1';
  name?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

export type TNestedRealestateFileConstructionRecordAddressLocationAddressAddressFiasDetailedLevelLevel1ObjectFilterType = {
  name?: InputMaybe<TStringFilter>;
  type?: InputMaybe<TStringFilter>;
};

export type TNestedRealestateFileConstructionRecordAddressLocationAddressAddressFiasDetailedLevelLevel2 = {
  __typename?: 'NestedRealestateFileConstructionRecordAddressLocationAddressAddressFiasDetailedLevelLevel2';
  name?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

export type TNestedRealestateFileConstructionRecordAddressLocationAddressAddressFiasDetailedLevelLevel2ObjectFilterType = {
  name?: InputMaybe<TStringFilter>;
  type?: InputMaybe<TStringFilter>;
};

export type TNestedRealestateFileConstructionRecordAddressLocationAddressAddressFiasDetailedLevelLevel3 = {
  __typename?: 'NestedRealestateFileConstructionRecordAddressLocationAddressAddressFiasDetailedLevelLevel3';
  name?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

export type TNestedRealestateFileConstructionRecordAddressLocationAddressAddressFiasDetailedLevelLevel3ObjectFilterType = {
  name?: InputMaybe<TStringFilter>;
  type?: InputMaybe<TStringFilter>;
};

export type TNestedRealestateFileConstructionRecordAddressLocationAddressAddressFiasDetailedLevelObjectFilterType = {
  apartment?: InputMaybe<TNestedRealestateFileConstructionRecordAddressLocationAddressAddressFiasDetailedLevelApartmentObjectFilterType>;
  level1?: InputMaybe<TNestedRealestateFileConstructionRecordAddressLocationAddressAddressFiasDetailedLevelLevel1ObjectFilterType>;
  level2?: InputMaybe<TNestedRealestateFileConstructionRecordAddressLocationAddressAddressFiasDetailedLevelLevel2ObjectFilterType>;
  level3?: InputMaybe<TNestedRealestateFileConstructionRecordAddressLocationAddressAddressFiasDetailedLevelLevel3ObjectFilterType>;
  other?: InputMaybe<TStringFilter>;
  street?: InputMaybe<TNestedRealestateFileConstructionRecordAddressLocationAddressAddressFiasDetailedLevelStreetObjectFilterType>;
};

export type TNestedRealestateFileConstructionRecordAddressLocationAddressAddressFiasDetailedLevelStreet = {
  __typename?: 'NestedRealestateFileConstructionRecordAddressLocationAddressAddressFiasDetailedLevelStreet';
  /** Наименование */
  name?: Maybe<Scalars['String']['output']>;
  /** Тип */
  type?: Maybe<Scalars['String']['output']>;
};

export type TNestedRealestateFileConstructionRecordAddressLocationAddressAddressFiasDetailedLevelStreetObjectFilterType = {
  name?: InputMaybe<TStringFilter>;
  type?: InputMaybe<TStringFilter>;
};

export type TNestedRealestateFileConstructionRecordAddressLocationAddressAddressFiasLevelSettlement = {
  __typename?: 'NestedRealestateFileConstructionRecordAddressLocationAddressAddressFiasLevelSettlement';
  /** Муниципальное образование */
  city?: Maybe<TNestedRealestateFileConstructionRecordAddressLocationAddressAddressFiasLevelSettlementCity>;
  /** Район */
  district?: Maybe<TNestedRealestateFileConstructionRecordAddressLocationAddressAddressFiasLevelSettlementDistrict>;
  fias?: Maybe<Scalars['String']['output']>;
  kladr?: Maybe<Scalars['String']['output']>;
  /** Населенный пункт */
  locality?: Maybe<TNestedRealestateFileConstructionRecordAddressLocationAddressAddressFiasLevelSettlementLocality>;
  okato?: Maybe<Scalars['String']['output']>;
  oktmo?: Maybe<Scalars['String']['output']>;
  /** Почтовый индекс */
  postalCode?: Maybe<Scalars['PostalCode']['output']>;
  /** Код региона */
  region?: Maybe<TNestedRealestateFileConstructionRecordAddressLocationAddressAddressFiasLevelSettlementRegion>;
  /** Сельсовет */
  sovietVillage?: Maybe<TNestedRealestateFileConstructionRecordAddressLocationAddressAddressFiasLevelSettlementSovietVillage>;
  /** Городской район */
  urbanDistrict?: Maybe<TNestedRealestateFileConstructionRecordAddressLocationAddressAddressFiasLevelSettlementUrbanDistrict>;
};

export type TNestedRealestateFileConstructionRecordAddressLocationAddressAddressFiasLevelSettlementCity = {
  __typename?: 'NestedRealestateFileConstructionRecordAddressLocationAddressAddressFiasLevelSettlementCity';
  /** Наименование */
  name?: Maybe<Scalars['String']['output']>;
  /** Тип */
  type?: Maybe<Scalars['String']['output']>;
};

export type TNestedRealestateFileConstructionRecordAddressLocationAddressAddressFiasLevelSettlementCityObjectFilterType = {
  name?: InputMaybe<TStringFilter>;
  type?: InputMaybe<TStringFilter>;
};

export type TNestedRealestateFileConstructionRecordAddressLocationAddressAddressFiasLevelSettlementDistrict = {
  __typename?: 'NestedRealestateFileConstructionRecordAddressLocationAddressAddressFiasLevelSettlementDistrict';
  /** Наименование */
  name?: Maybe<Scalars['String']['output']>;
  /** Тип */
  type?: Maybe<Scalars['String']['output']>;
};

export type TNestedRealestateFileConstructionRecordAddressLocationAddressAddressFiasLevelSettlementDistrictObjectFilterType = {
  name?: InputMaybe<TStringFilter>;
  type?: InputMaybe<TStringFilter>;
};

export type TNestedRealestateFileConstructionRecordAddressLocationAddressAddressFiasLevelSettlementLocality = {
  __typename?: 'NestedRealestateFileConstructionRecordAddressLocationAddressAddressFiasLevelSettlementLocality';
  /** Наименование */
  name?: Maybe<Scalars['String']['output']>;
  /** Тип */
  type?: Maybe<Scalars['String']['output']>;
};

export type TNestedRealestateFileConstructionRecordAddressLocationAddressAddressFiasLevelSettlementLocalityObjectFilterType = {
  name?: InputMaybe<TStringFilter>;
  type?: InputMaybe<TStringFilter>;
};

export type TNestedRealestateFileConstructionRecordAddressLocationAddressAddressFiasLevelSettlementObjectFilterType = {
  city?: InputMaybe<TNestedRealestateFileConstructionRecordAddressLocationAddressAddressFiasLevelSettlementCityObjectFilterType>;
  district?: InputMaybe<TNestedRealestateFileConstructionRecordAddressLocationAddressAddressFiasLevelSettlementDistrictObjectFilterType>;
  fias?: InputMaybe<TStringFilter>;
  kladr?: InputMaybe<TStringFilter>;
  locality?: InputMaybe<TNestedRealestateFileConstructionRecordAddressLocationAddressAddressFiasLevelSettlementLocalityObjectFilterType>;
  okato?: InputMaybe<TStringFilter>;
  oktmo?: InputMaybe<TStringFilter>;
  postalCode?: InputMaybe<TPostalCodeFilter>;
  region?: InputMaybe<TNestedRealestateFileConstructionRecordAddressLocationAddressAddressFiasLevelSettlementRegionObjectFilterType>;
  sovietVillage?: InputMaybe<TNestedRealestateFileConstructionRecordAddressLocationAddressAddressFiasLevelSettlementSovietVillageObjectFilterType>;
  urbanDistrict?: InputMaybe<TNestedRealestateFileConstructionRecordAddressLocationAddressAddressFiasLevelSettlementUrbanDistrictObjectFilterType>;
};

export type TNestedRealestateFileConstructionRecordAddressLocationAddressAddressFiasLevelSettlementRegion = {
  __typename?: 'NestedRealestateFileConstructionRecordAddressLocationAddressAddressFiasLevelSettlementRegion';
  /** код из справочника */
  code?: Maybe<Scalars['NumberString']['output']>;
  /** значение */
  value?: Maybe<Scalars['String']['output']>;
};

export type TNestedRealestateFileConstructionRecordAddressLocationAddressAddressFiasLevelSettlementRegionObjectFilterType = {
  code?: InputMaybe<TNumberStringFilter>;
  value?: InputMaybe<TStringFilter>;
};

export type TNestedRealestateFileConstructionRecordAddressLocationAddressAddressFiasLevelSettlementSovietVillage = {
  __typename?: 'NestedRealestateFileConstructionRecordAddressLocationAddressAddressFiasLevelSettlementSovietVillage';
  /** Наименование */
  name?: Maybe<Scalars['String']['output']>;
  /** Тип */
  type?: Maybe<Scalars['String']['output']>;
};

export type TNestedRealestateFileConstructionRecordAddressLocationAddressAddressFiasLevelSettlementSovietVillageObjectFilterType = {
  name?: InputMaybe<TStringFilter>;
  type?: InputMaybe<TStringFilter>;
};

export type TNestedRealestateFileConstructionRecordAddressLocationAddressAddressFiasLevelSettlementUrbanDistrict = {
  __typename?: 'NestedRealestateFileConstructionRecordAddressLocationAddressAddressFiasLevelSettlementUrbanDistrict';
  /** Наименование */
  name?: Maybe<Scalars['String']['output']>;
  /** Тип */
  type?: Maybe<Scalars['String']['output']>;
};

export type TNestedRealestateFileConstructionRecordAddressLocationAddressAddressFiasLevelSettlementUrbanDistrictObjectFilterType = {
  name?: InputMaybe<TStringFilter>;
  type?: InputMaybe<TStringFilter>;
};

export type TNestedRealestateFileConstructionRecordAddressLocationAddressAddressFiasObjectFilterType = {
  detailedLevel?: InputMaybe<TNestedRealestateFileConstructionRecordAddressLocationAddressAddressFiasDetailedLevelObjectFilterType>;
  levelSettlement?: InputMaybe<TNestedRealestateFileConstructionRecordAddressLocationAddressAddressFiasLevelSettlementObjectFilterType>;
};

export type TNestedRealestateFileConstructionRecordAddressLocationAddressObjectFilterType = {
  addressFias?: InputMaybe<TNestedRealestateFileConstructionRecordAddressLocationAddressAddressFiasObjectFilterType>;
  note?: InputMaybe<TStringFilter>;
  readableAddress?: InputMaybe<TStringFilter>;
};

export type TNestedRealestateFileConstructionRecordAddressLocationAddressType = {
  __typename?: 'NestedRealestateFileConstructionRecordAddressLocationAddressType';
  /** код из справочника */
  code?: Maybe<Scalars['NumberString']['output']>;
  /** значение */
  value?: Maybe<Scalars['String']['output']>;
};

export type TNestedRealestateFileConstructionRecordAddressLocationAddressTypeObjectFilterType = {
  code?: InputMaybe<TNumberStringFilter>;
  value?: InputMaybe<TStringFilter>;
};

export type TNestedRealestateFileConstructionRecordAddressLocationLocation = {
  __typename?: 'NestedRealestateFileConstructionRecordAddressLocationLocation';
  /** Муниципальное образование */
  city?: Maybe<TNestedRealestateFileConstructionRecordAddressLocationLocationCity>;
  /** Район */
  district?: Maybe<TNestedRealestateFileConstructionRecordAddressLocationLocationDistrict>;
  fias?: Maybe<Scalars['String']['output']>;
  kladr?: Maybe<Scalars['String']['output']>;
  /** Населенный пункт */
  locality?: Maybe<TNestedRealestateFileConstructionRecordAddressLocationLocationLocality>;
  okato?: Maybe<Scalars['String']['output']>;
  oktmo?: Maybe<Scalars['String']['output']>;
  /** Почтовый индекс */
  postalCode?: Maybe<Scalars['PostalCode']['output']>;
  /** Код региона */
  region?: Maybe<TNestedRealestateFileConstructionRecordAddressLocationLocationRegion>;
  /** Сельсовет */
  sovietVillage?: Maybe<TNestedRealestateFileConstructionRecordAddressLocationLocationSovietVillage>;
  /** Городской район */
  urbanDistrict?: Maybe<TNestedRealestateFileConstructionRecordAddressLocationLocationUrbanDistrict>;
};

export type TNestedRealestateFileConstructionRecordAddressLocationLocationCity = {
  __typename?: 'NestedRealestateFileConstructionRecordAddressLocationLocationCity';
  /** Наименование */
  name?: Maybe<Scalars['String']['output']>;
  /** Тип */
  type?: Maybe<Scalars['String']['output']>;
};

export type TNestedRealestateFileConstructionRecordAddressLocationLocationCityObjectFilterType = {
  name?: InputMaybe<TStringFilter>;
  type?: InputMaybe<TStringFilter>;
};

export type TNestedRealestateFileConstructionRecordAddressLocationLocationDistrict = {
  __typename?: 'NestedRealestateFileConstructionRecordAddressLocationLocationDistrict';
  /** Наименование */
  name?: Maybe<Scalars['String']['output']>;
  /** Тип */
  type?: Maybe<Scalars['String']['output']>;
};

export type TNestedRealestateFileConstructionRecordAddressLocationLocationDistrictObjectFilterType = {
  name?: InputMaybe<TStringFilter>;
  type?: InputMaybe<TStringFilter>;
};

export type TNestedRealestateFileConstructionRecordAddressLocationLocationLocality = {
  __typename?: 'NestedRealestateFileConstructionRecordAddressLocationLocationLocality';
  /** Наименование */
  name?: Maybe<Scalars['String']['output']>;
  /** Тип */
  type?: Maybe<Scalars['String']['output']>;
};

export type TNestedRealestateFileConstructionRecordAddressLocationLocationLocalityObjectFilterType = {
  name?: InputMaybe<TStringFilter>;
  type?: InputMaybe<TStringFilter>;
};

export type TNestedRealestateFileConstructionRecordAddressLocationLocationObjectFilterType = {
  city?: InputMaybe<TNestedRealestateFileConstructionRecordAddressLocationLocationCityObjectFilterType>;
  district?: InputMaybe<TNestedRealestateFileConstructionRecordAddressLocationLocationDistrictObjectFilterType>;
  fias?: InputMaybe<TStringFilter>;
  kladr?: InputMaybe<TStringFilter>;
  locality?: InputMaybe<TNestedRealestateFileConstructionRecordAddressLocationLocationLocalityObjectFilterType>;
  okato?: InputMaybe<TStringFilter>;
  oktmo?: InputMaybe<TStringFilter>;
  postalCode?: InputMaybe<TPostalCodeFilter>;
  region?: InputMaybe<TNestedRealestateFileConstructionRecordAddressLocationLocationRegionObjectFilterType>;
  sovietVillage?: InputMaybe<TNestedRealestateFileConstructionRecordAddressLocationLocationSovietVillageObjectFilterType>;
  urbanDistrict?: InputMaybe<TNestedRealestateFileConstructionRecordAddressLocationLocationUrbanDistrictObjectFilterType>;
};

export type TNestedRealestateFileConstructionRecordAddressLocationLocationRegion = {
  __typename?: 'NestedRealestateFileConstructionRecordAddressLocationLocationRegion';
  /** код из справочника */
  code?: Maybe<Scalars['NumberString']['output']>;
  /** значение */
  value?: Maybe<Scalars['String']['output']>;
};

export type TNestedRealestateFileConstructionRecordAddressLocationLocationRegionObjectFilterType = {
  code?: InputMaybe<TNumberStringFilter>;
  value?: InputMaybe<TStringFilter>;
};

export type TNestedRealestateFileConstructionRecordAddressLocationLocationSovietVillage = {
  __typename?: 'NestedRealestateFileConstructionRecordAddressLocationLocationSovietVillage';
  /** Наименование */
  name?: Maybe<Scalars['String']['output']>;
  /** Тип */
  type?: Maybe<Scalars['String']['output']>;
};

export type TNestedRealestateFileConstructionRecordAddressLocationLocationSovietVillageObjectFilterType = {
  name?: InputMaybe<TStringFilter>;
  type?: InputMaybe<TStringFilter>;
};

export type TNestedRealestateFileConstructionRecordAddressLocationLocationUrbanDistrict = {
  __typename?: 'NestedRealestateFileConstructionRecordAddressLocationLocationUrbanDistrict';
  /** Наименование */
  name?: Maybe<Scalars['String']['output']>;
  /** Тип */
  type?: Maybe<Scalars['String']['output']>;
};

export type TNestedRealestateFileConstructionRecordAddressLocationLocationUrbanDistrictObjectFilterType = {
  name?: InputMaybe<TStringFilter>;
  type?: InputMaybe<TStringFilter>;
};

export type TNestedRealestateFileConstructionRecordAddressLocationObjectFilterType = {
  address?: InputMaybe<TNestedRealestateFileConstructionRecordAddressLocationAddressObjectFilterType>;
  addressType?: InputMaybe<TNestedRealestateFileConstructionRecordAddressLocationAddressTypeObjectFilterType>;
  location?: InputMaybe<TNestedRealestateFileConstructionRecordAddressLocationLocationObjectFilterType>;
  relPosition?: InputMaybe<TNestedRealestateFileConstructionRecordAddressLocationRelPositionObjectFilterType>;
};

export type TNestedRealestateFileConstructionRecordAddressLocationRelPosition = {
  __typename?: 'NestedRealestateFileConstructionRecordAddressLocationRelPosition';
  /** Ориентир расположен в границах участка */
  inBoundariesMark?: Maybe<Scalars['Boolean']['output']>;
  /** Расположение относительно ориентира */
  locationDescription?: Maybe<Scalars['String']['output']>;
  /** Наименование ориентира */
  refPointName?: Maybe<Scalars['String']['output']>;
};

export type TNestedRealestateFileConstructionRecordAddressLocationRelPositionObjectFilterType = {
  inBoundariesMark?: InputMaybe<TBooleanFilter>;
  locationDescription?: InputMaybe<TStringFilter>;
  refPointName?: InputMaybe<TStringFilter>;
};

export type TNestedRealestateFileConstructionRecordCadLinks = {
  __typename?: 'NestedRealestateFileConstructionRecordCadLinks';
  /** Кадастровые номера земельных участков, из которых образован данный земельный участок */
  ascendantCadNumbers?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Кадастровые номера машиномест, расположенных в объекте недвижимости */
  carParkingSpaceCadNumbers?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Единое землепользование */
  commonLand?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Кадастровые номера земельных участков, образованных из данного земельного участка */
  descendantCadNumbers?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Кадастровый номер предприятия как имущественного комплекса, в состав которого входит земельный участок */
  facilityCadNumber?: Maybe<Scalars['String']['output']>;
  /** Кадастровые номера объектов недвижимости, входящих в состав единого недвижимого комплекса */
  includedCadNumbers?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Кадастровые номера расположенных в пределах земельного участка объектов недвижимости */
  includedObjects?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Кадастровые номера иных объектов недвижимости (земельных участков), в пределах которых расположен объект недвижимости */
  landCadNumbers?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Ранее присвоенные номера */
  oldNumbers?: Maybe<Array<Maybe<TNestedRealestateFileConstructionRecordCadLinksOldNumbers>>>;
  parentCadNumber?: Maybe<Scalars['String']['output']>;
  /** Кадастровые номера помещений, расположенных в объекте недвижимости */
  roomCadNumbers?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};


export type TNestedRealestateFileConstructionRecordCadLinksAscendantCadNumbersArgs = {
  pagination?: InputMaybe<TPagination>;
};


export type TNestedRealestateFileConstructionRecordCadLinksCarParkingSpaceCadNumbersArgs = {
  pagination?: InputMaybe<TPagination>;
};


export type TNestedRealestateFileConstructionRecordCadLinksCommonLandArgs = {
  pagination?: InputMaybe<TPagination>;
};


export type TNestedRealestateFileConstructionRecordCadLinksDescendantCadNumbersArgs = {
  pagination?: InputMaybe<TPagination>;
};


export type TNestedRealestateFileConstructionRecordCadLinksIncludedCadNumbersArgs = {
  pagination?: InputMaybe<TPagination>;
};


export type TNestedRealestateFileConstructionRecordCadLinksIncludedObjectsArgs = {
  pagination?: InputMaybe<TPagination>;
};


export type TNestedRealestateFileConstructionRecordCadLinksLandCadNumbersArgs = {
  pagination?: InputMaybe<TPagination>;
};


export type TNestedRealestateFileConstructionRecordCadLinksOldNumbersArgs = {
  pagination?: InputMaybe<TPagination>;
};


export type TNestedRealestateFileConstructionRecordCadLinksRoomCadNumbersArgs = {
  pagination?: InputMaybe<TPagination>;
};

export type TNestedRealestateFileConstructionRecordCadLinksObjectFilterType = {
  ascendantCadNumbers?: InputMaybe<TStringFilter>;
  carParkingSpaceCadNumbers?: InputMaybe<TStringFilter>;
  commonLand?: InputMaybe<TStringFilter>;
  descendantCadNumbers?: InputMaybe<TStringFilter>;
  facilityCadNumber?: InputMaybe<TStringFilter>;
  includedCadNumbers?: InputMaybe<TStringFilter>;
  includedObjects?: InputMaybe<TStringFilter>;
  landCadNumbers?: InputMaybe<TStringFilter>;
  oldNumbers?: InputMaybe<TNestedRealestateFileConstructionRecordCadLinksOldNumbersObjectFilterType>;
  parentCadNumber?: InputMaybe<TStringFilter>;
  roomCadNumbers?: InputMaybe<TStringFilter>;
};

export type TNestedRealestateFileConstructionRecordCadLinksOldNumbers = {
  __typename?: 'NestedRealestateFileConstructionRecordCadLinksOldNumbers';
  /** Организация, присвоившая номер */
  assigner?: Maybe<Scalars['String']['output']>;
  /** Дата присвоения */
  assignmentDate?: Maybe<Scalars['String']['output']>;
  /** Номер */
  number?: Maybe<Scalars['String']['output']>;
  /** Вид номера */
  numberType?: Maybe<TNestedRealestateFileConstructionRecordCadLinksOldNumbersNumberType>;
};

export type TNestedRealestateFileConstructionRecordCadLinksOldNumbersNumberType = {
  __typename?: 'NestedRealestateFileConstructionRecordCadLinksOldNumbersNumberType';
  /** код из справочника */
  code?: Maybe<Scalars['NumberString']['output']>;
  /** значение */
  value?: Maybe<Scalars['String']['output']>;
};

export type TNestedRealestateFileConstructionRecordCadLinksOldNumbersNumberTypeObjectFilterType = {
  code?: InputMaybe<TNumberStringFilter>;
  value?: InputMaybe<TStringFilter>;
};

export type TNestedRealestateFileConstructionRecordCadLinksOldNumbersObjectFilterType = {
  assigner?: InputMaybe<TStringFilter>;
  assignmentDate?: InputMaybe<TStringFilter>;
  number?: InputMaybe<TStringFilter>;
  numberType?: InputMaybe<TNestedRealestateFileConstructionRecordCadLinksOldNumbersNumberTypeObjectFilterType>;
};

export type TNestedRealestateFileConstructionRecordContours = {
  __typename?: 'NestedRealestateFileConstructionRecordContours';
  contour?: Maybe<Array<Maybe<TNestedRealestateFileConstructionRecordContoursContour>>>;
};


export type TNestedRealestateFileConstructionRecordContoursContourArgs = {
  pagination?: InputMaybe<TPagination>;
};

export type TNestedRealestateFileConstructionRecordContoursContour = {
  __typename?: 'NestedRealestateFileConstructionRecordContoursContour';
  /** Описание элементов контура (характерных точек контура) */
  entitySpatial?: Maybe<TNestedRealestateFileConstructionRecordContoursContourEntitySpatial>;
  /** Номер контура */
  numberPp?: Maybe<Scalars['Int']['output']>;
};

export type TNestedRealestateFileConstructionRecordContoursContourEntitySpatial = {
  __typename?: 'NestedRealestateFileConstructionRecordContoursContourEntitySpatial';
  /** Система координат */
  skId?: Maybe<Scalars['String']['output']>;
  /** Элементы контура */
  spatialsElements?: Maybe<Array<Maybe<TNestedRealestateFileConstructionRecordContoursContourEntitySpatialSpatialsElements>>>;
};


export type TNestedRealestateFileConstructionRecordContoursContourEntitySpatialSpatialsElementsArgs = {
  pagination?: InputMaybe<TPagination>;
};

export type TNestedRealestateFileConstructionRecordContoursContourEntitySpatialObjectFilterType = {
  skId?: InputMaybe<TStringFilter>;
  spatialsElements?: InputMaybe<TNestedRealestateFileConstructionRecordContoursContourEntitySpatialSpatialsElementsObjectFilterType>;
};

export type TNestedRealestateFileConstructionRecordContoursContourEntitySpatialSpatialsElements = {
  __typename?: 'NestedRealestateFileConstructionRecordContoursContourEntitySpatialSpatialsElements';
  /** Тип контура */
  levelContour?: Maybe<TNestedRealestateFileConstructionRecordContoursContourEntitySpatialSpatialsElementsLevelContour>;
  /** Список координат */
  ordinates?: Maybe<Array<Maybe<TNestedRealestateFileConstructionRecordContoursContourEntitySpatialSpatialsElementsOrdinates>>>;
};


export type TNestedRealestateFileConstructionRecordContoursContourEntitySpatialSpatialsElementsOrdinatesArgs = {
  pagination?: InputMaybe<TPagination>;
};

export type TNestedRealestateFileConstructionRecordContoursContourEntitySpatialSpatialsElementsLevelContour = {
  __typename?: 'NestedRealestateFileConstructionRecordContoursContourEntitySpatialSpatialsElementsLevelContour';
  /** код из справочника */
  code?: Maybe<Scalars['NumberString']['output']>;
  /** значение */
  value?: Maybe<Scalars['String']['output']>;
};

export type TNestedRealestateFileConstructionRecordContoursContourEntitySpatialSpatialsElementsLevelContourObjectFilterType = {
  code?: InputMaybe<TNumberStringFilter>;
  value?: InputMaybe<TStringFilter>;
};

export type TNestedRealestateFileConstructionRecordContoursContourEntitySpatialSpatialsElementsObjectFilterType = {
  levelContour?: InputMaybe<TNestedRealestateFileConstructionRecordContoursContourEntitySpatialSpatialsElementsLevelContourObjectFilterType>;
  ordinates?: InputMaybe<TNestedRealestateFileConstructionRecordContoursContourEntitySpatialSpatialsElementsOrdinatesObjectFilterType>;
};

export type TNestedRealestateFileConstructionRecordContoursContourEntitySpatialSpatialsElementsOrdinates = {
  __typename?: 'NestedRealestateFileConstructionRecordContoursContourEntitySpatialSpatialsElementsOrdinates';
  /** Погрешность */
  deltaGeopoint?: Maybe<Scalars['Int']['output']>;
  /** Номер точки */
  numGeopoint?: Maybe<Scalars['String']['output']>;
  /** Номер точки (порядок обхода) */
  ordNmb?: Maybe<Scalars['Int']['output']>;
  /** Радиус */
  r?: Maybe<Scalars['Int']['output']>;
  /** Координата X */
  x?: Maybe<Scalars['Int']['output']>;
  /** Координата Y */
  y?: Maybe<Scalars['Int']['output']>;
  /** Координата Z */
  z?: Maybe<Scalars['Int']['output']>;
};

export type TNestedRealestateFileConstructionRecordContoursContourEntitySpatialSpatialsElementsOrdinatesObjectFilterType = {
  deltaGeopoint?: InputMaybe<TIntFilter>;
  numGeopoint?: InputMaybe<TStringFilter>;
  ordNmb?: InputMaybe<TIntFilter>;
  r?: InputMaybe<TIntFilter>;
  x?: InputMaybe<TIntFilter>;
  y?: InputMaybe<TIntFilter>;
  z?: InputMaybe<TIntFilter>;
};

export type TNestedRealestateFileConstructionRecordContoursContourObjectFilterType = {
  entitySpatial?: InputMaybe<TNestedRealestateFileConstructionRecordContoursContourEntitySpatialObjectFilterType>;
  numberPp?: InputMaybe<TIntFilter>;
};

export type TNestedRealestateFileConstructionRecordContoursObjectFilterType = {
  contour?: InputMaybe<TNestedRealestateFileConstructionRecordContoursContourObjectFilterType>;
};

export type TNestedRealestateFileConstructionRecordObject = {
  __typename?: 'NestedRealestateFileConstructionRecordObject';
  /** Кадастровый номер */
  cadNumber?: Maybe<Scalars['String']['output']>;
  /** Номер кадастрового квартала */
  quarterCadNumber?: Maybe<Scalars['String']['output']>;
  /** Вид объекта недвижимости */
  type?: Maybe<TNestedRealestateFileConstructionRecordObjectType>;
};

export type TNestedRealestateFileConstructionRecordObjectFilterType = {
  addressLocation?: InputMaybe<TNestedRealestateFileConstructionRecordAddressLocationObjectFilterType>;
  cadLinks?: InputMaybe<TNestedRealestateFileConstructionRecordCadLinksObjectFilterType>;
  contours?: InputMaybe<TNestedRealestateFileConstructionRecordContoursObjectFilterType>;
  cost?: InputMaybe<TFloatFilter>;
  object?: InputMaybe<TNestedRealestateFileConstructionRecordObjectObjectFilterType>;
  objectParts?: InputMaybe<TNestedRealestateFileConstructionRecordObjectPartsObjectFilterType>;
  params?: InputMaybe<TNestedRealestateFileConstructionRecordParamsObjectFilterType>;
  recordInfo?: InputMaybe<TNestedRealestateFileConstructionRecordRecordInfoObjectFilterType>;
  specialNotes?: InputMaybe<TStringFilter>;
};

export type TNestedRealestateFileConstructionRecordObjectObjectFilterType = {
  cadNumber?: InputMaybe<TStringFilter>;
  quarterCadNumber?: InputMaybe<TStringFilter>;
  type?: InputMaybe<TNestedRealestateFileConstructionRecordObjectTypeObjectFilterType>;
};

export type TNestedRealestateFileConstructionRecordObjectParts = {
  __typename?: 'NestedRealestateFileConstructionRecordObjectParts';
  /** Площадь || Площадь, в кв. метрах */
  area?: Maybe<TNestedRealestateFileConstructionRecordObjectPartsArea>;
  /** Содержание ограничений */
  contentRestrictions?: Maybe<TNestedRealestateFileConstructionRecordObjectPartsContentRestrictions>;
  /** Описание местоположения границ */
  contours?: Maybe<Array<Maybe<TNestedRealestateFileConstructionRecordObjectPartsContours>>>;
  /** Примечание */
  footnote?: Maybe<Scalars['String']['output']>;
  /** Местоположение части здания */
  locationBuilding?: Maybe<TNestedRealestateFileConstructionRecordObjectPartsLocationBuilding>;
  /** Порядковый номер части */
  partNumber?: Maybe<Scalars['Int']['output']>;
};


export type TNestedRealestateFileConstructionRecordObjectPartsContoursArgs = {
  pagination?: InputMaybe<TPagination>;
};

export type TNestedRealestateFileConstructionRecordObjectPartsArea = {
  __typename?: 'NestedRealestateFileConstructionRecordObjectPartsArea';
  /** код из справочника */
  code?: Maybe<Scalars['NumberString']['output']>;
  /** значение */
  value?: Maybe<Scalars['Float']['output']>;
};

export type TNestedRealestateFileConstructionRecordObjectPartsAreaObjectFilterType = {
  code?: InputMaybe<TNumberStringFilter>;
  value?: InputMaybe<TFloatFilter>;
};

export type TNestedRealestateFileConstructionRecordObjectPartsContentRestrictions = {
  __typename?: 'NestedRealestateFileConstructionRecordObjectPartsContentRestrictions';
  /** Сведения о регистрации */
  dataRegistration?: Maybe<TNestedRealestateFileConstructionRecordObjectPartsContentRestrictionsDataRegistration>;
  /** Реестровый номер границы */
  regNumbBorder?: Maybe<TNestedRealestateFileConstructionRecordObjectPartsContentRestrictionsRegNumbBorder>;
};

export type TNestedRealestateFileConstructionRecordObjectPartsContentRestrictionsDataRegistration = {
  __typename?: 'NestedRealestateFileConstructionRecordObjectPartsContentRestrictionsDataRegistration';
  /** Дата регистрации */
  registrationDate?: Maybe<Scalars['String']['output']>;
  /** Номер регистрации/реестровой записи */
  restrictionEncumbranceNumber?: Maybe<TNestedRealestateFileConstructionRecordObjectPartsContentRestrictionsDataRegistrationRestrictionEncumbranceNumber>;
};

export type TNestedRealestateFileConstructionRecordObjectPartsContentRestrictionsDataRegistrationObjectFilterType = {
  registrationDate?: InputMaybe<TStringFilter>;
  restrictionEncumbranceNumber?: InputMaybe<TNestedRealestateFileConstructionRecordObjectPartsContentRestrictionsDataRegistrationRestrictionEncumbranceNumberObjectFilterType>;
};

export type TNestedRealestateFileConstructionRecordObjectPartsContentRestrictionsDataRegistrationRestrictionEncumbranceNumber = {
  __typename?: 'NestedRealestateFileConstructionRecordObjectPartsContentRestrictionsDataRegistrationRestrictionEncumbranceNumber';
  /** Номер реестровой записи */
  number?: Maybe<Scalars['String']['output']>;
  /** Номер регистрации ограничения права или обременения ОН */
  rightNumber?: Maybe<Scalars['String']['output']>;
};

export type TNestedRealestateFileConstructionRecordObjectPartsContentRestrictionsDataRegistrationRestrictionEncumbranceNumberObjectFilterType = {
  number?: InputMaybe<TStringFilter>;
  rightNumber?: InputMaybe<TStringFilter>;
};

export type TNestedRealestateFileConstructionRecordObjectPartsContentRestrictionsObjectFilterType = {
  dataRegistration?: InputMaybe<TNestedRealestateFileConstructionRecordObjectPartsContentRestrictionsDataRegistrationObjectFilterType>;
  regNumbBorder?: InputMaybe<TNestedRealestateFileConstructionRecordObjectPartsContentRestrictionsRegNumbBorderObjectFilterType>;
};

export type TNestedRealestateFileConstructionRecordObjectPartsContentRestrictionsRegNumbBorder = {
  __typename?: 'NestedRealestateFileConstructionRecordObjectPartsContentRestrictionsRegNumbBorder';
  regNumber?: Maybe<Scalars['String']['output']>;
};

export type TNestedRealestateFileConstructionRecordObjectPartsContentRestrictionsRegNumbBorderObjectFilterType = {
  regNumber?: InputMaybe<TStringFilter>;
};

export type TNestedRealestateFileConstructionRecordObjectPartsContours = {
  __typename?: 'NestedRealestateFileConstructionRecordObjectPartsContours';
  /** Описание элементов контура (характерных точек контура) */
  entitySpatial?: Maybe<TNestedRealestateFileConstructionRecordObjectPartsContoursEntitySpatial>;
  /** Номер контура */
  numberPp?: Maybe<Scalars['Int']['output']>;
};

export type TNestedRealestateFileConstructionRecordObjectPartsContoursEntitySpatial = {
  __typename?: 'NestedRealestateFileConstructionRecordObjectPartsContoursEntitySpatial';
  /** Система координат */
  skId?: Maybe<Scalars['String']['output']>;
  /** Координаты */
  spatialsElements?: Maybe<Array<Maybe<TNestedRealestateFileConstructionRecordObjectPartsContoursEntitySpatialSpatialsElements>>>;
};


export type TNestedRealestateFileConstructionRecordObjectPartsContoursEntitySpatialSpatialsElementsArgs = {
  pagination?: InputMaybe<TPagination>;
};

export type TNestedRealestateFileConstructionRecordObjectPartsContoursEntitySpatialObjectFilterType = {
  skId?: InputMaybe<TStringFilter>;
  spatialsElements?: InputMaybe<TNestedRealestateFileConstructionRecordObjectPartsContoursEntitySpatialSpatialsElementsObjectFilterType>;
};

export type TNestedRealestateFileConstructionRecordObjectPartsContoursEntitySpatialSpatialsElements = {
  __typename?: 'NestedRealestateFileConstructionRecordObjectPartsContoursEntitySpatialSpatialsElements';
  /** Погрешность */
  deltaGeopoint?: Maybe<Scalars['Int']['output']>;
  /** Описание закрепления точки */
  geopointZacrep?: Maybe<Scalars['String']['output']>;
  /** Номер межевой точки */
  numGeopoint?: Maybe<Scalars['String']['output']>;
  /** Номер точки (порядок обхода) */
  ordNmb?: Maybe<Scalars['Int']['output']>;
  /** Координата X */
  x?: Maybe<Scalars['Int']['output']>;
  /** Координата Y */
  y?: Maybe<Scalars['Int']['output']>;
  /** Координата Z */
  z?: Maybe<Scalars['Int']['output']>;
};

export type TNestedRealestateFileConstructionRecordObjectPartsContoursEntitySpatialSpatialsElementsObjectFilterType = {
  deltaGeopoint?: InputMaybe<TIntFilter>;
  geopointZacrep?: InputMaybe<TStringFilter>;
  numGeopoint?: InputMaybe<TStringFilter>;
  ordNmb?: InputMaybe<TIntFilter>;
  x?: InputMaybe<TIntFilter>;
  y?: InputMaybe<TIntFilter>;
  z?: InputMaybe<TIntFilter>;
};

export type TNestedRealestateFileConstructionRecordObjectPartsContoursObjectFilterType = {
  entitySpatial?: InputMaybe<TNestedRealestateFileConstructionRecordObjectPartsContoursEntitySpatialObjectFilterType>;
  numberPp?: InputMaybe<TIntFilter>;
};

export type TNestedRealestateFileConstructionRecordObjectPartsLocationBuilding = {
  __typename?: 'NestedRealestateFileConstructionRecordObjectPartsLocationBuilding';
  /** Описание местоположения контура */
  contours?: Maybe<Array<Maybe<TNestedRealestateFileConstructionRecordObjectPartsLocationBuildingContours>>>;
  /** Расположение в пределах объекта недвижимости */
  inBuild?: Maybe<Array<Maybe<TNestedRealestateFileConstructionRecordObjectPartsLocationBuildingInBuild>>>;
};


export type TNestedRealestateFileConstructionRecordObjectPartsLocationBuildingContoursArgs = {
  pagination?: InputMaybe<TPagination>;
};


export type TNestedRealestateFileConstructionRecordObjectPartsLocationBuildingInBuildArgs = {
  pagination?: InputMaybe<TPagination>;
};

export type TNestedRealestateFileConstructionRecordObjectPartsLocationBuildingContours = {
  __typename?: 'NestedRealestateFileConstructionRecordObjectPartsLocationBuildingContours';
  /** Описание элементов контура (характерных точек контура) */
  entitySpatial?: Maybe<TNestedRealestateFileConstructionRecordObjectPartsLocationBuildingContoursEntitySpatial>;
  /** Номер контура */
  numberPp?: Maybe<Scalars['Int']['output']>;
};

export type TNestedRealestateFileConstructionRecordObjectPartsLocationBuildingContoursEntitySpatial = {
  __typename?: 'NestedRealestateFileConstructionRecordObjectPartsLocationBuildingContoursEntitySpatial';
  /** Система координат */
  skId?: Maybe<Scalars['String']['output']>;
  /** Элементы контура */
  spatialsElements?: Maybe<Array<Maybe<TNestedRealestateFileConstructionRecordObjectPartsLocationBuildingContoursEntitySpatialSpatialsElements>>>;
};


export type TNestedRealestateFileConstructionRecordObjectPartsLocationBuildingContoursEntitySpatialSpatialsElementsArgs = {
  pagination?: InputMaybe<TPagination>;
};

export type TNestedRealestateFileConstructionRecordObjectPartsLocationBuildingContoursEntitySpatialObjectFilterType = {
  skId?: InputMaybe<TStringFilter>;
  spatialsElements?: InputMaybe<TNestedRealestateFileConstructionRecordObjectPartsLocationBuildingContoursEntitySpatialSpatialsElementsObjectFilterType>;
};

export type TNestedRealestateFileConstructionRecordObjectPartsLocationBuildingContoursEntitySpatialSpatialsElements = {
  __typename?: 'NestedRealestateFileConstructionRecordObjectPartsLocationBuildingContoursEntitySpatialSpatialsElements';
  /** Тип контура */
  levelContour?: Maybe<TNestedRealestateFileConstructionRecordObjectPartsLocationBuildingContoursEntitySpatialSpatialsElementsLevelContour>;
  /** Список координат */
  ordinates?: Maybe<Array<Maybe<TNestedRealestateFileConstructionRecordObjectPartsLocationBuildingContoursEntitySpatialSpatialsElementsOrdinates>>>;
};


export type TNestedRealestateFileConstructionRecordObjectPartsLocationBuildingContoursEntitySpatialSpatialsElementsOrdinatesArgs = {
  pagination?: InputMaybe<TPagination>;
};

export type TNestedRealestateFileConstructionRecordObjectPartsLocationBuildingContoursEntitySpatialSpatialsElementsLevelContour = {
  __typename?: 'NestedRealestateFileConstructionRecordObjectPartsLocationBuildingContoursEntitySpatialSpatialsElementsLevelContour';
  /** код из справочника */
  code?: Maybe<Scalars['NumberString']['output']>;
  /** значение */
  value?: Maybe<Scalars['String']['output']>;
};

export type TNestedRealestateFileConstructionRecordObjectPartsLocationBuildingContoursEntitySpatialSpatialsElementsLevelContourObjectFilterType = {
  code?: InputMaybe<TNumberStringFilter>;
  value?: InputMaybe<TStringFilter>;
};

export type TNestedRealestateFileConstructionRecordObjectPartsLocationBuildingContoursEntitySpatialSpatialsElementsObjectFilterType = {
  levelContour?: InputMaybe<TNestedRealestateFileConstructionRecordObjectPartsLocationBuildingContoursEntitySpatialSpatialsElementsLevelContourObjectFilterType>;
  ordinates?: InputMaybe<TNestedRealestateFileConstructionRecordObjectPartsLocationBuildingContoursEntitySpatialSpatialsElementsOrdinatesObjectFilterType>;
};

export type TNestedRealestateFileConstructionRecordObjectPartsLocationBuildingContoursEntitySpatialSpatialsElementsOrdinates = {
  __typename?: 'NestedRealestateFileConstructionRecordObjectPartsLocationBuildingContoursEntitySpatialSpatialsElementsOrdinates';
  /** Погрешность */
  deltaGeopoint?: Maybe<Scalars['Int']['output']>;
  /** Номер точки */
  numGeopoint?: Maybe<Scalars['String']['output']>;
  /** Номер точки (порядок обхода) */
  ordNmb?: Maybe<Scalars['Int']['output']>;
  /** Радиус */
  r?: Maybe<Scalars['Int']['output']>;
  /** Координата X */
  x?: Maybe<Scalars['Int']['output']>;
  /** Координата Y */
  y?: Maybe<Scalars['Int']['output']>;
  /** Координата Z */
  z?: Maybe<Scalars['Int']['output']>;
};

export type TNestedRealestateFileConstructionRecordObjectPartsLocationBuildingContoursEntitySpatialSpatialsElementsOrdinatesObjectFilterType = {
  deltaGeopoint?: InputMaybe<TIntFilter>;
  numGeopoint?: InputMaybe<TStringFilter>;
  ordNmb?: InputMaybe<TIntFilter>;
  r?: InputMaybe<TIntFilter>;
  x?: InputMaybe<TIntFilter>;
  y?: InputMaybe<TIntFilter>;
  z?: InputMaybe<TIntFilter>;
};

export type TNestedRealestateFileConstructionRecordObjectPartsLocationBuildingContoursObjectFilterType = {
  entitySpatial?: InputMaybe<TNestedRealestateFileConstructionRecordObjectPartsLocationBuildingContoursEntitySpatialObjectFilterType>;
  numberPp?: InputMaybe<TIntFilter>;
};

export type TNestedRealestateFileConstructionRecordObjectPartsLocationBuildingInBuild = {
  __typename?: 'NestedRealestateFileConstructionRecordObjectPartsLocationBuildingInBuild';
  /** Описание расположения */
  description?: Maybe<Scalars['String']['output']>;
  /** Номер этажа */
  floor?: Maybe<Scalars['Int']['output']>;
  /** Тип этажа */
  floorType?: Maybe<Scalars['Int']['output']>;
  /** Номер на поэтажном плане */
  planNumber?: Maybe<Scalars['String']['output']>;
  /** Планы */
  plans?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};


export type TNestedRealestateFileConstructionRecordObjectPartsLocationBuildingInBuildPlansArgs = {
  pagination?: InputMaybe<TPagination>;
};

export type TNestedRealestateFileConstructionRecordObjectPartsLocationBuildingInBuildObjectFilterType = {
  description?: InputMaybe<TStringFilter>;
  floor?: InputMaybe<TIntFilter>;
  floorType?: InputMaybe<TIntFilter>;
  planNumber?: InputMaybe<TStringFilter>;
  plans?: InputMaybe<TStringFilter>;
};

export type TNestedRealestateFileConstructionRecordObjectPartsLocationBuildingObjectFilterType = {
  contours?: InputMaybe<TNestedRealestateFileConstructionRecordObjectPartsLocationBuildingContoursObjectFilterType>;
  inBuild?: InputMaybe<TNestedRealestateFileConstructionRecordObjectPartsLocationBuildingInBuildObjectFilterType>;
};

export type TNestedRealestateFileConstructionRecordObjectPartsObjectFilterType = {
  area?: InputMaybe<TNestedRealestateFileConstructionRecordObjectPartsAreaObjectFilterType>;
  contentRestrictions?: InputMaybe<TNestedRealestateFileConstructionRecordObjectPartsContentRestrictionsObjectFilterType>;
  contours?: InputMaybe<TNestedRealestateFileConstructionRecordObjectPartsContoursObjectFilterType>;
  footnote?: InputMaybe<TStringFilter>;
  locationBuilding?: InputMaybe<TNestedRealestateFileConstructionRecordObjectPartsLocationBuildingObjectFilterType>;
  partNumber?: InputMaybe<TIntFilter>;
};

export type TNestedRealestateFileConstructionRecordObjectType = {
  __typename?: 'NestedRealestateFileConstructionRecordObjectType';
  /** код из справочника */
  code?: Maybe<Scalars['NumberString']['output']>;
  /** значение */
  value?: Maybe<Scalars['String']['output']>;
};

export type TNestedRealestateFileConstructionRecordObjectTypeObjectFilterType = {
  code?: InputMaybe<TNumberStringFilter>;
  value?: InputMaybe<TStringFilter>;
};

export type TNestedRealestateFileConstructionRecordParams = {
  __typename?: 'NestedRealestateFileConstructionRecordParams';
  /** Разрешенное использование */
  allowedUse?: Maybe<TNestedRealestateFileConstructionRecordParamsAllowedUse>;
  /** В Здании это значение является числом */
  area?: Maybe<TNestedRealestateFileConstructionRecordParamsArea>;
  /** Основные характеристики */
  baseParameters?: Maybe<Array<Maybe<TNestedRealestateFileConstructionRecordParamsBaseParameters>>>;
  /** Категория */
  category?: Maybe<TNestedRealestateFileConstructionRecordParamsCategory>;
  /** Степень готовности объекта незавершенного строительства в процентах */
  degreeReadiness?: Maybe<Scalars['String']['output']>;
  /** Количество этажей (в том числе подземных) */
  floors?: Maybe<Scalars['Int']['output']>;
  /** Материалы наружных стен здания */
  materials?: Maybe<Array<Maybe<TNestedRealestateFileConstructionRecordParamsMaterials>>>;
  /** Наименование сооружения */
  name?: Maybe<Scalars['String']['output']>;
  /** Вид(ы) разрешенного использования */
  permittedUses?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Разрешенное использование по градостроительному регламенту */
  permittesUsesGradReg?: Maybe<TNestedRealestateFileConstructionRecordParamsPermittesUsesGradReg>;
  /** Назначение сооружения */
  purpose?: Maybe<TNestedRealestateFileConstructionRecordParamsPurpose>;
  /** Количество подземных этажей */
  undergroundFloors?: Maybe<Scalars['Int']['output']>;
  /** Год завершения строительства */
  yearBuilt?: Maybe<Scalars['year']['output']>;
  /** Год ввода в эксплуатацию по завершении строительства */
  yearCommisioning?: Maybe<Scalars['String']['output']>;
};


export type TNestedRealestateFileConstructionRecordParamsBaseParametersArgs = {
  pagination?: InputMaybe<TPagination>;
};


export type TNestedRealestateFileConstructionRecordParamsMaterialsArgs = {
  pagination?: InputMaybe<TPagination>;
};


export type TNestedRealestateFileConstructionRecordParamsPermittedUsesArgs = {
  pagination?: InputMaybe<TPagination>;
};

export type TNestedRealestateFileConstructionRecordParamsAllowedUse = {
  __typename?: 'NestedRealestateFileConstructionRecordParamsAllowedUse';
  /** По документу */
  byDocument?: Maybe<Scalars['String']['output']>;
  /** Вид разрешенного использования земельного участка в соответствии с ранее использовавшимся классификатором */
  landUse?: Maybe<TNestedRealestateFileConstructionRecordParamsAllowedUseLandUse>;
  /** Вид разрешенного использования земельного участка в соответствии с классификатором, утвержденным приказом Минэкономразвития России от 01.09.2014 № 540 */
  landUseMer?: Maybe<TNestedRealestateFileConstructionRecordParamsAllowedUseLandUseMer>;
};

export type TNestedRealestateFileConstructionRecordParamsAllowedUseLandUse = {
  __typename?: 'NestedRealestateFileConstructionRecordParamsAllowedUseLandUse';
  /** код из справочника */
  code?: Maybe<Scalars['NumberString']['output']>;
  /** значение */
  value?: Maybe<Scalars['String']['output']>;
};

export type TNestedRealestateFileConstructionRecordParamsAllowedUseLandUseMer = {
  __typename?: 'NestedRealestateFileConstructionRecordParamsAllowedUseLandUseMer';
  /** код из справочника */
  code?: Maybe<Scalars['NumberString']['output']>;
  /** значение */
  value?: Maybe<Scalars['String']['output']>;
};

export type TNestedRealestateFileConstructionRecordParamsAllowedUseLandUseMerObjectFilterType = {
  code?: InputMaybe<TNumberStringFilter>;
  value?: InputMaybe<TStringFilter>;
};

export type TNestedRealestateFileConstructionRecordParamsAllowedUseLandUseObjectFilterType = {
  code?: InputMaybe<TNumberStringFilter>;
  value?: InputMaybe<TStringFilter>;
};

export type TNestedRealestateFileConstructionRecordParamsAllowedUseObjectFilterType = {
  byDocument?: InputMaybe<TStringFilter>;
  landUse?: InputMaybe<TNestedRealestateFileConstructionRecordParamsAllowedUseLandUseObjectFilterType>;
  landUseMer?: InputMaybe<TNestedRealestateFileConstructionRecordParamsAllowedUseLandUseMerObjectFilterType>;
};

export type TNestedRealestateFileConstructionRecordParamsArea = {
  __typename?: 'NestedRealestateFileConstructionRecordParamsArea';
  /** код из справочника */
  code?: Maybe<Scalars['NumberString']['output']>;
  /** значение */
  value?: Maybe<Scalars['Float']['output']>;
};

export type TNestedRealestateFileConstructionRecordParamsAreaObjectFilterType = {
  code?: InputMaybe<TNumberStringFilter>;
  value?: InputMaybe<TFloatFilter>;
};

export type TNestedRealestateFileConstructionRecordParamsBaseParameters = {
  __typename?: 'NestedRealestateFileConstructionRecordParamsBaseParameters';
  /** Площадь в кв. метрах */
  area?: Maybe<Scalars['Float']['output']>;
  /** Площадь застройки в квадратных метрах с округлением до 0,1 квадратного метра */
  builtUpArea?: Maybe<Scalars['Int']['output']>;
  /** Глубина в метрах с округлением до 0,1 метра */
  depth?: Maybe<Scalars['Int']['output']>;
  /** Протяженность в метрах с округлением до 1 метра */
  extension?: Maybe<Scalars['Int']['output']>;
  /** Высота в метрах с округлением до 0,1 метра */
  height?: Maybe<Scalars['Int']['output']>;
  /** Глубина залегания в метрах с округлением до 0,1 метра */
  occurenceDepth?: Maybe<Scalars['Int']['output']>;
  /** Объем в кубических метрах с округлением до 1 кубического метра */
  volume?: Maybe<Scalars['Int']['output']>;
};

export type TNestedRealestateFileConstructionRecordParamsBaseParametersObjectFilterType = {
  area?: InputMaybe<TFloatFilter>;
  builtUpArea?: InputMaybe<TIntFilter>;
  depth?: InputMaybe<TIntFilter>;
  extension?: InputMaybe<TIntFilter>;
  height?: InputMaybe<TIntFilter>;
  occurenceDepth?: InputMaybe<TIntFilter>;
  volume?: InputMaybe<TIntFilter>;
};

export type TNestedRealestateFileConstructionRecordParamsCategory = {
  __typename?: 'NestedRealestateFileConstructionRecordParamsCategory';
  /** код из справочника */
  code?: Maybe<Scalars['NumberString']['output']>;
  /** значение */
  value?: Maybe<Scalars['String']['output']>;
};

export type TNestedRealestateFileConstructionRecordParamsCategoryObjectFilterType = {
  code?: InputMaybe<TNumberStringFilter>;
  value?: InputMaybe<TStringFilter>;
};

export type TNestedRealestateFileConstructionRecordParamsMaterials = {
  __typename?: 'NestedRealestateFileConstructionRecordParamsMaterials';
  /** код из справочника */
  code?: Maybe<Scalars['NumberString']['output']>;
  /** значение */
  value?: Maybe<Scalars['String']['output']>;
};

export type TNestedRealestateFileConstructionRecordParamsMaterialsObjectFilterType = {
  code?: InputMaybe<TNumberStringFilter>;
  value?: InputMaybe<TStringFilter>;
};

export type TNestedRealestateFileConstructionRecordParamsObjectFilterType = {
  allowedUse?: InputMaybe<TNestedRealestateFileConstructionRecordParamsAllowedUseObjectFilterType>;
  area?: InputMaybe<TNestedRealestateFileConstructionRecordParamsAreaObjectFilterType>;
  baseParameters?: InputMaybe<TNestedRealestateFileConstructionRecordParamsBaseParametersObjectFilterType>;
  category?: InputMaybe<TNestedRealestateFileConstructionRecordParamsCategoryObjectFilterType>;
  degreeReadiness?: InputMaybe<TStringFilter>;
  floors?: InputMaybe<TIntFilter>;
  materials?: InputMaybe<TNestedRealestateFileConstructionRecordParamsMaterialsObjectFilterType>;
  name?: InputMaybe<TStringFilter>;
  permittedUses?: InputMaybe<TStringFilter>;
  permittesUsesGradReg?: InputMaybe<TNestedRealestateFileConstructionRecordParamsPermittesUsesGradRegObjectFilterType>;
  purpose?: InputMaybe<TNestedRealestateFileConstructionRecordParamsPurposeObjectFilterType>;
  undergroundFloors?: InputMaybe<TIntFilter>;
  yearBuilt?: InputMaybe<TYearFilter>;
  yearCommisioning?: InputMaybe<TStringFilter>;
};

export type TNestedRealestateFileConstructionRecordParamsPermittesUsesGradReg = {
  __typename?: 'NestedRealestateFileConstructionRecordParamsPermittesUsesGradReg';
  /** Вид разрешенного использования в соответствии с классификатором, утвержденным приказом Минэкономразвития России от 01.09.2014 № 540 */
  landUse?: Maybe<TNestedRealestateFileConstructionRecordParamsPermittesUsesGradRegLandUse>;
  /** Разрешенное использование (текстовое описание) */
  permittedUseText?: Maybe<Scalars['String']['output']>;
  /** Реестровый номер границы */
  regNumbBorder?: Maybe<Scalars['String']['output']>;
};

export type TNestedRealestateFileConstructionRecordParamsPermittesUsesGradRegLandUse = {
  __typename?: 'NestedRealestateFileConstructionRecordParamsPermittesUsesGradRegLandUse';
  /** код из справочника */
  code?: Maybe<Scalars['NumberString']['output']>;
  /** значение */
  value?: Maybe<Scalars['String']['output']>;
};

export type TNestedRealestateFileConstructionRecordParamsPermittesUsesGradRegLandUseObjectFilterType = {
  code?: InputMaybe<TNumberStringFilter>;
  value?: InputMaybe<TStringFilter>;
};

export type TNestedRealestateFileConstructionRecordParamsPermittesUsesGradRegObjectFilterType = {
  landUse?: InputMaybe<TNestedRealestateFileConstructionRecordParamsPermittesUsesGradRegLandUseObjectFilterType>;
  permittedUseText?: InputMaybe<TStringFilter>;
  regNumbBorder?: InputMaybe<TStringFilter>;
};

export type TNestedRealestateFileConstructionRecordParamsPurpose = {
  __typename?: 'NestedRealestateFileConstructionRecordParamsPurpose';
  /** код из справочника */
  code?: Maybe<Scalars['NumberString']['output']>;
  /** значение */
  value?: Maybe<Scalars['String']['output']>;
};

export type TNestedRealestateFileConstructionRecordParamsPurposeObjectFilterType = {
  code?: InputMaybe<TNumberStringFilter>;
  value?: InputMaybe<TStringFilter>;
};

export type TNestedRealestateFileConstructionRecordRecordInfo = {
  __typename?: 'NestedRealestateFileConstructionRecordRecordInfo';
  /** Дата снятия с учета / регистрации */
  cancelDate?: Maybe<Scalars['String']['output']>;
  /** Дата постановки на учет / регистрации */
  registrationDate?: Maybe<Scalars['DateTimeISO']['output']>;
};

export type TNestedRealestateFileConstructionRecordRecordInfoObjectFilterType = {
  cancelDate?: InputMaybe<TStringFilter>;
  registrationDate?: InputMaybe<TDateTimeIsoFilter>;
};

export type TNestedRealestateFileDealRecords = {
  __typename?: 'NestedRealestateFileDealRecords';
  /** Общие сведения о сделке (вид сделки) */
  dealData?: Maybe<TNestedRealestateFileDealRecordsDealData>;
  /** Сведения об осуществлении государственной регистрации сделки, права, ограничения права, совершенных без необходимого в силу закона согласия третьего лица, органа */
  thirdPartyConsents?: Maybe<TNestedRealestateFileDealRecordsThirdPartyConsents>;
};

export type TNestedRealestateFileDealRecordsDealData = {
  __typename?: 'NestedRealestateFileDealRecordsDealData';
  /** код из справочника */
  code?: Maybe<Scalars['NumberString']['output']>;
  /** значение */
  value?: Maybe<Scalars['String']['output']>;
};

export type TNestedRealestateFileDealRecordsDealDataObjectFilterType = {
  code?: InputMaybe<TNumberStringFilter>;
  value?: InputMaybe<TStringFilter>;
};

export type TNestedRealestateFileDealRecordsObjectFilterType = {
  dealData?: InputMaybe<TNestedRealestateFileDealRecordsDealDataObjectFilterType>;
  thirdPartyConsents?: InputMaybe<TNestedRealestateFileDealRecordsThirdPartyConsentsObjectFilterType>;
};

export type TNestedRealestateFileDealRecordsThirdPartyConsents = {
  __typename?: 'NestedRealestateFileDealRecordsThirdPartyConsents';
  /** Не представлено согласие на совершение сделки */
  dissentingEntities?: Maybe<TNestedRealestateFileDealRecordsThirdPartyConsentsDissentingEntities>;
  /** Федеральный закон, которым предусмотрено получение согласия на совершение сделки */
  law?: Maybe<TNestedRealestateFileDealRecordsThirdPartyConsentsLaw>;
  /** Содержание отметки при возникновении / погашении */
  markContent?: Maybe<Scalars['String']['output']>;
};

export type TNestedRealestateFileDealRecordsThirdPartyConsentsDissentingEntities = {
  __typename?: 'NestedRealestateFileDealRecordsThirdPartyConsentsDissentingEntities';
  /** Физическое лицо */
  individual?: Maybe<TNestedRealestateFileDealRecordsThirdPartyConsentsDissentingEntitiesIndividual>;
  /** Юридическое лицо, орган власти, местного самоуправления */
  legalEntity?: Maybe<Scalars['String']['output']>;
};

export type TNestedRealestateFileDealRecordsThirdPartyConsentsDissentingEntitiesIndividual = {
  __typename?: 'NestedRealestateFileDealRecordsThirdPartyConsentsDissentingEntitiesIndividual';
  firstName?: Maybe<Scalars['String']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  middleName?: Maybe<Scalars['String']['output']>;
};

export type TNestedRealestateFileDealRecordsThirdPartyConsentsDissentingEntitiesIndividualObjectFilterType = {
  firstName?: InputMaybe<TStringFilter>;
  lastName?: InputMaybe<TStringFilter>;
  middleName?: InputMaybe<TStringFilter>;
};

export type TNestedRealestateFileDealRecordsThirdPartyConsentsDissentingEntitiesObjectFilterType = {
  individual?: InputMaybe<TNestedRealestateFileDealRecordsThirdPartyConsentsDissentingEntitiesIndividualObjectFilterType>;
  legalEntity?: InputMaybe<TStringFilter>;
};

export type TNestedRealestateFileDealRecordsThirdPartyConsentsLaw = {
  __typename?: 'NestedRealestateFileDealRecordsThirdPartyConsentsLaw';
  /** Статья */
  article?: Maybe<Scalars['String']['output']>;
  /** Дата */
  lawDate?: Maybe<Scalars['String']['output']>;
  /** Номер */
  number?: Maybe<Scalars['String']['output']>;
  /** Пункт */
  paragraph?: Maybe<Scalars['String']['output']>;
  /** Часть */
  section?: Maybe<Scalars['String']['output']>;
  /** Наименование */
  title?: Maybe<Scalars['String']['output']>;
};

export type TNestedRealestateFileDealRecordsThirdPartyConsentsLawObjectFilterType = {
  article?: InputMaybe<TStringFilter>;
  lawDate?: InputMaybe<TStringFilter>;
  number?: InputMaybe<TStringFilter>;
  paragraph?: InputMaybe<TStringFilter>;
  section?: InputMaybe<TStringFilter>;
  title?: InputMaybe<TStringFilter>;
};

export type TNestedRealestateFileDealRecordsThirdPartyConsentsObjectFilterType = {
  dissentingEntities?: InputMaybe<TNestedRealestateFileDealRecordsThirdPartyConsentsDissentingEntitiesObjectFilterType>;
  law?: InputMaybe<TNestedRealestateFileDealRecordsThirdPartyConsentsLawObjectFilterType>;
  markContent?: InputMaybe<TStringFilter>;
};

export type TNestedRealestateFileDetailsRequest = {
  __typename?: 'NestedRealestateFileDetailsRequest';
  /** Дата получения запроса органом регистрации прав */
  dateReceiptRequestRegAuthorityRights?: Maybe<Scalars['DateTimeISO']['output']>;
  /** Дата поступившего запроса */
  dateReceivedRequest?: Maybe<Scalars['DateTimeISO']['output']>;
};

export type TNestedRealestateFileDetailsRequestObjectFilterType = {
  dateReceiptRequestRegAuthorityRights?: InputMaybe<TDateTimeIsoFilter>;
  dateReceivedRequest?: InputMaybe<TDateTimeIsoFilter>;
};

export type TNestedRealestateFileDetailsStatement = {
  __typename?: 'NestedRealestateFileDetailsStatement';
  /** Группа нижних реквизитов */
  groupLowerRequisites?: Maybe<TNestedRealestateFileDetailsStatementGroupLowerRequisites>;
  /** Группа верхних реквизитов */
  groupTopRequisites?: Maybe<TNestedRealestateFileDetailsStatementGroupTopRequisites>;
};

export type TNestedRealestateFileDetailsStatementGroupLowerRequisites = {
  __typename?: 'NestedRealestateFileDetailsStatementGroupLowerRequisites';
  /** Полное наименование должности */
  fullNamePosition?: Maybe<Scalars['String']['output']>;
  /** Инициалы, фамилия */
  initialsSurname?: Maybe<Scalars['String']['output']>;
};

export type TNestedRealestateFileDetailsStatementGroupLowerRequisitesObjectFilterType = {
  fullNamePosition?: InputMaybe<TStringFilter>;
  initialsSurname?: InputMaybe<TStringFilter>;
};

export type TNestedRealestateFileDetailsStatementGroupTopRequisites = {
  __typename?: 'NestedRealestateFileDetailsStatementGroupTopRequisites';
  /** Дата формирования выписки */
  dateFormation?: Maybe<Scalars['DateTimeISO']['output']>;
  /** Полное наименование органа регистрации прав */
  organRegistrRights?: Maybe<Scalars['String']['output']>;
  /** Регистрационный номер */
  registrationNumber?: Maybe<Scalars['String']['output']>;
};

export type TNestedRealestateFileDetailsStatementGroupTopRequisitesObjectFilterType = {
  dateFormation?: InputMaybe<TDateTimeIsoFilter>;
  organRegistrRights?: InputMaybe<TStringFilter>;
  registrationNumber?: InputMaybe<TStringFilter>;
};

export type TNestedRealestateFileDetailsStatementObjectFilterType = {
  groupLowerRequisites?: InputMaybe<TNestedRealestateFileDetailsStatementGroupLowerRequisitesObjectFilterType>;
  groupTopRequisites?: InputMaybe<TNestedRealestateFileDetailsStatementGroupTopRequisitesObjectFilterType>;
};

export type TNestedRealestateFileOwnerlessRightRecord = {
  __typename?: 'NestedRealestateFileOwnerlessRightRecord';
  /** Общие сведения о правах на бесхозяйное имущество */
  ownerlessRightData?: Maybe<TNestedRealestateFileOwnerlessRightRecordOwnerlessRightData>;
  recordInfo?: Maybe<TNestedRealestateFileOwnerlessRightRecordRecordInfo>;
};

export type TNestedRealestateFileOwnerlessRightRecordObjectFilterType = {
  ownerlessRightData?: InputMaybe<TNestedRealestateFileOwnerlessRightRecordOwnerlessRightDataObjectFilterType>;
  recordInfo?: InputMaybe<TNestedRealestateFileOwnerlessRightRecordRecordInfoObjectFilterType>;
};

export type TNestedRealestateFileOwnerlessRightRecordOwnerlessRightData = {
  __typename?: 'NestedRealestateFileOwnerlessRightRecordOwnerlessRightData';
  /** Наименование органа местного самоуправления (органа государственной власти - для городов федерального значения Москвы, Санкт-Петербурга, Севастополя), представившего заявление о постановке на учет данного объекта недвижимости в качестве бесхозяйного */
  authorityName?: Maybe<Scalars['String']['output']>;
  /** Номер регистрации */
  ownerlessRightNumber?: Maybe<Scalars['String']['output']>;
};

export type TNestedRealestateFileOwnerlessRightRecordOwnerlessRightDataObjectFilterType = {
  authorityName?: InputMaybe<TStringFilter>;
  ownerlessRightNumber?: InputMaybe<TStringFilter>;
};

export type TNestedRealestateFileOwnerlessRightRecordRecordInfo = {
  __typename?: 'NestedRealestateFileOwnerlessRightRecordRecordInfo';
  /** Дата снятия с учета / регистрации */
  cancelDate?: Maybe<Scalars['String']['output']>;
  /** Дата постановки на учет / регистрации */
  registrationDate?: Maybe<Scalars['DateTimeISO']['output']>;
};

export type TNestedRealestateFileOwnerlessRightRecordRecordInfoObjectFilterType = {
  cancelDate?: InputMaybe<TStringFilter>;
  registrationDate?: InputMaybe<TDateTimeIsoFilter>;
};

export type TNestedRealestateFileRealestateRecord = {
  __typename?: 'NestedRealestateFileRealestateRecord';
  /** Дополнительное пространственное описание конструктивных элементов */
  additionalContourLocation?: Maybe<TNestedRealestateFileRealestateRecordAdditionalContourLocation>;
  /** Адрес (местоположение) */
  address?: Maybe<TNestedRealestateFileRealestateRecordAddress>;
  /** Сведения о создании (эксплуатации) на земельном участке наемного дома */
  apartmentBuilding?: Maybe<TNestedRealestateFileRealestateRecordApartmentBuilding>;
  /** Сведения об объектах (связь с кадастровыми номерами) */
  cadLinks?: Maybe<TNestedRealestateFileRealestateRecordCadLinks>;
  /** Сведения о кадастровом инженере (кадастровых инженерах) */
  cadWorks?: Maybe<Array<Maybe<TNestedRealestateFileRealestateRecordCadWorks>>>;
  /** Описание местоположения контура сооружения */
  contours?: Maybe<Array<Maybe<TNestedRealestateFileRealestateRecordContours>>>;
  /** Описание местоположения границ земельного участка */
  contoursLocation?: Maybe<TNestedRealestateFileRealestateRecordContoursLocation>;
  /** Кадастровая стоимость */
  cost?: Maybe<Scalars['Float']['output']>;
  /** Сведения о включении объекта недвижимости в единый государственный реестр объектов культурного наследия (памятников истории и культуры) народов Российской Федерации */
  culturalHeritage?: Maybe<TNestedRealestateFileRealestateRecordCulturalHeritage>;
  /** Сведения о результатах проведения государственного земельного надзора */
  governmentLandSupervision?: Maybe<TNestedRealestateFileRealestateRecordGovernmentLandSupervision>;
  locationInBuild?: Maybe<Array<Maybe<TNestedRealestateFileRealestateRecordLocationInBuild>>>;
  /** Сведения о природных объектах, расположенных в пределах земельного участка */
  naturalObjects?: Maybe<TNestedRealestateFileRealestateRecordNaturalObjects>;
  /** Общие сведения об объекте недвижимости */
  object: TNestedRealestateFileRealestateRecordObject;
  /** Сведения о частях земельного участка */
  objectParts?: Maybe<Array<Maybe<TNestedRealestateFileRealestateRecordObjectParts>>>;
  /** Характеристики земельного участка */
  params?: Maybe<TNestedRealestateFileRealestateRecordParams>;
  /** Даты государственной регистрации */
  recordInfo?: Maybe<TNestedRealestateFileRealestateRecordRecordInfo>;
  /** Незарегистрированные и не подлежащие государственной регистрации ограничения (обременения) */
  restrictionsEncumbrances?: Maybe<TNestedRealestateFileRealestateRecordRestrictionsEncumbrances>;
  /** Особые отметки */
  specialNotes?: Maybe<Scalars['String']['output']>;
  /** Условный номер земельного участка и сведения о расположении земельного участка в границах территории, в отношении которой утвержден проект межевания территории */
  surveyBoundaries?: Maybe<TNestedRealestateFileRealestateRecordSurveyBoundaries>;
  /** Сведения о расположении земельного участка в границах зон, территорий */
  zonesAndBoundaries?: Maybe<TNestedRealestateFileRealestateRecordZonesAndBoundaries>;
};


export type TNestedRealestateFileRealestateRecordCadWorksArgs = {
  pagination?: InputMaybe<TPagination>;
};


export type TNestedRealestateFileRealestateRecordContoursArgs = {
  pagination?: InputMaybe<TPagination>;
};


export type TNestedRealestateFileRealestateRecordLocationInBuildArgs = {
  pagination?: InputMaybe<TPagination>;
};


export type TNestedRealestateFileRealestateRecordObjectPartsArgs = {
  pagination?: InputMaybe<TPagination>;
};

export type TNestedRealestateFileRealestateRecordAdditionalContourLocation = {
  __typename?: 'NestedRealestateFileRealestateRecordAdditionalContourLocation';
  /** Точки пересечения проекций контуров объекта */
  intersectionPoints?: Maybe<TNestedRealestateFileRealestateRecordAdditionalContourLocationIntersectionPoints>;
  /** Предельные размеры */
  limitDimensions?: Maybe<TNestedRealestateFileRealestateRecordAdditionalContourLocationLimitDimensions>;
  /** Система координат */
  skId?: Maybe<Scalars['String']['output']>;
};

export type TNestedRealestateFileRealestateRecordAdditionalContourLocationIntersectionPoints = {
  __typename?: 'NestedRealestateFileRealestateRecordAdditionalContourLocationIntersectionPoints';
  /** Точка пересечения */
  intersectionPoint?: Maybe<Array<Maybe<TNestedRealestateFileRealestateRecordAdditionalContourLocationIntersectionPointsIntersectionPoint>>>;
  /** Уровень расположения (тип контура) */
  levelContour?: Maybe<TNestedRealestateFileRealestateRecordAdditionalContourLocationIntersectionPointsLevelContour>;
};


export type TNestedRealestateFileRealestateRecordAdditionalContourLocationIntersectionPointsIntersectionPointArgs = {
  pagination?: InputMaybe<TPagination>;
};

export type TNestedRealestateFileRealestateRecordAdditionalContourLocationIntersectionPointsIntersectionPoint = {
  __typename?: 'NestedRealestateFileRealestateRecordAdditionalContourLocationIntersectionPointsIntersectionPoint';
  /** Кадастровые номера объектов недвижимости, с контуром которых пересекается контур данного объекта недвижимости */
  intersectionCadNumbers?: Maybe<Array<Maybe<TNestedRealestateFileRealestateRecordAdditionalContourLocationIntersectionPointsIntersectionPointIntersectionCadNumbers>>>;
  /** Описание точки пересечения */
  intersectionOrdinate?: Maybe<TNestedRealestateFileRealestateRecordAdditionalContourLocationIntersectionPointsIntersectionPointIntersectionOrdinate>;
};


export type TNestedRealestateFileRealestateRecordAdditionalContourLocationIntersectionPointsIntersectionPointIntersectionCadNumbersArgs = {
  pagination?: InputMaybe<TPagination>;
};

export type TNestedRealestateFileRealestateRecordAdditionalContourLocationIntersectionPointsIntersectionPointIntersectionCadNumbers = {
  __typename?: 'NestedRealestateFileRealestateRecordAdditionalContourLocationIntersectionPointsIntersectionPointIntersectionCadNumbers';
  cadNumber?: Maybe<Scalars['String']['output']>;
};

export type TNestedRealestateFileRealestateRecordAdditionalContourLocationIntersectionPointsIntersectionPointIntersectionCadNumbersObjectFilterType = {
  cadNumber?: InputMaybe<TStringFilter>;
};

export type TNestedRealestateFileRealestateRecordAdditionalContourLocationIntersectionPointsIntersectionPointIntersectionOrdinate = {
  __typename?: 'NestedRealestateFileRealestateRecordAdditionalContourLocationIntersectionPointsIntersectionPointIntersectionOrdinate';
  /** Погрешность */
  deltaGeopoint?: Maybe<Scalars['Int']['output']>;
  /** Глубина */
  depth?: Maybe<Scalars['Int']['output']>;
  /** Высота */
  height?: Maybe<Scalars['Int']['output']>;
  /** Номер точки */
  numGeopoint?: Maybe<Scalars['String']['output']>;
  /** Координата X */
  x?: Maybe<Scalars['Int']['output']>;
  /** Координата Y */
  y?: Maybe<Scalars['Int']['output']>;
};

export type TNestedRealestateFileRealestateRecordAdditionalContourLocationIntersectionPointsIntersectionPointIntersectionOrdinateObjectFilterType = {
  deltaGeopoint?: InputMaybe<TIntFilter>;
  depth?: InputMaybe<TIntFilter>;
  height?: InputMaybe<TIntFilter>;
  numGeopoint?: InputMaybe<TStringFilter>;
  x?: InputMaybe<TIntFilter>;
  y?: InputMaybe<TIntFilter>;
};

export type TNestedRealestateFileRealestateRecordAdditionalContourLocationIntersectionPointsIntersectionPointObjectFilterType = {
  intersectionCadNumbers?: InputMaybe<TNestedRealestateFileRealestateRecordAdditionalContourLocationIntersectionPointsIntersectionPointIntersectionCadNumbersObjectFilterType>;
  intersectionOrdinate?: InputMaybe<TNestedRealestateFileRealestateRecordAdditionalContourLocationIntersectionPointsIntersectionPointIntersectionOrdinateObjectFilterType>;
};

export type TNestedRealestateFileRealestateRecordAdditionalContourLocationIntersectionPointsLevelContour = {
  __typename?: 'NestedRealestateFileRealestateRecordAdditionalContourLocationIntersectionPointsLevelContour';
  /** код из справочника */
  code?: Maybe<Scalars['NumberString']['output']>;
  /** значение */
  value?: Maybe<Scalars['String']['output']>;
};

export type TNestedRealestateFileRealestateRecordAdditionalContourLocationIntersectionPointsLevelContourObjectFilterType = {
  code?: InputMaybe<TNumberStringFilter>;
  value?: InputMaybe<TStringFilter>;
};

export type TNestedRealestateFileRealestateRecordAdditionalContourLocationIntersectionPointsObjectFilterType = {
  intersectionPoint?: InputMaybe<TNestedRealestateFileRealestateRecordAdditionalContourLocationIntersectionPointsIntersectionPointObjectFilterType>;
  levelContour?: InputMaybe<TNestedRealestateFileRealestateRecordAdditionalContourLocationIntersectionPointsLevelContourObjectFilterType>;
};

export type TNestedRealestateFileRealestateRecordAdditionalContourLocationLimitDimensions = {
  __typename?: 'NestedRealestateFileRealestateRecordAdditionalContourLocationLimitDimensions';
  /** Максимальная глубина */
  maxDepth?: Maybe<Scalars['Int']['output']>;
  /** Максимальная высота */
  maxHeight?: Maybe<Scalars['Int']['output']>;
};

export type TNestedRealestateFileRealestateRecordAdditionalContourLocationLimitDimensionsObjectFilterType = {
  maxDepth?: InputMaybe<TIntFilter>;
  maxHeight?: InputMaybe<TIntFilter>;
};

export type TNestedRealestateFileRealestateRecordAdditionalContourLocationObjectFilterType = {
  intersectionPoints?: InputMaybe<TNestedRealestateFileRealestateRecordAdditionalContourLocationIntersectionPointsObjectFilterType>;
  limitDimensions?: InputMaybe<TNestedRealestateFileRealestateRecordAdditionalContourLocationLimitDimensionsObjectFilterType>;
  skId?: InputMaybe<TStringFilter>;
};

export type TNestedRealestateFileRealestateRecordAddress = {
  __typename?: 'NestedRealestateFileRealestateRecordAddress';
  /** Адрес (местоположение) */
  address?: Maybe<TNestedRealestateFileRealestateRecordAddressAddress>;
  /** Тип адреса */
  addressType?: Maybe<TNestedRealestateFileRealestateRecordAddressAddressType>;
  /** Наименования субъектов Российской Федерации, муниципальных образований, населенных пунктов (при наличии) */
  location?: Maybe<TNestedRealestateFileRealestateRecordAddressLocation>;
  /** Местоположение относительно ориентира */
  relPosition?: Maybe<TNestedRealestateFileRealestateRecordAddressRelPosition>;
};

export type TNestedRealestateFileRealestateRecordAddressAddress = {
  __typename?: 'NestedRealestateFileRealestateRecordAddressAddress';
  /** Адрес (по справочнику ФИАС) */
  addressFias?: Maybe<TNestedRealestateFileRealestateRecordAddressAddressAddressFias>;
  /** Неформализованное описание */
  note?: Maybe<Scalars['String']['output']>;
  /** Адрес в соответствии с ФИАС */
  readableAddress?: Maybe<Scalars['String']['output']>;
};

export type TNestedRealestateFileRealestateRecordAddressAddressAddressFias = {
  __typename?: 'NestedRealestateFileRealestateRecordAddressAddressAddressFias';
  /** Детализированный уровень */
  detailedLevel?: Maybe<TNestedRealestateFileRealestateRecordAddressAddressAddressFiasDetailedLevel>;
  /** Уровень населенного пункта */
  levelSettlement?: Maybe<TNestedRealestateFileRealestateRecordAddressAddressAddressFiasLevelSettlement>;
};

export type TNestedRealestateFileRealestateRecordAddressAddressAddressFiasDetailedLevel = {
  __typename?: 'NestedRealestateFileRealestateRecordAddressAddressAddressFiasDetailedLevel';
  /** Квартира */
  apartment?: Maybe<TNestedRealestateFileRealestateRecordAddressAddressAddressFiasDetailedLevelApartment>;
  /** Дом */
  level1?: Maybe<TNestedRealestateFileRealestateRecordAddressAddressAddressFiasDetailedLevelLevel1>;
  /** Корпус */
  level2?: Maybe<TNestedRealestateFileRealestateRecordAddressAddressAddressFiasDetailedLevelLevel2>;
  /** Строение */
  level3?: Maybe<TNestedRealestateFileRealestateRecordAddressAddressAddressFiasDetailedLevelLevel3>;
  /** Иное описание местоположения */
  other?: Maybe<Scalars['String']['output']>;
  /** Улица */
  street?: Maybe<TNestedRealestateFileRealestateRecordAddressAddressAddressFiasDetailedLevelStreet>;
};

export type TNestedRealestateFileRealestateRecordAddressAddressAddressFiasDetailedLevelApartment = {
  __typename?: 'NestedRealestateFileRealestateRecordAddressAddressAddressFiasDetailedLevelApartment';
  name?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

export type TNestedRealestateFileRealestateRecordAddressAddressAddressFiasDetailedLevelApartmentObjectFilterType = {
  name?: InputMaybe<TStringFilter>;
  type?: InputMaybe<TStringFilter>;
};

export type TNestedRealestateFileRealestateRecordAddressAddressAddressFiasDetailedLevelLevel1 = {
  __typename?: 'NestedRealestateFileRealestateRecordAddressAddressAddressFiasDetailedLevelLevel1';
  name?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

export type TNestedRealestateFileRealestateRecordAddressAddressAddressFiasDetailedLevelLevel1ObjectFilterType = {
  name?: InputMaybe<TStringFilter>;
  type?: InputMaybe<TStringFilter>;
};

export type TNestedRealestateFileRealestateRecordAddressAddressAddressFiasDetailedLevelLevel2 = {
  __typename?: 'NestedRealestateFileRealestateRecordAddressAddressAddressFiasDetailedLevelLevel2';
  name?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

export type TNestedRealestateFileRealestateRecordAddressAddressAddressFiasDetailedLevelLevel2ObjectFilterType = {
  name?: InputMaybe<TStringFilter>;
  type?: InputMaybe<TStringFilter>;
};

export type TNestedRealestateFileRealestateRecordAddressAddressAddressFiasDetailedLevelLevel3 = {
  __typename?: 'NestedRealestateFileRealestateRecordAddressAddressAddressFiasDetailedLevelLevel3';
  name?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

export type TNestedRealestateFileRealestateRecordAddressAddressAddressFiasDetailedLevelLevel3ObjectFilterType = {
  name?: InputMaybe<TStringFilter>;
  type?: InputMaybe<TStringFilter>;
};

export type TNestedRealestateFileRealestateRecordAddressAddressAddressFiasDetailedLevelObjectFilterType = {
  apartment?: InputMaybe<TNestedRealestateFileRealestateRecordAddressAddressAddressFiasDetailedLevelApartmentObjectFilterType>;
  level1?: InputMaybe<TNestedRealestateFileRealestateRecordAddressAddressAddressFiasDetailedLevelLevel1ObjectFilterType>;
  level2?: InputMaybe<TNestedRealestateFileRealestateRecordAddressAddressAddressFiasDetailedLevelLevel2ObjectFilterType>;
  level3?: InputMaybe<TNestedRealestateFileRealestateRecordAddressAddressAddressFiasDetailedLevelLevel3ObjectFilterType>;
  other?: InputMaybe<TStringFilter>;
  street?: InputMaybe<TNestedRealestateFileRealestateRecordAddressAddressAddressFiasDetailedLevelStreetObjectFilterType>;
};

export type TNestedRealestateFileRealestateRecordAddressAddressAddressFiasDetailedLevelStreet = {
  __typename?: 'NestedRealestateFileRealestateRecordAddressAddressAddressFiasDetailedLevelStreet';
  /** Наименование */
  name?: Maybe<Scalars['String']['output']>;
  /** Тип */
  type?: Maybe<Scalars['String']['output']>;
};

export type TNestedRealestateFileRealestateRecordAddressAddressAddressFiasDetailedLevelStreetObjectFilterType = {
  name?: InputMaybe<TStringFilter>;
  type?: InputMaybe<TStringFilter>;
};

export type TNestedRealestateFileRealestateRecordAddressAddressAddressFiasLevelSettlement = {
  __typename?: 'NestedRealestateFileRealestateRecordAddressAddressAddressFiasLevelSettlement';
  /** Муниципальное образование */
  city?: Maybe<TNestedRealestateFileRealestateRecordAddressAddressAddressFiasLevelSettlementCity>;
  /** Район */
  district?: Maybe<TNestedRealestateFileRealestateRecordAddressAddressAddressFiasLevelSettlementDistrict>;
  fias?: Maybe<Scalars['String']['output']>;
  kladr?: Maybe<Scalars['String']['output']>;
  /** Населенный пункт */
  locality?: Maybe<TNestedRealestateFileRealestateRecordAddressAddressAddressFiasLevelSettlementLocality>;
  okato?: Maybe<Scalars['String']['output']>;
  oktmo?: Maybe<Scalars['String']['output']>;
  /** Почтовый индекс */
  postalCode?: Maybe<Scalars['PostalCode']['output']>;
  /** Код региона */
  region?: Maybe<TNestedRealestateFileRealestateRecordAddressAddressAddressFiasLevelSettlementRegion>;
  /** Сельсовет */
  sovietVillage?: Maybe<TNestedRealestateFileRealestateRecordAddressAddressAddressFiasLevelSettlementSovietVillage>;
  /** Городской район */
  urbanDistrict?: Maybe<TNestedRealestateFileRealestateRecordAddressAddressAddressFiasLevelSettlementUrbanDistrict>;
};

export type TNestedRealestateFileRealestateRecordAddressAddressAddressFiasLevelSettlementCity = {
  __typename?: 'NestedRealestateFileRealestateRecordAddressAddressAddressFiasLevelSettlementCity';
  /** Наименование */
  name?: Maybe<Scalars['String']['output']>;
  /** Тип */
  type?: Maybe<Scalars['String']['output']>;
};

export type TNestedRealestateFileRealestateRecordAddressAddressAddressFiasLevelSettlementCityObjectFilterType = {
  name?: InputMaybe<TStringFilter>;
  type?: InputMaybe<TStringFilter>;
};

export type TNestedRealestateFileRealestateRecordAddressAddressAddressFiasLevelSettlementDistrict = {
  __typename?: 'NestedRealestateFileRealestateRecordAddressAddressAddressFiasLevelSettlementDistrict';
  /** Наименование */
  name?: Maybe<Scalars['String']['output']>;
  /** Тип */
  type?: Maybe<Scalars['String']['output']>;
};

export type TNestedRealestateFileRealestateRecordAddressAddressAddressFiasLevelSettlementDistrictObjectFilterType = {
  name?: InputMaybe<TStringFilter>;
  type?: InputMaybe<TStringFilter>;
};

export type TNestedRealestateFileRealestateRecordAddressAddressAddressFiasLevelSettlementLocality = {
  __typename?: 'NestedRealestateFileRealestateRecordAddressAddressAddressFiasLevelSettlementLocality';
  /** Наименование */
  name?: Maybe<Scalars['String']['output']>;
  /** Тип */
  type?: Maybe<Scalars['String']['output']>;
};

export type TNestedRealestateFileRealestateRecordAddressAddressAddressFiasLevelSettlementLocalityObjectFilterType = {
  name?: InputMaybe<TStringFilter>;
  type?: InputMaybe<TStringFilter>;
};

export type TNestedRealestateFileRealestateRecordAddressAddressAddressFiasLevelSettlementObjectFilterType = {
  city?: InputMaybe<TNestedRealestateFileRealestateRecordAddressAddressAddressFiasLevelSettlementCityObjectFilterType>;
  district?: InputMaybe<TNestedRealestateFileRealestateRecordAddressAddressAddressFiasLevelSettlementDistrictObjectFilterType>;
  fias?: InputMaybe<TStringFilter>;
  kladr?: InputMaybe<TStringFilter>;
  locality?: InputMaybe<TNestedRealestateFileRealestateRecordAddressAddressAddressFiasLevelSettlementLocalityObjectFilterType>;
  okato?: InputMaybe<TStringFilter>;
  oktmo?: InputMaybe<TStringFilter>;
  postalCode?: InputMaybe<TPostalCodeFilter>;
  region?: InputMaybe<TNestedRealestateFileRealestateRecordAddressAddressAddressFiasLevelSettlementRegionObjectFilterType>;
  sovietVillage?: InputMaybe<TNestedRealestateFileRealestateRecordAddressAddressAddressFiasLevelSettlementSovietVillageObjectFilterType>;
  urbanDistrict?: InputMaybe<TNestedRealestateFileRealestateRecordAddressAddressAddressFiasLevelSettlementUrbanDistrictObjectFilterType>;
};

export type TNestedRealestateFileRealestateRecordAddressAddressAddressFiasLevelSettlementRegion = {
  __typename?: 'NestedRealestateFileRealestateRecordAddressAddressAddressFiasLevelSettlementRegion';
  /** код из справочника */
  code?: Maybe<Scalars['NumberString']['output']>;
  /** значение */
  value?: Maybe<Scalars['String']['output']>;
};

export type TNestedRealestateFileRealestateRecordAddressAddressAddressFiasLevelSettlementRegionObjectFilterType = {
  code?: InputMaybe<TNumberStringFilter>;
  value?: InputMaybe<TStringFilter>;
};

export type TNestedRealestateFileRealestateRecordAddressAddressAddressFiasLevelSettlementSovietVillage = {
  __typename?: 'NestedRealestateFileRealestateRecordAddressAddressAddressFiasLevelSettlementSovietVillage';
  /** Наименование */
  name?: Maybe<Scalars['String']['output']>;
  /** Тип */
  type?: Maybe<Scalars['String']['output']>;
};

export type TNestedRealestateFileRealestateRecordAddressAddressAddressFiasLevelSettlementSovietVillageObjectFilterType = {
  name?: InputMaybe<TStringFilter>;
  type?: InputMaybe<TStringFilter>;
};

export type TNestedRealestateFileRealestateRecordAddressAddressAddressFiasLevelSettlementUrbanDistrict = {
  __typename?: 'NestedRealestateFileRealestateRecordAddressAddressAddressFiasLevelSettlementUrbanDistrict';
  /** Наименование */
  name?: Maybe<Scalars['String']['output']>;
  /** Тип */
  type?: Maybe<Scalars['String']['output']>;
};

export type TNestedRealestateFileRealestateRecordAddressAddressAddressFiasLevelSettlementUrbanDistrictObjectFilterType = {
  name?: InputMaybe<TStringFilter>;
  type?: InputMaybe<TStringFilter>;
};

export type TNestedRealestateFileRealestateRecordAddressAddressAddressFiasObjectFilterType = {
  detailedLevel?: InputMaybe<TNestedRealestateFileRealestateRecordAddressAddressAddressFiasDetailedLevelObjectFilterType>;
  levelSettlement?: InputMaybe<TNestedRealestateFileRealestateRecordAddressAddressAddressFiasLevelSettlementObjectFilterType>;
};

export type TNestedRealestateFileRealestateRecordAddressAddressObjectFilterType = {
  addressFias?: InputMaybe<TNestedRealestateFileRealestateRecordAddressAddressAddressFiasObjectFilterType>;
  note?: InputMaybe<TStringFilter>;
  readableAddress?: InputMaybe<TStringFilter>;
};

export type TNestedRealestateFileRealestateRecordAddressAddressType = {
  __typename?: 'NestedRealestateFileRealestateRecordAddressAddressType';
  /** код из справочника */
  code?: Maybe<Scalars['NumberString']['output']>;
  /** значение */
  value?: Maybe<Scalars['String']['output']>;
};

export type TNestedRealestateFileRealestateRecordAddressAddressTypeObjectFilterType = {
  code?: InputMaybe<TNumberStringFilter>;
  value?: InputMaybe<TStringFilter>;
};

export type TNestedRealestateFileRealestateRecordAddressLocation = {
  __typename?: 'NestedRealestateFileRealestateRecordAddressLocation';
  /** Муниципальное образование */
  city?: Maybe<TNestedRealestateFileRealestateRecordAddressLocationCity>;
  /** Район */
  district?: Maybe<TNestedRealestateFileRealestateRecordAddressLocationDistrict>;
  fias?: Maybe<Scalars['String']['output']>;
  kladr?: Maybe<Scalars['String']['output']>;
  /** Населенный пункт */
  locality?: Maybe<TNestedRealestateFileRealestateRecordAddressLocationLocality>;
  okato?: Maybe<Scalars['String']['output']>;
  oktmo?: Maybe<Scalars['String']['output']>;
  /** Почтовый индекс */
  postalCode?: Maybe<Scalars['PostalCode']['output']>;
  /** Код региона */
  region?: Maybe<TNestedRealestateFileRealestateRecordAddressLocationRegion>;
  /** Сельсовет */
  sovietVillage?: Maybe<TNestedRealestateFileRealestateRecordAddressLocationSovietVillage>;
  /** Городской район */
  urbanDistrict?: Maybe<TNestedRealestateFileRealestateRecordAddressLocationUrbanDistrict>;
};

export type TNestedRealestateFileRealestateRecordAddressLocationCity = {
  __typename?: 'NestedRealestateFileRealestateRecordAddressLocationCity';
  /** Наименование */
  name?: Maybe<Scalars['String']['output']>;
  /** Тип */
  type?: Maybe<Scalars['String']['output']>;
};

export type TNestedRealestateFileRealestateRecordAddressLocationCityObjectFilterType = {
  name?: InputMaybe<TStringFilter>;
  type?: InputMaybe<TStringFilter>;
};

export type TNestedRealestateFileRealestateRecordAddressLocationDistrict = {
  __typename?: 'NestedRealestateFileRealestateRecordAddressLocationDistrict';
  /** Наименование */
  name?: Maybe<Scalars['String']['output']>;
  /** Тип */
  type?: Maybe<Scalars['String']['output']>;
};

export type TNestedRealestateFileRealestateRecordAddressLocationDistrictObjectFilterType = {
  name?: InputMaybe<TStringFilter>;
  type?: InputMaybe<TStringFilter>;
};

export type TNestedRealestateFileRealestateRecordAddressLocationLocality = {
  __typename?: 'NestedRealestateFileRealestateRecordAddressLocationLocality';
  /** Наименование */
  name?: Maybe<Scalars['String']['output']>;
  /** Тип */
  type?: Maybe<Scalars['String']['output']>;
};

export type TNestedRealestateFileRealestateRecordAddressLocationLocalityObjectFilterType = {
  name?: InputMaybe<TStringFilter>;
  type?: InputMaybe<TStringFilter>;
};

export type TNestedRealestateFileRealestateRecordAddressLocationObjectFilterType = {
  city?: InputMaybe<TNestedRealestateFileRealestateRecordAddressLocationCityObjectFilterType>;
  district?: InputMaybe<TNestedRealestateFileRealestateRecordAddressLocationDistrictObjectFilterType>;
  fias?: InputMaybe<TStringFilter>;
  kladr?: InputMaybe<TStringFilter>;
  locality?: InputMaybe<TNestedRealestateFileRealestateRecordAddressLocationLocalityObjectFilterType>;
  okato?: InputMaybe<TStringFilter>;
  oktmo?: InputMaybe<TStringFilter>;
  postalCode?: InputMaybe<TPostalCodeFilter>;
  region?: InputMaybe<TNestedRealestateFileRealestateRecordAddressLocationRegionObjectFilterType>;
  sovietVillage?: InputMaybe<TNestedRealestateFileRealestateRecordAddressLocationSovietVillageObjectFilterType>;
  urbanDistrict?: InputMaybe<TNestedRealestateFileRealestateRecordAddressLocationUrbanDistrictObjectFilterType>;
};

export type TNestedRealestateFileRealestateRecordAddressLocationRegion = {
  __typename?: 'NestedRealestateFileRealestateRecordAddressLocationRegion';
  /** код из справочника */
  code?: Maybe<Scalars['NumberString']['output']>;
  /** значение */
  value?: Maybe<Scalars['String']['output']>;
};

export type TNestedRealestateFileRealestateRecordAddressLocationRegionObjectFilterType = {
  code?: InputMaybe<TNumberStringFilter>;
  value?: InputMaybe<TStringFilter>;
};

export type TNestedRealestateFileRealestateRecordAddressLocationSovietVillage = {
  __typename?: 'NestedRealestateFileRealestateRecordAddressLocationSovietVillage';
  /** Наименование */
  name?: Maybe<Scalars['String']['output']>;
  /** Тип */
  type?: Maybe<Scalars['String']['output']>;
};

export type TNestedRealestateFileRealestateRecordAddressLocationSovietVillageObjectFilterType = {
  name?: InputMaybe<TStringFilter>;
  type?: InputMaybe<TStringFilter>;
};

export type TNestedRealestateFileRealestateRecordAddressLocationUrbanDistrict = {
  __typename?: 'NestedRealestateFileRealestateRecordAddressLocationUrbanDistrict';
  /** Наименование */
  name?: Maybe<Scalars['String']['output']>;
  /** Тип */
  type?: Maybe<Scalars['String']['output']>;
};

export type TNestedRealestateFileRealestateRecordAddressLocationUrbanDistrictObjectFilterType = {
  name?: InputMaybe<TStringFilter>;
  type?: InputMaybe<TStringFilter>;
};

export type TNestedRealestateFileRealestateRecordAddressObjectFilterType = {
  address?: InputMaybe<TNestedRealestateFileRealestateRecordAddressAddressObjectFilterType>;
  addressType?: InputMaybe<TNestedRealestateFileRealestateRecordAddressAddressTypeObjectFilterType>;
  location?: InputMaybe<TNestedRealestateFileRealestateRecordAddressLocationObjectFilterType>;
  relPosition?: InputMaybe<TNestedRealestateFileRealestateRecordAddressRelPositionObjectFilterType>;
};

export type TNestedRealestateFileRealestateRecordAddressRelPosition = {
  __typename?: 'NestedRealestateFileRealestateRecordAddressRelPosition';
  /** Ориентир расположен в границах участка */
  inBoundariesMark?: Maybe<Scalars['Boolean']['output']>;
  /** Расположение относительно ориентира */
  locationDescription?: Maybe<Scalars['String']['output']>;
  /** Наименование ориентира */
  refPointName?: Maybe<Scalars['String']['output']>;
};

export type TNestedRealestateFileRealestateRecordAddressRelPositionObjectFilterType = {
  inBoundariesMark?: InputMaybe<TBooleanFilter>;
  locationDescription?: InputMaybe<TStringFilter>;
  refPointName?: InputMaybe<TStringFilter>;
};

export type TNestedRealestateFileRealestateRecordApartmentBuilding = {
  __typename?: 'NestedRealestateFileRealestateRecordApartmentBuilding';
  /** Основание создания наемного дома */
  basisHiredHouse?: Maybe<TNestedRealestateFileRealestateRecordApartmentBuildingBasisHiredHouse>;
  /** Назначение участка под наемный дом */
  purposeHiredHome?: Maybe<TNestedRealestateFileRealestateRecordApartmentBuildingPurposeHiredHome>;
  /** Вид использования наемного дома */
  useApartBuild?: Maybe<TNestedRealestateFileRealestateRecordApartmentBuildingUseApartBuild>;
};

export type TNestedRealestateFileRealestateRecordApartmentBuildingBasisHiredHouse = {
  __typename?: 'NestedRealestateFileRealestateRecordApartmentBuildingBasisHiredHouse';
  /** Акт о предоставлении */
  act?: Maybe<TNestedRealestateFileRealestateRecordApartmentBuildingBasisHiredHouseAct>;
  /** Договор */
  contract?: Maybe<TNestedRealestateFileRealestateRecordApartmentBuildingBasisHiredHouseContract>;
  /** Договор собственника */
  contractOwner?: Maybe<TNestedRealestateFileRealestateRecordApartmentBuildingBasisHiredHouseContractOwner>;
  /** Решение собственника */
  decisionOwner?: Maybe<TNestedRealestateFileRealestateRecordApartmentBuildingBasisHiredHouseDecisionOwner>;
};

export type TNestedRealestateFileRealestateRecordApartmentBuildingBasisHiredHouseAct = {
  __typename?: 'NestedRealestateFileRealestateRecordApartmentBuildingBasisHiredHouseAct';
  /** Код документа */
  code?: Maybe<TNestedRealestateFileRealestateRecordApartmentBuildingBasisHiredHouseActCode>;
  /** Дата документа */
  date?: Maybe<Scalars['String']['output']>;
  /** Орган власти, организация, выдавшие документ. Автор документа */
  issuer?: Maybe<Scalars['String']['output']>;
  /** Номер документа */
  number?: Maybe<Scalars['String']['output']>;
};

export type TNestedRealestateFileRealestateRecordApartmentBuildingBasisHiredHouseActCode = {
  __typename?: 'NestedRealestateFileRealestateRecordApartmentBuildingBasisHiredHouseActCode';
  /** код из справочника */
  code?: Maybe<Scalars['NumberString']['output']>;
  /** значение */
  value?: Maybe<Scalars['String']['output']>;
};

export type TNestedRealestateFileRealestateRecordApartmentBuildingBasisHiredHouseActCodeObjectFilterType = {
  code?: InputMaybe<TNumberStringFilter>;
  value?: InputMaybe<TStringFilter>;
};

export type TNestedRealestateFileRealestateRecordApartmentBuildingBasisHiredHouseActObjectFilterType = {
  code?: InputMaybe<TNestedRealestateFileRealestateRecordApartmentBuildingBasisHiredHouseActCodeObjectFilterType>;
  date?: InputMaybe<TStringFilter>;
  issuer?: InputMaybe<TStringFilter>;
  number?: InputMaybe<TStringFilter>;
};

export type TNestedRealestateFileRealestateRecordApartmentBuildingBasisHiredHouseContract = {
  __typename?: 'NestedRealestateFileRealestateRecordApartmentBuildingBasisHiredHouseContract';
  /** Код документа */
  code?: Maybe<TNestedRealestateFileRealestateRecordApartmentBuildingBasisHiredHouseContractCode>;
  /** Стороны договора */
  contractors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Дата документа */
  date?: Maybe<Scalars['String']['output']>;
  /** Орган власти, организация, выдавшие документ. Автор документа */
  issuer?: Maybe<Scalars['String']['output']>;
  /** Номер документа */
  number?: Maybe<Scalars['String']['output']>;
};


export type TNestedRealestateFileRealestateRecordApartmentBuildingBasisHiredHouseContractContractorsArgs = {
  pagination?: InputMaybe<TPagination>;
};

export type TNestedRealestateFileRealestateRecordApartmentBuildingBasisHiredHouseContractCode = {
  __typename?: 'NestedRealestateFileRealestateRecordApartmentBuildingBasisHiredHouseContractCode';
  /** код из справочника */
  code?: Maybe<Scalars['NumberString']['output']>;
  /** значение */
  value?: Maybe<Scalars['String']['output']>;
};

export type TNestedRealestateFileRealestateRecordApartmentBuildingBasisHiredHouseContractCodeObjectFilterType = {
  code?: InputMaybe<TNumberStringFilter>;
  value?: InputMaybe<TStringFilter>;
};

export type TNestedRealestateFileRealestateRecordApartmentBuildingBasisHiredHouseContractObjectFilterType = {
  code?: InputMaybe<TNestedRealestateFileRealestateRecordApartmentBuildingBasisHiredHouseContractCodeObjectFilterType>;
  contractors?: InputMaybe<TStringFilter>;
  date?: InputMaybe<TStringFilter>;
  issuer?: InputMaybe<TStringFilter>;
  number?: InputMaybe<TStringFilter>;
};

export type TNestedRealestateFileRealestateRecordApartmentBuildingBasisHiredHouseContractOwner = {
  __typename?: 'NestedRealestateFileRealestateRecordApartmentBuildingBasisHiredHouseContractOwner';
  /** Код документа */
  code?: Maybe<TNestedRealestateFileRealestateRecordApartmentBuildingBasisHiredHouseContractOwnerCode>;
  /** Стороны договора */
  contractors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Дата документа */
  date?: Maybe<Scalars['String']['output']>;
  /** Орган власти, организация, выдавшие документ. Автор документа */
  issuer?: Maybe<Scalars['String']['output']>;
  /** Номер документа */
  number?: Maybe<Scalars['String']['output']>;
};


export type TNestedRealestateFileRealestateRecordApartmentBuildingBasisHiredHouseContractOwnerContractorsArgs = {
  pagination?: InputMaybe<TPagination>;
};

export type TNestedRealestateFileRealestateRecordApartmentBuildingBasisHiredHouseContractOwnerCode = {
  __typename?: 'NestedRealestateFileRealestateRecordApartmentBuildingBasisHiredHouseContractOwnerCode';
  /** код из справочника */
  code?: Maybe<Scalars['NumberString']['output']>;
  /** значение */
  value?: Maybe<Scalars['String']['output']>;
};

export type TNestedRealestateFileRealestateRecordApartmentBuildingBasisHiredHouseContractOwnerCodeObjectFilterType = {
  code?: InputMaybe<TNumberStringFilter>;
  value?: InputMaybe<TStringFilter>;
};

export type TNestedRealestateFileRealestateRecordApartmentBuildingBasisHiredHouseContractOwnerObjectFilterType = {
  code?: InputMaybe<TNestedRealestateFileRealestateRecordApartmentBuildingBasisHiredHouseContractOwnerCodeObjectFilterType>;
  contractors?: InputMaybe<TStringFilter>;
  date?: InputMaybe<TStringFilter>;
  issuer?: InputMaybe<TStringFilter>;
  number?: InputMaybe<TStringFilter>;
};

export type TNestedRealestateFileRealestateRecordApartmentBuildingBasisHiredHouseDecisionOwner = {
  __typename?: 'NestedRealestateFileRealestateRecordApartmentBuildingBasisHiredHouseDecisionOwner';
  /** Код документа */
  code?: Maybe<TNestedRealestateFileRealestateRecordApartmentBuildingBasisHiredHouseDecisionOwnerCode>;
  /** Дата документа */
  date?: Maybe<Scalars['String']['output']>;
  /** Орган власти, организация, выдавшие документ. Автор документа */
  issuer?: Maybe<Scalars['String']['output']>;
  /** Номер документа */
  number?: Maybe<Scalars['String']['output']>;
};

export type TNestedRealestateFileRealestateRecordApartmentBuildingBasisHiredHouseDecisionOwnerCode = {
  __typename?: 'NestedRealestateFileRealestateRecordApartmentBuildingBasisHiredHouseDecisionOwnerCode';
  /** код из справочника */
  code?: Maybe<Scalars['NumberString']['output']>;
  /** значение */
  value?: Maybe<Scalars['String']['output']>;
};

export type TNestedRealestateFileRealestateRecordApartmentBuildingBasisHiredHouseDecisionOwnerCodeObjectFilterType = {
  code?: InputMaybe<TNumberStringFilter>;
  value?: InputMaybe<TStringFilter>;
};

export type TNestedRealestateFileRealestateRecordApartmentBuildingBasisHiredHouseDecisionOwnerObjectFilterType = {
  code?: InputMaybe<TNestedRealestateFileRealestateRecordApartmentBuildingBasisHiredHouseDecisionOwnerCodeObjectFilterType>;
  date?: InputMaybe<TStringFilter>;
  issuer?: InputMaybe<TStringFilter>;
  number?: InputMaybe<TStringFilter>;
};

export type TNestedRealestateFileRealestateRecordApartmentBuildingBasisHiredHouseObjectFilterType = {
  act?: InputMaybe<TNestedRealestateFileRealestateRecordApartmentBuildingBasisHiredHouseActObjectFilterType>;
  contract?: InputMaybe<TNestedRealestateFileRealestateRecordApartmentBuildingBasisHiredHouseContractObjectFilterType>;
  contractOwner?: InputMaybe<TNestedRealestateFileRealestateRecordApartmentBuildingBasisHiredHouseContractOwnerObjectFilterType>;
  decisionOwner?: InputMaybe<TNestedRealestateFileRealestateRecordApartmentBuildingBasisHiredHouseDecisionOwnerObjectFilterType>;
};

export type TNestedRealestateFileRealestateRecordApartmentBuildingObjectFilterType = {
  basisHiredHouse?: InputMaybe<TNestedRealestateFileRealestateRecordApartmentBuildingBasisHiredHouseObjectFilterType>;
  purposeHiredHome?: InputMaybe<TNestedRealestateFileRealestateRecordApartmentBuildingPurposeHiredHomeObjectFilterType>;
  useApartBuild?: InputMaybe<TNestedRealestateFileRealestateRecordApartmentBuildingUseApartBuildObjectFilterType>;
};

export type TNestedRealestateFileRealestateRecordApartmentBuildingPurposeHiredHome = {
  __typename?: 'NestedRealestateFileRealestateRecordApartmentBuildingPurposeHiredHome';
  /** код из справочника */
  code?: Maybe<Scalars['NumberString']['output']>;
  /** значение */
  value?: Maybe<Scalars['String']['output']>;
};

export type TNestedRealestateFileRealestateRecordApartmentBuildingPurposeHiredHomeObjectFilterType = {
  code?: InputMaybe<TNumberStringFilter>;
  value?: InputMaybe<TStringFilter>;
};

export type TNestedRealestateFileRealestateRecordApartmentBuildingUseApartBuild = {
  __typename?: 'NestedRealestateFileRealestateRecordApartmentBuildingUseApartBuild';
  /** код из справочника */
  code?: Maybe<Scalars['NumberString']['output']>;
  /** значение */
  value?: Maybe<Scalars['String']['output']>;
};

export type TNestedRealestateFileRealestateRecordApartmentBuildingUseApartBuildObjectFilterType = {
  code?: InputMaybe<TNumberStringFilter>;
  value?: InputMaybe<TStringFilter>;
};

export type TNestedRealestateFileRealestateRecordCadLinks = {
  __typename?: 'NestedRealestateFileRealestateRecordCadLinks';
  /** Кадастровые номера земельных участков, из которых образован данный земельный участок */
  ascendantCadNumbers?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Кадастровые номера машиномест, расположенных в объекте недвижимости */
  carParkingSpaceCadNumbers?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Единое землепользование */
  commonLand?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Кадастровые номера земельных участков, образованных из данного земельного участка */
  descendantCadNumbers?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Кадастровый номер предприятия как имущественного комплекса, в состав которого входит земельный участок */
  facilityCadNumber?: Maybe<Scalars['String']['output']>;
  /** Кадастровые номера объектов недвижимости, входящих в состав единого недвижимого комплекса */
  includedCadNumbers?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Кадастровые номера расположенных в пределах земельного участка объектов недвижимости */
  includedObjects?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Кадастровые номера иных объектов недвижимости (земельных участков), в пределах которых расположен объект недвижимости */
  landCadNumbers?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Ранее присвоенные номера */
  oldNumbers?: Maybe<Array<Maybe<TNestedRealestateFileRealestateRecordCadLinksOldNumbers>>>;
  parentCadNumber?: Maybe<Scalars['String']['output']>;
  /** Кадастровые номера помещений, расположенных в объекте недвижимости */
  roomCadNumbers?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};


export type TNestedRealestateFileRealestateRecordCadLinksAscendantCadNumbersArgs = {
  pagination?: InputMaybe<TPagination>;
};


export type TNestedRealestateFileRealestateRecordCadLinksCarParkingSpaceCadNumbersArgs = {
  pagination?: InputMaybe<TPagination>;
};


export type TNestedRealestateFileRealestateRecordCadLinksCommonLandArgs = {
  pagination?: InputMaybe<TPagination>;
};


export type TNestedRealestateFileRealestateRecordCadLinksDescendantCadNumbersArgs = {
  pagination?: InputMaybe<TPagination>;
};


export type TNestedRealestateFileRealestateRecordCadLinksIncludedCadNumbersArgs = {
  pagination?: InputMaybe<TPagination>;
};


export type TNestedRealestateFileRealestateRecordCadLinksIncludedObjectsArgs = {
  pagination?: InputMaybe<TPagination>;
};


export type TNestedRealestateFileRealestateRecordCadLinksLandCadNumbersArgs = {
  pagination?: InputMaybe<TPagination>;
};


export type TNestedRealestateFileRealestateRecordCadLinksOldNumbersArgs = {
  pagination?: InputMaybe<TPagination>;
};


export type TNestedRealestateFileRealestateRecordCadLinksRoomCadNumbersArgs = {
  pagination?: InputMaybe<TPagination>;
};

export type TNestedRealestateFileRealestateRecordCadLinksObjectFilterType = {
  ascendantCadNumbers?: InputMaybe<TStringFilter>;
  carParkingSpaceCadNumbers?: InputMaybe<TStringFilter>;
  commonLand?: InputMaybe<TStringFilter>;
  descendantCadNumbers?: InputMaybe<TStringFilter>;
  facilityCadNumber?: InputMaybe<TStringFilter>;
  includedCadNumbers?: InputMaybe<TStringFilter>;
  includedObjects?: InputMaybe<TStringFilter>;
  landCadNumbers?: InputMaybe<TStringFilter>;
  oldNumbers?: InputMaybe<TNestedRealestateFileRealestateRecordCadLinksOldNumbersObjectFilterType>;
  parentCadNumber?: InputMaybe<TStringFilter>;
  roomCadNumbers?: InputMaybe<TStringFilter>;
};

export type TNestedRealestateFileRealestateRecordCadLinksOldNumbers = {
  __typename?: 'NestedRealestateFileRealestateRecordCadLinksOldNumbers';
  /** Организация, присвоившая номер */
  assigner?: Maybe<Scalars['String']['output']>;
  /** Дата присвоения */
  assignmentDate?: Maybe<Scalars['String']['output']>;
  /** Номер */
  number?: Maybe<Scalars['String']['output']>;
  /** Вид номера */
  numberType?: Maybe<TNestedRealestateFileRealestateRecordCadLinksOldNumbersNumberType>;
};

export type TNestedRealestateFileRealestateRecordCadLinksOldNumbersNumberType = {
  __typename?: 'NestedRealestateFileRealestateRecordCadLinksOldNumbersNumberType';
  /** код из справочника */
  code?: Maybe<Scalars['NumberString']['output']>;
  /** значение */
  value?: Maybe<Scalars['String']['output']>;
};

export type TNestedRealestateFileRealestateRecordCadLinksOldNumbersNumberTypeObjectFilterType = {
  code?: InputMaybe<TNumberStringFilter>;
  value?: InputMaybe<TStringFilter>;
};

export type TNestedRealestateFileRealestateRecordCadLinksOldNumbersObjectFilterType = {
  assigner?: InputMaybe<TStringFilter>;
  assignmentDate?: InputMaybe<TStringFilter>;
  number?: InputMaybe<TStringFilter>;
  numberType?: InputMaybe<TNestedRealestateFileRealestateRecordCadLinksOldNumbersNumberTypeObjectFilterType>;
};

export type TNestedRealestateFileRealestateRecordCadWorks = {
  __typename?: 'NestedRealestateFileRealestateRecordCadWorks';
  /** Номер заключения договора на выполнение кадастровых работ */
  cadastralEngineerAgreement?: Maybe<Scalars['String']['output']>;
  /** Дата заключения договора на выполнение кадастровых работ */
  cadastralEngineerDate?: Maybe<Scalars['String']['output']>;
  /** Номер регистрации в государственном реестре лиц, осуществляющих кадастровую деятельность */
  cadastralEngineerRegistryNumber?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  middleName?: Maybe<Scalars['String']['output']>;
  /** Вид выполненных кадастровых работ */
  workType?: Maybe<Scalars['String']['output']>;
};

export type TNestedRealestateFileRealestateRecordCadWorksObjectFilterType = {
  cadastralEngineerAgreement?: InputMaybe<TStringFilter>;
  cadastralEngineerDate?: InputMaybe<TStringFilter>;
  cadastralEngineerRegistryNumber?: InputMaybe<TStringFilter>;
  firstName?: InputMaybe<TStringFilter>;
  lastName?: InputMaybe<TStringFilter>;
  middleName?: InputMaybe<TStringFilter>;
  workType?: InputMaybe<TStringFilter>;
};

export type TNestedRealestateFileRealestateRecordContours = {
  __typename?: 'NestedRealestateFileRealestateRecordContours';
  /** Описание элементов контура (характерных точек контура) */
  entitySpatial?: Maybe<TNestedRealestateFileRealestateRecordContoursEntitySpatial>;
  /** Номер контура */
  numberPp?: Maybe<Scalars['Int']['output']>;
};

export type TNestedRealestateFileRealestateRecordContoursEntitySpatial = {
  __typename?: 'NestedRealestateFileRealestateRecordContoursEntitySpatial';
  /** Система координат */
  skId?: Maybe<Scalars['String']['output']>;
  /** Элементы контура */
  spatialsElements?: Maybe<Array<Maybe<TNestedRealestateFileRealestateRecordContoursEntitySpatialSpatialsElements>>>;
};


export type TNestedRealestateFileRealestateRecordContoursEntitySpatialSpatialsElementsArgs = {
  pagination?: InputMaybe<TPagination>;
};

export type TNestedRealestateFileRealestateRecordContoursEntitySpatialObjectFilterType = {
  skId?: InputMaybe<TStringFilter>;
  spatialsElements?: InputMaybe<TNestedRealestateFileRealestateRecordContoursEntitySpatialSpatialsElementsObjectFilterType>;
};

export type TNestedRealestateFileRealestateRecordContoursEntitySpatialSpatialsElements = {
  __typename?: 'NestedRealestateFileRealestateRecordContoursEntitySpatialSpatialsElements';
  /** Тип контура */
  levelContour?: Maybe<TNestedRealestateFileRealestateRecordContoursEntitySpatialSpatialsElementsLevelContour>;
  /** Список координат */
  ordinates?: Maybe<Array<Maybe<TNestedRealestateFileRealestateRecordContoursEntitySpatialSpatialsElementsOrdinates>>>;
};


export type TNestedRealestateFileRealestateRecordContoursEntitySpatialSpatialsElementsOrdinatesArgs = {
  pagination?: InputMaybe<TPagination>;
};

export type TNestedRealestateFileRealestateRecordContoursEntitySpatialSpatialsElementsLevelContour = {
  __typename?: 'NestedRealestateFileRealestateRecordContoursEntitySpatialSpatialsElementsLevelContour';
  /** код из справочника */
  code?: Maybe<Scalars['NumberString']['output']>;
  /** значение */
  value?: Maybe<Scalars['String']['output']>;
};

export type TNestedRealestateFileRealestateRecordContoursEntitySpatialSpatialsElementsLevelContourObjectFilterType = {
  code?: InputMaybe<TNumberStringFilter>;
  value?: InputMaybe<TStringFilter>;
};

export type TNestedRealestateFileRealestateRecordContoursEntitySpatialSpatialsElementsObjectFilterType = {
  levelContour?: InputMaybe<TNestedRealestateFileRealestateRecordContoursEntitySpatialSpatialsElementsLevelContourObjectFilterType>;
  ordinates?: InputMaybe<TNestedRealestateFileRealestateRecordContoursEntitySpatialSpatialsElementsOrdinatesObjectFilterType>;
};

export type TNestedRealestateFileRealestateRecordContoursEntitySpatialSpatialsElementsOrdinates = {
  __typename?: 'NestedRealestateFileRealestateRecordContoursEntitySpatialSpatialsElementsOrdinates';
  /** Погрешность */
  deltaGeopoint?: Maybe<Scalars['Int']['output']>;
  /** Номер точки */
  numGeopoint?: Maybe<Scalars['String']['output']>;
  /** Номер точки (порядок обхода) */
  ordNmb?: Maybe<Scalars['Int']['output']>;
  /** Радиус */
  r?: Maybe<Scalars['Int']['output']>;
  /** Координата X */
  x?: Maybe<Scalars['Int']['output']>;
  /** Координата Y */
  y?: Maybe<Scalars['Int']['output']>;
  /** Координата Z */
  z?: Maybe<Scalars['Int']['output']>;
};

export type TNestedRealestateFileRealestateRecordContoursEntitySpatialSpatialsElementsOrdinatesObjectFilterType = {
  deltaGeopoint?: InputMaybe<TIntFilter>;
  numGeopoint?: InputMaybe<TStringFilter>;
  ordNmb?: InputMaybe<TIntFilter>;
  r?: InputMaybe<TIntFilter>;
  x?: InputMaybe<TIntFilter>;
  y?: InputMaybe<TIntFilter>;
  z?: InputMaybe<TIntFilter>;
};

export type TNestedRealestateFileRealestateRecordContoursLocation = {
  __typename?: 'NestedRealestateFileRealestateRecordContoursLocation';
  /** Описание границ земельного участка (от точки до точки) и наличие земельного спора */
  borders?: Maybe<Array<Maybe<TNestedRealestateFileRealestateRecordContoursLocationBorders>>>;
  /** Контуры границы */
  contours?: Maybe<Array<Maybe<TNestedRealestateFileRealestateRecordContoursLocationContours>>>;
};


export type TNestedRealestateFileRealestateRecordContoursLocationBordersArgs = {
  pagination?: InputMaybe<TPagination>;
};


export type TNestedRealestateFileRealestateRecordContoursLocationContoursArgs = {
  pagination?: InputMaybe<TPagination>;
};

export type TNestedRealestateFileRealestateRecordContoursLocationBorders = {
  __typename?: 'NestedRealestateFileRealestateRecordContoursLocationBorders';
  /** Часть границы (от точки до точки) по описанию */
  byDefinition?: Maybe<Array<Maybe<TNestedRealestateFileRealestateRecordContoursLocationBordersByDefinition>>>;
  /** Кадастровые номера смежных участков */
  cadastralNumbsAdjacentParcels?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Дирекционный угол */
  directionAngle?: Maybe<Scalars['String']['output']>;
  /** Описание закрепления на местности */
  geopointZacrep?: Maybe<Scalars['String']['output']>;
  /** Адреса правообладателей смежных земельных участков */
  holdersRelatedLands?: Maybe<Array<Maybe<TNestedRealestateFileRealestateRecordContoursLocationBordersHoldersRelatedLands>>>;
  /** Горизонтальное положение */
  horizontalDistance?: Maybe<Scalars['String']['output']>;
  /** Земельный спор */
  landDisput?: Maybe<TNestedRealestateFileRealestateRecordContoursLocationBordersLandDisput>;
};


export type TNestedRealestateFileRealestateRecordContoursLocationBordersByDefinitionArgs = {
  pagination?: InputMaybe<TPagination>;
};


export type TNestedRealestateFileRealestateRecordContoursLocationBordersCadastralNumbsAdjacentParcelsArgs = {
  pagination?: InputMaybe<TPagination>;
};


export type TNestedRealestateFileRealestateRecordContoursLocationBordersHoldersRelatedLandsArgs = {
  pagination?: InputMaybe<TPagination>;
};

export type TNestedRealestateFileRealestateRecordContoursLocationBordersByDefinition = {
  __typename?: 'NestedRealestateFileRealestateRecordContoursLocationBordersByDefinition';
  /** Описание границы */
  definition?: Maybe<Scalars['String']['output']>;
  /** Номер контура */
  nmbContour?: Maybe<Scalars['String']['output']>;
  /** Порядковый номер точки1 в элементе */
  point1?: Maybe<Scalars['Int']['output']>;
  /** Порядковый номер точки2 в элементе */
  point2?: Maybe<Scalars['Int']['output']>;
  /** Порядковый номер элемента контура */
  spatialElement?: Maybe<Scalars['String']['output']>;
};

export type TNestedRealestateFileRealestateRecordContoursLocationBordersByDefinitionObjectFilterType = {
  definition?: InputMaybe<TStringFilter>;
  nmbContour?: InputMaybe<TStringFilter>;
  point1?: InputMaybe<TIntFilter>;
  point2?: InputMaybe<TIntFilter>;
  spatialElement?: InputMaybe<TStringFilter>;
};

export type TNestedRealestateFileRealestateRecordContoursLocationBordersHoldersRelatedLands = {
  __typename?: 'NestedRealestateFileRealestateRecordContoursLocationBordersHoldersRelatedLands';
  email?: Maybe<Scalars['String']['output']>;
  /** ! Возможно в документации ошибка: mailing_addess */
  mailingAddress?: Maybe<Scalars['String']['output']>;
};

export type TNestedRealestateFileRealestateRecordContoursLocationBordersHoldersRelatedLandsObjectFilterType = {
  email?: InputMaybe<TStringFilter>;
  mailingAddress?: InputMaybe<TStringFilter>;
};

export type TNestedRealestateFileRealestateRecordContoursLocationBordersLandDisput = {
  __typename?: 'NestedRealestateFileRealestateRecordContoursLocationBordersLandDisput';
  /** Реквизиты акта об утверждении карты-плана территории */
  approovalActRequisites?: Maybe<TNestedRealestateFileRealestateRecordContoursLocationBordersLandDisputApproovalActRequisites>;
  /** Дата окончания контрольного срока действия отметки о наличии земельного спора */
  disputeCancelDate?: Maybe<Scalars['String']['output']>;
  /** Учетный номер контура */
  numberContour?: Maybe<Scalars['String']['output']>;
};

export type TNestedRealestateFileRealestateRecordContoursLocationBordersLandDisputApproovalActRequisites = {
  __typename?: 'NestedRealestateFileRealestateRecordContoursLocationBordersLandDisputApproovalActRequisites';
  /** Код документа */
  code?: Maybe<TNestedRealestateFileRealestateRecordContoursLocationBordersLandDisputApproovalActRequisitesCode>;
  /** Дата документа */
  date?: Maybe<Scalars['String']['output']>;
  /** Орган власти, организация, выдавшие документ. Автор документа */
  issuer?: Maybe<Scalars['String']['output']>;
  /** Номер документа */
  number?: Maybe<Scalars['String']['output']>;
};

export type TNestedRealestateFileRealestateRecordContoursLocationBordersLandDisputApproovalActRequisitesCode = {
  __typename?: 'NestedRealestateFileRealestateRecordContoursLocationBordersLandDisputApproovalActRequisitesCode';
  /** код из справочника */
  code?: Maybe<Scalars['NumberString']['output']>;
  /** значение */
  value?: Maybe<Scalars['String']['output']>;
};

export type TNestedRealestateFileRealestateRecordContoursLocationBordersLandDisputApproovalActRequisitesCodeObjectFilterType = {
  code?: InputMaybe<TNumberStringFilter>;
  value?: InputMaybe<TStringFilter>;
};

export type TNestedRealestateFileRealestateRecordContoursLocationBordersLandDisputApproovalActRequisitesObjectFilterType = {
  code?: InputMaybe<TNestedRealestateFileRealestateRecordContoursLocationBordersLandDisputApproovalActRequisitesCodeObjectFilterType>;
  date?: InputMaybe<TStringFilter>;
  issuer?: InputMaybe<TStringFilter>;
  number?: InputMaybe<TStringFilter>;
};

export type TNestedRealestateFileRealestateRecordContoursLocationBordersLandDisputObjectFilterType = {
  approovalActRequisites?: InputMaybe<TNestedRealestateFileRealestateRecordContoursLocationBordersLandDisputApproovalActRequisitesObjectFilterType>;
  disputeCancelDate?: InputMaybe<TStringFilter>;
  numberContour?: InputMaybe<TStringFilter>;
};

export type TNestedRealestateFileRealestateRecordContoursLocationBordersObjectFilterType = {
  byDefinition?: InputMaybe<TNestedRealestateFileRealestateRecordContoursLocationBordersByDefinitionObjectFilterType>;
  cadastralNumbsAdjacentParcels?: InputMaybe<TStringFilter>;
  directionAngle?: InputMaybe<TStringFilter>;
  geopointZacrep?: InputMaybe<TStringFilter>;
  holdersRelatedLands?: InputMaybe<TNestedRealestateFileRealestateRecordContoursLocationBordersHoldersRelatedLandsObjectFilterType>;
  horizontalDistance?: InputMaybe<TStringFilter>;
  landDisput?: InputMaybe<TNestedRealestateFileRealestateRecordContoursLocationBordersLandDisputObjectFilterType>;
};

export type TNestedRealestateFileRealestateRecordContoursLocationContours = {
  __typename?: 'NestedRealestateFileRealestateRecordContoursLocationContours';
  /** Площадь контура в квадратных метрах */
  area?: Maybe<Scalars['Float']['output']>;
  /** Кадастровый номер участка, входящего в состав единого землепользования */
  cadNumber?: Maybe<Scalars['String']['output']>;
  /** Описание элементов контура (характерных точек контура) */
  entitySpatial?: Maybe<TNestedRealestateFileRealestateRecordContoursLocationContoursEntitySpatial>;
  /** Номер контура */
  numberPp?: Maybe<Scalars['Int']['output']>;
};

export type TNestedRealestateFileRealestateRecordContoursLocationContoursEntitySpatial = {
  __typename?: 'NestedRealestateFileRealestateRecordContoursLocationContoursEntitySpatial';
  /** Система координат */
  skId?: Maybe<Scalars['String']['output']>;
  /** Координаты */
  spatialsElements?: Maybe<Array<Maybe<TNestedRealestateFileRealestateRecordContoursLocationContoursEntitySpatialSpatialsElements>>>;
};


export type TNestedRealestateFileRealestateRecordContoursLocationContoursEntitySpatialSpatialsElementsArgs = {
  pagination?: InputMaybe<TPagination>;
};

export type TNestedRealestateFileRealestateRecordContoursLocationContoursEntitySpatialObjectFilterType = {
  skId?: InputMaybe<TStringFilter>;
  spatialsElements?: InputMaybe<TNestedRealestateFileRealestateRecordContoursLocationContoursEntitySpatialSpatialsElementsObjectFilterType>;
};

export type TNestedRealestateFileRealestateRecordContoursLocationContoursEntitySpatialSpatialsElements = {
  __typename?: 'NestedRealestateFileRealestateRecordContoursLocationContoursEntitySpatialSpatialsElements';
  /** Погрешность */
  deltaGeopoint?: Maybe<Scalars['Int']['output']>;
  /** Описание закрепления точки */
  geopointZacrep?: Maybe<Scalars['String']['output']>;
  /** Номер межевой точки */
  numGeopoint?: Maybe<Scalars['String']['output']>;
  /** Номер точки (порядок обхода) */
  ordNmb?: Maybe<Scalars['Int']['output']>;
  /** Координата X */
  x?: Maybe<Scalars['Int']['output']>;
  /** Координата Y */
  y?: Maybe<Scalars['Int']['output']>;
  /** Координата Z */
  z?: Maybe<Scalars['Int']['output']>;
};

export type TNestedRealestateFileRealestateRecordContoursLocationContoursEntitySpatialSpatialsElementsObjectFilterType = {
  deltaGeopoint?: InputMaybe<TIntFilter>;
  geopointZacrep?: InputMaybe<TStringFilter>;
  numGeopoint?: InputMaybe<TStringFilter>;
  ordNmb?: InputMaybe<TIntFilter>;
  x?: InputMaybe<TIntFilter>;
  y?: InputMaybe<TIntFilter>;
  z?: InputMaybe<TIntFilter>;
};

export type TNestedRealestateFileRealestateRecordContoursLocationContoursObjectFilterType = {
  area?: InputMaybe<TFloatFilter>;
  cadNumber?: InputMaybe<TStringFilter>;
  entitySpatial?: InputMaybe<TNestedRealestateFileRealestateRecordContoursLocationContoursEntitySpatialObjectFilterType>;
  numberPp?: InputMaybe<TIntFilter>;
};

export type TNestedRealestateFileRealestateRecordContoursLocationObjectFilterType = {
  borders?: InputMaybe<TNestedRealestateFileRealestateRecordContoursLocationBordersObjectFilterType>;
  contours?: InputMaybe<TNestedRealestateFileRealestateRecordContoursLocationContoursObjectFilterType>;
};

export type TNestedRealestateFileRealestateRecordContoursObjectFilterType = {
  entitySpatial?: InputMaybe<TNestedRealestateFileRealestateRecordContoursEntitySpatialObjectFilterType>;
  numberPp?: InputMaybe<TIntFilter>;
};

export type TNestedRealestateFileRealestateRecordCulturalHeritage = {
  __typename?: 'NestedRealestateFileRealestateRecordCulturalHeritage';
  /** Реквизиты решений */
  heritageDecisions?: Maybe<Array<Maybe<TNestedRealestateFileRealestateRecordCulturalHeritageHeritageDecisions>>>;
  /** Включен в реестр объектов культурного наследия или является выявленным объектом */
  included?: Maybe<Scalars['Boolean']['output']>;
  /** Вид объекта */
  kind?: Maybe<TNestedRealestateFileRealestateRecordCulturalHeritageKind>;
  /** Наименование объекта */
  name?: Maybe<Scalars['String']['output']>;
  /** Регистрационный номер (регистрационный номер учетной карты) */
  regNumber?: Maybe<Scalars['String']['output']>;
};


export type TNestedRealestateFileRealestateRecordCulturalHeritageHeritageDecisionsArgs = {
  pagination?: InputMaybe<TPagination>;
};

export type TNestedRealestateFileRealestateRecordCulturalHeritageHeritageDecisions = {
  __typename?: 'NestedRealestateFileRealestateRecordCulturalHeritageHeritageDecisions';
  /** Дата документа */
  date?: Maybe<Scalars['String']['output']>;
  /** Номер документа */
  number?: Maybe<Scalars['String']['output']>;
};

export type TNestedRealestateFileRealestateRecordCulturalHeritageHeritageDecisionsObjectFilterType = {
  date?: InputMaybe<TStringFilter>;
  number?: InputMaybe<TStringFilter>;
};

export type TNestedRealestateFileRealestateRecordCulturalHeritageKind = {
  __typename?: 'NestedRealestateFileRealestateRecordCulturalHeritageKind';
  /** код из справочника */
  code?: Maybe<Scalars['NumberString']['output']>;
  /** значение */
  value?: Maybe<Scalars['String']['output']>;
};

export type TNestedRealestateFileRealestateRecordCulturalHeritageKindObjectFilterType = {
  code?: InputMaybe<TNumberStringFilter>;
  value?: InputMaybe<TStringFilter>;
};

export type TNestedRealestateFileRealestateRecordCulturalHeritageObjectFilterType = {
  heritageDecisions?: InputMaybe<TNestedRealestateFileRealestateRecordCulturalHeritageHeritageDecisionsObjectFilterType>;
  included?: InputMaybe<TBooleanFilter>;
  kind?: InputMaybe<TNestedRealestateFileRealestateRecordCulturalHeritageKindObjectFilterType>;
  name?: InputMaybe<TStringFilter>;
  regNumber?: InputMaybe<TStringFilter>;
};

export type TNestedRealestateFileRealestateRecordGovernmentLandSupervision = {
  __typename?: 'NestedRealestateFileRealestateRecordGovernmentLandSupervision';
  /** Наименование органа, проводившего мероприятие по государственному земельному надзору */
  agency?: Maybe<Scalars['String']['output']>;
  /** Реквизиты оформленных документов */
  docRequisites?: Maybe<Array<Maybe<TNestedRealestateFileRealestateRecordGovernmentLandSupervisionDocRequisites>>>;
  /** Сведения об устранении выявленного нарушения */
  elimination?: Maybe<TNestedRealestateFileRealestateRecordGovernmentLandSupervisionElimination>;
  /** Реквизиты документа, содержащего сведения об устранении правонарушения */
  eliminationDocRequisites?: Maybe<TNestedRealestateFileRealestateRecordGovernmentLandSupervisionEliminationDocRequisites>;
  /** Форма проведения плановой или внеплановой проверки */
  eventForm?: Maybe<TNestedRealestateFileRealestateRecordGovernmentLandSupervisionEventForm>;
  /** Мероприятие государственного земельного надзора по соблюдению требований законодательства (плановая, внеплановая проверка, административное обследование) */
  eventName?: Maybe<TNestedRealestateFileRealestateRecordGovernmentLandSupervisionEventName>;
  /** Дата окончания проверки */
  inspectionEnd?: Maybe<Scalars['String']['output']>;
  /** Результаты проведенного мероприятия */
  resultsEvent?: Maybe<TNestedRealestateFileRealestateRecordGovernmentLandSupervisionResultsEvent>;
};


export type TNestedRealestateFileRealestateRecordGovernmentLandSupervisionDocRequisitesArgs = {
  pagination?: InputMaybe<TPagination>;
};

export type TNestedRealestateFileRealestateRecordGovernmentLandSupervisionDocRequisites = {
  __typename?: 'NestedRealestateFileRealestateRecordGovernmentLandSupervisionDocRequisites';
  /** Дата документа */
  date?: Maybe<Scalars['String']['output']>;
  /** Номер документа */
  number?: Maybe<Scalars['String']['output']>;
};

export type TNestedRealestateFileRealestateRecordGovernmentLandSupervisionDocRequisitesObjectFilterType = {
  date?: InputMaybe<TStringFilter>;
  number?: InputMaybe<TStringFilter>;
};

export type TNestedRealestateFileRealestateRecordGovernmentLandSupervisionElimination = {
  __typename?: 'NestedRealestateFileRealestateRecordGovernmentLandSupervisionElimination';
  /** Наименование органа, принявшего решение об устранении правонарушения */
  agency?: Maybe<Scalars['String']['output']>;
  /** Отметка об устранении выявленного нарушения: устранено */
  mark?: Maybe<Scalars['Boolean']['output']>;
};

export type TNestedRealestateFileRealestateRecordGovernmentLandSupervisionEliminationDocRequisites = {
  __typename?: 'NestedRealestateFileRealestateRecordGovernmentLandSupervisionEliminationDocRequisites';
  /** Дата документа */
  date?: Maybe<Scalars['String']['output']>;
  /** Номер документа */
  number?: Maybe<Scalars['String']['output']>;
};

export type TNestedRealestateFileRealestateRecordGovernmentLandSupervisionEliminationDocRequisitesObjectFilterType = {
  date?: InputMaybe<TStringFilter>;
  number?: InputMaybe<TStringFilter>;
};

export type TNestedRealestateFileRealestateRecordGovernmentLandSupervisionEliminationObjectFilterType = {
  agency?: InputMaybe<TStringFilter>;
  mark?: InputMaybe<TBooleanFilter>;
};

export type TNestedRealestateFileRealestateRecordGovernmentLandSupervisionEventForm = {
  __typename?: 'NestedRealestateFileRealestateRecordGovernmentLandSupervisionEventForm';
  /** код из справочника */
  code?: Maybe<Scalars['NumberString']['output']>;
  /** значение */
  value?: Maybe<Scalars['String']['output']>;
};

export type TNestedRealestateFileRealestateRecordGovernmentLandSupervisionEventFormObjectFilterType = {
  code?: InputMaybe<TNumberStringFilter>;
  value?: InputMaybe<TStringFilter>;
};

export type TNestedRealestateFileRealestateRecordGovernmentLandSupervisionEventName = {
  __typename?: 'NestedRealestateFileRealestateRecordGovernmentLandSupervisionEventName';
  /** код из справочника */
  code?: Maybe<Scalars['NumberString']['output']>;
  /** значение */
  value?: Maybe<Scalars['String']['output']>;
};

export type TNestedRealestateFileRealestateRecordGovernmentLandSupervisionEventNameObjectFilterType = {
  code?: InputMaybe<TNumberStringFilter>;
  value?: InputMaybe<TStringFilter>;
};

export type TNestedRealestateFileRealestateRecordGovernmentLandSupervisionObjectFilterType = {
  agency?: InputMaybe<TStringFilter>;
  docRequisites?: InputMaybe<TNestedRealestateFileRealestateRecordGovernmentLandSupervisionDocRequisitesObjectFilterType>;
  elimination?: InputMaybe<TNestedRealestateFileRealestateRecordGovernmentLandSupervisionEliminationObjectFilterType>;
  eliminationDocRequisites?: InputMaybe<TNestedRealestateFileRealestateRecordGovernmentLandSupervisionEliminationDocRequisitesObjectFilterType>;
  eventForm?: InputMaybe<TNestedRealestateFileRealestateRecordGovernmentLandSupervisionEventFormObjectFilterType>;
  eventName?: InputMaybe<TNestedRealestateFileRealestateRecordGovernmentLandSupervisionEventNameObjectFilterType>;
  inspectionEnd?: InputMaybe<TStringFilter>;
  resultsEvent?: InputMaybe<TNestedRealestateFileRealestateRecordGovernmentLandSupervisionResultsEventObjectFilterType>;
};

export type TNestedRealestateFileRealestateRecordGovernmentLandSupervisionResultsEvent = {
  __typename?: 'NestedRealestateFileRealestateRecordGovernmentLandSupervisionResultsEvent';
  /** Наличие правонарушения */
  availabilityViolations?: Maybe<Scalars['Boolean']['output']>;
  /** Выявленные правонарушения */
  identifiedViolations?: Maybe<TNestedRealestateFileRealestateRecordGovernmentLandSupervisionResultsEventIdentifiedViolations>;
};

export type TNestedRealestateFileRealestateRecordGovernmentLandSupervisionResultsEventIdentifiedViolations = {
  __typename?: 'NestedRealestateFileRealestateRecordGovernmentLandSupervisionResultsEventIdentifiedViolations';
  /** Площадь */
  area?: Maybe<Scalars['Float']['output']>;
  /** Признаки выявленного правонарушения */
  sign?: Maybe<Scalars['String']['output']>;
  /** Вид выявленного правонарушения */
  type?: Maybe<Scalars['String']['output']>;
};

export type TNestedRealestateFileRealestateRecordGovernmentLandSupervisionResultsEventIdentifiedViolationsObjectFilterType = {
  area?: InputMaybe<TFloatFilter>;
  sign?: InputMaybe<TStringFilter>;
  type?: InputMaybe<TStringFilter>;
};

export type TNestedRealestateFileRealestateRecordGovernmentLandSupervisionResultsEventObjectFilterType = {
  availabilityViolations?: InputMaybe<TBooleanFilter>;
  identifiedViolations?: InputMaybe<TNestedRealestateFileRealestateRecordGovernmentLandSupervisionResultsEventIdentifiedViolationsObjectFilterType>;
};

export type TNestedRealestateFileRealestateRecordLocationInBuild = {
  __typename?: 'NestedRealestateFileRealestateRecordLocationInBuild';
  /** Описание расположения */
  description?: Maybe<Scalars['String']['output']>;
  /** Номер этажа */
  floor?: Maybe<Scalars['Int']['output']>;
  /** Тип этажа */
  floorType?: Maybe<TNestedRealestateFileRealestateRecordLocationInBuildFloorType>;
  /** Номер на поэтажном плане */
  planNumber?: Maybe<Scalars['String']['output']>;
  /** Планы */
  plans?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};


export type TNestedRealestateFileRealestateRecordLocationInBuildPlansArgs = {
  pagination?: InputMaybe<TPagination>;
};

export type TNestedRealestateFileRealestateRecordLocationInBuildFloorType = {
  __typename?: 'NestedRealestateFileRealestateRecordLocationInBuildFloorType';
  /** код из справочника */
  code?: Maybe<Scalars['NumberString']['output']>;
  /** значение */
  value?: Maybe<Scalars['String']['output']>;
};

export type TNestedRealestateFileRealestateRecordLocationInBuildFloorTypeObjectFilterType = {
  code?: InputMaybe<TNumberStringFilter>;
  value?: InputMaybe<TStringFilter>;
};

export type TNestedRealestateFileRealestateRecordLocationInBuildObjectFilterType = {
  description?: InputMaybe<TStringFilter>;
  floor?: InputMaybe<TIntFilter>;
  floorType?: InputMaybe<TNestedRealestateFileRealestateRecordLocationInBuildFloorTypeObjectFilterType>;
  planNumber?: InputMaybe<TStringFilter>;
  plans?: InputMaybe<TStringFilter>;
};

export type TNestedRealestateFileRealestateRecordNaturalObjects = {
  __typename?: 'NestedRealestateFileRealestateRecordNaturalObjects';
  /** Лесные объекты */
  forests?: Maybe<Array<Maybe<TNestedRealestateFileRealestateRecordNaturalObjectsForests>>>;
  /** Иные природные объекты */
  otherNaturalObjects?: Maybe<Array<Maybe<TNestedRealestateFileRealestateRecordNaturalObjectsOtherNaturalObjects>>>;
  /** Водные объекты */
  waters?: Maybe<Array<Maybe<TNestedRealestateFileRealestateRecordNaturalObjectsWaters>>>;
};


export type TNestedRealestateFileRealestateRecordNaturalObjectsForestsArgs = {
  pagination?: InputMaybe<TPagination>;
};


export type TNestedRealestateFileRealestateRecordNaturalObjectsOtherNaturalObjectsArgs = {
  pagination?: InputMaybe<TPagination>;
};


export type TNestedRealestateFileRealestateRecordNaturalObjectsWatersArgs = {
  pagination?: InputMaybe<TPagination>;
};

export type TNestedRealestateFileRealestateRecordNaturalObjectsForests = {
  __typename?: 'NestedRealestateFileRealestateRecordNaturalObjectsForests';
  /** Категория защитных лесов */
  forestCategory?: Maybe<TNestedRealestateFileRealestateRecordNaturalObjectsForestsForestCategory>;
  /** Целевое назначение (категория) лесов */
  forestPurpose?: Maybe<TNestedRealestateFileRealestateRecordNaturalObjectsForestsForestPurpose>;
  /** Номера лесных кварталов */
  forestQuarters?: Maybe<Array<Maybe<Scalars['Int']['output']>>>;
  /** Наименование лесничества, лесопарка, участкового лесничества */
  forestry?: Maybe<Scalars['String']['output']>;
};


export type TNestedRealestateFileRealestateRecordNaturalObjectsForestsForestQuartersArgs = {
  pagination?: InputMaybe<TPagination>;
};

export type TNestedRealestateFileRealestateRecordNaturalObjectsForestsForestCategory = {
  __typename?: 'NestedRealestateFileRealestateRecordNaturalObjectsForestsForestCategory';
  /** код из справочника */
  code?: Maybe<Scalars['NumberString']['output']>;
  /** значение */
  value?: Maybe<Scalars['String']['output']>;
};

export type TNestedRealestateFileRealestateRecordNaturalObjectsForestsForestCategoryObjectFilterType = {
  code?: InputMaybe<TNumberStringFilter>;
  value?: InputMaybe<TStringFilter>;
};

export type TNestedRealestateFileRealestateRecordNaturalObjectsForestsForestPurpose = {
  __typename?: 'NestedRealestateFileRealestateRecordNaturalObjectsForestsForestPurpose';
  /** код из справочника */
  code?: Maybe<Scalars['NumberString']['output']>;
  /** значение */
  value?: Maybe<Scalars['String']['output']>;
};

export type TNestedRealestateFileRealestateRecordNaturalObjectsForestsForestPurposeObjectFilterType = {
  code?: InputMaybe<TNumberStringFilter>;
  value?: InputMaybe<TStringFilter>;
};

export type TNestedRealestateFileRealestateRecordNaturalObjectsForestsObjectFilterType = {
  forestCategory?: InputMaybe<TNestedRealestateFileRealestateRecordNaturalObjectsForestsForestCategoryObjectFilterType>;
  forestPurpose?: InputMaybe<TNestedRealestateFileRealestateRecordNaturalObjectsForestsForestPurposeObjectFilterType>;
  forestQuarters?: InputMaybe<TIntFilter>;
  forestry?: InputMaybe<TStringFilter>;
};

export type TNestedRealestateFileRealestateRecordNaturalObjectsObjectFilterType = {
  forests?: InputMaybe<TNestedRealestateFileRealestateRecordNaturalObjectsForestsObjectFilterType>;
  otherNaturalObjects?: InputMaybe<TNestedRealestateFileRealestateRecordNaturalObjectsOtherNaturalObjectsObjectFilterType>;
  waters?: InputMaybe<TNestedRealestateFileRealestateRecordNaturalObjectsWatersObjectFilterType>;
};

export type TNestedRealestateFileRealestateRecordNaturalObjectsOtherNaturalObjects = {
  __typename?: 'NestedRealestateFileRealestateRecordNaturalObjectsOtherNaturalObjects';
  /** Наименование */
  name?: Maybe<Scalars['String']['output']>;
  /** Назначение */
  purpose?: Maybe<Scalars['String']['output']>;
};

export type TNestedRealestateFileRealestateRecordNaturalObjectsOtherNaturalObjectsObjectFilterType = {
  name?: InputMaybe<TStringFilter>;
  purpose?: InputMaybe<TStringFilter>;
};

export type TNestedRealestateFileRealestateRecordNaturalObjectsWaters = {
  __typename?: 'NestedRealestateFileRealestateRecordNaturalObjectsWaters';
  /** Наименование водного объекта */
  name?: Maybe<Scalars['String']['output']>;
  /** Вид (тип) водного объекта */
  type?: Maybe<TNestedRealestateFileRealestateRecordNaturalObjectsWatersType>;
};

export type TNestedRealestateFileRealestateRecordNaturalObjectsWatersObjectFilterType = {
  name?: InputMaybe<TStringFilter>;
  type?: InputMaybe<TNestedRealestateFileRealestateRecordNaturalObjectsWatersTypeObjectFilterType>;
};

export type TNestedRealestateFileRealestateRecordNaturalObjectsWatersType = {
  __typename?: 'NestedRealestateFileRealestateRecordNaturalObjectsWatersType';
  /** код из справочника */
  code?: Maybe<Scalars['NumberString']['output']>;
  /** значение */
  value?: Maybe<Scalars['String']['output']>;
};

export type TNestedRealestateFileRealestateRecordNaturalObjectsWatersTypeObjectFilterType = {
  code?: InputMaybe<TNumberStringFilter>;
  value?: InputMaybe<TStringFilter>;
};

export type TNestedRealestateFileRealestateRecordObject = {
  __typename?: 'NestedRealestateFileRealestateRecordObject';
  /** Общие сведения о земельном участке */
  commonData: TNestedRealestateFileRealestateRecordObjectCommonData;
  /** Сведения об образовании земельного участка (на основании решения об изъятии, или из земель или земельных участков, государственная собственность на которые не разграничена) */
  dateRemovedCadAccount?: Maybe<TNestedRealestateFileRealestateRecordObjectDateRemovedCadAccount>;
  /** Дата постановки по документу */
  regDateByDoc?: Maybe<Scalars['String']['output']>;
  /** Вид земельного участка */
  subtype?: Maybe<TNestedRealestateFileRealestateRecordObjectSubtype>;
};

export type TNestedRealestateFileRealestateRecordObjectCommonData = {
  __typename?: 'NestedRealestateFileRealestateRecordObjectCommonData';
  /** Кадастровый номер */
  cadNumber: Scalars['String']['output'];
  /** Номер кадастрового квартала */
  quarterCadNumber?: Maybe<Scalars['String']['output']>;
  /** Вид объекта недвижимости */
  type?: Maybe<TNestedRealestateFileRealestateRecordObjectCommonDataType>;
};

export type TNestedRealestateFileRealestateRecordObjectCommonDataObjectFilterType = {
  cadNumber?: InputMaybe<TStringFilter>;
  quarterCadNumber?: InputMaybe<TStringFilter>;
  type?: InputMaybe<TNestedRealestateFileRealestateRecordObjectCommonDataTypeObjectFilterType>;
};

export type TNestedRealestateFileRealestateRecordObjectCommonDataType = {
  __typename?: 'NestedRealestateFileRealestateRecordObjectCommonDataType';
  /** код из справочника */
  code?: Maybe<Scalars['NumberString']['output']>;
  /** значение */
  value?: Maybe<Scalars['String']['output']>;
};

export type TNestedRealestateFileRealestateRecordObjectCommonDataTypeObjectFilterType = {
  code?: InputMaybe<TNumberStringFilter>;
  value?: InputMaybe<TStringFilter>;
};

export type TNestedRealestateFileRealestateRecordObjectDateRemovedCadAccount = {
  __typename?: 'NestedRealestateFileRealestateRecordObjectDateRemovedCadAccount';
  /** Сведения об образовании земельного участка из земель или земельных участков, государственная собственность на которые не разграничена */
  formLandStateNotDifferentiated?: Maybe<TNestedRealestateFileRealestateRecordObjectDateRemovedCadAccountFormLandStateNotDifferentiated>;
  /** Сведения об образовании земельного участка на основании решения об изъятии объекта недвижимости для государственных и муниципальных нужд (реквизиты решения) */
  withdrawalStateMunicNeeds?: Maybe<TNestedRealestateFileRealestateRecordObjectDateRemovedCadAccountWithdrawalStateMunicNeeds>;
};

export type TNestedRealestateFileRealestateRecordObjectDateRemovedCadAccountFormLandStateNotDifferentiated = {
  __typename?: 'NestedRealestateFileRealestateRecordObjectDateRemovedCadAccountFormLandStateNotDifferentiated';
  /** Дата снятия с учета */
  dateRemove?: Maybe<Scalars['String']['output']>;
  /** Наименование уполномоченного органа */
  nameAuthority?: Maybe<Scalars['String']['output']>;
};

export type TNestedRealestateFileRealestateRecordObjectDateRemovedCadAccountFormLandStateNotDifferentiatedObjectFilterType = {
  dateRemove?: InputMaybe<TStringFilter>;
  nameAuthority?: InputMaybe<TStringFilter>;
};

export type TNestedRealestateFileRealestateRecordObjectDateRemovedCadAccountObjectFilterType = {
  formLandStateNotDifferentiated?: InputMaybe<TNestedRealestateFileRealestateRecordObjectDateRemovedCadAccountFormLandStateNotDifferentiatedObjectFilterType>;
  withdrawalStateMunicNeeds?: InputMaybe<TNestedRealestateFileRealestateRecordObjectDateRemovedCadAccountWithdrawalStateMunicNeedsObjectFilterType>;
};

export type TNestedRealestateFileRealestateRecordObjectDateRemovedCadAccountWithdrawalStateMunicNeeds = {
  __typename?: 'NestedRealestateFileRealestateRecordObjectDateRemovedCadAccountWithdrawalStateMunicNeeds';
  /** Код документа */
  code?: Maybe<TNestedRealestateFileRealestateRecordObjectDateRemovedCadAccountWithdrawalStateMunicNeedsCode>;
  /** Дата документа */
  date?: Maybe<Scalars['String']['output']>;
  /** Орган власти, организация, выдавшие документ. Автор документа */
  issuer?: Maybe<Scalars['String']['output']>;
  /** Номер документа */
  number?: Maybe<Scalars['String']['output']>;
};

export type TNestedRealestateFileRealestateRecordObjectDateRemovedCadAccountWithdrawalStateMunicNeedsCode = {
  __typename?: 'NestedRealestateFileRealestateRecordObjectDateRemovedCadAccountWithdrawalStateMunicNeedsCode';
  /** код из справочника */
  code?: Maybe<Scalars['NumberString']['output']>;
  /** значение */
  value?: Maybe<Scalars['String']['output']>;
};

export type TNestedRealestateFileRealestateRecordObjectDateRemovedCadAccountWithdrawalStateMunicNeedsCodeObjectFilterType = {
  code?: InputMaybe<TNumberStringFilter>;
  value?: InputMaybe<TStringFilter>;
};

export type TNestedRealestateFileRealestateRecordObjectDateRemovedCadAccountWithdrawalStateMunicNeedsObjectFilterType = {
  code?: InputMaybe<TNestedRealestateFileRealestateRecordObjectDateRemovedCadAccountWithdrawalStateMunicNeedsCodeObjectFilterType>;
  date?: InputMaybe<TStringFilter>;
  issuer?: InputMaybe<TStringFilter>;
  number?: InputMaybe<TStringFilter>;
};

export type TNestedRealestateFileRealestateRecordObjectFilterType = {
  additionalContourLocation?: InputMaybe<TNestedRealestateFileRealestateRecordAdditionalContourLocationObjectFilterType>;
  address?: InputMaybe<TNestedRealestateFileRealestateRecordAddressObjectFilterType>;
  apartmentBuilding?: InputMaybe<TNestedRealestateFileRealestateRecordApartmentBuildingObjectFilterType>;
  cadLinks?: InputMaybe<TNestedRealestateFileRealestateRecordCadLinksObjectFilterType>;
  cadWorks?: InputMaybe<TNestedRealestateFileRealestateRecordCadWorksObjectFilterType>;
  contours?: InputMaybe<TNestedRealestateFileRealestateRecordContoursObjectFilterType>;
  contoursLocation?: InputMaybe<TNestedRealestateFileRealestateRecordContoursLocationObjectFilterType>;
  cost?: InputMaybe<TFloatFilter>;
  culturalHeritage?: InputMaybe<TNestedRealestateFileRealestateRecordCulturalHeritageObjectFilterType>;
  governmentLandSupervision?: InputMaybe<TNestedRealestateFileRealestateRecordGovernmentLandSupervisionObjectFilterType>;
  locationInBuild?: InputMaybe<TNestedRealestateFileRealestateRecordLocationInBuildObjectFilterType>;
  naturalObjects?: InputMaybe<TNestedRealestateFileRealestateRecordNaturalObjectsObjectFilterType>;
  object?: InputMaybe<TNestedRealestateFileRealestateRecordObjectObjectFilterType>;
  objectParts?: InputMaybe<TNestedRealestateFileRealestateRecordObjectPartsObjectFilterType>;
  params?: InputMaybe<TNestedRealestateFileRealestateRecordParamsObjectFilterType>;
  recordInfo?: InputMaybe<TNestedRealestateFileRealestateRecordRecordInfoObjectFilterType>;
  restrictionsEncumbrances?: InputMaybe<TNestedRealestateFileRealestateRecordRestrictionsEncumbrancesObjectFilterType>;
  specialNotes?: InputMaybe<TStringFilter>;
  surveyBoundaries?: InputMaybe<TNestedRealestateFileRealestateRecordSurveyBoundariesObjectFilterType>;
  zonesAndBoundaries?: InputMaybe<TNestedRealestateFileRealestateRecordZonesAndBoundariesObjectFilterType>;
};

export type TNestedRealestateFileRealestateRecordObjectObjectFilterType = {
  commonData?: InputMaybe<TNestedRealestateFileRealestateRecordObjectCommonDataObjectFilterType>;
  dateRemovedCadAccount?: InputMaybe<TNestedRealestateFileRealestateRecordObjectDateRemovedCadAccountObjectFilterType>;
  regDateByDoc?: InputMaybe<TStringFilter>;
  subtype?: InputMaybe<TNestedRealestateFileRealestateRecordObjectSubtypeObjectFilterType>;
};

export type TNestedRealestateFileRealestateRecordObjectParts = {
  __typename?: 'NestedRealestateFileRealestateRecordObjectParts';
  /** Площадь || Площадь, в кв. метрах */
  area?: Maybe<TNestedRealestateFileRealestateRecordObjectPartsArea>;
  /** Содержание ограничений */
  contentRestrictions?: Maybe<TNestedRealestateFileRealestateRecordObjectPartsContentRestrictions>;
  /** Описание местоположения границ */
  contours?: Maybe<Array<Maybe<TNestedRealestateFileRealestateRecordObjectPartsContours>>>;
  /** Примечание */
  footnote?: Maybe<Scalars['String']['output']>;
  /** Местоположение части здания */
  locationBuilding?: Maybe<TNestedRealestateFileRealestateRecordObjectPartsLocationBuilding>;
  /** Порядковый номер части */
  partNumber?: Maybe<Scalars['Int']['output']>;
};


export type TNestedRealestateFileRealestateRecordObjectPartsContoursArgs = {
  pagination?: InputMaybe<TPagination>;
};

export type TNestedRealestateFileRealestateRecordObjectPartsArea = {
  __typename?: 'NestedRealestateFileRealestateRecordObjectPartsArea';
  /** код из справочника */
  code?: Maybe<Scalars['NumberString']['output']>;
  /** значение */
  value?: Maybe<Scalars['Float']['output']>;
};

export type TNestedRealestateFileRealestateRecordObjectPartsAreaObjectFilterType = {
  code?: InputMaybe<TNumberStringFilter>;
  value?: InputMaybe<TFloatFilter>;
};

export type TNestedRealestateFileRealestateRecordObjectPartsContentRestrictions = {
  __typename?: 'NestedRealestateFileRealestateRecordObjectPartsContentRestrictions';
  /** Сведения о регистрации */
  dataRegistration?: Maybe<TNestedRealestateFileRealestateRecordObjectPartsContentRestrictionsDataRegistration>;
  /** Реестровый номер границы */
  regNumbBorder?: Maybe<TNestedRealestateFileRealestateRecordObjectPartsContentRestrictionsRegNumbBorder>;
};

export type TNestedRealestateFileRealestateRecordObjectPartsContentRestrictionsDataRegistration = {
  __typename?: 'NestedRealestateFileRealestateRecordObjectPartsContentRestrictionsDataRegistration';
  /** Дата регистрации */
  registrationDate?: Maybe<Scalars['String']['output']>;
  /** Номер регистрации/реестровой записи */
  restrictionEncumbranceNumber?: Maybe<TNestedRealestateFileRealestateRecordObjectPartsContentRestrictionsDataRegistrationRestrictionEncumbranceNumber>;
};

export type TNestedRealestateFileRealestateRecordObjectPartsContentRestrictionsDataRegistrationObjectFilterType = {
  registrationDate?: InputMaybe<TStringFilter>;
  restrictionEncumbranceNumber?: InputMaybe<TNestedRealestateFileRealestateRecordObjectPartsContentRestrictionsDataRegistrationRestrictionEncumbranceNumberObjectFilterType>;
};

export type TNestedRealestateFileRealestateRecordObjectPartsContentRestrictionsDataRegistrationRestrictionEncumbranceNumber = {
  __typename?: 'NestedRealestateFileRealestateRecordObjectPartsContentRestrictionsDataRegistrationRestrictionEncumbranceNumber';
  /** Номер реестровой записи */
  number?: Maybe<Scalars['String']['output']>;
  /** Номер регистрации ограничения права или обременения ОН */
  rightNumber?: Maybe<Scalars['String']['output']>;
};

export type TNestedRealestateFileRealestateRecordObjectPartsContentRestrictionsDataRegistrationRestrictionEncumbranceNumberObjectFilterType = {
  number?: InputMaybe<TStringFilter>;
  rightNumber?: InputMaybe<TStringFilter>;
};

export type TNestedRealestateFileRealestateRecordObjectPartsContentRestrictionsObjectFilterType = {
  dataRegistration?: InputMaybe<TNestedRealestateFileRealestateRecordObjectPartsContentRestrictionsDataRegistrationObjectFilterType>;
  regNumbBorder?: InputMaybe<TNestedRealestateFileRealestateRecordObjectPartsContentRestrictionsRegNumbBorderObjectFilterType>;
};

export type TNestedRealestateFileRealestateRecordObjectPartsContentRestrictionsRegNumbBorder = {
  __typename?: 'NestedRealestateFileRealestateRecordObjectPartsContentRestrictionsRegNumbBorder';
  regNumber?: Maybe<Scalars['String']['output']>;
};

export type TNestedRealestateFileRealestateRecordObjectPartsContentRestrictionsRegNumbBorderObjectFilterType = {
  regNumber?: InputMaybe<TStringFilter>;
};

export type TNestedRealestateFileRealestateRecordObjectPartsContours = {
  __typename?: 'NestedRealestateFileRealestateRecordObjectPartsContours';
  /** Описание элементов контура (характерных точек контура) */
  entitySpatial?: Maybe<TNestedRealestateFileRealestateRecordObjectPartsContoursEntitySpatial>;
  /** Номер контура */
  numberPp?: Maybe<Scalars['Int']['output']>;
};

export type TNestedRealestateFileRealestateRecordObjectPartsContoursEntitySpatial = {
  __typename?: 'NestedRealestateFileRealestateRecordObjectPartsContoursEntitySpatial';
  /** Система координат */
  skId?: Maybe<Scalars['String']['output']>;
  /** Координаты */
  spatialsElements?: Maybe<Array<Maybe<TNestedRealestateFileRealestateRecordObjectPartsContoursEntitySpatialSpatialsElements>>>;
};


export type TNestedRealestateFileRealestateRecordObjectPartsContoursEntitySpatialSpatialsElementsArgs = {
  pagination?: InputMaybe<TPagination>;
};

export type TNestedRealestateFileRealestateRecordObjectPartsContoursEntitySpatialObjectFilterType = {
  skId?: InputMaybe<TStringFilter>;
  spatialsElements?: InputMaybe<TNestedRealestateFileRealestateRecordObjectPartsContoursEntitySpatialSpatialsElementsObjectFilterType>;
};

export type TNestedRealestateFileRealestateRecordObjectPartsContoursEntitySpatialSpatialsElements = {
  __typename?: 'NestedRealestateFileRealestateRecordObjectPartsContoursEntitySpatialSpatialsElements';
  /** Погрешность */
  deltaGeopoint?: Maybe<Scalars['Int']['output']>;
  /** Описание закрепления точки */
  geopointZacrep?: Maybe<Scalars['String']['output']>;
  /** Номер межевой точки */
  numGeopoint?: Maybe<Scalars['String']['output']>;
  /** Номер точки (порядок обхода) */
  ordNmb?: Maybe<Scalars['Int']['output']>;
  /** Координата X */
  x?: Maybe<Scalars['Int']['output']>;
  /** Координата Y */
  y?: Maybe<Scalars['Int']['output']>;
  /** Координата Z */
  z?: Maybe<Scalars['Int']['output']>;
};

export type TNestedRealestateFileRealestateRecordObjectPartsContoursEntitySpatialSpatialsElementsObjectFilterType = {
  deltaGeopoint?: InputMaybe<TIntFilter>;
  geopointZacrep?: InputMaybe<TStringFilter>;
  numGeopoint?: InputMaybe<TStringFilter>;
  ordNmb?: InputMaybe<TIntFilter>;
  x?: InputMaybe<TIntFilter>;
  y?: InputMaybe<TIntFilter>;
  z?: InputMaybe<TIntFilter>;
};

export type TNestedRealestateFileRealestateRecordObjectPartsContoursObjectFilterType = {
  entitySpatial?: InputMaybe<TNestedRealestateFileRealestateRecordObjectPartsContoursEntitySpatialObjectFilterType>;
  numberPp?: InputMaybe<TIntFilter>;
};

export type TNestedRealestateFileRealestateRecordObjectPartsLocationBuilding = {
  __typename?: 'NestedRealestateFileRealestateRecordObjectPartsLocationBuilding';
  /** Описание местоположения контура */
  contours?: Maybe<Array<Maybe<TNestedRealestateFileRealestateRecordObjectPartsLocationBuildingContours>>>;
  /** Расположение в пределах объекта недвижимости */
  inBuild?: Maybe<Array<Maybe<TNestedRealestateFileRealestateRecordObjectPartsLocationBuildingInBuild>>>;
};


export type TNestedRealestateFileRealestateRecordObjectPartsLocationBuildingContoursArgs = {
  pagination?: InputMaybe<TPagination>;
};


export type TNestedRealestateFileRealestateRecordObjectPartsLocationBuildingInBuildArgs = {
  pagination?: InputMaybe<TPagination>;
};

export type TNestedRealestateFileRealestateRecordObjectPartsLocationBuildingContours = {
  __typename?: 'NestedRealestateFileRealestateRecordObjectPartsLocationBuildingContours';
  /** Описание элементов контура (характерных точек контура) */
  entitySpatial?: Maybe<TNestedRealestateFileRealestateRecordObjectPartsLocationBuildingContoursEntitySpatial>;
  /** Номер контура */
  numberPp?: Maybe<Scalars['Int']['output']>;
};

export type TNestedRealestateFileRealestateRecordObjectPartsLocationBuildingContoursEntitySpatial = {
  __typename?: 'NestedRealestateFileRealestateRecordObjectPartsLocationBuildingContoursEntitySpatial';
  /** Система координат */
  skId?: Maybe<Scalars['String']['output']>;
  /** Элементы контура */
  spatialsElements?: Maybe<Array<Maybe<TNestedRealestateFileRealestateRecordObjectPartsLocationBuildingContoursEntitySpatialSpatialsElements>>>;
};


export type TNestedRealestateFileRealestateRecordObjectPartsLocationBuildingContoursEntitySpatialSpatialsElementsArgs = {
  pagination?: InputMaybe<TPagination>;
};

export type TNestedRealestateFileRealestateRecordObjectPartsLocationBuildingContoursEntitySpatialObjectFilterType = {
  skId?: InputMaybe<TStringFilter>;
  spatialsElements?: InputMaybe<TNestedRealestateFileRealestateRecordObjectPartsLocationBuildingContoursEntitySpatialSpatialsElementsObjectFilterType>;
};

export type TNestedRealestateFileRealestateRecordObjectPartsLocationBuildingContoursEntitySpatialSpatialsElements = {
  __typename?: 'NestedRealestateFileRealestateRecordObjectPartsLocationBuildingContoursEntitySpatialSpatialsElements';
  /** Тип контура */
  levelContour?: Maybe<TNestedRealestateFileRealestateRecordObjectPartsLocationBuildingContoursEntitySpatialSpatialsElementsLevelContour>;
  /** Список координат */
  ordinates?: Maybe<Array<Maybe<TNestedRealestateFileRealestateRecordObjectPartsLocationBuildingContoursEntitySpatialSpatialsElementsOrdinates>>>;
};


export type TNestedRealestateFileRealestateRecordObjectPartsLocationBuildingContoursEntitySpatialSpatialsElementsOrdinatesArgs = {
  pagination?: InputMaybe<TPagination>;
};

export type TNestedRealestateFileRealestateRecordObjectPartsLocationBuildingContoursEntitySpatialSpatialsElementsLevelContour = {
  __typename?: 'NestedRealestateFileRealestateRecordObjectPartsLocationBuildingContoursEntitySpatialSpatialsElementsLevelContour';
  /** код из справочника */
  code?: Maybe<Scalars['NumberString']['output']>;
  /** значение */
  value?: Maybe<Scalars['String']['output']>;
};

export type TNestedRealestateFileRealestateRecordObjectPartsLocationBuildingContoursEntitySpatialSpatialsElementsLevelContourObjectFilterType = {
  code?: InputMaybe<TNumberStringFilter>;
  value?: InputMaybe<TStringFilter>;
};

export type TNestedRealestateFileRealestateRecordObjectPartsLocationBuildingContoursEntitySpatialSpatialsElementsObjectFilterType = {
  levelContour?: InputMaybe<TNestedRealestateFileRealestateRecordObjectPartsLocationBuildingContoursEntitySpatialSpatialsElementsLevelContourObjectFilterType>;
  ordinates?: InputMaybe<TNestedRealestateFileRealestateRecordObjectPartsLocationBuildingContoursEntitySpatialSpatialsElementsOrdinatesObjectFilterType>;
};

export type TNestedRealestateFileRealestateRecordObjectPartsLocationBuildingContoursEntitySpatialSpatialsElementsOrdinates = {
  __typename?: 'NestedRealestateFileRealestateRecordObjectPartsLocationBuildingContoursEntitySpatialSpatialsElementsOrdinates';
  /** Погрешность */
  deltaGeopoint?: Maybe<Scalars['Int']['output']>;
  /** Номер точки */
  numGeopoint?: Maybe<Scalars['String']['output']>;
  /** Номер точки (порядок обхода) */
  ordNmb?: Maybe<Scalars['Int']['output']>;
  /** Радиус */
  r?: Maybe<Scalars['Int']['output']>;
  /** Координата X */
  x?: Maybe<Scalars['Int']['output']>;
  /** Координата Y */
  y?: Maybe<Scalars['Int']['output']>;
  /** Координата Z */
  z?: Maybe<Scalars['Int']['output']>;
};

export type TNestedRealestateFileRealestateRecordObjectPartsLocationBuildingContoursEntitySpatialSpatialsElementsOrdinatesObjectFilterType = {
  deltaGeopoint?: InputMaybe<TIntFilter>;
  numGeopoint?: InputMaybe<TStringFilter>;
  ordNmb?: InputMaybe<TIntFilter>;
  r?: InputMaybe<TIntFilter>;
  x?: InputMaybe<TIntFilter>;
  y?: InputMaybe<TIntFilter>;
  z?: InputMaybe<TIntFilter>;
};

export type TNestedRealestateFileRealestateRecordObjectPartsLocationBuildingContoursObjectFilterType = {
  entitySpatial?: InputMaybe<TNestedRealestateFileRealestateRecordObjectPartsLocationBuildingContoursEntitySpatialObjectFilterType>;
  numberPp?: InputMaybe<TIntFilter>;
};

export type TNestedRealestateFileRealestateRecordObjectPartsLocationBuildingInBuild = {
  __typename?: 'NestedRealestateFileRealestateRecordObjectPartsLocationBuildingInBuild';
  /** Описание расположения */
  description?: Maybe<Scalars['String']['output']>;
  /** Номер этажа */
  floor?: Maybe<Scalars['Int']['output']>;
  /** Тип этажа */
  floorType?: Maybe<Scalars['Int']['output']>;
  /** Номер на поэтажном плане */
  planNumber?: Maybe<Scalars['String']['output']>;
  /** Планы */
  plans?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};


export type TNestedRealestateFileRealestateRecordObjectPartsLocationBuildingInBuildPlansArgs = {
  pagination?: InputMaybe<TPagination>;
};

export type TNestedRealestateFileRealestateRecordObjectPartsLocationBuildingInBuildObjectFilterType = {
  description?: InputMaybe<TStringFilter>;
  floor?: InputMaybe<TIntFilter>;
  floorType?: InputMaybe<TIntFilter>;
  planNumber?: InputMaybe<TStringFilter>;
  plans?: InputMaybe<TStringFilter>;
};

export type TNestedRealestateFileRealestateRecordObjectPartsLocationBuildingObjectFilterType = {
  contours?: InputMaybe<TNestedRealestateFileRealestateRecordObjectPartsLocationBuildingContoursObjectFilterType>;
  inBuild?: InputMaybe<TNestedRealestateFileRealestateRecordObjectPartsLocationBuildingInBuildObjectFilterType>;
};

export type TNestedRealestateFileRealestateRecordObjectPartsObjectFilterType = {
  area?: InputMaybe<TNestedRealestateFileRealestateRecordObjectPartsAreaObjectFilterType>;
  contentRestrictions?: InputMaybe<TNestedRealestateFileRealestateRecordObjectPartsContentRestrictionsObjectFilterType>;
  contours?: InputMaybe<TNestedRealestateFileRealestateRecordObjectPartsContoursObjectFilterType>;
  footnote?: InputMaybe<TStringFilter>;
  locationBuilding?: InputMaybe<TNestedRealestateFileRealestateRecordObjectPartsLocationBuildingObjectFilterType>;
  partNumber?: InputMaybe<TIntFilter>;
};

export type TNestedRealestateFileRealestateRecordObjectSubtype = {
  __typename?: 'NestedRealestateFileRealestateRecordObjectSubtype';
  /** код из справочника */
  code?: Maybe<Scalars['NumberString']['output']>;
  /** значение */
  value?: Maybe<Scalars['String']['output']>;
};

export type TNestedRealestateFileRealestateRecordObjectSubtypeObjectFilterType = {
  code?: InputMaybe<TNumberStringFilter>;
  value?: InputMaybe<TStringFilter>;
};

export type TNestedRealestateFileRealestateRecordParams = {
  __typename?: 'NestedRealestateFileRealestateRecordParams';
  /** Разрешенное использование */
  allowedUse?: Maybe<TNestedRealestateFileRealestateRecordParamsAllowedUse>;
  /** В Здании это значение является числом */
  area?: Maybe<TNestedRealestateFileRealestateRecordParamsArea>;
  /** Основные характеристики */
  baseParameters?: Maybe<Array<Maybe<TNestedRealestateFileRealestateRecordParamsBaseParameters>>>;
  /** Категория */
  category?: Maybe<TNestedRealestateFileRealestateRecordParamsCategory>;
  /** Степень готовности объекта незавершенного строительства в процентах */
  degreeReadiness?: Maybe<Scalars['String']['output']>;
  /** Количество этажей (в том числе подземных) */
  floors?: Maybe<Scalars['Int']['output']>;
  /** Материалы наружных стен здания */
  materials?: Maybe<Array<Maybe<TNestedRealestateFileRealestateRecordParamsMaterials>>>;
  /** Наименование сооружения */
  name?: Maybe<Scalars['String']['output']>;
  /** Вид(ы) разрешенного использования */
  permittedUses?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Разрешенное использование по градостроительному регламенту */
  permittesUsesGradReg?: Maybe<TNestedRealestateFileRealestateRecordParamsPermittesUsesGradReg>;
  /** Назначение сооружения */
  purpose?: Maybe<TNestedRealestateFileRealestateRecordParamsPurpose>;
  /** Количество подземных этажей */
  undergroundFloors?: Maybe<Scalars['Int']['output']>;
  /** Год завершения строительства */
  yearBuilt?: Maybe<Scalars['year']['output']>;
  /** Год ввода в эксплуатацию по завершении строительства */
  yearCommisioning?: Maybe<Scalars['String']['output']>;
};


export type TNestedRealestateFileRealestateRecordParamsBaseParametersArgs = {
  pagination?: InputMaybe<TPagination>;
};


export type TNestedRealestateFileRealestateRecordParamsMaterialsArgs = {
  pagination?: InputMaybe<TPagination>;
};


export type TNestedRealestateFileRealestateRecordParamsPermittedUsesArgs = {
  pagination?: InputMaybe<TPagination>;
};

export type TNestedRealestateFileRealestateRecordParamsAllowedUse = {
  __typename?: 'NestedRealestateFileRealestateRecordParamsAllowedUse';
  /** По документу */
  byDocument?: Maybe<Scalars['String']['output']>;
  /** Вид разрешенного использования земельного участка в соответствии с ранее использовавшимся классификатором */
  landUse?: Maybe<TNestedRealestateFileRealestateRecordParamsAllowedUseLandUse>;
  /** Вид разрешенного использования земельного участка в соответствии с классификатором, утвержденным приказом Минэкономразвития России от 01.09.2014 № 540 */
  landUseMer?: Maybe<TNestedRealestateFileRealestateRecordParamsAllowedUseLandUseMer>;
};

export type TNestedRealestateFileRealestateRecordParamsAllowedUseLandUse = {
  __typename?: 'NestedRealestateFileRealestateRecordParamsAllowedUseLandUse';
  /** код из справочника */
  code?: Maybe<Scalars['NumberString']['output']>;
  /** значение */
  value?: Maybe<Scalars['String']['output']>;
};

export type TNestedRealestateFileRealestateRecordParamsAllowedUseLandUseMer = {
  __typename?: 'NestedRealestateFileRealestateRecordParamsAllowedUseLandUseMer';
  /** код из справочника */
  code?: Maybe<Scalars['NumberString']['output']>;
  /** значение */
  value?: Maybe<Scalars['String']['output']>;
};

export type TNestedRealestateFileRealestateRecordParamsAllowedUseLandUseMerObjectFilterType = {
  code?: InputMaybe<TNumberStringFilter>;
  value?: InputMaybe<TStringFilter>;
};

export type TNestedRealestateFileRealestateRecordParamsAllowedUseLandUseObjectFilterType = {
  code?: InputMaybe<TNumberStringFilter>;
  value?: InputMaybe<TStringFilter>;
};

export type TNestedRealestateFileRealestateRecordParamsAllowedUseObjectFilterType = {
  byDocument?: InputMaybe<TStringFilter>;
  landUse?: InputMaybe<TNestedRealestateFileRealestateRecordParamsAllowedUseLandUseObjectFilterType>;
  landUseMer?: InputMaybe<TNestedRealestateFileRealestateRecordParamsAllowedUseLandUseMerObjectFilterType>;
};

export type TNestedRealestateFileRealestateRecordParamsArea = {
  __typename?: 'NestedRealestateFileRealestateRecordParamsArea';
  type?: Maybe<TNestedRealestateFileRealestateRecordParamsAreaType>;
  /** значение */
  value?: Maybe<Scalars['Float']['output']>;
};

export type TNestedRealestateFileRealestateRecordParamsAreaObjectFilterType = {
  type?: InputMaybe<TNestedRealestateFileRealestateRecordParamsAreaTypeObjectFilterType>;
  value?: InputMaybe<TFloatFilter>;
};

export type TNestedRealestateFileRealestateRecordParamsAreaType = {
  __typename?: 'NestedRealestateFileRealestateRecordParamsAreaType';
  /** код из справочника */
  code?: Maybe<Scalars['NumberString']['output']>;
  /** значение */
  value?: Maybe<Scalars['String']['output']>;
};

export type TNestedRealestateFileRealestateRecordParamsAreaTypeObjectFilterType = {
  code?: InputMaybe<TNumberStringFilter>;
  value?: InputMaybe<TStringFilter>;
};

export type TNestedRealestateFileRealestateRecordParamsBaseParameters = {
  __typename?: 'NestedRealestateFileRealestateRecordParamsBaseParameters';
  /** Площадь в кв. метрах */
  area?: Maybe<Scalars['Float']['output']>;
  /** Площадь застройки в квадратных метрах с округлением до 0,1 квадратного метра */
  builtUpArea?: Maybe<Scalars['Int']['output']>;
  /** Глубина в метрах с округлением до 0,1 метра */
  depth?: Maybe<Scalars['Int']['output']>;
  /** Протяженность в метрах с округлением до 1 метра */
  extension?: Maybe<Scalars['Int']['output']>;
  /** Высота в метрах с округлением до 0,1 метра */
  height?: Maybe<Scalars['Int']['output']>;
  /** Глубина залегания в метрах с округлением до 0,1 метра */
  occurenceDepth?: Maybe<Scalars['Int']['output']>;
  /** Объем в кубических метрах с округлением до 1 кубического метра */
  volume?: Maybe<Scalars['Int']['output']>;
};

export type TNestedRealestateFileRealestateRecordParamsBaseParametersObjectFilterType = {
  area?: InputMaybe<TFloatFilter>;
  builtUpArea?: InputMaybe<TIntFilter>;
  depth?: InputMaybe<TIntFilter>;
  extension?: InputMaybe<TIntFilter>;
  height?: InputMaybe<TIntFilter>;
  occurenceDepth?: InputMaybe<TIntFilter>;
  volume?: InputMaybe<TIntFilter>;
};

export type TNestedRealestateFileRealestateRecordParamsCategory = {
  __typename?: 'NestedRealestateFileRealestateRecordParamsCategory';
  /** код из справочника */
  code?: Maybe<Scalars['NumberString']['output']>;
  /** значение */
  value?: Maybe<Scalars['String']['output']>;
};

export type TNestedRealestateFileRealestateRecordParamsCategoryObjectFilterType = {
  code?: InputMaybe<TNumberStringFilter>;
  value?: InputMaybe<TStringFilter>;
};

export type TNestedRealestateFileRealestateRecordParamsMaterials = {
  __typename?: 'NestedRealestateFileRealestateRecordParamsMaterials';
  /** код из справочника */
  code?: Maybe<Scalars['NumberString']['output']>;
  /** значение */
  value?: Maybe<Scalars['String']['output']>;
};

export type TNestedRealestateFileRealestateRecordParamsMaterialsObjectFilterType = {
  code?: InputMaybe<TNumberStringFilter>;
  value?: InputMaybe<TStringFilter>;
};

export type TNestedRealestateFileRealestateRecordParamsObjectFilterType = {
  allowedUse?: InputMaybe<TNestedRealestateFileRealestateRecordParamsAllowedUseObjectFilterType>;
  area?: InputMaybe<TNestedRealestateFileRealestateRecordParamsAreaObjectFilterType>;
  baseParameters?: InputMaybe<TNestedRealestateFileRealestateRecordParamsBaseParametersObjectFilterType>;
  category?: InputMaybe<TNestedRealestateFileRealestateRecordParamsCategoryObjectFilterType>;
  degreeReadiness?: InputMaybe<TStringFilter>;
  floors?: InputMaybe<TIntFilter>;
  materials?: InputMaybe<TNestedRealestateFileRealestateRecordParamsMaterialsObjectFilterType>;
  name?: InputMaybe<TStringFilter>;
  permittedUses?: InputMaybe<TStringFilter>;
  permittesUsesGradReg?: InputMaybe<TNestedRealestateFileRealestateRecordParamsPermittesUsesGradRegObjectFilterType>;
  purpose?: InputMaybe<TNestedRealestateFileRealestateRecordParamsPurposeObjectFilterType>;
  undergroundFloors?: InputMaybe<TIntFilter>;
  yearBuilt?: InputMaybe<TYearFilter>;
  yearCommisioning?: InputMaybe<TStringFilter>;
};

export type TNestedRealestateFileRealestateRecordParamsPermittesUsesGradReg = {
  __typename?: 'NestedRealestateFileRealestateRecordParamsPermittesUsesGradReg';
  /** Вид разрешенного использования в соответствии с классификатором, утвержденным приказом Минэкономразвития России от 01.09.2014 № 540 */
  landUse?: Maybe<TNestedRealestateFileRealestateRecordParamsPermittesUsesGradRegLandUse>;
  /** Разрешенное использование (текстовое описание) */
  permittedUseText?: Maybe<Scalars['String']['output']>;
  /** Реестровый номер границы */
  regNumbBorder?: Maybe<Scalars['String']['output']>;
};

export type TNestedRealestateFileRealestateRecordParamsPermittesUsesGradRegLandUse = {
  __typename?: 'NestedRealestateFileRealestateRecordParamsPermittesUsesGradRegLandUse';
  /** код из справочника */
  code?: Maybe<Scalars['NumberString']['output']>;
  /** значение */
  value?: Maybe<Scalars['String']['output']>;
};

export type TNestedRealestateFileRealestateRecordParamsPermittesUsesGradRegLandUseObjectFilterType = {
  code?: InputMaybe<TNumberStringFilter>;
  value?: InputMaybe<TStringFilter>;
};

export type TNestedRealestateFileRealestateRecordParamsPermittesUsesGradRegObjectFilterType = {
  landUse?: InputMaybe<TNestedRealestateFileRealestateRecordParamsPermittesUsesGradRegLandUseObjectFilterType>;
  permittedUseText?: InputMaybe<TStringFilter>;
  regNumbBorder?: InputMaybe<TStringFilter>;
};

export type TNestedRealestateFileRealestateRecordParamsPurpose = {
  __typename?: 'NestedRealestateFileRealestateRecordParamsPurpose';
  /** код из справочника */
  code?: Maybe<Scalars['NumberString']['output']>;
  /** значение */
  value?: Maybe<Scalars['String']['output']>;
};

export type TNestedRealestateFileRealestateRecordParamsPurposeObjectFilterType = {
  code?: InputMaybe<TNumberStringFilter>;
  value?: InputMaybe<TStringFilter>;
};

export type TNestedRealestateFileRealestateRecordRecordInfo = {
  __typename?: 'NestedRealestateFileRealestateRecordRecordInfo';
  /** Дата снятия с учета / регистрации */
  cancelDate?: Maybe<Scalars['String']['output']>;
  /** Дата постановки на учет / регистрации */
  registrationDate?: Maybe<Scalars['DateTimeISO']['output']>;
};

export type TNestedRealestateFileRealestateRecordRecordInfoObjectFilterType = {
  cancelDate?: InputMaybe<TStringFilter>;
  registrationDate?: InputMaybe<TDateTimeIsoFilter>;
};

export type TNestedRealestateFileRealestateRecordRestrictionsEncumbrances = {
  __typename?: 'NestedRealestateFileRealestateRecordRestrictionsEncumbrances';
  /** Сведения об объектах */
  cadLink?: Maybe<TNestedRealestateFileRealestateRecordRestrictionsEncumbrancesCadLink>;
  /** Содержание ограничения (обременения) */
  contentRestrictEncumbrances?: Maybe<Scalars['String']['output']>;
  /** Вид обременения */
  encumbranceType?: Maybe<TNestedRealestateFileRealestateRecordRestrictionsEncumbrancesEncumbranceType>;
  /** Порядковый номер части */
  partNumber?: Maybe<Scalars['Int']['output']>;
  /** Лица, в пользу которых ограничиваются права */
  persons?: Maybe<Array<Maybe<TNestedRealestateFileRealestateRecordRestrictionsEncumbrancesPersons>>>;
  /** Документы - основания для внесения сведений */
  underlyingDocs?: Maybe<Array<Maybe<TNestedRealestateFileRealestateRecordRestrictionsEncumbrancesUnderlyingDocs>>>;
  /** Срок действия обременения */
  validity?: Maybe<Scalars['String']['output']>;
};


export type TNestedRealestateFileRealestateRecordRestrictionsEncumbrancesPersonsArgs = {
  pagination?: InputMaybe<TPagination>;
};


export type TNestedRealestateFileRealestateRecordRestrictionsEncumbrancesUnderlyingDocsArgs = {
  pagination?: InputMaybe<TPagination>;
};

export type TNestedRealestateFileRealestateRecordRestrictionsEncumbrancesCadLink = {
  __typename?: 'NestedRealestateFileRealestateRecordRestrictionsEncumbrancesCadLink';
  /** Кадастровый номер земельного участка, для которого обеспечен проход (проезд) */
  easementCadNumbers?: Maybe<Scalars['String']['output']>;
  /** Реестровый номер зоны */
  regNumberBorder?: Maybe<Scalars['String']['output']>;
};

export type TNestedRealestateFileRealestateRecordRestrictionsEncumbrancesCadLinkObjectFilterType = {
  easementCadNumbers?: InputMaybe<TStringFilter>;
  regNumberBorder?: InputMaybe<TStringFilter>;
};

export type TNestedRealestateFileRealestateRecordRestrictionsEncumbrancesEncumbranceType = {
  __typename?: 'NestedRealestateFileRealestateRecordRestrictionsEncumbrancesEncumbranceType';
  /** код из справочника */
  code?: Maybe<Scalars['NumberString']['output']>;
  /** значение */
  value?: Maybe<Scalars['String']['output']>;
};

export type TNestedRealestateFileRealestateRecordRestrictionsEncumbrancesEncumbranceTypeObjectFilterType = {
  code?: InputMaybe<TNumberStringFilter>;
  value?: InputMaybe<TStringFilter>;
};

export type TNestedRealestateFileRealestateRecordRestrictionsEncumbrancesObjectFilterType = {
  cadLink?: InputMaybe<TNestedRealestateFileRealestateRecordRestrictionsEncumbrancesCadLinkObjectFilterType>;
  contentRestrictEncumbrances?: InputMaybe<TStringFilter>;
  encumbranceType?: InputMaybe<TNestedRealestateFileRealestateRecordRestrictionsEncumbrancesEncumbranceTypeObjectFilterType>;
  partNumber?: InputMaybe<TIntFilter>;
  persons?: InputMaybe<TNestedRealestateFileRealestateRecordRestrictionsEncumbrancesPersonsObjectFilterType>;
  underlyingDocs?: InputMaybe<TNestedRealestateFileRealestateRecordRestrictionsEncumbrancesUnderlyingDocsObjectFilterType>;
  validity?: InputMaybe<TStringFilter>;
};

export type TNestedRealestateFileRealestateRecordRestrictionsEncumbrancesPersons = {
  __typename?: 'NestedRealestateFileRealestateRecordRestrictionsEncumbrancesPersons';
  subject?: Maybe<TNestedRealestateFileRealestateRecordRestrictionsEncumbrancesPersonsSubject>;
  /** Тип лица, в пользу которых установлены ограничения права и обременения объекта недвижимости */
  type?: Maybe<TNestedRealestateFileRealestateRecordRestrictionsEncumbrancesPersonsType>;
};

export type TNestedRealestateFileRealestateRecordRestrictionsEncumbrancesPersonsObjectFilterType = {
  subject?: InputMaybe<TNestedRealestateFileRealestateRecordRestrictionsEncumbrancesPersonsSubjectObjectFilterType>;
  type?: InputMaybe<TNestedRealestateFileRealestateRecordRestrictionsEncumbrancesPersonsTypeObjectFilterType>;
};

export type TNestedRealestateFileRealestateRecordRestrictionsEncumbrancesPersonsSubject = {
  __typename?: 'NestedRealestateFileRealestateRecordRestrictionsEncumbrancesPersonsSubject';
  /** Иное лицо, в пользу которого установлены ограничения права и обременения объекта недвижимости */
  another?: Maybe<TNestedRealestateFileRealestateRecordRestrictionsEncumbrancesPersonsSubjectAnother>;
  /** Физическое лицо */
  individual?: Maybe<TNestedRealestateFileRealestateRecordRestrictionsEncumbrancesPersonsSubjectIndividual>;
  /** Юридическое лицо, орган власти */
  legalEntity?: Maybe<TNestedRealestateFileRealestateRecordRestrictionsEncumbrancesPersonsSubjectLegalEntity>;
  /** Публично-правовое образование */
  publicFormation?: Maybe<TNestedRealestateFileRealestateRecordRestrictionsEncumbrancesPersonsSubjectPublicFormation>;
  /** Публичный сервитут */
  publicServitude?: Maybe<Scalars['String']['output']>;
  /** Не определено (тип undefined в документации) */
  somethingElse?: Maybe<Scalars['String']['output']>;
};

export type TNestedRealestateFileRealestateRecordRestrictionsEncumbrancesPersonsSubjectAnother = {
  __typename?: 'NestedRealestateFileRealestateRecordRestrictionsEncumbrancesPersonsSubjectAnother';
  /** Собственники помещений в многоквартирном доме */
  aparthouseOwners?: Maybe<Scalars['String']['output']>;
  /** Владельцы облигаций */
  bondsHolders?: Maybe<TNestedRealestateFileRealestateRecordRestrictionsEncumbrancesPersonsSubjectAnotherBondsHolders>;
  /** Индивидуальное обозначение, идентифицирующее ипотечные сертификаты участия, в интересах владельцев которых осуществляется доверительное управление таким ипотечным покрытием */
  certificatesHolders?: Maybe<Scalars['String']['output']>;
  /** Участники долевого строительства */
  equityParticipantsInfo?: Maybe<Scalars['String']['output']>;
  /** Название (индивидуальное обозначение), идентифицирующее паевой инвестиционный фонд */
  investmentUnitOwner?: Maybe<Scalars['String']['output']>;
  /** Участники долевого строительства по договорам участия в долевом строительстве, которым не переданы объекты долевого строительства */
  notEquityParticipantsInfo?: Maybe<Scalars['String']['output']>;
  /** Иной субъект */
  other?: Maybe<TNestedRealestateFileRealestateRecordRestrictionsEncumbrancesPersonsSubjectAnotherOther>;
  /** Инвестиционное товарищество */
  partnership?: Maybe<TNestedRealestateFileRealestateRecordRestrictionsEncumbrancesPersonsSubjectAnotherPartnership>;
};

export type TNestedRealestateFileRealestateRecordRestrictionsEncumbrancesPersonsSubjectAnotherBondsHolders = {
  __typename?: 'NestedRealestateFileRealestateRecordRestrictionsEncumbrancesPersonsSubjectAnotherBondsHolders';
  /** Дата государственной регистрации номера выпуска облигаций */
  issueDate?: Maybe<Scalars['String']['output']>;
  /** Государственный регистрационный номер выпуска облигаций */
  number?: Maybe<Scalars['String']['output']>;
};

export type TNestedRealestateFileRealestateRecordRestrictionsEncumbrancesPersonsSubjectAnotherBondsHoldersObjectFilterType = {
  issueDate?: InputMaybe<TStringFilter>;
  number?: InputMaybe<TStringFilter>;
};

export type TNestedRealestateFileRealestateRecordRestrictionsEncumbrancesPersonsSubjectAnotherObjectFilterType = {
  aparthouseOwners?: InputMaybe<TStringFilter>;
  bondsHolders?: InputMaybe<TNestedRealestateFileRealestateRecordRestrictionsEncumbrancesPersonsSubjectAnotherBondsHoldersObjectFilterType>;
  certificatesHolders?: InputMaybe<TStringFilter>;
  equityParticipantsInfo?: InputMaybe<TStringFilter>;
  investmentUnitOwner?: InputMaybe<TStringFilter>;
  notEquityParticipantsInfo?: InputMaybe<TStringFilter>;
  other?: InputMaybe<TNestedRealestateFileRealestateRecordRestrictionsEncumbrancesPersonsSubjectAnotherOtherObjectFilterType>;
  partnership?: InputMaybe<TNestedRealestateFileRealestateRecordRestrictionsEncumbrancesPersonsSubjectAnotherPartnershipObjectFilterType>;
};

export type TNestedRealestateFileRealestateRecordRestrictionsEncumbrancesPersonsSubjectAnotherOther = {
  __typename?: 'NestedRealestateFileRealestateRecordRestrictionsEncumbrancesPersonsSubjectAnotherOther';
  /** Комментарий */
  comment?: Maybe<Scalars['String']['output']>;
  contacts?: Maybe<TNestedRealestateFileRealestateRecordRestrictionsEncumbrancesPersonsSubjectAnotherOtherContacts>;
  /** Наименование для печати */
  printText?: Maybe<Scalars['String']['output']>;
  /** Регистрирующий орган */
  registrationOrgan?: Maybe<Scalars['String']['output']>;
  /** Краткое наименование */
  shortTitle?: Maybe<Scalars['String']['output']>;
  /** Наименование */
  title?: Maybe<Scalars['String']['output']>;
};

export type TNestedRealestateFileRealestateRecordRestrictionsEncumbrancesPersonsSubjectAnotherOtherContacts = {
  __typename?: 'NestedRealestateFileRealestateRecordRestrictionsEncumbrancesPersonsSubjectAnotherOtherContacts';
  email?: Maybe<Scalars['String']['output']>;
  /** ! Возможно в документации ошибка: mailing_addess */
  mailingAddress?: Maybe<Scalars['String']['output']>;
};

export type TNestedRealestateFileRealestateRecordRestrictionsEncumbrancesPersonsSubjectAnotherOtherContactsObjectFilterType = {
  email?: InputMaybe<TStringFilter>;
  mailingAddress?: InputMaybe<TStringFilter>;
};

export type TNestedRealestateFileRealestateRecordRestrictionsEncumbrancesPersonsSubjectAnotherOtherObjectFilterType = {
  comment?: InputMaybe<TStringFilter>;
  contacts?: InputMaybe<TNestedRealestateFileRealestateRecordRestrictionsEncumbrancesPersonsSubjectAnotherOtherContactsObjectFilterType>;
  printText?: InputMaybe<TStringFilter>;
  registrationOrgan?: InputMaybe<TStringFilter>;
  shortTitle?: InputMaybe<TStringFilter>;
  title?: InputMaybe<TStringFilter>;
};

export type TNestedRealestateFileRealestateRecordRestrictionsEncumbrancesPersonsSubjectAnotherPartnership = {
  __typename?: 'NestedRealestateFileRealestateRecordRestrictionsEncumbrancesPersonsSubjectAnotherPartnership';
  /** Участник договора инвестиционного товарищества */
  participants?: Maybe<Array<Maybe<TNestedRealestateFileRealestateRecordRestrictionsEncumbrancesPersonsSubjectAnotherPartnershipParticipants>>>;
};


export type TNestedRealestateFileRealestateRecordRestrictionsEncumbrancesPersonsSubjectAnotherPartnershipParticipantsArgs = {
  pagination?: InputMaybe<TPagination>;
};

export type TNestedRealestateFileRealestateRecordRestrictionsEncumbrancesPersonsSubjectAnotherPartnershipObjectFilterType = {
  participants?: InputMaybe<TNestedRealestateFileRealestateRecordRestrictionsEncumbrancesPersonsSubjectAnotherPartnershipParticipantsObjectFilterType>;
};

export type TNestedRealestateFileRealestateRecordRestrictionsEncumbrancesPersonsSubjectAnotherPartnershipParticipants = {
  __typename?: 'NestedRealestateFileRealestateRecordRestrictionsEncumbrancesPersonsSubjectAnotherPartnershipParticipants';
  contacts?: Maybe<TNestedRealestateFileRealestateRecordRestrictionsEncumbrancesPersonsSubjectAnotherPartnershipParticipantsContacts>;
  legalEntity?: Maybe<TNestedRealestateFileRealestateRecordRestrictionsEncumbrancesPersonsSubjectAnotherPartnershipParticipantsLegalEntity>;
};

export type TNestedRealestateFileRealestateRecordRestrictionsEncumbrancesPersonsSubjectAnotherPartnershipParticipantsContacts = {
  __typename?: 'NestedRealestateFileRealestateRecordRestrictionsEncumbrancesPersonsSubjectAnotherPartnershipParticipantsContacts';
  email?: Maybe<Scalars['String']['output']>;
  /** ! Возможно в документации ошибка: mailing_addess */
  mailingAddress?: Maybe<Scalars['String']['output']>;
};

export type TNestedRealestateFileRealestateRecordRestrictionsEncumbrancesPersonsSubjectAnotherPartnershipParticipantsContactsObjectFilterType = {
  email?: InputMaybe<TStringFilter>;
  mailingAddress?: InputMaybe<TStringFilter>;
};

export type TNestedRealestateFileRealestateRecordRestrictionsEncumbrancesPersonsSubjectAnotherPartnershipParticipantsLegalEntity = {
  __typename?: 'NestedRealestateFileRealestateRecordRestrictionsEncumbrancesPersonsSubjectAnotherPartnershipParticipantsLegalEntity';
  notResident?: Maybe<TNestedRealestateFileRealestateRecordRestrictionsEncumbrancesPersonsSubjectAnotherPartnershipParticipantsLegalEntityNotResident>;
  resident?: Maybe<TNestedRealestateFileRealestateRecordRestrictionsEncumbrancesPersonsSubjectAnotherPartnershipParticipantsLegalEntityResident>;
};

export type TNestedRealestateFileRealestateRecordRestrictionsEncumbrancesPersonsSubjectAnotherPartnershipParticipantsLegalEntityNotResident = {
  __typename?: 'NestedRealestateFileRealestateRecordRestrictionsEncumbrancesPersonsSubjectAnotherPartnershipParticipantsLegalEntityNotResident';
  /** Страна регистрации (инкорпорации) */
  incorporateCountry?: Maybe<TNestedRealestateFileRealestateRecordRestrictionsEncumbrancesPersonsSubjectAnotherPartnershipParticipantsLegalEntityNotResidentIncorporateCountry>;
  /** Организационно-правовая форма */
  incorporationForm?: Maybe<TNestedRealestateFileRealestateRecordRestrictionsEncumbrancesPersonsSubjectAnotherPartnershipParticipantsLegalEntityNotResidentIncorporationForm>;
  inn?: Maybe<Scalars['String']['output']>;
  /** Адрес (местонахождение) в стране регистрации (инкорпорации) */
  regAddress?: Maybe<Scalars['String']['output']>;
  /** Дата регистрации */
  registrationDate?: Maybe<Scalars['String']['output']>;
  /** Регистрационный номер */
  registrationNumber?: Maybe<Scalars['String']['output']>;
  /** Наименование регистрирующего органа */
  registrationOrgan?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

export type TNestedRealestateFileRealestateRecordRestrictionsEncumbrancesPersonsSubjectAnotherPartnershipParticipantsLegalEntityNotResidentIncorporateCountry = {
  __typename?: 'NestedRealestateFileRealestateRecordRestrictionsEncumbrancesPersonsSubjectAnotherPartnershipParticipantsLegalEntityNotResidentIncorporateCountry';
  /** код из справочника */
  code?: Maybe<Scalars['NumberString']['output']>;
  /** значение */
  value?: Maybe<Scalars['String']['output']>;
};

export type TNestedRealestateFileRealestateRecordRestrictionsEncumbrancesPersonsSubjectAnotherPartnershipParticipantsLegalEntityNotResidentIncorporateCountryObjectFilterType = {
  code?: InputMaybe<TNumberStringFilter>;
  value?: InputMaybe<TStringFilter>;
};

export type TNestedRealestateFileRealestateRecordRestrictionsEncumbrancesPersonsSubjectAnotherPartnershipParticipantsLegalEntityNotResidentIncorporationForm = {
  __typename?: 'NestedRealestateFileRealestateRecordRestrictionsEncumbrancesPersonsSubjectAnotherPartnershipParticipantsLegalEntityNotResidentIncorporationForm';
  /** код из справочника */
  code?: Maybe<Scalars['NumberString']['output']>;
  /** значение */
  value?: Maybe<Scalars['String']['output']>;
};

export type TNestedRealestateFileRealestateRecordRestrictionsEncumbrancesPersonsSubjectAnotherPartnershipParticipantsLegalEntityNotResidentIncorporationFormObjectFilterType = {
  code?: InputMaybe<TNumberStringFilter>;
  value?: InputMaybe<TStringFilter>;
};

export type TNestedRealestateFileRealestateRecordRestrictionsEncumbrancesPersonsSubjectAnotherPartnershipParticipantsLegalEntityNotResidentObjectFilterType = {
  incorporateCountry?: InputMaybe<TNestedRealestateFileRealestateRecordRestrictionsEncumbrancesPersonsSubjectAnotherPartnershipParticipantsLegalEntityNotResidentIncorporateCountryObjectFilterType>;
  incorporationForm?: InputMaybe<TNestedRealestateFileRealestateRecordRestrictionsEncumbrancesPersonsSubjectAnotherPartnershipParticipantsLegalEntityNotResidentIncorporationFormObjectFilterType>;
  inn?: InputMaybe<TStringFilter>;
  regAddress?: InputMaybe<TStringFilter>;
  registrationDate?: InputMaybe<TStringFilter>;
  registrationNumber?: InputMaybe<TStringFilter>;
  registrationOrgan?: InputMaybe<TStringFilter>;
  title?: InputMaybe<TStringFilter>;
};

export type TNestedRealestateFileRealestateRecordRestrictionsEncumbrancesPersonsSubjectAnotherPartnershipParticipantsLegalEntityObjectFilterType = {
  notResident?: InputMaybe<TNestedRealestateFileRealestateRecordRestrictionsEncumbrancesPersonsSubjectAnotherPartnershipParticipantsLegalEntityNotResidentObjectFilterType>;
  resident?: InputMaybe<TNestedRealestateFileRealestateRecordRestrictionsEncumbrancesPersonsSubjectAnotherPartnershipParticipantsLegalEntityResidentObjectFilterType>;
};

export type TNestedRealestateFileRealestateRecordRestrictionsEncumbrancesPersonsSubjectAnotherPartnershipParticipantsLegalEntityResident = {
  __typename?: 'NestedRealestateFileRealestateRecordRestrictionsEncumbrancesPersonsSubjectAnotherPartnershipParticipantsLegalEntityResident';
  /** Организационно-правовая форма */
  incorporationForm?: Maybe<TNestedRealestateFileRealestateRecordRestrictionsEncumbrancesPersonsSubjectAnotherPartnershipParticipantsLegalEntityResidentIncorporationForm>;
  inn?: Maybe<Scalars['String']['output']>;
  ogrn?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

export type TNestedRealestateFileRealestateRecordRestrictionsEncumbrancesPersonsSubjectAnotherPartnershipParticipantsLegalEntityResidentIncorporationForm = {
  __typename?: 'NestedRealestateFileRealestateRecordRestrictionsEncumbrancesPersonsSubjectAnotherPartnershipParticipantsLegalEntityResidentIncorporationForm';
  /** код из справочника */
  code?: Maybe<Scalars['NumberString']['output']>;
  /** значение */
  value?: Maybe<Scalars['String']['output']>;
};

export type TNestedRealestateFileRealestateRecordRestrictionsEncumbrancesPersonsSubjectAnotherPartnershipParticipantsLegalEntityResidentIncorporationFormObjectFilterType = {
  code?: InputMaybe<TNumberStringFilter>;
  value?: InputMaybe<TStringFilter>;
};

export type TNestedRealestateFileRealestateRecordRestrictionsEncumbrancesPersonsSubjectAnotherPartnershipParticipantsLegalEntityResidentObjectFilterType = {
  incorporationForm?: InputMaybe<TNestedRealestateFileRealestateRecordRestrictionsEncumbrancesPersonsSubjectAnotherPartnershipParticipantsLegalEntityResidentIncorporationFormObjectFilterType>;
  inn?: InputMaybe<TStringFilter>;
  ogrn?: InputMaybe<TStringFilter>;
  title?: InputMaybe<TStringFilter>;
};

export type TNestedRealestateFileRealestateRecordRestrictionsEncumbrancesPersonsSubjectAnotherPartnershipParticipantsObjectFilterType = {
  contacts?: InputMaybe<TNestedRealestateFileRealestateRecordRestrictionsEncumbrancesPersonsSubjectAnotherPartnershipParticipantsContactsObjectFilterType>;
  legalEntity?: InputMaybe<TNestedRealestateFileRealestateRecordRestrictionsEncumbrancesPersonsSubjectAnotherPartnershipParticipantsLegalEntityObjectFilterType>;
};

export type TNestedRealestateFileRealestateRecordRestrictionsEncumbrancesPersonsSubjectIndividual = {
  __typename?: 'NestedRealestateFileRealestateRecordRestrictionsEncumbrancesPersonsSubjectIndividual';
  birthDate?: Maybe<Scalars['BirthDate']['output']>;
  birthPlace?: Maybe<Scalars['String']['output']>;
  /** Гражданство */
  citizenship?: Maybe<TNestedRealestateFileRealestateRecordRestrictionsEncumbrancesPersonsSubjectIndividualCitizenship>;
  /** Связь с правообладателем */
  contacts?: Maybe<TNestedRealestateFileRealestateRecordRestrictionsEncumbrancesPersonsSubjectIndividualContacts>;
  firstName?: Maybe<Scalars['String']['output']>;
  /** Документ, удостоверяющий личность */
  identityDocument?: Maybe<TNestedRealestateFileRealestateRecordRestrictionsEncumbrancesPersonsSubjectIndividualIdentityDocument>;
  lastName?: Maybe<Scalars['String']['output']>;
  middleName?: Maybe<Scalars['String']['output']>;
  snils?: Maybe<Scalars['String']['output']>;
  /** Тип физического лица */
  type?: Maybe<TNestedRealestateFileRealestateRecordRestrictionsEncumbrancesPersonsSubjectIndividualType>;
};

export type TNestedRealestateFileRealestateRecordRestrictionsEncumbrancesPersonsSubjectIndividualCitizenship = {
  __typename?: 'NestedRealestateFileRealestateRecordRestrictionsEncumbrancesPersonsSubjectIndividualCitizenship';
  /** Страна гражданства */
  country?: Maybe<TNestedRealestateFileRealestateRecordRestrictionsEncumbrancesPersonsSubjectIndividualCitizenshipCountry>;
  /** Без гражданства [по документации тут какой-то текст должен быть] */
  noCitizenship?: Maybe<Scalars['String']['output']>;
};

export type TNestedRealestateFileRealestateRecordRestrictionsEncumbrancesPersonsSubjectIndividualCitizenshipCountry = {
  __typename?: 'NestedRealestateFileRealestateRecordRestrictionsEncumbrancesPersonsSubjectIndividualCitizenshipCountry';
  code?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

export type TNestedRealestateFileRealestateRecordRestrictionsEncumbrancesPersonsSubjectIndividualCitizenshipCountryObjectFilterType = {
  code?: InputMaybe<TStringFilter>;
  value?: InputMaybe<TStringFilter>;
};

export type TNestedRealestateFileRealestateRecordRestrictionsEncumbrancesPersonsSubjectIndividualCitizenshipObjectFilterType = {
  country?: InputMaybe<TNestedRealestateFileRealestateRecordRestrictionsEncumbrancesPersonsSubjectIndividualCitizenshipCountryObjectFilterType>;
  noCitizenship?: InputMaybe<TStringFilter>;
};

export type TNestedRealestateFileRealestateRecordRestrictionsEncumbrancesPersonsSubjectIndividualContacts = {
  __typename?: 'NestedRealestateFileRealestateRecordRestrictionsEncumbrancesPersonsSubjectIndividualContacts';
  email?: Maybe<Scalars['String']['output']>;
  /** ! Возможно в документации ошибка: mailing_addess */
  mailingAddress?: Maybe<Scalars['String']['output']>;
};

export type TNestedRealestateFileRealestateRecordRestrictionsEncumbrancesPersonsSubjectIndividualContactsObjectFilterType = {
  email?: InputMaybe<TStringFilter>;
  mailingAddress?: InputMaybe<TStringFilter>;
};

export type TNestedRealestateFileRealestateRecordRestrictionsEncumbrancesPersonsSubjectIndividualIdentityDocument = {
  __typename?: 'NestedRealestateFileRealestateRecordRestrictionsEncumbrancesPersonsSubjectIndividualIdentityDocument';
  /** Код документа */
  code?: Maybe<TNestedRealestateFileRealestateRecordRestrictionsEncumbrancesPersonsSubjectIndividualIdentityDocumentCode>;
  /** Дата документа */
  date?: Maybe<Scalars['DateTimeISO']['output']>;
  /** Нотариальное удостоверение документа */
  docNotarized?: Maybe<TNestedRealestateFileRealestateRecordRestrictionsEncumbrancesPersonsSubjectIndividualIdentityDocumentDocNotarized>;
  /** Кем выдан (Организация, выдавшая документ) */
  issuer?: Maybe<Scalars['String']['output']>;
  /** Наименование */
  name?: Maybe<Scalars['String']['output']>;
  /** Номер документа */
  number?: Maybe<Scalars['String']['output']>;
  /** Серия документа */
  series?: Maybe<Scalars['String']['output']>;
  /** Особые отметки */
  specialMarks?: Maybe<Scalars['String']['output']>;
};

export type TNestedRealestateFileRealestateRecordRestrictionsEncumbrancesPersonsSubjectIndividualIdentityDocumentCode = {
  __typename?: 'NestedRealestateFileRealestateRecordRestrictionsEncumbrancesPersonsSubjectIndividualIdentityDocumentCode';
  /** код из справочника */
  code?: Maybe<Scalars['NumberString']['output']>;
  /** значение */
  value?: Maybe<Scalars['String']['output']>;
};

export type TNestedRealestateFileRealestateRecordRestrictionsEncumbrancesPersonsSubjectIndividualIdentityDocumentCodeObjectFilterType = {
  code?: InputMaybe<TNumberStringFilter>;
  value?: InputMaybe<TStringFilter>;
};

export type TNestedRealestateFileRealestateRecordRestrictionsEncumbrancesPersonsSubjectIndividualIdentityDocumentDocNotarized = {
  __typename?: 'NestedRealestateFileRealestateRecordRestrictionsEncumbrancesPersonsSubjectIndividualIdentityDocumentDocNotarized';
  /** Дата нотариального удостоверения */
  notarizeDate?: Maybe<Scalars['String']['output']>;
  /** Номер в реестре регистрации нотариальных действий */
  notaryActionNum?: Maybe<Scalars['String']['output']>;
  /** Фамилия и инициалы нотариуса */
  notaryName?: Maybe<Scalars['String']['output']>;
};

export type TNestedRealestateFileRealestateRecordRestrictionsEncumbrancesPersonsSubjectIndividualIdentityDocumentDocNotarizedObjectFilterType = {
  notarizeDate?: InputMaybe<TStringFilter>;
  notaryActionNum?: InputMaybe<TStringFilter>;
  notaryName?: InputMaybe<TStringFilter>;
};

export type TNestedRealestateFileRealestateRecordRestrictionsEncumbrancesPersonsSubjectIndividualIdentityDocumentObjectFilterType = {
  code?: InputMaybe<TNestedRealestateFileRealestateRecordRestrictionsEncumbrancesPersonsSubjectIndividualIdentityDocumentCodeObjectFilterType>;
  date?: InputMaybe<TDateTimeIsoFilter>;
  docNotarized?: InputMaybe<TNestedRealestateFileRealestateRecordRestrictionsEncumbrancesPersonsSubjectIndividualIdentityDocumentDocNotarizedObjectFilterType>;
  issuer?: InputMaybe<TStringFilter>;
  name?: InputMaybe<TStringFilter>;
  number?: InputMaybe<TStringFilter>;
  series?: InputMaybe<TStringFilter>;
  specialMarks?: InputMaybe<TStringFilter>;
};

export type TNestedRealestateFileRealestateRecordRestrictionsEncumbrancesPersonsSubjectIndividualObjectFilterType = {
  birthDate?: InputMaybe<TBirthDateFilter>;
  birthPlace?: InputMaybe<TStringFilter>;
  citizenship?: InputMaybe<TNestedRealestateFileRealestateRecordRestrictionsEncumbrancesPersonsSubjectIndividualCitizenshipObjectFilterType>;
  contacts?: InputMaybe<TNestedRealestateFileRealestateRecordRestrictionsEncumbrancesPersonsSubjectIndividualContactsObjectFilterType>;
  firstName?: InputMaybe<TStringFilter>;
  identityDocument?: InputMaybe<TNestedRealestateFileRealestateRecordRestrictionsEncumbrancesPersonsSubjectIndividualIdentityDocumentObjectFilterType>;
  lastName?: InputMaybe<TStringFilter>;
  middleName?: InputMaybe<TStringFilter>;
  snils?: InputMaybe<TStringFilter>;
  type?: InputMaybe<TNestedRealestateFileRealestateRecordRestrictionsEncumbrancesPersonsSubjectIndividualTypeObjectFilterType>;
};

export type TNestedRealestateFileRealestateRecordRestrictionsEncumbrancesPersonsSubjectIndividualType = {
  __typename?: 'NestedRealestateFileRealestateRecordRestrictionsEncumbrancesPersonsSubjectIndividualType';
  /** код из справочника */
  code?: Maybe<Scalars['NumberString']['output']>;
  /** значение */
  value?: Maybe<Scalars['String']['output']>;
};

export type TNestedRealestateFileRealestateRecordRestrictionsEncumbrancesPersonsSubjectIndividualTypeObjectFilterType = {
  code?: InputMaybe<TNumberStringFilter>;
  value?: InputMaybe<TStringFilter>;
};

export type TNestedRealestateFileRealestateRecordRestrictionsEncumbrancesPersonsSubjectLegalEntity = {
  __typename?: 'NestedRealestateFileRealestateRecordRestrictionsEncumbrancesPersonsSubjectLegalEntity';
  contacts?: Maybe<TNestedRealestateFileRealestateRecordRestrictionsEncumbrancesPersonsSubjectLegalEntityContacts>;
  entity?: Maybe<TNestedRealestateFileRealestateRecordRestrictionsEncumbrancesPersonsSubjectLegalEntityEntity>;
  /** Тип юридического лица */
  type?: Maybe<TNestedRealestateFileRealestateRecordRestrictionsEncumbrancesPersonsSubjectLegalEntityType>;
};

export type TNestedRealestateFileRealestateRecordRestrictionsEncumbrancesPersonsSubjectLegalEntityContacts = {
  __typename?: 'NestedRealestateFileRealestateRecordRestrictionsEncumbrancesPersonsSubjectLegalEntityContacts';
  email?: Maybe<Scalars['String']['output']>;
  /** ! Возможно в документации ошибка: mailing_addess */
  mailingAddress?: Maybe<Scalars['String']['output']>;
};

export type TNestedRealestateFileRealestateRecordRestrictionsEncumbrancesPersonsSubjectLegalEntityContactsObjectFilterType = {
  email?: InputMaybe<TStringFilter>;
  mailingAddress?: InputMaybe<TStringFilter>;
};

export type TNestedRealestateFileRealestateRecordRestrictionsEncumbrancesPersonsSubjectLegalEntityEntity = {
  __typename?: 'NestedRealestateFileRealestateRecordRestrictionsEncumbrancesPersonsSubjectLegalEntityEntity';
  /** Орган государственной власти, орган местного самоуправления, иной государственный орган */
  governmentEntity?: Maybe<TNestedRealestateFileRealestateRecordRestrictionsEncumbrancesPersonsSubjectLegalEntityEntityGovernmentEntity>;
  /** Иностранное юридическое лицо */
  notResident?: Maybe<TNestedRealestateFileRealestateRecordRestrictionsEncumbrancesPersonsSubjectLegalEntityEntityNotResident>;
  /** Российское юридическое лицо */
  resident?: Maybe<TNestedRealestateFileRealestateRecordRestrictionsEncumbrancesPersonsSubjectLegalEntityEntityResident>;
};

export type TNestedRealestateFileRealestateRecordRestrictionsEncumbrancesPersonsSubjectLegalEntityEntityGovernmentEntity = {
  __typename?: 'NestedRealestateFileRealestateRecordRestrictionsEncumbrancesPersonsSubjectLegalEntityEntityGovernmentEntity';
  inn?: Maybe<Scalars['String']['output']>;
  ogrn?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

export type TNestedRealestateFileRealestateRecordRestrictionsEncumbrancesPersonsSubjectLegalEntityEntityGovernmentEntityObjectFilterType = {
  inn?: InputMaybe<TStringFilter>;
  ogrn?: InputMaybe<TStringFilter>;
  title?: InputMaybe<TStringFilter>;
};

export type TNestedRealestateFileRealestateRecordRestrictionsEncumbrancesPersonsSubjectLegalEntityEntityNotResident = {
  __typename?: 'NestedRealestateFileRealestateRecordRestrictionsEncumbrancesPersonsSubjectLegalEntityEntityNotResident';
  /** Страна регистрации (инкорпорации) */
  incorporateCountry?: Maybe<TNestedRealestateFileRealestateRecordRestrictionsEncumbrancesPersonsSubjectLegalEntityEntityNotResidentIncorporateCountry>;
  /** Организационно-правовая форма */
  incorporationForm?: Maybe<TNestedRealestateFileRealestateRecordRestrictionsEncumbrancesPersonsSubjectLegalEntityEntityNotResidentIncorporationForm>;
  inn?: Maybe<Scalars['String']['output']>;
  /** Адрес (местонахождение) в стране регистрации (инкорпорации) */
  regAddress?: Maybe<Scalars['String']['output']>;
  /** Дата регистрации */
  registrationDate?: Maybe<Scalars['String']['output']>;
  /** Регистрационный номер */
  registrationNumber?: Maybe<Scalars['String']['output']>;
  /** Наименование регистрирующего органа */
  registrationOrgan?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

export type TNestedRealestateFileRealestateRecordRestrictionsEncumbrancesPersonsSubjectLegalEntityEntityNotResidentIncorporateCountry = {
  __typename?: 'NestedRealestateFileRealestateRecordRestrictionsEncumbrancesPersonsSubjectLegalEntityEntityNotResidentIncorporateCountry';
  /** код из справочника */
  code?: Maybe<Scalars['NumberString']['output']>;
  /** значение */
  value?: Maybe<Scalars['String']['output']>;
};

export type TNestedRealestateFileRealestateRecordRestrictionsEncumbrancesPersonsSubjectLegalEntityEntityNotResidentIncorporateCountryObjectFilterType = {
  code?: InputMaybe<TNumberStringFilter>;
  value?: InputMaybe<TStringFilter>;
};

export type TNestedRealestateFileRealestateRecordRestrictionsEncumbrancesPersonsSubjectLegalEntityEntityNotResidentIncorporationForm = {
  __typename?: 'NestedRealestateFileRealestateRecordRestrictionsEncumbrancesPersonsSubjectLegalEntityEntityNotResidentIncorporationForm';
  /** код из справочника */
  code?: Maybe<Scalars['NumberString']['output']>;
  /** значение */
  value?: Maybe<Scalars['String']['output']>;
};

export type TNestedRealestateFileRealestateRecordRestrictionsEncumbrancesPersonsSubjectLegalEntityEntityNotResidentIncorporationFormObjectFilterType = {
  code?: InputMaybe<TNumberStringFilter>;
  value?: InputMaybe<TStringFilter>;
};

export type TNestedRealestateFileRealestateRecordRestrictionsEncumbrancesPersonsSubjectLegalEntityEntityNotResidentObjectFilterType = {
  incorporateCountry?: InputMaybe<TNestedRealestateFileRealestateRecordRestrictionsEncumbrancesPersonsSubjectLegalEntityEntityNotResidentIncorporateCountryObjectFilterType>;
  incorporationForm?: InputMaybe<TNestedRealestateFileRealestateRecordRestrictionsEncumbrancesPersonsSubjectLegalEntityEntityNotResidentIncorporationFormObjectFilterType>;
  inn?: InputMaybe<TStringFilter>;
  regAddress?: InputMaybe<TStringFilter>;
  registrationDate?: InputMaybe<TStringFilter>;
  registrationNumber?: InputMaybe<TStringFilter>;
  registrationOrgan?: InputMaybe<TStringFilter>;
  title?: InputMaybe<TStringFilter>;
};

export type TNestedRealestateFileRealestateRecordRestrictionsEncumbrancesPersonsSubjectLegalEntityEntityObjectFilterType = {
  governmentEntity?: InputMaybe<TNestedRealestateFileRealestateRecordRestrictionsEncumbrancesPersonsSubjectLegalEntityEntityGovernmentEntityObjectFilterType>;
  notResident?: InputMaybe<TNestedRealestateFileRealestateRecordRestrictionsEncumbrancesPersonsSubjectLegalEntityEntityNotResidentObjectFilterType>;
  resident?: InputMaybe<TNestedRealestateFileRealestateRecordRestrictionsEncumbrancesPersonsSubjectLegalEntityEntityResidentObjectFilterType>;
};

export type TNestedRealestateFileRealestateRecordRestrictionsEncumbrancesPersonsSubjectLegalEntityEntityResident = {
  __typename?: 'NestedRealestateFileRealestateRecordRestrictionsEncumbrancesPersonsSubjectLegalEntityEntityResident';
  /** Организационно-правовая форма */
  incorporationForm?: Maybe<TNestedRealestateFileRealestateRecordRestrictionsEncumbrancesPersonsSubjectLegalEntityEntityResidentIncorporationForm>;
  inn?: Maybe<Scalars['String']['output']>;
  ogrn?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

export type TNestedRealestateFileRealestateRecordRestrictionsEncumbrancesPersonsSubjectLegalEntityEntityResidentIncorporationForm = {
  __typename?: 'NestedRealestateFileRealestateRecordRestrictionsEncumbrancesPersonsSubjectLegalEntityEntityResidentIncorporationForm';
  /** код из справочника */
  code?: Maybe<Scalars['NumberString']['output']>;
  /** значение */
  value?: Maybe<Scalars['String']['output']>;
};

export type TNestedRealestateFileRealestateRecordRestrictionsEncumbrancesPersonsSubjectLegalEntityEntityResidentIncorporationFormObjectFilterType = {
  code?: InputMaybe<TNumberStringFilter>;
  value?: InputMaybe<TStringFilter>;
};

export type TNestedRealestateFileRealestateRecordRestrictionsEncumbrancesPersonsSubjectLegalEntityEntityResidentObjectFilterType = {
  incorporationForm?: InputMaybe<TNestedRealestateFileRealestateRecordRestrictionsEncumbrancesPersonsSubjectLegalEntityEntityResidentIncorporationFormObjectFilterType>;
  inn?: InputMaybe<TStringFilter>;
  ogrn?: InputMaybe<TStringFilter>;
  title?: InputMaybe<TStringFilter>;
};

export type TNestedRealestateFileRealestateRecordRestrictionsEncumbrancesPersonsSubjectLegalEntityObjectFilterType = {
  contacts?: InputMaybe<TNestedRealestateFileRealestateRecordRestrictionsEncumbrancesPersonsSubjectLegalEntityContactsObjectFilterType>;
  entity?: InputMaybe<TNestedRealestateFileRealestateRecordRestrictionsEncumbrancesPersonsSubjectLegalEntityEntityObjectFilterType>;
  type?: InputMaybe<TNestedRealestateFileRealestateRecordRestrictionsEncumbrancesPersonsSubjectLegalEntityTypeObjectFilterType>;
};

export type TNestedRealestateFileRealestateRecordRestrictionsEncumbrancesPersonsSubjectLegalEntityType = {
  __typename?: 'NestedRealestateFileRealestateRecordRestrictionsEncumbrancesPersonsSubjectLegalEntityType';
  /** код из справочника */
  code?: Maybe<Scalars['NumberString']['output']>;
  /** значение */
  value?: Maybe<Scalars['String']['output']>;
};

export type TNestedRealestateFileRealestateRecordRestrictionsEncumbrancesPersonsSubjectLegalEntityTypeObjectFilterType = {
  code?: InputMaybe<TNumberStringFilter>;
  value?: InputMaybe<TStringFilter>;
};

export type TNestedRealestateFileRealestateRecordRestrictionsEncumbrancesPersonsSubjectObjectFilterType = {
  another?: InputMaybe<TNestedRealestateFileRealestateRecordRestrictionsEncumbrancesPersonsSubjectAnotherObjectFilterType>;
  individual?: InputMaybe<TNestedRealestateFileRealestateRecordRestrictionsEncumbrancesPersonsSubjectIndividualObjectFilterType>;
  legalEntity?: InputMaybe<TNestedRealestateFileRealestateRecordRestrictionsEncumbrancesPersonsSubjectLegalEntityObjectFilterType>;
  publicFormation?: InputMaybe<TNestedRealestateFileRealestateRecordRestrictionsEncumbrancesPersonsSubjectPublicFormationObjectFilterType>;
  publicServitude?: InputMaybe<TStringFilter>;
  somethingElse?: InputMaybe<TStringFilter>;
};

export type TNestedRealestateFileRealestateRecordRestrictionsEncumbrancesPersonsSubjectPublicFormation = {
  __typename?: 'NestedRealestateFileRealestateRecordRestrictionsEncumbrancesPersonsSubjectPublicFormation';
  /** Иностранное государство */
  foreign?: Maybe<Scalars['String']['output']>;
  /** Наименование муниципального образования */
  municipality?: Maybe<Scalars['String']['output']>;
  /** Российская Федерация */
  russia?: Maybe<TNestedRealestateFileRealestateRecordRestrictionsEncumbrancesPersonsSubjectPublicFormationRussia>;
  /** Наименование субъекта Российской Федерации */
  subjectOfRf?: Maybe<TNestedRealestateFileRealestateRecordRestrictionsEncumbrancesPersonsSubjectPublicFormationSubjectOfRf>;
  /** Союзное государство */
  union?: Maybe<Scalars['String']['output']>;
};

export type TNestedRealestateFileRealestateRecordRestrictionsEncumbrancesPersonsSubjectPublicFormationObjectFilterType = {
  foreign?: InputMaybe<TStringFilter>;
  municipality?: InputMaybe<TStringFilter>;
  russia?: InputMaybe<TNestedRealestateFileRealestateRecordRestrictionsEncumbrancesPersonsSubjectPublicFormationRussiaObjectFilterType>;
  subjectOfRf?: InputMaybe<TNestedRealestateFileRealestateRecordRestrictionsEncumbrancesPersonsSubjectPublicFormationSubjectOfRfObjectFilterType>;
  union?: InputMaybe<TStringFilter>;
};

export type TNestedRealestateFileRealestateRecordRestrictionsEncumbrancesPersonsSubjectPublicFormationRussia = {
  __typename?: 'NestedRealestateFileRealestateRecordRestrictionsEncumbrancesPersonsSubjectPublicFormationRussia';
  /** код из справочника */
  code?: Maybe<Scalars['NumberString']['output']>;
  /** значение */
  value?: Maybe<Scalars['String']['output']>;
};

export type TNestedRealestateFileRealestateRecordRestrictionsEncumbrancesPersonsSubjectPublicFormationRussiaObjectFilterType = {
  code?: InputMaybe<TNumberStringFilter>;
  value?: InputMaybe<TStringFilter>;
};

export type TNestedRealestateFileRealestateRecordRestrictionsEncumbrancesPersonsSubjectPublicFormationSubjectOfRf = {
  __typename?: 'NestedRealestateFileRealestateRecordRestrictionsEncumbrancesPersonsSubjectPublicFormationSubjectOfRf';
  /** код из справочника */
  code?: Maybe<Scalars['NumberString']['output']>;
  /** значение */
  value?: Maybe<Scalars['String']['output']>;
};

export type TNestedRealestateFileRealestateRecordRestrictionsEncumbrancesPersonsSubjectPublicFormationSubjectOfRfObjectFilterType = {
  code?: InputMaybe<TNumberStringFilter>;
  value?: InputMaybe<TStringFilter>;
};

export type TNestedRealestateFileRealestateRecordRestrictionsEncumbrancesPersonsType = {
  __typename?: 'NestedRealestateFileRealestateRecordRestrictionsEncumbrancesPersonsType';
  /** код из справочника */
  code?: Maybe<Scalars['NumberString']['output']>;
  /** значение */
  value?: Maybe<Scalars['String']['output']>;
};

export type TNestedRealestateFileRealestateRecordRestrictionsEncumbrancesPersonsTypeObjectFilterType = {
  code?: InputMaybe<TNumberStringFilter>;
  value?: InputMaybe<TStringFilter>;
};

export type TNestedRealestateFileRealestateRecordRestrictionsEncumbrancesUnderlyingDocs = {
  __typename?: 'NestedRealestateFileRealestateRecordRestrictionsEncumbrancesUnderlyingDocs';
  /** Код документа */
  code?: Maybe<TNestedRealestateFileRealestateRecordRestrictionsEncumbrancesUnderlyingDocsCode>;
  /** Дата документа */
  date?: Maybe<Scalars['String']['output']>;
  /** Нотариальное удостоверение документа */
  docNotarized?: Maybe<TNestedRealestateFileRealestateRecordRestrictionsEncumbrancesUnderlyingDocsDocNotarized>;
  /** Полное наименование должности должностного лица */
  fullnamePostsPerson?: Maybe<Scalars['String']['output']>;
  /** Орган власти, организация, выдавшие документ */
  issuer?: Maybe<Scalars['String']['output']>;
  /** Наименование документа */
  name?: Maybe<Scalars['String']['output']>;
  /** Номер документа */
  number?: Maybe<Scalars['String']['output']>;
  /** Серия документа */
  series?: Maybe<Scalars['String']['output']>;
};

export type TNestedRealestateFileRealestateRecordRestrictionsEncumbrancesUnderlyingDocsCode = {
  __typename?: 'NestedRealestateFileRealestateRecordRestrictionsEncumbrancesUnderlyingDocsCode';
  /** код из справочника */
  code?: Maybe<Scalars['NumberString']['output']>;
  /** значение */
  value?: Maybe<Scalars['String']['output']>;
};

export type TNestedRealestateFileRealestateRecordRestrictionsEncumbrancesUnderlyingDocsCodeObjectFilterType = {
  code?: InputMaybe<TNumberStringFilter>;
  value?: InputMaybe<TStringFilter>;
};

export type TNestedRealestateFileRealestateRecordRestrictionsEncumbrancesUnderlyingDocsDocNotarized = {
  __typename?: 'NestedRealestateFileRealestateRecordRestrictionsEncumbrancesUnderlyingDocsDocNotarized';
  /** Дата нотариального удостоверения */
  notarizeDate?: Maybe<Scalars['String']['output']>;
  /** Номер в реестре регистрации нотариальных действий */
  notaryActionNum?: Maybe<Scalars['String']['output']>;
  /** Фамилия и инициалы нотариуса */
  notaryName?: Maybe<Scalars['String']['output']>;
};

export type TNestedRealestateFileRealestateRecordRestrictionsEncumbrancesUnderlyingDocsDocNotarizedObjectFilterType = {
  notarizeDate?: InputMaybe<TStringFilter>;
  notaryActionNum?: InputMaybe<TStringFilter>;
  notaryName?: InputMaybe<TStringFilter>;
};

export type TNestedRealestateFileRealestateRecordRestrictionsEncumbrancesUnderlyingDocsObjectFilterType = {
  code?: InputMaybe<TNestedRealestateFileRealestateRecordRestrictionsEncumbrancesUnderlyingDocsCodeObjectFilterType>;
  date?: InputMaybe<TStringFilter>;
  docNotarized?: InputMaybe<TNestedRealestateFileRealestateRecordRestrictionsEncumbrancesUnderlyingDocsDocNotarizedObjectFilterType>;
  fullnamePostsPerson?: InputMaybe<TStringFilter>;
  issuer?: InputMaybe<TStringFilter>;
  name?: InputMaybe<TStringFilter>;
  number?: InputMaybe<TStringFilter>;
  series?: InputMaybe<TStringFilter>;
};

export type TNestedRealestateFileRealestateRecordSurveyBoundaries = {
  __typename?: 'NestedRealestateFileRealestateRecordSurveyBoundaries';
  /** Реквизиты акта об утверждении проекта межевания территории */
  actRequisites?: Maybe<TNestedRealestateFileRealestateRecordSurveyBoundariesActRequisites>;
  /** Сведения о лице (лицах), утвердивших проект межевания земельного участка */
  approvePersons?: Maybe<Array<Maybe<TNestedRealestateFileRealestateRecordSurveyBoundariesApprovePersons>>>;
  /** Реквизиты решения */
  decisionRequisites?: Maybe<TNestedRealestateFileRealestateRecordSurveyBoundariesDecisionRequisites>;
  /** Условный номер земельного участка */
  nominalNumber?: Maybe<Scalars['String']['output']>;
  /** Реквизиты протокола, подготовленного по результатам общего собрания участников долевой собственности на земельный участок */
  protocolRequisites?: Maybe<TNestedRealestateFileRealestateRecordSurveyBoundariesProtocolRequisites>;
  /** Дата присвоения учетного номера проекту межевания */
  registrationDate?: Maybe<Scalars['String']['output']>;
  /** Учетный номер проекта межевания */
  surveyProjectNum?: Maybe<Scalars['String']['output']>;
};


export type TNestedRealestateFileRealestateRecordSurveyBoundariesApprovePersonsArgs = {
  pagination?: InputMaybe<TPagination>;
};

export type TNestedRealestateFileRealestateRecordSurveyBoundariesActRequisites = {
  __typename?: 'NestedRealestateFileRealestateRecordSurveyBoundariesActRequisites';
  /** Код документа */
  code?: Maybe<TNestedRealestateFileRealestateRecordSurveyBoundariesActRequisitesCode>;
  /** Дата документа */
  date?: Maybe<Scalars['String']['output']>;
  /** Орган власти, организация, выдавшие документ. Автор документа */
  issuer?: Maybe<Scalars['String']['output']>;
  /** Номер документа */
  number?: Maybe<Scalars['String']['output']>;
};

export type TNestedRealestateFileRealestateRecordSurveyBoundariesActRequisitesCode = {
  __typename?: 'NestedRealestateFileRealestateRecordSurveyBoundariesActRequisitesCode';
  /** код из справочника */
  code?: Maybe<Scalars['NumberString']['output']>;
  /** значение */
  value?: Maybe<Scalars['String']['output']>;
};

export type TNestedRealestateFileRealestateRecordSurveyBoundariesActRequisitesCodeObjectFilterType = {
  code?: InputMaybe<TNumberStringFilter>;
  value?: InputMaybe<TStringFilter>;
};

export type TNestedRealestateFileRealestateRecordSurveyBoundariesActRequisitesObjectFilterType = {
  code?: InputMaybe<TNestedRealestateFileRealestateRecordSurveyBoundariesActRequisitesCodeObjectFilterType>;
  date?: InputMaybe<TStringFilter>;
  issuer?: InputMaybe<TStringFilter>;
  number?: InputMaybe<TStringFilter>;
};

export type TNestedRealestateFileRealestateRecordSurveyBoundariesApprovePersons = {
  __typename?: 'NestedRealestateFileRealestateRecordSurveyBoundariesApprovePersons';
  /** Фамилия, имя, отчество физического лица */
  individual?: Maybe<TNestedRealestateFileRealestateRecordSurveyBoundariesApprovePersonsIndividual>;
  /** Полное наименование юридического лица */
  legalEntity?: Maybe<Scalars['String']['output']>;
};

export type TNestedRealestateFileRealestateRecordSurveyBoundariesApprovePersonsIndividual = {
  __typename?: 'NestedRealestateFileRealestateRecordSurveyBoundariesApprovePersonsIndividual';
  /** Имя */
  firstName?: Maybe<Scalars['String']['output']>;
  /** Фамилия */
  lastName?: Maybe<Scalars['String']['output']>;
  /** Отчество */
  middleName?: Maybe<Scalars['String']['output']>;
};

export type TNestedRealestateFileRealestateRecordSurveyBoundariesApprovePersonsIndividualObjectFilterType = {
  firstName?: InputMaybe<TStringFilter>;
  lastName?: InputMaybe<TStringFilter>;
  middleName?: InputMaybe<TStringFilter>;
};

export type TNestedRealestateFileRealestateRecordSurveyBoundariesApprovePersonsObjectFilterType = {
  individual?: InputMaybe<TNestedRealestateFileRealestateRecordSurveyBoundariesApprovePersonsIndividualObjectFilterType>;
  legalEntity?: InputMaybe<TStringFilter>;
};

export type TNestedRealestateFileRealestateRecordSurveyBoundariesDecisionRequisites = {
  __typename?: 'NestedRealestateFileRealestateRecordSurveyBoundariesDecisionRequisites';
  /** Код документа */
  code?: Maybe<TNestedRealestateFileRealestateRecordSurveyBoundariesDecisionRequisitesCode>;
  /** Дата документа */
  date?: Maybe<Scalars['String']['output']>;
  /** Орган власти, организация, выдавшие документ. Автор документа */
  issuer?: Maybe<Scalars['String']['output']>;
  /** Номер документа */
  number?: Maybe<Scalars['String']['output']>;
};

export type TNestedRealestateFileRealestateRecordSurveyBoundariesDecisionRequisitesCode = {
  __typename?: 'NestedRealestateFileRealestateRecordSurveyBoundariesDecisionRequisitesCode';
  /** код из справочника */
  code?: Maybe<Scalars['NumberString']['output']>;
  /** значение */
  value?: Maybe<Scalars['String']['output']>;
};

export type TNestedRealestateFileRealestateRecordSurveyBoundariesDecisionRequisitesCodeObjectFilterType = {
  code?: InputMaybe<TNumberStringFilter>;
  value?: InputMaybe<TStringFilter>;
};

export type TNestedRealestateFileRealestateRecordSurveyBoundariesDecisionRequisitesObjectFilterType = {
  code?: InputMaybe<TNestedRealestateFileRealestateRecordSurveyBoundariesDecisionRequisitesCodeObjectFilterType>;
  date?: InputMaybe<TStringFilter>;
  issuer?: InputMaybe<TStringFilter>;
  number?: InputMaybe<TStringFilter>;
};

export type TNestedRealestateFileRealestateRecordSurveyBoundariesObjectFilterType = {
  actRequisites?: InputMaybe<TNestedRealestateFileRealestateRecordSurveyBoundariesActRequisitesObjectFilterType>;
  approvePersons?: InputMaybe<TNestedRealestateFileRealestateRecordSurveyBoundariesApprovePersonsObjectFilterType>;
  decisionRequisites?: InputMaybe<TNestedRealestateFileRealestateRecordSurveyBoundariesDecisionRequisitesObjectFilterType>;
  nominalNumber?: InputMaybe<TStringFilter>;
  protocolRequisites?: InputMaybe<TNestedRealestateFileRealestateRecordSurveyBoundariesProtocolRequisitesObjectFilterType>;
  registrationDate?: InputMaybe<TStringFilter>;
  surveyProjectNum?: InputMaybe<TStringFilter>;
};

export type TNestedRealestateFileRealestateRecordSurveyBoundariesProtocolRequisites = {
  __typename?: 'NestedRealestateFileRealestateRecordSurveyBoundariesProtocolRequisites';
  /** Код документа */
  code?: Maybe<TNestedRealestateFileRealestateRecordSurveyBoundariesProtocolRequisitesCode>;
  /** Дата документа */
  date?: Maybe<Scalars['String']['output']>;
  /** Орган власти, организация, выдавшие документ. Автор документа */
  issuer?: Maybe<Scalars['String']['output']>;
  /** Номер документа */
  number?: Maybe<Scalars['String']['output']>;
};

export type TNestedRealestateFileRealestateRecordSurveyBoundariesProtocolRequisitesCode = {
  __typename?: 'NestedRealestateFileRealestateRecordSurveyBoundariesProtocolRequisitesCode';
  /** код из справочника */
  code?: Maybe<Scalars['NumberString']['output']>;
  /** значение */
  value?: Maybe<Scalars['String']['output']>;
};

export type TNestedRealestateFileRealestateRecordSurveyBoundariesProtocolRequisitesCodeObjectFilterType = {
  code?: InputMaybe<TNumberStringFilter>;
  value?: InputMaybe<TStringFilter>;
};

export type TNestedRealestateFileRealestateRecordSurveyBoundariesProtocolRequisitesObjectFilterType = {
  code?: InputMaybe<TNestedRealestateFileRealestateRecordSurveyBoundariesProtocolRequisitesCodeObjectFilterType>;
  date?: InputMaybe<TStringFilter>;
  issuer?: InputMaybe<TStringFilter>;
  number?: InputMaybe<TStringFilter>;
};

export type TNestedRealestateFileRealestateRecordZonesAndBoundaries = {
  __typename?: 'NestedRealestateFileRealestateRecordZonesAndBoundaries';
  /** Сведения о расположении земельного участка в границах особо охраняемой природной территории, охотничьих угодий, лесничеств, лесопарков */
  guardedNaturalBoundaries?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Сведения о расположении земельного участка в границах особо охраняемой природной территории, охотничьих угодий, лесничеств, лесопарков */
  specialEconomicBoundary?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Сведения о расположении земельного участка полностью или частично в границах зоны с особыми условиями использования территории или территории объекта культурного наследия */
  specialUseBoundaries?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};


export type TNestedRealestateFileRealestateRecordZonesAndBoundariesGuardedNaturalBoundariesArgs = {
  pagination?: InputMaybe<TPagination>;
};


export type TNestedRealestateFileRealestateRecordZonesAndBoundariesSpecialEconomicBoundaryArgs = {
  pagination?: InputMaybe<TPagination>;
};


export type TNestedRealestateFileRealestateRecordZonesAndBoundariesSpecialUseBoundariesArgs = {
  pagination?: InputMaybe<TPagination>;
};

export type TNestedRealestateFileRealestateRecordZonesAndBoundariesObjectFilterType = {
  guardedNaturalBoundaries?: InputMaybe<TStringFilter>;
  specialEconomicBoundary?: InputMaybe<TStringFilter>;
  specialUseBoundaries?: InputMaybe<TStringFilter>;
};

export type TNestedRealestateFileRestrictRecords = {
  __typename?: 'NestedRealestateFileRestrictRecords';
  recordInfo?: Maybe<TNestedRealestateFileRestrictRecordsRecordInfo>;
  /** Номер регистрации ограничения права или обременения объекта недвижимости */
  restrictionsEncumbrancesData?: Maybe<TNestedRealestateFileRestrictRecordsRestrictionsEncumbrancesData>;
  rightHolders?: Maybe<Array<Maybe<TNestedRealestateFileRestrictRecordsRightHolders>>>;
  underlyingDocuments?: Maybe<Array<Maybe<TNestedRealestateFileRestrictRecordsUnderlyingDocuments>>>;
};


export type TNestedRealestateFileRestrictRecordsRightHoldersArgs = {
  pagination?: InputMaybe<TPagination>;
};


export type TNestedRealestateFileRestrictRecordsUnderlyingDocumentsArgs = {
  pagination?: InputMaybe<TPagination>;
};

export type TNestedRealestateFileRestrictRecordsObjectFilterType = {
  recordInfo?: InputMaybe<TNestedRealestateFileRestrictRecordsRecordInfoObjectFilterType>;
  restrictionsEncumbrancesData?: InputMaybe<TNestedRealestateFileRestrictRecordsRestrictionsEncumbrancesDataObjectFilterType>;
  rightHolders?: InputMaybe<TNestedRealestateFileRestrictRecordsRightHoldersObjectFilterType>;
  underlyingDocuments?: InputMaybe<TNestedRealestateFileRestrictRecordsUnderlyingDocumentsObjectFilterType>;
};

export type TNestedRealestateFileRestrictRecordsRecordInfo = {
  __typename?: 'NestedRealestateFileRestrictRecordsRecordInfo';
  /** Дата снятия с учета / регистрации */
  cancelDate?: Maybe<Scalars['String']['output']>;
  /** Дата постановки на учет / регистрации */
  registrationDate?: Maybe<Scalars['DateTimeISO']['output']>;
};

export type TNestedRealestateFileRestrictRecordsRecordInfoObjectFilterType = {
  cancelDate?: InputMaybe<TStringFilter>;
  registrationDate?: InputMaybe<TDateTimeIsoFilter>;
};

export type TNestedRealestateFileRestrictRecordsRestrictionsEncumbrancesData = {
  __typename?: 'NestedRealestateFileRestrictRecordsRestrictionsEncumbrancesData';
  /** Дополнительная информация в зависимости от вида зарегистрированного ограничения права или обременения объекта недвижимости */
  additionalInfo?: Maybe<TNestedRealestateFileRestrictRecordsRestrictionsEncumbrancesDataAdditionalInfo>;
  /** Номер регистрации ограничения права или обременения объекта недвижимости */
  number?: Maybe<Scalars['String']['output']>;
  /** Дата начала действия */
  period?: Maybe<TNestedRealestateFileRestrictRecordsRestrictionsEncumbrancesDataPeriod>;
  /** Ограничиваемые права */
  restrictingRights?: Maybe<Array<Maybe<TNestedRealestateFileRestrictRecordsRestrictionsEncumbrancesDataRestrictingRights>>>;
  /** Вид зарегистрированного ограничения права или обременения объекта недвижимости */
  type?: Maybe<TNestedRealestateFileRestrictRecordsRestrictionsEncumbrancesDataType>;
};


export type TNestedRealestateFileRestrictRecordsRestrictionsEncumbrancesDataRestrictingRightsArgs = {
  pagination?: InputMaybe<TPagination>;
};

export type TNestedRealestateFileRestrictRecordsRestrictionsEncumbrancesDataAdditionalInfo = {
  __typename?: 'NestedRealestateFileRestrictRecordsRestrictionsEncumbrancesDataAdditionalInfo';
  /** Условия сервитута */
  servitudeCondition?: Maybe<Scalars['String']['output']>;
  /** Вид сервитута */
  servitudeType?: Maybe<TNestedRealestateFileRestrictRecordsRestrictionsEncumbrancesDataAdditionalInfoServitudeType>;
};

export type TNestedRealestateFileRestrictRecordsRestrictionsEncumbrancesDataAdditionalInfoObjectFilterType = {
  servitudeCondition?: InputMaybe<TStringFilter>;
  servitudeType?: InputMaybe<TNestedRealestateFileRestrictRecordsRestrictionsEncumbrancesDataAdditionalInfoServitudeTypeObjectFilterType>;
};

export type TNestedRealestateFileRestrictRecordsRestrictionsEncumbrancesDataAdditionalInfoServitudeType = {
  __typename?: 'NestedRealestateFileRestrictRecordsRestrictionsEncumbrancesDataAdditionalInfoServitudeType';
  /** код из справочника */
  code?: Maybe<Scalars['NumberString']['output']>;
  /** значение */
  value?: Maybe<Scalars['String']['output']>;
};

export type TNestedRealestateFileRestrictRecordsRestrictionsEncumbrancesDataAdditionalInfoServitudeTypeObjectFilterType = {
  code?: InputMaybe<TNumberStringFilter>;
  value?: InputMaybe<TStringFilter>;
};

export type TNestedRealestateFileRestrictRecordsRestrictionsEncumbrancesDataObjectFilterType = {
  additionalInfo?: InputMaybe<TNestedRealestateFileRestrictRecordsRestrictionsEncumbrancesDataAdditionalInfoObjectFilterType>;
  number?: InputMaybe<TStringFilter>;
  period?: InputMaybe<TNestedRealestateFileRestrictRecordsRestrictionsEncumbrancesDataPeriodObjectFilterType>;
  restrictingRights?: InputMaybe<TNestedRealestateFileRestrictRecordsRestrictionsEncumbrancesDataRestrictingRightsObjectFilterType>;
  type?: InputMaybe<TNestedRealestateFileRestrictRecordsRestrictionsEncumbrancesDataTypeObjectFilterType>;
};

export type TNestedRealestateFileRestrictRecordsRestrictionsEncumbrancesDataPeriod = {
  __typename?: 'NestedRealestateFileRestrictRecordsRestrictionsEncumbrancesDataPeriod';
  /** Срок действия ограничения/обременения (Продолжительность) */
  dealValidityTime?: Maybe<Scalars['String']['output']>;
  /** Дата прекращения действия */
  endDate?: Maybe<Scalars['String']['output']>;
  /** Дата начала действия */
  startDate?: Maybe<Scalars['String']['output']>;
};

export type TNestedRealestateFileRestrictRecordsRestrictionsEncumbrancesDataPeriodObjectFilterType = {
  dealValidityTime?: InputMaybe<TStringFilter>;
  endDate?: InputMaybe<TStringFilter>;
  startDate?: InputMaybe<TStringFilter>;
};

export type TNestedRealestateFileRestrictRecordsRestrictionsEncumbrancesDataRestrictingRights = {
  __typename?: 'NestedRealestateFileRestrictRecordsRestrictionsEncumbrancesDataRestrictingRights';
  /** Номер реестровой записи */
  number?: Maybe<Scalars['String']['output']>;
  /** Номер регистрации вещного права */
  rightNumber?: Maybe<Scalars['String']['output']>;
};

export type TNestedRealestateFileRestrictRecordsRestrictionsEncumbrancesDataRestrictingRightsObjectFilterType = {
  number?: InputMaybe<TStringFilter>;
  rightNumber?: InputMaybe<TStringFilter>;
};

export type TNestedRealestateFileRestrictRecordsRestrictionsEncumbrancesDataType = {
  __typename?: 'NestedRealestateFileRestrictRecordsRestrictionsEncumbrancesDataType';
  /** код из справочника */
  code?: Maybe<Scalars['NumberString']['output']>;
  /** значение */
  value?: Maybe<Scalars['String']['output']>;
};

export type TNestedRealestateFileRestrictRecordsRestrictionsEncumbrancesDataTypeObjectFilterType = {
  code?: InputMaybe<TNumberStringFilter>;
  value?: InputMaybe<TStringFilter>;
};

export type TNestedRealestateFileRestrictRecordsRightHolders = {
  __typename?: 'NestedRealestateFileRestrictRecordsRightHolders';
  /** Иное лицо, в пользу которого установлены ограничения права и обременения объекта недвижимости */
  another?: Maybe<TNestedRealestateFileRestrictRecordsRightHoldersAnother>;
  /** Физическое лицо */
  individual?: Maybe<TNestedRealestateFileRestrictRecordsRightHoldersIndividual>;
  /** Юридическое лицо, орган власти */
  legalEntity?: Maybe<TNestedRealestateFileRestrictRecordsRightHoldersLegalEntity>;
  /** Публично-правовое образование */
  publicFormation?: Maybe<TNestedRealestateFileRestrictRecordsRightHoldersPublicFormation>;
  /** Публичный сервитут */
  publicServitude?: Maybe<Scalars['String']['output']>;
  /** Не определено (тип undefined в документации) */
  somethingElse?: Maybe<Scalars['String']['output']>;
};

export type TNestedRealestateFileRestrictRecordsRightHoldersAnother = {
  __typename?: 'NestedRealestateFileRestrictRecordsRightHoldersAnother';
  /** Собственники помещений в многоквартирном доме */
  aparthouseOwners?: Maybe<Scalars['String']['output']>;
  /** Владельцы облигаций */
  bondsHolders?: Maybe<TNestedRealestateFileRestrictRecordsRightHoldersAnotherBondsHolders>;
  /** Индивидуальное обозначение, идентифицирующее ипотечные сертификаты участия, в интересах владельцев которых осуществляется доверительное управление таким ипотечным покрытием */
  certificatesHolders?: Maybe<Scalars['String']['output']>;
  /** Участники долевого строительства */
  equityParticipantsInfo?: Maybe<Scalars['String']['output']>;
  /** Название (индивидуальное обозначение), идентифицирующее паевой инвестиционный фонд */
  investmentUnitOwner?: Maybe<Scalars['String']['output']>;
  /** Участники долевого строительства по договорам участия в долевом строительстве, которым не переданы объекты долевого строительства */
  notEquityParticipantsInfo?: Maybe<Scalars['String']['output']>;
  /** Иной субъект */
  other?: Maybe<TNestedRealestateFileRestrictRecordsRightHoldersAnotherOther>;
  /** Инвестиционное товарищество */
  partnership?: Maybe<TNestedRealestateFileRestrictRecordsRightHoldersAnotherPartnership>;
};

export type TNestedRealestateFileRestrictRecordsRightHoldersAnotherBondsHolders = {
  __typename?: 'NestedRealestateFileRestrictRecordsRightHoldersAnotherBondsHolders';
  /** Дата государственной регистрации номера выпуска облигаций */
  issueDate?: Maybe<Scalars['String']['output']>;
  /** Государственный регистрационный номер выпуска облигаций */
  number?: Maybe<Scalars['String']['output']>;
};

export type TNestedRealestateFileRestrictRecordsRightHoldersAnotherBondsHoldersObjectFilterType = {
  issueDate?: InputMaybe<TStringFilter>;
  number?: InputMaybe<TStringFilter>;
};

export type TNestedRealestateFileRestrictRecordsRightHoldersAnotherObjectFilterType = {
  aparthouseOwners?: InputMaybe<TStringFilter>;
  bondsHolders?: InputMaybe<TNestedRealestateFileRestrictRecordsRightHoldersAnotherBondsHoldersObjectFilterType>;
  certificatesHolders?: InputMaybe<TStringFilter>;
  equityParticipantsInfo?: InputMaybe<TStringFilter>;
  investmentUnitOwner?: InputMaybe<TStringFilter>;
  notEquityParticipantsInfo?: InputMaybe<TStringFilter>;
  other?: InputMaybe<TNestedRealestateFileRestrictRecordsRightHoldersAnotherOtherObjectFilterType>;
  partnership?: InputMaybe<TNestedRealestateFileRestrictRecordsRightHoldersAnotherPartnershipObjectFilterType>;
};

export type TNestedRealestateFileRestrictRecordsRightHoldersAnotherOther = {
  __typename?: 'NestedRealestateFileRestrictRecordsRightHoldersAnotherOther';
  /** Комментарий */
  comment?: Maybe<Scalars['String']['output']>;
  contacts?: Maybe<TNestedRealestateFileRestrictRecordsRightHoldersAnotherOtherContacts>;
  /** Наименование для печати */
  printText?: Maybe<Scalars['String']['output']>;
  /** Регистрирующий орган */
  registrationOrgan?: Maybe<Scalars['String']['output']>;
  /** Краткое наименование */
  shortTitle?: Maybe<Scalars['String']['output']>;
  /** Наименование */
  title?: Maybe<Scalars['String']['output']>;
};

export type TNestedRealestateFileRestrictRecordsRightHoldersAnotherOtherContacts = {
  __typename?: 'NestedRealestateFileRestrictRecordsRightHoldersAnotherOtherContacts';
  email?: Maybe<Scalars['String']['output']>;
  /** ! Возможно в документации ошибка: mailing_addess */
  mailingAddress?: Maybe<Scalars['String']['output']>;
};

export type TNestedRealestateFileRestrictRecordsRightHoldersAnotherOtherContactsObjectFilterType = {
  email?: InputMaybe<TStringFilter>;
  mailingAddress?: InputMaybe<TStringFilter>;
};

export type TNestedRealestateFileRestrictRecordsRightHoldersAnotherOtherObjectFilterType = {
  comment?: InputMaybe<TStringFilter>;
  contacts?: InputMaybe<TNestedRealestateFileRestrictRecordsRightHoldersAnotherOtherContactsObjectFilterType>;
  printText?: InputMaybe<TStringFilter>;
  registrationOrgan?: InputMaybe<TStringFilter>;
  shortTitle?: InputMaybe<TStringFilter>;
  title?: InputMaybe<TStringFilter>;
};

export type TNestedRealestateFileRestrictRecordsRightHoldersAnotherPartnership = {
  __typename?: 'NestedRealestateFileRestrictRecordsRightHoldersAnotherPartnership';
  /** Участник договора инвестиционного товарищества */
  participants?: Maybe<Array<Maybe<TNestedRealestateFileRestrictRecordsRightHoldersAnotherPartnershipParticipants>>>;
};


export type TNestedRealestateFileRestrictRecordsRightHoldersAnotherPartnershipParticipantsArgs = {
  pagination?: InputMaybe<TPagination>;
};

export type TNestedRealestateFileRestrictRecordsRightHoldersAnotherPartnershipObjectFilterType = {
  participants?: InputMaybe<TNestedRealestateFileRestrictRecordsRightHoldersAnotherPartnershipParticipantsObjectFilterType>;
};

export type TNestedRealestateFileRestrictRecordsRightHoldersAnotherPartnershipParticipants = {
  __typename?: 'NestedRealestateFileRestrictRecordsRightHoldersAnotherPartnershipParticipants';
  contacts?: Maybe<TNestedRealestateFileRestrictRecordsRightHoldersAnotherPartnershipParticipantsContacts>;
  legalEntity?: Maybe<TNestedRealestateFileRestrictRecordsRightHoldersAnotherPartnershipParticipantsLegalEntity>;
};

export type TNestedRealestateFileRestrictRecordsRightHoldersAnotherPartnershipParticipantsContacts = {
  __typename?: 'NestedRealestateFileRestrictRecordsRightHoldersAnotherPartnershipParticipantsContacts';
  email?: Maybe<Scalars['String']['output']>;
  /** ! Возможно в документации ошибка: mailing_addess */
  mailingAddress?: Maybe<Scalars['String']['output']>;
};

export type TNestedRealestateFileRestrictRecordsRightHoldersAnotherPartnershipParticipantsContactsObjectFilterType = {
  email?: InputMaybe<TStringFilter>;
  mailingAddress?: InputMaybe<TStringFilter>;
};

export type TNestedRealestateFileRestrictRecordsRightHoldersAnotherPartnershipParticipantsLegalEntity = {
  __typename?: 'NestedRealestateFileRestrictRecordsRightHoldersAnotherPartnershipParticipantsLegalEntity';
  notResident?: Maybe<TNestedRealestateFileRestrictRecordsRightHoldersAnotherPartnershipParticipantsLegalEntityNotResident>;
  resident?: Maybe<TNestedRealestateFileRestrictRecordsRightHoldersAnotherPartnershipParticipantsLegalEntityResident>;
};

export type TNestedRealestateFileRestrictRecordsRightHoldersAnotherPartnershipParticipantsLegalEntityNotResident = {
  __typename?: 'NestedRealestateFileRestrictRecordsRightHoldersAnotherPartnershipParticipantsLegalEntityNotResident';
  /** Страна регистрации (инкорпорации) */
  incorporateCountry?: Maybe<TNestedRealestateFileRestrictRecordsRightHoldersAnotherPartnershipParticipantsLegalEntityNotResidentIncorporateCountry>;
  /** Организационно-правовая форма */
  incorporationForm?: Maybe<TNestedRealestateFileRestrictRecordsRightHoldersAnotherPartnershipParticipantsLegalEntityNotResidentIncorporationForm>;
  inn?: Maybe<Scalars['String']['output']>;
  /** Адрес (местонахождение) в стране регистрации (инкорпорации) */
  regAddress?: Maybe<Scalars['String']['output']>;
  /** Дата регистрации */
  registrationDate?: Maybe<Scalars['String']['output']>;
  /** Регистрационный номер */
  registrationNumber?: Maybe<Scalars['String']['output']>;
  /** Наименование регистрирующего органа */
  registrationOrgan?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

export type TNestedRealestateFileRestrictRecordsRightHoldersAnotherPartnershipParticipantsLegalEntityNotResidentIncorporateCountry = {
  __typename?: 'NestedRealestateFileRestrictRecordsRightHoldersAnotherPartnershipParticipantsLegalEntityNotResidentIncorporateCountry';
  /** код из справочника */
  code?: Maybe<Scalars['NumberString']['output']>;
  /** значение */
  value?: Maybe<Scalars['String']['output']>;
};

export type TNestedRealestateFileRestrictRecordsRightHoldersAnotherPartnershipParticipantsLegalEntityNotResidentIncorporateCountryObjectFilterType = {
  code?: InputMaybe<TNumberStringFilter>;
  value?: InputMaybe<TStringFilter>;
};

export type TNestedRealestateFileRestrictRecordsRightHoldersAnotherPartnershipParticipantsLegalEntityNotResidentIncorporationForm = {
  __typename?: 'NestedRealestateFileRestrictRecordsRightHoldersAnotherPartnershipParticipantsLegalEntityNotResidentIncorporationForm';
  /** код из справочника */
  code?: Maybe<Scalars['NumberString']['output']>;
  /** значение */
  value?: Maybe<Scalars['String']['output']>;
};

export type TNestedRealestateFileRestrictRecordsRightHoldersAnotherPartnershipParticipantsLegalEntityNotResidentIncorporationFormObjectFilterType = {
  code?: InputMaybe<TNumberStringFilter>;
  value?: InputMaybe<TStringFilter>;
};

export type TNestedRealestateFileRestrictRecordsRightHoldersAnotherPartnershipParticipantsLegalEntityNotResidentObjectFilterType = {
  incorporateCountry?: InputMaybe<TNestedRealestateFileRestrictRecordsRightHoldersAnotherPartnershipParticipantsLegalEntityNotResidentIncorporateCountryObjectFilterType>;
  incorporationForm?: InputMaybe<TNestedRealestateFileRestrictRecordsRightHoldersAnotherPartnershipParticipantsLegalEntityNotResidentIncorporationFormObjectFilterType>;
  inn?: InputMaybe<TStringFilter>;
  regAddress?: InputMaybe<TStringFilter>;
  registrationDate?: InputMaybe<TStringFilter>;
  registrationNumber?: InputMaybe<TStringFilter>;
  registrationOrgan?: InputMaybe<TStringFilter>;
  title?: InputMaybe<TStringFilter>;
};

export type TNestedRealestateFileRestrictRecordsRightHoldersAnotherPartnershipParticipantsLegalEntityObjectFilterType = {
  notResident?: InputMaybe<TNestedRealestateFileRestrictRecordsRightHoldersAnotherPartnershipParticipantsLegalEntityNotResidentObjectFilterType>;
  resident?: InputMaybe<TNestedRealestateFileRestrictRecordsRightHoldersAnotherPartnershipParticipantsLegalEntityResidentObjectFilterType>;
};

export type TNestedRealestateFileRestrictRecordsRightHoldersAnotherPartnershipParticipantsLegalEntityResident = {
  __typename?: 'NestedRealestateFileRestrictRecordsRightHoldersAnotherPartnershipParticipantsLegalEntityResident';
  /** Организационно-правовая форма */
  incorporationForm?: Maybe<TNestedRealestateFileRestrictRecordsRightHoldersAnotherPartnershipParticipantsLegalEntityResidentIncorporationForm>;
  inn?: Maybe<Scalars['String']['output']>;
  ogrn?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

export type TNestedRealestateFileRestrictRecordsRightHoldersAnotherPartnershipParticipantsLegalEntityResidentIncorporationForm = {
  __typename?: 'NestedRealestateFileRestrictRecordsRightHoldersAnotherPartnershipParticipantsLegalEntityResidentIncorporationForm';
  /** код из справочника */
  code?: Maybe<Scalars['NumberString']['output']>;
  /** значение */
  value?: Maybe<Scalars['String']['output']>;
};

export type TNestedRealestateFileRestrictRecordsRightHoldersAnotherPartnershipParticipantsLegalEntityResidentIncorporationFormObjectFilterType = {
  code?: InputMaybe<TNumberStringFilter>;
  value?: InputMaybe<TStringFilter>;
};

export type TNestedRealestateFileRestrictRecordsRightHoldersAnotherPartnershipParticipantsLegalEntityResidentObjectFilterType = {
  incorporationForm?: InputMaybe<TNestedRealestateFileRestrictRecordsRightHoldersAnotherPartnershipParticipantsLegalEntityResidentIncorporationFormObjectFilterType>;
  inn?: InputMaybe<TStringFilter>;
  ogrn?: InputMaybe<TStringFilter>;
  title?: InputMaybe<TStringFilter>;
};

export type TNestedRealestateFileRestrictRecordsRightHoldersAnotherPartnershipParticipantsObjectFilterType = {
  contacts?: InputMaybe<TNestedRealestateFileRestrictRecordsRightHoldersAnotherPartnershipParticipantsContactsObjectFilterType>;
  legalEntity?: InputMaybe<TNestedRealestateFileRestrictRecordsRightHoldersAnotherPartnershipParticipantsLegalEntityObjectFilterType>;
};

export type TNestedRealestateFileRestrictRecordsRightHoldersIndividual = {
  __typename?: 'NestedRealestateFileRestrictRecordsRightHoldersIndividual';
  birthDate?: Maybe<Scalars['BirthDate']['output']>;
  birthPlace?: Maybe<Scalars['String']['output']>;
  /** Гражданство */
  citizenship?: Maybe<TNestedRealestateFileRestrictRecordsRightHoldersIndividualCitizenship>;
  /** Связь с правообладателем */
  contacts?: Maybe<TNestedRealestateFileRestrictRecordsRightHoldersIndividualContacts>;
  firstName?: Maybe<Scalars['String']['output']>;
  /** Документ, удостоверяющий личность */
  identityDocument?: Maybe<TNestedRealestateFileRestrictRecordsRightHoldersIndividualIdentityDocument>;
  lastName?: Maybe<Scalars['String']['output']>;
  middleName?: Maybe<Scalars['String']['output']>;
  snils?: Maybe<Scalars['String']['output']>;
  /** Тип физического лица */
  type?: Maybe<TNestedRealestateFileRestrictRecordsRightHoldersIndividualType>;
};

export type TNestedRealestateFileRestrictRecordsRightHoldersIndividualCitizenship = {
  __typename?: 'NestedRealestateFileRestrictRecordsRightHoldersIndividualCitizenship';
  /** Страна гражданства */
  country?: Maybe<TNestedRealestateFileRestrictRecordsRightHoldersIndividualCitizenshipCountry>;
  /** Без гражданства [по документации тут какой-то текст должен быть] */
  noCitizenship?: Maybe<Scalars['String']['output']>;
};

export type TNestedRealestateFileRestrictRecordsRightHoldersIndividualCitizenshipCountry = {
  __typename?: 'NestedRealestateFileRestrictRecordsRightHoldersIndividualCitizenshipCountry';
  code?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

export type TNestedRealestateFileRestrictRecordsRightHoldersIndividualCitizenshipCountryObjectFilterType = {
  code?: InputMaybe<TStringFilter>;
  value?: InputMaybe<TStringFilter>;
};

export type TNestedRealestateFileRestrictRecordsRightHoldersIndividualCitizenshipObjectFilterType = {
  country?: InputMaybe<TNestedRealestateFileRestrictRecordsRightHoldersIndividualCitizenshipCountryObjectFilterType>;
  noCitizenship?: InputMaybe<TStringFilter>;
};

export type TNestedRealestateFileRestrictRecordsRightHoldersIndividualContacts = {
  __typename?: 'NestedRealestateFileRestrictRecordsRightHoldersIndividualContacts';
  email?: Maybe<Scalars['String']['output']>;
  /** ! Возможно в документации ошибка: mailing_addess */
  mailingAddress?: Maybe<Scalars['String']['output']>;
};

export type TNestedRealestateFileRestrictRecordsRightHoldersIndividualContactsObjectFilterType = {
  email?: InputMaybe<TStringFilter>;
  mailingAddress?: InputMaybe<TStringFilter>;
};

export type TNestedRealestateFileRestrictRecordsRightHoldersIndividualIdentityDocument = {
  __typename?: 'NestedRealestateFileRestrictRecordsRightHoldersIndividualIdentityDocument';
  /** Код документа */
  code?: Maybe<TNestedRealestateFileRestrictRecordsRightHoldersIndividualIdentityDocumentCode>;
  /** Дата документа */
  date?: Maybe<Scalars['DateTimeISO']['output']>;
  /** Нотариальное удостоверение документа */
  docNotarized?: Maybe<TNestedRealestateFileRestrictRecordsRightHoldersIndividualIdentityDocumentDocNotarized>;
  /** Кем выдан (Организация, выдавшая документ) */
  issuer?: Maybe<Scalars['String']['output']>;
  /** Наименование */
  name?: Maybe<Scalars['String']['output']>;
  /** Номер документа */
  number?: Maybe<Scalars['String']['output']>;
  /** Серия документа */
  series?: Maybe<Scalars['String']['output']>;
  /** Особые отметки */
  specialMarks?: Maybe<Scalars['String']['output']>;
};

export type TNestedRealestateFileRestrictRecordsRightHoldersIndividualIdentityDocumentCode = {
  __typename?: 'NestedRealestateFileRestrictRecordsRightHoldersIndividualIdentityDocumentCode';
  /** код из справочника */
  code?: Maybe<Scalars['NumberString']['output']>;
  /** значение */
  value?: Maybe<Scalars['String']['output']>;
};

export type TNestedRealestateFileRestrictRecordsRightHoldersIndividualIdentityDocumentCodeObjectFilterType = {
  code?: InputMaybe<TNumberStringFilter>;
  value?: InputMaybe<TStringFilter>;
};

export type TNestedRealestateFileRestrictRecordsRightHoldersIndividualIdentityDocumentDocNotarized = {
  __typename?: 'NestedRealestateFileRestrictRecordsRightHoldersIndividualIdentityDocumentDocNotarized';
  /** Дата нотариального удостоверения */
  notarizeDate?: Maybe<Scalars['String']['output']>;
  /** Номер в реестре регистрации нотариальных действий */
  notaryActionNum?: Maybe<Scalars['String']['output']>;
  /** Фамилия и инициалы нотариуса */
  notaryName?: Maybe<Scalars['String']['output']>;
};

export type TNestedRealestateFileRestrictRecordsRightHoldersIndividualIdentityDocumentDocNotarizedObjectFilterType = {
  notarizeDate?: InputMaybe<TStringFilter>;
  notaryActionNum?: InputMaybe<TStringFilter>;
  notaryName?: InputMaybe<TStringFilter>;
};

export type TNestedRealestateFileRestrictRecordsRightHoldersIndividualIdentityDocumentObjectFilterType = {
  code?: InputMaybe<TNestedRealestateFileRestrictRecordsRightHoldersIndividualIdentityDocumentCodeObjectFilterType>;
  date?: InputMaybe<TDateTimeIsoFilter>;
  docNotarized?: InputMaybe<TNestedRealestateFileRestrictRecordsRightHoldersIndividualIdentityDocumentDocNotarizedObjectFilterType>;
  issuer?: InputMaybe<TStringFilter>;
  name?: InputMaybe<TStringFilter>;
  number?: InputMaybe<TStringFilter>;
  series?: InputMaybe<TStringFilter>;
  specialMarks?: InputMaybe<TStringFilter>;
};

export type TNestedRealestateFileRestrictRecordsRightHoldersIndividualObjectFilterType = {
  birthDate?: InputMaybe<TBirthDateFilter>;
  birthPlace?: InputMaybe<TStringFilter>;
  citizenship?: InputMaybe<TNestedRealestateFileRestrictRecordsRightHoldersIndividualCitizenshipObjectFilterType>;
  contacts?: InputMaybe<TNestedRealestateFileRestrictRecordsRightHoldersIndividualContactsObjectFilterType>;
  firstName?: InputMaybe<TStringFilter>;
  identityDocument?: InputMaybe<TNestedRealestateFileRestrictRecordsRightHoldersIndividualIdentityDocumentObjectFilterType>;
  lastName?: InputMaybe<TStringFilter>;
  middleName?: InputMaybe<TStringFilter>;
  snils?: InputMaybe<TStringFilter>;
  type?: InputMaybe<TNestedRealestateFileRestrictRecordsRightHoldersIndividualTypeObjectFilterType>;
};

export type TNestedRealestateFileRestrictRecordsRightHoldersIndividualType = {
  __typename?: 'NestedRealestateFileRestrictRecordsRightHoldersIndividualType';
  /** код из справочника */
  code?: Maybe<Scalars['NumberString']['output']>;
  /** значение */
  value?: Maybe<Scalars['String']['output']>;
};

export type TNestedRealestateFileRestrictRecordsRightHoldersIndividualTypeObjectFilterType = {
  code?: InputMaybe<TNumberStringFilter>;
  value?: InputMaybe<TStringFilter>;
};

export type TNestedRealestateFileRestrictRecordsRightHoldersLegalEntity = {
  __typename?: 'NestedRealestateFileRestrictRecordsRightHoldersLegalEntity';
  contacts?: Maybe<TNestedRealestateFileRestrictRecordsRightHoldersLegalEntityContacts>;
  entity?: Maybe<TNestedRealestateFileRestrictRecordsRightHoldersLegalEntityEntity>;
  /** Тип юридического лица */
  type?: Maybe<TNestedRealestateFileRestrictRecordsRightHoldersLegalEntityType>;
};

export type TNestedRealestateFileRestrictRecordsRightHoldersLegalEntityContacts = {
  __typename?: 'NestedRealestateFileRestrictRecordsRightHoldersLegalEntityContacts';
  email?: Maybe<Scalars['String']['output']>;
  /** ! Возможно в документации ошибка: mailing_addess */
  mailingAddress?: Maybe<Scalars['String']['output']>;
};

export type TNestedRealestateFileRestrictRecordsRightHoldersLegalEntityContactsObjectFilterType = {
  email?: InputMaybe<TStringFilter>;
  mailingAddress?: InputMaybe<TStringFilter>;
};

export type TNestedRealestateFileRestrictRecordsRightHoldersLegalEntityEntity = {
  __typename?: 'NestedRealestateFileRestrictRecordsRightHoldersLegalEntityEntity';
  /** Орган государственной власти, орган местного самоуправления, иной государственный орган */
  governmentEntity?: Maybe<TNestedRealestateFileRestrictRecordsRightHoldersLegalEntityEntityGovernmentEntity>;
  /** Иностранное юридическое лицо */
  notResident?: Maybe<TNestedRealestateFileRestrictRecordsRightHoldersLegalEntityEntityNotResident>;
  /** Российское юридическое лицо */
  resident?: Maybe<TNestedRealestateFileRestrictRecordsRightHoldersLegalEntityEntityResident>;
};

export type TNestedRealestateFileRestrictRecordsRightHoldersLegalEntityEntityGovernmentEntity = {
  __typename?: 'NestedRealestateFileRestrictRecordsRightHoldersLegalEntityEntityGovernmentEntity';
  inn?: Maybe<Scalars['String']['output']>;
  ogrn?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

export type TNestedRealestateFileRestrictRecordsRightHoldersLegalEntityEntityGovernmentEntityObjectFilterType = {
  inn?: InputMaybe<TStringFilter>;
  ogrn?: InputMaybe<TStringFilter>;
  title?: InputMaybe<TStringFilter>;
};

export type TNestedRealestateFileRestrictRecordsRightHoldersLegalEntityEntityNotResident = {
  __typename?: 'NestedRealestateFileRestrictRecordsRightHoldersLegalEntityEntityNotResident';
  /** Страна регистрации (инкорпорации) */
  incorporateCountry?: Maybe<TNestedRealestateFileRestrictRecordsRightHoldersLegalEntityEntityNotResidentIncorporateCountry>;
  /** Организационно-правовая форма */
  incorporationForm?: Maybe<TNestedRealestateFileRestrictRecordsRightHoldersLegalEntityEntityNotResidentIncorporationForm>;
  inn?: Maybe<Scalars['String']['output']>;
  /** Адрес (местонахождение) в стране регистрации (инкорпорации) */
  regAddress?: Maybe<Scalars['String']['output']>;
  /** Дата регистрации */
  registrationDate?: Maybe<Scalars['String']['output']>;
  /** Регистрационный номер */
  registrationNumber?: Maybe<Scalars['String']['output']>;
  /** Наименование регистрирующего органа */
  registrationOrgan?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

export type TNestedRealestateFileRestrictRecordsRightHoldersLegalEntityEntityNotResidentIncorporateCountry = {
  __typename?: 'NestedRealestateFileRestrictRecordsRightHoldersLegalEntityEntityNotResidentIncorporateCountry';
  /** код из справочника */
  code?: Maybe<Scalars['NumberString']['output']>;
  /** значение */
  value?: Maybe<Scalars['String']['output']>;
};

export type TNestedRealestateFileRestrictRecordsRightHoldersLegalEntityEntityNotResidentIncorporateCountryObjectFilterType = {
  code?: InputMaybe<TNumberStringFilter>;
  value?: InputMaybe<TStringFilter>;
};

export type TNestedRealestateFileRestrictRecordsRightHoldersLegalEntityEntityNotResidentIncorporationForm = {
  __typename?: 'NestedRealestateFileRestrictRecordsRightHoldersLegalEntityEntityNotResidentIncorporationForm';
  /** код из справочника */
  code?: Maybe<Scalars['NumberString']['output']>;
  /** значение */
  value?: Maybe<Scalars['String']['output']>;
};

export type TNestedRealestateFileRestrictRecordsRightHoldersLegalEntityEntityNotResidentIncorporationFormObjectFilterType = {
  code?: InputMaybe<TNumberStringFilter>;
  value?: InputMaybe<TStringFilter>;
};

export type TNestedRealestateFileRestrictRecordsRightHoldersLegalEntityEntityNotResidentObjectFilterType = {
  incorporateCountry?: InputMaybe<TNestedRealestateFileRestrictRecordsRightHoldersLegalEntityEntityNotResidentIncorporateCountryObjectFilterType>;
  incorporationForm?: InputMaybe<TNestedRealestateFileRestrictRecordsRightHoldersLegalEntityEntityNotResidentIncorporationFormObjectFilterType>;
  inn?: InputMaybe<TStringFilter>;
  regAddress?: InputMaybe<TStringFilter>;
  registrationDate?: InputMaybe<TStringFilter>;
  registrationNumber?: InputMaybe<TStringFilter>;
  registrationOrgan?: InputMaybe<TStringFilter>;
  title?: InputMaybe<TStringFilter>;
};

export type TNestedRealestateFileRestrictRecordsRightHoldersLegalEntityEntityObjectFilterType = {
  governmentEntity?: InputMaybe<TNestedRealestateFileRestrictRecordsRightHoldersLegalEntityEntityGovernmentEntityObjectFilterType>;
  notResident?: InputMaybe<TNestedRealestateFileRestrictRecordsRightHoldersLegalEntityEntityNotResidentObjectFilterType>;
  resident?: InputMaybe<TNestedRealestateFileRestrictRecordsRightHoldersLegalEntityEntityResidentObjectFilterType>;
};

export type TNestedRealestateFileRestrictRecordsRightHoldersLegalEntityEntityResident = {
  __typename?: 'NestedRealestateFileRestrictRecordsRightHoldersLegalEntityEntityResident';
  /** Организационно-правовая форма */
  incorporationForm?: Maybe<TNestedRealestateFileRestrictRecordsRightHoldersLegalEntityEntityResidentIncorporationForm>;
  inn?: Maybe<Scalars['String']['output']>;
  ogrn?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

export type TNestedRealestateFileRestrictRecordsRightHoldersLegalEntityEntityResidentIncorporationForm = {
  __typename?: 'NestedRealestateFileRestrictRecordsRightHoldersLegalEntityEntityResidentIncorporationForm';
  /** код из справочника */
  code?: Maybe<Scalars['NumberString']['output']>;
  /** значение */
  value?: Maybe<Scalars['String']['output']>;
};

export type TNestedRealestateFileRestrictRecordsRightHoldersLegalEntityEntityResidentIncorporationFormObjectFilterType = {
  code?: InputMaybe<TNumberStringFilter>;
  value?: InputMaybe<TStringFilter>;
};

export type TNestedRealestateFileRestrictRecordsRightHoldersLegalEntityEntityResidentObjectFilterType = {
  incorporationForm?: InputMaybe<TNestedRealestateFileRestrictRecordsRightHoldersLegalEntityEntityResidentIncorporationFormObjectFilterType>;
  inn?: InputMaybe<TStringFilter>;
  ogrn?: InputMaybe<TStringFilter>;
  title?: InputMaybe<TStringFilter>;
};

export type TNestedRealestateFileRestrictRecordsRightHoldersLegalEntityObjectFilterType = {
  contacts?: InputMaybe<TNestedRealestateFileRestrictRecordsRightHoldersLegalEntityContactsObjectFilterType>;
  entity?: InputMaybe<TNestedRealestateFileRestrictRecordsRightHoldersLegalEntityEntityObjectFilterType>;
  type?: InputMaybe<TNestedRealestateFileRestrictRecordsRightHoldersLegalEntityTypeObjectFilterType>;
};

export type TNestedRealestateFileRestrictRecordsRightHoldersLegalEntityType = {
  __typename?: 'NestedRealestateFileRestrictRecordsRightHoldersLegalEntityType';
  /** код из справочника */
  code?: Maybe<Scalars['NumberString']['output']>;
  /** значение */
  value?: Maybe<Scalars['String']['output']>;
};

export type TNestedRealestateFileRestrictRecordsRightHoldersLegalEntityTypeObjectFilterType = {
  code?: InputMaybe<TNumberStringFilter>;
  value?: InputMaybe<TStringFilter>;
};

export type TNestedRealestateFileRestrictRecordsRightHoldersObjectFilterType = {
  another?: InputMaybe<TNestedRealestateFileRestrictRecordsRightHoldersAnotherObjectFilterType>;
  individual?: InputMaybe<TNestedRealestateFileRestrictRecordsRightHoldersIndividualObjectFilterType>;
  legalEntity?: InputMaybe<TNestedRealestateFileRestrictRecordsRightHoldersLegalEntityObjectFilterType>;
  publicFormation?: InputMaybe<TNestedRealestateFileRestrictRecordsRightHoldersPublicFormationObjectFilterType>;
  publicServitude?: InputMaybe<TStringFilter>;
  somethingElse?: InputMaybe<TStringFilter>;
};

export type TNestedRealestateFileRestrictRecordsRightHoldersPublicFormation = {
  __typename?: 'NestedRealestateFileRestrictRecordsRightHoldersPublicFormation';
  /** Иностранное государство */
  foreign?: Maybe<Scalars['String']['output']>;
  /** Наименование муниципального образования */
  municipality?: Maybe<Scalars['String']['output']>;
  /** Российская Федерация */
  russia?: Maybe<TNestedRealestateFileRestrictRecordsRightHoldersPublicFormationRussia>;
  /** Наименование субъекта Российской Федерации */
  subjectOfRf?: Maybe<TNestedRealestateFileRestrictRecordsRightHoldersPublicFormationSubjectOfRf>;
  /** Союзное государство */
  union?: Maybe<Scalars['String']['output']>;
};

export type TNestedRealestateFileRestrictRecordsRightHoldersPublicFormationObjectFilterType = {
  foreign?: InputMaybe<TStringFilter>;
  municipality?: InputMaybe<TStringFilter>;
  russia?: InputMaybe<TNestedRealestateFileRestrictRecordsRightHoldersPublicFormationRussiaObjectFilterType>;
  subjectOfRf?: InputMaybe<TNestedRealestateFileRestrictRecordsRightHoldersPublicFormationSubjectOfRfObjectFilterType>;
  union?: InputMaybe<TStringFilter>;
};

export type TNestedRealestateFileRestrictRecordsRightHoldersPublicFormationRussia = {
  __typename?: 'NestedRealestateFileRestrictRecordsRightHoldersPublicFormationRussia';
  /** код из справочника */
  code?: Maybe<Scalars['NumberString']['output']>;
  /** значение */
  value?: Maybe<Scalars['String']['output']>;
};

export type TNestedRealestateFileRestrictRecordsRightHoldersPublicFormationRussiaObjectFilterType = {
  code?: InputMaybe<TNumberStringFilter>;
  value?: InputMaybe<TStringFilter>;
};

export type TNestedRealestateFileRestrictRecordsRightHoldersPublicFormationSubjectOfRf = {
  __typename?: 'NestedRealestateFileRestrictRecordsRightHoldersPublicFormationSubjectOfRf';
  /** код из справочника */
  code?: Maybe<Scalars['NumberString']['output']>;
  /** значение */
  value?: Maybe<Scalars['String']['output']>;
};

export type TNestedRealestateFileRestrictRecordsRightHoldersPublicFormationSubjectOfRfObjectFilterType = {
  code?: InputMaybe<TNumberStringFilter>;
  value?: InputMaybe<TStringFilter>;
};

export type TNestedRealestateFileRestrictRecordsUnderlyingDocuments = {
  __typename?: 'NestedRealestateFileRestrictRecordsUnderlyingDocuments';
  code?: Maybe<TNestedRealestateFileRestrictRecordsUnderlyingDocumentsCode>;
  date?: Maybe<Scalars['DateTimeISO']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type TNestedRealestateFileRestrictRecordsUnderlyingDocumentsCode = {
  __typename?: 'NestedRealestateFileRestrictRecordsUnderlyingDocumentsCode';
  /** код из справочника */
  code?: Maybe<Scalars['NumberString']['output']>;
  /** значение */
  value?: Maybe<Scalars['String']['output']>;
};

export type TNestedRealestateFileRestrictRecordsUnderlyingDocumentsCodeObjectFilterType = {
  code?: InputMaybe<TNumberStringFilter>;
  value?: InputMaybe<TStringFilter>;
};

export type TNestedRealestateFileRestrictRecordsUnderlyingDocumentsObjectFilterType = {
  code?: InputMaybe<TNestedRealestateFileRestrictRecordsUnderlyingDocumentsCodeObjectFilterType>;
  date?: InputMaybe<TDateTimeIsoFilter>;
  name?: InputMaybe<TStringFilter>;
};

export type TNestedRealestateFileRightRecordRecordInfo = {
  __typename?: 'NestedRealestateFileRightRecordRecordInfo';
  /** Дата снятия с учета / регистрации */
  cancelDate?: Maybe<Scalars['String']['output']>;
  /** Дата постановки на учет / регистрации */
  registrationDate?: Maybe<Scalars['DateTimeISO']['output']>;
};

export type TNestedRealestateFileRightRecordRecordInfoObjectFilterType = {
  cancelDate?: InputMaybe<TStringFilter>;
  registrationDate?: InputMaybe<TDateTimeIsoFilter>;
};

export type TNestedRealestateFileRightRecordRightData = {
  __typename?: 'NestedRealestateFileRightRecordRightData';
  reinstatement?: Maybe<Scalars['String']['output']>;
  rightNumber: Scalars['String']['output'];
  rightType?: Maybe<TNestedRealestateFileRightRecordRightDataRightType>;
  shareDescription?: Maybe<Scalars['String']['output']>;
  /** Размер доли в праве */
  shares?: Maybe<Array<Maybe<TNestedRealestateFileRightRecordRightDataShares>>>;
};


export type TNestedRealestateFileRightRecordRightDataSharesArgs = {
  pagination?: InputMaybe<TPagination>;
};

export type TNestedRealestateFileRightRecordRightDataObjectFilterType = {
  reinstatement?: InputMaybe<TStringFilter>;
  rightNumber?: InputMaybe<TStringFilter>;
  rightType?: InputMaybe<TNestedRealestateFileRightRecordRightDataRightTypeObjectFilterType>;
  shareDescription?: InputMaybe<TStringFilter>;
  shares?: InputMaybe<TNestedRealestateFileRightRecordRightDataSharesObjectFilterType>;
};

export type TNestedRealestateFileRightRecordRightDataRightType = {
  __typename?: 'NestedRealestateFileRightRecordRightDataRightType';
  /** код из справочника */
  code?: Maybe<Scalars['NumberString']['output']>;
  /** значение */
  value?: Maybe<Scalars['String']['output']>;
};

export type TNestedRealestateFileRightRecordRightDataRightTypeObjectFilterType = {
  code?: InputMaybe<TNumberStringFilter>;
  value?: InputMaybe<TStringFilter>;
};

export type TNestedRealestateFileRightRecordRightDataShares = {
  __typename?: 'NestedRealestateFileRightRecordRightDataShares';
  /** Размер доли в праве общей долевой собственности на общее имущество */
  roomOwnersShare?: Maybe<Scalars['String']['output']>;
  /** Размер доли в праве */
  share?: Maybe<TNestedRealestateFileRightRecordRightDataSharesShare>;
  /** Размер доли в праве в баллогектарах */
  shareBalHectare?: Maybe<Scalars['Int']['output']>;
  /** Размер доли в праве в гектарах */
  shareHectare?: Maybe<Scalars['Int']['output']>;
  /** Не указан размер доли в праве общей долевой собственности на общее имущество, в том числе на земельный участок, собственников помещений, машиномест в здании, если объектом недвижимости является помещение, машиноместо в здании */
  shareUnknown?: Maybe<TNestedRealestateFileRightRecordRightDataSharesShareUnknown>;
};

export type TNestedRealestateFileRightRecordRightDataSharesObjectFilterType = {
  roomOwnersShare?: InputMaybe<TStringFilter>;
  share?: InputMaybe<TNestedRealestateFileRightRecordRightDataSharesShareObjectFilterType>;
  shareBalHectare?: InputMaybe<TIntFilter>;
  shareHectare?: InputMaybe<TIntFilter>;
  shareUnknown?: InputMaybe<TNestedRealestateFileRightRecordRightDataSharesShareUnknownObjectFilterType>;
};

export type TNestedRealestateFileRightRecordRightDataSharesShare = {
  __typename?: 'NestedRealestateFileRightRecordRightDataSharesShare';
  denominator?: Maybe<Scalars['Int']['output']>;
  numerator?: Maybe<Scalars['Int']['output']>;
};

export type TNestedRealestateFileRightRecordRightDataSharesShareObjectFilterType = {
  denominator?: InputMaybe<TIntFilter>;
  numerator?: InputMaybe<TIntFilter>;
};

export type TNestedRealestateFileRightRecordRightDataSharesShareUnknown = {
  __typename?: 'NestedRealestateFileRightRecordRightDataSharesShareUnknown';
  cadNumber?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
};

export type TNestedRealestateFileRightRecordRightDataSharesShareUnknownObjectFilterType = {
  cadNumber?: InputMaybe<TStringFilter>;
  description?: InputMaybe<TStringFilter>;
};

export type TNestedRealestateFileRightRecordRightHolders = {
  __typename?: 'NestedRealestateFileRightRecordRightHolders';
  /** Иное лицо, в пользу которого установлены ограничения права и обременения объекта недвижимости */
  another?: Maybe<TNestedRealestateFileRightRecordRightHoldersAnother>;
  /** Физическое лицо */
  individual?: Maybe<TNestedRealestateFileRightRecordRightHoldersIndividual>;
  /** Юридическое лицо, орган власти */
  legalEntity?: Maybe<TNestedRealestateFileRightRecordRightHoldersLegalEntity>;
  /** Публично-правовое образование */
  publicFormation?: Maybe<TNestedRealestateFileRightRecordRightHoldersPublicFormation>;
  /** Публичный сервитут */
  publicServitude?: Maybe<Scalars['String']['output']>;
  /** Не определено (тип undefined в документации) */
  somethingElse?: Maybe<Scalars['String']['output']>;
};

export type TNestedRealestateFileRightRecordRightHoldersAnother = {
  __typename?: 'NestedRealestateFileRightRecordRightHoldersAnother';
  /** Собственники помещений в многоквартирном доме */
  aparthouseOwners?: Maybe<Scalars['String']['output']>;
  /** Владельцы облигаций */
  bondsHolders?: Maybe<TNestedRealestateFileRightRecordRightHoldersAnotherBondsHolders>;
  /** Индивидуальное обозначение, идентифицирующее ипотечные сертификаты участия, в интересах владельцев которых осуществляется доверительное управление таким ипотечным покрытием */
  certificatesHolders?: Maybe<Scalars['String']['output']>;
  /** Участники долевого строительства */
  equityParticipantsInfo?: Maybe<Scalars['String']['output']>;
  /** Название (индивидуальное обозначение), идентифицирующее паевой инвестиционный фонд */
  investmentUnitOwner?: Maybe<Scalars['String']['output']>;
  /** Участники долевого строительства по договорам участия в долевом строительстве, которым не переданы объекты долевого строительства */
  notEquityParticipantsInfo?: Maybe<Scalars['String']['output']>;
  /** Иной субъект */
  other?: Maybe<TNestedRealestateFileRightRecordRightHoldersAnotherOther>;
  /** Инвестиционное товарищество */
  partnership?: Maybe<TNestedRealestateFileRightRecordRightHoldersAnotherPartnership>;
};

export type TNestedRealestateFileRightRecordRightHoldersAnotherBondsHolders = {
  __typename?: 'NestedRealestateFileRightRecordRightHoldersAnotherBondsHolders';
  /** Дата государственной регистрации номера выпуска облигаций */
  issueDate?: Maybe<Scalars['String']['output']>;
  /** Государственный регистрационный номер выпуска облигаций */
  number?: Maybe<Scalars['String']['output']>;
};

export type TNestedRealestateFileRightRecordRightHoldersAnotherBondsHoldersObjectFilterType = {
  issueDate?: InputMaybe<TStringFilter>;
  number?: InputMaybe<TStringFilter>;
};

export type TNestedRealestateFileRightRecordRightHoldersAnotherObjectFilterType = {
  aparthouseOwners?: InputMaybe<TStringFilter>;
  bondsHolders?: InputMaybe<TNestedRealestateFileRightRecordRightHoldersAnotherBondsHoldersObjectFilterType>;
  certificatesHolders?: InputMaybe<TStringFilter>;
  equityParticipantsInfo?: InputMaybe<TStringFilter>;
  investmentUnitOwner?: InputMaybe<TStringFilter>;
  notEquityParticipantsInfo?: InputMaybe<TStringFilter>;
  other?: InputMaybe<TNestedRealestateFileRightRecordRightHoldersAnotherOtherObjectFilterType>;
  partnership?: InputMaybe<TNestedRealestateFileRightRecordRightHoldersAnotherPartnershipObjectFilterType>;
};

export type TNestedRealestateFileRightRecordRightHoldersAnotherOther = {
  __typename?: 'NestedRealestateFileRightRecordRightHoldersAnotherOther';
  /** Комментарий */
  comment?: Maybe<Scalars['String']['output']>;
  contacts?: Maybe<TNestedRealestateFileRightRecordRightHoldersAnotherOtherContacts>;
  /** Наименование для печати */
  printText?: Maybe<Scalars['String']['output']>;
  /** Регистрирующий орган */
  registrationOrgan?: Maybe<Scalars['String']['output']>;
  /** Краткое наименование */
  shortTitle?: Maybe<Scalars['String']['output']>;
  /** Наименование */
  title?: Maybe<Scalars['String']['output']>;
};

export type TNestedRealestateFileRightRecordRightHoldersAnotherOtherContacts = {
  __typename?: 'NestedRealestateFileRightRecordRightHoldersAnotherOtherContacts';
  email?: Maybe<Scalars['String']['output']>;
  /** ! Возможно в документации ошибка: mailing_addess */
  mailingAddress?: Maybe<Scalars['String']['output']>;
};

export type TNestedRealestateFileRightRecordRightHoldersAnotherOtherContactsObjectFilterType = {
  email?: InputMaybe<TStringFilter>;
  mailingAddress?: InputMaybe<TStringFilter>;
};

export type TNestedRealestateFileRightRecordRightHoldersAnotherOtherObjectFilterType = {
  comment?: InputMaybe<TStringFilter>;
  contacts?: InputMaybe<TNestedRealestateFileRightRecordRightHoldersAnotherOtherContactsObjectFilterType>;
  printText?: InputMaybe<TStringFilter>;
  registrationOrgan?: InputMaybe<TStringFilter>;
  shortTitle?: InputMaybe<TStringFilter>;
  title?: InputMaybe<TStringFilter>;
};

export type TNestedRealestateFileRightRecordRightHoldersAnotherPartnership = {
  __typename?: 'NestedRealestateFileRightRecordRightHoldersAnotherPartnership';
  /** Участник договора инвестиционного товарищества */
  participants?: Maybe<Array<Maybe<TNestedRealestateFileRightRecordRightHoldersAnotherPartnershipParticipants>>>;
};


export type TNestedRealestateFileRightRecordRightHoldersAnotherPartnershipParticipantsArgs = {
  pagination?: InputMaybe<TPagination>;
};

export type TNestedRealestateFileRightRecordRightHoldersAnotherPartnershipObjectFilterType = {
  participants?: InputMaybe<TNestedRealestateFileRightRecordRightHoldersAnotherPartnershipParticipantsObjectFilterType>;
};

export type TNestedRealestateFileRightRecordRightHoldersAnotherPartnershipParticipants = {
  __typename?: 'NestedRealestateFileRightRecordRightHoldersAnotherPartnershipParticipants';
  contacts?: Maybe<TNestedRealestateFileRightRecordRightHoldersAnotherPartnershipParticipantsContacts>;
  legalEntity?: Maybe<TNestedRealestateFileRightRecordRightHoldersAnotherPartnershipParticipantsLegalEntity>;
};

export type TNestedRealestateFileRightRecordRightHoldersAnotherPartnershipParticipantsContacts = {
  __typename?: 'NestedRealestateFileRightRecordRightHoldersAnotherPartnershipParticipantsContacts';
  email?: Maybe<Scalars['String']['output']>;
  /** ! Возможно в документации ошибка: mailing_addess */
  mailingAddress?: Maybe<Scalars['String']['output']>;
};

export type TNestedRealestateFileRightRecordRightHoldersAnotherPartnershipParticipantsContactsObjectFilterType = {
  email?: InputMaybe<TStringFilter>;
  mailingAddress?: InputMaybe<TStringFilter>;
};

export type TNestedRealestateFileRightRecordRightHoldersAnotherPartnershipParticipantsLegalEntity = {
  __typename?: 'NestedRealestateFileRightRecordRightHoldersAnotherPartnershipParticipantsLegalEntity';
  notResident?: Maybe<TNestedRealestateFileRightRecordRightHoldersAnotherPartnershipParticipantsLegalEntityNotResident>;
  resident?: Maybe<TNestedRealestateFileRightRecordRightHoldersAnotherPartnershipParticipantsLegalEntityResident>;
};

export type TNestedRealestateFileRightRecordRightHoldersAnotherPartnershipParticipantsLegalEntityNotResident = {
  __typename?: 'NestedRealestateFileRightRecordRightHoldersAnotherPartnershipParticipantsLegalEntityNotResident';
  /** Страна регистрации (инкорпорации) */
  incorporateCountry?: Maybe<TNestedRealestateFileRightRecordRightHoldersAnotherPartnershipParticipantsLegalEntityNotResidentIncorporateCountry>;
  /** Организационно-правовая форма */
  incorporationForm?: Maybe<TNestedRealestateFileRightRecordRightHoldersAnotherPartnershipParticipantsLegalEntityNotResidentIncorporationForm>;
  inn?: Maybe<Scalars['String']['output']>;
  /** Адрес (местонахождение) в стране регистрации (инкорпорации) */
  regAddress?: Maybe<Scalars['String']['output']>;
  /** Дата регистрации */
  registrationDate?: Maybe<Scalars['String']['output']>;
  /** Регистрационный номер */
  registrationNumber?: Maybe<Scalars['String']['output']>;
  /** Наименование регистрирующего органа */
  registrationOrgan?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

export type TNestedRealestateFileRightRecordRightHoldersAnotherPartnershipParticipantsLegalEntityNotResidentIncorporateCountry = {
  __typename?: 'NestedRealestateFileRightRecordRightHoldersAnotherPartnershipParticipantsLegalEntityNotResidentIncorporateCountry';
  /** код из справочника */
  code?: Maybe<Scalars['NumberString']['output']>;
  /** значение */
  value?: Maybe<Scalars['String']['output']>;
};

export type TNestedRealestateFileRightRecordRightHoldersAnotherPartnershipParticipantsLegalEntityNotResidentIncorporateCountryObjectFilterType = {
  code?: InputMaybe<TNumberStringFilter>;
  value?: InputMaybe<TStringFilter>;
};

export type TNestedRealestateFileRightRecordRightHoldersAnotherPartnershipParticipantsLegalEntityNotResidentIncorporationForm = {
  __typename?: 'NestedRealestateFileRightRecordRightHoldersAnotherPartnershipParticipantsLegalEntityNotResidentIncorporationForm';
  /** код из справочника */
  code?: Maybe<Scalars['NumberString']['output']>;
  /** значение */
  value?: Maybe<Scalars['String']['output']>;
};

export type TNestedRealestateFileRightRecordRightHoldersAnotherPartnershipParticipantsLegalEntityNotResidentIncorporationFormObjectFilterType = {
  code?: InputMaybe<TNumberStringFilter>;
  value?: InputMaybe<TStringFilter>;
};

export type TNestedRealestateFileRightRecordRightHoldersAnotherPartnershipParticipantsLegalEntityNotResidentObjectFilterType = {
  incorporateCountry?: InputMaybe<TNestedRealestateFileRightRecordRightHoldersAnotherPartnershipParticipantsLegalEntityNotResidentIncorporateCountryObjectFilterType>;
  incorporationForm?: InputMaybe<TNestedRealestateFileRightRecordRightHoldersAnotherPartnershipParticipantsLegalEntityNotResidentIncorporationFormObjectFilterType>;
  inn?: InputMaybe<TStringFilter>;
  regAddress?: InputMaybe<TStringFilter>;
  registrationDate?: InputMaybe<TStringFilter>;
  registrationNumber?: InputMaybe<TStringFilter>;
  registrationOrgan?: InputMaybe<TStringFilter>;
  title?: InputMaybe<TStringFilter>;
};

export type TNestedRealestateFileRightRecordRightHoldersAnotherPartnershipParticipantsLegalEntityObjectFilterType = {
  notResident?: InputMaybe<TNestedRealestateFileRightRecordRightHoldersAnotherPartnershipParticipantsLegalEntityNotResidentObjectFilterType>;
  resident?: InputMaybe<TNestedRealestateFileRightRecordRightHoldersAnotherPartnershipParticipantsLegalEntityResidentObjectFilterType>;
};

export type TNestedRealestateFileRightRecordRightHoldersAnotherPartnershipParticipantsLegalEntityResident = {
  __typename?: 'NestedRealestateFileRightRecordRightHoldersAnotherPartnershipParticipantsLegalEntityResident';
  /** Организационно-правовая форма */
  incorporationForm?: Maybe<TNestedRealestateFileRightRecordRightHoldersAnotherPartnershipParticipantsLegalEntityResidentIncorporationForm>;
  inn?: Maybe<Scalars['String']['output']>;
  ogrn?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

export type TNestedRealestateFileRightRecordRightHoldersAnotherPartnershipParticipantsLegalEntityResidentIncorporationForm = {
  __typename?: 'NestedRealestateFileRightRecordRightHoldersAnotherPartnershipParticipantsLegalEntityResidentIncorporationForm';
  /** код из справочника */
  code?: Maybe<Scalars['NumberString']['output']>;
  /** значение */
  value?: Maybe<Scalars['String']['output']>;
};

export type TNestedRealestateFileRightRecordRightHoldersAnotherPartnershipParticipantsLegalEntityResidentIncorporationFormObjectFilterType = {
  code?: InputMaybe<TNumberStringFilter>;
  value?: InputMaybe<TStringFilter>;
};

export type TNestedRealestateFileRightRecordRightHoldersAnotherPartnershipParticipantsLegalEntityResidentObjectFilterType = {
  incorporationForm?: InputMaybe<TNestedRealestateFileRightRecordRightHoldersAnotherPartnershipParticipantsLegalEntityResidentIncorporationFormObjectFilterType>;
  inn?: InputMaybe<TStringFilter>;
  ogrn?: InputMaybe<TStringFilter>;
  title?: InputMaybe<TStringFilter>;
};

export type TNestedRealestateFileRightRecordRightHoldersAnotherPartnershipParticipantsObjectFilterType = {
  contacts?: InputMaybe<TNestedRealestateFileRightRecordRightHoldersAnotherPartnershipParticipantsContactsObjectFilterType>;
  legalEntity?: InputMaybe<TNestedRealestateFileRightRecordRightHoldersAnotherPartnershipParticipantsLegalEntityObjectFilterType>;
};

export type TNestedRealestateFileRightRecordRightHoldersIndividual = {
  __typename?: 'NestedRealestateFileRightRecordRightHoldersIndividual';
  birthDate?: Maybe<Scalars['BirthDate']['output']>;
  birthPlace?: Maybe<Scalars['String']['output']>;
  /** Гражданство */
  citizenship?: Maybe<TNestedRealestateFileRightRecordRightHoldersIndividualCitizenship>;
  /** Связь с правообладателем */
  contacts?: Maybe<TNestedRealestateFileRightRecordRightHoldersIndividualContacts>;
  firstName?: Maybe<Scalars['String']['output']>;
  /** Документ, удостоверяющий личность */
  identityDocument?: Maybe<TNestedRealestateFileRightRecordRightHoldersIndividualIdentityDocument>;
  lastName?: Maybe<Scalars['String']['output']>;
  middleName?: Maybe<Scalars['String']['output']>;
  snils?: Maybe<Scalars['String']['output']>;
  /** Тип физического лица */
  type?: Maybe<TNestedRealestateFileRightRecordRightHoldersIndividualType>;
};

export type TNestedRealestateFileRightRecordRightHoldersIndividualCitizenship = {
  __typename?: 'NestedRealestateFileRightRecordRightHoldersIndividualCitizenship';
  /** Страна гражданства */
  country?: Maybe<TNestedRealestateFileRightRecordRightHoldersIndividualCitizenshipCountry>;
  /** Без гражданства [по документации тут какой-то текст должен быть] */
  noCitizenship?: Maybe<Scalars['String']['output']>;
};

export type TNestedRealestateFileRightRecordRightHoldersIndividualCitizenshipCountry = {
  __typename?: 'NestedRealestateFileRightRecordRightHoldersIndividualCitizenshipCountry';
  code?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

export type TNestedRealestateFileRightRecordRightHoldersIndividualCitizenshipCountryObjectFilterType = {
  code?: InputMaybe<TStringFilter>;
  value?: InputMaybe<TStringFilter>;
};

export type TNestedRealestateFileRightRecordRightHoldersIndividualCitizenshipObjectFilterType = {
  country?: InputMaybe<TNestedRealestateFileRightRecordRightHoldersIndividualCitizenshipCountryObjectFilterType>;
  noCitizenship?: InputMaybe<TStringFilter>;
};

export type TNestedRealestateFileRightRecordRightHoldersIndividualContacts = {
  __typename?: 'NestedRealestateFileRightRecordRightHoldersIndividualContacts';
  email?: Maybe<Scalars['String']['output']>;
  /** ! Возможно в документации ошибка: mailing_addess */
  mailingAddress?: Maybe<Scalars['String']['output']>;
};

export type TNestedRealestateFileRightRecordRightHoldersIndividualContactsObjectFilterType = {
  email?: InputMaybe<TStringFilter>;
  mailingAddress?: InputMaybe<TStringFilter>;
};

export type TNestedRealestateFileRightRecordRightHoldersIndividualIdentityDocument = {
  __typename?: 'NestedRealestateFileRightRecordRightHoldersIndividualIdentityDocument';
  /** Код документа */
  code?: Maybe<TNestedRealestateFileRightRecordRightHoldersIndividualIdentityDocumentCode>;
  /** Дата документа */
  date?: Maybe<Scalars['DateTimeISO']['output']>;
  /** Нотариальное удостоверение документа */
  docNotarized?: Maybe<TNestedRealestateFileRightRecordRightHoldersIndividualIdentityDocumentDocNotarized>;
  /** Кем выдан (Организация, выдавшая документ) */
  issuer?: Maybe<Scalars['String']['output']>;
  /** Наименование */
  name?: Maybe<Scalars['String']['output']>;
  /** Номер документа */
  number?: Maybe<Scalars['String']['output']>;
  /** Серия документа */
  series?: Maybe<Scalars['String']['output']>;
  /** Особые отметки */
  specialMarks?: Maybe<Scalars['String']['output']>;
};

export type TNestedRealestateFileRightRecordRightHoldersIndividualIdentityDocumentCode = {
  __typename?: 'NestedRealestateFileRightRecordRightHoldersIndividualIdentityDocumentCode';
  /** код из справочника */
  code?: Maybe<Scalars['NumberString']['output']>;
  /** значение */
  value?: Maybe<Scalars['String']['output']>;
};

export type TNestedRealestateFileRightRecordRightHoldersIndividualIdentityDocumentCodeObjectFilterType = {
  code?: InputMaybe<TNumberStringFilter>;
  value?: InputMaybe<TStringFilter>;
};

export type TNestedRealestateFileRightRecordRightHoldersIndividualIdentityDocumentDocNotarized = {
  __typename?: 'NestedRealestateFileRightRecordRightHoldersIndividualIdentityDocumentDocNotarized';
  /** Дата нотариального удостоверения */
  notarizeDate?: Maybe<Scalars['String']['output']>;
  /** Номер в реестре регистрации нотариальных действий */
  notaryActionNum?: Maybe<Scalars['String']['output']>;
  /** Фамилия и инициалы нотариуса */
  notaryName?: Maybe<Scalars['String']['output']>;
};

export type TNestedRealestateFileRightRecordRightHoldersIndividualIdentityDocumentDocNotarizedObjectFilterType = {
  notarizeDate?: InputMaybe<TStringFilter>;
  notaryActionNum?: InputMaybe<TStringFilter>;
  notaryName?: InputMaybe<TStringFilter>;
};

export type TNestedRealestateFileRightRecordRightHoldersIndividualIdentityDocumentObjectFilterType = {
  code?: InputMaybe<TNestedRealestateFileRightRecordRightHoldersIndividualIdentityDocumentCodeObjectFilterType>;
  date?: InputMaybe<TDateTimeIsoFilter>;
  docNotarized?: InputMaybe<TNestedRealestateFileRightRecordRightHoldersIndividualIdentityDocumentDocNotarizedObjectFilterType>;
  issuer?: InputMaybe<TStringFilter>;
  name?: InputMaybe<TStringFilter>;
  number?: InputMaybe<TStringFilter>;
  series?: InputMaybe<TStringFilter>;
  specialMarks?: InputMaybe<TStringFilter>;
};

export type TNestedRealestateFileRightRecordRightHoldersIndividualObjectFilterType = {
  birthDate?: InputMaybe<TBirthDateFilter>;
  birthPlace?: InputMaybe<TStringFilter>;
  citizenship?: InputMaybe<TNestedRealestateFileRightRecordRightHoldersIndividualCitizenshipObjectFilterType>;
  contacts?: InputMaybe<TNestedRealestateFileRightRecordRightHoldersIndividualContactsObjectFilterType>;
  firstName?: InputMaybe<TStringFilter>;
  identityDocument?: InputMaybe<TNestedRealestateFileRightRecordRightHoldersIndividualIdentityDocumentObjectFilterType>;
  lastName?: InputMaybe<TStringFilter>;
  middleName?: InputMaybe<TStringFilter>;
  snils?: InputMaybe<TStringFilter>;
  type?: InputMaybe<TNestedRealestateFileRightRecordRightHoldersIndividualTypeObjectFilterType>;
};

export type TNestedRealestateFileRightRecordRightHoldersIndividualType = {
  __typename?: 'NestedRealestateFileRightRecordRightHoldersIndividualType';
  /** код из справочника */
  code?: Maybe<Scalars['NumberString']['output']>;
  /** значение */
  value?: Maybe<Scalars['String']['output']>;
};

export type TNestedRealestateFileRightRecordRightHoldersIndividualTypeObjectFilterType = {
  code?: InputMaybe<TNumberStringFilter>;
  value?: InputMaybe<TStringFilter>;
};

export type TNestedRealestateFileRightRecordRightHoldersLegalEntity = {
  __typename?: 'NestedRealestateFileRightRecordRightHoldersLegalEntity';
  contacts?: Maybe<TNestedRealestateFileRightRecordRightHoldersLegalEntityContacts>;
  entity?: Maybe<TNestedRealestateFileRightRecordRightHoldersLegalEntityEntity>;
  /** Тип юридического лица */
  type?: Maybe<TNestedRealestateFileRightRecordRightHoldersLegalEntityType>;
};

export type TNestedRealestateFileRightRecordRightHoldersLegalEntityContacts = {
  __typename?: 'NestedRealestateFileRightRecordRightHoldersLegalEntityContacts';
  email?: Maybe<Scalars['String']['output']>;
  /** ! Возможно в документации ошибка: mailing_addess */
  mailingAddress?: Maybe<Scalars['String']['output']>;
};

export type TNestedRealestateFileRightRecordRightHoldersLegalEntityContactsObjectFilterType = {
  email?: InputMaybe<TStringFilter>;
  mailingAddress?: InputMaybe<TStringFilter>;
};

export type TNestedRealestateFileRightRecordRightHoldersLegalEntityEntity = {
  __typename?: 'NestedRealestateFileRightRecordRightHoldersLegalEntityEntity';
  /** Орган государственной власти, орган местного самоуправления, иной государственный орган */
  governmentEntity?: Maybe<TNestedRealestateFileRightRecordRightHoldersLegalEntityEntityGovernmentEntity>;
  /** Иностранное юридическое лицо */
  notResident?: Maybe<TNestedRealestateFileRightRecordRightHoldersLegalEntityEntityNotResident>;
  /** Российское юридическое лицо */
  resident?: Maybe<TNestedRealestateFileRightRecordRightHoldersLegalEntityEntityResident>;
};

export type TNestedRealestateFileRightRecordRightHoldersLegalEntityEntityGovernmentEntity = {
  __typename?: 'NestedRealestateFileRightRecordRightHoldersLegalEntityEntityGovernmentEntity';
  inn?: Maybe<Scalars['String']['output']>;
  ogrn?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

export type TNestedRealestateFileRightRecordRightHoldersLegalEntityEntityGovernmentEntityObjectFilterType = {
  inn?: InputMaybe<TStringFilter>;
  ogrn?: InputMaybe<TStringFilter>;
  title?: InputMaybe<TStringFilter>;
};

export type TNestedRealestateFileRightRecordRightHoldersLegalEntityEntityNotResident = {
  __typename?: 'NestedRealestateFileRightRecordRightHoldersLegalEntityEntityNotResident';
  /** Страна регистрации (инкорпорации) */
  incorporateCountry?: Maybe<TNestedRealestateFileRightRecordRightHoldersLegalEntityEntityNotResidentIncorporateCountry>;
  /** Организационно-правовая форма */
  incorporationForm?: Maybe<TNestedRealestateFileRightRecordRightHoldersLegalEntityEntityNotResidentIncorporationForm>;
  inn?: Maybe<Scalars['String']['output']>;
  /** Адрес (местонахождение) в стране регистрации (инкорпорации) */
  regAddress?: Maybe<Scalars['String']['output']>;
  /** Дата регистрации */
  registrationDate?: Maybe<Scalars['String']['output']>;
  /** Регистрационный номер */
  registrationNumber?: Maybe<Scalars['String']['output']>;
  /** Наименование регистрирующего органа */
  registrationOrgan?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

export type TNestedRealestateFileRightRecordRightHoldersLegalEntityEntityNotResidentIncorporateCountry = {
  __typename?: 'NestedRealestateFileRightRecordRightHoldersLegalEntityEntityNotResidentIncorporateCountry';
  /** код из справочника */
  code?: Maybe<Scalars['NumberString']['output']>;
  /** значение */
  value?: Maybe<Scalars['String']['output']>;
};

export type TNestedRealestateFileRightRecordRightHoldersLegalEntityEntityNotResidentIncorporateCountryObjectFilterType = {
  code?: InputMaybe<TNumberStringFilter>;
  value?: InputMaybe<TStringFilter>;
};

export type TNestedRealestateFileRightRecordRightHoldersLegalEntityEntityNotResidentIncorporationForm = {
  __typename?: 'NestedRealestateFileRightRecordRightHoldersLegalEntityEntityNotResidentIncorporationForm';
  /** код из справочника */
  code?: Maybe<Scalars['NumberString']['output']>;
  /** значение */
  value?: Maybe<Scalars['String']['output']>;
};

export type TNestedRealestateFileRightRecordRightHoldersLegalEntityEntityNotResidentIncorporationFormObjectFilterType = {
  code?: InputMaybe<TNumberStringFilter>;
  value?: InputMaybe<TStringFilter>;
};

export type TNestedRealestateFileRightRecordRightHoldersLegalEntityEntityNotResidentObjectFilterType = {
  incorporateCountry?: InputMaybe<TNestedRealestateFileRightRecordRightHoldersLegalEntityEntityNotResidentIncorporateCountryObjectFilterType>;
  incorporationForm?: InputMaybe<TNestedRealestateFileRightRecordRightHoldersLegalEntityEntityNotResidentIncorporationFormObjectFilterType>;
  inn?: InputMaybe<TStringFilter>;
  regAddress?: InputMaybe<TStringFilter>;
  registrationDate?: InputMaybe<TStringFilter>;
  registrationNumber?: InputMaybe<TStringFilter>;
  registrationOrgan?: InputMaybe<TStringFilter>;
  title?: InputMaybe<TStringFilter>;
};

export type TNestedRealestateFileRightRecordRightHoldersLegalEntityEntityObjectFilterType = {
  governmentEntity?: InputMaybe<TNestedRealestateFileRightRecordRightHoldersLegalEntityEntityGovernmentEntityObjectFilterType>;
  notResident?: InputMaybe<TNestedRealestateFileRightRecordRightHoldersLegalEntityEntityNotResidentObjectFilterType>;
  resident?: InputMaybe<TNestedRealestateFileRightRecordRightHoldersLegalEntityEntityResidentObjectFilterType>;
};

export type TNestedRealestateFileRightRecordRightHoldersLegalEntityEntityResident = {
  __typename?: 'NestedRealestateFileRightRecordRightHoldersLegalEntityEntityResident';
  /** Организационно-правовая форма */
  incorporationForm?: Maybe<TNestedRealestateFileRightRecordRightHoldersLegalEntityEntityResidentIncorporationForm>;
  inn?: Maybe<Scalars['String']['output']>;
  ogrn?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

export type TNestedRealestateFileRightRecordRightHoldersLegalEntityEntityResidentIncorporationForm = {
  __typename?: 'NestedRealestateFileRightRecordRightHoldersLegalEntityEntityResidentIncorporationForm';
  /** код из справочника */
  code?: Maybe<Scalars['NumberString']['output']>;
  /** значение */
  value?: Maybe<Scalars['String']['output']>;
};

export type TNestedRealestateFileRightRecordRightHoldersLegalEntityEntityResidentIncorporationFormObjectFilterType = {
  code?: InputMaybe<TNumberStringFilter>;
  value?: InputMaybe<TStringFilter>;
};

export type TNestedRealestateFileRightRecordRightHoldersLegalEntityEntityResidentObjectFilterType = {
  incorporationForm?: InputMaybe<TNestedRealestateFileRightRecordRightHoldersLegalEntityEntityResidentIncorporationFormObjectFilterType>;
  inn?: InputMaybe<TStringFilter>;
  ogrn?: InputMaybe<TStringFilter>;
  title?: InputMaybe<TStringFilter>;
};

export type TNestedRealestateFileRightRecordRightHoldersLegalEntityObjectFilterType = {
  contacts?: InputMaybe<TNestedRealestateFileRightRecordRightHoldersLegalEntityContactsObjectFilterType>;
  entity?: InputMaybe<TNestedRealestateFileRightRecordRightHoldersLegalEntityEntityObjectFilterType>;
  type?: InputMaybe<TNestedRealestateFileRightRecordRightHoldersLegalEntityTypeObjectFilterType>;
};

export type TNestedRealestateFileRightRecordRightHoldersLegalEntityType = {
  __typename?: 'NestedRealestateFileRightRecordRightHoldersLegalEntityType';
  /** код из справочника */
  code?: Maybe<Scalars['NumberString']['output']>;
  /** значение */
  value?: Maybe<Scalars['String']['output']>;
};

export type TNestedRealestateFileRightRecordRightHoldersLegalEntityTypeObjectFilterType = {
  code?: InputMaybe<TNumberStringFilter>;
  value?: InputMaybe<TStringFilter>;
};

export type TNestedRealestateFileRightRecordRightHoldersObjectFilterType = {
  another?: InputMaybe<TNestedRealestateFileRightRecordRightHoldersAnotherObjectFilterType>;
  individual?: InputMaybe<TNestedRealestateFileRightRecordRightHoldersIndividualObjectFilterType>;
  legalEntity?: InputMaybe<TNestedRealestateFileRightRecordRightHoldersLegalEntityObjectFilterType>;
  publicFormation?: InputMaybe<TNestedRealestateFileRightRecordRightHoldersPublicFormationObjectFilterType>;
  publicServitude?: InputMaybe<TStringFilter>;
  somethingElse?: InputMaybe<TStringFilter>;
};

export type TNestedRealestateFileRightRecordRightHoldersPublicFormation = {
  __typename?: 'NestedRealestateFileRightRecordRightHoldersPublicFormation';
  /** Иностранное государство */
  foreign?: Maybe<Scalars['String']['output']>;
  /** Наименование муниципального образования */
  municipality?: Maybe<Scalars['String']['output']>;
  /** Российская Федерация */
  russia?: Maybe<TNestedRealestateFileRightRecordRightHoldersPublicFormationRussia>;
  /** Наименование субъекта Российской Федерации */
  subjectOfRf?: Maybe<TNestedRealestateFileRightRecordRightHoldersPublicFormationSubjectOfRf>;
  /** Союзное государство */
  union?: Maybe<Scalars['String']['output']>;
};

export type TNestedRealestateFileRightRecordRightHoldersPublicFormationObjectFilterType = {
  foreign?: InputMaybe<TStringFilter>;
  municipality?: InputMaybe<TStringFilter>;
  russia?: InputMaybe<TNestedRealestateFileRightRecordRightHoldersPublicFormationRussiaObjectFilterType>;
  subjectOfRf?: InputMaybe<TNestedRealestateFileRightRecordRightHoldersPublicFormationSubjectOfRfObjectFilterType>;
  union?: InputMaybe<TStringFilter>;
};

export type TNestedRealestateFileRightRecordRightHoldersPublicFormationRussia = {
  __typename?: 'NestedRealestateFileRightRecordRightHoldersPublicFormationRussia';
  /** код из справочника */
  code?: Maybe<Scalars['NumberString']['output']>;
  /** значение */
  value?: Maybe<Scalars['String']['output']>;
};

export type TNestedRealestateFileRightRecordRightHoldersPublicFormationRussiaObjectFilterType = {
  code?: InputMaybe<TNumberStringFilter>;
  value?: InputMaybe<TStringFilter>;
};

export type TNestedRealestateFileRightRecordRightHoldersPublicFormationSubjectOfRf = {
  __typename?: 'NestedRealestateFileRightRecordRightHoldersPublicFormationSubjectOfRf';
  /** код из справочника */
  code?: Maybe<Scalars['NumberString']['output']>;
  /** значение */
  value?: Maybe<Scalars['String']['output']>;
};

export type TNestedRealestateFileRightRecordRightHoldersPublicFormationSubjectOfRfObjectFilterType = {
  code?: InputMaybe<TNumberStringFilter>;
  value?: InputMaybe<TStringFilter>;
};

export type TNestedRealestateFileRightRecordThirdPartyConsents = {
  __typename?: 'NestedRealestateFileRightRecordThirdPartyConsents';
  /** Не представлено согласие на совершение сделки */
  dissentingEntities?: Maybe<TNestedRealestateFileRightRecordThirdPartyConsentsDissentingEntities>;
  /** Федеральный закон, которым предусмотрено получение согласия на совершение сделки */
  law?: Maybe<TNestedRealestateFileRightRecordThirdPartyConsentsLaw>;
  /** Содержание отметки при возникновении / погашении */
  markContent?: Maybe<Scalars['String']['output']>;
};

export type TNestedRealestateFileRightRecordThirdPartyConsentsDissentingEntities = {
  __typename?: 'NestedRealestateFileRightRecordThirdPartyConsentsDissentingEntities';
  /** Физическое лицо */
  individual?: Maybe<TNestedRealestateFileRightRecordThirdPartyConsentsDissentingEntitiesIndividual>;
  /** Юридическое лицо, орган власти, местного самоуправления */
  legalEntity?: Maybe<Scalars['String']['output']>;
};

export type TNestedRealestateFileRightRecordThirdPartyConsentsDissentingEntitiesIndividual = {
  __typename?: 'NestedRealestateFileRightRecordThirdPartyConsentsDissentingEntitiesIndividual';
  firstName?: Maybe<Scalars['String']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  middleName?: Maybe<Scalars['String']['output']>;
};

export type TNestedRealestateFileRightRecordThirdPartyConsentsDissentingEntitiesIndividualObjectFilterType = {
  firstName?: InputMaybe<TStringFilter>;
  lastName?: InputMaybe<TStringFilter>;
  middleName?: InputMaybe<TStringFilter>;
};

export type TNestedRealestateFileRightRecordThirdPartyConsentsDissentingEntitiesObjectFilterType = {
  individual?: InputMaybe<TNestedRealestateFileRightRecordThirdPartyConsentsDissentingEntitiesIndividualObjectFilterType>;
  legalEntity?: InputMaybe<TStringFilter>;
};

export type TNestedRealestateFileRightRecordThirdPartyConsentsLaw = {
  __typename?: 'NestedRealestateFileRightRecordThirdPartyConsentsLaw';
  /** Статья */
  article?: Maybe<Scalars['String']['output']>;
  /** Дата */
  lawDate?: Maybe<Scalars['String']['output']>;
  /** Номер */
  number?: Maybe<Scalars['String']['output']>;
  /** Пункт */
  paragraph?: Maybe<Scalars['String']['output']>;
  /** Часть */
  section?: Maybe<Scalars['String']['output']>;
  /** Наименование */
  title?: Maybe<Scalars['String']['output']>;
};

export type TNestedRealestateFileRightRecordThirdPartyConsentsLawObjectFilterType = {
  article?: InputMaybe<TStringFilter>;
  lawDate?: InputMaybe<TStringFilter>;
  number?: InputMaybe<TStringFilter>;
  paragraph?: InputMaybe<TStringFilter>;
  section?: InputMaybe<TStringFilter>;
  title?: InputMaybe<TStringFilter>;
};

export type TNestedRealestateFileRightRecordThirdPartyConsentsObjectFilterType = {
  dissentingEntities?: InputMaybe<TNestedRealestateFileRightRecordThirdPartyConsentsDissentingEntitiesObjectFilterType>;
  law?: InputMaybe<TNestedRealestateFileRightRecordThirdPartyConsentsLawObjectFilterType>;
  markContent?: InputMaybe<TStringFilter>;
};

export type TNestedRealestateFileRightRecordUnderlyingDocuments = {
  __typename?: 'NestedRealestateFileRightRecordUnderlyingDocuments';
  code?: Maybe<TNestedRealestateFileRightRecordUnderlyingDocumentsCode>;
  date?: Maybe<Scalars['DateTimeISO']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type TNestedRealestateFileRightRecordUnderlyingDocumentsCode = {
  __typename?: 'NestedRealestateFileRightRecordUnderlyingDocumentsCode';
  /** код из справочника */
  code?: Maybe<Scalars['NumberString']['output']>;
  /** значение */
  value?: Maybe<Scalars['String']['output']>;
};

export type TNestedRealestateFileRightRecordUnderlyingDocumentsCodeObjectFilterType = {
  code?: InputMaybe<TNumberStringFilter>;
  value?: InputMaybe<TStringFilter>;
};

export type TNestedRealestateFileRightRecordUnderlyingDocumentsObjectFilterType = {
  code?: InputMaybe<TNestedRealestateFileRightRecordUnderlyingDocumentsCodeObjectFilterType>;
  date?: InputMaybe<TDateTimeIsoFilter>;
  name?: InputMaybe<TStringFilter>;
};

export type TNestedRealestateFileRoomRecords = {
  __typename?: 'NestedRealestateFileRoomRecords';
  /** Расположение в пределах объекта недвижимости (планы этажа, части этажа, нескольких этажей) */
  locationInBuild?: Maybe<Array<Maybe<TNestedRealestateFileRoomRecordsLocationInBuild>>>;
  /** Общие сведения (кадастровый номер помещения) */
  object?: Maybe<TNestedRealestateFileRoomRecordsObject>;
};


export type TNestedRealestateFileRoomRecordsLocationInBuildArgs = {
  pagination?: InputMaybe<TPagination>;
};

export type TNestedRealestateFileRoomRecordsLocationInBuild = {
  __typename?: 'NestedRealestateFileRoomRecordsLocationInBuild';
  /** Описание расположения */
  description?: Maybe<Scalars['String']['output']>;
  /** Номер этажа */
  floor?: Maybe<Scalars['Int']['output']>;
  /** Тип этажа */
  floorType?: Maybe<Scalars['Int']['output']>;
  /** Номер на поэтажном плане */
  planNumber?: Maybe<Scalars['String']['output']>;
  /** Планы */
  plans?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};


export type TNestedRealestateFileRoomRecordsLocationInBuildPlansArgs = {
  pagination?: InputMaybe<TPagination>;
};

export type TNestedRealestateFileRoomRecordsLocationInBuildObjectFilterType = {
  description?: InputMaybe<TStringFilter>;
  floor?: InputMaybe<TIntFilter>;
  floorType?: InputMaybe<TIntFilter>;
  planNumber?: InputMaybe<TStringFilter>;
  plans?: InputMaybe<TStringFilter>;
};

export type TNestedRealestateFileRoomRecordsObject = {
  __typename?: 'NestedRealestateFileRoomRecordsObject';
  /** Кадастровый номер */
  cadNumber?: Maybe<Scalars['String']['output']>;
  /** Номер кадастрового квартала */
  quarterCadNumber?: Maybe<Scalars['String']['output']>;
  /** Вид объекта недвижимости */
  type?: Maybe<TNestedRealestateFileRoomRecordsObjectType>;
};

export type TNestedRealestateFileRoomRecordsObjectFilterType = {
  locationInBuild?: InputMaybe<TNestedRealestateFileRoomRecordsLocationInBuildObjectFilterType>;
  object?: InputMaybe<TNestedRealestateFileRoomRecordsObjectObjectFilterType>;
};

export type TNestedRealestateFileRoomRecordsObjectObjectFilterType = {
  cadNumber?: InputMaybe<TStringFilter>;
  quarterCadNumber?: InputMaybe<TStringFilter>;
  type?: InputMaybe<TNestedRealestateFileRoomRecordsObjectTypeObjectFilterType>;
};

export type TNestedRealestateFileRoomRecordsObjectType = {
  __typename?: 'NestedRealestateFileRoomRecordsObjectType';
  /** код из справочника */
  code?: Maybe<Scalars['NumberString']['output']>;
  /** значение */
  value?: Maybe<Scalars['String']['output']>;
};

export type TNestedRealestateFileRoomRecordsObjectTypeObjectFilterType = {
  code?: InputMaybe<TNumberStringFilter>;
  value?: InputMaybe<TStringFilter>;
};

/** Filter type for NumberString scalar */
export type TNumberStringFilter = {
  /** [$all] Полное совпадение значений */
  ALL?: InputMaybe<Array<InputMaybe<Scalars['NumberString']['input']>>>;
  /** [$eq] Равенство значений */
  EQ?: InputMaybe<Scalars['NumberString']['input']>;
  /** [$in] Одно из значений */
  IN?: InputMaybe<Array<InputMaybe<Scalars['NumberString']['input']>>>;
  /** [$ne] Не равно переданному значению */
  NE?: InputMaybe<Scalars['NumberString']['input']>;
  /** [$nin] Не равно ни одному из переданных значений */
  NIN?: InputMaybe<Array<InputMaybe<Scalars['NumberString']['input']>>>;
  /** [$not] Логическое отрицание */
  NOT?: InputMaybe<TNumberStringNotFilter>;
};

/** Filter type for $not of NumberString scalar */
export type TNumberStringNotFilter = {
  /** [$all] Полное совпадение значений */
  ALL?: InputMaybe<Array<InputMaybe<Scalars['NumberString']['input']>>>;
  /** [$eq] Равенство значений */
  EQ?: InputMaybe<Scalars['NumberString']['input']>;
  /** [$in] Одно из значений */
  IN?: InputMaybe<Array<InputMaybe<Scalars['NumberString']['input']>>>;
  /** [$ne] Не равно переданному значению */
  NE?: InputMaybe<Scalars['NumberString']['input']>;
  /** [$nin] Не равно ни одному из переданных значений */
  NIN?: InputMaybe<Array<InputMaybe<Scalars['NumberString']['input']>>>;
};

/** Filter type for OGRN scalar */
export type TOgrnFilter = {
  /** [$all] Полное совпадение значений */
  ALL?: InputMaybe<Array<InputMaybe<Scalars['OGRN']['input']>>>;
  /** [$eq] Равенство значений */
  EQ?: InputMaybe<Scalars['OGRN']['input']>;
  /** [$in] Одно из значений */
  IN?: InputMaybe<Array<InputMaybe<Scalars['OGRN']['input']>>>;
  /** [$ne] Не равно переданному значению */
  NE?: InputMaybe<Scalars['OGRN']['input']>;
  /** [$nin] Не равно ни одному из переданных значений */
  NIN?: InputMaybe<Array<InputMaybe<Scalars['OGRN']['input']>>>;
  /** [$not] Логическое отрицание */
  NOT?: InputMaybe<TOgrnNotFilter>;
};

/** Filter type for $not of OGRN scalar */
export type TOgrnNotFilter = {
  /** [$all] Полное совпадение значений */
  ALL?: InputMaybe<Array<InputMaybe<Scalars['OGRN']['input']>>>;
  /** [$eq] Равенство значений */
  EQ?: InputMaybe<Scalars['OGRN']['input']>;
  /** [$in] Одно из значений */
  IN?: InputMaybe<Array<InputMaybe<Scalars['OGRN']['input']>>>;
  /** [$ne] Не равно переданному значению */
  NE?: InputMaybe<Scalars['OGRN']['input']>;
  /** [$nin] Не равно ни одному из переданных значений */
  NIN?: InputMaybe<Array<InputMaybe<Scalars['OGRN']['input']>>>;
};

export type TOrganization = {
  __typename?: 'Organization';
  /** Фактический адрес */
  actualAddress?: Maybe<Scalars['String']['output']>;
  bank?: Maybe<TNestedOrganizationBank>;
  ceo?: Maybe<TNestedOrganizationCeo>;
  /** Город организации */
  city?: Maybe<Scalars['String']['output']>;
  contact?: Maybe<TNestedOrganizationContact>;
  /** Дата создания объекта в БД */
  created?: Maybe<Scalars['DateTimeISO']['output']>;
  /** ClientId продукта, создавшего объект */
  createdBy?: Maybe<Scalars['String']['output']>;
  /** Email организации */
  email?: Maybe<Scalars['EmailAddress']['output']>;
  /** Количество сотрудников */
  employeesCount?: Maybe<Scalars['Int']['output']>;
  hash?: Maybe<Scalars['String']['output']>;
  /** Идентификационный номер налогоплательщика организации (ИНН) */
  inn: Scalars['INN']['output'];
  /** КПП */
  kpp?: Maybe<Scalars['KPP']['output']>;
  /** Связь между организацией и заявкой */
  loanApplication?: Maybe<TLoanApplication>;
  /** Организация которая является основной у человека */
  mainOwner?: Maybe<TPeople>;
  /** Тип основного помещения */
  mainRoomType?: Maybe<EOrganizationRoomType>;
  /** Название организации */
  name?: Maybe<Scalars['String']['output']>;
  /** ОКАТО */
  okato?: Maybe<Scalars['String']['output']>;
  /** ОКПО */
  okpo?: Maybe<Scalars['String']['output']>;
  /** ОКВЭД */
  okved?: Maybe<Scalars['String']['output']>;
  owner?: Maybe<TNestedOrganizationOwner>;
  /** Список организаций пользователя (как владельца) */
  ownerPeople?: Maybe<TPeople>;
  /** Тип собственности помещения */
  ownershipRoomType?: Maybe<EOrgOwnershipRoomType>;
  /** Адрес регистрации */
  registrationAddress?: Maybe<Scalars['String']['output']>;
  /** Выручка компании */
  revenue?: Maybe<Scalars['Int']['output']>;
  /** Система налогооблажения */
  taxationType?: Maybe<EOrgTaxationType>;
  /** Дата последнего обновления объекта в БД */
  updated?: Maybe<Scalars['DateTimeISO']['output']>;
  /** ClientId продукта, обновившего объект */
  updatedBy?: Maybe<Scalars['String']['output']>;
  /** Сайт компании */
  webSiteUrl?: Maybe<Scalars['String']['output']>;
};


export type TOrganizationLoanApplicationArgs = {
  filter?: InputMaybe<TLoanApplicationFilter>;
};


export type TOrganizationMainOwnerArgs = {
  filter?: InputMaybe<TPeopleFilter>;
};


export type TOrganizationOwnerPeopleArgs = {
  filter?: InputMaybe<TPeopleFilter>;
};

export type TOrganizationFilter = {
  AND?: InputMaybe<Array<InputMaybe<TOrganizationFilter>>>;
  NOR?: InputMaybe<Array<InputMaybe<TOrganizationFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<TOrganizationFilter>>>;
  actualAddress?: InputMaybe<TStringFilter>;
  bank?: InputMaybe<TNestedOrganizationBankObjectFilterType>;
  ceo?: InputMaybe<TNestedOrganizationCeoObjectFilterType>;
  city?: InputMaybe<TStringFilter>;
  contact?: InputMaybe<TNestedOrganizationContactObjectFilterType>;
  created?: InputMaybe<TDateTimeIsoFilter>;
  createdBy?: InputMaybe<TStringFilter>;
  email?: InputMaybe<TEmailAddressFilter>;
  employeesCount?: InputMaybe<TIntFilter>;
  hash?: InputMaybe<TStringFilter>;
  inn?: InputMaybe<TInnFilter>;
  kpp?: InputMaybe<TKppFilter>;
  mainRoomType?: InputMaybe<TEOrganizationRoomTypeFilter>;
  name?: InputMaybe<TStringFilter>;
  okato?: InputMaybe<TStringFilter>;
  okpo?: InputMaybe<TStringFilter>;
  okved?: InputMaybe<TStringFilter>;
  owner?: InputMaybe<TNestedOrganizationOwnerObjectFilterType>;
  ownershipRoomType?: InputMaybe<TEOrgOwnershipRoomTypeFilter>;
  registrationAddress?: InputMaybe<TStringFilter>;
  revenue?: InputMaybe<TIntFilter>;
  taxationType?: InputMaybe<TEOrgTaxationTypeFilter>;
  updated?: InputMaybe<TDateTimeIsoFilter>;
  updatedBy?: InputMaybe<TStringFilter>;
  webSiteUrl?: InputMaybe<TStringFilter>;
};

/** Пагинация */
export type TPagination = {
  limit?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  skip?: InputMaybe<Scalars['NonNegativeInt']['input']>;
};

export type TPassport = {
  __typename?: 'Passport';
  /** Дата регистрации */
  addressRegistrationDate?: Maybe<Scalars['DateTimeISO']['output']>;
  /** Вручную подтвержденный адрес регистрации в CRM */
  approvedRegistration?: Maybe<THabitation>;
  /** Дата рождения */
  birthDate?: Maybe<Scalars['BirthDate']['output']>;
  /** Место рождения */
  birthPlace?: Maybe<Scalars['String']['output']>;
  /** Дата создания объекта в БД */
  created?: Maybe<Scalars['DateTimeISO']['output']>;
  /** ClientId продукта, создавшего объект */
  createdBy?: Maybe<Scalars['String']['output']>;
  /** Ведомство */
  departmentDoc?: Maybe<Scalars['String']['output']>;
  /** Имя */
  firstName?: Maybe<Scalars['StrictString']['output']>;
  /** Пол клиента */
  gender?: Maybe<EGender>;
  hash?: Maybe<Scalars['String']['output']>;
  /**
   * ИД документа ESIA
   * @deprecated This field is deprecated. Never use it
   */
  id?: Maybe<Scalars['String']['output']>;
  /** Дата выдачи */
  issueDate?: Maybe<Scalars['DateTimeISO']['output']>;
  /** Код подразделения */
  issueId?: Maybe<Scalars['IssueId']['output']>;
  /** Кем выдан паспорт */
  issuedBy?: Maybe<Scalars['String']['output']>;
  /** Фамилия */
  lastName?: Maybe<Scalars['StrictString']['output']>;
  /** Отчество */
  middleName?: Maybe<Scalars['StrictString']['output']>;
  /** Номер */
  number: Scalars['String']['output'];
  /**
   * Статус паспорта ESIA
   * @deprecated Не используется.
   */
  passportStatus?: Maybe<Scalars['String']['output']>;
  /**
   * Тип паспорта
   * @deprecated Не используется. Отдельные типы паспорта в отдельных типах данных.
   */
  passportType?: Maybe<Scalars['String']['output']>;
  /** Временная ссылка для миграции People.passport в отдельный объект */
  people?: Maybe<TPeople>;
  /** Паспорт гражданина РФ [Альфа] */
  peopleFromAlfaPassport?: Maybe<TPeople>;
  peopleFromAlfaPassportHistory?: Maybe<TPeople>;
  /** Паспорт гражданина РФ [ЕСИА] */
  peopleFromEsiaPassport?: Maybe<TPeople>;
  /** Паспорт гражданина РФ [Сбер] */
  peopleFromSberPassport?: Maybe<TPeople>;
  peopleFromSberPassportHistory?: Maybe<TPeople>;
  /** Паспорт гражданина РФ [ТБанк] */
  peopleFromTBankPassport?: Maybe<TPeople>;
  peopleFromTBankPassportHistory?: Maybe<TPeople>;
  /** Вручную подтвержденный паспорт в CRM */
  profile?: Maybe<TProfile>;
  /** Паспорт гражданина РФ (ЕСИА) */
  profileFromESIAPassport?: Maybe<TProfile>;
  profileFromESIAPassportHistory?: Maybe<TProfile>;
  /** Паспорт гражданина РФ (Сбер) */
  profileFromSberPassport?: Maybe<TProfile>;
  profileFromSberPassportHistory?: Maybe<TProfile>;
  /** Паспорт гражданина РФ (ТБанк) */
  profileFromTBankPassport?: Maybe<TProfile>;
  profileFromTBankPassportHistory?: Maybe<TProfile>;
  /** Дата получения документа */
  receiptDocDate?: Maybe<Scalars['DateTimeISO']['output']>;
  /** Релевантность ESIA */
  relevance?: Maybe<EDocumentRelevance>;
  /** Серия */
  series: Scalars['String']['output'];
  /** Источник паспорта (manual или approved) */
  source: ESource;
  /**
   * Статус ESIA
   * @deprecated Поле бесмысленно и не используется.
   */
  status?: Maybe<EDocumentStatus>;
  /**
   * Тип документа
   * @deprecated Поле бесмысленно и не используется.
   */
  type?: Maybe<EDocumentType>;
  /** Дата последнего обновления объекта в БД */
  updated?: Maybe<Scalars['DateTimeISO']['output']>;
  /** ClientId продукта, обновившего объект */
  updatedBy?: Maybe<Scalars['String']['output']>;
  /**
   * Дата валидации документа ESIA
   * @deprecated This field is deprecated. Never use it
   */
  validateDateDoc?: Maybe<Scalars['DateTimeISO']['output']>;
};


export type TPassportApprovedRegistrationArgs = {
  filter?: InputMaybe<THabitationFilter>;
};


export type TPassportPeopleArgs = {
  filter?: InputMaybe<TPeopleFilter>;
};


export type TPassportPeopleFromAlfaPassportArgs = {
  filter?: InputMaybe<TPeopleFilter>;
};


export type TPassportPeopleFromAlfaPassportHistoryArgs = {
  filter?: InputMaybe<TPeopleFilter>;
};


export type TPassportPeopleFromEsiaPassportArgs = {
  filter?: InputMaybe<TPeopleFilter>;
};


export type TPassportPeopleFromSberPassportArgs = {
  filter?: InputMaybe<TPeopleFilter>;
};


export type TPassportPeopleFromSberPassportHistoryArgs = {
  filter?: InputMaybe<TPeopleFilter>;
};


export type TPassportPeopleFromTBankPassportArgs = {
  filter?: InputMaybe<TPeopleFilter>;
};


export type TPassportPeopleFromTBankPassportHistoryArgs = {
  filter?: InputMaybe<TPeopleFilter>;
};


export type TPassportProfileArgs = {
  filter?: InputMaybe<TProfileFilter>;
};


export type TPassportProfileFromEsiaPassportArgs = {
  filter?: InputMaybe<TProfileFilter>;
};


export type TPassportProfileFromEsiaPassportHistoryArgs = {
  filter?: InputMaybe<TProfileFilter>;
};


export type TPassportProfileFromSberPassportArgs = {
  filter?: InputMaybe<TProfileFilter>;
};


export type TPassportProfileFromSberPassportHistoryArgs = {
  filter?: InputMaybe<TProfileFilter>;
};


export type TPassportProfileFromTBankPassportArgs = {
  filter?: InputMaybe<TProfileFilter>;
};


export type TPassportProfileFromTBankPassportHistoryArgs = {
  filter?: InputMaybe<TProfileFilter>;
};

export type TPassportFilter = {
  AND?: InputMaybe<Array<InputMaybe<TPassportFilter>>>;
  NOR?: InputMaybe<Array<InputMaybe<TPassportFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<TPassportFilter>>>;
  addressRegistrationDate?: InputMaybe<TDateTimeIsoFilter>;
  birthDate?: InputMaybe<TBirthDateFilter>;
  birthPlace?: InputMaybe<TStringFilter>;
  created?: InputMaybe<TDateTimeIsoFilter>;
  createdBy?: InputMaybe<TStringFilter>;
  departmentDoc?: InputMaybe<TStringFilter>;
  firstName?: InputMaybe<TStrictStringFilter>;
  gender?: InputMaybe<TEGenderFilter>;
  hash?: InputMaybe<TStringFilter>;
  id?: InputMaybe<TStringFilter>;
  issueDate?: InputMaybe<TDateTimeIsoFilter>;
  issueId?: InputMaybe<TIssueIdFilter>;
  issuedBy?: InputMaybe<TStringFilter>;
  lastName?: InputMaybe<TStrictStringFilter>;
  middleName?: InputMaybe<TStrictStringFilter>;
  number?: InputMaybe<TStringFilter>;
  passportStatus?: InputMaybe<TStringFilter>;
  passportType?: InputMaybe<TStringFilter>;
  receiptDocDate?: InputMaybe<TDateTimeIsoFilter>;
  relevance?: InputMaybe<TEDocumentRelevanceFilter>;
  series?: InputMaybe<TStringFilter>;
  source?: InputMaybe<TESourceFilter>;
  status?: InputMaybe<TEDocumentStatusFilter>;
  type?: InputMaybe<TEDocumentTypeFilter>;
  updated?: InputMaybe<TDateTimeIsoFilter>;
  updatedBy?: InputMaybe<TStringFilter>;
  validateDateDoc?: InputMaybe<TDateTimeIsoFilter>;
};

export type TPayoutIncome = {
  __typename?: 'PayoutIncome';
  /** Список информации о 2-НДФЛ */
  NDFL2?: Maybe<Array<Maybe<TPayoutIncomeNdfl2>>>;
  /** Список информации о 2-НДФЛ */
  NDFL3?: Maybe<Array<Maybe<TPayoutIncomeNdfl3>>>;
  /** Дата создания объекта в БД */
  created?: Maybe<Scalars['DateTimeISO']['output']>;
  /** ClientId продукта, создавшего объект */
  createdBy?: Maybe<Scalars['String']['output']>;
  /** - */
  hash?: Maybe<Scalars['String']['output']>;
  /** ИД документа ESIA */
  id?: Maybe<Scalars['String']['output']>;
  /** [Тут когда-то будет описание] */
  payout?: Maybe<Array<Maybe<TNestedPayoutIncomePayout>>>;
  person?: Maybe<TNestedPayoutIncomePerson>;
  /** Сведения о доходах физического лица, о выплатах, произведённых плательщиками страховых взносов в пользу физического лица */
  profile?: Maybe<TPeople>;
  /** Источник */
  source: ESource;
  /** Дата последнего обновления объекта в БД */
  updated?: Maybe<Scalars['DateTimeISO']['output']>;
  /** ClientId продукта, обновившего объект */
  updatedBy?: Maybe<Scalars['String']['output']>;
  /** Отчетный год */
  year: Scalars['year']['output'];
};


export type TPayoutIncomeNdfl2Args = {
  filter?: InputMaybe<TPayoutIncomeNdfl2Filter>;
  pagination?: InputMaybe<TPagination>;
};


export type TPayoutIncomeNdfl3Args = {
  filter?: InputMaybe<TPayoutIncomeNdfl3Filter>;
  pagination?: InputMaybe<TPagination>;
};


export type TPayoutIncomePayoutArgs = {
  pagination?: InputMaybe<TPagination>;
};


export type TPayoutIncomeProfileArgs = {
  filter?: InputMaybe<TPeopleFilter>;
};

export type TPayoutIncomeFilter = {
  AND?: InputMaybe<Array<InputMaybe<TPayoutIncomeFilter>>>;
  NOR?: InputMaybe<Array<InputMaybe<TPayoutIncomeFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<TPayoutIncomeFilter>>>;
  created?: InputMaybe<TDateTimeIsoFilter>;
  createdBy?: InputMaybe<TStringFilter>;
  hash?: InputMaybe<TStringFilter>;
  id?: InputMaybe<TStringFilter>;
  payout?: InputMaybe<TNestedPayoutIncomePayoutObjectFilterType>;
  person?: InputMaybe<TNestedPayoutIncomePersonObjectFilterType>;
  source?: InputMaybe<TESourceFilter>;
  updated?: InputMaybe<TDateTimeIsoFilter>;
  updatedBy?: InputMaybe<TStringFilter>;
  year?: InputMaybe<TYearFilter>;
};

export type TPayoutIncomeNdfl2 = {
  __typename?: 'PayoutIncomeNDFL2';
  /** Дата создания объекта в БД */
  created?: Maybe<Scalars['DateTimeISO']['output']>;
  /** ClientId продукта, создавшего объект */
  createdBy?: Maybe<Scalars['String']['output']>;
  /** hash */
  hash?: Maybe<Scalars['String']['output']>;
  /** Список доходов */
  incomeTaxable?: Maybe<Array<Maybe<TNestedPayoutIncomeNdfl2IncomeTaxable>>>;
  /** Системное поле для генерации hash */
  index: Scalars['Int']['output'];
  /** Источник */
  source: ESource;
  taxAgent?: Maybe<TNestedPayoutIncomeNdfl2TaxAgent>;
  total?: Maybe<TNestedPayoutIncomeNdfl2Total>;
  /** Дата последнего обновления объекта в БД */
  updated?: Maybe<Scalars['DateTimeISO']['output']>;
  /** ClientId продукта, обновившего объект */
  updatedBy?: Maybe<Scalars['String']['output']>;
  /** Год дохода */
  year: Scalars['year']['output'];
};


export type TPayoutIncomeNdfl2IncomeTaxableArgs = {
  pagination?: InputMaybe<TPagination>;
};

export type TPayoutIncomeNdfl2Filter = {
  AND?: InputMaybe<Array<InputMaybe<TPayoutIncomeNdfl2Filter>>>;
  NOR?: InputMaybe<Array<InputMaybe<TPayoutIncomeNdfl2Filter>>>;
  OR?: InputMaybe<Array<InputMaybe<TPayoutIncomeNdfl2Filter>>>;
  created?: InputMaybe<TDateTimeIsoFilter>;
  createdBy?: InputMaybe<TStringFilter>;
  hash?: InputMaybe<TStringFilter>;
  incomeTaxable?: InputMaybe<TNestedPayoutIncomeNdfl2IncomeTaxableObjectFilterType>;
  index?: InputMaybe<TIntFilter>;
  source?: InputMaybe<TESourceFilter>;
  taxAgent?: InputMaybe<TNestedPayoutIncomeNdfl2TaxAgentObjectFilterType>;
  total?: InputMaybe<TNestedPayoutIncomeNdfl2TotalObjectFilterType>;
  updated?: InputMaybe<TDateTimeIsoFilter>;
  updatedBy?: InputMaybe<TStringFilter>;
  year?: InputMaybe<TYearFilter>;
};

export type TPayoutIncomeNdfl3 = {
  __typename?: 'PayoutIncomeNDFL3';
  /** Дата создания объекта в БД */
  created?: Maybe<Scalars['DateTimeISO']['output']>;
  /** ClientId продукта, создавшего объект */
  createdBy?: Maybe<Scalars['String']['output']>;
  entrepreneurship?: Maybe<TNestedPayoutIncomeNdfl3Entrepreneurship>;
  /** hash */
  hash?: Maybe<Scalars['String']['output']>;
  income?: Maybe<TNestedPayoutIncomeNdfl3Income>;
  /** Системное поле для генерации hash */
  index: Scalars['Int']['output'];
  /** Источник */
  source: ESource;
  /** Дата последнего обновления объекта в БД */
  updated?: Maybe<Scalars['DateTimeISO']['output']>;
  /** ClientId продукта, обновившего объект */
  updatedBy?: Maybe<Scalars['String']['output']>;
  /** Год */
  year: Scalars['year']['output'];
};

export type TPayoutIncomeNdfl3Filter = {
  AND?: InputMaybe<Array<InputMaybe<TPayoutIncomeNdfl3Filter>>>;
  NOR?: InputMaybe<Array<InputMaybe<TPayoutIncomeNdfl3Filter>>>;
  OR?: InputMaybe<Array<InputMaybe<TPayoutIncomeNdfl3Filter>>>;
  created?: InputMaybe<TDateTimeIsoFilter>;
  createdBy?: InputMaybe<TStringFilter>;
  entrepreneurship?: InputMaybe<TNestedPayoutIncomeNdfl3EntrepreneurshipObjectFilterType>;
  hash?: InputMaybe<TStringFilter>;
  income?: InputMaybe<TNestedPayoutIncomeNdfl3IncomeObjectFilterType>;
  index?: InputMaybe<TIntFilter>;
  source?: InputMaybe<TESourceFilter>;
  updated?: InputMaybe<TDateTimeIsoFilter>;
  updatedBy?: InputMaybe<TStringFilter>;
  year?: InputMaybe<TYearFilter>;
};

export type TPeople = {
  __typename?: 'People';
  /** Дополнительный доход, руб. */
  additionalIncome?: Maybe<Scalars['String']['output']>;
  /** Дополнительный телефон */
  additionalPhone?: Maybe<Scalars['PhoneNumber']['output']>;
  /** Владелец дополнительного телефона */
  additionalPhoneOwner?: Maybe<EAdditionalPhoneOwner>;
  additionalPhoneOwnerFIO?: Maybe<Scalars['String']['output']>;
  /** Псевдоним объекта */
  alias?: Maybe<Scalars['String']['output']>;
  /** Дата рождения */
  birthDate: Scalars['BirthDate']['output'];
  /** Место рождения */
  birthPlace?: Maybe<Scalars['String']['output']>;
  /** Страхователь в расчете КАСКО */
  cascoInsuredCars?: Maybe<Array<Maybe<TCar>>>;
  /** Гражданство */
  citizenship?: Maybe<ECitizenship>;
  /** Дата создания объекта в БД */
  created?: Maybe<Scalars['DateTimeISO']['output']>;
  /** ClientId продукта, создавшего объект */
  createdBy?: Maybe<Scalars['String']['output']>;
  creditRating?: Maybe<TNestedPeopleCreditRating>;
  creditSelection?: Maybe<TNestedPeopleCreditSelection>;
  /** Залоговое авто в кредитах */
  creditSelectionPledgeCar?: Maybe<TCar>;
  /** Адрес залога в кредитах */
  creditSelectionPledgeHabitation?: Maybe<THabitation>;
  /** Количество иждивенцев */
  dependentsCount?: Maybe<EDependents>;
  documents?: Maybe<TNestedPeopleDocuments>;
  /** Водители */
  driveCars?: Maybe<Array<Maybe<TCar>>>;
  /**
   * Старый объект водительский прав
   * @deprecated Используйте People.documents.driverLincense
   */
  driverLicence?: Maybe<TNestedPeopleDriverLicence>;
  /** Уровень образования */
  education?: Maybe<EEducation>;
  /** Email. Адрес электронной почты */
  email?: Maybe<Scalars['EmailAddress']['output']>;
  /**
   * Email подтвержден?
   * @deprecated Подтвержденный email только в объекте Profile
   */
  emailConfirmed?: Maybe<Scalars['Boolean']['output']>;
  /** Тип занятости */
  employmentType?: Maybe<EEmploymentType>;
  /** Недвижимость во владении */
  estate?: Maybe<Array<Maybe<THabitation>>>;
  /** Количество детей */
  exactDependentsNumber?: Maybe<Scalars['String']['output']>;
  familyAssets?: Maybe<TNestedPeopleFamilyAssets>;
  /** Имя */
  firstName: Scalars['StrictString']['output'];
  /**
   * Имя
   * @deprecated This field is deprecated. Never use it
   */
  firstName2?: Maybe<Scalars['StrictString']['output']>;
  /** Стоимость аренды квартиры, руб. */
  flatRentAmount?: Maybe<Scalars['String']['output']>;
  /** Пол */
  gender?: Maybe<EGender>;
  /** Договор страхования квартиры */
  habitationInsurance?: Maybe<Array<Maybe<THabitationInsuranceAgreement>>>;
  /** Уникальный хеш клиента */
  hash?: Maybe<Scalars['String']['output']>;
  /** Флаг наличия квартиры */
  haveApartment?: Maybe<EPropertyType>;
  /**
   * Флаг наличия автомобиля
   * @deprecated Не используйте для определения наличия машины
   */
  haveCar?: Maybe<EHaveCar>;
  /**
   * Статус идентификации пользователя (ТЬанк)
   * @deprecated This field is deprecated. Never use it
   */
  identificationStatus?: Maybe<Scalars['Boolean']['output']>;
  /** Идентификационный номер налогоплательщика (ИНН) */
  inn?: Maybe<Scalars['INN']['output']>;
  /** Страхуемая квартира */
  insuredHabitation?: Maybe<THabitation>;
  /** Адрес страхования недвижимости */
  insuredHabitations?: Maybe<Array<Maybe<THabitation>>>;
  internationalPassport?: Maybe<TNestedPeopleInternationalPassport>;
  job?: Maybe<TNestedPeopleJob>;
  /** Фамилия */
  lastName: Scalars['StrictString']['output'];
  /** Адрес проживания */
  livingHabitation?: Maybe<THabitation>;
  /** Суммарный платеж по действующим кредитам, руб. */
  loanPaymentTotal?: Maybe<Scalars['String']['output']>;
  /** Ограничения на кредиты */
  loanRestrictions?: Maybe<TNestedPeopleLoanRestrictions>;
  /** Организация которая является основной у человека */
  mainOrganization?: Maybe<TOrganization>;
  /** Семейное положение */
  maritalStatus?: Maybe<EFamilyStatus>;
  mfo?: Maybe<TNestedPeopleMfo>;
  /** Отчество */
  middleName?: Maybe<Scalars['StrictString']['output']>;
  /** Мобильный номер */
  mobilePhone?: Maybe<Scalars['PhoneNumber']['output']>;
  /** Ежемесячный доход, руб. */
  monthlyIncome?: Maybe<Scalars['String']['output']>;
  /** Ипотечный договор */
  mortgageAgreement?: Maybe<Array<Maybe<TMortgageAgreement>>>;
  /** Адрес ипотеки */
  mortgageHabitations?: Maybe<THabitation>;
  /** Нет отчества */
  noMiddleName?: Maybe<Scalars['Boolean']['output']>;
  /** Ссылка от заемщика на заявку */
  organizationLoanApps?: Maybe<Array<Maybe<TLoanApplication>>>;
  /** Список организаций пользователя (как владельца) */
  organizations?: Maybe<Array<Maybe<TOrganization>>>;
  osago?: Maybe<TNestedPeopleOsago>;
  /** Страхователь авто в ОСАГО */
  osagoInsuredCars?: Maybe<Array<Maybe<TCar>>>;
  /** Водители в расчете ОСАГО */
  osagoSelectedCars?: Maybe<Array<Maybe<TCar>>>;
  /** Владелец авто */
  ownCars?: Maybe<Array<Maybe<TCar>>>;
  /** Владельцы недвижимости */
  ownHabitations?: Maybe<Array<Maybe<THabitation>>>;
  /** Принадлежность к владельцу профиля */
  ownerRelation?: Maybe<ERelationStatus>;
  /**
   * Старый объект паспорта
   * @deprecated Используй People.documents.passport
   */
  passport?: Maybe<TNestedPeoplePassport>;
  /** Телефон */
  phone?: Maybe<Scalars['PhoneNumber']['output']>;
  /**
   * Телефон подтвержден?
   * @deprecated Подтвержденный phone только в объекте Profile
   */
  phoneConfirmed?: Maybe<Scalars['Boolean']['output']>;
  physiology?: Maybe<TNestedPeoplePhysiology>;
  /** Залоговое авто в кредитах */
  pledgeCar?: Maybe<Array<Maybe<TCar>>>;
  /** Адрес залога в кредитах */
  pledgeHabitations?: Maybe<Array<Maybe<THabitation>>>;
  /** Бывшее имя */
  previousFirstName?: Maybe<Scalars['String']['output']>;
  /** Бывшая фамилия */
  previousLastName?: Maybe<Scalars['StrictString']['output']>;
  /** Бывшее отчество */
  previousMiddleName?: Maybe<Scalars['StrictString']['output']>;
  /** Владелец профиля */
  profile?: Maybe<TProfile>;
  /** credit people */
  profileFromCreditPeople?: Maybe<TProfile>;
  /** mfo people */
  profileFromCreditRatingPeople?: Maybe<TProfile>;
  /** mfo people */
  profileFromMfoPeople?: Maybe<TProfile>;
  /** Mortgage People */
  profileFromMortgagePeople?: Maybe<TProfile>;
  /** mpl people */
  profileFromMplPeople?: Maybe<TProfile>;
  /** MSB People */
  profileFromMsbPeople?: Maybe<TProfile>;
  /** OSAGO People */
  profileFromOsagoPeople?: Maybe<TProfile>;
  /** Для записи данных клиента, получаемых от партнерских заявок. */
  profileFromWaybackPeople?: Maybe<TProfile>;
  /** Red people */
  profileRedPeople?: Maybe<TProfile>;
  /** Адрес регистрации! */
  registrationHabitation?: Maybe<THabitation>;
  /** Расходы на аренду и ЖКХ в месяц, руб. */
  rentCost?: Maybe<Scalars['String']['output']>;
  /** Заработная плата, руб. */
  salary?: Maybe<Scalars['String']['output']>;
  /** Банк, в котором ведется зарплатный проект */
  salaryBank?: Maybe<Scalars['String']['output']>;
  /**
   * Статус самозанятого (ТБанк)
   * @deprecated This field is deprecated. Never use it
   */
  selfEmployedStatus?: Maybe<Scalars['Boolean']['output']>;
  /** Страховой номер индивидуального лицевого счёта (СНИЛС) */
  snils?: Maybe<Scalars['SNILS']['output']>;
  /** Документ, подтверждающий платежеспособность */
  solvencyProof?: Maybe<EIncomeConfirmation>;
  /** Какой источник данных использовался для создания объекта */
  source: ESource;
  /** Тестовая ссылка */
  testo2o?: Maybe<TCar>;
  /** Причина отсутствия занятости */
  unemploymentReason?: Maybe<EUnemploymentReason>;
  /** Тестовое описание причины отсутствия занятости */
  unemploymentReasonText?: Maybe<Scalars['String']['output']>;
  /** Дата последнего обновления объекта в БД */
  updated?: Maybe<Scalars['DateTimeISO']['output']>;
  /** ClientId продукта, обновившего объект */
  updatedBy?: Maybe<Scalars['String']['output']>;
  /** Общий рабочий стаж */
  workExperience?: Maybe<EWorkExperience>;
};


export type TPeopleCascoInsuredCarsArgs = {
  filter?: InputMaybe<TCarFilter>;
  pagination?: InputMaybe<TPagination>;
};


export type TPeopleCreditSelectionPledgeCarArgs = {
  filter?: InputMaybe<TCarFilter>;
};


export type TPeopleCreditSelectionPledgeHabitationArgs = {
  filter?: InputMaybe<THabitationFilter>;
};


export type TPeopleDriveCarsArgs = {
  filter?: InputMaybe<TCarFilter>;
  pagination?: InputMaybe<TPagination>;
};


export type TPeopleEstateArgs = {
  filter?: InputMaybe<THabitationFilter>;
  pagination?: InputMaybe<TPagination>;
};


export type TPeopleHabitationInsuranceArgs = {
  filter?: InputMaybe<THabitationInsuranceAgreementFilter>;
  pagination?: InputMaybe<TPagination>;
};


export type TPeopleInsuredHabitationArgs = {
  filter?: InputMaybe<THabitationFilter>;
};


export type TPeopleInsuredHabitationsArgs = {
  filter?: InputMaybe<THabitationFilter>;
  pagination?: InputMaybe<TPagination>;
};


export type TPeopleLivingHabitationArgs = {
  filter?: InputMaybe<THabitationFilter>;
};


export type TPeopleMainOrganizationArgs = {
  filter?: InputMaybe<TOrganizationFilter>;
};


export type TPeopleMortgageAgreementArgs = {
  filter?: InputMaybe<TMortgageAgreementFilter>;
  pagination?: InputMaybe<TPagination>;
};


export type TPeopleMortgageHabitationsArgs = {
  filter?: InputMaybe<THabitationFilter>;
};


export type TPeopleOrganizationLoanAppsArgs = {
  filter?: InputMaybe<TLoanApplicationFilter>;
  pagination?: InputMaybe<TPagination>;
};


export type TPeopleOrganizationsArgs = {
  filter?: InputMaybe<TOrganizationFilter>;
  pagination?: InputMaybe<TPagination>;
};


export type TPeopleOsagoInsuredCarsArgs = {
  filter?: InputMaybe<TCarFilter>;
  pagination?: InputMaybe<TPagination>;
};


export type TPeopleOsagoSelectedCarsArgs = {
  filter?: InputMaybe<TCarFilter>;
  pagination?: InputMaybe<TPagination>;
};


export type TPeopleOwnCarsArgs = {
  filter?: InputMaybe<TCarFilter>;
  pagination?: InputMaybe<TPagination>;
};


export type TPeopleOwnHabitationsArgs = {
  filter?: InputMaybe<THabitationFilter>;
  pagination?: InputMaybe<TPagination>;
};


export type TPeoplePledgeCarArgs = {
  filter?: InputMaybe<TCarFilter>;
  pagination?: InputMaybe<TPagination>;
};


export type TPeoplePledgeHabitationsArgs = {
  filter?: InputMaybe<THabitationFilter>;
  pagination?: InputMaybe<TPagination>;
};


export type TPeopleProfileArgs = {
  filter?: InputMaybe<TProfileFilter>;
};


export type TPeopleProfileFromCreditPeopleArgs = {
  filter?: InputMaybe<TProfileFilter>;
};


export type TPeopleProfileFromCreditRatingPeopleArgs = {
  filter?: InputMaybe<TProfileFilter>;
};


export type TPeopleProfileFromMfoPeopleArgs = {
  filter?: InputMaybe<TProfileFilter>;
};


export type TPeopleProfileFromMortgagePeopleArgs = {
  filter?: InputMaybe<TProfileFilter>;
};


export type TPeopleProfileFromMplPeopleArgs = {
  filter?: InputMaybe<TProfileFilter>;
};


export type TPeopleProfileFromMsbPeopleArgs = {
  filter?: InputMaybe<TProfileFilter>;
};


export type TPeopleProfileFromOsagoPeopleArgs = {
  filter?: InputMaybe<TProfileFilter>;
};


export type TPeopleProfileFromWaybackPeopleArgs = {
  filter?: InputMaybe<TProfileFilter>;
};


export type TPeopleProfileRedPeopleArgs = {
  filter?: InputMaybe<TProfileFilter>;
};


export type TPeopleRegistrationHabitationArgs = {
  filter?: InputMaybe<THabitationFilter>;
};


export type TPeopleTesto2oArgs = {
  filter?: InputMaybe<TCarFilter>;
};

export type TPeopleFilter = {
  AND?: InputMaybe<Array<InputMaybe<TPeopleFilter>>>;
  NOR?: InputMaybe<Array<InputMaybe<TPeopleFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<TPeopleFilter>>>;
  additionalIncome?: InputMaybe<TStringFilter>;
  additionalPhone?: InputMaybe<TPhoneNumberFilter>;
  additionalPhoneOwner?: InputMaybe<TEAdditionalPhoneOwnerFilter>;
  additionalPhoneOwnerFIO?: InputMaybe<TStringFilter>;
  alias?: InputMaybe<TStringFilter>;
  birthDate?: InputMaybe<TBirthDateFilter>;
  birthPlace?: InputMaybe<TStringFilter>;
  citizenship?: InputMaybe<TECitizenshipFilter>;
  created?: InputMaybe<TDateTimeIsoFilter>;
  createdBy?: InputMaybe<TStringFilter>;
  creditRating?: InputMaybe<TNestedPeopleCreditRatingObjectFilterType>;
  creditSelection?: InputMaybe<TNestedPeopleCreditSelectionObjectFilterType>;
  dependentsCount?: InputMaybe<TEDependentsFilter>;
  education?: InputMaybe<TEEducationFilter>;
  email?: InputMaybe<TEmailAddressFilter>;
  emailConfirmed?: InputMaybe<TBooleanFilter>;
  employmentType?: InputMaybe<TEEmploymentTypeFilter>;
  exactDependentsNumber?: InputMaybe<TStringFilter>;
  familyAssets?: InputMaybe<TNestedPeopleFamilyAssetsObjectFilterType>;
  firstName?: InputMaybe<TStrictStringFilter>;
  firstName2?: InputMaybe<TStrictStringFilter>;
  flatRentAmount?: InputMaybe<TStringFilter>;
  gender?: InputMaybe<TEGenderFilter>;
  hash?: InputMaybe<TStringFilter>;
  haveApartment?: InputMaybe<TEPropertyTypeFilter>;
  haveCar?: InputMaybe<TEHaveCarFilter>;
  identificationStatus?: InputMaybe<TBooleanFilter>;
  inn?: InputMaybe<TInnFilter>;
  job?: InputMaybe<TNestedPeopleJobObjectFilterType>;
  lastName?: InputMaybe<TStrictStringFilter>;
  loanPaymentTotal?: InputMaybe<TStringFilter>;
  loanRestrictions?: InputMaybe<TNestedPeopleLoanRestrictionsObjectFilterType>;
  maritalStatus?: InputMaybe<TEFamilyStatusFilter>;
  mfo?: InputMaybe<TNestedPeopleMfoObjectFilterType>;
  middleName?: InputMaybe<TStrictStringFilter>;
  mobilePhone?: InputMaybe<TPhoneNumberFilter>;
  monthlyIncome?: InputMaybe<TStringFilter>;
  noMiddleName?: InputMaybe<TBooleanFilter>;
  osago?: InputMaybe<TNestedPeopleOsagoObjectFilterType>;
  ownerRelation?: InputMaybe<TERelationStatusFilter>;
  phone?: InputMaybe<TPhoneNumberFilter>;
  phoneConfirmed?: InputMaybe<TBooleanFilter>;
  physiology?: InputMaybe<TNestedPeoplePhysiologyObjectFilterType>;
  previousFirstName?: InputMaybe<TStringFilter>;
  previousLastName?: InputMaybe<TStrictStringFilter>;
  previousMiddleName?: InputMaybe<TStrictStringFilter>;
  rentCost?: InputMaybe<TStringFilter>;
  salary?: InputMaybe<TStringFilter>;
  salaryBank?: InputMaybe<TStringFilter>;
  selfEmployedStatus?: InputMaybe<TBooleanFilter>;
  snils?: InputMaybe<TSnilsFilter>;
  solvencyProof?: InputMaybe<TEIncomeConfirmationFilter>;
  source?: InputMaybe<TESourceFilter>;
  unemploymentReason?: InputMaybe<TEUnemploymentReasonFilter>;
  unemploymentReasonText?: InputMaybe<TStringFilter>;
  updated?: InputMaybe<TDateTimeIsoFilter>;
  updatedBy?: InputMaybe<TStringFilter>;
  workExperience?: InputMaybe<TEWorkExperienceFilter>;
};

/** Filter type for PhoneNumber scalar */
export type TPhoneNumberFilter = {
  /** [$all] Полное совпадение значений */
  ALL?: InputMaybe<Array<InputMaybe<Scalars['PhoneNumber']['input']>>>;
  /** [$eq] Равенство значений */
  EQ?: InputMaybe<Scalars['PhoneNumber']['input']>;
  /** [$in] Одно из значений */
  IN?: InputMaybe<Array<InputMaybe<Scalars['PhoneNumber']['input']>>>;
  /** [$ne] Не равно переданному значению */
  NE?: InputMaybe<Scalars['PhoneNumber']['input']>;
  /** [$nin] Не равно ни одному из переданных значений */
  NIN?: InputMaybe<Array<InputMaybe<Scalars['PhoneNumber']['input']>>>;
  /** [$not] Логическое отрицание */
  NOT?: InputMaybe<TPhoneNumberNotFilter>;
};

/** Filter type for $not of PhoneNumber scalar */
export type TPhoneNumberNotFilter = {
  /** [$all] Полное совпадение значений */
  ALL?: InputMaybe<Array<InputMaybe<Scalars['PhoneNumber']['input']>>>;
  /** [$eq] Равенство значений */
  EQ?: InputMaybe<Scalars['PhoneNumber']['input']>;
  /** [$in] Одно из значений */
  IN?: InputMaybe<Array<InputMaybe<Scalars['PhoneNumber']['input']>>>;
  /** [$ne] Не равно переданному значению */
  NE?: InputMaybe<Scalars['PhoneNumber']['input']>;
  /** [$nin] Не равно ни одному из переданных значений */
  NIN?: InputMaybe<Array<InputMaybe<Scalars['PhoneNumber']['input']>>>;
};

/** Filter type for PostalCode scalar */
export type TPostalCodeFilter = {
  /** [$all] Полное совпадение значений */
  ALL?: InputMaybe<Array<InputMaybe<Scalars['PostalCode']['input']>>>;
  /** [$eq] Равенство значений */
  EQ?: InputMaybe<Scalars['PostalCode']['input']>;
  /** [$in] Одно из значений */
  IN?: InputMaybe<Array<InputMaybe<Scalars['PostalCode']['input']>>>;
  /** [$ne] Не равно переданному значению */
  NE?: InputMaybe<Scalars['PostalCode']['input']>;
  /** [$nin] Не равно ни одному из переданных значений */
  NIN?: InputMaybe<Array<InputMaybe<Scalars['PostalCode']['input']>>>;
  /** [$not] Логическое отрицание */
  NOT?: InputMaybe<TPostalCodeNotFilter>;
};

/** Filter type for $not of PostalCode scalar */
export type TPostalCodeNotFilter = {
  /** [$all] Полное совпадение значений */
  ALL?: InputMaybe<Array<InputMaybe<Scalars['PostalCode']['input']>>>;
  /** [$eq] Равенство значений */
  EQ?: InputMaybe<Scalars['PostalCode']['input']>;
  /** [$in] Одно из значений */
  IN?: InputMaybe<Array<InputMaybe<Scalars['PostalCode']['input']>>>;
  /** [$ne] Не равно переданному значению */
  NE?: InputMaybe<Scalars['PostalCode']['input']>;
  /** [$nin] Не равно ни одному из переданных значений */
  NIN?: InputMaybe<Array<InputMaybe<Scalars['PostalCode']['input']>>>;
};

export type TProductMeta = {
  __typename?: 'ProductMeta';
  meta?: Maybe<Scalars['String']['output']>;
};

export type TProfile = {
  __typename?: 'Profile';
  Alfa?: Maybe<TNestedProfileAlfa>;
  ESIA?: Maybe<TNestedProfileEsia>;
  /**
   * Водительское удостоверение (ЕСИА)
   * @deprecated Use 'profile.ESIA.owner.documents.driverLicense'
   */
  ESIADriverLicense?: Maybe<TDriverLicense>;
  /**
   * История водительских удостоверений (ЕСИА)
   * @deprecated Use 'profile.ESIA.owner.documents.driverLicenseHistory'
   */
  ESIADriverLicenseHistory?: Maybe<Array<Maybe<TDriverLicense>>>;
  /**
   * Электронная книжка ЕСИА
   * @deprecated Use 'profile.ESIA.owner.documents.workbook'
   */
  ESIAEWorkbook?: Maybe<TEsiaeWorkbook>;
  /**
   * Последний заграничный паспорт [ЕСИА]
   * @deprecated Use 'profile.ESIA.owner.documents.FRGNPassport'
   */
  ESIAFrgnPassport?: Maybe<TFrgnPassport>;
  /**
   * История заграничных паспортов [ЕСИА]
   * @deprecated Use 'profile.ESIA.owner.documents.FRGNPassportHistory'
   */
  ESIAFrgnPassportHistory?: Maybe<Array<Maybe<TFrgnPassport>>>;
  /**
   * Владелец профиля ЕСИА
   * @deprecated Use 'profile.ESIA.owner'
   */
  ESIAOwner?: Maybe<TPeople>;
  /**
   * Паспорт гражданина РФ (ЕСИА)
   * @deprecated Use 'profile.ESIA.owner.documents.passport'
   */
  ESIAPassport?: Maybe<TPassport>;
  /** @deprecated Use 'profile.ESIA.owner.documents.passportHistory' */
  ESIAPassportHistory?: Maybe<Array<Maybe<TPassport>>>;
  /**
   * Сведения о доходах физического лица, о выплатах, произведённых плательщиками страховых взносов в пользу физического лица
   * @deprecated Use 'profile.ESIA.owner.documents.payoutIncome'
   */
  ESIAPayoutIncome?: Maybe<Array<Maybe<TPayoutIncome>>>;
  /**
   * Транспортное средство (ESIA)
   * @deprecated Use 'profile.ESIA.vehicle'
   */
  ESIAVehicle?: Maybe<Array<Maybe<TEsiaVehicle>>>;
  /** Флаги клиента MPL */
  MPLFlags?: Maybe<TMplClientFlags>;
  /**
   * Справка 2-НДФЛ
   * @deprecated Use 'profile.ESIA.owner.documents.NDFL2'
   */
  NDFL2?: Maybe<Array<Maybe<TNdfl2>>>;
  Sber?: Maybe<TNestedProfileSber>;
  TBank?: Maybe<TNestedProfileTBank>;
  /** Я принимаю оферту сервиса и условия обработки персональных данных */
  acceptOffer?: Maybe<Scalars['Boolean']['output']>;
  /** Дата и время согласия с офертой и условиями обработки персональных данных */
  acceptOfferTime?: Maybe<Scalars['String']['output']>;
  /** Вручную подтвержденный паспорт в CRM */
  approvedPassport?: Maybe<TPassport>;
  /** Аватар профиля */
  avatar?: Maybe<Scalars['String']['output']>;
  /** Дата создания объекта в БД */
  created?: Maybe<Scalars['DateTimeISO']['output']>;
  /** ClientId продукта, создавшего объект */
  createdBy?: Maybe<Scalars['String']['output']>;
  /** credit people */
  creditPeople?: Maybe<TPeople>;
  /** mfo people */
  creditRatingPeople?: Maybe<TPeople>;
  /** Email клиента */
  email?: Maybe<Scalars['EmailAddress']['output']>;
  emailConfirmed?: Maybe<Scalars['Boolean']['output']>;
  /** Имя identity */
  firstName?: Maybe<Scalars['String']['output']>;
  /** Фамилия identity */
  lastName?: Maybe<Scalars['String']['output']>;
  /** Введенный вручную вне какого-либо продукта автомобиль */
  manualInputCars?: Maybe<Array<Maybe<TCar>>>;
  /** Руками введенный адрес после регистрации ЕСИА */
  manualInputESIARegistrationHabitation?: Maybe<THabitation>;
  /** Введенная вручную вне какого-либо продукта недвижимость */
  manualInputHabitations?: Maybe<Array<Maybe<THabitation>>>;
  /** Мета информация */
  meta?: Maybe<TMeta>;
  /** mfo people */
  mfoPeople?: Maybe<TPeople>;
  /** Mortgage People */
  mortgagePeople?: Maybe<TPeople>;
  /** mpl people */
  mplPeople?: Maybe<TPeople>;
  /** MSB People */
  msbPeople?: Maybe<TPeople>;
  /** OSAGO People */
  osagoPeople?: Maybe<TPeople>;
  /** Владелец профиля */
  owner?: Maybe<TPeople>;
  phone?: Maybe<Scalars['PhoneNumber']['output']>;
  phoneConfirmed?: Maybe<Scalars['Boolean']['output']>;
  /** Red people */
  redPeople?: Maybe<TPeople>;
  /** Источник установки приложения */
  sourceInstallApp?: Maybe<Scalars['String']['output']>;
  /** Дата последнего обновления объекта в БД */
  updated?: Maybe<Scalars['DateTimeISO']['output']>;
  /** ClientId продукта, обновившего объект */
  updatedBy?: Maybe<Scalars['String']['output']>;
  /** Для записи данных клиента, получаемых от партнерских заявок. */
  waybackPeople?: Maybe<TPeople>;
};


export type TProfileEsiaDriverLicenseArgs = {
  filter?: InputMaybe<TDriverLicenseFilter>;
};


export type TProfileEsiaDriverLicenseHistoryArgs = {
  filter?: InputMaybe<TDriverLicenseFilter>;
  pagination?: InputMaybe<TPagination>;
};


export type TProfileEsiaeWorkbookArgs = {
  filter?: InputMaybe<TEsiaeWorkbookFilter>;
};


export type TProfileEsiaFrgnPassportArgs = {
  filter?: InputMaybe<TFrgnPassportFilter>;
};


export type TProfileEsiaFrgnPassportHistoryArgs = {
  filter?: InputMaybe<TFrgnPassportFilter>;
  pagination?: InputMaybe<TPagination>;
};


export type TProfileEsiaOwnerArgs = {
  filter?: InputMaybe<TPeopleFilter>;
};


export type TProfileEsiaPassportArgs = {
  filter?: InputMaybe<TPassportFilter>;
};


export type TProfileEsiaPassportHistoryArgs = {
  filter?: InputMaybe<TPassportFilter>;
  pagination?: InputMaybe<TPagination>;
};


export type TProfileEsiaPayoutIncomeArgs = {
  filter?: InputMaybe<TPayoutIncomeFilter>;
  pagination?: InputMaybe<TPagination>;
};


export type TProfileEsiaVehicleArgs = {
  filter?: InputMaybe<TEsiaVehicleFilter>;
  pagination?: InputMaybe<TPagination>;
};


export type TProfileMplFlagsArgs = {
  filter?: InputMaybe<TMplClientFlagsFilter>;
};


export type TProfileNdfl2Args = {
  filter?: InputMaybe<TNdfl2Filter>;
  pagination?: InputMaybe<TPagination>;
};


export type TProfileApprovedPassportArgs = {
  filter?: InputMaybe<TPassportFilter>;
};


export type TProfileCreditPeopleArgs = {
  filter?: InputMaybe<TPeopleFilter>;
};


export type TProfileCreditRatingPeopleArgs = {
  filter?: InputMaybe<TPeopleFilter>;
};


export type TProfileManualInputCarsArgs = {
  filter?: InputMaybe<TCarFilter>;
  pagination?: InputMaybe<TPagination>;
};


export type TProfileManualInputEsiaRegistrationHabitationArgs = {
  filter?: InputMaybe<THabitationFilter>;
};


export type TProfileManualInputHabitationsArgs = {
  filter?: InputMaybe<THabitationFilter>;
  pagination?: InputMaybe<TPagination>;
};


export type TProfileMetaArgs = {
  filter?: InputMaybe<TMetaFilter>;
};


export type TProfileMfoPeopleArgs = {
  filter?: InputMaybe<TPeopleFilter>;
};


export type TProfileMortgagePeopleArgs = {
  filter?: InputMaybe<TPeopleFilter>;
};


export type TProfileMplPeopleArgs = {
  filter?: InputMaybe<TPeopleFilter>;
};


export type TProfileMsbPeopleArgs = {
  filter?: InputMaybe<TPeopleFilter>;
};


export type TProfileOsagoPeopleArgs = {
  filter?: InputMaybe<TPeopleFilter>;
};


export type TProfileOwnerArgs = {
  filter?: InputMaybe<TPeopleFilter>;
};


export type TProfileRedPeopleArgs = {
  filter?: InputMaybe<TPeopleFilter>;
};


export type TProfileWaybackPeopleArgs = {
  filter?: InputMaybe<TPeopleFilter>;
};

/**
 * got_mort_without_ins: Данные из кредитного рейтинга: Есть ипотека и подходит дата и у нас не страхуется;
 * only_mfo: МФО FD (не интересуются другими продуктами вообще);
 * low_income_mfo: Интересовался кредитами и низкий доход, показывать только MFO FD;
 * low_revenue_high_load: Данные из кредитного рейтинга: Небольшой доход и большая нагрузка;
 * car_want_only_credit: Клиент, отправлявший заявки в подборе на кредиты, есть авто (в анкете), нет других купленных продуктов;
 * osago_bought_polis: Клиент ОСАГО, купивший полис у нас;
 *
 */
export type TProfileChars = {
  __typename?: 'ProfileChars';
  /** Характеристика профиля */
  char?: Maybe<EProfileChars>;
};

export type TProfileFilter = {
  AND?: InputMaybe<Array<InputMaybe<TProfileFilter>>>;
  NOR?: InputMaybe<Array<InputMaybe<TProfileFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<TProfileFilter>>>;
  acceptOffer?: InputMaybe<TBooleanFilter>;
  acceptOfferTime?: InputMaybe<TStringFilter>;
  avatar?: InputMaybe<TStringFilter>;
  created?: InputMaybe<TDateTimeIsoFilter>;
  createdBy?: InputMaybe<TStringFilter>;
  email?: InputMaybe<TEmailAddressFilter>;
  emailConfirmed?: InputMaybe<TBooleanFilter>;
  firstName?: InputMaybe<TStringFilter>;
  lastName?: InputMaybe<TStringFilter>;
  phone?: InputMaybe<TPhoneNumberFilter>;
  phoneConfirmed?: InputMaybe<TBooleanFilter>;
  sourceInstallApp?: InputMaybe<TStringFilter>;
  updated?: InputMaybe<TDateTimeIsoFilter>;
  updatedBy?: InputMaybe<TStringFilter>;
};

export type TQuery = {
  __typename?: 'Query';
  /** @deprecated ESIAHabitations больше не существует. Используйте Habitations. */
  ESIAHabitations?: Maybe<Array<Maybe<THabitation>>>;
  /** @deprecated ESIAPeople больше не существует. Используйте people. */
  ESIAPeople?: Maybe<Array<Maybe<TPeople>>>;
  cars?: Maybe<Array<Maybe<TCar>>>;
  documents?: Maybe<TNestedGlobalDocuments>;
  habitations?: Maybe<Array<Maybe<THabitation>>>;
  organizations?: Maybe<Array<Maybe<TOrganization>>>;
  owner?: Maybe<TPeople>;
  people?: Maybe<Array<Maybe<TPeople>>>;
  productMeta?: Maybe<TProductMeta>;
  profile?: Maybe<TProfile>;
  profileChar?: Maybe<TProfileChars>;
  profileState?: Maybe<TProfile>;
};


export type TQueryEsiaHabitationsArgs = {
  ownerId?: InputMaybe<Scalars['Int']['input']>;
  pagination?: InputMaybe<TPagination>;
};


export type TQueryEsiaPeopleArgs = {
  ownerId?: InputMaybe<Scalars['Int']['input']>;
  pagination?: InputMaybe<TPagination>;
};


export type TQueryCarsArgs = {
  filter?: InputMaybe<TCarFilter>;
  ownerId?: InputMaybe<Scalars['Int']['input']>;
  pagination?: InputMaybe<TPagination>;
};


export type TQueryDocumentsArgs = {
  ownerId?: InputMaybe<Scalars['Int']['input']>;
};


export type TQueryHabitationsArgs = {
  filter?: InputMaybe<THabitationFilter>;
  ownerId?: InputMaybe<Scalars['Int']['input']>;
  pagination?: InputMaybe<TPagination>;
};


export type TQueryOrganizationsArgs = {
  filter?: InputMaybe<TOrganizationFilter>;
  ownerId?: InputMaybe<Scalars['Int']['input']>;
  pagination?: InputMaybe<TPagination>;
};


export type TQueryOwnerArgs = {
  ownerId?: InputMaybe<Scalars['Int']['input']>;
  priority?: InputMaybe<Array<InputMaybe<EProfileOwnerSources>>>;
};


export type TQueryPeopleArgs = {
  filter?: InputMaybe<TPeopleFilter>;
  ownerId?: InputMaybe<Scalars['Int']['input']>;
  pagination?: InputMaybe<TPagination>;
};


export type TQueryProductMetaArgs = {
  key: Scalars['String']['input'];
  ownerId: Scalars['Int']['input'];
};


export type TQueryProfileArgs = {
  ownerId?: InputMaybe<Scalars['Int']['input']>;
};


export type TQueryProfileCharArgs = {
  ownerId: Scalars['Int']['input'];
};


export type TQueryProfileStateArgs = {
  ownerId?: InputMaybe<Scalars['Int']['input']>;
};

export type TRealestateFile = {
  __typename?: 'RealestateFile';
  /** Местоположение машиномест в объекте недвижимости (план(ы) расположения машиноместа) */
  carParkingSpaceRecords?: Maybe<Array<Maybe<TNestedRealestateFileCarParkingSpaceRecords>>>;
  /** Сведения о правопритязаниях */
  claimRecords?: Maybe<Array<Maybe<TNestedRealestateFileClaimRecords>>>;
  /** Сведения об объекте недвижимости - сооружении */
  constructionRecord?: Maybe<TNestedRealestateFileConstructionRecord>;
  /** Дата создания объекта в БД */
  created?: Maybe<Scalars['DateTimeISO']['output']>;
  /** ClientId продукта, создавшего объект */
  createdBy?: Maybe<Scalars['String']['output']>;
  /** Сведения о сделках, совершенных без необходимого в силу закона согласия третьего лица, органа */
  dealRecords?: Maybe<Array<Maybe<TNestedRealestateFileDealRecords>>>;
  /** Реквизиты поступившего запроса */
  detailsRequest?: Maybe<TNestedRealestateFileDetailsRequest>;
  /** Реквизиты выписки */
  detailsStatement?: Maybe<TNestedRealestateFileDetailsStatement>;
  /** Хеш */
  hash?: Maybe<Scalars['String']['output']>;
  /** Сведения о невозможности государственной регистрации перехода, прекращения, ограничения права на земельный участок из земель сельскохозяйственного назначения или обременения такого земельного участка до завершения рассмотрения судом дела о его изъятии в связи с неиспользованием по целевому назначению или использованием с нарушением законодательства Российской Федерации */
  nonRegistrabilitys?: Maybe<Scalars['String']['output']>;
  /** Сведения о праве (бесхозяйное имущество) */
  ownerlessRightRecord?: Maybe<TNestedRealestateFileOwnerlessRightRecord>;
  /** !! Вычисляем на основании ключей в исходных данных */
  realestateRecord: TNestedRealestateFileRealestateRecord;
  /** Получатель выписки */
  recipientStatement?: Maybe<Scalars['String']['output']>;
  /** Ограничение прав и обременение объекта недвижимости */
  restrictRecords?: Maybe<Array<Maybe<TNestedRealestateFileRestrictRecords>>>;
  /** Права собственности */
  rightRecords?: Maybe<Array<Maybe<TRealestateFileRightRecord>>>;
  /** Местоположение помещений в объекте недвижимости (план(ы) расположения помещения) */
  roomRecords?: Maybe<Array<Maybe<TNestedRealestateFileRoomRecords>>>;
  /** Источник */
  source: ESource;
  /** Статус записи об объекте недвижимости */
  status?: Maybe<Scalars['String']['output']>;
  /** Дата последнего обновления объекта в БД */
  updated?: Maybe<Scalars['DateTimeISO']['output']>;
  /** ClientId продукта, обновившего объект */
  updatedBy?: Maybe<Scalars['String']['output']>;
};


export type TRealestateFileCarParkingSpaceRecordsArgs = {
  pagination?: InputMaybe<TPagination>;
};


export type TRealestateFileClaimRecordsArgs = {
  pagination?: InputMaybe<TPagination>;
};


export type TRealestateFileDealRecordsArgs = {
  pagination?: InputMaybe<TPagination>;
};


export type TRealestateFileRestrictRecordsArgs = {
  pagination?: InputMaybe<TPagination>;
};


export type TRealestateFileRightRecordsArgs = {
  filter?: InputMaybe<TRealestateFileRightRecordFilter>;
  pagination?: InputMaybe<TPagination>;
};


export type TRealestateFileRoomRecordsArgs = {
  pagination?: InputMaybe<TPagination>;
};

export type TRealestateFileFilter = {
  AND?: InputMaybe<Array<InputMaybe<TRealestateFileFilter>>>;
  NOR?: InputMaybe<Array<InputMaybe<TRealestateFileFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<TRealestateFileFilter>>>;
  carParkingSpaceRecords?: InputMaybe<TNestedRealestateFileCarParkingSpaceRecordsObjectFilterType>;
  claimRecords?: InputMaybe<TNestedRealestateFileClaimRecordsObjectFilterType>;
  constructionRecord?: InputMaybe<TNestedRealestateFileConstructionRecordObjectFilterType>;
  created?: InputMaybe<TDateTimeIsoFilter>;
  createdBy?: InputMaybe<TStringFilter>;
  dealRecords?: InputMaybe<TNestedRealestateFileDealRecordsObjectFilterType>;
  detailsRequest?: InputMaybe<TNestedRealestateFileDetailsRequestObjectFilterType>;
  detailsStatement?: InputMaybe<TNestedRealestateFileDetailsStatementObjectFilterType>;
  hash?: InputMaybe<TStringFilter>;
  nonRegistrabilitys?: InputMaybe<TStringFilter>;
  ownerlessRightRecord?: InputMaybe<TNestedRealestateFileOwnerlessRightRecordObjectFilterType>;
  realestateRecord?: InputMaybe<TNestedRealestateFileRealestateRecordObjectFilterType>;
  recipientStatement?: InputMaybe<TStringFilter>;
  restrictRecords?: InputMaybe<TNestedRealestateFileRestrictRecordsObjectFilterType>;
  roomRecords?: InputMaybe<TNestedRealestateFileRoomRecordsObjectFilterType>;
  source?: InputMaybe<TESourceFilter>;
  status?: InputMaybe<TStringFilter>;
  updated?: InputMaybe<TDateTimeIsoFilter>;
  updatedBy?: InputMaybe<TStringFilter>;
};

export type TRealestateFileRightRecord = {
  __typename?: 'RealestateFileRightRecord';
  /** Дата создания объекта в БД */
  created?: Maybe<Scalars['DateTimeISO']['output']>;
  /** ClientId продукта, создавшего объект */
  createdBy?: Maybe<Scalars['String']['output']>;
  /** Хеш */
  hash?: Maybe<Scalars['String']['output']>;
  /** Заявленное в судебном порядке право требования */
  litigations?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Сведения о возражении в отношении зарегистрированного права */
  objections?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Личное участие правообладателя */
  personalParticipations?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  recordInfo?: Maybe<TNestedRealestateFileRightRecordRecordInfo>;
  /** Размер доли в праве */
  rightData: TNestedRealestateFileRightRecordRightData;
  rightHolders?: Maybe<Array<Maybe<TNestedRealestateFileRightRecordRightHolders>>>;
  /** Источник */
  source: ESource;
  /** Сведения об осуществлении государственной регистрации сделки, права, ограничения права, совершенных без необходимого в силу закона согласия третьего лица, органа */
  thirdPartyConsents?: Maybe<Array<Maybe<TNestedRealestateFileRightRecordThirdPartyConsents>>>;
  underlyingDocuments?: Maybe<Array<Maybe<TNestedRealestateFileRightRecordUnderlyingDocuments>>>;
  /** Дата последнего обновления объекта в БД */
  updated?: Maybe<Scalars['DateTimeISO']['output']>;
  /** ClientId продукта, обновившего объект */
  updatedBy?: Maybe<Scalars['String']['output']>;
};


export type TRealestateFileRightRecordLitigationsArgs = {
  pagination?: InputMaybe<TPagination>;
};


export type TRealestateFileRightRecordObjectionsArgs = {
  pagination?: InputMaybe<TPagination>;
};


export type TRealestateFileRightRecordPersonalParticipationsArgs = {
  pagination?: InputMaybe<TPagination>;
};


export type TRealestateFileRightRecordRightHoldersArgs = {
  pagination?: InputMaybe<TPagination>;
};


export type TRealestateFileRightRecordThirdPartyConsentsArgs = {
  pagination?: InputMaybe<TPagination>;
};


export type TRealestateFileRightRecordUnderlyingDocumentsArgs = {
  pagination?: InputMaybe<TPagination>;
};

export type TRealestateFileRightRecordFilter = {
  AND?: InputMaybe<Array<InputMaybe<TRealestateFileRightRecordFilter>>>;
  NOR?: InputMaybe<Array<InputMaybe<TRealestateFileRightRecordFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<TRealestateFileRightRecordFilter>>>;
  created?: InputMaybe<TDateTimeIsoFilter>;
  createdBy?: InputMaybe<TStringFilter>;
  hash?: InputMaybe<TStringFilter>;
  litigations?: InputMaybe<TStringFilter>;
  objections?: InputMaybe<TStringFilter>;
  personalParticipations?: InputMaybe<TStringFilter>;
  recordInfo?: InputMaybe<TNestedRealestateFileRightRecordRecordInfoObjectFilterType>;
  rightData?: InputMaybe<TNestedRealestateFileRightRecordRightDataObjectFilterType>;
  rightHolders?: InputMaybe<TNestedRealestateFileRightRecordRightHoldersObjectFilterType>;
  source?: InputMaybe<TESourceFilter>;
  thirdPartyConsents?: InputMaybe<TNestedRealestateFileRightRecordThirdPartyConsentsObjectFilterType>;
  underlyingDocuments?: InputMaybe<TNestedRealestateFileRightRecordUnderlyingDocumentsObjectFilterType>;
  updated?: InputMaybe<TDateTimeIsoFilter>;
  updatedBy?: InputMaybe<TStringFilter>;
};

/** Filter type for RegistrationPlateScalar scalar */
export type TRegistrationPlateScalarFilter = {
  /** [$all] Полное совпадение значений */
  ALL?: InputMaybe<Array<InputMaybe<Scalars['RegistrationPlateScalar']['input']>>>;
  /** [$eq] Равенство значений */
  EQ?: InputMaybe<Scalars['RegistrationPlateScalar']['input']>;
  /** [$in] Одно из значений */
  IN?: InputMaybe<Array<InputMaybe<Scalars['RegistrationPlateScalar']['input']>>>;
  /** [$ne] Не равно переданному значению */
  NE?: InputMaybe<Scalars['RegistrationPlateScalar']['input']>;
  /** [$nin] Не равно ни одному из переданных значений */
  NIN?: InputMaybe<Array<InputMaybe<Scalars['RegistrationPlateScalar']['input']>>>;
  /** [$not] Логическое отрицание */
  NOT?: InputMaybe<TRegistrationPlateScalarNotFilter>;
};

/** Filter type for $not of RegistrationPlateScalar scalar */
export type TRegistrationPlateScalarNotFilter = {
  /** [$all] Полное совпадение значений */
  ALL?: InputMaybe<Array<InputMaybe<Scalars['RegistrationPlateScalar']['input']>>>;
  /** [$eq] Равенство значений */
  EQ?: InputMaybe<Scalars['RegistrationPlateScalar']['input']>;
  /** [$in] Одно из значений */
  IN?: InputMaybe<Array<InputMaybe<Scalars['RegistrationPlateScalar']['input']>>>;
  /** [$ne] Не равно переданному значению */
  NE?: InputMaybe<Scalars['RegistrationPlateScalar']['input']>;
  /** [$nin] Не равно ни одному из переданных значений */
  NIN?: InputMaybe<Array<InputMaybe<Scalars['RegistrationPlateScalar']['input']>>>;
};

/** Filter type for SNILS scalar */
export type TSnilsFilter = {
  /** [$all] Полное совпадение значений */
  ALL?: InputMaybe<Array<InputMaybe<Scalars['SNILS']['input']>>>;
  /** [$eq] Равенство значений */
  EQ?: InputMaybe<Scalars['SNILS']['input']>;
  /** [$in] Одно из значений */
  IN?: InputMaybe<Array<InputMaybe<Scalars['SNILS']['input']>>>;
  /** [$ne] Не равно переданному значению */
  NE?: InputMaybe<Scalars['SNILS']['input']>;
  /** [$nin] Не равно ни одному из переданных значений */
  NIN?: InputMaybe<Array<InputMaybe<Scalars['SNILS']['input']>>>;
  /** [$not] Логическое отрицание */
  NOT?: InputMaybe<TSnilsNotFilter>;
};

/** Filter type for $not of SNILS scalar */
export type TSnilsNotFilter = {
  /** [$all] Полное совпадение значений */
  ALL?: InputMaybe<Array<InputMaybe<Scalars['SNILS']['input']>>>;
  /** [$eq] Равенство значений */
  EQ?: InputMaybe<Scalars['SNILS']['input']>;
  /** [$in] Одно из значений */
  IN?: InputMaybe<Array<InputMaybe<Scalars['SNILS']['input']>>>;
  /** [$ne] Не равно переданному значению */
  NE?: InputMaybe<Scalars['SNILS']['input']>;
  /** [$nin] Не равно ни одному из переданных значений */
  NIN?: InputMaybe<Array<InputMaybe<Scalars['SNILS']['input']>>>;
};

/** Filter type for SerialNumberEPTS scalar */
export type TSerialNumberEptsFilter = {
  /** [$all] Полное совпадение значений */
  ALL?: InputMaybe<Array<InputMaybe<Scalars['SerialNumberEPTS']['input']>>>;
  /** [$eq] Равенство значений */
  EQ?: InputMaybe<Scalars['SerialNumberEPTS']['input']>;
  /** [$in] Одно из значений */
  IN?: InputMaybe<Array<InputMaybe<Scalars['SerialNumberEPTS']['input']>>>;
  /** [$ne] Не равно переданному значению */
  NE?: InputMaybe<Scalars['SerialNumberEPTS']['input']>;
  /** [$nin] Не равно ни одному из переданных значений */
  NIN?: InputMaybe<Array<InputMaybe<Scalars['SerialNumberEPTS']['input']>>>;
  /** [$not] Логическое отрицание */
  NOT?: InputMaybe<TSerialNumberEptsNotFilter>;
};

/** Filter type for $not of SerialNumberEPTS scalar */
export type TSerialNumberEptsNotFilter = {
  /** [$all] Полное совпадение значений */
  ALL?: InputMaybe<Array<InputMaybe<Scalars['SerialNumberEPTS']['input']>>>;
  /** [$eq] Равенство значений */
  EQ?: InputMaybe<Scalars['SerialNumberEPTS']['input']>;
  /** [$in] Одно из значений */
  IN?: InputMaybe<Array<InputMaybe<Scalars['SerialNumberEPTS']['input']>>>;
  /** [$ne] Не равно переданному значению */
  NE?: InputMaybe<Scalars['SerialNumberEPTS']['input']>;
  /** [$nin] Не равно ни одному из переданных значений */
  NIN?: InputMaybe<Array<InputMaybe<Scalars['SerialNumberEPTS']['input']>>>;
};

/** Filter type for StrictString scalar */
export type TStrictStringFilter = {
  /** [$all] Полное совпадение значений */
  ALL?: InputMaybe<Array<InputMaybe<Scalars['StrictString']['input']>>>;
  /** [$eq] Равенство значений */
  EQ?: InputMaybe<Scalars['StrictString']['input']>;
  /** [$in] Одно из значений */
  IN?: InputMaybe<Array<InputMaybe<Scalars['StrictString']['input']>>>;
  /** [$ne] Не равно переданному значению */
  NE?: InputMaybe<Scalars['StrictString']['input']>;
  /** [$nin] Не равно ни одному из переданных значений */
  NIN?: InputMaybe<Array<InputMaybe<Scalars['StrictString']['input']>>>;
  /** [$not] Логическое отрицание */
  NOT?: InputMaybe<TStrictStringNotFilter>;
};

/** Filter type for $not of StrictString scalar */
export type TStrictStringNotFilter = {
  /** [$all] Полное совпадение значений */
  ALL?: InputMaybe<Array<InputMaybe<Scalars['StrictString']['input']>>>;
  /** [$eq] Равенство значений */
  EQ?: InputMaybe<Scalars['StrictString']['input']>;
  /** [$in] Одно из значений */
  IN?: InputMaybe<Array<InputMaybe<Scalars['StrictString']['input']>>>;
  /** [$ne] Не равно переданному значению */
  NE?: InputMaybe<Scalars['StrictString']['input']>;
  /** [$nin] Не равно ни одному из переданных значений */
  NIN?: InputMaybe<Array<InputMaybe<Scalars['StrictString']['input']>>>;
};

/** Filter type for String scalar */
export type TStringFilter = {
  /** [$all] Полное совпадение значений */
  ALL?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** [$eq] Равенство значений */
  EQ?: InputMaybe<Scalars['String']['input']>;
  /** [$in] Одно из значений */
  IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** [$ne] Не равно переданному значению */
  NE?: InputMaybe<Scalars['String']['input']>;
  /** [$nin] Не равно ни одному из переданных значений */
  NIN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** [$not] Логическое отрицание */
  NOT?: InputMaybe<TStringNotFilter>;
};

/** Filter type for $not of String scalar */
export type TStringNotFilter = {
  /** [$all] Полное совпадение значений */
  ALL?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** [$eq] Равенство значений */
  EQ?: InputMaybe<Scalars['String']['input']>;
  /** [$in] Одно из значений */
  IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** [$ne] Не равно переданному значению */
  NE?: InputMaybe<Scalars['String']['input']>;
  /** [$nin] Не равно ни одному из переданных значений */
  NIN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type TTBankFlags = {
  __typename?: 'TBankFlags';
  /** Дата создания объекта в БД */
  created?: Maybe<Scalars['DateTimeISO']['output']>;
  /** ClientId продукта, создавшего объект */
  createdBy?: Maybe<Scalars['String']['output']>;
  /** Hash */
  hash?: Maybe<Scalars['String']['output']>;
  /** Статус идентификации пользователя */
  identificationStatus?: Maybe<Scalars['Boolean']['output']>;
  /** Флаги профиля [ТБанк] */
  profile?: Maybe<TProfile>;
  /** Статус самозанятости ТБанк */
  selfEmployedStatus?: Maybe<Scalars['Boolean']['output']>;
  /** Дата последнего обновления объекта в БД */
  updated?: Maybe<Scalars['DateTimeISO']['output']>;
  /** ClientId продукта, обновившего объект */
  updatedBy?: Maybe<Scalars['String']['output']>;
};


export type TTBankFlagsProfileArgs = {
  filter?: InputMaybe<TProfileFilter>;
};

export type TTBankFlagsFilter = {
  AND?: InputMaybe<Array<InputMaybe<TTBankFlagsFilter>>>;
  NOR?: InputMaybe<Array<InputMaybe<TTBankFlagsFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<TTBankFlagsFilter>>>;
  created?: InputMaybe<TDateTimeIsoFilter>;
  createdBy?: InputMaybe<TStringFilter>;
  hash?: InputMaybe<TStringFilter>;
  identificationStatus?: InputMaybe<TBooleanFilter>;
  selfEmployedStatus?: InputMaybe<TBooleanFilter>;
  updated?: InputMaybe<TDateTimeIsoFilter>;
  updatedBy?: InputMaybe<TStringFilter>;
};

export type TTickInsuranceAgreement = {
  __typename?: 'TickInsuranceAgreement';
  /** Дата начала договора страхования от клеща */
  contractAgreementDate?: Maybe<Scalars['DateTimeISO']['output']>;
  /** Дата окончания договора страхования от клеща */
  contractAgreementEndDate?: Maybe<Scalars['DateTimeISO']['output']>;
  /** Номер договора страхования от клеща */
  contractNumber: Scalars['String']['output'];
  /** Дата создания объекта в БД */
  created?: Maybe<Scalars['DateTimeISO']['output']>;
  /** ClientId продукта, создавшего объект */
  createdBy?: Maybe<Scalars['String']['output']>;
  /** Хэш договора от клеща */
  hash?: Maybe<Scalars['String']['output']>;
  /** Застрахованные от клеща люди */
  insuredPeople?: Maybe<Array<Maybe<TPeople>>>;
  /** Договор страхования от клеща */
  insurer?: Maybe<TPeople>;
  /** Дата окончания действия полиса */
  policyEndDate?: Maybe<Scalars['DateTimeISO']['output']>;
  /** Дата начала действия полиса */
  policyStartDate?: Maybe<Scalars['DateTimeISO']['output']>;
  /** Область договора страхования от клеща */
  region?: Maybe<THabitation>;
  /** Регион страхования от клеща */
  region1?: Maybe<Scalars['String']['output']>;
  /** Дата последнего обновления объекта в БД */
  updated?: Maybe<Scalars['DateTimeISO']['output']>;
  /** ClientId продукта, обновившего объект */
  updatedBy?: Maybe<Scalars['String']['output']>;
};


export type TTickInsuranceAgreementInsuredPeopleArgs = {
  filter?: InputMaybe<TPeopleFilter>;
  pagination?: InputMaybe<TPagination>;
};


export type TTickInsuranceAgreementInsurerArgs = {
  filter?: InputMaybe<TPeopleFilter>;
};


export type TTickInsuranceAgreementRegionArgs = {
  filter?: InputMaybe<THabitationFilter>;
};

export type TTickInsuranceAgreementFilter = {
  AND?: InputMaybe<Array<InputMaybe<TTickInsuranceAgreementFilter>>>;
  NOR?: InputMaybe<Array<InputMaybe<TTickInsuranceAgreementFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<TTickInsuranceAgreementFilter>>>;
  contractAgreementDate?: InputMaybe<TDateTimeIsoFilter>;
  contractAgreementEndDate?: InputMaybe<TDateTimeIsoFilter>;
  contractNumber?: InputMaybe<TStringFilter>;
  created?: InputMaybe<TDateTimeIsoFilter>;
  createdBy?: InputMaybe<TStringFilter>;
  hash?: InputMaybe<TStringFilter>;
  policyEndDate?: InputMaybe<TDateTimeIsoFilter>;
  policyStartDate?: InputMaybe<TDateTimeIsoFilter>;
  region1?: InputMaybe<TStringFilter>;
  updated?: InputMaybe<TDateTimeIsoFilter>;
  updatedBy?: InputMaybe<TStringFilter>;
};

/** Filter type for year scalar */
export type TYearFilter = {
  /** [$all] Полное совпадение значений */
  ALL?: InputMaybe<Array<InputMaybe<Scalars['year']['input']>>>;
  /** [$eq] Равенство значений */
  EQ?: InputMaybe<Scalars['year']['input']>;
  /** [$in] Одно из значений */
  IN?: InputMaybe<Array<InputMaybe<Scalars['year']['input']>>>;
  /** [$ne] Не равно переданному значению */
  NE?: InputMaybe<Scalars['year']['input']>;
  /** [$nin] Не равно ни одному из переданных значений */
  NIN?: InputMaybe<Array<InputMaybe<Scalars['year']['input']>>>;
  /** [$not] Логическое отрицание */
  NOT?: InputMaybe<TYearNotFilter>;
};

/** Filter type for $not of year scalar */
export type TYearNotFilter = {
  /** [$all] Полное совпадение значений */
  ALL?: InputMaybe<Array<InputMaybe<Scalars['year']['input']>>>;
  /** [$eq] Равенство значений */
  EQ?: InputMaybe<Scalars['year']['input']>;
  /** [$in] Одно из значений */
  IN?: InputMaybe<Array<InputMaybe<Scalars['year']['input']>>>;
  /** [$ne] Не равно переданному значению */
  NE?: InputMaybe<Scalars['year']['input']>;
  /** [$nin] Не равно ни одному из переданных значений */
  NIN?: InputMaybe<Array<InputMaybe<Scalars['year']['input']>>>;
};

export type TJobAddressFieldsFragment = { __typename?: 'NestedPeopleJobAddress', dadata?: string | null, street?: string | null, locationRoute?: string | null, house?: string | null, flat?: string | null, region?: string | null, block?: string | null, blockType?: string | null };

export type TAddressFieldsFragment = { __typename?: 'NestedHabitationAddress', area?: string | null, areaType?: string | null, block?: string | null, blockType?: string | null, city?: string | null, cityType?: string | null, dadata?: string | null, fiasId: string, fiasLevel?: string | null, flat?: string | null, flatType?: string | null, house?: string | null, houseType?: string | null, kladrId?: string | null, locationRoute?: string | null, postalCode?: any | null, region?: string | null, regionType?: string | null, settlement?: string | null, settlementType?: string | null, street?: string | null, streetType?: string | null };

export type TEsiaAddressFieldsFragment = { __typename?: 'NestedHabitationAddress', area?: string | null, areaType?: string | null, block?: string | null, blockType?: string | null, city?: string | null, cityType?: string | null, dadata?: string | null, fiasId: string, fiasLevel?: string | null, flat?: string | null, flatType?: string | null, house?: string | null, houseType?: string | null, kladrId?: string | null, postalCode?: any | null, region?: string | null, regionType?: string | null, settlement?: string | null, settlementType?: string | null, street?: string | null, streetType?: string | null };

export type TPeopleFieldsFragment = { __typename?: 'People', firstName: any, lastName: any, middleName?: any | null, birthDate: any, updated?: any | null, hash?: string | null, additionalIncome?: string | null, additionalPhone?: any | null, additionalPhoneOwner?: EAdditionalPhoneOwner | null, additionalPhoneOwnerFIO?: string | null, birthPlace?: string | null, dependentsCount?: EDependents | null, education?: EEducation | null, email?: any | null, employmentType?: EEmploymentType | null, flatRentAmount?: string | null, gender?: EGender | null, loanPaymentTotal?: string | null, maritalStatus?: EFamilyStatus | null, monthlyIncome?: string | null, rentCost?: string | null, salary?: string | null, snils?: any | null, solvencyProof?: EIncomeConfirmation | null, unemploymentReason?: EUnemploymentReason | null, unemploymentReasonText?: string | null, workExperience?: EWorkExperience | null, haveCar?: EHaveCar | null, haveApartment?: EPropertyType | null, creditSelection?: { __typename?: 'NestedPeopleCreditSelection', amount?: string | null, autoBrand?: string | null, autoModel?: string | null, autoYear?: any | null, creditSecurity?: ECreditSecurity | null, initialFee?: string | null, obtainCityId?: string | null, obtainCityLocationRoute?: string | null, period?: string | null, propertyAutoRegistrationPlate?: any | null, purpose?: ECreditPurpose | null, region?: string | null } | null, creditSelectionPledgeCar?: { __typename?: 'Car', registrationPlate?: any | null, modelId?: string | null, model: string, markId?: string | null, mark: string, power?: string | null, year: any, hash?: string | null, vin?: any | null } | null, creditSelectionPledgeHabitation?: { __typename?: 'Habitation', updated?: any | null, hash?: string | null, address: { __typename?: 'NestedHabitationAddress', dadata?: string | null, house?: string | null, locationRoute?: string | null, street?: string | null, flat?: string | null, block?: string | null, region?: string | null, city?: string | null, regionType?: string | null, area?: string | null, areaType?: string | null, cityType?: string | null, settlementType?: string | null, settlement?: string | null, streetType?: string | null }, creditSelection?: { __typename?: 'NestedHabitationCreditSelection', pledgeOwnerFamilyStatus?: EFamilyStatus | null, pledgeOwnerFirstName?: any | null, pledgeOwnerLastName?: any | null, pledgeOwnerMiddleName?: any | null, pledgeOwnerPhone?: any | null, pledgeOwnerRelationship?: ERelationStatus | null, pledgeOwnerSingle?: string | null } | null } | null, job?: { __typename?: 'NestedPeopleJob', lastExperienceStartDate?: any | null, title?: string | null, type?: EJobPosition | null, address?: { __typename?: 'NestedPeopleJobAddress', dadata?: string | null, street?: string | null, locationRoute?: string | null, house?: string | null, flat?: string | null, region?: string | null, block?: string | null, blockType?: string | null } | null, organization?: { __typename?: 'NestedPeopleJobOrganization', activity?: EOrganizationActivity | null, inn?: any | null, name?: string | null, ogrn?: any | null, phone?: any | null, type?: EEmployerType | null, typeCode?: any | null } | null } | null, livingHabitation?: { __typename?: 'Habitation', hash?: string | null, address: { __typename?: 'NestedHabitationAddress', area?: string | null, areaType?: string | null, block?: string | null, blockType?: string | null, city?: string | null, cityType?: string | null, dadata?: string | null, fiasId: string, fiasLevel?: string | null, flat?: string | null, flatType?: string | null, house?: string | null, houseType?: string | null, kladrId?: string | null, locationRoute?: string | null, postalCode?: any | null, region?: string | null, regionType?: string | null, settlement?: string | null, settlementType?: string | null, street?: string | null, streetType?: string | null } } | null, registrationHabitation?: { __typename?: 'Habitation', phone?: any | null, hash?: string | null, address: { __typename?: 'NestedHabitationAddress', area?: string | null, areaType?: string | null, block?: string | null, blockType?: string | null, city?: string | null, cityType?: string | null, dadata?: string | null, fiasId: string, fiasLevel?: string | null, flat?: string | null, flatType?: string | null, house?: string | null, houseType?: string | null, kladrId?: string | null, locationRoute?: string | null, postalCode?: any | null, region?: string | null, regionType?: string | null, settlement?: string | null, settlementType?: string | null, street?: string | null, streetType?: string | null } } | null, documents?: { __typename?: 'NestedPeopleDocuments', passport?: { __typename?: 'Passport', addressRegistrationDate?: any | null, issueDate?: any | null, issuedBy?: string | null, issueId?: any | null, number: string, series: string } | null } | null };

export type TEsiaPassportFieldsFragment = { __typename?: 'Passport', updated?: any | null, hash?: string | null, series: string, number: string, issuedBy?: string | null, issueDate?: any | null, issueId?: any | null };

export type TEsiaPeopleFieldsFragment = { __typename?: 'People', updated?: any | null, hash?: string | null, firstName: any, lastName: any, middleName?: any | null, gender?: EGender | null, email?: any | null, birthDate: any, birthPlace?: string | null, snils?: any | null, registrationHabitation?: { __typename?: 'Habitation', hash?: string | null, address: { __typename?: 'NestedHabitationAddress', area?: string | null, areaType?: string | null, block?: string | null, blockType?: string | null, city?: string | null, cityType?: string | null, dadata?: string | null, fiasId: string, fiasLevel?: string | null, flat?: string | null, flatType?: string | null, house?: string | null, houseType?: string | null, kladrId?: string | null, postalCode?: any | null, region?: string | null, regionType?: string | null, settlement?: string | null, settlementType?: string | null, street?: string | null, streetType?: string | null } } | null, livingHabitation?: { __typename?: 'Habitation', hash?: string | null, address: { __typename?: 'NestedHabitationAddress', area?: string | null, areaType?: string | null, block?: string | null, blockType?: string | null, city?: string | null, cityType?: string | null, dadata?: string | null, fiasId: string, fiasLevel?: string | null, flat?: string | null, flatType?: string | null, house?: string | null, houseType?: string | null, kladrId?: string | null, postalCode?: any | null, region?: string | null, regionType?: string | null, settlement?: string | null, settlementType?: string | null, street?: string | null, streetType?: string | null } } | null, documents?: { __typename?: 'NestedPeopleDocuments', passport?: { __typename?: 'Passport', updated?: any | null, hash?: string | null, series: string, number: string, issuedBy?: string | null, issueDate?: any | null, issueId?: any | null } | null } | null };

export type TCreditSelectionFrontendLoadDataQueryVariables = Exact<{
  ownerId?: InputMaybe<Scalars['Int']['input']>;
}>;


export type TCreditSelectionFrontendLoadDataQuery = { __typename?: 'Query', profile?: { __typename?: 'Profile', phone?: any | null, ESIA?: { __typename?: 'NestedProfileESIA', owner?: { __typename?: 'People', updated?: any | null, hash?: string | null, firstName: any, lastName: any, middleName?: any | null, gender?: EGender | null, email?: any | null, birthDate: any, birthPlace?: string | null, snils?: any | null, registrationHabitation?: { __typename?: 'Habitation', hash?: string | null, address: { __typename?: 'NestedHabitationAddress', area?: string | null, areaType?: string | null, block?: string | null, blockType?: string | null, city?: string | null, cityType?: string | null, dadata?: string | null, fiasId: string, fiasLevel?: string | null, flat?: string | null, flatType?: string | null, house?: string | null, houseType?: string | null, kladrId?: string | null, postalCode?: any | null, region?: string | null, regionType?: string | null, settlement?: string | null, settlementType?: string | null, street?: string | null, streetType?: string | null } } | null, livingHabitation?: { __typename?: 'Habitation', hash?: string | null, address: { __typename?: 'NestedHabitationAddress', area?: string | null, areaType?: string | null, block?: string | null, blockType?: string | null, city?: string | null, cityType?: string | null, dadata?: string | null, fiasId: string, fiasLevel?: string | null, flat?: string | null, flatType?: string | null, house?: string | null, houseType?: string | null, kladrId?: string | null, postalCode?: any | null, region?: string | null, regionType?: string | null, settlement?: string | null, settlementType?: string | null, street?: string | null, streetType?: string | null } } | null, documents?: { __typename?: 'NestedPeopleDocuments', passport?: { __typename?: 'Passport', updated?: any | null, hash?: string | null, series: string, number: string, issuedBy?: string | null, issueDate?: any | null, issueId?: any | null } | null } | null } | null } | null, owner?: { __typename?: 'People', firstName: any, lastName: any, middleName?: any | null, birthDate: any, updated?: any | null, hash?: string | null, additionalIncome?: string | null, additionalPhone?: any | null, additionalPhoneOwner?: EAdditionalPhoneOwner | null, additionalPhoneOwnerFIO?: string | null, birthPlace?: string | null, dependentsCount?: EDependents | null, education?: EEducation | null, email?: any | null, employmentType?: EEmploymentType | null, flatRentAmount?: string | null, gender?: EGender | null, loanPaymentTotal?: string | null, maritalStatus?: EFamilyStatus | null, monthlyIncome?: string | null, rentCost?: string | null, salary?: string | null, snils?: any | null, solvencyProof?: EIncomeConfirmation | null, unemploymentReason?: EUnemploymentReason | null, unemploymentReasonText?: string | null, workExperience?: EWorkExperience | null, haveCar?: EHaveCar | null, haveApartment?: EPropertyType | null, creditSelection?: { __typename?: 'NestedPeopleCreditSelection', amount?: string | null, autoBrand?: string | null, autoModel?: string | null, autoYear?: any | null, creditSecurity?: ECreditSecurity | null, initialFee?: string | null, obtainCityId?: string | null, obtainCityLocationRoute?: string | null, period?: string | null, propertyAutoRegistrationPlate?: any | null, purpose?: ECreditPurpose | null, region?: string | null } | null, creditSelectionPledgeCar?: { __typename?: 'Car', registrationPlate?: any | null, modelId?: string | null, model: string, markId?: string | null, mark: string, power?: string | null, year: any, hash?: string | null, vin?: any | null } | null, creditSelectionPledgeHabitation?: { __typename?: 'Habitation', updated?: any | null, hash?: string | null, address: { __typename?: 'NestedHabitationAddress', dadata?: string | null, house?: string | null, locationRoute?: string | null, street?: string | null, flat?: string | null, block?: string | null, region?: string | null, city?: string | null, regionType?: string | null, area?: string | null, areaType?: string | null, cityType?: string | null, settlementType?: string | null, settlement?: string | null, streetType?: string | null }, creditSelection?: { __typename?: 'NestedHabitationCreditSelection', pledgeOwnerFamilyStatus?: EFamilyStatus | null, pledgeOwnerFirstName?: any | null, pledgeOwnerLastName?: any | null, pledgeOwnerMiddleName?: any | null, pledgeOwnerPhone?: any | null, pledgeOwnerRelationship?: ERelationStatus | null, pledgeOwnerSingle?: string | null } | null } | null, job?: { __typename?: 'NestedPeopleJob', lastExperienceStartDate?: any | null, title?: string | null, type?: EJobPosition | null, address?: { __typename?: 'NestedPeopleJobAddress', dadata?: string | null, street?: string | null, locationRoute?: string | null, house?: string | null, flat?: string | null, region?: string | null, block?: string | null, blockType?: string | null } | null, organization?: { __typename?: 'NestedPeopleJobOrganization', activity?: EOrganizationActivity | null, inn?: any | null, name?: string | null, ogrn?: any | null, phone?: any | null, type?: EEmployerType | null, typeCode?: any | null } | null } | null, livingHabitation?: { __typename?: 'Habitation', hash?: string | null, address: { __typename?: 'NestedHabitationAddress', area?: string | null, areaType?: string | null, block?: string | null, blockType?: string | null, city?: string | null, cityType?: string | null, dadata?: string | null, fiasId: string, fiasLevel?: string | null, flat?: string | null, flatType?: string | null, house?: string | null, houseType?: string | null, kladrId?: string | null, locationRoute?: string | null, postalCode?: any | null, region?: string | null, regionType?: string | null, settlement?: string | null, settlementType?: string | null, street?: string | null, streetType?: string | null } } | null, registrationHabitation?: { __typename?: 'Habitation', phone?: any | null, hash?: string | null, address: { __typename?: 'NestedHabitationAddress', area?: string | null, areaType?: string | null, block?: string | null, blockType?: string | null, city?: string | null, cityType?: string | null, dadata?: string | null, fiasId: string, fiasLevel?: string | null, flat?: string | null, flatType?: string | null, house?: string | null, houseType?: string | null, kladrId?: string | null, locationRoute?: string | null, postalCode?: any | null, region?: string | null, regionType?: string | null, settlement?: string | null, settlementType?: string | null, street?: string | null, streetType?: string | null } } | null, documents?: { __typename?: 'NestedPeopleDocuments', passport?: { __typename?: 'Passport', addressRegistrationDate?: any | null, issueDate?: any | null, issuedBy?: string | null, issueId?: any | null, number: string, series: string } | null } | null } | null, creditPeople?: { __typename?: 'People', firstName: any, lastName: any, middleName?: any | null, birthDate: any, updated?: any | null, hash?: string | null, additionalIncome?: string | null, additionalPhone?: any | null, additionalPhoneOwner?: EAdditionalPhoneOwner | null, additionalPhoneOwnerFIO?: string | null, birthPlace?: string | null, dependentsCount?: EDependents | null, education?: EEducation | null, email?: any | null, employmentType?: EEmploymentType | null, flatRentAmount?: string | null, gender?: EGender | null, loanPaymentTotal?: string | null, maritalStatus?: EFamilyStatus | null, monthlyIncome?: string | null, rentCost?: string | null, salary?: string | null, snils?: any | null, solvencyProof?: EIncomeConfirmation | null, unemploymentReason?: EUnemploymentReason | null, unemploymentReasonText?: string | null, workExperience?: EWorkExperience | null, haveCar?: EHaveCar | null, haveApartment?: EPropertyType | null, creditSelection?: { __typename?: 'NestedPeopleCreditSelection', amount?: string | null, autoBrand?: string | null, autoModel?: string | null, autoYear?: any | null, creditSecurity?: ECreditSecurity | null, initialFee?: string | null, obtainCityId?: string | null, obtainCityLocationRoute?: string | null, period?: string | null, propertyAutoRegistrationPlate?: any | null, purpose?: ECreditPurpose | null, region?: string | null } | null, creditSelectionPledgeCar?: { __typename?: 'Car', registrationPlate?: any | null, modelId?: string | null, model: string, markId?: string | null, mark: string, power?: string | null, year: any, hash?: string | null, vin?: any | null } | null, creditSelectionPledgeHabitation?: { __typename?: 'Habitation', updated?: any | null, hash?: string | null, address: { __typename?: 'NestedHabitationAddress', dadata?: string | null, house?: string | null, locationRoute?: string | null, street?: string | null, flat?: string | null, block?: string | null, region?: string | null, city?: string | null, regionType?: string | null, area?: string | null, areaType?: string | null, cityType?: string | null, settlementType?: string | null, settlement?: string | null, streetType?: string | null }, creditSelection?: { __typename?: 'NestedHabitationCreditSelection', pledgeOwnerFamilyStatus?: EFamilyStatus | null, pledgeOwnerFirstName?: any | null, pledgeOwnerLastName?: any | null, pledgeOwnerMiddleName?: any | null, pledgeOwnerPhone?: any | null, pledgeOwnerRelationship?: ERelationStatus | null, pledgeOwnerSingle?: string | null } | null } | null, job?: { __typename?: 'NestedPeopleJob', lastExperienceStartDate?: any | null, title?: string | null, type?: EJobPosition | null, address?: { __typename?: 'NestedPeopleJobAddress', dadata?: string | null, street?: string | null, locationRoute?: string | null, house?: string | null, flat?: string | null, region?: string | null, block?: string | null, blockType?: string | null } | null, organization?: { __typename?: 'NestedPeopleJobOrganization', activity?: EOrganizationActivity | null, inn?: any | null, name?: string | null, ogrn?: any | null, phone?: any | null, type?: EEmployerType | null, typeCode?: any | null } | null } | null, livingHabitation?: { __typename?: 'Habitation', hash?: string | null, address: { __typename?: 'NestedHabitationAddress', area?: string | null, areaType?: string | null, block?: string | null, blockType?: string | null, city?: string | null, cityType?: string | null, dadata?: string | null, fiasId: string, fiasLevel?: string | null, flat?: string | null, flatType?: string | null, house?: string | null, houseType?: string | null, kladrId?: string | null, locationRoute?: string | null, postalCode?: any | null, region?: string | null, regionType?: string | null, settlement?: string | null, settlementType?: string | null, street?: string | null, streetType?: string | null } } | null, registrationHabitation?: { __typename?: 'Habitation', phone?: any | null, hash?: string | null, address: { __typename?: 'NestedHabitationAddress', area?: string | null, areaType?: string | null, block?: string | null, blockType?: string | null, city?: string | null, cityType?: string | null, dadata?: string | null, fiasId: string, fiasLevel?: string | null, flat?: string | null, flatType?: string | null, house?: string | null, houseType?: string | null, kladrId?: string | null, locationRoute?: string | null, postalCode?: any | null, region?: string | null, regionType?: string | null, settlement?: string | null, settlementType?: string | null, street?: string | null, streetType?: string | null } } | null, documents?: { __typename?: 'NestedPeopleDocuments', passport?: { __typename?: 'Passport', addressRegistrationDate?: any | null, issueDate?: any | null, issuedBy?: string | null, issueId?: any | null, number: string, series: string } | null } | null } | null, mfoPeople?: { __typename?: 'People', firstName: any, lastName: any, middleName?: any | null, birthDate: any, updated?: any | null, hash?: string | null, additionalIncome?: string | null, additionalPhone?: any | null, additionalPhoneOwner?: EAdditionalPhoneOwner | null, additionalPhoneOwnerFIO?: string | null, birthPlace?: string | null, dependentsCount?: EDependents | null, education?: EEducation | null, email?: any | null, employmentType?: EEmploymentType | null, flatRentAmount?: string | null, gender?: EGender | null, loanPaymentTotal?: string | null, maritalStatus?: EFamilyStatus | null, monthlyIncome?: string | null, rentCost?: string | null, salary?: string | null, snils?: any | null, solvencyProof?: EIncomeConfirmation | null, unemploymentReason?: EUnemploymentReason | null, unemploymentReasonText?: string | null, workExperience?: EWorkExperience | null, haveCar?: EHaveCar | null, haveApartment?: EPropertyType | null, creditSelection?: { __typename?: 'NestedPeopleCreditSelection', amount?: string | null, autoBrand?: string | null, autoModel?: string | null, autoYear?: any | null, creditSecurity?: ECreditSecurity | null, initialFee?: string | null, obtainCityId?: string | null, obtainCityLocationRoute?: string | null, period?: string | null, propertyAutoRegistrationPlate?: any | null, purpose?: ECreditPurpose | null, region?: string | null } | null, creditSelectionPledgeCar?: { __typename?: 'Car', registrationPlate?: any | null, modelId?: string | null, model: string, markId?: string | null, mark: string, power?: string | null, year: any, hash?: string | null, vin?: any | null } | null, creditSelectionPledgeHabitation?: { __typename?: 'Habitation', updated?: any | null, hash?: string | null, address: { __typename?: 'NestedHabitationAddress', dadata?: string | null, house?: string | null, locationRoute?: string | null, street?: string | null, flat?: string | null, block?: string | null, region?: string | null, city?: string | null, regionType?: string | null, area?: string | null, areaType?: string | null, cityType?: string | null, settlementType?: string | null, settlement?: string | null, streetType?: string | null }, creditSelection?: { __typename?: 'NestedHabitationCreditSelection', pledgeOwnerFamilyStatus?: EFamilyStatus | null, pledgeOwnerFirstName?: any | null, pledgeOwnerLastName?: any | null, pledgeOwnerMiddleName?: any | null, pledgeOwnerPhone?: any | null, pledgeOwnerRelationship?: ERelationStatus | null, pledgeOwnerSingle?: string | null } | null } | null, job?: { __typename?: 'NestedPeopleJob', lastExperienceStartDate?: any | null, title?: string | null, type?: EJobPosition | null, address?: { __typename?: 'NestedPeopleJobAddress', dadata?: string | null, street?: string | null, locationRoute?: string | null, house?: string | null, flat?: string | null, region?: string | null, block?: string | null, blockType?: string | null } | null, organization?: { __typename?: 'NestedPeopleJobOrganization', activity?: EOrganizationActivity | null, inn?: any | null, name?: string | null, ogrn?: any | null, phone?: any | null, type?: EEmployerType | null, typeCode?: any | null } | null } | null, livingHabitation?: { __typename?: 'Habitation', hash?: string | null, address: { __typename?: 'NestedHabitationAddress', area?: string | null, areaType?: string | null, block?: string | null, blockType?: string | null, city?: string | null, cityType?: string | null, dadata?: string | null, fiasId: string, fiasLevel?: string | null, flat?: string | null, flatType?: string | null, house?: string | null, houseType?: string | null, kladrId?: string | null, locationRoute?: string | null, postalCode?: any | null, region?: string | null, regionType?: string | null, settlement?: string | null, settlementType?: string | null, street?: string | null, streetType?: string | null } } | null, registrationHabitation?: { __typename?: 'Habitation', phone?: any | null, hash?: string | null, address: { __typename?: 'NestedHabitationAddress', area?: string | null, areaType?: string | null, block?: string | null, blockType?: string | null, city?: string | null, cityType?: string | null, dadata?: string | null, fiasId: string, fiasLevel?: string | null, flat?: string | null, flatType?: string | null, house?: string | null, houseType?: string | null, kladrId?: string | null, locationRoute?: string | null, postalCode?: any | null, region?: string | null, regionType?: string | null, settlement?: string | null, settlementType?: string | null, street?: string | null, streetType?: string | null } } | null, documents?: { __typename?: 'NestedPeopleDocuments', passport?: { __typename?: 'Passport', addressRegistrationDate?: any | null, issueDate?: any | null, issuedBy?: string | null, issueId?: any | null, number: string, series: string } | null } | null } | null, MPLFlags?: { __typename?: 'MPLClientFlags', MPLRegistration?: any | null, identificationDate?: any | null, AMLQuestionsDate?: any | null, blockReason?: string | null, blockedDate?: any | null } | null } | null };

export type TCreditSelectionFrontendCallCenterLoadDataQueryVariables = Exact<{
  ownerId: Scalars['Int']['input'];
}>;


export type TCreditSelectionFrontendCallCenterLoadDataQuery = { __typename?: 'Query', profile?: { __typename?: 'Profile', phone?: any | null, ESIA?: { __typename?: 'NestedProfileESIA', owner?: { __typename?: 'People', updated?: any | null, hash?: string | null, firstName: any, lastName: any, middleName?: any | null, gender?: EGender | null, email?: any | null, birthDate: any, birthPlace?: string | null, snils?: any | null, registrationHabitation?: { __typename?: 'Habitation', hash?: string | null, address: { __typename?: 'NestedHabitationAddress', area?: string | null, areaType?: string | null, block?: string | null, blockType?: string | null, city?: string | null, cityType?: string | null, dadata?: string | null, fiasId: string, fiasLevel?: string | null, flat?: string | null, flatType?: string | null, house?: string | null, houseType?: string | null, kladrId?: string | null, postalCode?: any | null, region?: string | null, regionType?: string | null, settlement?: string | null, settlementType?: string | null, street?: string | null, streetType?: string | null } } | null, livingHabitation?: { __typename?: 'Habitation', hash?: string | null, address: { __typename?: 'NestedHabitationAddress', area?: string | null, areaType?: string | null, block?: string | null, blockType?: string | null, city?: string | null, cityType?: string | null, dadata?: string | null, fiasId: string, fiasLevel?: string | null, flat?: string | null, flatType?: string | null, house?: string | null, houseType?: string | null, kladrId?: string | null, postalCode?: any | null, region?: string | null, regionType?: string | null, settlement?: string | null, settlementType?: string | null, street?: string | null, streetType?: string | null } } | null, documents?: { __typename?: 'NestedPeopleDocuments', passport?: { __typename?: 'Passport', updated?: any | null, hash?: string | null, series: string, number: string, issuedBy?: string | null, issueDate?: any | null, issueId?: any | null } | null } | null } | null } | null, owner?: { __typename?: 'People', firstName: any, lastName: any, middleName?: any | null, birthDate: any, updated?: any | null, hash?: string | null, additionalIncome?: string | null, additionalPhone?: any | null, additionalPhoneOwner?: EAdditionalPhoneOwner | null, additionalPhoneOwnerFIO?: string | null, birthPlace?: string | null, dependentsCount?: EDependents | null, education?: EEducation | null, email?: any | null, employmentType?: EEmploymentType | null, flatRentAmount?: string | null, gender?: EGender | null, loanPaymentTotal?: string | null, maritalStatus?: EFamilyStatus | null, monthlyIncome?: string | null, rentCost?: string | null, salary?: string | null, snils?: any | null, solvencyProof?: EIncomeConfirmation | null, unemploymentReason?: EUnemploymentReason | null, unemploymentReasonText?: string | null, workExperience?: EWorkExperience | null, haveCar?: EHaveCar | null, haveApartment?: EPropertyType | null, creditSelection?: { __typename?: 'NestedPeopleCreditSelection', amount?: string | null, autoBrand?: string | null, autoModel?: string | null, autoYear?: any | null, creditSecurity?: ECreditSecurity | null, initialFee?: string | null, obtainCityId?: string | null, obtainCityLocationRoute?: string | null, period?: string | null, propertyAutoRegistrationPlate?: any | null, purpose?: ECreditPurpose | null, region?: string | null } | null, creditSelectionPledgeCar?: { __typename?: 'Car', registrationPlate?: any | null, modelId?: string | null, model: string, markId?: string | null, mark: string, power?: string | null, year: any, hash?: string | null, vin?: any | null } | null, creditSelectionPledgeHabitation?: { __typename?: 'Habitation', updated?: any | null, hash?: string | null, address: { __typename?: 'NestedHabitationAddress', dadata?: string | null, house?: string | null, locationRoute?: string | null, street?: string | null, flat?: string | null, block?: string | null, region?: string | null, city?: string | null, regionType?: string | null, area?: string | null, areaType?: string | null, cityType?: string | null, settlementType?: string | null, settlement?: string | null, streetType?: string | null }, creditSelection?: { __typename?: 'NestedHabitationCreditSelection', pledgeOwnerFamilyStatus?: EFamilyStatus | null, pledgeOwnerFirstName?: any | null, pledgeOwnerLastName?: any | null, pledgeOwnerMiddleName?: any | null, pledgeOwnerPhone?: any | null, pledgeOwnerRelationship?: ERelationStatus | null, pledgeOwnerSingle?: string | null } | null } | null, job?: { __typename?: 'NestedPeopleJob', lastExperienceStartDate?: any | null, title?: string | null, type?: EJobPosition | null, address?: { __typename?: 'NestedPeopleJobAddress', dadata?: string | null, street?: string | null, locationRoute?: string | null, house?: string | null, flat?: string | null, region?: string | null, block?: string | null, blockType?: string | null } | null, organization?: { __typename?: 'NestedPeopleJobOrganization', activity?: EOrganizationActivity | null, inn?: any | null, name?: string | null, ogrn?: any | null, phone?: any | null, type?: EEmployerType | null, typeCode?: any | null } | null } | null, livingHabitation?: { __typename?: 'Habitation', hash?: string | null, address: { __typename?: 'NestedHabitationAddress', area?: string | null, areaType?: string | null, block?: string | null, blockType?: string | null, city?: string | null, cityType?: string | null, dadata?: string | null, fiasId: string, fiasLevel?: string | null, flat?: string | null, flatType?: string | null, house?: string | null, houseType?: string | null, kladrId?: string | null, locationRoute?: string | null, postalCode?: any | null, region?: string | null, regionType?: string | null, settlement?: string | null, settlementType?: string | null, street?: string | null, streetType?: string | null } } | null, registrationHabitation?: { __typename?: 'Habitation', phone?: any | null, hash?: string | null, address: { __typename?: 'NestedHabitationAddress', area?: string | null, areaType?: string | null, block?: string | null, blockType?: string | null, city?: string | null, cityType?: string | null, dadata?: string | null, fiasId: string, fiasLevel?: string | null, flat?: string | null, flatType?: string | null, house?: string | null, houseType?: string | null, kladrId?: string | null, locationRoute?: string | null, postalCode?: any | null, region?: string | null, regionType?: string | null, settlement?: string | null, settlementType?: string | null, street?: string | null, streetType?: string | null } } | null, documents?: { __typename?: 'NestedPeopleDocuments', passport?: { __typename?: 'Passport', addressRegistrationDate?: any | null, issueDate?: any | null, issuedBy?: string | null, issueId?: any | null, number: string, series: string } | null } | null } | null, creditPeople?: { __typename?: 'People', firstName: any, lastName: any, middleName?: any | null, birthDate: any, updated?: any | null, hash?: string | null, additionalIncome?: string | null, additionalPhone?: any | null, additionalPhoneOwner?: EAdditionalPhoneOwner | null, additionalPhoneOwnerFIO?: string | null, birthPlace?: string | null, dependentsCount?: EDependents | null, education?: EEducation | null, email?: any | null, employmentType?: EEmploymentType | null, flatRentAmount?: string | null, gender?: EGender | null, loanPaymentTotal?: string | null, maritalStatus?: EFamilyStatus | null, monthlyIncome?: string | null, rentCost?: string | null, salary?: string | null, snils?: any | null, solvencyProof?: EIncomeConfirmation | null, unemploymentReason?: EUnemploymentReason | null, unemploymentReasonText?: string | null, workExperience?: EWorkExperience | null, haveCar?: EHaveCar | null, haveApartment?: EPropertyType | null, creditSelection?: { __typename?: 'NestedPeopleCreditSelection', amount?: string | null, autoBrand?: string | null, autoModel?: string | null, autoYear?: any | null, creditSecurity?: ECreditSecurity | null, initialFee?: string | null, obtainCityId?: string | null, obtainCityLocationRoute?: string | null, period?: string | null, propertyAutoRegistrationPlate?: any | null, purpose?: ECreditPurpose | null, region?: string | null } | null, creditSelectionPledgeCar?: { __typename?: 'Car', registrationPlate?: any | null, modelId?: string | null, model: string, markId?: string | null, mark: string, power?: string | null, year: any, hash?: string | null, vin?: any | null } | null, creditSelectionPledgeHabitation?: { __typename?: 'Habitation', updated?: any | null, hash?: string | null, address: { __typename?: 'NestedHabitationAddress', dadata?: string | null, house?: string | null, locationRoute?: string | null, street?: string | null, flat?: string | null, block?: string | null, region?: string | null, city?: string | null, regionType?: string | null, area?: string | null, areaType?: string | null, cityType?: string | null, settlementType?: string | null, settlement?: string | null, streetType?: string | null }, creditSelection?: { __typename?: 'NestedHabitationCreditSelection', pledgeOwnerFamilyStatus?: EFamilyStatus | null, pledgeOwnerFirstName?: any | null, pledgeOwnerLastName?: any | null, pledgeOwnerMiddleName?: any | null, pledgeOwnerPhone?: any | null, pledgeOwnerRelationship?: ERelationStatus | null, pledgeOwnerSingle?: string | null } | null } | null, job?: { __typename?: 'NestedPeopleJob', lastExperienceStartDate?: any | null, title?: string | null, type?: EJobPosition | null, address?: { __typename?: 'NestedPeopleJobAddress', dadata?: string | null, street?: string | null, locationRoute?: string | null, house?: string | null, flat?: string | null, region?: string | null, block?: string | null, blockType?: string | null } | null, organization?: { __typename?: 'NestedPeopleJobOrganization', activity?: EOrganizationActivity | null, inn?: any | null, name?: string | null, ogrn?: any | null, phone?: any | null, type?: EEmployerType | null, typeCode?: any | null } | null } | null, livingHabitation?: { __typename?: 'Habitation', hash?: string | null, address: { __typename?: 'NestedHabitationAddress', area?: string | null, areaType?: string | null, block?: string | null, blockType?: string | null, city?: string | null, cityType?: string | null, dadata?: string | null, fiasId: string, fiasLevel?: string | null, flat?: string | null, flatType?: string | null, house?: string | null, houseType?: string | null, kladrId?: string | null, locationRoute?: string | null, postalCode?: any | null, region?: string | null, regionType?: string | null, settlement?: string | null, settlementType?: string | null, street?: string | null, streetType?: string | null } } | null, registrationHabitation?: { __typename?: 'Habitation', phone?: any | null, hash?: string | null, address: { __typename?: 'NestedHabitationAddress', area?: string | null, areaType?: string | null, block?: string | null, blockType?: string | null, city?: string | null, cityType?: string | null, dadata?: string | null, fiasId: string, fiasLevel?: string | null, flat?: string | null, flatType?: string | null, house?: string | null, houseType?: string | null, kladrId?: string | null, locationRoute?: string | null, postalCode?: any | null, region?: string | null, regionType?: string | null, settlement?: string | null, settlementType?: string | null, street?: string | null, streetType?: string | null } } | null, documents?: { __typename?: 'NestedPeopleDocuments', passport?: { __typename?: 'Passport', addressRegistrationDate?: any | null, issueDate?: any | null, issuedBy?: string | null, issueId?: any | null, number: string, series: string } | null } | null } | null, mfoPeople?: { __typename?: 'People', firstName: any, lastName: any, middleName?: any | null, birthDate: any, updated?: any | null, hash?: string | null, additionalIncome?: string | null, additionalPhone?: any | null, additionalPhoneOwner?: EAdditionalPhoneOwner | null, additionalPhoneOwnerFIO?: string | null, birthPlace?: string | null, dependentsCount?: EDependents | null, education?: EEducation | null, email?: any | null, employmentType?: EEmploymentType | null, flatRentAmount?: string | null, gender?: EGender | null, loanPaymentTotal?: string | null, maritalStatus?: EFamilyStatus | null, monthlyIncome?: string | null, rentCost?: string | null, salary?: string | null, snils?: any | null, solvencyProof?: EIncomeConfirmation | null, unemploymentReason?: EUnemploymentReason | null, unemploymentReasonText?: string | null, workExperience?: EWorkExperience | null, haveCar?: EHaveCar | null, haveApartment?: EPropertyType | null, creditSelection?: { __typename?: 'NestedPeopleCreditSelection', amount?: string | null, autoBrand?: string | null, autoModel?: string | null, autoYear?: any | null, creditSecurity?: ECreditSecurity | null, initialFee?: string | null, obtainCityId?: string | null, obtainCityLocationRoute?: string | null, period?: string | null, propertyAutoRegistrationPlate?: any | null, purpose?: ECreditPurpose | null, region?: string | null } | null, creditSelectionPledgeCar?: { __typename?: 'Car', registrationPlate?: any | null, modelId?: string | null, model: string, markId?: string | null, mark: string, power?: string | null, year: any, hash?: string | null, vin?: any | null } | null, creditSelectionPledgeHabitation?: { __typename?: 'Habitation', updated?: any | null, hash?: string | null, address: { __typename?: 'NestedHabitationAddress', dadata?: string | null, house?: string | null, locationRoute?: string | null, street?: string | null, flat?: string | null, block?: string | null, region?: string | null, city?: string | null, regionType?: string | null, area?: string | null, areaType?: string | null, cityType?: string | null, settlementType?: string | null, settlement?: string | null, streetType?: string | null }, creditSelection?: { __typename?: 'NestedHabitationCreditSelection', pledgeOwnerFamilyStatus?: EFamilyStatus | null, pledgeOwnerFirstName?: any | null, pledgeOwnerLastName?: any | null, pledgeOwnerMiddleName?: any | null, pledgeOwnerPhone?: any | null, pledgeOwnerRelationship?: ERelationStatus | null, pledgeOwnerSingle?: string | null } | null } | null, job?: { __typename?: 'NestedPeopleJob', lastExperienceStartDate?: any | null, title?: string | null, type?: EJobPosition | null, address?: { __typename?: 'NestedPeopleJobAddress', dadata?: string | null, street?: string | null, locationRoute?: string | null, house?: string | null, flat?: string | null, region?: string | null, block?: string | null, blockType?: string | null } | null, organization?: { __typename?: 'NestedPeopleJobOrganization', activity?: EOrganizationActivity | null, inn?: any | null, name?: string | null, ogrn?: any | null, phone?: any | null, type?: EEmployerType | null, typeCode?: any | null } | null } | null, livingHabitation?: { __typename?: 'Habitation', hash?: string | null, address: { __typename?: 'NestedHabitationAddress', area?: string | null, areaType?: string | null, block?: string | null, blockType?: string | null, city?: string | null, cityType?: string | null, dadata?: string | null, fiasId: string, fiasLevel?: string | null, flat?: string | null, flatType?: string | null, house?: string | null, houseType?: string | null, kladrId?: string | null, locationRoute?: string | null, postalCode?: any | null, region?: string | null, regionType?: string | null, settlement?: string | null, settlementType?: string | null, street?: string | null, streetType?: string | null } } | null, registrationHabitation?: { __typename?: 'Habitation', phone?: any | null, hash?: string | null, address: { __typename?: 'NestedHabitationAddress', area?: string | null, areaType?: string | null, block?: string | null, blockType?: string | null, city?: string | null, cityType?: string | null, dadata?: string | null, fiasId: string, fiasLevel?: string | null, flat?: string | null, flatType?: string | null, house?: string | null, houseType?: string | null, kladrId?: string | null, locationRoute?: string | null, postalCode?: any | null, region?: string | null, regionType?: string | null, settlement?: string | null, settlementType?: string | null, street?: string | null, streetType?: string | null } } | null, documents?: { __typename?: 'NestedPeopleDocuments', passport?: { __typename?: 'Passport', addressRegistrationDate?: any | null, issueDate?: any | null, issuedBy?: string | null, issueId?: any | null, number: string, series: string } | null } | null } | null, MPLFlags?: { __typename?: 'MPLClientFlags', MPLRegistration?: any | null, identificationDate?: any | null, AMLQuestionsDate?: any | null, blockReason?: string | null, blockedDate?: any | null } | null } | null };

export type TCreditSelectionFrontendUpdateDataMutationVariables = Exact<{
  ownerId?: InputMaybe<Scalars['Int']['input']>;
  data: TInputCommon;
}>;


export type TCreditSelectionFrontendUpdateDataMutation = { __typename?: 'Mutation', saveData?: { __typename?: 'Profile', creditPeople?: { __typename?: 'People', firstName: any, lastName: any, middleName?: any | null, birthDate: any, updated?: any | null, hash?: string | null, additionalIncome?: string | null, additionalPhone?: any | null, additionalPhoneOwner?: EAdditionalPhoneOwner | null, additionalPhoneOwnerFIO?: string | null, birthPlace?: string | null, dependentsCount?: EDependents | null, education?: EEducation | null, email?: any | null, employmentType?: EEmploymentType | null, flatRentAmount?: string | null, gender?: EGender | null, loanPaymentTotal?: string | null, maritalStatus?: EFamilyStatus | null, monthlyIncome?: string | null, rentCost?: string | null, salary?: string | null, snils?: any | null, solvencyProof?: EIncomeConfirmation | null, unemploymentReason?: EUnemploymentReason | null, unemploymentReasonText?: string | null, workExperience?: EWorkExperience | null, haveCar?: EHaveCar | null, haveApartment?: EPropertyType | null, creditSelection?: { __typename?: 'NestedPeopleCreditSelection', amount?: string | null, autoBrand?: string | null, autoModel?: string | null, autoYear?: any | null, creditSecurity?: ECreditSecurity | null, initialFee?: string | null, obtainCityId?: string | null, obtainCityLocationRoute?: string | null, period?: string | null, propertyAutoRegistrationPlate?: any | null, purpose?: ECreditPurpose | null, region?: string | null } | null, creditSelectionPledgeCar?: { __typename?: 'Car', registrationPlate?: any | null, modelId?: string | null, model: string, markId?: string | null, mark: string, power?: string | null, year: any, hash?: string | null, vin?: any | null } | null, creditSelectionPledgeHabitation?: { __typename?: 'Habitation', updated?: any | null, hash?: string | null, address: { __typename?: 'NestedHabitationAddress', dadata?: string | null, house?: string | null, locationRoute?: string | null, street?: string | null, flat?: string | null, block?: string | null, region?: string | null, city?: string | null, regionType?: string | null, area?: string | null, areaType?: string | null, cityType?: string | null, settlementType?: string | null, settlement?: string | null, streetType?: string | null }, creditSelection?: { __typename?: 'NestedHabitationCreditSelection', pledgeOwnerFamilyStatus?: EFamilyStatus | null, pledgeOwnerFirstName?: any | null, pledgeOwnerLastName?: any | null, pledgeOwnerMiddleName?: any | null, pledgeOwnerPhone?: any | null, pledgeOwnerRelationship?: ERelationStatus | null, pledgeOwnerSingle?: string | null } | null } | null, job?: { __typename?: 'NestedPeopleJob', lastExperienceStartDate?: any | null, title?: string | null, type?: EJobPosition | null, address?: { __typename?: 'NestedPeopleJobAddress', dadata?: string | null, street?: string | null, locationRoute?: string | null, house?: string | null, flat?: string | null, region?: string | null, block?: string | null, blockType?: string | null } | null, organization?: { __typename?: 'NestedPeopleJobOrganization', activity?: EOrganizationActivity | null, inn?: any | null, name?: string | null, ogrn?: any | null, phone?: any | null, type?: EEmployerType | null, typeCode?: any | null } | null } | null, livingHabitation?: { __typename?: 'Habitation', hash?: string | null, address: { __typename?: 'NestedHabitationAddress', area?: string | null, areaType?: string | null, block?: string | null, blockType?: string | null, city?: string | null, cityType?: string | null, dadata?: string | null, fiasId: string, fiasLevel?: string | null, flat?: string | null, flatType?: string | null, house?: string | null, houseType?: string | null, kladrId?: string | null, locationRoute?: string | null, postalCode?: any | null, region?: string | null, regionType?: string | null, settlement?: string | null, settlementType?: string | null, street?: string | null, streetType?: string | null } } | null, registrationHabitation?: { __typename?: 'Habitation', phone?: any | null, hash?: string | null, address: { __typename?: 'NestedHabitationAddress', area?: string | null, areaType?: string | null, block?: string | null, blockType?: string | null, city?: string | null, cityType?: string | null, dadata?: string | null, fiasId: string, fiasLevel?: string | null, flat?: string | null, flatType?: string | null, house?: string | null, houseType?: string | null, kladrId?: string | null, locationRoute?: string | null, postalCode?: any | null, region?: string | null, regionType?: string | null, settlement?: string | null, settlementType?: string | null, street?: string | null, streetType?: string | null } } | null, documents?: { __typename?: 'NestedPeopleDocuments', passport?: { __typename?: 'Passport', addressRegistrationDate?: any | null, issueDate?: any | null, issuedBy?: string | null, issueId?: any | null, number: string, series: string } | null } | null } | null } | null };

export type TCreditSelectionFrontendCallCenterUpdateDataMutationVariables = Exact<{
  ownerId: Scalars['Int']['input'];
  data: TInputCommon;
}>;


export type TCreditSelectionFrontendCallCenterUpdateDataMutation = { __typename?: 'Mutation', saveData?: { __typename?: 'Profile', creditPeople?: { __typename?: 'People', firstName: any, lastName: any, middleName?: any | null, birthDate: any, updated?: any | null, hash?: string | null, additionalIncome?: string | null, additionalPhone?: any | null, additionalPhoneOwner?: EAdditionalPhoneOwner | null, additionalPhoneOwnerFIO?: string | null, birthPlace?: string | null, dependentsCount?: EDependents | null, education?: EEducation | null, email?: any | null, employmentType?: EEmploymentType | null, flatRentAmount?: string | null, gender?: EGender | null, loanPaymentTotal?: string | null, maritalStatus?: EFamilyStatus | null, monthlyIncome?: string | null, rentCost?: string | null, salary?: string | null, snils?: any | null, solvencyProof?: EIncomeConfirmation | null, unemploymentReason?: EUnemploymentReason | null, unemploymentReasonText?: string | null, workExperience?: EWorkExperience | null, haveCar?: EHaveCar | null, haveApartment?: EPropertyType | null, creditSelection?: { __typename?: 'NestedPeopleCreditSelection', amount?: string | null, autoBrand?: string | null, autoModel?: string | null, autoYear?: any | null, creditSecurity?: ECreditSecurity | null, initialFee?: string | null, obtainCityId?: string | null, obtainCityLocationRoute?: string | null, period?: string | null, propertyAutoRegistrationPlate?: any | null, purpose?: ECreditPurpose | null, region?: string | null } | null, creditSelectionPledgeCar?: { __typename?: 'Car', registrationPlate?: any | null, modelId?: string | null, model: string, markId?: string | null, mark: string, power?: string | null, year: any, hash?: string | null, vin?: any | null } | null, creditSelectionPledgeHabitation?: { __typename?: 'Habitation', updated?: any | null, hash?: string | null, address: { __typename?: 'NestedHabitationAddress', dadata?: string | null, house?: string | null, locationRoute?: string | null, street?: string | null, flat?: string | null, block?: string | null, region?: string | null, city?: string | null, regionType?: string | null, area?: string | null, areaType?: string | null, cityType?: string | null, settlementType?: string | null, settlement?: string | null, streetType?: string | null }, creditSelection?: { __typename?: 'NestedHabitationCreditSelection', pledgeOwnerFamilyStatus?: EFamilyStatus | null, pledgeOwnerFirstName?: any | null, pledgeOwnerLastName?: any | null, pledgeOwnerMiddleName?: any | null, pledgeOwnerPhone?: any | null, pledgeOwnerRelationship?: ERelationStatus | null, pledgeOwnerSingle?: string | null } | null } | null, job?: { __typename?: 'NestedPeopleJob', lastExperienceStartDate?: any | null, title?: string | null, type?: EJobPosition | null, address?: { __typename?: 'NestedPeopleJobAddress', dadata?: string | null, street?: string | null, locationRoute?: string | null, house?: string | null, flat?: string | null, region?: string | null, block?: string | null, blockType?: string | null } | null, organization?: { __typename?: 'NestedPeopleJobOrganization', activity?: EOrganizationActivity | null, inn?: any | null, name?: string | null, ogrn?: any | null, phone?: any | null, type?: EEmployerType | null, typeCode?: any | null } | null } | null, livingHabitation?: { __typename?: 'Habitation', hash?: string | null, address: { __typename?: 'NestedHabitationAddress', area?: string | null, areaType?: string | null, block?: string | null, blockType?: string | null, city?: string | null, cityType?: string | null, dadata?: string | null, fiasId: string, fiasLevel?: string | null, flat?: string | null, flatType?: string | null, house?: string | null, houseType?: string | null, kladrId?: string | null, locationRoute?: string | null, postalCode?: any | null, region?: string | null, regionType?: string | null, settlement?: string | null, settlementType?: string | null, street?: string | null, streetType?: string | null } } | null, registrationHabitation?: { __typename?: 'Habitation', phone?: any | null, hash?: string | null, address: { __typename?: 'NestedHabitationAddress', area?: string | null, areaType?: string | null, block?: string | null, blockType?: string | null, city?: string | null, cityType?: string | null, dadata?: string | null, fiasId: string, fiasLevel?: string | null, flat?: string | null, flatType?: string | null, house?: string | null, houseType?: string | null, kladrId?: string | null, locationRoute?: string | null, postalCode?: any | null, region?: string | null, regionType?: string | null, settlement?: string | null, settlementType?: string | null, street?: string | null, streetType?: string | null } } | null, documents?: { __typename?: 'NestedPeopleDocuments', passport?: { __typename?: 'Passport', addressRegistrationDate?: any | null, issueDate?: any | null, issuedBy?: string | null, issueId?: any | null, number: string, series: string } | null } | null } | null } | null };

export const JobAddressFieldsFragmentDoc = gql`
    fragment jobAddressFields on NestedPeopleJobAddress {
  dadata
  street
  locationRoute
  house
  flat
  region
  block
  blockType
}
    `;
export const AddressFieldsFragmentDoc = gql`
    fragment addressFields on NestedHabitationAddress {
  area
  areaType
  block
  blockType
  city
  cityType
  dadata
  fiasId
  fiasLevel
  flat
  flatType
  house
  houseType
  kladrId
  locationRoute
  postalCode
  region
  regionType
  settlement
  settlementType
  street
  streetType
}
    `;
export const PeopleFieldsFragmentDoc = gql`
    fragment peopleFields on People {
  firstName
  lastName
  middleName
  birthDate
  updated
  hash
  additionalIncome
  additionalPhone
  additionalPhoneOwner
  additionalPhoneOwnerFIO
  birthPlace
  creditSelection {
    amount
    autoBrand
    autoModel
    autoYear
    creditSecurity
    initialFee
    obtainCityId
    obtainCityLocationRoute
    period
    propertyAutoRegistrationPlate
    purpose
    region
  }
  creditSelectionPledgeCar {
    registrationPlate
    modelId
    model
    markId
    mark
    power
    year
    hash
    vin
  }
  creditSelectionPledgeHabitation {
    updated
    hash
    address {
      dadata
      house
      locationRoute
      street
      flat
      block
      region
      city
      regionType
      area
      areaType
      cityType
      settlementType
      settlement
      streetType
      street
    }
    creditSelection {
      pledgeOwnerFamilyStatus
      pledgeOwnerFirstName
      pledgeOwnerLastName
      pledgeOwnerMiddleName
      pledgeOwnerPhone
      pledgeOwnerRelationship
      pledgeOwnerSingle
    }
  }
  dependentsCount
  education
  email
  employmentType
  flatRentAmount
  gender
  job {
    address {
      ...jobAddressFields
    }
    lastExperienceStartDate
    organization {
      activity
      inn
      name
      ogrn
      phone
      type
      typeCode
    }
    title
    type
  }
  livingHabitation {
    address {
      ...addressFields
    }
    hash
  }
  registrationHabitation {
    address {
      ...addressFields
    }
    phone
    hash
  }
  loanPaymentTotal
  maritalStatus
  monthlyIncome
  documents {
    passport {
      addressRegistrationDate
      issueDate
      issuedBy
      issueId
      number
      series
    }
  }
  rentCost
  salary
  snils
  solvencyProof
  unemploymentReason
  unemploymentReasonText
  workExperience
  haveCar
  haveApartment
}
    ${JobAddressFieldsFragmentDoc}
${AddressFieldsFragmentDoc}`;
export const EsiaAddressFieldsFragmentDoc = gql`
    fragment esiaAddressFields on NestedHabitationAddress {
  area
  areaType
  block
  blockType
  city
  cityType
  dadata
  fiasId
  fiasLevel
  flat
  flatType
  house
  houseType
  kladrId
  postalCode
  region
  regionType
  settlement
  settlementType
  street
  streetType
}
    `;
export const EsiaPassportFieldsFragmentDoc = gql`
    fragment esiaPassportFields on Passport {
  updated
  hash
  series
  number
  issuedBy
  issueDate
  issueId
}
    `;
export const EsiaPeopleFieldsFragmentDoc = gql`
    fragment esiaPeopleFields on People {
  updated
  hash
  firstName
  lastName
  middleName
  gender
  email
  birthDate
  birthPlace
  snils
  registrationHabitation {
    address {
      ...esiaAddressFields
    }
    hash
  }
  livingHabitation {
    address {
      ...esiaAddressFields
    }
    hash
  }
  documents {
    passport {
      ...esiaPassportFields
    }
  }
}
    ${EsiaAddressFieldsFragmentDoc}
${EsiaPassportFieldsFragmentDoc}`;
export const CreditSelectionFrontendLoadDataDocument = gql`
    query CreditSelectionFrontendLoadData($ownerId: Int) {
  profile(ownerId: $ownerId) {
    phone
    ESIA {
      owner {
        ...esiaPeopleFields
      }
    }
    owner {
      ...peopleFields
    }
    creditPeople {
      ...peopleFields
    }
    mfoPeople {
      ...peopleFields
    }
    MPLFlags {
      MPLRegistration
      identificationDate
      AMLQuestionsDate
      blockReason
      blockedDate
    }
  }
}
    ${EsiaPeopleFieldsFragmentDoc}
${PeopleFieldsFragmentDoc}`;
export const CreditSelectionFrontendCallCenterLoadDataDocument = gql`
    query CreditSelectionFrontendCallCenterLoadData($ownerId: Int!) {
  profile(ownerId: $ownerId) {
    phone
    ESIA {
      owner {
        ...esiaPeopleFields
      }
    }
    owner {
      ...peopleFields
    }
    creditPeople {
      ...peopleFields
    }
    mfoPeople {
      ...peopleFields
    }
    MPLFlags {
      MPLRegistration
      identificationDate
      AMLQuestionsDate
      blockReason
      blockedDate
    }
  }
}
    ${EsiaPeopleFieldsFragmentDoc}
${PeopleFieldsFragmentDoc}`;
export const CreditSelectionFrontendUpdateDataDocument = gql`
    mutation CreditSelectionFrontendUpdateData($ownerId: Int, $data: InputCommon!) {
  saveData(ownerId: $ownerId, data: $data) {
    creditPeople {
      ...peopleFields
    }
  }
}
    ${PeopleFieldsFragmentDoc}`;
export const CreditSelectionFrontendCallCenterUpdateDataDocument = gql`
    mutation CreditSelectionFrontendCallCenterUpdateData($ownerId: Int!, $data: InputCommon!) {
  saveData(ownerId: $ownerId, data: $data) {
    creditPeople {
      ...peopleFields
    }
  }
}
    ${PeopleFieldsFragmentDoc}`;

export type SdkFunctionWrapper = <T>(action: (requestHeaders?:Record<string, string>) => Promise<T>, operationName: string, operationType?: string) => Promise<T>;


const defaultWrapper: SdkFunctionWrapper = (action, _operationName, _operationType) => action();

export function getSdk(client: GraphQLClient, withWrapper: SdkFunctionWrapper = defaultWrapper) {
  return {
    CreditSelectionFrontendLoadData(variables?: TCreditSelectionFrontendLoadDataQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<TCreditSelectionFrontendLoadDataQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<TCreditSelectionFrontendLoadDataQuery>(CreditSelectionFrontendLoadDataDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'CreditSelectionFrontendLoadData', 'query');
    },
    CreditSelectionFrontendCallCenterLoadData(variables: TCreditSelectionFrontendCallCenterLoadDataQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<TCreditSelectionFrontendCallCenterLoadDataQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<TCreditSelectionFrontendCallCenterLoadDataQuery>(CreditSelectionFrontendCallCenterLoadDataDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'CreditSelectionFrontendCallCenterLoadData', 'query');
    },
    CreditSelectionFrontendUpdateData(variables: TCreditSelectionFrontendUpdateDataMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<TCreditSelectionFrontendUpdateDataMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<TCreditSelectionFrontendUpdateDataMutation>(CreditSelectionFrontendUpdateDataDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'CreditSelectionFrontendUpdateData', 'mutation');
    },
    CreditSelectionFrontendCallCenterUpdateData(variables: TCreditSelectionFrontendCallCenterUpdateDataMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<TCreditSelectionFrontendCallCenterUpdateDataMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<TCreditSelectionFrontendCallCenterUpdateDataMutation>(CreditSelectionFrontendCallCenterUpdateDataDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'CreditSelectionFrontendCallCenterUpdateData', 'mutation');
    }
  };
}
export type Sdk = ReturnType<typeof getSdk>;